webpackJsonp([2,0,3],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(946);
	
	var _vue = __webpack_require__(132);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(1171);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Router = __webpack_require__(610);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	var _vueAsyncData = __webpack_require__(1113);
	
	var _vueAsyncData2 = _interopRequireDefault(_vueAsyncData);
	
	var _vueTouch = __webpack_require__(1213);
	
	var _vueTouch2 = _interopRequireDefault(_vueTouch);
	
	var _vueMoment = __webpack_require__(1210);
	
	var _vueMoment2 = _interopRequireDefault(_vueMoment);
	
	var _vueValidator = __webpack_require__(1214);
	
	var _vueValidator2 = _interopRequireDefault(_vueValidator);
	
	var _vueD = __webpack_require__(1114);
	
	var _vueD2 = _interopRequireDefault(_vueD);
	
	var _vueSortable = __webpack_require__(1212);
	
	var _vueSortable2 = _interopRequireDefault(_vueSortable);
	
	var _vuex = __webpack_require__(109);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _videoStore = __webpack_require__(618);
	
	var _videoStore2 = _interopRequireDefault(_videoStore);
	
	var _vuefire = __webpack_require__(1215);
	
	var _vuefire2 = _interopRequireDefault(_vuefire);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueValidator2.default);
	_vue2.default.use(_Router2.default);
	_vue2.default.use(_vueAsyncData2.default);
	_vue2.default.use(_vueTouch2.default);
	_vue2.default.use(_vueMoment2.default);
	_vue2.default.use(_vueD2.default);
	_vue2.default.use(_vueSortable2.default);
	_vue2.default.use(_vuex2.default);
	_vue2.default.use(_vuefire2.default);
	// use d3 as this.$d3
	_vue2.default.config.debug = true;
	_vue2.default.config.devtools = true;
	_vue2.default.config.warnExpressionErrors = false; // this line hide then warning when {{ a.b }} a is null
	
	// ============== Validators ==================
	// @@Todo: set global msgs, would have a title ex: 'Name: msgmsgmsgmsg'
	_vue2.default.validator('email', function (val) {
	  return (/^[-a-z0-9~!$%^&*_=+}{\\'?]+(\.[-a-z0-9~!$%^&*_=+}{\\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i.test(val)
	  );
	});
	_vue2.default.validator('assocCode', function (val) {
	  return (/^[0-9]{6}$/.test(val)
	  );
	}); // for associate code
	_vue2.default.validator('numeric', function (val) {
	  return (/^[0-9]{1,}$/.test(val)
	  );
	});
	_vue2.default.validator('ipAddress', function (val) {
	  return (/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(val)
	  );
	});
	_vue2.default.validator('ipOrURL', function (val) {
	  return (/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(val) || /[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|[a-zA-Z0-9]\.[^\s]{2,}|[a-zA-Z0-9]\.[^\s]{2,}/.test(val)
	  );
	});
	_vue2.default.validator('engAndNum', function (val) {
	  return (/^[0-9A-Za-z\s_]{1,}$/.test(val)
	  );
	});
	_vue2.default.validator('deviceValid', function (val) {
	  return (/^[0-9A-Za-z\-_]{1,}$/.test(val)
	  );
	});
	_vue2.default.validator('password', function (val) {
	  return (/^[0-9A-Za-z]{4,}$/.test(val)
	  );
	});
	// for Sequence time in Event.vue
	_vue2.default.validator('float', function (val) {
	  return (/^[0-9]+(.[0-9]{1,})?$/.test(val)
	  );
	});
	_vue2.default.validator('int', function (val) {
	  return (/^-{0,1}[0-9]+/.test(val)
	  );
	});
	
	var router = new _Router2.default({
	  // Set to true to remove #! in path.
	  // It needs proper configured server.
	  // http://readystate4.com/2012/05/17/nginx-and-apache-rewrite-to-support-html5-pushstate/
	  history: false
	});
	var application = _vue2.default.extend({
	  store: _videoStore2.default, // inject store to all children
	  components: { App: _App2.default }
	});
	router.start(application, 'body');

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.photos = exports.getFirst = exports.getDeviceFavorite = exports.getSpecificDevice = exports.getAuthState = exports.deviceTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var getAuthState = exports.getAuthState = function () {
	  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	    return regeneratorRuntime.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            if (!(authState === PENDING)) {
	              _context2.next = 6;
	              break;
	            }
	
	            _context2.next = 3;
	            return delay(1);
	
	          case 3:
	            console.log('wait auth');
	            _context2.next = 0;
	            break;
	
	          case 6:
	            return _context2.abrupt('return', authState === AUTHED);
	
	          case 7:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function getAuthState() {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var getSpecificDevice = exports.getSpecificDevice = function () {
	  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(mac) {
	    return regeneratorRuntime.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            if (!(!store.devices || !store.devices[mac])) {
	              _context3.next = 6;
	              break;
	            }
	
	            console.log('no auth yet');
	            _context3.next = 4;
	            return delay(1);
	
	          case 4:
	            _context3.next = 0;
	            break;
	
	          case 6:
	            return _context3.abrupt('return', store.devices[mac]);
	
	          case 7:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function getSpecificDevice(_x3) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var getDeviceFavorite = exports.getDeviceFavorite = function () {
	  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(mac) {
	    var snap;
	    return regeneratorRuntime.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            if (userDeviceFavorRef) {
	              _context4.next = 6;
	              break;
	            }
	
	            console.log('wait devRef.');
	            _context4.next = 4;
	            return delay(1);
	
	          case 4:
	            _context4.next = 0;
	            break;
	
	          case 6:
	            _context4.next = 8;
	            return userDeviceFavorRef.child(mac).once('value');
	
	          case 8:
	            snap = _context4.sent;
	            return _context4.abrupt('return', snap.val());
	
	          case 10:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function getDeviceFavorite(_x4) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var getFirst = exports.getFirst = function () {
	  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	    var userDeviceList;
	    return regeneratorRuntime.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            if (!(store.devices === null)) {
	              _context5.next = 4;
	              break;
	            }
	
	            throw Error('data not ready');
	
	          case 4:
	            if (!(store.user.installer || store.user.favorite && store.devices[store.user.favorite].ownerId === authData.uid)) {
	              _context5.next = 8;
	              break;
	            }
	
	            return _context5.abrupt('return', _extends({
	              mac: store.user.favorite
	            }, store.devices[store.user.favorite]));
	
	          case 8:
	            // if user's favorite not belongs to user anymore
	            // list all user devices and return the first
	            userDeviceList = Object.keys(store.devices).filter(function (mac) {
	              return store.devices[mac].ownerId === authData.uid;
	            }).map(function (mac) {
	              return _extends({
	                mac: mac
	              }, store.devices[mac]);
	            });
	
	            if (!(userDeviceList.length !== 0)) {
	              _context5.next = 13;
	              break;
	            }
	
	            return _context5.abrupt('return', userDeviceList[0]);
	
	          case 13:
	            return _context5.abrupt('return', {});
	
	          case 14:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function getFirst() {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	exports.bindVM = bindVM;
	exports.getUser = getUser;
	exports.changeDeviceNickname = changeDeviceNickname;
	exports.call = call;
	exports.login = login;
	exports.logout = logout;
	exports.getOnlineDevsRef = getOnlineDevsRef;
	exports.getDeviceRef = getDeviceRef;
	exports.getEventLogRef = getEventLogRef;
	exports.clearEvents = clearEvents;
	exports.changePassword = changePassword;
	exports.changeUserProfile = changeUserProfile;
	exports.createUser = createUser;
	exports.addDevice = addDevice;
	exports.setUserDeviceFavoritePort = setUserDeviceFavoritePort;
	exports.removeFirebaseKey = removeFirebaseKey;
	exports.resetPassword = resetPassword;
	exports.hasNewFirmware = hasNewFirmware;
	
	var _firebase = __webpack_require__(1004);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _vue = __webpack_require__(132);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(534);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _Rpc = __webpack_require__(611);
	
	var _Rpc2 = _interopRequireDefault(_Rpc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new _vue.Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return _vue.Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	_vue2.default.use(_vueResource2.default); // bootstrop promist and http in vue which has already imported
	
	var deviceTypes = exports.deviceTypes = ['', 'power', 'matrix', 'mixer', 'splitter', 'mes', 'dio', 'control', 'ir', 'rs232'];
	// const eagleFb = new Firebase('https://bageleyes.firebaseio.com/')
	var config = {
	  apiKey: 'AIzaSyC9ZlewJAyeSRK03_bvSkKXmR6tiyS_IiI',
	  authDomain: 'intrisingio.firebaseapp.com',
	  databaseURL: 'https://intrisingio.firebaseio.com',
	  projectId: 'intrisingio',
	  storageBucket: 'intrisingio.appspot.com',
	  messagingSenderId: '289021557523'
	};
	var eagleFb = _firebase2.default.initializeApp(config).database().ref();
	var PENDING = 0;
	var AUTHED = 1;
	var NOAUTH = 2;
	var authState = PENDING;
	var authData = null;
	var userDeviceFavorRef = null;
	var devLogRef = null;
	var dbUrl = window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost' || /^192.168\./.test(window.location.hostname) ? 'dbapi.intri.cloud' : window.location.hostname.replace(/www/, 'dbapi');
	
	var wsPrxfix = window.location.protocol.replace(/http/, 'ws');
	var wsUrl = dbUrl.replace(/dbapi/, wsPrxfix + '//www');
	var store = {
	  user: null,
	  devices: null, // set initial to null that we can detect it state
	  events: []
	};
	
	console.log('env', ("production"));
	
	var app = null;
	var rpc = {};
	if (false) {
	  rpc = new _Rpc2.default('wss://www.intri.cloud:443');
	} else {
	  rpc = new _Rpc2.default(wsUrl);
	}
	
	function idMatchsParam(deviceId) {
	  return app && app.$route && app.$route.params && app.$route.params.mac === deviceId;
	}
	rpc.subscribe('dsStatusNotifications', function (_ref) {
	  var deviceId = _ref.deviceId,
	      events = _ref.events;
	
	  console.log('got events');
	  if (!idMatchsParam(deviceId)) return;
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var event = _step.value;
	
	      if (event.event) {
	        // to change mapping to all msg
	        var temp = Object.keys(event.event);
	        if (temp.length !== 1 && event.type === 'mapping') {
	          if (temp.length !== 0) {
	            if (event.event[temp[0]] === '0') {
	              event.msg = 'Set mute to All output';
	            } else {
	              event.msg = 'Input ' + event.event[temp[0]] + ' mapping to All output';
	            }
	          }
	        }
	      }
	      emit('update', deviceId, event);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	});
	
	var getRand = function getRand(max, min) {
	  return Math.round(Math.random() * (max - min + 1)) + min;
	};
	
	rpc.subscribe('dsPowerStatusUpdate', function (_ref2) {
	  var deviceId = _ref2.deviceId,
	      banks = _ref2.banks,
	      input = _ref2.input;
	
	  if (!idMatchsParam(deviceId)) return;
	  var inputV = getRand(113.4, 109.2);
	  var inputI = getRand(12.4, 15.2);
	  var randData = {
	    dateTime: Date.now(),
	    banks: {
	      '1': { current: 0, power: getRand(600, 650) },
	      '2': { current: getRand(6.5, 6.4), power: getRand(700, 750) },
	      '3': { current: getRand(2.2, 2.4), power: getRand(275, 325) },
	      '4': { current: 0, power: getRand(175, 311) },
	      '5': { current: 0, power: getRand(175, 311) },
	      '6': { current: 0, power: getRand(175, 311) },
	      '7': { current: 0, power: getRand(175, 311) },
	      '8': { current: 0, power: getRand(175, 311) },
	      '9': { current: 0, power: getRand(175, 311) }
	    },
	    input: { voltage: inputV, current: inputI, power: inputV * inputI }
	  };
	  if (!deviceId.startsWith('11:22:33:44:55')) {
	    // for real device
	    var event = {
	      banks: banks,
	      input: input
	    };
	    emit('status', deviceId, event);
	  } else {
	    // for virtual device
	    console.log('for virtual device');
	    emit('status', deviceId, randData);
	  }
	});
	
	function emit() {
	  var _app, _app2;
	
	  if (app == null) throw new Error('app has not been initialed');
	  (_app = app).$emit.apply(_app, arguments);
	  (_app2 = app).$broadcast.apply(_app2, arguments);
	}
	
	var verifyUnnecessaryTargets = ['joe@gmail.com', 'installer@gmail.com', 'eagleyestest2017@gmail.com', 'scptest@gomax-electronics.com.tw'];
	
	_firebase2.default.auth().onAuthStateChanged(function () {
	  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(adata) {
	    var _authData, uid, devSnapShot, userProfileRef;
	
	    return regeneratorRuntime.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            // firebase will set the juset created account as login, so we force logout
	            if (adata && !adata.emailVerified && !verifyUnnecessaryTargets.includes(adata.email)) {
	              // created user, firebase default will be user logged in, but email not verified, so we force logout
	              logout();
	              authState = NOAUTH;
	            } else if (adata && adata.emailVerified) {
	              authState = AUTHED;
	            } else if (!adata) {
	              authState = NOAUTH;
	            }
	
	            authData = adata;
	            console.log('is authed ', authState === AUTHED);
	
	            if (authData && verifyUnnecessaryTargets.includes(authData.email)) authState = AUTHED;
	
	            if (!(authState === AUTHED)) {
	              _context.next = 21;
	              break;
	            }
	
	            // did login
	            _authData = authData, uid = _authData.uid;
	
	            _vue.http.post('/ajax/access-log', {
	              uid: uid,
	              isLogin: true
	            });
	            userDeviceFavorRef = eagleFb.child('user/' + uid + '/device_favor');
	            devLogRef = eagleFb.child('devLog');
	            userDeviceFavorRef.off('value');
	            userDeviceFavorRef.on('value', function (snap) {
	              emit('favoritePort', snap.val());
	            });
	            _context.next = 13;
	            return eagleFb.child('device').once('value');
	
	          case 13:
	            devSnapShot = _context.sent;
	
	            store.devices = devSnapShot.val();
	            userProfileRef = eagleFb.child('user/' + uid);
	            _context.next = 18;
	            return userProfileRef.off('value');
	
	          case 18:
	            // must call this, or the on-value dont work after logout
	            userProfileRef.on('value', function (snap) {
	              if (snap.val() === null) {
	                // a new user just signed up ,thus it has no profiles
	                var userInfo = {
	                  name: authData.email.split('@')[0],
	                  email: authData.email,
	                  photo_link: authData.photoURL,
	                  session_time: 0,
	                  installer: false
	                };
	                userProfileRef.set(userInfo);
	                emit('user', uid, userInfo);
	              } else {
	                if (!snap.hasChild('session_time')) {
	                  userProfileRef.update({
	                    session_time: 0
	                  });
	                }
	                store.user = snap.val();
	                emit('user', uid, snap.val());
	              }
	            });
	            _context.next = 24;
	            break;
	
	          case 21:
	            // when logout
	            userDeviceFavorRef = null;
	            store.user = null;
	            store.devices = null;
	
	          case 24:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function (_x) {
	    return _ref3.apply(this, arguments);
	  };
	}());
	
	function bindVM(vm) {
	  app = vm;
	}
	
	function getUser() {
	  return store.user;
	}
	
	function delay() {
	  var sec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	  if (sec > 10) return console.log('delay cannot bigger than 10s');
	  return new _vue.Promise(function (resolve) {
	    setTimeout(resolve, sec * 1000);
	  });
	}
	
	function changeDeviceNickname(mac, nickname) {
	  return eagleFb.child('device').child(mac).update({
	    nickname: nickname
	  });
	}
	
	function call() {
	  var _rpc;
	
	  if (!rpc) throw new Error('rpc has not initialed');
	  return (_rpc = rpc).call.apply(_rpc, arguments);
	}
	
	function login() {
	  var _firebase$auth;
	
	  return (_firebase$auth = _firebase2.default.auth()).signInWithEmailAndPassword.apply(_firebase$auth, arguments);
	}
	
	function logout() {
	  store.devices = null;
	  return _firebase2.default.auth().signOut();
	}
	
	function getOnlineDevsRef() {
	  return eagleFb.child('devices_online');
	}
	
	function getDeviceRef() {
	  return eagleFb.child('device');
	}
	
	function getEventLogRef(mac) {
	  return devLogRef.child(mac);
	}
	
	function clearEvents(mac) {
	  return devLogRef.child(mac).remove();
	  // while (store.events.length > 0) {
	  //   store.events.pop()
	  // }
	}
	function changePassword(newPassword) {
	  // console.log(eagleFb.auth().currentUser)
	  var user = _firebase2.default.auth().currentUser;
	  return user.updatePassword(newPassword);
	}
	function changeUserProfile(arg) {
	  var _authData2 = authData,
	      uid = _authData2.uid;
	
	  return eagleFb.child('user/' + uid).update(arg);
	}
	function createUser(email, password) {
	  return _firebase2.default.auth().createUserWithEmailAndPassword(email, password);
	}
	
	function addDevice(params) {
	  return _vue.http.post('ajax/associate_device', params);
	}
	
	function setUserDeviceFavoritePort() {
	  var _userDeviceFavorRef;
	
	  return (_userDeviceFavorRef = userDeviceFavorRef).update.apply(_userDeviceFavorRef, arguments);
	}
	
	function removeFirebaseKey(obj) {
	  var nobj = _extends({}, obj);
	  delete nobj['.key'];
	  return nobj;
	}
	
	var photos = exports.photos = {
	  outputs: ['', // for no imgs
	  __webpack_require__(174), __webpack_require__(175), __webpack_require__(254), __webpack_require__(255), __webpack_require__(174), __webpack_require__(1108), __webpack_require__(1109), __webpack_require__(175)],
	  inputs: ['', // for no imgs
	  __webpack_require__(1088), __webpack_require__(1089), __webpack_require__(1090), __webpack_require__(1091), __webpack_require__(1092), __webpack_require__(1093), __webpack_require__(1094), __webpack_require__(1095), __webpack_require__(1096), __webpack_require__(1097), __webpack_require__(1098), __webpack_require__(1099), __webpack_require__(1100), __webpack_require__(1101), __webpack_require__(1102), __webpack_require__(1103), __webpack_require__(1104)],
	  vga: [__webpack_require__(1105)]
	};
	
	function resetPassword(mail) {
	  return _firebase2.default.auth().sendPasswordResetEmail(mail);
	}
	
	function hasNewFirmware(_ref8) {
	  var version = _ref8.version;
	
	  return new _vue.Promise(function (resolve, reject) {
	    var vSp = version.split('.');
	    var tail = vSp.pop();
	    tail = Number(tail) + 1;
	    resolve([].concat(_toConsumableArray(vSp), [tail]).join('.'));
	  });
	}
	
	exports.default = {
	  getAuthState: getAuthState,
	  getUser: getUser,
	  getFirst: getFirst,
	  call: call,
	  login: login,
	  logout: logout,
	  getEventLogRef: getEventLogRef,
	  clearEvents: clearEvents,
	  createUser: createUser,
	  changePassword: changePassword,
	  changeUserProfile: changeUserProfile,
	  changeDeviceNickname: changeDeviceNickname,
	  addDevice: addDevice,
	  setUserDeviceFavoritePort: setUserDeviceFavoritePort,
	  getSpecificDevice: getSpecificDevice,
	  photos: photos,
	  resetPassword: resetPassword,
	  hasNewFirmware: hasNewFirmware
	};

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(977)
	__vue_script__ = __webpack_require__(634)
	__vue_template__ = __webpack_require__(1147)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(984)
	__vue_script__ = __webpack_require__(624)
	__vue_template__ = __webpack_require__(1154)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(980)
	__vue_script__ = __webpack_require__(625)
	__vue_template__ = __webpack_require__(1150)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/output1.ef17873.jpg";

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/output2.47bf5fc.jpg";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(992)
	__vue_script__ = __webpack_require__(626)
	__vue_template__ = __webpack_require__(1162)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(990)
	__vue_script__ = __webpack_require__(628)
	__vue_template__ = __webpack_require__(1160)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(987)
	__vue_script__ = __webpack_require__(630)
	__vue_template__ = __webpack_require__(1157)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAhCAYAAACvBDmYAAAAAXNSR0IArs4c6QAAAJJJREFUWAntljEKgDAQBBOx8V0WfiTPykd8mWCjXHcHVjLNwqa6NMsyk8D1fd5PUzgKRaPjogAzOroobWr9Cjzm9euDnWPrOY/KiUyrz2SJ2UQJijnDRDMNYjZRgmLOkCHavD1lb8Aso95LCWC7RMiod9HiDbiYKACxRJhowQFcZIh6KQFslwgZ9TJFu8LiHG/gBfnwJv/nh6fFAAAAAElFTkSuQmCC"

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/output3.5cf7070.jpg";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/output4.d3faf3c.jpg";

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(965)
	__vue_script__ = __webpack_require__(629)
	__vue_template__ = __webpack_require__(1135)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(989)
	__vue_script__ = __webpack_require__(632)
	__vue_template__ = __webpack_require__(1159)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(962)
	__vue_script__ = __webpack_require__(636)
	__vue_template__ = __webpack_require__(1132)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(983)
	__vue_script__ = __webpack_require__(637)
	__vue_template__ = __webpack_require__(1153)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(975)
	__vue_script__ = __webpack_require__(640)
	__vue_template__ = __webpack_require__(1145)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  label: {
	    vendor: 'Intrising',
	    appName: 'IntriCloud'
	  },
	  color: {
	    theme: 'hsl(350,66%,44%)'
	  }
	};

/***/ }),
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAhCAYAAACvBDmYAAAAAXNSR0IArs4c6QAAAMxJREFUWAljdJ7z6z/DUABDwaEgNzINhcAEuXHIOJRloELUfc53vHmDhYXZZGsC21mY+4ZMiI46FBZl1KKHTIhiZCZCiZzSENqZwslIjhkYDiXHEHL0MDIy/sWn788/BpRSYcAcuiOZgyS7h24axRcd1JQjlBdGC3xqhjY2s4ZMGh11KLboo0SMpLKMEovQ9Y4W+OghQm/+gEX9aIFP76hGtw8j6sltL6IbTG3+aIFP7RDFiHpqW4DLvNECH1fI0Et8yGQmxqEw7AiKNQC8zy88Nkx1mAAAAABJRU5ErkJggg=="

/***/ }),
/* 526 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAhCAYAAACvBDmYAAAAAXNSR0IArs4c6QAAAMxJREFUWAljdJ7z6z/DUABDwaEgNzINhcAEuXHIOJQFPUTd53zHm2ZZWJhNtiawnUXXR2v+kAnRUYdSOykMmRDFyEzEhgShTEesObjU7UzhZESWw3AoIyPjX2QF6Ow//xjwlgro6qnFx3DojmQODDFqWUaJOUM3jRJKe6MFPoF0MWSiftShBGKSZOkhE6IYZeZogU9yZKNqGLpRP1rgo8YkybyhG/XEehW9vUisPnLVDZkQHTIOHS3wyU2LuPQNmagfMg5lHArDjqDkAABGay88otBulQAAAABJRU5ErkJggg=="

/***/ }),
/* 527 */,
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(971)
	__vue_script__ = __webpack_require__(622)
	__vue_template__ = __webpack_require__(1141)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(974)
	__vue_script__ = __webpack_require__(633)
	__vue_template__ = __webpack_require__(1144)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(948)
	__vue_script__ = __webpack_require__(635)
	__vue_template__ = __webpack_require__(1115)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(949)
	__vue_script__ = __webpack_require__(638)
	__vue_template__ = __webpack_require__(1116)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(958)
	__vue_script__ = __webpack_require__(648)
	__vue_template__ = __webpack_require__(1128)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(959)
	__vue_script__ = __webpack_require__(653)
	__vue_template__ = __webpack_require__(1129)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vueRouter = __webpack_require__(1211);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _Service = __webpack_require__(8);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var subPage = {
	  template: '<router-view></router-view>'
	};
	
	var _class = function (_VueRouter) {
	  _inherits(_class, _VueRouter);
	
	  function _class(arg) {
	    _classCallCheck(this, _class);
	
	    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, arg));
	
	    _this.redirect({
	      '/matrix/:mac': '/matrix/:mac/mapping',
	      '/power/:mac': '/power/:mac/status',
	      '/mixer/:mac': '/mixer/:mac/status',
	      '/dio/:mac': '/dio/:mac/status',
	      '/control/:mac': '/control/:mac/mapping',
	      '/splitter/:mac': '/splitter/:mac/status',
	      '/mes/:mac': '/mes/:mac/port-status'
	    });
	
	    _this.map({
	      '/login': {
	        component: __webpack_require__(1175),
	        noauth: true,
	        noloading: true
	      },
	      '/welcome': {
	        name: 'nodev',
	        component: __webpack_require__(1176),
	        noloading: true
	      },
	      '/test': {
	        component: __webpack_require__(1205),
	        noloading: true,
	        noauth: true,
	        name: 'test'
	      },
	      '/': {
	        component: {
	          template: '',
	          ready: function ready() {
	            this.$router.goToIndex();
	          }
	        }
	      },
	      '/matrix/:mac': {
	        name: 'matrix',
	        component: subPage,
	        subRoutes: {
	          '/mapping': {
	            component: __webpack_require__(1185)
	          },
	          '/preset': {
	            component: __webpack_require__(1186)
	          },
	          '/EDID': {
	            component: __webpack_require__(532)
	          },
	          '/setting': {
	            component: __webpack_require__(131)
	          },
	          '/log': {
	            component: __webpack_require__(130)
	          },
	          '/m2m': {
	            component: __webpack_require__(260)
	          },
	          '/HDCP': {
	            component: __webpack_require__(528)
	          },
	          '/system': {
	            component: __webpack_require__(176)
	          },
	          '/schedule': {
	            component: __webpack_require__(533)
	          }
	        }
	      },
	      '/power/:mac': {
	        name: 'power',
	        component: subPage,
	        subRoutes: {
	          '/status': {
	            component: __webpack_require__(1195)
	          },
	          '/analysis': {
	            component: __webpack_require__(1192)
	          },
	          '/schedule': {
	            component: __webpack_require__(1194)
	          },
	          '/setting': {
	            component: __webpack_require__(131)
	          },
	          '/log': {
	            component: __webpack_require__(130)
	          },
	          '/event': {
	            component: __webpack_require__(1193)
	          },
	          '/system': {
	            component: __webpack_require__(176)
	          },
	          '/m2m': {
	            component: __webpack_require__(260)
	          }
	        }
	      },
	      '/mixer/:mac': {
	        name: 'mixer',
	        component: subPage,
	        subRoutes: {
	          '/layout': {
	            isLayout: true,
	            component: __webpack_require__(1189)
	          },
	          '/status': {
	            component: __webpack_require__(1191)
	          },
	          '/setting': {
	            component: __webpack_require__(131)
	          },
	          '/log': {
	            component: __webpack_require__(130)
	          },
	          '/preset': {
	            component: __webpack_require__(1190)
	          },
	          '/m2m': {
	            component: __webpack_require__(260)
	          },
	          '/system': {
	            component: __webpack_require__(176)
	          },
	          '/HDCP': {
	            component: __webpack_require__(528)
	          },
	          '/EDID': {
	            component: __webpack_require__(532)
	          },
	          '/schedule': {
	            component: __webpack_require__(533)
	          }
	        }
	      },
	      '/splitter/:mac': {
	        name: 'splitter',
	        component: subPage,
	        subRoutes: {
	          '/status': {
	            component: __webpack_require__(1208)
	          },
	          '/layout': {
	            component: __webpack_require__(1206)
	          },
	          '/preset': {
	            component: __webpack_require__(1207)
	          },
	          '/setting': {
	            component: __webpack_require__(131)
	          },
	          '/system': {
	            component: __webpack_require__(176)
	          },
	          '/log': {
	            component: __webpack_require__(130)
	          }
	        }
	      },
	      '/dio/:mac': {
	        name: 'dio',
	        component: subPage,
	        subRoutes: {
	          '/status': {
	            component: __webpack_require__(1179)
	          },
	          '/schedule': {
	            component: __webpack_require__(1178)
	          },
	          '/event': {
	            component: __webpack_require__(1177)
	          },
	          '/setting': {
	            component: __webpack_require__(131)
	          },
	          '/log': {
	            component: __webpack_require__(130)
	          }
	        }
	      },
	      '/control/:mac': {
	        name: 'control',
	        component: subPage,
	        subRoutes: {
	          '/mapping': {
	            component: __webpack_require__(1180)
	          }
	        }
	      },
	      '/mes/:mac': {
	        name: 'mes',
	        component: subPage,
	        subRoutes: {
	          '/port-status': {
	            component: __webpack_require__(1187)
	          },
	          '/setting': {
	            component: __webpack_require__(1188)
	          }
	        }
	      },
	      '/ir/:mac': {
	        name: 'ir',
	        component: subPage
	      }
	    });
	    // note: beforeEach is a vue function not available to use async
	    _this.beforeEach(function (_ref) {
	      var to = _ref.to,
	          next = _ref.next,
	          abort = _ref.abort;
	
	      if (to.matched === null) {
	        console.log('state is null');
	        abort();
	        _this.replace('/');
	      } else if (to.noauth) {
	        next();
	      } else {
	        _Service2.default.getAuthState().then(function (state) {
	          if (state) {
	            return next();
	          }
	          abort();
	          _this.replace('/login');
	        });
	      }
	    });
	    return _this;
	  } // close constructor
	
	
	  _createClass(_class, [{
	    key: 'goToIndex',
	    value: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var _this2 = this;
	
	        var dev;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return _Service2.default.getFirst();
	
	              case 3:
	                dev = _context.sent;
	
	                // undefined when new user, null when state not ready
	                console.log('dev in goToIndex =>', dev);
	                if (dev && dev.typeId) {
	                  console.log('devics in goToIndex', dev);
	                  this.replace({
	                    name: _Service.deviceTypes[dev.typeId],
	                    params: {
	                      mac: dev.mac
	                    }
	                  });
	                } else {
	                  this.replace({
	                    name: 'nodev'
	                  });
	                }
	                _context.next = 12;
	                break;
	
	              case 8:
	                _context.prev = 8;
	                _context.t0 = _context['catch'](0);
	
	                console.log(_context.t0);
	                if (_context.t0.message !== 'no online') {
	                  setTimeout(function () {
	                    return _this2.goToIndex();
	                  }, 1000);
	                }
	
	              case 12:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[0, 8]]);
	      }));
	
	      function goToIndex() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return goToIndex;
	    }()
	  }]);
	
	  return _class;
	}(_vueRouter2.default); // close class
	

	exports.default = _class;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vue = __webpack_require__(132);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(534);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	_vue2.default.use(_vueResource2.default);
	
	function generateCallId() {
	  // call UID
	  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	    var r = Math.random() * 16 | 0;
	    var v = c === 'x' ? r : r & 0x3 | 0x8;
	    return v.toString(16);
	  });
	}
	
	var callerPromisePool = {};
	var eventHandler = {};
	var beforeWsOpenMessages = [];
	
	var _class = function () {
	  function _class(url) {
	    var _this = this;
	
	    _classCallCheck(this, _class);
	
	    this.ws = new window.WebSocket(url, 'intri');
	    this.ws.onopen = function () {
	      console.log('ws rpc opened');
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = beforeWsOpenMessages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _ref2 = _step.value;
	          var uuid = _ref2.uuid,
	              wsMessage = _ref2.wsMessage;
	
	          _this.wsSendWithTimeoutRetry(uuid, wsMessage);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      beforeWsOpenMessages = [];
	    };
	    this.ws.onclose = function (e) {
	      console.log('ws rpc close', e);
	      window.location.reload(true);
	    };
	    this.ws.onerror = function (error) {
	      return console.log('ws error', error);
	    };
	    this.ws.onmessage = function (msg) {
	      var o = JSON.parse(msg.data);
	      if (!o.jsonrpc) return;
	      _this.handleMessage(o);
	    };
	  }
	
	  _createClass(_class, [{
	    key: 'handleMessage',
	    value: function handleMessage(msg) {
	      if (msg.result && msg.id) {
	        if (callerPromisePool[msg.id]) {
	          callerPromisePool[msg.id].resolve(msg.result);
	          delete callerPromisePool[msg.id];
	        } else {
	          console.log('got call return but ' + msg.id + ' not in pool');
	        }
	      } else if (msg.method) {
	        if (eventHandler[msg.method]) {
	          eventHandler[msg.method](msg.params);
	        } else {
	          console.log('received unsubscribed event ' + msg.method);
	        }
	      } else {
	        console.log('unknow format received message', msg);
	      }
	    }
	  }, {
	    key: 'subscribe',
	    value: function subscribe(eventName, func) {
	      if (typeof func === 'function') eventHandler[eventName] = func;
	    }
	  }, {
	    key: 'call',
	    value: function call(devid, method) {
	      var _this2 = this;
	
	      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      return new _vue.Promise(function (resolve, reject) {
	        if (typeof devid !== 'string') reject('rpc caller must have a device id');
	        if (typeof method !== 'string') reject('rpc caller must have a method');
	        var uuid = generateCallId();
	        var message = {
	          jsonrpc: '2.0',
	          method: method,
	          params: _extends({}, params, {
	            version: '0',
	            deviceId: devid
	          }),
	          id: uuid
	        };
	        var wsMessage = JSON.stringify(message);
	        callerPromisePool[uuid] = {
	          resolve: resolve,
	          reject: reject,
	          wsMessage: wsMessage
	        };
	        if (_this2.ws.readyState) {
	          _this2.wsSendWithTimeoutRetry(uuid, wsMessage);
	        } else {
	          beforeWsOpenMessages.push({
	            uuid: uuid,
	            wsMessage: wsMessage
	          });
	        }
	      });
	    }
	  }, {
	    key: 'wsSendWithTimeoutRetry',
	    value: function wsSendWithTimeoutRetry(uuid, wsMessage) {
	      var _this3 = this;
	
	      var counter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	      this.ws.send(wsMessage);
	      setTimeout(function () {
	        if (callerPromisePool[uuid]) {
	          if (counter < 5) _this3.wsSendWithTimeoutRetry(uuid, wsMessage, counter + 1);else {
	            callerPromisePool[uuid].reject('Device no response.');
	            delete callerPromisePool[uuid];
	          }
	        }
	      }, 5000);
	    }
	  }]);

	  return _class;
	}();

	exports.default = _class;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _utils = __webpack_require__(614);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  data: function data() {
	    return {
	      search: '',
	      isOpen: false,
	      value: this.selected || this.selected === 0 ? (0, _utils2.default)(this.selected) : this.multiple ? [] : null
	    };
	  },
	
	  props: {
	    /**
	     * Decide whether to filter the results based on search query.
	     * Useful for async filtering, where we search through more complex data.
	     * @type {Boolean}
	     */
	    localSearch: {
	      type: Boolean,
	      default: true
	    },
	    /**
	     * Array of available options: Objects, Strings or Integers.
	     * If array of objects, visible label will default to option.label.
	     * If `labal` prop is passed, label will equal option['label']
	     * @type {Array}
	     */
	    options: {
	      type: Array,
	      required: true
	    },
	    /**
	     * Equivalent to the `multiple` attribute on a `<select>` input.
	     * @default false
	     * @type {Boolean}
	     */
	    multiple: {
	      type: Boolean,
	      default: false
	    },
	    /**
	     * Presets the selected options value.
	     * @type {Object||Array||String||Integer}
	     */
	    selected: {},
	    /**
	     * Key to compare objects
	     * @default 'id'
	     * @type {String}
	     */
	    key: {
	      type: String,
	      default: false
	    },
	    /**
	     * Label to look for in option Object
	     * @default 'label'
	     * @type {String}
	     */
	    label: {
	      type: String,
	      default: false
	    },
	    /**
	     * Enable/disable search in options
	     * @default true
	     * @type {Boolean}
	     */
	    searchable: {
	      type: Boolean,
	      default: true
	    },
	    /**
	     * Clear the search input after select()
	     * @default true
	     * @type {Boolean}
	     */
	    clearOnSelect: {
	      type: Boolean,
	      default: true
	    },
	    /**
	     * Hide already selected options
	     * @default false
	     * @type {Boolean}
	     */
	    hideSelected: {
	      type: Boolean,
	      default: false
	    },
	    /**
	     * Equivalent to the `placeholder` attribute on a `<select>` input.
	     * @default 'Select option'
	     * @type {String}
	     */
	    placeholder: {
	      type: String,
	      default: 'Select option'
	    },
	    /**
	     * Sets maxHeight style value of the dropdown
	     * @default 300
	     * @type {Integer}
	     */
	    maxHeight: {
	      type: Number,
	      default: 300
	    },
	    /**
	     * Allow to remove all selected values
	     * @default true
	     * @type {Boolean}
	     */
	    allowEmpty: {
	      type: Boolean,
	      default: true
	    },
	    /**
	     * Reset this.value, this.search, this.selected after this.value changes.
	     * Useful if want to create a stateless dropdown, that fires the this.onChange
	     * callback function with different params.
	     * @default false
	     * @type {Boolean}
	     */
	    resetAfter: {
	      type: Boolean,
	      default: false
	    },
	    /**
	     * Enable/disable closing after selecting an option
	     * @default true
	     * @type {Boolean}
	     */
	    closeOnSelect: {
	      type: Boolean,
	      default: true
	    },
	    /**
	     * Function to interpolate the custom label
	     * @default false
	     * @type {Function}
	     */
	    customLabel: {
	      type: Function,
	      default: function _default(option, label) {
	        return label ? option[label] : option;
	      }
	    },
	    /**
	     * Disable / Enable tagging
	     * @default false
	     * @type {Boolean}
	     */
	    taggable: {
	      type: Boolean,
	      default: false
	    },
	    /**
	     * String to show when highlighting a potential tag
	     * @default 'Press enter to create a tag'
	     * @type {String}
	    */
	    tagPlaceholder: {
	      type: String,
	      default: 'Press enter to create a tag'
	    },
	    /**
	     * Number of allowed selected options. No limit if false.
	     * @default False
	     * @type {Number}
	    */
	    max: {
	      type: Number,
	      default: 0
	    },
	    /**
	     * Will be passed with all events as second param.
	     * Useful for identifying events origin.
	     * @default null
	     * @type {String|Integer}
	    */
	    id: {
	      default: null
	    },
	    /**
	     * Limits the options displayed in the dropdown
	     * to the first X options.
	     * @default 1000
	     * @type {Integer}
	    */
	    optionsLimit: {
	      type: Number,
	      default: 1000
	    }
	  },
	  created: function created() {
	    if (this.searchable) this.adjustSearch();
	  },
	
	  computed: {
	    filteredOptions: function filteredOptions() {
	      var search = this.search || '';
	      var options = this.hideSelected ? this.options.filter(this.isNotSelected) : this.options;
	      if (this.localSearch) options = this.$options.filters.filterBy(options, this.search);
	      if (this.taggable && search.length && !this.isExistingOption(search)) {
	        options.unshift({ isTag: true, label: search });
	      }
	      return options.slice(0, this.optionsLimit);
	    },
	    valueKeys: function valueKeys() {
	      var _this = this;
	
	      if (this.key) {
	        return this.multiple ? this.value.map(function (element) {
	          return element[_this.key];
	        }) : this.value[this.key];
	      } else {
	        return this.value;
	      }
	    },
	    optionKeys: function optionKeys() {
	      var _this2 = this;
	
	      return this.label ? this.options.map(function (element) {
	        return element[_this2.label];
	      }) : this.options;
	    },
	    currentOptionLabel: function currentOptionLabel() {
	      return this.getOptionLabel(this.value);
	    }
	  },
	  watch: {
	    'value': function value() {
	      if (this.resetAfter) {
	        this.$set('value', null);
	        this.$set('search', null);
	        this.$set('selected', null);
	      }
	      this.adjustSearch();
	    },
	    'search': function search() {
	      /* istanbul ignore else */
	      if (this.search === this.currentOptionLabel) return;
	
	      this.$emit('search-change', this.search, this.id);
	    },
	    'selected': function selected() {
	      this.value = (0, _utils2.default)(this.selected);
	    }
	  },
	  methods: {
	    /**
	     * Finds out if the given query is already present
	     * in the available options
	     * @param  {String}
	     * @returns {Boolean} returns true if element is available
	     */
	    isExistingOption: function isExistingOption(query) {
	      return !this.options ? false : this.optionKeys.indexOf(query) > -1;
	    },
	
	    /**
	     * Finds out if the given element is already present
	     * in the result value
	     * @param  {Object||String||Integer} option passed element to check
	     * @returns {Boolean} returns true if element is selected
	     */
	    isSelected: function isSelected(option) {
	      /* istanbul ignore else */
	      if (!this.value && this.value !== 0) return false;
	      var opt = this.key ? option[this.key] : option;
	
	      if (this.multiple) {
	        return this.valueKeys.indexOf(opt) > -1;
	      } else {
	        return this.valueKeys === opt;
	      }
	    },
	
	    /**
	     * Finds out if the given element is NOT already present
	     * in the result value. Negated isSelected method.
	     * @param  {Object||String||Integer} option passed element to check
	     * @returns {Boolean} returns true if element is not selected
	     */
	    isNotSelected: function isNotSelected(option) {
	      return !this.isSelected(option);
	    },
	
	    /**
	     * Returns empty string when options is null/undefined
	     * Returns tag query if option is tag.
	     * Returns the customLabel() results and casts it to string.
	     * @param  {Object||String||Integer} Passed option
	     * @returns {Object||String}
	     */
	    getOptionLabel: function getOptionLabel(option) {
	      if (!option && option !== 0) return '';
	      if (option.isTag) return option.label;
	      return this.customLabel(option, this.label) + '';
	    },
	
	    /**
	     * Add the given option to the list of selected options
	     * or sets the option as the selected option.
	     * If option is already selected -> remove it from the results.
	     *
	     * @param  {Object||String||Integer} option to select/deselect
	     */
	    select: function select(option) {
	      if (this.max !== 0 && this.multiple && this.value.length === this.max) return;
	      if (option.isTag) {
	        this.$emit('tag', option.label, this.id);
	        this.search = '';
	      } else {
	        if (this.multiple) {
	          if (this.isSelected(option)) {
	            this.removeElement(option);
	            return;
	          } else {
	            this.value.push(option);
	          }
	        } else {
	          var isSelected = this.isSelected(option);
	
	          /* istanbul ignore else */
	          if (isSelected && !this.allowEmpty) return;
	
	          this.value = isSelected ? null : option;
	        }
	        this.$emit('select', (0, _utils2.default)(option), this.id);
	        this.$emit('update', (0, _utils2.default)(this.value), this.id);
	
	        if (this.closeOnSelect) this.deactivate();
	      }
	    },
	
	    /**
	     * Removes the given option from the selected options.
	     * Additionally checks this.allowEmpty prop if option can be removed when
	     * it is the last selected option.
	     *
	     * @param  {type} option description
	     * @returns {type}        description
	     */
	    removeElement: function removeElement(option) {
	      /* istanbul ignore else */
	      if (!this.allowEmpty && this.value.length <= 1) return;
	
	      if (this.multiple && (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
	        var index = this.valueKeys.indexOf(option[this.key]);
	        this.value.splice(index, 1);
	      } else {
	        this.value.$remove(option);
	      }
	      this.$emit('remove', (0, _utils2.default)(option), this.id);
	      this.$emit('update', (0, _utils2.default)(this.value), this.id);
	    },
	
	    /**
	     * Calls this.removeElement() with the last element
	     * from this.value (selected element Array)
	     *
	     * @fires this#removeElement
	     */
	    removeLastElement: function removeLastElement() {
	      /* istanbul ignore else */
	      if (this.search.length === 0 && Array.isArray(this.value)) {
	        this.removeElement(this.value[this.value.length - 1]);
	      }
	    },
	
	    /**
	     * Opens the multiselect’s dropdown.
	     * Sets this.isOpen to TRUE
	     */
	    activate: function activate() {
	      /* istanbul ignore else */
	      if (this.isOpen) return;
	
	      this.isOpen = true;
	      /* istanbul ignore else  */
	      if (this.searchable) {
	        this.search = '';
	        this.$els.search.focus();
	      } else {
	        this.$el.focus();
	      }
	      this.$emit('open', this.id);
	    },
	
	    /**
	     * Closes the multiselect’s dropdown.
	     * Sets this.isOpen to FALSE
	     */
	    deactivate: function deactivate() {
	      /* istanbul ignore else */
	      if (!this.isOpen) return;
	
	      this.isOpen = false;
	      /* istanbul ignore else  */
	      if (this.searchable) {
	        this.$els.search.blur();
	        this.adjustSearch();
	      } else {
	        this.$el.blur();
	      }
	      this.$emit('close', (0, _utils2.default)(this.value), this.id);
	    },
	
	    /**
	     * Adjusts the Search property to equal the correct value
	     * depending on the selected value.
	     */
	    adjustSearch: function adjustSearch() {
	      var _this3 = this;
	
	      if (!this.searchable || !this.clearOnSelect) return;
	
	      this.$nextTick(function () {
	        _this3.search = _this3.multiple ? '' : _this3.currentOptionLabel;
	      });
	    },
	
	    /**
	     * Call this.activate() or this.deactivate()
	     * depending on this.isOpen value.
	     *
	     * @fires this#activate || this#deactivate
	     * @property {Boolean} isOpen indicates if dropdown is open
	     */
	    toggle: function toggle() {
	      this.isOpen ? this.deactivate() : this.activate();
	    }
	  }
	};

/***/ }),
/* 613 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  data: function data() {
	    return {
	      pointer: 0,
	      visibleElements: this.maxHeight / this.optionHeight
	    };
	  },
	
	  props: {
	    /**
	     * Enable/disable highlighting of the pointed value.
	     * @type {Boolean}
	     * @default true
	     */
	    showPointer: {
	      type: Boolean,
	      default: true
	    },
	    /**
	     * Sets the height of the option. Used for scroll calculations
	     * @type {Number}
	     * @default 40
	     */
	    optionHeight: {
	      type: Number,
	      default: 40
	    }
	  },
	  computed: {
	    pointerPosition: function pointerPosition() {
	      return this.pointer * this.optionHeight;
	    }
	  },
	  watch: {
	    'filteredOptions': function filteredOptions() {
	      this.pointerAdjust();
	    }
	  },
	  methods: {
	    addPointerElement: function addPointerElement() {
	      if (this.filteredOptions.length > 0) {
	        this.select(this.filteredOptions[this.pointer]);
	      }
	      this.pointerReset();
	    },
	    pointerForward: function pointerForward() {
	      if (this.pointer < this.filteredOptions.length - 1) {
	        this.pointer++;
	        if (this.$els.list.scrollTop <= this.pointerPosition - this.visibleElements * this.optionHeight) {
	          this.$els.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight;
	        }
	      }
	    },
	    pointerBackward: function pointerBackward() {
	      if (this.pointer > 0) {
	        this.pointer--;
	        if (this.$els.list.scrollTop >= this.pointerPosition) {
	          this.$els.list.scrollTop = this.pointerPosition;
	        }
	      }
	    },
	    pointerReset: function pointerReset() {
	      if (!this.closeOnSelect) return;
	
	      this.pointer = 0;
	      if (this.$els.list) {
	        this.$els.list.scrollTop = 0;
	      }
	    },
	    pointerAdjust: function pointerAdjust() {
	      if (this.pointer >= this.filteredOptions.length - 1) {
	        this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0;
	      }
	    },
	    pointerSet: function pointerSet(index) {
	      this.pointer = index;
	    }
	  }
	};

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Returns a depply cloned object without reference.
	 * Copied from Vuex.
	 * @type {Object}
	 */
	var deepClone = function deepClone(obj) {
	  if (Array.isArray(obj)) {
	    return obj.map(deepClone);
	  } else if (obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
	    var cloned = {};
	    var keys = Object.keys(obj);
	    for (var i = 0, l = keys.length; i < l; i++) {
	      var key = keys[i];
	      cloned[key] = deepClone(obj[key]);
	    }
	    return cloned;
	  } else {
	    return obj;
	  }
	};
	
	module.exports = deepClone;

/***/ }),
/* 615 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	// Attempt to convert a string value to a Boolean. Otherwise, return the value
	// without modification so Vue can throw a warning.
	exports.default = function (val) {
	  return typeof val !== 'string' ? val : val === 'true' ? true : val === 'false' ? false : val === 'null' ? false : val === 'undefined' ? false : val;
	};

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.callAjax = callAjax;
	exports.getScrollBarWidth = getScrollBarWidth;
	exports.translations = translations;
	// coerce convert som types of data into another type
	var coerce = exports.coerce = {
	  // Convert a string to booleam. Otherwise, return the value without modification, so if is not boolean, Vue throw a warning.
	  boolean: function boolean(val) {
	    return typeof val !== 'string' ? val : val === 'true' ? true : val === 'false' ? false : val === 'null' ? false : val === 'undefined' ? false : val;
	  },
	  // Attempt to convert a string value to a Number. Otherwise, return 0.
	  number: function number(val) {
	    var alt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    return typeof val === 'number' ? val : val === undefined || val === null || isNaN(Number(val)) ? alt : Number(val);
	  }
	
	  // callAjax (only get)
	};function callAjax(url, callback) {
	  var request = new window.XMLHttpRequest();
	  var data = {};
	  // p (-simulated- promise)
	  var p = {
	    then: function then(fn1, fn2, fn3) {
	      return p.done(fn1).fail(fn2).always(fn3);
	    }
	  };
	  var _arr = ['done', 'fail', 'always'];
	
	  var _loop = function _loop() {
	    var name = _arr[_i];
	    data[name] = [];
	    p[name] = function (fn) {
	      if (fn instanceof Function) data[name].push(fn);
	      return p;
	    };
	  };
	
	  for (var _i = 0; _i < _arr.length; _i++) {
	    _loop();
	  }
	  p.done(callback);
	  request.onreadystatechange = function () {
	    if (request.readyState === 4) {
	      if (request.status === 200) {
	        try {
	          var response = JSON.parse(request.responseText);
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = data.done[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var done = _step.value;
	              done(response);
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        } catch (e) {
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = data.fail[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var fail = _step2.value;
	              fail(e);
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      } else {
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = data.fail[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var _fail = _step3.value;
	
	            _fail({ status: request.status });
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	      }
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = data.always[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var always = _step4.value;
	
	          always({ status: request.status });
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	    }
	  };
	  request.open('GET', url);
	  request.setRequestHeader('Accept', 'application/json');
	  request.send();
	  return p;
	}
	
	function getScrollBarWidth() {
	  if (document.documentElement.scrollHeight <= document.documentElement.clientHeight) {
	    return 0;
	  }
	  var inner = document.createElement('p');
	  inner.style.width = '100%';
	  inner.style.height = '200px';
	
	  var outer = document.createElement('div');
	  outer.style.position = 'absolute';
	  outer.style.top = '0px';
	  outer.style.left = '0px';
	  outer.style.visibility = 'hidden';
	  outer.style.width = '200px';
	  outer.style.height = '150px';
	  outer.style.overflow = 'hidden';
	  outer.appendChild(inner);
	
	  document.body.appendChild(outer);
	  var w1 = inner.offsetWidth;
	  outer.style.overflow = 'scroll';
	  var w2 = inner.offsetWidth;
	  if (w1 === w2) w2 = outer.clientWidth;
	
	  document.body.removeChild(outer);
	
	  return w1 - w2;
	}
	
	// return all the translations or the default language (english)
	function translations(lang) {
	  lang = lang || 'en';
	  var text = {
	    daysOfWeek: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	    limit: 'Limit reached ({{limit}} items max).',
	    loading: 'Loading...',
	    minLength: 'Min. Length',
	    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	    notSelected: 'Nothing Selected',
	    required: 'Required',
	    search: 'Search'
	  };
	  return window.VueStrapLang ? window.VueStrapLang(lang) : text;
	}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTimezoneOptions = getTimezoneOptions;
	var options = [{
	  'id': 'GMT-12:00',
	  'offset': -43200,
	  'dstSavings': 0,
	  'useDaylight': false
	}, {
	  'id': 'GMT-11:00',
	  'offset': -39600,
	  'dstSavings': 0,
	  'useDaylight': false
	}, {
	  'id': 'GMT-10:00',
	  'offset': -36000,
	  'dstSavings': 0,
	  'useDaylight': false
	}, {
	  'id': 'GMT-9:00(Alaska)',
	  'offset': -32400,
	  'dstSavings': 3600,
	  'useDaylight': true
	}, {
	  'id': 'GMT-8:00(Las Vegas, Los Angeles, San Francisco, Vancouver)',
	  'offset': -28800,
	  'dstSavings': 3600,
	  'useDaylight': true
	}, {
	  'id': 'GMT-7:00(Calgary, Denver)',
	  'offset': -25200,
	  'dstSavings': 3600,
	  'useDaylight': true
	}, {
	  'id': 'GMT-6:00(Chicago, Dallas, Huston, Mexico City, New Orleans)',
	  'offset': -21600,
	  'dstSavings': 3600,
	  'useDaylight': true
	}, {
	  'id': 'GMT-5:00(Montreal, Ottawa, Toronto)',
	  'offset': -18000,
	  'dstSavings': 3600,
	  'useDaylight': true
	}, {
	  'id': 'GMT-4:00(Santiago)',
	  'offset': -14400,
	  'dstSavings': 3600,
	  'useDaylight': true
	}, {
	  'id': 'GMT-3:00(Brasilia, Rio de Janeiro, Sao Paulo)',
	  'offset': -10800,
	  'dstSavings': 0,
	  'useDaylight': false
	}, {
	  'id': 'GMT-2:00',
	  'offset': -7200,
	  'dstSavings': 0,
	  'useDaylight': false
	}, {
	  'id': 'GMT-1:00',
	  'offset': -3600,
	  'dstSavings': 0,
	  'useDaylight': false
	}, {
	  'id': 'GMT+0:00(Dublin, London, Lisbon)',
	  'offset': 0,
	  'dstSavings': 3600,
	  'useDaylight': true
	}, {
	  'id': 'GMT+1:00(Amsterdam, Berlin, Brussel, Paris, Prague, Rome, Vienna)',
	  'offset': 3600,
	  'dstSavings': 3600,
	  'useDaylight': true
	}, {
	  'id': 'GMT+2:00(Athens, Beirut, Helsinki)',
	  'offset': 7200,
	  'dstSavings': 3600,
	  'useDaylight': true
	}, {
	  'id': 'GMT+3:00(Moscow, Istanbul)',
	  'offset': 10800,
	  'dstSavings': 0,
	  'useDaylight': false
	}, {
	  'id': 'GMT+4:00(Abu Dhabi, Dubai)',
	  'offset': 14400,
	  'dstSavings': 0,
	  'useDaylight': false
	}, {
	  'id': 'GMT+5:00(Islamabad, Karachi)',
	  'offset': 18000,
	  'dstSavings': 0,
	  'useDaylight': false
	}, {
	  'id': 'GMT+5:30(Bengaluru, Mumbai, New Delhi)',
	  'offset': 19800,
	  'dstSavings': 0,
	  'useDaylight': false
	}, {
	  'id': 'GMT+6:00(Dhaka)',
	  'offset': 21600,
	  'dstSavings': 0,
	  'useDaylight': false
	}, {
	  'id': 'GMT+7:00(Bangkok, Hanoi, Jakarta)',
	  'offset': 25200,
	  'dstSavings': 0,
	  'useDaylight': false
	}, {
	  'id': 'GMT+8:00(Beijing, Hong Kong, Singapore, Taipei)',
	  'offset': 28800,
	  'dstSavings': 0,
	  'useDaylight': false
	}, {
	  'id': 'GMT+9:00(Tokyo, Seoul)',
	  'offset': 32400,
	  'dstSavings': 0,
	  'useDaylight': false
	}, {
	  'id': 'GMT+10:00(Canberra, Melbourne, Sydney)',
	  'offset': 36000,
	  'dstSavings': 3600,
	  'useDaylight': true
	}, {
	  'id': 'GMT+11:00(Solomon Islands)',
	  'offset': 39600,
	  'dstSavings': 0,
	  'useDaylight': false
	}, {
	  'id': 'GMT+12:00(Auckland, Wellington)',
	  'offset': 43200,
	  'dstSavings': 3600,
	  'useDaylight': true
	}];
	
	function getTimezoneOptions() {
	  return options;
	}
	
	exports.default = {
	  getTimezoneOptions: getTimezoneOptions
	};

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutations;
	
	var _vuex = __webpack_require__(109);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vue = __webpack_require__(132);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mobileDetect = __webpack_require__(56);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Service = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	_vue2.default.use(_vuex2.default);
	
	var FETCHDATA_VW_SUCCESS = 'FETCHDATA_VW_SUCCESS';
	var FETCHDATA_VW_REQUEST = 'FETCHDATA_VW_REQUEST';
	var FETCHDATA_VW_ERROR = 'FETCHDATA_VW_ERROR';
	// const OUTPUT_4K_LIMIT = {
	//   '1': [0, 0, 1920, 1080],
	//   '2': [1921, 0, 3840, 1080],
	//   '3': [0, 1081, 1920, 2160],
	//   '4': [1921, 1081, 3840, 2160]
	// }
	
	var FROM_RESIZE = 'fromResize';
	var FROM_GESTURE = 'fromGesture';
	var FROM_DRAG = 'fromDrag';
	var FROM_INPUT = 'fromInput';
	var DOUBLE_INPUT_VW = 'VW-1404ZH-G';
	
	// function limitX1Range (id, x) {
	//   if (x < OUTPUT_4K_LIMIT[id][0]) return OUTPUT_4K_LIMIT[id][0]
	//   return x
	// }
	
	// function limitX2Range (id, x1) {
	//   if (x1 > OUTPUT_4K_LIMIT[id][2]) return OUTPUT_4K_LIMIT[id][2]
	//   return x1
	// }
	
	// function limitY1Range (id, y) {
	//   if (y < OUTPUT_4K_LIMIT[id][1]) return OUTPUT_4K_LIMIT[id][1]
	//   return y
	// }
	
	// function limitY2Range (id, y2) {
	//   if (y2 > OUTPUT_4K_LIMIT[id][3]) return OUTPUT_4K_LIMIT[id][3]
	//   return y2
	// }
	// checkDragRange is to avoid overflow of width of 1920 or height of 1080
	function checkDragRange(split, index) {
	  var port = _lodash2.default.cloneDeep(split[index]);
	  var width = port[2] - port[0];
	  var height = port[3] - port[1];
	  if (width > 1920) {
	    port[2] = port[0] + 1920;
	  }
	
	  if (height > 1080) {
	    port[3] = port[1] + 1080;
	  }
	  // keep the shape of the rect, just move the position
	  split[index] = port;
	  return split;
	}
	
	function ratioComputer(resolution) {
	  var newRatio = [];
	  switch (resolution) {// input just has port 1
	    case '800x600':
	    case '800x600@60':
	    default:
	      newRatio = [4, 3, 200]; // [width, height, baseWidth]
	      break;
	    case '3840x2160@60Hz':
	    case '4096x2160@60Hz':
	    case '4096x2160@30Hz':
	    case '3840x2160@30Hz':
	      newRatio = [16, 9, 240];
	      break;
	    case '1080 to 4K2K@60':
	    case '1920x1080@30Hz':
	    case '1920x1080@60Hz':
	      newRatio = [16, 9, 120];
	      break;
	    case '1280x720@60Hz':
	      newRatio = [16, 9, 80];
	      break;
	    case '720x480@60Hz':
	    case '720x480@30Hz':
	      newRatio = [3, 2, 240];
	      break;
	    case '720x576@30Hz':
	    case '720x576@50Hz':
	      newRatio = [5, 4, 256];
	      break;
	    case '1680x1050@60':
	      newRatio = [8, 5, 210];
	      break;
	
	    case '640x480':
	    case '640x480@60':
	    case '480p':
	      newRatio = [4, 3, 160];
	      break;
	  }
	  var md = new _mobileDetect2.default(window.navigator.userAgent);
	  var ww = window.innerWidth;
	  if (md.mobile() !== null && window.innerWidth <= 768) {
	    if (ww === 320) {
	      // i5
	      newRatio.push(Math.round(280 / newRatio[0]));
	    } else if (ww === 375 || ww === 360) {
	      // i6 && S5
	      newRatio.push(Math.round(320 / newRatio[0]));
	    } else if (ww === 414 || ww === 412 || ww === 411) {
	      // i6+ && nexus 6P
	      newRatio.push(Math.round(360 / newRatio[0]));
	    } else if (ww === 568) {
	      // i5 landscape
	      newRatio.push(Math.round(330 / newRatio[0]));
	    } else if (ww === 684) {
	      newRatio.push(Math.round(400 / newRatio[0]));
	    } else if (ww > 568 && ww <= 667) {
	      newRatio.push(Math.round(400 / newRatio[0]));
	    } else if (ww > 667 && ww <= 736) {
	      newRatio.push(Math.round(450 / newRatio[0]));
	    } else if (ww === 768) {
	      newRatio.push(Math.round(400 / newRatio[0]));
	    } else {
	      // set 300 to others
	      newRatio.push(Math.round(300 / newRatio[0]));
	    }
	  } else if (window.innerWidth > 768 && window.innerWidth < 992) {
	    newRatio.push(Math.round(450 / newRatio[0])); // ipad UP
	  } else if (window.innerWidth >= 992 && window.innerWidth < 1200) {
	    newRatio.push(Math.round(550 / newRatio[0])); // md
	  } else if (window.innerWidth >= 1200) {
	    newRatio.push(Math.round(680 / newRatio[0])); // lg
	  }
	  // console.log('new ratio is', newRatio)
	  return newRatio;
	}
	
	var state = {
	  isFetching: false,
	  isInput4k: false,
	  isLayoutChanged: false,
	  splitArea: {
	    split: {}
	  },
	  inResolution: {},
	  outResolutions: {},
	  outResolutionOptions: {},
	  inRatio: [],
	  presetRatios: {},
	  windowFocus: '1',
	  defaultOutputSplitOpts: {
	    '1': '3x1L', // 3*1 rotate left 90 deg
	    '2': '3x1R', // 3*1 rotate right 90 deg
	    '3': '4x1L', // 4*1 rotate left 90 deg
	    '4': '4x1R', // 4*1 rotate right 90 deg
	    '5': '1x1',
	    '6': '2x2',
	    '7': '1x4',
	    '8': '4x1'
	  },
	  profiles: {},
	  error: {},
	  isMobile: false,
	  model: '',
	  isInputSourceFromHDMI: false
	};
	
	var mutations = (_mutations = {}, _defineProperty(_mutations, FETCHDATA_VW_SUCCESS, function (state, _ref) {
	  var inResolution = _ref.inResolution,
	      outResolutions = _ref.outResolutions,
	      outResolutionOptions = _ref.outResolutionOptions,
	      splitArea = _ref.splitArea,
	      outputSplitOptions = _ref.outputSplitOptions,
	      profiles = _ref.profiles,
	      model = _ref.model;
	
	  state.isFetching = false;
	  state.inResolution = inResolution;
	  state.outResolutions = outResolutions;
	  state.outResolutionOptions = outResolutionOptions;
	  state.splitArea.split = splitArea.split;
	  state.defaultOutputSplitOpts = outputSplitOptions;
	  state.isInput4k = state.inResolution['1'] === '3840x2160@60Hz' || state.inResolution['1'] === '4096x2160@60Hz';
	  state.profiles = profiles;
	  state.model = model;
	}), _defineProperty(_mutations, FETCHDATA_VW_REQUEST, function (state) {
	  state.isFetching = true;
	}), _defineProperty(_mutations, FETCHDATA_VW_ERROR, function (state, error) {
	  state.isFetching = false;
	  state.error = error;
	}), _defineProperty(_mutations, 'check4KLimit', function check4KLimit(state, _ref2) {
	  var index = _ref2.index,
	      _ref2$type = _ref2.type,
	      type = _ref2$type === undefined ? FROM_INPUT : _ref2$type;
	
	  console.log('check4KLimit');
	  var oldSplit = _lodash2.default.cloneDeep(state.splitArea.split);
	  if (type === FROM_INPUT || type === FROM_RESIZE) {
	    // limit the width and height only
	    if (parseInt(oldSplit[index][2]) - parseInt(oldSplit[index][0]) > 1920) oldSplit[index][2] = parseInt(oldSplit[index][0]) + 1920;
	    if (parseInt(oldSplit[index][3]) - parseInt(oldSplit[index][1]) > 1080) oldSplit[index][3] = parseInt(oldSplit[index][1]) + 1080;
	  } else if (type === FROM_DRAG) {
	    oldSplit = checkDragRange(oldSplit, index);
	  } else if (type === FROM_GESTURE) {
	    // seems to be no this type?
	    console.log('sth wrong');
	  }
	  state.splitArea.split = oldSplit;
	}), _defineProperty(_mutations, 'UPDATE', function UPDATE(state, _ref3) {
	  var type = _ref3.type,
	      splitArea = _ref3.splitArea,
	      resolution = _ref3.resolution,
	      windowFocus = _ref3.windowFocus,
	      isLayoutChanged = _ref3.isLayoutChanged,
	      preset = _ref3.preset;
	
	  // console.warn('got update , type => ', type)
	  var md = new _mobileDetect2.default(window.navigator.userAgent);
	  switch (type) {
	    case 'isMobile':
	      // && window.innerWidth <= 768
	      state.isMobile = md.mobile() !== null;
	      break;
	    case 'layoutChanged':
	      state.isLayoutChanged = isLayoutChanged;
	      break;
	    case 'split':
	      // Object.assign seems not to trigger the vuex watch system
	      // So we use the dump way
	
	      // It maybe the situations that update 1 output or multi outputs,
	      // So update the ports following the keys
	
	      var keys = Object.keys(splitArea.split);
	      var newSplit = _lodash2.default.cloneDeep(state.splitArea.split);
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var key = _step.value;
	
	          newSplit[key] = splitArea.split[key];
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      state.splitArea.split = newSplit;
	      break;
	
	    case 'winFocus':
	      console.log('focus is', windowFocus);
	      state.windowFocus = windowFocus;
	      break;
	
	    case 'inResolution':
	    case 'outResolutions':
	      Object.assign(state[type], resolution);
	      // update the isInput4k here
	      if (type === 'inResolution') {
	        state.isInput4k = resolution['1'] === '3840x2160@60Hz' || resolution['1'] === '4096x2160@60Hz';
	      }
	      break;
	
	    case 'preset':
	      Object.assign(state.profiles, preset);
	      break;
	
	    case 'presetRatio':
	      for (var pKey in state.profiles) {
	        state.presetRatios[pKey] = ratioComputer(state.profiles[pKey].resolution);
	      }
	      break;
	
	    case 'inRatio':
	      var newRatio = ratioComputer(state.inResolution['1']);
	      state.inRatio = newRatio;
	      // console.log('inResolution', state.inResolution)
	      break;
	
	    default:
	  }
	}), _defineProperty(_mutations, 'updateInputSourcFrom', function updateInputSourcFrom(state, isFromHDMI) {
	  state.isInputSourceFromHDMI = isFromHDMI;
	}), _mutations);
	
	var actions = {
	  updateMainScreenSize: function updateMainScreenSize(_ref4) {
	    var commit = _ref4.commit;
	
	    commit('UPDATE', {
	      type: 'isMobile'
	    });
	    commit('UPDATE', {
	      type: 'inRatio'
	    });
	  },
	  updatePreset: function updatePreset(_ref5, preset) {
	    var commit = _ref5.commit,
	        state = _ref5.state;
	
	    commit('UPDATE', {
	      type: 'preset',
	      preset: preset
	    });
	    commit('UPDATE', {
	      type: 'presetRatio'
	    });
	  },
	
	  // fetchData need async operation, so put it in actions
	  fetchData: function fetchData(_ref6, mac) {
	    var commit = _ref6.commit,
	        state = _ref6.state,
	        dispatch = _ref6.dispatch;
	
	    commit(FETCHDATA_VW_REQUEST);
	    var params = {
	      splitArea: {
	        split: {}
	      }
	    };
	    (0, _Service.call)(mac, 'dxGetAbout').then(function (_ref7) {
	      var model = _ref7.model;
	
	      params.model = model;
	      dispatch('fetchSource', { mac: mac, model: model });
	      return (0, _Service.call)(mac, 'dxGetInputResolution');
	    }).then(function (_ref8) {
	      var resolution = _ref8.resolution;
	
	      params.inResolution = resolution;
	      return (0, _Service.call)(mac, 'dxGetOutputResolution');
	    }).then(function (_ref9) {
	      var resolution = _ref9.resolution;
	
	      params.outResolutions = resolution;
	      return (0, _Service.call)(mac, 'dxGetOutputResolutionOptions');
	    }).then(function (_ref10) {
	      var options = _ref10.options;
	
	      params.outResolutionOptions = options;
	      return (0, _Service.call)(mac, 'dxGetOutputSplitOptions');
	    }).then(function (_ref11) {
	      var options = _ref11.options;
	
	      params.outputSplitOptions = options;
	      return (0, _Service.call)(mac, 'dxGetProfiles');
	    }).then(function (_ref12) {
	      var profiles = _ref12.profiles;
	
	      params.profiles = profiles;
	      return (0, _Service.call)(mac, 'dxGetSplitArea');
	    }).then(function (_ref13) {
	      var split = _ref13.split;
	
	      params.splitArea.split = split;
	      commit(FETCHDATA_VW_SUCCESS, params);
	      commit('UPDATE', {
	        type: 'inRatio'
	      });
	      commit('UPDATE', {
	        type: 'isMobile'
	      });
	      commit('UPDATE', {
	        type: 'presetRatio'
	      });
	    }).catch(function (e) {
	      console.log('error while fetching data', e);
	      commit(FETCHDATA_VW_ERROR, e);
	    });
	  },
	  fetchSource: function fetchSource(_ref14, _ref15) {
	    var commit = _ref14.commit,
	        state = _ref14.state;
	    var mac = _ref15.mac,
	        model = _ref15.model;
	
	    if (model === DOUBLE_INPUT_VW || model === 'vw 1x4-virtual') {
	      (0, _Service.call)(mac, 'dxGetInputSource').then(function (_ref16) {
	        var isSourceFromHDMI = _ref16.isSourceFromHDMI;
	
	        commit('updateInputSourcFrom', isSourceFromHDMI);
	      });
	    }
	  }
	};
	var getters = {
	  getIsFetching: function getIsFetching(state) {
	    return state.isFetching;
	  },
	  getIsInput4k: function getIsInput4k(state) {
	    return state.isInput4k;
	  },
	  getOutResolutionOptions: function getOutResolutionOptions(state) {
	    return state.outResolutionOptions;
	  },
	  getOutResolutions: function getOutResolutions(state) {
	    return state.outResolutions;
	  },
	  getOutputPorts: function getOutputPorts(state) {
	    return Object.keys(state.splitArea.split);
	  },
	  getOutputSplitOptions: function getOutputSplitOptions(state) {
	    return state.defaultOutputSplitOpts;
	  },
	  getInResolution: function getInResolution(state) {
	    return state.inResolution;
	  },
	  getSplitArea: function getSplitArea(state) {
	    return state.splitArea.split;
	  },
	  getInRatio: function getInRatio(state) {
	    return state.inRatio;
	  },
	  getInScreenWidth: function getInScreenWidth(state) {
	    return state.inRatio[0] * state.inRatio[3];
	  },
	  getInScreenHeight: function getInScreenHeight(state) {
	    return state.inRatio[1] * state.inRatio[3];
	  },
	  getProfiles: function getProfiles(state) {
	    return state.profiles;
	  },
	  getWindowFocus: function getWindowFocus(state) {
	    return state.windowFocus;
	  },
	  isFocus1: function isFocus1(state) {
	    return state.windowFocus === '1';
	  },
	  isFocus2: function isFocus2(state) {
	    return state.windowFocus === '2';
	  },
	  isFocus3: function isFocus3(state) {
	    return state.windowFocus === '3';
	  },
	  isFocus4: function isFocus4(state) {
	    return state.windowFocus === '4';
	  },
	  getLayoutChanged: function getLayoutChanged(state) {
	    return state.isLayoutChanged;
	  },
	  getComputedSplit: function getComputedSplit(state) {
	    var newSplit = _lodash2.default.cloneDeep(state.splitArea);
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = newSplit[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var key = _step2.value;
	
	        for (var i in newSplit[key]) {
	          newSplit[key][i] = newSplit[key][i] / state.inRatio[2] * state.inRatio[3];
	        }
	      }
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	          _iterator2.return();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	
	    return newSplit;
	  },
	  getCanSetRotatedSplit: function getCanSetRotatedSplit(state) {
	    var out1Resolution = state.outResolutionOptions[state.outResolutions['1']];
	    var out2Resolution = state.outResolutionOptions[state.outResolutions['2']];
	    var out3Resolution = state.outResolutionOptions[state.outResolutions['3']];
	    var out4Resolution = state.outResolutionOptions[state.outResolutions['4']];
	    var inResolution = state.inResolution['1'];
	    // console.log('out1', out1Resolution)
	    // console.log('out2', out2Resolution)
	    // console.log('out3', out3Resolution)
	    // console.log('out4', out4Resolution)
	    // console.log('in', inResolution)
	    return checkResolutionIsIn1920x1080(out1Resolution) && checkResolutionIsIn1920x1080(out2Resolution) && checkResolutionIsIn1920x1080(out3Resolution) && checkResolutionIsIn1920x1080(out4Resolution) && checkResolutionIsIn1920x1080(inResolution);
	  },
	  getIsMobile: function getIsMobile(state) {
	    return state.isMobile;
	  },
	  getPresetRatios: function getPresetRatios(state) {
	    return state.presetRatios;
	  },
	  getDeviceModel: function getDeviceModel(state) {
	    return state.model;
	  },
	  getIsSourceFromHDMI: function getIsSourceFromHDMI(state) {
	    return state.isInputSourceFromHDMI;
	  }
	};
	
	function checkResolutionIsIn1920x1080(resolution) {
	  return resolution.toLowerCase().includes('1920x1080@');
	}
	
	exports.default = new _vuex2.default.Store({
	  state: state,
	  mutations: mutations,
	  getters: getters,
	  actions: actions
	});

/***/ }),
/* 619 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Edid;
	/* eslint-disable */
	function Edid() {
	  this.EDID_BLOCK_LENGTH = 128;
	  this.WhiteAndSyncLevels = ["+0.7/−0.3 V", "+0.714/−0.286 V", "+1.0/−0.4 V", "+0.7/0 V"];
	  this.digitalColorSpace = ["RGB 4:4:4", "RGB 4:4:4 + YCrCb 4:4:4", "RGB 4:4:4 + YCrCb 4:2:2", "RGB 4:4:4 + YCrCb 4:4:4 + YCrCb 4:2:2"];
	  this.analogColorSpace = ["Monochrome or Grayscale", "RGB color", "Non-RGB color", "Undefined"];
	  this.establishedTimingBitmaps = ["720×400 @ 70 Hz", "720×400 @ 88 Hz", "640×480 @ 60 Hz", "640×480 @ 67 Hz", "640×480 @ 72 Hz", "640×480 @ 75 Hz", "800×600 @ 56 Hz", "800×600 @ 60 Hz", "800×600 @ 72 Hz", "800×600 @ 75 Hz", "832×624 @ 75 Hz", "1024×768i @ 87 Hz", "1024×768 @ 60 Hz", "1024×768 @ 72 Hz", "1024×768 @ 75 Hz", "1280×1024 @ 75 Hz", "1152x870 @ 75 Hz"];
	  this.DTD_LENGTH = 18;
	
	  this.xyPixelRatioEnum = [{ "string": "16:10" }, { "string": "4:3" }, { "string": "5:4" }, { "string": "16:9" }];
	
	  this.syncTypeEnum = { "ANALOG_COMPOSITE": 0x00,
	    "BIPOLAR_ANALOG_COMPOSITE": 0x01,
	    "DIGITAL_COMPOSITE": 0x02,
	    "DIGITAL_SEPARATE": 0x03 };
	
	  this.dataBlockType = {
	    RESERVED: { string: "RESERVED", value: 0 },
	    AUDIO: { string: "AUDIO", value: 1 },
	    VIDEO: { string: "VIDEO", value: 2 },
	    VENDOR_SPECIFIC: { string: "VENDOR SPECIFIC", value: 3 },
	    SPEAKER_ALLOCATION: { string: "SPEAKER ALLOCATION", value: 4 },
	    EXTENDED_TAG: { string: "EXTENDED TAG", value: 7 } };
	
	  this.extendedDataBlockType = {
	    VIDEO_CAPABILITY: { string: "VIDEO CAPABILITY", value: 0 },
	    COLORIMETRY: { string: "COLORIMETRY", value: 5 },
	    YCBCR420_VIDEO: { string: "YCBCR420 VIDEO DATA", value: 14 },
	    YCBCR420_CAPABILITY_MAP: { string: "YCBCR420_CAPABILITY_MAP", value: 15 } };
	
	  this.ieeeOuiType = {
	    HDMI14: { string: "HDMI14", value: 0x000C03 },
	    HDMI20: { string: "HDMI20", value: 0xC45DD8 } };
	
	  this.overscanBehavior = ["No data", "Always overscanned", "Always underscanned", "Supports both overscan and underscan"];
	
	  this.audioFormatArray = [1, 8, 13, 14, 15];
	  this.shortAudioDescriptors = ["RESERVED", "LPCM", "AC-3", "MPEG-1", "MP3", "MPEG2", "AAC LC", "DTS", "ATRAC", "DSD", "E-AC-3", "DTS-HD", "MLP", "DST", "WMA Pro"];
	  this.sadSampleRates = ["32 kHz", "44.1 kHz", "48 kHz", "88.2 kHz", "96 kHz", "176.4 kHz", "192 kHz"];
	  this.sadBitDepths = ["16 bit", "20 bit", "24 bit"];
	  this.shortVideoDescriptors = [{ "vic": 0 }, { "vic": 1, "format": "640x480p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "1:1" }, { "vic": 2, "format": "720x480p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "8:9" }, { "vic": 3, "format": "720x480p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "32:27" }, { "vic": 4, "format": "1280x720p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 5, "format": "1920x1080i", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 6, "format": "720(1440)x480i", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "8:9" }, { "vic": 7, "format": "720(1440)x480i", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "32:27" }, { "vic": 8, "format": "720(1440)x240p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "4:9" }, { "vic": 9, "format": "720(1440)x240p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "16:27" }, { "vic": 10, "format": "2880x480i", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "2:9 – 20:9" }, { "vic": 11, "format": "2880x480i", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "8:27 -80:27" }, { "vic": 12, "format": "2880x240p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "1:9 – 10:9" }, { "vic": 13, "format": "2880x240p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "4:27 – 40:27" }, { "vic": 14, "format": "1440x480p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "4:9 or 8:9" }, { "vic": 15, "format": "1440x480p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "16:27 or 32:27" }, { "vic": 16, "format": "1920x1080p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 17, "format": "720x576p", "fieldRate": "50Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "16:15" }, { "vic": 18, "format": "720x576p", "fieldRate": "50Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "64:45" }, { "vic": 19, "format": "1280x720p", "fieldRate": "50Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 20, "format": "1920x1080i", "fieldRate": "50Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 21, "format": "720(1440)x576i", "fieldRate": "50Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "16:15" }, { "vic": 22, "format": "720(1440)x576i", "fieldRate": "50Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "64:45" }, { "vic": 23, "format": "720(1440)x288p", "fieldRate": "50Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "8:15" }, { "vic": 24, "format": "720(1440)x288p", "fieldRate": "50Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "32:45" }, { "vic": 25, "format": "2880x576i", "fieldRate": "50Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "2:15 – 20:15" }, { "vic": 26, "format": "2880x576i", "fieldRate": "50Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "16:45-160:45" }, { "vic": 27, "format": "2880x288p", "fieldRate": "50Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "1:15 – 10:15" }, { "vic": 28, "format": "2880x288p", "fieldRate": "50Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "8:45 – 80:45" }, { "vic": 29, "format": "1440x576p", "fieldRate": "50Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "8:15 or 16:15" }, { "vic": 30, "format": "1440x576p", "fieldRate": "50Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "32:45 or 64:45" }, { "vic": 31, "format": "1920x1080p", "fieldRate": "50Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 32, "format": "1920x1080p", "fieldRate": "23.97Hz/24Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 33, "format": "1920x1080p", "fieldRate": "25Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 34, "format": "1920x1080p", "fieldRate": "29.97Hz/30Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 35, "format": "2880x480p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "2:9, 4:9, or 8:9" }, { "vic": 36, "format": "2880x480p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "8:27, 16:27, or 32:27" }, { "vic": 37, "format": "2880x576p", "fieldRate": "50Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "4:15, 8:15, or 16:15" }, { "vic": 38, "format": "2880x576p", "fieldRate": "50Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "16:45, 32:45, or 64:45" }, { "vic": 39, "format": "1920x1080i (1250 total)", "fieldRate": "50Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 40, "format": "1920x1080i", "fieldRate": "100Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 41, "format": "1280x720p", "fieldRate": "100Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 42, "format": "720x576p", "fieldRate": "100Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "16:15" }, { "vic": 43, "format": "720x576p", "fieldRate": "100Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "64:45" }, { "vic": 44, "format": "720(1440)x576i", "fieldRate": "100Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "16:15" }, { "vic": 45, "format": "720(1440)x576i", "fieldRate": "100Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "64:45" }, { "vic": 46, "format": "1920x1080i", "fieldRate": "119.88/120Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 47, "format": "1280x720p", "fieldRate": "119.88/120Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 48, "format": "720x480p", "fieldRate": "119.88/120Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "8:9" }, { "vic": 49, "format": "720x480p", "fieldRate": "119.88/120Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "32:27" }, { "vic": 50, "format": "720(1440)x480i", "fieldRate": "119.88/120Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "8:9" }, { "vic": 51, "format": "720(1440)x480i", "fieldRate": "119.88/120Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "32:27" }, { "vic": 52, "format": "720x576p", "fieldRate": "200Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "16:15" }, { "vic": 53, "format": "720x576p", "fieldRate": "200Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "64:45" }, { "vic": 54, "format": "720(1440)x576i", "fieldRate": "200Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "16:15" }, { "vic": 55, "format": "720(1440)x576i", "fieldRate": "200Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "64:45" }, { "vic": 56, "format": "720x480p", "fieldRate": "239.76/240Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "8:9" }, { "vic": 57, "format": "720x480p", "fieldRate": "239.76/240Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "32:27" }, { "vic": 58, "format": "720(1440)x480i", "fieldRate": "239.76/240Hz", "pictureAspectRatio": "4:3", "pixelAspectRatio": "8:9" }, { "vic": 59, "format": "720(1440)x480i", "fieldRate": "239.76/240Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "32:27" }, { "vic": 60, "format": "1280x720p", "fieldRate": "23.97Hz/24Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 61, "format": "1280x720p", "fieldRate": "25Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 62, "format": "1280x720p", "fieldRate": "29.97Hz/30Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 63, "format": "1920x1080p", "fieldRate": "119.88/120Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 64, "format": "1920x1080p", "fieldRate": "100Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 65, "format": "1280x720p", "fieldRate": "23.98Hz/24Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "4:3" }, { "vic": 66, "format": "1280x720p", "fieldRate": "25Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "4:3" }, { "vic": 67, "format": "1280x720p", "fieldRate": "29.97Hz/30Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "4:3" }, { "vic": 68, "format": "1280x720p", "fieldRate": "50Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "4:3" }, { "vic": 69, "format": "1280x720p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "4:3" }, { "vic": 70, "format": "1280x720p", "fieldRate": "100Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "4:3" }, { "vic": 71, "format": "1280x720p", "fieldRate": "119.88Hz/120Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "4:3" }, { "vic": 72, "format": "1920x1080p", "fieldRate": "23.98Hz/24Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "4:3" }, { "vic": 73, "format": "1920x1080p", "fieldRate": "25Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "4:3" }, { "vic": 74, "format": "1920x1080p", "fieldRate": "29.97Hz/30Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "4:3" }, { "vic": 75, "format": "1920x1080p", "fieldRate": "50Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "4:3" }, { "vic": 76, "format": "1920x1080p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "4:3" }, { "vic": 77, "format": "1920x1080p", "fieldRate": "100Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "4:3" }, { "vic": 78, "format": "1920x1080p", "fieldRate": "119.88Hz/120Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "4:3" }, { "vic": 79, "format": "1680x720p", "fieldRate": "23.98Hz/24Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "64:63" }, { "vic": 80, "format": "1680x720p", "fieldRate": "25Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "64:63" }, { "vic": 81, "format": "1680x720p", "fieldRate": "29.97Hz/30Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "64:63" }, { "vic": 82, "format": "1680x720p", "fieldRate": "50Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "64:63" }, { "vic": 83, "format": "1680x720p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "64:63" }, { "vic": 84, "format": "1680x720p", "fieldRate": "100Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "64:63" }, { "vic": 85, "format": "1680x720p", "fieldRate": "119.88Hz/120Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "64:63" }, { "vic": 86, "format": "2560p1080p", "fieldRate": "23.98Hz/24Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "1:1" }, { "vic": 87, "format": "2560p1080p", "fieldRate": "25Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "1:1" }, { "vic": 88, "format": "2560p1080p", "fieldRate": "29.97Hz/30Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "1:1" }, { "vic": 89, "format": "2560p1080p", "fieldRate": "50Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "1:1" }, { "vic": 90, "format": "2560p1080p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "1:1" }, { "vic": 91, "format": "2560p1080p", "fieldRate": "100Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "1:1" }, { "vic": 92, "format": "2560p1080p", "fieldRate": "119.88Hz/120Hz", "pictureAspectRatio": "64:27", "pixelAspectRatio": "1:1" }, { "vic": 93, "format": "3840x2160p", "fieldRate": "23.98Hz/24Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 94, "format": "3840x2160p", "fieldRate": "25Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 95, "format": "3840x2160p", "fieldRate": "29.97Hz/30Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 96, "format": "3840x2160p", "fieldRate": "50Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 97, "format": "3840x2160p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 98, "format": "4096x2160p", "fieldRate": "23.98Hz/24Hz", "pictureAspectRatio": "256:135", "pixelAspectRatio": "1:1" }, { "vic": 99, "format": "4096x2160p", "fieldRate": "25Hz", "pictureAspectRatio": "256:135", "pixelAspectRatio": "1:1" }, { "vic": 100, "format": "4096x2160p", "fieldRate": "29.97Hz/30Hz", "pictureAspectRatio": "256:135", "pixelAspectRatio": "1:1" }, { "vic": 101, "format": "4096x2160p", "fieldRate": "50Hz", "pictureAspectRatio": "256:135", "pixelAspectRatio": "1:1" }, { "vic": 102, "format": "4096x2160p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "256:135", "pixelAspectRatio": "1:1" }, { "vic": 103, "format": "3840x2160p", "fieldRate": "23.98Hz/24Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 104, "format": "3840x2160p", "fieldRate": "25Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 105, "format": "3840x2160p", "fieldRate": "29.97Hz/30Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 106, "format": "3840x2160p", "fieldRate": "50Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }, { "vic": 107, "format": "3840x2160p", "fieldRate": "59.94Hz/60Hz", "pictureAspectRatio": "16:9", "pixelAspectRatio": "1:1" }];
	  this.speakerAllocation = ["Front Left/Front Right (FL/FR)", "Low Frequency Effort (LFE)", "Front Center (FC)", "Rear Left/Rear Right (RL/RR)", "Rear Center (RC)", "Front Left Center/Front Right Center (FLC/FRC)", "Rear Left Center/Rear Right Center (RLC/RRC)", "Front Left Wide/Front Right Wide (FLW/FRW)", "Front Left High/Frong Right High (FLH/FRH)", "Top Center (TC)", "Front Center High (FCH)"];
	}
	
	Edid.prototype.setEdidData = function (edid) {
	  this.edidData = edid;
	};
	
	Edid.prototype.parse = function () {
	  if (this.validateHeader() == true) {
	    this.validHeader = "OK";
	  } else {
	    this.validHeader = "ERROR";
	  }
	
	  this.eisaId = this.getEisaId();
	
	  this.productCode = this.getProductCode();
	
	  this.serialNumber = this.getSerialNumber();
	
	  this.manufactureDate = this.getManufactureWeek() + "/" + this.getManufactureYear();
	
	  this.edidVersion = this.getEdidVersion() + "." + this.getEdidRevision();
	
	  this.bdp = this.getBasicDisplayParams();
	
	  this.chromaticity = this.getChromaticityCoordinates();
	
	  this.timingBitmap = this.getTimingBitmap();
	
	  this.standardDisplayModes = this.getStandardDisplayModes();
	
	  this.dtds = this.getDtds();
	
	  this.numberOfExtensions = this.getNumberExtensions();
	
	  this.checksum = this.getChecksum();
	
	  this.exts = new Array();
	  // Begin Parsing Extension blocks
	  for (var extIndex = 0; extIndex < this.numberOfExtensions; extIndex++) {
	    this.exts[extIndex] = new Object();
	    this.exts[extIndex].blockNumber = extIndex + 1;
	    this.exts[extIndex].extTag = this.getExtTag(extIndex);
	    this.exts[extIndex].revisionNumber = this.getRevisionNumber(extIndex);
	    this.exts[extIndex].dtdStart = this.getDtdStart(extIndex);
	    this.exts[extIndex].numDtds = this.getNumberExtDtds(extIndex);
	    this.exts[extIndex].underscan = this.getUnderscan(extIndex);
	    this.exts[extIndex].basicAudio = this.getBasicAudio(extIndex);
	    this.exts[extIndex].ycbcr444 = this.getYcBcR444(extIndex);
	    this.exts[extIndex].ycbcr422 = this.getYcBcR422(extIndex);
	    // If DTDs don't start at byte 4
	    if (this.exts[extIndex].dtdStart != 4) {
	      // Parse Data Collection block
	      this.exts[extIndex].dataBlockCollection = this.parseDataBlockCollection(extIndex);
	    }
	    // Parse DTDs
	    this.exts[extIndex].dtds = this.getExtDtds(extIndex, this.exts[extIndex].dtdStart);
	    // Get Checkum
	    this.exts[extIndex].checksum = this.getExtChecksum(extIndex);
	  }
	};
	
	Edid.prototype.validateHeader = function () {
	  var validHeader = new Boolean();
	  if (this.edidData[0] == 0x00 && this.edidData[1] == 0xFF && this.edidData[2] == 0xFF && this.edidData[3] == 0xFF && this.edidData[4] == 0xFF && this.edidData[5] == 0xFF && this.edidData[6] == 0xFF && this.edidData[7] == 0x00) {
	    validHeader = true;
	  } else {
	    validHeader = false;
	  }
	  return validHeader;
	};
	
	Edid.prototype.getEisaId = function () {
	  var FIVE_BIT_LETTER_MASK = 0x1F;
	  var EISA_ID_BYTE1 = 8;
	  var EISA_ID_BYTE2 = 9;
	  var EISA_LETTER1_OFF = 2;
	  var EISA_LETTER2_OFF = 5;
	  var LETTER2_TOP_BYTES = 3;
	  var LETTER2_TOP_MASK = 0x03;
	  var LETTER2_BOT_MASK = 0x07;
	
	  var firstLetter = this.edidData[EISA_ID_BYTE1] >> EISA_LETTER1_OFF & FIVE_BIT_LETTER_MASK;
	
	  // Get the first two bits [2:0] of the top byte
	  var secondLetterTop = this.edidData[EISA_ID_BYTE1] & LETTER2_TOP_MASK;
	  // Get the last three bits [7:5] of the bottom byte
	  var secondLetterBottom = this.edidData[EISA_ID_BYTE2] >> EISA_LETTER2_OFF & LETTER2_BOT_MASK;
	  // Combine the top and bottom
	  var secondLetter = secondLetterTop << LETTER2_TOP_BYTES | secondLetterBottom;
	
	  var thirdLetter = this.edidData[EISA_ID_BYTE2] & FIVE_BIT_LETTER_MASK;
	
	  return intToAscii(firstLetter) + intToAscii(secondLetter) + intToAscii(thirdLetter);
	};
	
	function intToAscii(intCode) {
	  var abc = "0ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
	  return abc[intCode];
	}
	
	Edid.prototype.getProductCode = function () {
	  var PRODUCT_CODE1 = 10;
	  var PRODUCT_CODE2 = 11;
	
	  return this.edidData[PRODUCT_CODE2] << 8 | this.edidData[PRODUCT_CODE1];
	};
	
	Edid.prototype.getSerialNumber = function () {
	  var SERIAL_NUMBER1 = 12;
	  var SERIAL_NUMBER2 = 13;
	  var SERIAL_NUMBER3 = 14;
	  var SERIAL_NUMBER4 = 15;
	
	  return this.edidData[SERIAL_NUMBER4] << 24 | this.edidData[SERIAL_NUMBER3] << 16 | this.edidData[SERIAL_NUMBER2] << 8 | this.edidData[SERIAL_NUMBER1];
	};
	
	Edid.prototype.getManufactureWeek = function () {
	  var MANUFACTURE_WEEK = 16;
	  return this.edidData[MANUFACTURE_WEEK];
	};
	
	Edid.prototype.getManufactureYear = function () {
	  var MANUFACTURE_YEAR = 17;
	  return this.edidData[MANUFACTURE_YEAR] + 1990;
	};
	
	Edid.prototype.getEdidVersion = function () {
	  var EDID_VERSION = 18;
	  return this.edidData[EDID_VERSION];
	};
	
	Edid.prototype.getEdidRevision = function () {
	  var EDID_REVISION = 19;
	  return this.edidData[EDID_REVISION];
	};
	
	Edid.prototype.getBasicDisplayParams = function () {
	  var bdp = new Object();
	
	  var VIDEO_IN_PARAMS_BITMAP = 20;
	  var DIGITAL_INPUT = 0x80;
	  if (this.edidData[VIDEO_IN_PARAMS_BITMAP] & DIGITAL_INPUT) {
	    var VESA_DFP_COMPATIBLE = 0x01;
	    bdp.digitalInput = true;
	    if (this.edidData[VIDEO_IN_PARAMS_BITMAP] & VESA_DFP_COMPATIBLE) {
	      bdp.vesaDfpCompatible = true;
	    } else {
	      bdp.vesaDfpCompatible = false;
	    }
	  } else {
	    bdp.digitalInput = false;
	
	    var WHITE_SYNC_LVLS_OFF = 5;
	    var WHITE_SYNC_LVLS_MASK = 0x03;
	    bdp.whiteSyncLevels = this.edidData[VIDEO_IN_PARAMS_BITMAP] >> WHITE_SYNC_LVLS_OFF & WHITE_SYNC_LVLS_MASK;
	
	    var BLANK_TO_BLACK_OFF = 4;
	    var BLANK_TO_BLACK_MASK = 0x01;
	    bdp.blankToBlack = this.edidData[VIDEO_IN_PARAMS_BITMAP] >> BLANK_TO_BLACK_OFF & BLANK_TO_BLACK_MASK ? true : false;
	
	    var SEPARATE_SYNC_OFF = 3;
	    var SEPARATE_SYNC_MASK = 0x01;
	    bdp.separateSyncSupported = this.edidData[VIDEO_IN_PARAMS_BITMAP] >> SEPARATE_SYNC_OFF & SEPARATE_SYNC_MASK ? true : false;
	
	    var COMPOSITE_SYNC_OFF = 2;
	    var COMPOSITE_SYNC_MASK = 0x01;
	    bdp.compositeSyncSupported = this.edidData[VIDEO_IN_PARAMS_BITMAP] >> COMPOSITE_SYNC_OFF & COMPOSITE_SYNC_MASK ? true : false;
	
	    var SYNC_ON_GREEN_OFF = 1;
	    var SYNC_ON_GREEN_MASK = 0x01;
	    bdp.synOnGreen = this.edidData[VIDEO_IN_PARAMS_BITMAP] >> SYNC_ON_GREEN_OFF & SYNC_ON_GREEN_MASK ? true : false;
	
	    var VSYNC_SERRATED_MASK = 0x01;
	    bdp.vsyncSerrated = this.edidData[VIDEO_IN_PARAMS_BITMAP] & VSYNC_SERRATED_MASK ? true : false;
	  }
	  var MAX_HOR_IMG_SIZE = 21;
	  bdp.maxHorImgSize = this.edidData[MAX_HOR_IMG_SIZE];
	
	  var MAX_VERT_IMG_SIZE = 22;
	  bdp.maxVertImgSize = this.edidData[MAX_VERT_IMG_SIZE];
	
	  var DISPLAY_GAMMA = 23;
	  bdp.displayGamma = this.edidData[DISPLAY_GAMMA] * (2.54 / 255) + 1;
	
	  var SUPPORTED_FEATURES_BITMAP = 24;
	  var DPMS_STANDBY = 0x80;
	  bdp.dpmsStandby = this.edidData[SUPPORTED_FEATURES_BITMAP] & DPMS_STANDBY ? true : false;
	  var DPMS_SUSPEND = 0x40;
	  bdp.dpmsSuspend = this.edidData[SUPPORTED_FEATURES_BITMAP] & DPMS_SUSPEND ? true : false;
	  var DPMS_ACTIVE_OFF = 0x20;
	  bdp.dpmsActiveOff = this.edidData[SUPPORTED_FEATURES_BITMAP] & DPMS_ACTIVE_OFF ? true : false;
	  var DISPLAY_TYPE_OFF = 3;
	  var DISPLAY_TYPE_MASK = 0x03;
	  bdp.displayType = this.edidData[SUPPORTED_FEATURES_BITMAP] >> DISPLAY_TYPE_OFF & DISPLAY_TYPE_MASK;
	
	  var STANDARD_SRGB = 0x04;
	  bdp.standardSRgb = this.edidData[SUPPORTED_FEATURES_BITMAP] & STANDARD_SRGB ? true : false;
	  var PREFERRED_TIMING = 0x02;
	  bdp.preferredTiming = this.edidData[SUPPORTED_FEATURES_BITMAP] & PREFERRED_TIMING ? true : false;
	  var GTF_SUPPORTED = 0x01;
	  bdp.gtfSupported = this.edidData[SUPPORTED_FEATURES_BITMAP] & GTF_SUPPORTED ? true : false;
	  return bdp;
	};
	
	Edid.prototype.getChromaticityCoordinates = function () {
	  var chromaticity = new Object();
	  var TWO_BIT_MASK = 0x03;
	  var TWO_BIT_OFF = 2;
	  var FOUR_BIT_OFF = 4;
	  var SIX_BIT_OFF = 6;
	
	  var RED_GREEN_LSB = 25;
	  var RED_X_MSB = 27;
	  chromaticity.redX = this.edidData[RED_X_MSB] << TWO_BIT_OFF | this.edidData[RED_GREEN_LSB] >> SIX_BIT_OFF & TWO_BIT_MASK;
	  chromaticity.redXCoords = chromaticity.redX / 1024;
	
	  var RED_Y_MSB = 28;
	  chromaticity.redY = this.edidData[RED_Y_MSB] << TWO_BIT_OFF | this.edidData[RED_GREEN_LSB] >> FOUR_BIT_OFF & TWO_BIT_MASK;
	  chromaticity.redYCoords = chromaticity.redY / 1024;
	
	  var GREEN_X_MSB = 29;
	  chromaticity.greenX = this.edidData[GREEN_X_MSB] << TWO_BIT_OFF | this.edidData[RED_GREEN_LSB] >> TWO_BIT_OFF & TWO_BIT_MASK;
	  chromaticity.greenXCoords = chromaticity.greenX / 1024;
	
	  var GREEN_Y_MSB = 30;
	  chromaticity.greenY = this.edidData[GREEN_Y_MSB] << TWO_BIT_OFF | this.edidData[RED_GREEN_LSB] & TWO_BIT_MASK;
	  chromaticity.greenYCoords = chromaticity.greenY / 1024;
	
	  var BLUE_WHITE_LSB = 26;
	  var BLUE_X_MSB = 31;
	  chromaticity.blueX = this.edidData[BLUE_X_MSB] << TWO_BIT_OFF | this.edidData[BLUE_WHITE_LSB] >> SIX_BIT_OFF & TWO_BIT_MASK;
	  chromaticity.blueXCoords = chromaticity.blueX / 1024;
	
	  var BLUE_Y_MSB = 32;
	  chromaticity.blueY = this.edidData[BLUE_Y_MSB] << TWO_BIT_OFF | this.edidData[BLUE_WHITE_LSB] >> FOUR_BIT_OFF & TWO_BIT_MASK;
	  chromaticity.blueYCoords = chromaticity.blueY / 1024;
	
	  var WHITE_X_MSB = 33;
	  chromaticity.whiteX = this.edidData[WHITE_X_MSB] << TWO_BIT_OFF | this.edidData[BLUE_WHITE_LSB] >> TWO_BIT_OFF & TWO_BIT_MASK;
	  chromaticity.whiteXCoords = chromaticity.whiteX / 1024;
	
	  var WHITE_Y_MSB = 34;
	  chromaticity.whiteY = this.edidData[WHITE_Y_MSB] << TWO_BIT_OFF | this.edidData[BLUE_WHITE_LSB] & TWO_BIT_MASK;
	  chromaticity.whiteYCoords = chromaticity.whiteY / 1024;
	
	  return chromaticity;
	};
	
	Edid.prototype.getTimingBitmap = function () {
	  var TIMING_BITMAP1 = 35;
	  var TIMING_BITMAP2 = 36;
	  var TIMING_BITMAP3 = 37;
	
	  var timingBitmap = this.edidData[TIMING_BITMAP1] << 16 | this.edidData[TIMING_BITMAP2] << 8 | this.edidData[TIMING_BITMAP3];
	  return timingBitmap;
	};
	
	Edid.prototype.getStandardDisplayModes = function () {
	  var STD_DISPLAY_MODES_START = 38;
	  var STD_DISPLAY_MODES_END = 53;
	
	  var stdDispModesArray = new Array();
	  var arrayCounter = 0;
	  var index = STD_DISPLAY_MODES_START;
	  while (index < STD_DISPLAY_MODES_END) {
	    if (this.edidData[index] != 0x01 && this.edidData[index + 1] != 0x01) {
	      var standardDisplayModes = new Object();
	      standardDisplayModes.xResolution = (this.edidData[index] + 31) * 8;
	
	      var XY_PIXEL_RATIO_OFF = 6;
	      var XY_PIXEL_RATIO_MASK = 0x03;
	      standardDisplayModes.xyPixelRatio = this.edidData[index + 1] >> XY_PIXEL_RATIO_OFF & XY_PIXEL_RATIO_MASK;
	
	      var VERTICAL_FREQUENCY_MASK = 0x3F;
	      standardDisplayModes.vertFreq = (this.edidData[index + 1] & VERTICAL_FREQUENCY_MASK) + 60;
	
	      stdDispModesArray[arrayCounter] = standardDisplayModes;
	      arrayCounter++;
	    }
	    index += 2;
	  }
	  return stdDispModesArray;
	};
	
	Edid.prototype.parseDtd = function (dtdIndex) {
	  var dtd = new Object();
	
	  // Pixel Clock in MHz
	  dtd.pixelClock = (this.edidData[dtdIndex + 1] << 8 | this.edidData[dtdIndex]) / 100;
	
	  var HOR_ACTIVE_OFF = 4;
	  var HOR_ACTIVE_PIX_MASK = 0x0F;
	  dtd.horActivePixels = (this.edidData[dtdIndex + 4] >> HOR_ACTIVE_OFF & HOR_ACTIVE_PIX_MASK) << 8 | this.edidData[dtdIndex + 2];
	
	  var HOR_BLANK_MASK = 0x0F;
	  dtd.horBlankPixels = (this.edidData[dtdIndex + 4] & HOR_BLANK_MASK) << 8 | this.edidData[dtdIndex + 3];
	
	  var VERT_ACTIVE_OFF = 4;
	  var VERT_ACTIVE_MASK = 0x0F;
	  dtd.vertActivePixels = (this.edidData[dtdIndex + 7] >> VERT_ACTIVE_OFF & VERT_ACTIVE_MASK) << 8 | this.edidData[dtdIndex + 5];;
	  var VERT_BLANK_MASK = 0x0F;
	  dtd.vertBlankPixels = (this.edidData[dtdIndex + 7] & VERT_BLANK_MASK) << 8 | this.edidData[dtdIndex + 6];
	
	  var HOR_SYNC_OFF_OFF = 6;
	  var HOR_SYNC_OFF_MASK = 0x03;
	  dtd.horSyncOff = (this.edidData[dtdIndex + 11] >> HOR_SYNC_OFF_OFF & HOR_SYNC_OFF_MASK) << 8 | this.edidData[dtdIndex + 8];
	
	  var HOR_SYNC_PULSE_OFF = 4;
	  var HOR_SYNC_PULSE_MASK = 0x03;
	  dtd.horSyncPulse = (this.edidData[dtdIndex + 11] >> HOR_SYNC_PULSE_OFF & HOR_SYNC_PULSE_MASK) << 8 | this.edidData[dtdIndex + 9];
	
	  var VERT_SYNC_OFF_TOP_OFF = 2;
	  var VERT_SYNC_OFF_TOP_MASK = 0x03;
	  var VERT_SYNC_OFF_BOT_OFF = 4;
	  var VERT_SYNC_OFF_BOT_MASK = 0x0F;
	  dtd.vertSyncOff = (this.edidData[dtdIndex + 11] >> VERT_SYNC_OFF_TOP_OFF & VERT_SYNC_OFF_TOP_MASK) << 4 | this.edidData[dtdIndex + 10] >> VERT_SYNC_OFF_BOT_OFF & VERT_SYNC_OFF_BOT_MASK;
	
	  var VERT_SYNC_PULSE_TOP_MASK = 0x03;
	  var VERT_SYNC_PULSE_BOT_MASK = 0x0F;
	  dtd.vertSyncPulse = (this.edidData[dtdIndex + 11] & VERT_SYNC_PULSE_TOP_MASK) << 4 | this.edidData[dtdIndex + 10] & VERT_SYNC_PULSE_BOT_MASK;
	
	  var HOR_DISPLAY_TOP_OFF = 4;
	  var HOR_DISPLAY_TOP_MASK = 0x0F;
	  dtd.horDisplaySize = (this.edidData[dtdIndex + 14] >> HOR_DISPLAY_TOP_OFF & HOR_DISPLAY_TOP_MASK) << 8 | this.edidData[dtdIndex + 12];
	
	  var VERT_DISPLAY_TOP_MASK = 0x0F;
	  dtd.vertDisplaySize = (this.edidData[dtdIndex + 14] & VERT_DISPLAY_TOP_MASK) << 8 | this.edidData[dtdIndex + 13];
	
	  dtd.horBorderPixels = this.edidData[dtdIndex + 15];
	
	  dtd.vertBorderLines = this.edidData[dtdIndex + 16];
	
	  var INTERLACED_MASK = 0x80;
	  dtd.interlaced = this.edidData[dtdIndex + 17] & INTERLACED_MASK ? true : false;
	
	  var STEREO_MODE_OFFSET = 5;
	  var STEREO_MODE_MASK = 0x03;
	  dtd.stereoMode = this.edidData[dtdIndex + 17] >> STEREO_MODE_OFFSET & STEREO_MODE_MASK;
	
	  var SYNC_TYPE_OFFSET = 3;
	  var SYNC_TYPE_MASK = 0x03;
	  dtd.syncType = this.edidData[dtdIndex + 17] >> SYNC_TYPE_OFFSET & SYNC_TYPE_MASK;
	  // Bit is dependent on sync type
	  if (dtd.syncType == this.syncTypeEnum.DIGITAL_SEPARATE) {
	    var VSYNC_POLARITY_MASK = 0x04;
	    dtd.vSyncPolarity = this.edidData[dtdIndex + 17] & VSYNC_POLARITY_MASK ? true : false;
	  } else {
	    var VSYNC_SERRATED_MASK = 0x04;
	    dtd.vSyncSerrated = this.edidData[dtdIndex + 17] & VSYNC_SERRATED_MASK ? true : false;
	  }
	
	  // Bit is dependent on syn type
	  if (dtd.syncType == this.syncTypeEnum.ANALOG_COMPOSITE || dtd.syncType == this.syncTypeEnum.BIPOLAR_ANALOG_COMPOSITE) {
	    var SYNC_ALL_RGB_MASK = 0x02;
	    dtd.syncAllRGBLines = this.edidData[dtdIndex + 17] & SYNC_ALL_RGB_MASK ? true : false;
	  } else {
	    var HSYNC_POLARY_MASK = 0x02;
	    dtd.hSyncPolarity = this.edidData[dtdIndex + 17] & HSYNC_POLARY_MASK ? true : false;
	  }
	  var TWO_WAY_STEREO_MASK = 0x01;
	  dtd.twoWayStereo = this.edidData[dtdIndex + 17] & TWO_WAY_STEREO_MASK ? true : false;
	
	  return dtd;
	};
	
	Edid.prototype.getDtds = function () {
	  var dtdArray = new Array();
	  var dtdCounter = 0;
	
	  var DTD_START = 54;
	  var DTD_END = 125;
	
	  var dtdIndex = DTD_START;
	
	  // While the pixel clock is not equal to zero and
	  // the DTD index is less than the last byte of the DTD
	  while ((this.edidData[dtdIndex] != 0 || this.edidData[dtdIndex + 1] != 0) && dtdIndex < DTD_END) {
	    var dtd = this.parseDtd(dtdIndex);
	    // Add DTD to the DTD Array
	    dtdArray[dtdCounter] = dtd;
	    // Increment DTD Counter
	    dtdCounter++;
	    // Add a DTD length, to go to the next descriptor
	    dtdIndex += this.DTD_LENGTH;
	  }
	  return dtdArray;
	};
	
	Edid.prototype.getNumberExtensions = function () {
	  var NUMBER_OF_EXTENSIONS = 126;
	  return this.edidData[NUMBER_OF_EXTENSIONS];
	};
	
	Edid.prototype.getChecksum = function () {
	  var CHECKSUM = 127;
	  return this.edidData[CHECKSUM];
	};
	
	Edid.prototype.calcChecksum = function (block) {
	  var startAddress = block * this.EDID_BLOCK_LENGTH;
	  var endAddress = startAddress + this.EDID_BLOCK_LENGTH - 1;
	  var checksum = 0;
	  for (var index = startAddress; index < endAddress; index++) {
	    checksum += this.edidData[index];
	  }
	  return 256 - checksum % 256;
	};
	
	Edid.prototype.validChecksum = function (block) {
	  var checksum = this.edidData[(block + 1) * this.EDID_BLOCK_LENGTH - 1];
	  var calculatedChecksum = this.calcChecksum(block);
	  var validChecksum = new Boolean();
	
	  if (checksum == calculatedChecksum) {
	    validChecksum = true;
	  } else {
	    validChecksum = false;
	  }
	  return validChecksum;
	};
	
	Edid.prototype.getExtTag = function (extIndex) {
	  var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
	  var EXT_TAG = BLOCK_OFFSET + 0;
	  return this.edidData[EXT_TAG];
	};
	
	Edid.prototype.getRevisionNumber = function (extIndex) {
	  var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
	  var REV_NUMBER = BLOCK_OFFSET + 1;
	  return this.edidData[REV_NUMBER];
	};
	
	Edid.prototype.getDtdStart = function (extIndex) {
	  var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
	  var DTD_START = BLOCK_OFFSET + 2;
	  return this.edidData[DTD_START];
	};
	
	Edid.prototype.getNumberExtDtds = function (extIndex) {
	  var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
	  var NUM_DTDS = BLOCK_OFFSET + 3;
	  var NUM_DTDS_MASK = 0x0F;
	  return this.edidData[NUM_DTDS] & NUM_DTDS_MASK;
	};
	
	Edid.prototype.getUnderscan = function (extIndex) {
	  var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
	  var UNDERSCAN = BLOCK_OFFSET + 3;
	  var UNDERSCAN_MASK = 0x80;
	  return this.edidData[UNDERSCAN] & UNDERSCAN_MASK ? true : false;
	};
	
	Edid.prototype.getBasicAudio = function (extIndex) {
	  var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
	  var BASIC_AUDIO = BLOCK_OFFSET + 3;
	  var BASIC_AUDIO_MASK = 0x40;
	  return this.edidData[BASIC_AUDIO] & BASIC_AUDIO_MASK ? true : false;
	};
	
	Edid.prototype.getYcBcR444 = function (extIndex) {
	  var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
	  var YCBCR_444 = BLOCK_OFFSET + 3;
	  var YCBCR_444_MASK = 0x20;
	  return this.edidData[YCBCR_444] & YCBCR_444_MASK ? true : false;
	};
	
	Edid.prototype.getYcBcR422 = function (extIndex) {
	  var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
	  var YCBCR_422 = BLOCK_OFFSET + 3;
	  var YCBCR_422_MASK = 0x10;
	  return this.edidData[YCBCR_422] & YCBCR_422_MASK ? true : false;
	};
	
	Edid.prototype.parseDataBlockCollection = function (extIndex) {
	  var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
	  var START_DATA_BLOCK = 4;
	  var startAddress = BLOCK_OFFSET + START_DATA_BLOCK;
	  var dataBlockLength = this.exts[extIndex].dtdStart - START_DATA_BLOCK;
	  var endAddress = startAddress + dataBlockLength;
	  var dataBlockCollection = new Array();
	
	  var TAG_CODE_MASK = 0x07;
	  var TAG_CODE_OFFSET = 5;
	  var DATA_BLOCK_LENGTH_MASK = 0x1F;
	  var index = startAddress;
	  var numberDataBlocks = 0;
	  while (index < endAddress) {
	    // Parse tag code
	    var blockTagCode = this.edidData[index] >> TAG_CODE_OFFSET & TAG_CODE_MASK;
	    // Parse Length
	    var blockLength = this.edidData[index] & DATA_BLOCK_LENGTH_MASK;
	
	    // Object that holds Parsed Data block
	    var dataBlock;
	
	    // Parse the data block by the tag code
	    if (blockTagCode == this.dataBlockType.AUDIO.value) {
	      dataBlock = this.parseAudioDataBlock(index + 1, blockLength);
	    } else if (blockTagCode == this.dataBlockType.VIDEO.value) {
	      dataBlock = this.parseVideoDataBlock(index + 1, blockLength);
	    } else if (blockTagCode == this.dataBlockType.VENDOR_SPECIFIC.value) {
	      dataBlock = this.parseVendorDataBlock(index + 1, blockLength);
	    } else if (blockTagCode == this.dataBlockType.SPEAKER_ALLOCATION.value) {
	      dataBlock = this.parseSpeakerDataBlock(index + 1, blockLength);
	    } else if (blockTagCode == this.dataBlockType.EXTENDED_TAG.value) {
	      dataBlock = this.parseExtendedTagDataBlock(index + 1, blockLength);
	    }
	
	    // Add the new object to the data block collection
	    dataBlockCollection[numberDataBlocks] = dataBlock;
	    // Increment the Index, to the location of the next block
	    index += blockLength + 1;
	    // Increment the number of data blocks
	    numberDataBlocks++;
	  }
	  return dataBlockCollection;
	};
	
	Edid.prototype.parseAudioDataBlock = function (startAddress, blockLength) {
	  var audioBlock = new Array();
	  // Audio blocks are made up of Short Audio Descriptors that are three bytes each
	  var SHORT_AUDIO_DESC_LENGTH = 3;
	  // The number of Short Audio Descriptors is the block length divided by the descriptor size
	  var numberShortAudioDescriptors = blockLength / SHORT_AUDIO_DESC_LENGTH;
	  var shortAudDescIndex = 0;
	  var index = startAddress;
	
	  // Set the Audio Block Tag
	  audioBlock.tag = this.dataBlockType.AUDIO;
	  // Set the Audio block length
	  audioBlock.dataLength = blockLength;
	  // Set the number of short audio descriptors
	  audioBlock.length = numberShortAudioDescriptors;
	  // Create array for short audio descriptors
	  audioBlock.shortAudioDescriptors = new Array();
	
	  // Parse the short audio descriptors in the Audio Data Block
	  var SHORT_AUDIO_DESC_MASK = 0x0F;
	  var SHORT_AUDIO_DESC_OFF = 3;
	  var MAX_CHANNELS_MASK = 0x07;
	  var SAMPLE_RATE_MASK = 0x7F;
	  while (shortAudDescIndex < numberShortAudioDescriptors) {
	    // Each Short Audio Descriptor is a 3 byte object
	    var shortAudDesc = new Object();
	
	    // Parse the format
	    shortAudDesc.format = this.edidData[index] >> SHORT_AUDIO_DESC_OFF & SHORT_AUDIO_DESC_MASK;
	    // Parse max number of channels
	    shortAudDesc.maxChannels = (this.edidData[index] & MAX_CHANNELS_MASK) + 1;
	    // Parse audio sample rates
	    shortAudDesc.sampleRates = this.edidData[index + 1] & SAMPLE_RATE_MASK;
	
	    if (shortAudDesc.format <= this.audioFormatArray[0]) {
	      var BIT_DEPTH_MASK = 0x07;
	      shortAudDesc.bitDepth = this.edidData[index + 2] & BIT_DEPTH_MASK;
	    } else if (shortAudDesc.format <= this.audioFormatArray[1]) {
	      var MAX_BIT_RATE_MASK = 0xFF;
	      shortAudDesc.bitRate = (this.edidData[index + 2] & MAX_BIT_RATE_MASK) * 8;
	    } else if (shortAudDesc.format <= this.audioFormatArray[2]) {
	      var AUDIO_FORMAT_CODE_MASK = 0xFF;
	      shortAudDesc.audioFormatCode = this.edidData[index + 2] & AUDIO_FORMAT_CODE_MASK;
	    } else if (shortAudDesc.format <= this.audioFormatArray[3]) {
	      var PROFILE_MASK = 0x07;
	      shortAudDesc.profile = this.edidData[index + 2] & PROFILE_MASK;
	    } else if (shortAudDesc.format <= this.audioFormatArray[4]) {
	      var FORMAT_CODE_EXT_OFF = 3;
	      var FORMAT_CODE_EXT_MASK = 0x1F;
	      shortAudDesc.formatCodeExt = this.edidData[index + 2] >> FORMAT_CODE_EXT_OFF & FORMAT_CODE_EXT_MASK;
	    }
	
	    // Add Short Audio Descriptor to Audio Data Block
	    audioBlock.shortAudioDescriptors[shortAudDescIndex] = shortAudDesc;
	    // Move the index to the beginning of the next Short Audio Descriptor
	    index += SHORT_AUDIO_DESC_LENGTH;
	    // Increment the count to the next Short Audio Descriptor
	    shortAudDescIndex++;
	  }
	
	  return audioBlock;
	};
	
	Edid.prototype.parseVideoDataBlock = function (startAddress, blockLength) {
	  var videoBlock = new Object();
	  videoBlock.tag = this.dataBlockType.VIDEO;
	  videoBlock.length = blockLength;
	
	  var index = 0;
	  videoBlock.shortVideoDescriptors = new Array();
	
	  var NATIVE_RESOLUTION_MASK = 0x80;
	  var CEA861F_VIC_MASK = 0x40;
	  var LOW_VIC_MASK = 0x3F;
	  var HIGH_VIC_MASK = 0xFF;
	  while (index < blockLength) {
	    var shortVideoDescriptor = new Object();
	    var dataByte = this.edidData[startAddress + index];
	    if ((dataByte & CEA861F_VIC_MASK) > 0) {
	      shortVideoDescriptor.vic = dataByte & HIGH_VIC_MASK;
	      shortVideoDescriptor.nativeResolution = false;
	    } else {
	      shortVideoDescriptor.vic = dataByte & LOW_VIC_MASK;
	      shortVideoDescriptor.nativeResolution = dataByte & NATIVE_RESOLUTION_MASK ? true : false;
	    }
	    videoBlock.shortVideoDescriptors[index] = shortVideoDescriptor;
	
	    index++;
	  }
	
	  // Store the video block - it is referenced by other data blocks (e.g. YCbCr 4:2:0 Capability Map)
	  this.videoBlock = videoBlock;
	
	  return videoBlock;
	};
	
	Edid.prototype.parseVendorDataBlockHDMI14 = function (startAddress, blockLength, vendorBlock) {
	  // Subtract one, so the indexing matches the HDMI Specification
	  var vsdbAddress = startAddress - 1;
	
	  var PHYSICAL_ADDRESS_1 = 4;
	  var PHYSICAL_ADDRESS_2 = 5;
	  // Physical Address
	  vendorBlock.physicalAddress = this.edidData[vsdbAddress + PHYSICAL_ADDRESS_1] << 8 | this.edidData[vsdbAddress + PHYSICAL_ADDRESS_2];
	
	  var AI_DC_DUAL_ADDRESS = 6;
	  if (blockLength >= AI_DC_DUAL_ADDRESS) {
	    var SUPPORT_AI_MASK = 0x80;
	    // Parse Supports ACP, ISRC1, ISRC2
	    vendorBlock.supportsAI = this.edidData[vsdbAddress + AI_DC_DUAL_ADDRESS] & SUPPORT_AI_MASK ? true : false;
	
	    var DEEP_COLOR_48_MASK = 0x40;
	    vendorBlock.deepColor48 = this.edidData[vsdbAddress + AI_DC_DUAL_ADDRESS] & DEEP_COLOR_48_MASK ? true : false;
	    var DEEP_COLOR_36_MASK = 0x20;
	    vendorBlock.deepColor36 = this.edidData[vsdbAddress + AI_DC_DUAL_ADDRESS] & DEEP_COLOR_36_MASK ? true : false;
	    var DEEP_COLOR_30_MASK = 0x10;
	    vendorBlock.deepColor30 = this.edidData[vsdbAddress + AI_DC_DUAL_ADDRESS] & DEEP_COLOR_30_MASK ? true : false;
	    var DEEP_COLOR_Y444_MASK = 0x08;
	    vendorBlock.deepColorY444 = this.edidData[vsdbAddress + AI_DC_DUAL_ADDRESS] & DEEP_COLOR_Y444_MASK ? true : false;
	    var DUAL_DVI_MASK = 0x01;
	    vendorBlock.dualDvi = this.edidData[vsdbAddress + AI_DC_DUAL_ADDRESS] & DUAL_DVI_MASK ? true : false;
	  }
	
	  var MAX_TMDS_CLOCK_ADDRESS = 7;
	  if (blockLength >= MAX_TMDS_CLOCK_ADDRESS) {
	    // Parse Max TMDS rate, the edid has TMDS clock. Multiply TMDS clock x 5Mhz
	    // and you'll get max TMDS rate
	    vendorBlock.maxTmdsRate = this.edidData[vsdbAddress + MAX_TMDS_CLOCK_ADDRESS] * 5;
	  }
	
	  var LATENCY_PRESENT_ADDRESS = 8;
	  if (blockLength >= LATENCY_PRESENT_ADDRESS) {
	    var LATENCY_FIELDS_PRESENT_MASK = 0x80;
	    vendorBlock.latencyPresent = this.edidData[vsdbAddress + LATENCY_PRESENT_ADDRESS] & LATENCY_FIELDS_PRESENT_MASK ? true : false;
	
	    var I_LATENCY_FIELDS_PRESENT_MASK = 0x80;
	    vendorBlock.iLatencyPresent = this.edidData[vsdbAddress + LATENCY_PRESENT_ADDRESS] & I_LATENCY_FIELDS_PRESENT_MASK ? true : false;
	  }
	
	  // If Latency fields are present
	  if (vendorBlock.latencyPresent && blockLength >= AUDIO_LATENCY_ADDRESS) {
	    var VIDEO_LATENCY_ADDRESS = 9;
	    // TODO: Add description
	    vendorBlock.videoLatency = (this.edidData[vsdbAddress + VIDEO_LATENCY_ADDRESS] - 1) * 2;
	
	    var AUDIO_LATENCY_ADDRESS = 10;
	    // TODO: Add description
	    vendorBlock.audioLatency = (this.edidData[vsdbAddress + AUDIO_LATENCY_ADDRESS] - 1) * 2;
	  }
	
	  // If Interlaced Latency fields are present
	  if (vendorBlock.iLatencyPresent && blockLength >= I_AUDIO_LATENCY_ADDRESS) {
	    var I_VIDEO_LATENCY_ADDRESS = 11;
	    // TODO: Add description
	    vendorBlock.iVideoLatency = (this.edidData[vsdbAddress + I_VIDEO_LATENCY_ADDRESS] - 1) * 2;
	
	    var I_AUDIO_LATENCY_ADDRESS = 12;
	    // TODO: Add description
	    vendorBlock.iAudioLatency = (this.edidData[vsdbAddress + I_AUDIO_LATENCY_ADDRESS] - 1) * 2;
	  }
	
	  return vendorBlock;
	};
	
	Edid.prototype.parseVendorDataBlockHDMI20 = function (startAddress, blockLength, vendorBlock) {
	  // Subtract one, so the indexing matches the HDMI Specification
	  var vsdbAddress = startAddress - 1;
	
	  var FIELD_ADDRESS = 0;
	  var FIELD_MASK = 0x0;
	
	  FIELD_ADDRESS = 4;
	  // VSDB version for HDMI Forum
	  vendorBlock.versionHF = this.edidData[vsdbAddress + FIELD_ADDRESS];
	
	  FIELD_ADDRESS = 5;
	  vendorBlock.maxTmdsRateHF = this.edidData[vsdbAddress + FIELD_ADDRESS] * 5;
	
	  FIELD_ADDRESS = 6;
	  FIELD_MASK = 0x80;
	  vendorBlock.supportsSCDC = this.edidData[vsdbAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	
	  FIELD_ADDRESS = 6;
	  FIELD_MASK = 0x40;
	  vendorBlock.supportsSCDCRR = this.edidData[vsdbAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	
	  FIELD_ADDRESS = 6;
	  FIELD_MASK = 0x08;
	  vendorBlock.supportsLTE340scramble = this.edidData[vsdbAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	
	  FIELD_ADDRESS = 6;
	  FIELD_MASK = 0x04;
	  vendorBlock.supports3DIV = this.edidData[vsdbAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	
	  FIELD_ADDRESS = 6;
	  FIELD_MASK = 0x02;
	  vendorBlock.supports3DDV = this.edidData[vsdbAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	
	  FIELD_ADDRESS = 6;
	  FIELD_MASK = 0x01;
	  vendorBlock.supports3DOSD = this.edidData[vsdbAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	
	  FIELD_ADDRESS = 7;
	  FIELD_MASK = 0x04;
	  vendorBlock.deepColorY420_30 = this.edidData[vsdbAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	
	  FIELD_ADDRESS = 7;
	  FIELD_MASK = 0x02;
	  vendorBlock.deepColorY420_30 = this.edidData[vsdbAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	
	  FIELD_ADDRESS = 7;
	  FIELD_MASK = 0x01;
	  vendorBlock.deepColorY420_30 = this.edidData[vsdbAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	
	  return vendorBlock;
	};
	
	Edid.prototype.parseVendorDataBlock = function (startAddress, blockLength) {
	  var vendorBlock = new Object();
	  vendorBlock.tag = this.dataBlockType.VENDOR_SPECIFIC;
	  vendorBlock.length = blockLength;
	
	  // Subtract one, so the indexing matches the HDMI Specification
	  var vsdbAddress = startAddress - 1;
	
	  var IEEE_REG_IDENTIFIER_1 = 1;
	  var IEEE_REG_IDENTIFIER_2 = 2;
	  var IEEE_REG_IDENTIFIER_3 = 3;
	  // 24-bit IEEE Registration Identifier
	  vendorBlock.ieeeIdentifier = this.edidData[vsdbAddress + IEEE_REG_IDENTIFIER_3] << 16 | this.edidData[vsdbAddress + IEEE_REG_IDENTIFIER_2] << 8 | this.edidData[vsdbAddress + IEEE_REG_IDENTIFIER_1];
	
	  if (vendorBlock.ieeeIdentifier == this.ieeeOuiType.HDMI14.value) {
	    // HDMI 1.4 VSDB
	    return this.parseVendorDataBlockHDMI14(startAddress, blockLength, vendorBlock);
	  } else if (vendorBlock.ieeeIdentifier == this.ieeeOuiType.HDMI20.value) {
	    // HDMI 2.0 VSDB
	    return this.parseVendorDataBlockHDMI20(startAddress, blockLength, vendorBlock);
	  }
	
	  return vendorBlock;
	};
	
	Edid.prototype.parseVideoCapabilityDataBlock = function (startAddress, blockLength, extendedTagBlock) {
	  extendedTagBlock.extendedTag = this.extendedDataBlockType.VIDEO_CAPABILITY;
	
	  var FIELD_ADDRESS = 0;
	  var FIELD_MASK = 0x0;
	  var FIELD_SHIFT = 0;
	  var fieldData = 0;
	
	  FIELD_ADDRESS = 1;
	  FIELD_MASK = 0x80;
	  extendedTagBlock.quantizationRangeYCC = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	
	  FIELD_ADDRESS = 1;
	  FIELD_MASK = 0x40;
	  extendedTagBlock.quantizationRangeRGB = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	
	  FIELD_ADDRESS = 1;
	  FIELD_MASK = 0x30;
	  FIELD_SHIFT = 4;
	  fieldData = (this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK) >> FIELD_SHIFT;
	  extendedTagBlock.overscanPT = this.overscanBehavior[fieldData];
	
	  FIELD_ADDRESS = 1;
	  FIELD_MASK = 0x0C;
	  FIELD_SHIFT = 2;
	  fieldData = (this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK) >> FIELD_SHIFT;
	  extendedTagBlock.overscanIT = this.overscanBehavior[fieldData];
	
	  FIELD_ADDRESS = 1;
	  FIELD_MASK = 0x03;
	  FIELD_SHIFT = 0;
	  fieldData = (this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK) >> FIELD_SHIFT;
	  extendedTagBlock.overscanCE = this.overscanBehavior[fieldData];
	
	  return extendedTagBlock;
	};
	
	Edid.prototype.parseColorimetryDataBlock = function (startAddress, blockLength, extendedTagBlock) {
	  extendedTagBlock.extendedTag = this.extendedDataBlockType.COLORIMETRY;
	
	  var FIELD_ADDRESS = 0;
	  var FIELD_MASK = 0x0;
	
	  FIELD_ADDRESS = 1;
	  FIELD_MASK = 0x80;
	  extendedTagBlock.supportsBT2020RGB = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	
	  FIELD_ADDRESS = 1;
	  FIELD_MASK = 0x40;
	  extendedTagBlock.supportsBT2020YCC = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	
	  FIELD_ADDRESS = 1;
	  FIELD_MASK = 0x20;
	  extendedTagBlock.supportsBT2020cYCC = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	
	  FIELD_ADDRESS = 1;
	  FIELD_MASK = 0x10;
	  extendedTagBlock.supportsAdobeRGB = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	
	  FIELD_ADDRESS = 1;
	  FIELD_MASK = 0x08;
	  extendedTagBlock.supportsAdobeYCC601 = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	
	  FIELD_ADDRESS = 1;
	  FIELD_MASK = 0x04;
	  extendedTagBlock.supportssYCC601 = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	
	  FIELD_ADDRESS = 1;
	  FIELD_MASK = 0x02;
	  extendedTagBlock.supportsxvYCC709 = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	
	  FIELD_ADDRESS = 1;
	  FIELD_MASK = 0x01;
	  extendedTagBlock.supportsxvYCC601 = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	
	  FIELD_ADDRESS = 2;
	  FIELD_MASK = 0x08;
	  extendedTagBlock.gamutMD3 = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? 1 : 0;
	
	  FIELD_ADDRESS = 2;
	  FIELD_MASK = 0x04;
	  extendedTagBlock.gamutMD2 = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? 1 : 0;
	
	  FIELD_ADDRESS = 2;
	  FIELD_MASK = 0x02;
	  extendedTagBlock.gamutMD1 = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? 1 : 0;
	
	  FIELD_ADDRESS = 2;
	  FIELD_MASK = 0x01;
	  extendedTagBlock.gamutMD0 = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? 1 : 0;
	
	  return extendedTagBlock;
	};
	
	Edid.prototype.parseYCbCr420VideoDataBlock = function (startAddress, blockLength, extendedTagBlock) {
	  extendedTagBlock.extendedTag = this.extendedDataBlockType.YCBCR420_VIDEO;
	
	  var svdIndex = 0;
	
	  var NATIVE_RESOLUTION_MASK = 0x80;
	  var CEA861F_VIC_MASK = 0x40;
	  var LOW_VIC_MASK = 0x3F;
	  var HIGH_VIC_MASK = 0xFF;
	
	  // SVDs listed in this block support only YCbCr 4:2:0 color format.
	  // These SVDs are not listed in the standard Video data block.
	  extendedTagBlock.YCbCr420OnlyShortVideoDescriptors = new Array();
	
	  for (svdIndex = 0; svdIndex < blockLength - 1; svdIndex++) {
	    var shortVideoDescriptor = new Object();
	    var dataByte = this.edidData[startAddress + 1 + svdIndex]; // +1 as this is an extended tag data block
	    if ((dataByte & CEA861F_VIC_MASK) > 0) {
	      shortVideoDescriptor.vic = dataByte & HIGH_VIC_MASK;
	      shortVideoDescriptor.nativeResolution = false;
	    } else {
	      shortVideoDescriptor.vic = dataByte & LOW_VIC_MASK;
	      shortVideoDescriptor.nativeResolution = dataByte & NATIVE_RESOLUTION_MASK ? true : false;
	    }
	    extendedTagBlock.YCbCr420OnlyShortVideoDescriptors[svdIndex] = shortVideoDescriptor;
	  }
	
	  return extendedTagBlock;
	};
	
	Edid.prototype.parseYCbCr420CapabilityMapDataBlock = function (startAddress, blockLength, extendedTagBlock) {
	  extendedTagBlock.extendedTag = this.extendedDataBlockType.YCBCR420_CAPABILITY_MAP;
	
	  var FIELD_ADDRESS = 0;
	  var FIELD_MASK = 0x0;
	  var svdIndex = 0;
	  var YCbCr420Capable = false;
	  var YCbCr420svdIndex = 0;
	
	  // YCbCr420 Capability Map block contains a bit map of SVDs from the Video block
	  // If a bit is set to "1", the corresponding SVD supports YCbCr 4:2:0 color format
	  // This data block is only used for SVDs which support 4:2:0 and some other colour
	  // format (e.g. 4:2:2).
	  // For SVDs which support only 4:2:0, YCbCr 4:2:0 Video data block is used.
	  extendedTagBlock.YCbCr420CapableShortVideoDescriptors = new Array();
	
	  for (FIELD_ADDRESS = 1; FIELD_ADDRESS < blockLength; FIELD_ADDRESS++) {
	    for (FIELD_MASK = 0x01; FIELD_MASK <= 0x80; FIELD_MASK <<= 1) {
	      YCbCr420Capable = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
	      if (YCbCr420Capable) {
	        extendedTagBlock.YCbCr420CapableShortVideoDescriptors[YCbCr420svdIndex] = this.videoBlock.shortVideoDescriptors[svdIndex];
	        YCbCr420svdIndex++;
	      }
	      svdIndex++;
	    }
	  }
	
	  return extendedTagBlock;
	};
	
	Edid.prototype.parseSpeakerDataBlock = function (startAddress, blockLength) {
	  var speakerBlock = new Object();
	  speakerBlock.tag = this.dataBlockType.SPEAKER_ALLOCATION;
	  speakerBlock.length = blockLength;
	
	  speakerBlock.payload = this.edidData[startAddress + 2] << 16 | this.edidData[startAddress + 1] << 8 | this.edidData[startAddress];
	
	  return speakerBlock;
	};
	
	Edid.prototype.parseExtendedTagDataBlock = function (startAddress, blockLength) {
	  var extendedTagBlock = new Object();
	  extendedTagBlock.tag = this.dataBlockType.EXTENDED_TAG;
	  extendedTagBlock.length = blockLength;
	
	  var EXTENDED_TAG_ADDRESS = 0;
	
	  var extendedBlockTagCode = this.edidData[startAddress + EXTENDED_TAG_ADDRESS];
	
	  if (extendedBlockTagCode == this.extendedDataBlockType.VIDEO_CAPABILITY.value) {
	    return this.parseVideoCapabilityDataBlock(startAddress, blockLength, extendedTagBlock);
	  } else if (extendedBlockTagCode == this.extendedDataBlockType.COLORIMETRY.value) {
	    return this.parseColorimetryDataBlock(startAddress, blockLength, extendedTagBlock);
	  } else if (extendedBlockTagCode == this.extendedDataBlockType.YCBCR420_VIDEO.value) {
	    return this.parseYCbCr420VideoDataBlock(startAddress, blockLength, extendedTagBlock);
	  } else if (extendedBlockTagCode == this.extendedDataBlockType.YCBCR420_CAPABILITY_MAP.value) {
	    return this.parseYCbCr420CapabilityMapDataBlock(startAddress, blockLength, extendedTagBlock);
	  } else {
	    extendedTagBlock.extendedTag = this.edidData[startAddress + EXTENDED_TAG_ADDRESS];
	  }
	
	  return extendedTagBlock;
	};
	
	Edid.prototype.getExtChecksum = function (extIndex) {
	  var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
	  var CHECKSUM_OFFSET = 127;
	
	  return this.edidData[BLOCK_OFFSET + CHECKSUM_OFFSET];
	};
	
	Edid.prototype.getExtDtds = function (extIndex, startAddress) {
	  var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
	  var dtdArray = new Array();
	  var dtdCounter = 0;
	  var dtdIndex = startAddress + BLOCK_OFFSET;
	  var endAddress = this.EDID_BLOCK_LENGTH * (extIndex + 2) - 2;
	
	  while ((this.edidData[dtdIndex] != 0 || this.edidData[dtdIndex + 1] != 0) && dtdIndex < endAddress) {
	    var dtd = this.parseDtd(dtdIndex);
	    // Add DTD to the DTD Array
	    dtdArray[dtdCounter] = dtd;
	    // Increment DTD Counter
	    dtdCounter++;
	    // Add a DTD length, to go to the next descriptor
	    dtdIndex += this.DTD_LENGTH;
	  }
	  return dtdArray;
	};

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseEDID;
	
	var _edidClass = __webpack_require__(619);
	
	var _edidClass2 = _interopRequireDefault(_edidClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	
	function convertToIntArray(stringArray) {
	  return stringArray.map(function (v) {
	    return parseInt(v, 16);
	  });
	}
	
	function parseEDID(str) {
	  var edid = new _edidClass2.default();
	  var wordArray = str.split('');
	  var hexArray = [];
	  wordArray.forEach(function (w, i) {
	    if (i % 2 === 0) {
	      hexArray.push(w + wordArray[i + 1]);
	    }
	  });
	  var intArr = convertToIntArray(hexArray);
	  edid.setEdidData(intArr);
	  edid.parse();
	
	  var treedata = [];
	
	  var block0 = {
	    label: "Block 0",
	    id: "tBlock0",
	    children: []
	  };
	
	  var headerInfo = {
	    label: "Header Information",
	    id: "tHeaderInfo",
	    url: 'partials/block0/edidHeaderInfo.html',
	    "children": []
	  };
	  block0.children.push(headerInfo);
	
	  var bdp = {
	    label: "Basic Display Parameters",
	    id: "tBDP",
	    url: 'partials/block0/basicDisplayParameters.html',
	    "children": []
	  };
	
	  block0.children.push(bdp);
	
	  var chromaticityCoords = { label: "Chromaticity Coordinates",
	    id: "tchromaticityCoords",
	    url: 'partials/block0/chromacityCoords.html',
	    "children": []
	  };
	  block0.children.push(chromaticityCoords);
	
	  var timingBitmap = {
	    label: "Timing Bitmap",
	    id: "tTimingBitmap",
	    url: 'partials/block0/timingBitmap.html',
	    "children": []
	  };
	  block0.children.push(timingBitmap);
	
	  var standardTimingInfo = {
	    label: "Standard Timing Information",
	    id: "tStandardTimingInfo",
	    "children": []
	  };
	
	  var standardDisplayModes = {
	    label: "Standard Display Modes",
	    id: "role151",
	    url: 'partials/block0/stdDisplayModes.html',
	    "children": []
	  };
	  standardTimingInfo.children.push(standardDisplayModes);
	
	  // For Each Block 0 Descriptor
	  for (var index = 0; index < edid.dtds.length; index++) {
	    var descriptorNumber = index + 1;
	    var descriptor = {
	      label: "Descriptor " + descriptorNumber,
	      id: "block0Descriptor" + descriptorNumber,
	      url: 'partials/block0/detailedTimingDescriptors.html',
	      "children": []
	    };
	    standardTimingInfo.children.push(descriptor);
	  }
	
	  // Add Standard Timing Info to Block 0
	  block0.children.push(standardTimingInfo);
	  for (var _index = 0; _index < edid.exts.length; _index++) {
	    var blockNumber = _index + 1;
	    var blockLabel = "Block " + blockNumber;
	    var id = "tBlock" + blockNumber;
	
	    // Add Block
	    var blockX = {
	      label: blockLabel,
	      id: id,
	      children: []
	    };
	
	    var extHeader = {
	      label: "Extenstion Header Information",
	      id: id + "ExtensionHeaderInfo",
	      url: 'partials/blockX/extHeader.html',
	      "children": []
	    };
	    blockX.children.push(extHeader);
	
	    // If there is a collection of data blocks in this extension
	    if (edid.exts[_index].dataBlockCollection) {
	      var ceaDataBlock = { label: "CEA Data Block",
	        id: id + "CeaDataBlock",
	        "children": []
	        // For Each CEA Data Block
	      };for (var ceaIndex = 0; ceaIndex < edid.exts[_index].dataBlockCollection.length; ceaIndex++) {
	        var dataBlock = edid.exts[_index].dataBlockCollection[ceaIndex];
	        var treeDataBlock = {};
	        if (dataBlock.tag == edid.dataBlockType.RESERVED) {
	          treeDataBlock = { label: "Reserved Data Block",
	            id: id + edid.dataBlockType.RESERVED.string + ceaIndex,
	            url: 'partials/blockX/dataBlocks/reserved.html',
	            "children": [] };
	        } else if (dataBlock.tag == edid.dataBlockType.AUDIO) {
	          treeDataBlock = { label: "Audio Data Block",
	            id: id + edid.dataBlockType.AUDIO.string + ceaIndex,
	            url: 'partials/blockX/dataBlocks/audio.html',
	            "children": [] };
	        } else if (dataBlock.tag == edid.dataBlockType.VIDEO) {
	          treeDataBlock = { label: "Video Data Block",
	            id: id + edid.dataBlockType.VIDEO.string + ceaIndex,
	            url: 'partials/blockX/dataBlocks/video.html',
	            "children": [] };
	        } else if (dataBlock.tag == edid.dataBlockType.VENDOR_SPECIFIC) {
	          if (dataBlock.ieeeIdentifier == edid.ieeeOuiType.HDMI14.value) {
	            treeDataBlock = { label: "Vendor Specific Data Block HDMI 1.4",
	              id: id + edid.dataBlockType.VENDOR_SPECIFIC.string + ceaIndex,
	              url: 'partials/blockX/dataBlocks/vendorSpecificHDMI14.html',
	              "children": [] };
	          } else if (dataBlock.ieeeIdentifier == edid.ieeeOuiType.HDMI20.value) {
	            treeDataBlock = { label: "Vendor Specific Data Block HDMI 2.0",
	              id: id + edid.dataBlockType.VENDOR_SPECIFIC.string + ceaIndex,
	              url: 'partials/blockX/dataBlocks/vendorSpecificHDMI20.html',
	              "children": [] };
	          } else {
	            treeDataBlock = { label: "Vendor Specific Data Block",
	              id: id + edid.dataBlockType.VENDOR_SPECIFIC.string + ceaIndex,
	              url: 'partials/blockX/dataBlocks/vendorSpecific.html',
	              "children": [] };
	          }
	        } else if (dataBlock.tag == edid.dataBlockType.SPEAKER_ALLOCATION) {
	          treeDataBlock = { label: "Speaker Allocation Data Block",
	            id: id + edid.dataBlockType.SPEAKER_ALLOCATION.string + ceaIndex,
	            url: 'partials/blockX/dataBlocks/speakerAllocation.html',
	            "children": [] };
	        } else if (dataBlock.tag == edid.dataBlockType.EXTENDED_TAG) {
	          if (dataBlock.extendedTag == edid.extendedDataBlockType.VIDEO_CAPABILITY) {
	            treeDataBlock = { label: "Video Capability Data Block",
	              id: id + edid.dataBlockType.EXTENDED_TAG.string + ceaIndex,
	              url: 'partials/blockX/dataBlocks/videoCapability.html',
	              "children": [] };
	          } else if (dataBlock.extendedTag == edid.extendedDataBlockType.COLORIMETRY) {
	            treeDataBlock = { label: "Colorimetry Data Block",
	              id: id + edid.dataBlockType.EXTENDED_TAG.string + ceaIndex,
	              url: 'partials/blockX/dataBlocks/colorimetry.html',
	              "children": [] };
	          } else if (dataBlock.extendedTag == edid.extendedDataBlockType.YCBCR420_VIDEO) {
	            treeDataBlock = { label: "YCbCr 4:2:0 Video Data Block",
	              id: id + edid.dataBlockType.EXTENDED_TAG.string + ceaIndex,
	              url: 'partials/blockX/dataBlocks/YCbCr420Video.html',
	              "children": [] };
	          } else if (dataBlock.extendedTag == edid.extendedDataBlockType.YCBCR420_CAPABILITY_MAP) {
	            treeDataBlock = { label: "YCbCr 4:2:0 Capability Map Data Block",
	              id: id + edid.dataBlockType.EXTENDED_TAG.string + ceaIndex,
	              url: 'partials/blockX/dataBlocks/YCbCr420CapabilityMap.html',
	              "children": [] };
	          } else {
	            treeDataBlock = { label: "Extended Tag Data Block",
	              id: id + edid.dataBlockType.EXTENDED_TAG.string + ceaIndex,
	              url: 'partials/blockX/dataBlocks/extended.html',
	              "children": [] };
	          }
	        }
	        ceaDataBlock.children.push(treeDataBlock);
	      }
	      blockX.children.push(ceaDataBlock);
	    }
	
	    // For each extension DTD, build the tree object then add it to blockX
	    for (var extDtdIndex = 0; extDtdIndex < edid.exts[_index].dtds.length; extDtdIndex++) {
	      // let dtd = edid.exts[index].dtds[extDtdIndex];
	      var dtdNumber = extDtdIndex + 1;
	      var dtdTree = {
	        label: "Detailed Timing Descriptor " + dtdNumber,
	        id: id + "Dtd" + dtdNumber,
	        url: 'partials/blockX/extDtds.html',
	        "children": []
	      };
	      blockX.children.push(dtdTree);
	    }
	    treedata.push(blockX);
	  }
	  return edid;
	}
	/* header
	  XXX: Valid Checksum: {{validChecksums[0]}}
	  EDID Header: d.validHeader
	  EISA ID: d.eisaId
	  Product Code: d.productCode.toString(16).toUpperCase()
	  Serial Number: d.serialNumber
	  Manufacture Date: d.manufactureDate
	  EDID Version: d.edidVersion
	  Number of Extensions: d.numberOfExtensions
	  Checksum: 0x d.checksum.toString(16).toUpperCase
	*/
	
	/* Basic Display Parameters
	
	  Digital Input: d.bdp.digitalInput
	  Compatible with VESA DFP: d.bdp.vesaDfpCompatible
	  Maximum Horizontal Image Size: d.bdp.maxHorImgSize
	  Maximum Vertical Image Size: d.bdp.maxVertImgSize
	  Display Gamma: d.bdp.displayGamma.toFixed(2)
	  DPMS Standby: edid.bdp.dpmsStandby
	  DPMS Suspend: edid.bdp.dpmsSuspend
	  DPMS Active-Off: edid.bdp.dpmsActiveOff
	  Display Type: edid.digitalColorSpace[edid.bdp.displayType]
	  Standard sRGB Color Space: edid.bdp.standardSRgb
	  Preferred Timing Mode: edid.bdp.preferredTiming
	  GTF Supported: edid.bdp.gtfSupported
	
	  XXX IF analogBDP edid.bdp.digitalInput
	    Digital Input: edid.bdp.digitalInput
	    Video white and sync levels, relative to blank: edid.WhiteAndSyncLevels[edid.bdp.whiteSyncLevels]
	    Blank-to-black setup (pedestal) expected: edid.bdp.blankToBlack
	    Separate sync supported: edid.bdp.separateSyncSupported
	    Composite sync (on HSync) supported: edid.bdp.compositeSyncSupported
	    Sync on green supported: edid.bdp.synOnGreen
	    VSync pulse must be serrated: edid.bdp.vsyncSerrated
	    Maximum Horizontal Image Size: edid.bdp.maxHorImgSize
	    Maximum Vertical Image Size: edid.bdp.maxVertImgSize
	    Display Gamma: edid.bdp.displayGamma.toFixed(2)
	    DPMS Standby: edid.bdp.dpmsStandby
	    DPMS Suspend: edid.bdp.dpmsSuspend
	    DPMS Active-Off: edid.bdp.dpmsActiveOff
	    Display Type: edid.digitalColorSpace[edid.bdp.displayType]
	    Standard sRGB Color Space: edid.bdp.standardSRgb
	    Preferred Timing Mode: edid.bdp.preferredTiming
	    GTF Supported: edid.bdp.gtfSupported
	*/
	
	/*
	
	Chromaticity Coordinates
	
	  Red X: {{edid.chromaticity.redXCoords.toFixed(3)}}
	  Red Y: {{edid.chromaticity.redYCoords.toFixed(3)}}
	  Green X: {{edid.chromaticity.greenXCoords.toFixed(3)}}
	  Green Y: {{edid.chromaticity.greenYCoords.toFixed(3)}}
	  Blue X: {{edid.chromaticity.blueXCoords.toFixed(3)}}
	  Blue Y: {{edid.chromaticity.blueYCoords.toFixed(3)}}
	  White X: {{edid.chromaticity.whiteXCoords.toFixed(3)}}
	  White Y: {{edid.chromaticity.whiteYCoords.toFixed(3)}}
	
	*/
	
	/*
	
	Timing Bitmap
	
	  tb in edid.establishedTimingBitmaps
	    checked = isTimingBitmapSet($index)
	    {{tb}}
	*/
	
	/*
	Standard Display Modes
	  dispMode in edid.standardDisplayModes
	    X Resolution: {{dispMode.xResolution}}
	    X:Y Pixel Ratio: {{edid.xyPixelRatioEnum[dispMode.xyPixelRatio].string}}
	    Vertical Frequency: {{dispMode.vertFreq}}
	*/
	
	/*
	Detailed Timing Descriptor   (Descriptor 1~2)
	  Pixel Clock: {{dtd.pixelClock}}MHz
	  Horizontal Active: {{dtd.horActivePixels}}
	  Horizontal Blanking: {{dtd.horBlankPixels}}
	  Vertical Active: {{dtd.vertActivePixels}}
	  Vertical Blanking: {{dtd.vertBlankPixels}}
	  Horizontal Sync Offset: {{dtd.horSyncOff}}
	  Horizontal Sync Pulse: {{dtd.horSyncPulse}}
	  Vertical Sync Offset: {{dtd.vertSyncOff}}
	  Vertical Sync Pulse: {{dtd.vertSyncPulse}}
	  Horizontal Display Size: {{dtd.horDisplaySize}}
	  Vertical Display Size: {{dtd.vertDisplaySize}}
	  Horizontal Border: {{dtd.horBorderPixels}}
	  Vertical Border: {{dtd.vertBorderLines}}
	  Interlaced: {{dtd.interlaced}}
	  Stereo Mode: {{dtd.stereoMode}}
	  Sync Type: {{dtd.syncType}}
	  <span ng-show="dtd.syncType == edid.syncTypeEnum.DIGITAL_SEPARATE">
	      Vertical Sync Polarity: {{dtd.vSyncPolarity}}
	  </span>
	  <span ng-show="dtd.syncType != edid.syncTypeEnum.DIGITAL_SEPARATE">
	      Vertical Sync Serrated: {{dtd.vSyncSerrated}}
	  </span>
	
	  <span ng-show="(dtd.syncType == edid.syncTypeEnum.ANALOG_COMPOSITE) ||
	                  (dtd.syncType == edid.syncTypeEnum.BIPOLAR_ANALOG_COMPOSITE)">
	      Sync on all 3 RGB lines: {{dtd.syncAllRGBLines}}
	  </span>
	  <span ng-show="(dtd.syncType != edid.syncTypeEnum.ANALOG_COMPOSITE) &&
	                  (dtd.syncType != edid.syncTypeEnum.BIPOLAR_ANALOG_COMPOSITE)">
	      HSync polarity: {{dtd.hSyncPolarity}}
	  </span>
	  2-Way Line-Interleaved Stereo: {{dtd.twoWayStereo}}
	*/
	
	/*
	  Extension Header Information
	  Valid Checksum: {{validChecksums[ext.blockNumber]}}
	  Extension Tag: {{ext.extTag}}
	  Revision Number: {{ext.revisionNumber}}
	  DTD Start: 0x{{ext.dtdStart.toString(16).toUpperCase()}}
	  Number of Native DTDs: {{ext.numDtds}}
	  Supports Underscan: ext.underscan
	  Supports Basic Audio: ext.basicAudio
	  Supports YcBcR 4:4:4: ext.ycbcr444
	  Supports YcBcR 4:2:2: ext.ycbcr422
	  Checksum: 0x{{ext.checksum.toString(16).toUpperCase()}}
	*/
	
	/*
	  Video Data Block
	  ng-repeat="shortVideoDescriptor in ceaDataBlock.shortVideoDescriptors
	    Native: {{shortVideoDescriptor.nativeResolution.toString().toUpperCase()}}
	    VIC: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].vic}}
	    Format: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].format}}
	    Field Rate: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].fieldRate}}
	    Picture AR: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].pictureAspectRatio}}
	    Pixel AR: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].pixelAspectRatio}}
	
	*/
	
	/*
	  Audio Data Block
	  shortAudioDescriptor in ceaDataBlock.shortAudioDescriptors
	  <div class="dataBlock" ng-include src=shortAudioDescView(shortAudioDescriptor.format)>
	  </div>
	</div>
	
	*/
	
	/*
	  Speaker Allocation Data Block
	  speakerAllocation in edid.speakerAllocation
	    speakerAllocation
	    ng-checked="isBitSet(ceaDataBlock.payload,$index)">
	*/
	
	/*
	  Video Capability Data Block
	
	  Quantization Range selectable via AVI YQ for YCC formats: ceaDataBlock.quantizationRangeYCC
	  Quantization Range selectable via AVI Q for RGB formats: ceaDataBlock.quantizationRangeRGB
	  Overscan underscan behaviour for Preferred Video Format: ceaDataBlock.overscanPT
	  Overscan underscan behaviour for IT Video Formats: ceaDataBlock.overscanIT
	  Overscan underscan behaviour for CE Video Formats: ceaDataBlock.overscanCE
	*/
	
	/*
	  Colorimetry Data Block
	
	  Supports BT2020 RGB: ceaDataBlock.supportsBT2020RGB
	  Supports BT2020 YCC: ceaDataBlock.supportsBT2020YCC
	  Supports BT2020 cYCC: ceaDataBlock.supportsBT2020cYCC
	  Supports Adobe RGB: ceaDataBlock.supportsAdobeRGB
	  Supports Adobe YCC601: ceaDataBlock.supportsAdobeYCC601
	  Supports sYCC601: ceaDataBlock.supportssYCC601
	  Supports xvYCC709: ceaDataBlock.supportsxvYCC709
	  Supports xvYCC601: ceaDataBlock.supportsxvYCC601
	
	  Gamut MetaData3 (MD3): {{ceaDataBlock.gamutMD3}}
	  Gamut MetaData2 (MD2): {{ceaDataBlock.gamutMD2}}
	  Gamut MetaData1 (MD1): {{ceaDataBlock.gamutMD1}}
	  Gamut MetaData0 (MD0): {{ceaDataBlock.gamutMD0}}
	
	*/
	
	/*
	  Vendor Specific Data Block HDMI 1.4
	  IEEE OUI: {{pad(ceaDataBlock.ieeeIdentifier.toString(16).toUpperCase(),6)}} <br />
	  Source Physical Address: {{ceaDataBlock.physicalAddress.toString(16).toUpperCase()}} <br />
	  Supports ACP, ISRC1, ISRC2: ceaDataBlock.supportsAI
	  Supports 48 bits/pixel (16 bits/color): ceaDataBlock.deepColor48
	  Supports 36 bits/pixel (12 bits/color): ceaDataBlock.deepColor36
	
	  Supports 30 bits/pixel (10 bits/color): ceaDataBlock.deepColor30
	
	  Supports YCbCr 4:4:4 Deep Color: ceaDataBlock.deepColorY444
	
	  Supports Dual DVI: ceaDataBlock.dualDvi
	  Max TMDS Clock Rate: {{ceaDataBlock.maxTmdsRate}} MHz
	
	  Video/Audio Latency Fields Present: ceaDataBlock.latencyPresent
	  ng-show="ceaDataBlock.latencyPresent
	    Video Latency: {{ceaDataBlock.videoLatency}} ms
	    Audio Latency: {{ceaDataBlock.audioLatency}} ms
	    Interlaced Video/Audio Latency Fields Present: {{ceaDataBlock..iLatencyPresent.toString().toUpperCase()}}
	    Interlaced Video Latency: {{ceaDataBlock.iVideoLatency}} ms
	    Interlaced Audio Latency: {{ceaDataBlock.iAudioLatency}} ms
	
	*/
	
	/*
	  Vendor Specific Data Block HDMI 2.0
	  IEEE OUI: {{pad(ceaDataBlock.ieeeIdentifier.toString(16).toUpperCase(),6)}}
	
	  Version: {{ceaDataBlock.versionHF}}
	  Max TMDS Clock Rate: {{ceaDataBlock.maxTmdsRateHF}} MHz
	
	  Supports SCDC: ceaDataBlock.supportsSCDC
	
	  Supports SCDC Read Request: ceaDataBlock.supportsSCDCRR
	
	  Supports Scrambling for less &lt;=340MHz: ceaDataBlock.supportsLTE340scramble
	
	  Supports 3D Independent View: ceaDataBlock.supports3DIV
	
	  Supports 3D Dual View: ceaDataBlock.supports3DDV
	  Supports 3D OSD Disparity: ceaDataBlock.supports3DOSD
	
	  Supports 30 bits/pixel (10 bits/color) for Deep Color YCbCr 4:2:0 : ceaDataBlock.deepColorY420_30
	
	  Supports 36 bits/pixel (12 bits/color) for Deep Color YCbCr 4:2:0 : ceaDataBlock.deepColorY420_36
	
	  Supports 48 bits/pixel (16 bits/color) for Deep Color YCbCr 4:2:0 : ceaDataBlock.deepColorY420_48
	
	*/
	/*
	  Extended Tag Data Block
	  Extended Tag: {{ceaDataBlock.extendedTag}} <br />
	  Block Length: {{ceaDataBlock.length}} <br />
	*/
	
	/*
	  Extended Tag Data Block</h3>
	
	  Extended Tag: {{ceaDataBlock.extendedTag}} <br />
	  Block Length: {{ceaDataBlock.length}} <br />
	*/
	
	/*
	  YCbCr 4:2:0 Video Data Block
	
	  shortVideoDescriptor in ceaDataBlock.YCbCr420OnlyShortVideoDescriptors
	    Native: {{shortVideoDescriptor.nativeResolution.toString().toUpperCase()}}
	    VIC: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].vic}}
	    Format: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].format}}
	    Field Rate: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].fieldRate}}
	    Picture AR: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].pictureAspectRatio}}
	    Pixel AR: {{edid.shortVideoDescriptors[shortVideoDescriptor.vic].pixelAspectRatio}}
	
	*/
	
	// console.log(treedata[0].children)

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(156);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vueStrap = __webpack_require__(12);
	
	var _Header = __webpack_require__(1172);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Service = __webpack_require__(8);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _mobileDetect = __webpack_require__(56);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var md = new _mobileDetect2.default(window.navigator.userAgent);
	
	exports.default = {
	  components: {
	    AppHeader: _Header2.default,
	    aside: _vueStrap.aside,
	    alert: _vueStrap.alert
	  },
	  data: function data() {
	    return {
	      showLoadingAni: false,
	      showLeft: false,
	      alertList: [],
	      alertData: {
	        type: '',
	        title: '',
	        show: false,
	        content: ''
	      },
	      user: {},
	      isInstaller: false,
	      showWarning: false,
	      isSwitcher: false,
	      alertDuration: 5000
	    };
	  },
	  firebase: function firebase() {
	    return {
	      onlines: {
	        source: (0, _Service.getOnlineDevsRef)(),
	        asObject: true
	      }
	    };
	  },
	  ready: function ready() {
	    (0, _Service.bindVM)(this);
	
	    if (window.innerWidth < 768 && md.mobile() === null) this.showWarning = true;
	    window.addEventListener('resize', this.resize);
	    this.showAlert();
	  },
	
	  computed: {
	    isCurrentOnline: function isCurrentOnline() {
	      return this.onlines[this.$route.params.mac];
	    },
	    showLoading: function showLoading() {
	      if (!this.isCurrentOnline) {
	        this.loaderMsg = 'Current device is offline';
	        this.loaderMsg1 = 'Please check the connection or try another device.';
	      } else {
	        this.loaderMsg = '';
	      }
	      return !(this.$route.noloading || this.isCurrentOnline);
	    }
	  },
	  watch: {
	    alertData: {
	      handler: function handler(n, o) {
	        var _this = this;
	
	        if (n > o) {
	          console.log(n.content);
	          this.alertData.show = true;
	          setTimeout(function () {
	            _this.alertData.show = false;
	          }, 4000);
	        }
	      },
	      deep: true
	    }
	  },
	  methods: {
	    showAlert: function showAlert() {
	      var _this2 = this;
	
	      setInterval(function () {
	        if (_this2.alertList.length) {
	          _this2.alertData = _this2.alertList.shift();
	        }
	      }, 3000);
	    },
	    stateMatch: function stateMatch(state) {
	      return RegExp(state + '$').test(this.$route.path);
	    },
	    alert: function alert(_ref) {
	      var _this3 = this;
	
	      var type = _ref.type,
	          title = _ref.title,
	          content = _ref.content;
	
	      this.alertList.push({
	        type: type,
	        title: title,
	        content: content,
	        show: true
	      });
	
	      return new _promise2.default(function (resolve, reject) {
	        setTimeout(function () {
	          _this3.alertList.shift();
	          resolve();
	        }, _this3.alertDuration);
	      });
	    },
	    resize: function resize() {
	      md = new _mobileDetect2.default(window.navigator.userAgent);
	      if (window.innerWidth < 768 && md.mobile() === null) {
	        this.showWarning = true;
	      } else {
	        this.showWarning = false;
	      }
	    }
	  },
	  events: {
	    updateIsSwitcher: function updateIsSwitcher(isSwitcher) {
	      this.isSwitcher = isSwitcher;
	    },
	    update: function update(mac, _ref2) {
	      var type = _ref2.type,
	          event = _ref2.event,
	          msg = _ref2.msg;
	
	      if (mac === this.$route.params.mac) {
	        this.alert({
	          type: 'success',
	
	          content: msg
	        });
	      }
	      return true;
	    },
	    user: function user(uid, _user) {
	      if (this.user.name && this.user.name !== _user.name) {
	        this.alert({
	          type: 'success',
	          titile: '',
	          content: 'Name Changes To \'' + _user.name + '\''
	        });
	      } else {
	        this.user = _lodash2.default.cloneDeep(_user);
	      }
	
	      this.isInstaller = _user.installer;
	      this.$unbind('onlines');
	      this.$bindAsObject('onlines', (0, _Service.getOnlineDevsRef)(), null, function () {
	        return console.log('vfire rebind since user auth changed!');
	      });
	      this.$broadcast('user', uid, _user);
	    },
	    alert: function alert(e) {
	      this.alert(e);
	    },
	    nav: function nav(obj) {
	      this.showLeft = !this.showLeft;
	    },
	    vendor: function vendor(_vendor) {
	      this.$broadcast('vendor', _vendor);
	    }
	  }
	};

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(220);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _Service = __webpack_require__(8);
	
	var _vueStrap = __webpack_require__(12);
	
	var _SingleSelect = __webpack_require__(26);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Indicator = __webpack_require__(177);
	
	var _Indicator2 = _interopRequireDefault(_Indicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Indicator: _Indicator2.default,
	    modal: _vueStrap.modal,
	    'v-select': _SingleSelect2.default
	  },
	  data: function data() {
	    return {
	      outputHDCP: {},
	      outputLink: {},
	      inputLink: {},
	      inputHDCP: {},
	      showModal: false,
	      showEngineModal: false,
	      password: '',
	      HDCPEngine: '0.0',
	      HDCPopts: [{ label: '1.4', value: '1.4' }, { label: '2.2', value: '2.2' }],
	      editting: ''
	    };
	  },
	  asyncData: function asyncData() {
	    var _this = this;
	
	    var mac = this.$route.params.mac;
	
	
	    (0, _Service.call)(mac, 'dxGetHDCP').then(function (_ref) {
	      var outputs = _ref.outputs,
	          inputs = _ref.inputs;
	
	      console.log('HDCP outputs', outputs);
	      console.log('HDCP inputs', inputs);
	      _this.outputHDCP = outputs;
	      _this.inputHDCP = inputs;
	      if (_this.$route.name === 'mixer') {
	        return (0, _Service.call)(mac, 'dxGetMixerStatus');
	      } else {
	        return (0, _Service.call)(mac, 'dxGetMatrixStatus');
	      }
	    }).then(function (_ref2) {
	      var links = _ref2.links;
	
	      console.log('links', links);
	      _this.outputLink = links.outputs;
	      _this.inputLink = links.inputs;
	    }).catch(function (err) {
	      _this.alert('danger', '', err);
	    });
	  },
	
	  computed: {},
	  methods: {
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    enterPassword: function enterPassword(key) {
	      console.log(key);
	
	      this.editting = key;
	      if (this.outputHDCP[key].enabled) {
	        this.showModal = true;
	      } else {
	        this.applyChange();
	      }
	    },
	    applyChange: function applyChange() {
	      var _this2 = this;
	
	      var mac = this.$route.params.mac;
	
	      if (!this.outputHDCP[this.editting].enabled) {
	        this.password = 'HDCP';
	      }
	      if (this.password !== 'HDCP') {
	        return this.alert('danger', '', 'Invalid Password.');
	      } else {
	        var param = {
	          enabled: !this.outputHDCP[this.editting].enabled,
	          engine: this.HDCPEngine
	        };
	        console.log('HDCP param is: ', param);
	        (0, _Service.call)(mac, 'dxSetHDCP', {
	          outputs: (0, _defineProperty3.default)({}, this.editting, param)
	        }).then(function (res) {
	          console.log(res);
	          _this2.showModal = false;
	          _this2.password = '';
	        }).catch(function (err) {
	          _this2.alert('danger', '', err);
	        });
	      }
	    },
	    resetLink: function resetLink(key, which) {
	      var _this3 = this;
	
	      var mac = this.$route.params.mac;
	
	      var ary = [];
	      var title = which === 'i' ? 'inputs' : 'outputs';
	      ary[0] = key;
	
	      (0, _Service.call)(mac, 'dxResetLink', (0, _defineProperty3.default)({}, title, ary)).then(function (res) {
	        console.log(res);
	      }).catch(function (err) {
	        _this3.alert('danger', '', err);
	      });
	    }
	  }, ready: function ready() {},
	
	  watch: {},
	  events: {
	    update: function update(mac, _ref3) {
	      var type = _ref3.type,
	          event = _ref3.event,
	          msg = _ref3.msg;
	
	      switch (type) {
	        case 'hdcp':
	          if (event.outputs && (0, _typeof3.default)(event.outputs) === 'object') {
	            var newOut = _lodash2.default.cloneDeep(this.outputHDCP);
	            _lodash2.default.assignIn(newOut, event.outputs);
	            this.outputHDCP = _lodash2.default.cloneDeep(newOut);
	          } else if (event.inputs && (0, _typeof3.default)(event.inputs) === 'object') {
	            var newIn = _lodash2.default.cloneDeep(this.inputHDCP);
	            _lodash2.default.assignIn(newIn, event.inputs);
	            this.inputHDCP = _lodash2.default.cloneDeep(newIn);
	          }
	          break;
	        case 'links':
	          console.log('got event links');
	          if (event.outputs && (0, _typeof3.default)(event.outputs) === 'object') {
	            var _newOut = _lodash2.default.cloneDeep(this.outputLink);
	            _lodash2.default.assignIn(_newOut, event.outputs);
	            console.log(_newOut);
	            this.outputLink = _lodash2.default.cloneDeep(_newOut);
	          }
	
	          if (event.inputs && (0, _typeof3.default)(event.inputs) === 'object') {
	            var _newIn = _lodash2.default.cloneDeep(this.inputLink);
	            _lodash2.default.assignIn(_newIn, event.inputs);
	            this.inputLink = _lodash2.default.cloneDeep(_newIn);
	          }
	
	          break;
	      }
	    }
	  }
	};

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(220);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(22);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(28);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _regenerator = __webpack_require__(54);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(53);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(119);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _jquery = __webpack_require__(21);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _vendor_variables_js__ = __webpack_require__(301);
	
	var _vendor_variables_js__2 = _interopRequireDefault(_vendor_variables_js__);
	
	var _SingleSelect = __webpack_require__(26);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _vueStrap = __webpack_require__(12);
	
	var _Service = __webpack_require__(8);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _mobileDetect = __webpack_require__(56);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	var _Indicator = __webpack_require__(177);
	
	var _Indicator2 = _interopRequireDefault(_Indicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['showLeftBar'],
	  components: {
	    dropdown: _vueStrap.dropdown,
	    aside: _vueStrap.aside,
	    modal: _vueStrap.modal,
	    Indicator: _Indicator2.default,
	    vSelect: _SingleSelect2.default
	  },
	  data: function data() {
	    return {
	      VV: _vendor_variables_js__2.default,
	
	      version: ("v1.22.61i"),
	      user: {},
	      oldPwd: '',
	      newPwd: '',
	      newPwd2: '',
	      newName: '',
	      favorite: '',
	      favoriteOptions: [],
	      favoriteStatus: '',
	      devices: [],
	      showLeft: false,
	      showChgPw: false,
	      showChgProfile: false,
	      showAddDevice: false,
	      vendor: '',
	      vendorIcons: {
	        'gofanco': __webpack_require__(1106),
	        'siig': __webpack_require__(1107),
	        'avlt': ''
	      },
	      showChangePiNicknameModal: false,
	      newNickname: 'init',
	
	      imgs: ['', __webpack_require__(1069), __webpack_require__(1067), __webpack_require__(1068), __webpack_require__(1071), __webpack_require__(1066), __webpack_require__(1062), __webpack_require__(1070), __webpack_require__(1064), __webpack_require__(1063), __webpack_require__(1065)],
	      mobileTitle: 'Mapping',
	      sessionOptions: [{
	        value: '0',
	        label: 'Never'
	      }, {
	        value: '24',
	        label: 'One day'
	      }, {
	        value: '12',
	        label: '12 hours'
	      }, {
	        value: '1',
	        label: 'An hour'
	      }],
	      newSessionTime: '0',
	      newDevice: {
	        email: null,
	        code: null,
	        vendor: null,
	        fbid: null
	      },
	      ww: 0,
	      wh: 0
	    };
	  },
	  firebase: function firebase() {
	    return {
	      dbOnlines: {
	        source: (0, _Service.getOnlineDevsRef)(),
	        asObject: true
	      },
	      dbDevice: {
	        source: (0, _Service.getDeviceRef)(),
	        asObject: true
	      }
	    };
	  },
	  asyncData: function asyncData() {
	    var _this = this;
	
	    var mac = this.$route.params.mac;
	
	    (0, _Service.call)(mac, 'dxGetAbout').then(function (_ref) {
	      var capability = _ref.capability;
	
	      _this.vendor = capability.vendor;
	    }).catch(function (err) {
	      console.error('error in getAbout', err);
	    });
	  },
	  ready: function ready() {
	    this.ww = window.innerWidth;
	    this.wh = window.innerHeight;
	    window.addEventListener('orientationchange', this.addListener, false);
	    window.addEventListener('resize', this.addListener, false);
	  },
	
	  computed: {
	    handleDisableFavoriteSelect: function handleDisableFavoriteSelect() {
	      console.log('options', this.favoriteOptions);
	    },
	    onlines: function onlines() {
	      return (0, _Service.removeFirebaseKey)(this.dbOnlines);
	    },
	    devices: function devices() {
	      var devices = {};
	      for (var mac in this.dbDevice) {
	        devices[mac] = (0, _extends3.default)({}, this.dbDevice[mac], {
	          online: !!this.onlines[mac],
	          type: _Service.deviceTypes[this.dbDevice[mac].typeId],
	          mac_address: mac
	        });
	      }
	
	      return (0, _Service.removeFirebaseKey)(devices);
	    },
	    isMobile: function isMobile() {
	      var md = new _mobileDetect2.default(window.navigator.userAgent);
	      return md.mobile() !== null && this.wh > this.ww && this.$route.isLayout;
	    },
	    current: function current() {
	      var mac = this.$route.params.mac;
	
	      if (this.isEmpty(this.devices)) {
	        return { nickname: 'No device', type_id: 0 };
	      } else {
	        return this.devices[mac];
	      }
	    }
	  },
	  methods: {
	    handleShowChgNickname: function handleShowChgNickname() {
	      this.showChangePiNicknameModal = true;
	      console.log(this.newNickname);
	    },
	    handleChangePiNickName: function handleChangePiNickName() {
	      var _this2 = this;
	
	      if (!this.newNickname || this.newNickname.trim().length === 0) {
	        this.alert('danger', '', 'Please enter at least one English character or number only.');
	        return;
	      }
	
	      if (!this.$deviceNameValidator.devicename.valid && this.newNickname) {
	        this.alert('danger', '', 'Invalid device name');
	        return;
	      }
	
	      (0, _Service.changeDeviceNickname)(this.$route.params.mac, this.newNickname.trim()).then(function () {
	        _this2.alert('success', '', 'Device Name has been set to \'' + _this2.newNickname + '\'.');
	      });
	      this.showChangePiNicknameModal = false;
	    },
	    addListener: function addListener() {
	      this.ww = window.innerWidth;
	      this.wh = window.innerHeight;
	    },
	    wheelOnMachineList: function wheelOnMachineList(e) {
	      if (e.deltaX !== 0) {
	        return;
	      }
	      if (e.deltaY < 0) {
	        this.toScrollSlider('left');
	      } else {
	        this.toScrollSlider('right');
	      }
	      e.preventDefault();
	    },
	    toIndex: function toIndex() {
	      this.$router.go({
	        name: this.$route.name,
	        params: this.$route.params
	      });
	    },
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', { type: type, title: title, content: content });
	    },
	
	    isEmpty: _lodash2.default.isEmpty,
	    logout: function logout() {
	      var _this3 = this;
	
	      (0, _Service.logout)().then(function () {
	        _this3.alert('success', '', 'Logout Success');
	        _this3.$router.replace('/login');
	      });
	    },
	    toShowLeft: function toShowLeft() {
	      if (this.$route.name === 'control') return;
	      this.showLeftBar = true;
	    },
	    toScrollSlider: function toScrollSlider(direction) {
	      var slider = this.$els.slider;
	
	      var space = 100;
	      var curScrollLeft = (0, _jquery2.default)(slider).scrollLeft();
	      if (direction === 'left' && curScrollLeft > 0) {
	        (0, _jquery2.default)(slider).scrollLeft(curScrollLeft - space);
	      } else if (direction === 'right') {
	        (0, _jquery2.default)(slider).scrollLeft(curScrollLeft + space);
	      }
	    },
	    handleChgProfile: function handleChgProfile() {
	      var _this4 = this;
	
	      if (this.$displayName.name.valid && this.newName || this.$displayName.name.untouched) {
	        (0, _Service.changeUserProfile)({
	          name: this.newName.trim(),
	          session_time: this.newSessionTime,
	          favorite: this.favorite
	        }).then(function () {
	          _this4.$dispatch('alert', {
	            type: 'success',
	            title: '',
	            content: 'Name Changes To \'' + _this4.newName + '\' ,Logout Time set To ' + _this4.newSessionTime
	          });
	          _this4.user.name = _this4.newName.trim();
	          _this4.showChgProfile = false;
	        }).catch(function (err) {
	          _this4.alert('danger', 'Error', err.message);
	        });
	      } else {
	        this.alert('danger', '', 'Please enter a valid name.');
	      }
	    },
	    handleChgPw: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!(this.$changePwValidator.newpwd.valid && this.$changePwValidator.newpwd2.valid)) {
	                  _context.next = 18;
	                  break;
	                }
	
	                if (!(this.newPwd !== this.newPwd2)) {
	                  _context.next = 5;
	                  break;
	                }
	
	                this.alert('danger', 'Error', 'Please confirm your password again.');
	                _context.next = 16;
	                break;
	
	              case 5:
	                _context.prev = 5;
	                _context.next = 8;
	                return (0, _Service.changePassword)(this.newPwd);
	
	              case 8:
	                this.alert('success', '', 'Password Change success.');
	                this.showChgPw = false;
	                _context.next = 16;
	                break;
	
	              case 12:
	                _context.prev = 12;
	                _context.t0 = _context['catch'](5);
	
	                console.log(_context.t0.message);
	                this.alert('danger', '', _context.t0.message);
	
	              case 16:
	                _context.next = 19;
	                break;
	
	              case 18:
	                this.alert('danger', '', 'Please enter only English and number as new password only');
	
	              case 19:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[5, 12]]);
	      }));
	
	      function handleChgPw() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return handleChgPw;
	    }(),
	    handleAddDevice: function () {
	      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var theOnlyDev, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, mac;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!this.$addDeviceValidation.asscode.valid) {
	                  _context2.next = 50;
	                  break;
	                }
	
	                this.newDevice.fbid = this.user.uid;
	                _context2.prev = 2;
	                _context2.next = 5;
	                return (0, _Service.addDevice)(this.newDevice);
	
	              case 5:
	                this.alert('success', '', 'Device successfully added');
	                this.alert('warning', '', 'Page will refresh in 10 seconds');
	
	                if (!(!this.user.favorite || this.user.favorite && this.user.favorite.length === 0)) {
	                  _context2.next = 40;
	                  break;
	                }
	
	                theOnlyDev = '';
	                _iteratorNormalCompletion = true;
	                _didIteratorError = false;
	                _iteratorError = undefined;
	                _context2.prev = 12;
	                _iterator = (0, _getIterator3.default)((0, _keys2.default)(this.devices));
	
	              case 14:
	                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                  _context2.next = 22;
	                  break;
	                }
	
	                mac = _step.value;
	
	                if (!(this.devices[mac].ownerId === this.user.uid)) {
	                  _context2.next = 19;
	                  break;
	                }
	
	                theOnlyDev = mac;
	                return _context2.abrupt('break', 22);
	
	              case 19:
	                _iteratorNormalCompletion = true;
	                _context2.next = 14;
	                break;
	
	              case 22:
	                _context2.next = 28;
	                break;
	
	              case 24:
	                _context2.prev = 24;
	                _context2.t0 = _context2['catch'](12);
	                _didIteratorError = true;
	                _iteratorError = _context2.t0;
	
	              case 28:
	                _context2.prev = 28;
	                _context2.prev = 29;
	
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	
	              case 31:
	                _context2.prev = 31;
	
	                if (!_didIteratorError) {
	                  _context2.next = 34;
	                  break;
	                }
	
	                throw _iteratorError;
	
	              case 34:
	                return _context2.finish(31);
	
	              case 35:
	                return _context2.finish(28);
	
	              case 36:
	                _context2.next = 38;
	                return (0, _Service.changeUserProfile)({
	                  name: this.user.name,
	                  session_time: this.user.session_time,
	                  favorite: theOnlyDev
	                });
	
	              case 38:
	                console.log('Set the only device to the favorite of this user.');
	                this.alert('success', '', 'Set the only device to the favorite of this user.');
	
	              case 40:
	                this.showAddDevice = false;
	
	                setTimeout(function () {
	                  window.location.replace('/');
	                }, 12000);
	                _context2.next = 48;
	                break;
	
	              case 44:
	                _context2.prev = 44;
	                _context2.t1 = _context2['catch'](2);
	
	                console.log(_context2.t1);
	                if ((typeof _context2.t1 === 'undefined' ? 'undefined' : (0, _typeof3.default)(_context2.t1)) === 'object') {
	                  this.alert('danger', 'Error', _context2.t1.data);
	                } else {
	                  this.alert('danger', 'Error', _context2.t1);
	                }
	
	              case 48:
	                _context2.next = 51;
	                break;
	
	              case 50:
	                this.alert('danger', '', 'Please enter valid info to add a new device');
	
	              case 51:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[2, 44], [12, 24, 28, 36], [29,, 31, 35]]);
	      }));
	
	      function handleAddDevice() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return handleAddDevice;
	    }()
	  },
	  watch: {
	    showChgPw: function showChgPw(show) {
	      if (show) {
	        this.oldPwd = '';
	        this.newPwd = '';
	        this.newPwd2 = '';
	      }
	    },
	    showChgProfile: function showChgProfile(show) {
	      var _this5 = this;
	
	      if (show) {
	        this.newName = this.user.name;
	        this.newSessionTime = String(this.user.session_time);
	        this.account = this.user.email;
	        this.favorite = this.user.favorite || '';
	        this.favoriteOptions = [];
	
	        var options = (0, _keys2.default)(this.devices);
	        this.favoriteOptions = options.map(function (mac) {
	          if (!_this5.user.installer) {
	            if (_this5.user.favorite) {
	              if (mac === _this5.favorite && _this5.devices[mac].ownerId === _this5.user.uid) {
	                return {
	                  value: mac,
	                  label: _this5.devices[mac].online ? _this5.devices[mac].nickname || 'Anonymous' : 'Favorite device offline',
	                  online: true,
	                  isFake: !_this5.devices[mac].online
	                };
	              } else if (mac === _this5.favorite && _this5.devices[mac].ownerId !== _this5.user.uid) {
	                return;
	              }
	            } else {
	              if (_this5.devices[mac].ownerId === _this5.user.uid) {
	                return {
	                  value: mac,
	                  label: _this5.devices[mac].nickname || 'Anonymous',
	                  online: _this5.devices[mac].online,
	                  isFake: false
	                };
	              }
	            }
	          } else {
	            if (mac === _this5.favorite && !_this5.devices[mac].online) {
	              return {
	                value: mac,
	                label: 'Favorite device offline',
	                online: true,
	                isFake: true
	              };
	            }
	            return {
	              value: mac,
	              label: _this5.devices[mac].nickname || 'Anonymous',
	              online: _this5.devices[mac].online,
	              isFake: false
	            };
	          }
	        }).filter(function (obj) {
	          if (obj && obj.online) return obj.online;else return false;
	        });
	      }
	    },
	    showAddDevice: function showAddDevice(show) {
	      if (show) {
	        this.newDevice.email = 'installer@gmail.com';
	        this.newDevice.code = '';
	      }
	    },
	    '$route.name': function $routeName(name) {
	      var _this6 = this;
	
	      if (name === 'control') {
	        (0, _Service.getSpecificDevice)(this.$route.params.mac).then(function (device) {
	          _this6.alert('success', '', 'Probe device ' + device.nickname);
	          _this6.newNickname = device.nickname;
	        }).catch(function (e) {
	          _this6.alert('danger', '', e);
	        });
	      }
	    },
	    '$route.params.mac': function $routeParamsMac(mac) {
	      var _this7 = this;
	
	      console.log('mac changed');
	      (0, _Service.call)(mac, 'dxGetAbout').then(function (_ref4) {
	        var capability = _ref4.capability;
	
	        _this7.vendor = capability.vendor;
	      }).catch(function (err) {
	        console.error('error in getAbout', err);
	      });
	    }
	  },
	  events: {
	    user: function user(uid, _user) {
	      this.user = _user;
	      this.user.uid = uid;
	      this.favorite = _user.favorite;
	    },
	    add_device: function add_device(user) {
	      this.showAddDevice = true;
	    },
	    vendor: function vendor(_vendor) {
	      console.log('Got vendor event => ', _vendor);
	      this.vendor = _vendor;
	    },
	    nickname: function nickname(_nickname) {
	      console.log('got nickname');
	      this.newNickname = _nickname;
	    }
	  }
	};

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(28);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _jquery = __webpack_require__(21);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Service = __webpack_require__(8);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _vueDatepicker = __webpack_require__(1209);
	
	var _vueDatepicker2 = _interopRequireDefault(_vueDatepicker);
	
	var _vueStrap = __webpack_require__(12);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mobileDetect = __webpack_require__(56);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	var _Pagination = __webpack_require__(1174);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _vendor_variables_js__ = __webpack_require__(301);
	
	var _vendor_variables_js__2 = _interopRequireDefault(_vendor_variables_js__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var longDataFormat = 'DD-MM-YYYY HH:mm:ss';
	var shortDateFormat = 'DD-MM-YYYY';
	exports.default = {
	  components: {
	    'date-picker': _vueDatepicker2.default,
	    'v-pagination': _Pagination2.default,
	    modal: _vueStrap.modal
	  },
	  data: function data() {
	    return {
	      startDate: '',
	      endDate: '',
	      downloadlink: '',
	      selectedOptions: [],
	      startOption: {
	        type: 'day',
	        SundayFirst: true,
	        week: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	        format: shortDateFormat,
	        placeholder: 'Select a start date',
	        inputStyle: {
	          'display': 'inline-block',
	          'padding': '6px',
	          'line-height': '22px',
	          'font-size': '14px',
	          'font-family': 'Avenir',
	          'font-weight': '400',
	          'width': '100%',
	          'border': '2px solid transparent',
	          'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.5)',
	          '-o-box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.5)',
	          '-webkit-box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.5)',
	          'border-radius': '2px',
	          'background-color': '#fff',
	          'color': 'transparent',
	          'text-shadow': '0 0 0 #5f5f5f',
	          '::-webkit-input-placeholder': '#aaa',
	          '::-moz-input-placeholder': '#aaa',
	          '::-ms-input-placeholder': '#aaa',
	          '::-o-input-placeholder': '#aaa',
	          'cursor': 'text',
	          'outline': '1px solid #aaa'
	        },
	        color: {
	          header: _vendor_variables_js__2.default.color.theme,
	          headerText: '#fff'
	        },
	        buttons: {
	          ok: 'Ok',
	          cancel: 'Cancel'
	        },
	        overlayOpacity: 0.5,
	        dismissible: true },
	      showConfirm: false,
	      confirmMsg: '',
	      confirmCb: function confirmCb() {},
	      countOfPage: 50,
	      currPage: 1,
	      countOfPagination: 5,
	      currPaginationSec: 1,
	      timezone: {},
	      currentTime: '',
	      isSwitcher: false
	    };
	  },
	  asyncData: function asyncData() {
	    var _this = this;
	
	    _Service2.default.call(this.$route.params.mac, 'dxGetTimeZone').then(function (_ref) {
	      var timezone = _ref.timezone;
	
	      _this.timezone = timezone;
	      _this.updateTime();
	      return _Service2.default.call(_this.$route.params.mac, 'dxGetAbout');
	    }).then(function (_ref2) {
	      var model = _ref2.model;
	
	      _this.isSwitcher = model.toUpperCase().includes('SW');
	      _this.$dispatch('updateIsSwitcher', model.toUpperCase().includes('SW'));
	      console.log('isSwitcher =>', _this.isSwitcher);
	    }).catch(function (err) {
	      _this.alert('danger', 'No response', err);
	    });
	  },
	  firebase: function firebase() {
	    return {
	      events: _Service2.default.getEventLogRef(this.$route.params.mac).limitToLast(3000)
	    };
	  },
	
	  computed: {
	    deviceTime: function deviceTime() {
	      if (this.timezone.useDaylight && (0, _moment2.default)().isDST()) {
	        return (0, _moment2.default)(this.currentTime).utc().add(this.timezone.offset, 'seconds').add(this.timezone.dstSavings, 'seconds').format(longDataFormat);
	      } else {
	        return (0, _moment2.default)(this.currentTime).utc().add(this.timezone.offset, 'seconds').format(longDataFormat);
	      }
	    },
	    isMobile: function isMobile() {
	      var md = new _mobileDetect2.default(window.navigator.userAgent);
	      return md.mobile() !== null;
	    },
	    pageStart: function pageStart() {
	      return (this.currPage - 1) * this.countOfPage;
	    },
	    paginationStart: function paginationStart() {
	      return (this.currPaginationSec - 1) * this.countOfPagination;
	    },
	    totalSection: function totalSection() {
	      return Math.ceil(this.totalPage / this.countOfPagination);
	    },
	    totalPage: function totalPage() {
	      return Math.ceil(this.computedLog.length / this.countOfPage);
	    },
	    totalPageAry: function totalPageAry() {
	      var ary = [];
	      for (var i = 0; i < this.totalPage; i++) {
	        ary.push(i);
	      }
	      return ary;
	    },
	    limitStart: function limitStart() {
	      return this.endDate ? [{
	        type: 'fromto',
	        from: '2010-01-01',
	        to: (0, _moment2.default)(this.endDate, shortDateFormat)
	      }] : [];
	    },
	    limitEnd: function limitEnd() {
	      return this.startDate ? [{
	        type: 'fromto',
	        from: (0, _moment2.default)(this.startDate, shortDateFormat).format('YYYY-MM-DD'),
	        to: '2100-12-31'
	      }] : [];
	    },
	
	    selectAll: {
	      get: function get() {
	        return this.selectedOptions.length === this.checkedConditions.length;
	      },
	      set: function set(value) {
	        this.selectedOptions = value ? _lodash2.default.cloneDeep(this.checkedConditions) : [];
	      }
	    },
	    checkedConditions: function checkedConditions() {
	      if (this.$route.name === 'power') {
	        return ['lock', 'enable', 'info', 'reset', 'maintenance'];
	      } else if (this.$route.name === 'matrix') {
	        var filters = ['links', 'quality', 'power', 'mapping', 'hdcp', 'edid', 'maps', 'info', 'maintenance'];
	        if (this.isSwitcher) filters.push('switcherLayout');
	        return filters;
	      } else if (this.$route.name === 'mixer') {
	        return ['mapping', 'layer', 'split', 'label', 'preset', 'sound', 'video', 'color', 'crop', 'maintenance', 'links', 'hdcp', 'edid'];
	      } else if (this.$route.name === 'dio') {
	        return ['state', 'info', 'maintenance'];
	      } else if (this.$route.name === 'splitter') {
	        return ['split', 'preset', 'resolution', 'maintenance'];
	      }
	    },
	    endOption: function endOption() {
	      var opt = _lodash2.default.cloneDeep(this.startOption);
	      opt.placeholder = 'Select a end date';
	      return opt;
	    },
	    computedLog: function computedLog() {
	      var _this2 = this;
	
	      var events = null;
	      if (this.startDate && this.endDate) {
	        var startMoment = (0, _moment2.default)(this.startDate, shortDateFormat);
	        var endMoment = (0, _moment2.default)(this.endDate, shortDateFormat);
	        events = this.events.filter(function (e) {
	          return (0, _moment2.default)(e.dateTime).isBetween(startMoment, endMoment, 'days', '[]');
	        });
	      } else {
	        events = this.events;
	      }
	      events = events.map(function (evt) {
	        var devTime = 0;
	        var offset = _moment2.default.parseZone((0, _moment2.default)(_this2.currentTime).utcOffset());
	        if (_this2.$route.name === 'power') {
	          if (_this2.timezone.useDaylight) {
	            devTime = evt.dateTime - offset * 60000 + (_this2.timezone.offset + _this2.timezone.dstSavings) * 1000;
	          } else {
	            devTime = evt.dateTime - offset * 60000 + _this2.timezone.offset * 1000;
	          }
	          return {
	            dateTime: devTime,
	            timeString: (0, _moment2.default)(devTime, shortDateFormat).format(longDataFormat),
	            type: evt.type,
	            message: evt.msg
	          };
	        } else {
	          return {
	            dateTime: evt.dateTime,
	            timeString: (0, _moment2.default)(evt.dateTime, shortDateFormat).format(longDataFormat),
	            type: evt.type,
	            message: evt.msg
	          };
	        }
	      });
	      return events.filter(function (evt) {
	        return _this2.selectedOptions.indexOf(evt.type) > -1;
	      });
	    },
	    logLength: function logLength() {
	      return this.computedLog.length;
	    }
	  },
	  events: {
	    update: function update(mac, _ref3) {
	      var type = _ref3.type,
	          event = _ref3.event,
	          msg = _ref3.msg;
	
	      if (type === 'timezone') {
	        this.timezone = event.timezone;
	      }
	    }
	  },
	  methods: {
	    updateTime: function updateTime() {
	      this.currentTime = Date.now();
	      var vue = this;
	      setTimeout(function () {
	        vue.updateTime();
	      }, 1000);
	    },
	
	    setPage: function setPage(idx) {
	      if (idx <= 0 || idx > this.totalPage) {
	        return;
	      }
	      this.currPage = idx;
	      if (idx > this.currPaginationSec * this.countOfPagination) {
	        this.setPaginationSec(this.currPaginationSec + 1);
	      } else if (idx <= (this.currPaginationSec - 1) * this.countOfPagination) {
	        this.setPaginationSec(this.currPaginationSec - 1);
	      }
	    },
	    setPaginationSec: function setPaginationSec(idx) {
	      if (idx <= 0 || idx > this.totalSection) {
	        return;
	      }
	      this.currPaginationSec = idx;
	    },
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    toggleMsg: function toggleMsg(e) {
	      if ((0, _jquery2.default)(e.target).hasClass('open')) {
	        (0, _jquery2.default)(e.target).removeClass('open');
	      } else {
	        (0, _jquery2.default)(e.target).addClass('open');
	      }
	    },
	    clear: function clear() {
	      var _this3 = this;
	
	      this.handleConfirmModal('This will CLEAR all logs of this device, do you want to continue?', function () {
	        _Service2.default.clearEvents(_this3.$route.params.mac);
	        _this3.alert('success', '', 'Logs have been cleaned');
	      });
	    },
	    handleConfirmModal: function handleConfirmModal(msg, callback) {
	      var _this4 = this;
	
	      var confirmCb = function confirmCb() {
	        callback();
	        _this4.showConfirm = false;
	      };
	      this.confirmMsg = msg;
	      this.confirmCb = confirmCb;
	      this.showConfirm = true;
	    },
	    download: function download() {
	      var csvTitles = ['Time', 'Type', 'Message'];
	      var dataKeys = ['dateTime', 'type', 'message'];
	      var csvContent = csvTitles.join() + '\r\n';
	      var csvToDown = this.computedLog;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        var _loop = function _loop() {
	          var column = _step.value;
	
	          var columnData = dataKeys.map(function (k) {
	            if (k === 'dateTime') {
	              return (0, _moment2.default)(column[k]).format(longDataFormat);
	            } else {
	              return column[k];
	            }
	          });
	          csvContent = csvContent + columnData.join() + '\r\n';
	        };
	
	        for (var _iterator = (0, _getIterator3.default)(csvToDown), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          _loop();
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var textFileAsBlob = new window.Blob([csvContent], { type: 'text/plain' });
	      var atag = this.$els.download;
	      atag.download = 'exportLog.csv';
	      atag.href = window.URL.createObjectURL(textFileAsBlob);
	      try {
	        atag.click();
	      } catch (e) {
	        window.navigator.msSaveBlob(textFileAsBlob, 'exportLog.csv');
	      }
	    },
	    blur: function blur(evt) {
	      (0, _jquery2.default)(evt.target).blur();
	    },
	    cleanFilterTime: function cleanFilterTime() {
	      this.startDate = '';
	      this.endDate = '';
	    }
	  }
	};

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Service = __webpack_require__(8);
	
	var _vueStrap = __webpack_require__(12);
	
	var _SingleSelect = __webpack_require__(26);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEVICE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss';
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal,
	    'v-select': _SingleSelect2.default
	  },
	  data: function data() {
	    return {
	      loadingData: true,
	      device: {},
	      keyToDisable: ['type', 'id', 'ownerId', 'installerId', 'created_at', 'installer_email', 'mfg', 'updated_at', 'platform', 'online', 'serviceTag', 'name', 'model', 'activeLog', 'firmware_version'],
	      editting: {},
	      newNickname: '',
	      types: ['', 'DPS', 'Matrix', 'Mixer', 'Video wall', 'MES', 'DIO'],
	      namesToShow: {
	        mac_address: 'Mac Address',
	        typeId: 'Device Type',
	        serialNum: 'Serial No.',
	        ip_address: 'Device IP',
	        firmware: 'Firmware',
	        nickname: 'Device Name',
	        description: 'Model Description'
	      },
	      showConfirm: false,
	      confirmMsg: '',
	      confirmCb: function confirmCb() {},
	      capability: {},
	      timezoneOptions: [],
	      timezoneUIOptions: [],
	      timezone: {},
	      timezoneIndex: '',
	      timezoneKeyAry: [],
	      currentTime: '',
	      isSwitcher: false
	    };
	  },
	  asyncData: function asyncData() {
	    var _this = this;
	
	    var mac = this.$route.params.mac;
	
	    var deviceRet = {};
	    if (this.$route.name === 'power' || this.$route.name === 'dio') {
	      return (0, _Service.getSpecificDevice)(mac).then(function (device) {
	        console.log(device);
	        _this.newNickname = device.nickname;
	        for (var key in device) {
	          if (_this.keyToDisable.indexOf(key) === -1) {
	            deviceRet[key] = device[key];
	          }
	        }
	        return (0, _Service.call)(mac, 'dxGetNetworkSettings');
	      }).then(function (settings) {
	        _this.loadingData = false;
	        _this.editting = settings;
	
	        deviceRet.ip_address = _this.editting.deviceIpAddress;
	        return (0, _Service.call)(mac, 'dxGetTimeZone');
	      }).then(function (_ref) {
	        var timezone = _ref.timezone;
	
	        _this.timezone = timezone;
	        return (0, _Service.call)(mac, 'dxGetTimeZoneOptions');
	      }).then(function (_ref2) {
	        var options = _ref2.options;
	
	        var opts = [];
	        var keyAry = [];
	
	        for (var i = 0; i < options.length; i++) {
	          opts.push({
	            label: options[i].id,
	            value: i
	          });
	
	          keyAry.push(i);
	
	          if (options[i].id === _this.timezone.id) {
	            _this.timezoneIndex = i;
	          }
	        }
	        _this.timezoneKeyAry = keyAry;
	        _this.timezoneUIOptions = opts;
	        _this.timezoneOptions = options;
	        return (0, _Service.call)(mac, 'dxGetAbout');
	      }).then(function (_ref3) {
	        var firmware = _ref3.firmware,
	            description = _ref3.description,
	            capability = _ref3.capability,
	            model = _ref3.model;
	
	        if (model === '8x8 HDMI 2.0a Matrix' && description === 'MA-5588H2') {
	          deviceRet.description = '8x8 HDMI 2.0a Matrix';
	        } else {
	          deviceRet.description = description;
	        }
	        deviceRet.firmware = firmware;
	        return {
	          device: deviceRet,
	          capability: capability
	        };
	      }).catch(function (err) {
	        console.error(err);
	        setTimeout(_this.reloadAsyncData, 1000);
	      });
	    } else {
	      return (0, _Service.getSpecificDevice)(mac).then(function (device) {
	        console.log('device is ===>', device);
	        _this.newNickname = device.nickname;
	        for (var key in device) {
	          if (_this.keyToDisable.indexOf(key) === -1) {
	            deviceRet[key] = device[key];
	          }
	
	          if (key === 'model' && device[key].includes('SW')) {
	            _this.isSwitcher = device[key].includes('SW');
	            _this.$dispatch('updateIsSwitcher', _this.isSwitcher);
	          }
	        }
	        return (0, _Service.call)(mac, 'dxGetNetworkSettings');
	      }).then(function (settings) {
	        _this.loadingData = false;
	        _this.editting = settings;
	
	        deviceRet.ip_address = _this.editting.deviceIpAddress;
	        return (0, _Service.call)(mac, 'dxGetAbout');
	      }).then(function (_ref4) {
	        var firmware = _ref4.firmware,
	            description = _ref4.description,
	            capability = _ref4.capability;
	
	        console.log('description', description);
	        if (description) {
	          if (description.indexOf('MA-5588H2') !== -1) {
	            deviceRet.description = '8x8 HDMI 2.0a Matrix';
	          } else {
	            deviceRet.description = description;
	          }
	        }
	        deviceRet.firmware = firmware;
	        return {
	          device: deviceRet,
	          capability: capability
	        };
	      }).catch(function (err) {
	        console.error(err);
	        setTimeout(_this.reloadAsyncData, 1000);
	      });
	    }
	  },
	
	  computed: {
	    utcTime: function utcTime() {
	      return (0, _moment2.default)(this.currentTime).utc().format(DEVICE_TIME_FORMAT);
	    },
	    deviceTime: function deviceTime() {
	      if (this.timezone.useDaylight && (0, _moment2.default)().isDST()) {
	        return (0, _moment2.default)(this.currentTime).utc().add(this.timezone.offset, 'seconds').add(this.timezone.dstSavings, 'seconds').format(DEVICE_TIME_FORMAT);
	      } else {
	        return (0, _moment2.default)(this.currentTime).utc().add(this.timezone.offset, 'seconds').format(DEVICE_TIME_FORMAT);
	      }
	    },
	    isDST: function isDST() {
	      return (0, _moment2.default)().isDST();
	    }
	  },
	  ready: function ready() {
	    this.updateTime();
	  },
	
	  events: {
	    user: function user(uid, _user) {
	      this.isInstaller = _user.installer;
	    }
	  },
	  methods: {
	    applyTimeZone: function applyTimeZone() {
	      var _this2 = this;
	
	      (0, _Service.call)(this.$route.params.mac, 'dxSetTimeZone', {
	        timezone: this.timezoneOptions[this.timezoneIndex]
	      }).then(function (res) {
	        _this2.timezone = _this2.timezoneOptions[_this2.timezoneIndex];
	      }).catch(function (err) {
	        console.log(err);
	      });
	    },
	    updateTime: function updateTime() {
	      this.currentTime = Date.now();
	      var vue = this;
	      setTimeout(function () {
	        vue.updateTime();
	      }, 1000);
	    },
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    chgName: function chgName() {
	      var _this3 = this;
	
	      var newDevice = _lodash2.default.clone(this.device);
	      if (this.$deviceNameValidator.devicename.valid && this.newNickname) {
	        (0, _Service.changeDeviceNickname)(this.$route.params.mac, this.newNickname.trim()).then(function () {
	          newDevice.nickname = _this3.newNickname;
	          _this3.device = newDevice;
	
	          _this3.alert('success', '', 'Device Name has been set to \'' + _this3.newNickname + '\'.');
	        });
	      } else {
	        this.alert('danger', '', 'Please enter at least one English character or number only.');
	      }
	    },
	    handleConfirmModal: function handleConfirmModal(msg, callback) {
	      var _this4 = this;
	
	      var confirmCb = function confirmCb() {
	        callback();
	        _this4.showConfirm = false;
	      };
	      this.confirmMsg = msg;
	      this.confirmCb = confirmCb;
	      this.showConfirm = true;
	    },
	    handleMaintenance: function handleMaintenance() {
	      var _this5 = this;
	
	      (0, _Service.hasNewFirmware)({
	        mac: this.$route.params.mac,
	        version: this.device.firmware_version
	      }).then(function (newV) {
	        if (newV) {
	          _this5.handleConfirmModal('Your device is on firmware ' + _this5.device.firmware_version + ' Do you want to update to ' + newV + '?', function () {
	            (0, _Service.call)(_this5.$route.params.mac, 'dxUpdateFirmware', { url: newV });
	          });
	        } else {
	          _this5.handleConfirmModal('Your device firmware is the lastest .');
	        }
	      });
	    },
	    rollbackFirmware: function rollbackFirmware() {
	      var _this6 = this;
	
	      this.handleConfirmModal('Are you sure you want to rollback?', function () {
	        (0, _Service.call)(_this6.$route.params.mac, 'dxRollbackDevice', {});
	      });
	    },
	    resetToFactoryDefault: function resetToFactoryDefault() {
	      var _this7 = this;
	
	      this.handleConfirmModal('Do you want to reset the device to factory default?', function () {
	        (0, _Service.call)(_this7.$route.params.mac, 'dxDefaultDevice', {}).then(function (resolved) {
	          console.log('resolved: ', resolved);
	        }, function (rejected) {
	          console.log('in rejected');
	          _this7.alert('danger', 'Error resetting to factory default', rejected);
	        });
	      });
	    },
	    reboot: function reboot() {
	      var _this8 = this;
	
	      this.handleConfirmModal('Do you want to reboot the device?', function () {
	        (0, _Service.call)(_this8.$route.params.mac, 'dxResetDevice', {}).then(function (resolved) {
	          console.log(resolved);
	        }, function (rejected) {
	          _this8.alert('danger', 'Error in reboot', rejected);
	        });
	      });
	    },
	    setNetwork: function setNetwork() {
	      var _this9 = this;
	
	      console.log('set network');
	      var obj = {};
	      if ((obj.dhcpEnabled = this.editting.dhcpEnabled) === false) {
	        if (this.$dhcpValidation.ip.valid && this.$dhcpValidation.netmask.valid && this.$dhcpValidation.gateway.valid) {
	          obj.dhcpEnabled = false;
	          obj.deviceIpAddress = this.editting.deviceIpAddress;
	          obj.deviceSubnetMask = this.editting.deviceSubnetMask;
	          obj.deviceDefaultGateway = this.editting.deviceDefaultGateway;
	        } else {
	          this.alert('danger', '', 'Please enter valid ip or valid netmask or valid gateway.');
	          return;
	        }
	      }
	
	      (0, _Service.call)(this.$route.params.mac, 'dxSetNetworkSettings', obj).then(function (resolved) {
	        if (resolved.error && resolved.error.msg) {
	          _this9.alert('danger', '', resolved.error.msg);
	        } else {
	          console.log(resolved);
	        }
	      }, function (rejected) {
	        if (rejected.error || rejected.error.msg) {
	          _this9.alert('danger', '', rejected.error || rejected.error.msg);
	        }
	      });
	    }
	  } };

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Service = __webpack_require__(8);
	
	var _vueStrap = __webpack_require__(12);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEVICE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss';
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal,
	    radio: _vueStrap.radio,
	    'button-group': _vueStrap.buttonGroup
	  },
	  data: function data() {
	    return {
	      firmware_version: '',
	      capability: {},
	      showConfirm: false,
	      confirmMsg: '',
	      confirmCb: function confirmCb() {},
	      timezone: {},
	      currentTime: ''
	    };
	  },
	  asyncData: function asyncData() {
	    var _this = this;
	
	    var mac = this.$route.params.mac;
	
	    if (this.$route.name === 'power') {
	      (0, _Service.call)(mac, 'dxGetTimeZone').then(function (_ref) {
	        var timezone = _ref.timezone;
	
	        _this.timezone = timezone;
	        _this.updateTime();
	      });
	    }
	    (0, _Service.call)(mac, 'dxGetAbout').then(function (_ref2) {
	      var capability = _ref2.capability,
	          firmware = _ref2.firmware,
	          model = _ref2.model;
	
	      _this.capability = _lodash2.default.cloneDeep(capability);
	      _this.firmware_version = firmware;
	      console.log(_this.capability);
	      console.log(_this.firmware_version);
	      _this.$dispatch('updateIsSwitcher', model.toUpperCase().includes('SW'));
	    });
	  },
	
	  computed: {
	    deviceTime: function deviceTime() {
	      if (this.timezone.useDaylight && (0, _moment2.default)().isDST()) {
	        return (0, _moment2.default)(this.currentTime).utc().add(this.timezone.offset, 'seconds').add(this.timezone.dstSavings, 'seconds').format(DEVICE_TIME_FORMAT);
	      } else {
	        return (0, _moment2.default)(this.currentTime).utc().add(this.timezone.offset, 'seconds').format(DEVICE_TIME_FORMAT);
	      }
	    }
	  },
	  methods: {
	    updateTime: function updateTime() {
	      this.currentTime = Date.now();
	      var vue = this;
	      setTimeout(function () {
	        vue.updateTime();
	      }, 1000);
	    },
	    handleMaintenance: function handleMaintenance() {
	      var _this2 = this;
	
	      (0, _Service.hasNewFirmware)({
	        mac: this.$route.params.mac,
	        version: this.firmware_version
	      }).then(function (newV) {
	        if (newV) {
	          _this2.handleConfirmModal('Your device is on firmware ' + _this2.firmware_version + ' Do you want to update to ' + newV + '?', function () {
	            (0, _Service.call)(_this2.$route.params.mac, 'dxUpdateFirmware', { url: newV });
	          });
	        } else {
	          _this2.handleConfirmModal('Your device firmware is the lastest .');
	        }
	      });
	    },
	    rollbackFirmware: function rollbackFirmware() {
	      var _this3 = this;
	
	      this.handleConfirmModal('Are you sure you want to rollback?', function () {
	        (0, _Service.call)(_this3.$route.params.mac, 'dxRollbackDevice', {});
	      });
	    },
	    resetToFactoryDefault: function resetToFactoryDefault() {
	      var _this4 = this;
	
	      this.handleConfirmModal('Do you want to reset the device to factory default?', function () {
	        (0, _Service.call)(_this4.$route.params.mac, 'dxDefaultDevice', {}).then(function (resolved) {
	          console.log('resolved: ', resolved);
	        }, function (rejected) {
	          console.log('in rejected');
	          _this4.alert('danger', 'Error resetting to factory default', rejected);
	        });
	      });
	    },
	    reboot: function reboot() {
	      var _this5 = this;
	
	      this.handleConfirmModal('Do you want to reboot the device?', function () {
	        (0, _Service.call)(_this5.$route.params.mac, 'dxResetDevice', {}).then(function (resolved) {
	          console.log(resolved);
	        }, function (rejected) {
	          _this5.alert('danger', 'Error in reboot', rejected);
	        });
	      });
	    },
	    handleConfirmModal: function handleConfirmModal(msg, callback) {
	      var _this6 = this;
	
	      console.log('in handleConfim');
	      var confirmCb = function confirmCb() {
	        callback();
	        _this6.showConfirm = false;
	      };
	      this.confirmMsg = msg;
	      this.confirmCb = confirmCb;
	      this.showConfirm = true;
	    }
	  }, ready: function ready() {},
	
	  watch: {}
	};

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _coerceBoolean = __webpack_require__(615);
	
	var _coerceBoolean2 = _interopRequireDefault(_coerceBoolean);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    isOpen: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: false
	    },
	    header: {
	      type: String
	    }
	  },
	  methods: {
	    toggleIsOpen: function toggleIsOpen() {
	      this.isOpen = !this.isOpen;
	      this.$dispatch('isOpenEvent', this);
	    }
	  },
	  transitions: {
	    collapse: {
	      afterEnter: function afterEnter(el) {
	        el.style.maxHeight = '';
	      },
	      beforeLeave: function beforeLeave(el) {
	        el.style.maxHeight = el.offsetHeight + 'px';
	
	        return el.offsetHeight;
	      }
	    }
	  }
	};

/***/ }),
/* 628 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    enable: {
	      type: Boolean,
	      default: false
	    },
	    na: {
	      default: true
	    },
	    showText: {
	      default: false
	    },
	    textForEnable: {
	      type: String,
	      default: 'Enable'
	    },
	    textForDisable: {
	      type: String,
	      default: 'Disable'
	    },
	    textForNa: {
	      type: String,
	      default: 'N/A'
	    }
	  },
	  computed: {
	    indicatorClass: function indicatorClass() {
	      if (this.enable) {
	        return 'indicator-enable';
	      } else {
	        if (this.na) {
	          return 'indicator-na';
	        }
	        return 'indicator-disable';
	      }
	    },
	    indicatorText: function indicatorText() {
	      if (this.enable) {
	        return this.textForEnable;
	      } else {
	        if (this.na) {
	          return this.textForNa;
	        }
	        return this.textForDisable;
	      }
	    }
	  }
	};

/***/ }),
/* 629 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  components: {},
	  props: {
	    aniKey: {
	      type: String,
	      default: '1'
	    }
	  },
	  data: function data() {
	    return {};
	  },
	  asyncData: function asyncData() {},
	
	  computed: {},
	  methods: {}, ready: function ready() {},
	
	  watch: {}
	};

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    showOption: {
	      type: Boolean,
	      default: true
	    },
	    options: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    outputAry: {
	      type: Array,
	      default: function _default() {
	        return [];
	      },
	
	      twoWay: true
	    },
	    nameProp: {
	      type: String,
	      default: 'tagTypeCheckbox'
	    },
	    showAllOutletBtn: {
	      type: Boolean,
	      default: false
	    }
	  },
	  components: {},
	  data: function data() {
	    return {};
	  },
	
	  computed: {
	    allSelected: function allSelected() {
	      return this.outputAry.length === this.options.length;
	    }
	  },
	  asyncData: function asyncData() {},
	
	  methods: {
	    selectAll: function selectAll() {
	      if (this.allSelected) {
	        this.outputAry = [];
	      } else {
	        this.outputAry = this.options.map(function (o) {
	          return o.value;
	        });
	      }
	    }
	  },
	  ready: function ready() {},
	
	  events: {},
	  watch: {}
	};

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  components: {},
	  data: function data() {
	    return {
	      countOfPage: 50,
	      currPage: 1,
	      countOfPagination: 5,
	      currPaginationSec: 1
	    };
	  },
	
	  computed: {
	    pageStart: function pageStart() {
	      return (this.currPage - 1) * this.countOfPage;
	    },
	    paginationStart: function paginationStart() {
	      return (this.currPaginationSec - 1) * this.countOfPagination;
	    },
	    totalSection: function totalSection() {
	      return Math.ceil(this.totalPage / this.countOfPagination);
	    },
	    totalPage: function totalPage() {
	      return Math.ceil(this.computedLog.length / this.countOfPage);
	    },
	    totalPageAry: function totalPageAry() {
	      var ary = [];
	      for (var i = 0; i < this.totalPage; i++) {
	        ary.push(i);
	      }
	      return ary;
	    }
	  },
	  methods: {
	    setPage: function setPage(idx) {
	      if (idx <= 0 || idx > this.totalPage) {
	        return;
	      }
	      this.currPage = idx;
	      if (idx > this.currPaginationSec * this.countOfPagination) {
	        this.setPaginationSec(this.currPaginationSec + 1);
	      } else if (idx <= (this.currPaginationSec - 1) * this.countOfPagination) {
	        this.setPaginationSec(this.currPaginationSec - 1);
	      }
	    },
	    setPaginationSec: function setPaginationSec(idx) {
	      if (idx <= 0 || idx > this.totalSection) {
	        return;
	      }
	      this.currPaginationSec = idx;
	    }
	  }, ready: function ready() {},
	
	  watch: {}
	};

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueStrap = __webpack_require__(12);
	
	var _interact2 = __webpack_require__(361);
	
	var _interact3 = _interopRequireDefault(_interact2);
	
	var _jquery = __webpack_require__(21);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal
	  },
	  props: {
	    showLink: {
	      type: Boolean,
	      default: false
	    },
	    inProfile: {
	      type: Boolean,
	      default: false
	    },
	    id: {
	      type: String,
	      default: '1'
	    },
	    showPs: {
	      type: Boolean,
	      default: false
	    },
	    imgs: {
	      type: Array,
	      default: function _default() {
	        return ['', __webpack_require__(174), __webpack_require__(175), __webpack_require__(254), __webpack_require__(255)];
	      }
	    },
	    editable: {
	      type: Boolean,
	      default: true
	    },
	    splits: {
	      type: Object,
	      default: function _default() {
	        return {
	          '1': {},
	          '2': {},
	          '3': {},
	          '4': {}
	        };
	      }
	    },
	    inputs: {
	      type: Object
	    },
	    outResolution: {
	      type: String,
	      twoway: true
	    },
	    outRatio: {
	      type: Array
	    },
	    outLayout: {
	      type: String,
	      twoway: true
	    },
	    whichSplit: {
	      type: String
	    },
	    windowFocus: {
	      type: String,
	      twoway: true
	    },
	    layer: {
	      type: Array,
	      twoway: true,
	      require: true
	    },
	    outResolutionOptions: {
	      type: Object
	    },
	    label: {
	      type: Object,
	      default: function _default() {
	        return {};
	      },
	
	      twoway: true
	    },
	    apply: {
	      type: Function,
	      default: function _default() {}
	    },
	    resizeEvent: {
	      type: Object,
	      default: function _default() {
	        return {};
	      },
	
	      twoway: true
	    },
	    mapping: {
	      type: Object
	    }
	  },
	  data: function data() {
	    return {
	      posArray: [],
	      bigWidth: 0,
	      bigHeight: 0,
	      smallWidth: 0,
	      smallHeight: 0,
	      event: {},
	      box: {}
	    };
	  },
	  asyncData: function asyncData() {},
	
	  computed: {},
	  methods: {
	    toFocus: function toFocus(key) {
	      this.windowFocus = key;
	    },
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    interact: function interact() {
	      var vue = this;
	      var screen = this.$els.screen;
	
	      (0, _interact3.default)('.focus').resizable({
	        inertia: false,
	        preserveAspectRatio: false,
	
	        edges: {
	          left: true,
	          right: true,
	          bottom: true,
	          top: true
	        },
	        restrict: {
	          restriction: screen,
	          endOnly: false
	        },
	        snap: {
	          targets: [_interact3.default.createSnapGrid({ x: 5, y: 5 })],
	          range: Infinity,
	          relativePoints: [{ x: 0, y: 0 }]
	        },
	        enabled: true,
	        invert: 'none',
	        onmove: function onmove(event) {
	          if (event.type === 'resizemove') {
	            vue.updateScreenCords(event, 'resize');
	            vue.$dispatch('resizemove', event);
	          }
	        },
	        onend: function onend(event) {
	          if (event.type === 'resizeend') {
	            vue.$dispatch('resizeend', {
	              target: event.target.getAttribute('data-index')
	            });
	          }
	        }
	      }).draggable({
	        inertia: false,
	
	        restrict: {
	          restriction: screen,
	          endOnly: true,
	          elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
	        },
	        snap: {
	          targets: [_interact3.default.createSnapGrid({ x: 5, y: 5 })],
	          range: Infinity,
	          relativePoints: [{ x: 0, y: 0 }]
	        },
	        autoScroll: false,
	        onstart: function onstart(event) {},
	        onmove: function onmove(event) {
	          if (event.type === 'dragmove') {
	            vue.updateScreenCords(event, 'drag');
	          }
	        },
	        onend: function onend(event) {
	          vue.$dispatch('dragend', {
	            target: event.target.getAttribute('data-index')
	          });
	          console.log(event.target.getAttribute('data-index'));
	        }
	      }).gesturable({
	        restrict: {
	          restriction: screen,
	          endOnly: true
	        },
	        maxPerElement: 1,
	        onstart: function onstart(event) {
	          if (event.type === 'gesturestart') {
	            vue.event = event.type;
	            var target = event.target;
	
	            target.setAttribute('data-bWidth', event.box.width);
	            target.setAttribute('data-bHeight', event.box.height);
	            target.setAttribute('data-bPreviousX', event.box.x);
	            target.setAttribute('data-bPreviousY', event.box.y);
	          }
	        },
	        onmove: function onmove(event) {
	          if (event.type === 'gesturemove') {
	            vue.event = event.type;
	            vue.updateScreenCords(event, 'gesture');
	          }
	        },
	        onend: function onend(event) {
	          vue.$dispatch('gestureend', {
	            target: event.target.getAttribute('data-index')
	          });
	          console.log(event.target.getAttribute('data-index'));
	        }
	      });
	    },
	    _getSplitSize: function _getSplitSize(screen, screenWidth, screenHeight) {
	      var _this = this;
	
	      (0, _jquery2.default)(screen).css('width', screenWidth + 'px');
	      (0, _jquery2.default)(screen).css('height', screenHeight + 'px');
	
	      if (this.outLayout === 'quick') {
	        if (this.whichSplit === '2*2') {
	          var divisionX = 2;
	          var divisionY = 2;
	          this.bigWidth = screenWidth / divisionX;
	          this.bigHeight = screenHeight / divisionY;
	
	          if (this.posArray.length === 0) {
	            for (var y = 0; y < divisionY; y++) {
	              for (var x = 0; x < divisionX; x++) {
	                this.posArray.push({
	                  x: x,
	                  y: y
	                });
	              }
	            }
	          } else {
	            var counter = 0;
	            for (var _y = 0; _y < divisionY; _y++) {
	              for (var _x = 0; _x < divisionX; _x++) {
	                this.posArray[counter] = {
	                  x: _x,
	                  y: _y
	                };
	                counter++;
	              }
	            }
	          }
	
	          (0, _jquery2.default)('.resizable').width(this.bigWidth);
	          (0, _jquery2.default)('.resizable').height(this.bigHeight);
	        } else {
	          this.bigWidth = screenWidth / 3 * 2;
	          this.bigHeight = screenHeight / 3 * 2;
	          this.smallWidth = screenWidth / 3;
	          this.smallHeight = screenHeight / 3 * 1;
	          _jquery2.default.each((0, _jquery2.default)('.resizable'), function (i, val) {
	            if (val.getAttribute('data-index') === '1') {
	              val.style.width = _this.bigWidth + 'px';
	              val.style.height = _this.bigHeight + 'px';
	            } else {
	              val.style.width = _this.smallWidth + 'px';
	              val.style.height = _this.smallHeight + 'px';
	            }
	          });
	          switch (this.whichSplit) {
	            case 't':
	              this.posArray[0] = {
	                x: 0.3333 / 2,
	                y: 0
	              };
	              for (var i = 0; i < 3; i++) {
	                this.posArray[i + 1] = {
	                  x: 0.3333 * i,
	                  y: 0.6666
	                };
	              }
	              break;
	
	            case 'r':
	              this.posArray[0] = {
	                x: 0.3333,
	                y: 0.3333 / 2
	              };
	              for (var _i = 0; _i < 3; _i++) {
	                this.posArray[_i + 1] = {
	                  x: 0,
	                  y: 0.3333 * _i
	                };
	              }
	              break;
	
	            case 'b':
	              this.posArray[0] = {
	                x: 0.3333 / 2,
	                y: 0.3333
	              };
	              for (var _i2 = 0; _i2 < 3; _i2++) {
	                this.posArray[_i2 + 1] = {
	                  x: 0.3333 * _i2,
	                  y: 0
	                };
	              }
	              break;
	
	            case 'l':
	              this.posArray[0] = {
	                x: 0,
	                y: 0.3333 / 2
	              };
	              for (var _i3 = 0; _i3 < 3; _i3++) {
	                this.posArray[_i3 + 1] = {
	                  x: 0.6666,
	                  y: 0.3333 * _i3
	                };
	              }
	          }
	        }
	      } else if (this.outLayout === 'full') {} else if (this.outLayout === 'custom') {} else if (this.outLayout === 'init') {}
	    },
	    _operateCSS: function _operateCSS(screenWidth, screenHeight) {
	      var counter = this.layer.length;
	      for (var i = 0; i < this.layer.length; i++) {
	        (0, _jquery2.default)('#screen' + this.id + ' .resizable[data-index=' + this.layer[i] + ']').css({
	          'z-index': (counter - i).toString()
	        });
	      }
	      var vue = this;
	      if (this.outLayout === 'quick') {
	        var w = void 0;
	        var h = void 0;
	        _jquery2.default.each((0, _jquery2.default)('.resizable'), function (i, val) {
	          (0, _jquery2.default)(val).show();
	          var index = val.getAttribute('data-index');
	          vue._updateSplits(index, i, screenWidth, screenHeight);
	          if (vue.whichSplit === '2*2') {
	            w = vue.bigWidth;
	            h = vue.bigHeight;
	          } else {
	            w = screenWidth;
	            h = screenHeight;
	          }
	          val.style.webkitTransform = val.style.transform = 'translate(' + vue.posArray[i].x * w + 'px,' + vue.posArray[i].y * h + 'px)';
	
	          val.setAttribute('data-x', vue.posArray[i].x * w);
	          val.setAttribute('data-y', vue.posArray[i].y * h);
	        });
	      } else if (this.outLayout === 'full') {
	        var focus = this.whichSplit;
	        _jquery2.default.each((0, _jquery2.default)('.resizable'), function (i, val) {
	          (0, _jquery2.default)(val).width(screenWidth).height(screenHeight);
	          (0, _jquery2.default)(val).css({
	            transform: 'translate(0px,0px)'
	          });
	        });
	
	        var focusIndex = this.layer.indexOf(parseInt(focus));
	        var newAry = [this.layer[focusIndex]];
	        for (var key = 0; key < this.layer.length; key++) {
	          if (this.layer[key] !== this.layer[focusIndex]) newAry.push(this.layer[key]);
	        }
	        this.layer = _lodash2.default.cloneDeep(newAry);
	
	        vue._updateSplits(vue.whichSplit, null, screenWidth, screenHeight);
	      } else if (this.outLayout === 'init' || this.outLayout === 'custom') {
	        var sizeAry = [];
	        var toSmall = this.outRatio[3] / this.outRatio[2];
	        for (var windowID in this.splits) {
	          var size = {
	            width: Math.round((this.splits[windowID][2] - this.splits[windowID][0]) * toSmall),
	            height: Math.round((this.splits[windowID][3] - this.splits[windowID][1]) * toSmall)
	          };
	          sizeAry.push(size);
	        }
	        var query = '#screen' + this.id + ' .resizable';
	        _jquery2.default.each((0, _jquery2.default)(query), function (i, val) {
	          (0, _jquery2.default)(val).width(sizeAry[i].width);
	          (0, _jquery2.default)(val).height(sizeAry[i].height);
	          val.style.webkitTransform = val.style.transform = 'translate(' + Math.round(vue.splits[i + 1][0] * toSmall) + 'px,' + Math.round(vue.splits[i + 1][1] * toSmall) + 'px)';
	          (0, _jquery2.default)(val).attr('data-x', Math.round(vue.splits[i + 1][0] * toSmall));
	          (0, _jquery2.default)(val).attr('data-y', Math.round(vue.splits[i + 1][1] * toSmall));
	        });
	
	        query = '#screen' + this.id + ' .resizable[data-index=';
	
	        var _counter = this.layer.length;
	        for (var _i4 = 0; _i4 < this.layer.length; _i4++) {
	          (0, _jquery2.default)(query + this.layer[_i4] + ']').css({
	            'z-index': (_counter - _i4).toString()
	          });
	        }
	      }
	    },
	    _updateSplits: function _updateSplits(index, posIndex, screenWidth, screenHeight) {
	      var splits = _lodash2.default.cloneDeep(this.splits);
	      var toRealCords = this.outRatio[2] / this.outRatio[3];
	      var w = void 0;
	      var h = void 0;
	      if (this.outLayout === 'quick') {
	        if (this.whichSplit === '2*2') {
	          w = this.bigWidth;
	          h = this.bigHeight;
	          splits[index][0] = Math.round(this.posArray[posIndex].x * w * toRealCords);
	          splits[index][1] = Math.round(this.posArray[posIndex].y * h * toRealCords);
	          splits[index][2] = Math.round((this.posArray[posIndex].x + 1) * w * toRealCords);
	          splits[index][3] = Math.round((this.posArray[posIndex].y + 1) * h * toRealCords);
	        } else {
	          w = screenWidth;
	          h = screenHeight;
	          var inputW = index === '1' ? this.bigWidth : this.smallWidth;
	          var inputH = index === '1' ? this.bigHeight : this.smallHeight;
	
	          splits[index][0] = Math.round(this.posArray[posIndex].x * w * toRealCords);
	          splits[index][1] = Math.round(this.posArray[posIndex].y * h * toRealCords);
	          splits[index][2] = Math.round((this.posArray[posIndex].x * w + inputW) * toRealCords);
	          splits[index][3] = Math.round((this.posArray[posIndex].y * h + inputH) * toRealCords);
	        }
	      } else if (this.outLayout === 'full') {
	        for (var i in splits) {
	          splits[i][0] = splits[i][1] = 0;
	          splits[i][2] = screenWidth * toRealCords;
	          splits[i][3] = screenHeight * toRealCords;
	        }
	      }
	
	      this.splits = _lodash2.default.cloneDeep(splits);
	    },
	    renderScreen: function renderScreen() {
	      var query = '#screen' + this.id + ' .screen';
	      var query2 = '#screen' + this.id + ' .resizable';
	      (0, _jquery2.default)(query).css({ transition: 'all .5s' });
	      _jquery2.default.each((0, _jquery2.default)(query2), function (i, val) {
	        (0, _jquery2.default)(val).css({
	          transition: 'all .5s ease'
	        });
	      });
	      var screen = this.$els.screen;
	      var screenWidth = this.outRatio[0] * this.outRatio[3];
	      var screenHeight = this.outRatio[1] * this.outRatio[3];
	
	      this._getSplitSize(screen, screenWidth, screenHeight);
	      this._operateCSS(screenWidth, screenHeight);
	      setTimeout(function () {
	        (0, _jquery2.default)(query).css({ transition: '' });
	        _jquery2.default.each((0, _jquery2.default)(query2), function (i, val) {
	          (0, _jquery2.default)(val).css({
	            transition: ''
	          });
	        });
	      }, 1000);
	      this.interact();
	    },
	    updateScreenCords: function updateScreenCords(event, type) {
	      if (!type) return console.log('need to give it a type');
	      var target = event.target;
	      if (type === 'drag') {
	        var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
	        var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
	
	        target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
	
	        target.setAttribute('data-x', x);
	        target.setAttribute('data-y', y);
	
	        var width = parseInt(target.style.width.replace('px', ''));
	        var height = parseInt(target.style.height.replace('px', ''));
	
	        this.updateSplitData(target.getAttribute('data-index'), x, y, width, height);
	      } else if (type === 'resize') {
	        var limit = 10;
	
	        var screenWidth = this.outRatio[0] * this.outRatio[3];
	        var screenHeight = this.outRatio[1] * this.outRatio[3];
	
	
	        var _x2 = parseFloat(target.getAttribute('data-x')) || 0;
	        var _y2 = parseFloat(target.getAttribute('data-y')) || 0;
	
	        var _width = parseInt(target.style.width.replace('px', ''));
	        var _height = parseInt(target.style.height.replace('px', ''));
	
	        if (event.rect.width > screenWidth / limit) {
	          target.style.width = event.rect.width + 'px';
	          _width += event.deltaRect.width;
	          _x2 += event.deltaRect.left;
	          target.setAttribute('data-x', _x2);
	        }
	        if (event.rect.height > screenHeight / limit) {
	          target.style.height = event.rect.height + 'px';
	          _y2 += event.deltaRect.top;
	          _height += event.deltaRect.height;
	          target.setAttribute('data-y', _y2);
	        }
	
	        target.style.webkitTransform = target.style.transform = 'translate(' + _x2 + 'px,' + _y2 + 'px)';
	
	        this.updateSplitData(target.getAttribute('data-index'), _x2, _y2, _width, _height);
	      } else if (type === 'gesture') {
	        var _limit = 10;
	
	        var _screenWidth = this.outRatio[0] * this.outRatio[3];
	        var _screenHeight = this.outRatio[1] * this.outRatio[3];
	
	        var _x3 = parseFloat(target.getAttribute('data-x')) || 0;
	        var _y3 = parseFloat(target.getAttribute('data-y')) || 0;
	
	        var _width2 = parseInt(target.style.width.replace('px', ''));
	        var _height2 = parseInt(target.style.height.replace('px', ''));
	
	        var bPreviousX = parseInt(target.getAttribute('data-bPreviousX'));
	        var bPreviousY = parseInt(target.getAttribute('data-bPreviousY'));
	        var bWidth = parseInt(target.getAttribute('data-bWidth'));
	        var bHeight = parseInt(target.getAttribute('data-bHeight'));
	
	        if (_width2 > _screenWidth / _limit) {
	          _width2 += event.box.width - bWidth;
	          if (_width2 > _screenWidth) _width2 = _screenWidth;
	          _x3 += event.box.x - bPreviousX;
	          if (_x3 < 0) _x3 = 0;
	          if (_x3 + _width2 > _screenWidth) _x3 = _screenWidth - _width2;
	          target.style.width = _width2 + 'px';
	          target.setAttribute('data-x', _x3);
	          target.setAttribute('data-bPreviousX', event.box.x);
	          target.setAttribute('data-bWidth', event.box.width);
	        }
	        if (_height2 > _screenHeight / _limit) {
	          _height2 += event.box.height - bHeight;
	          if (_height2 > _screenHeight) _height2 = _screenHeight;
	          _y3 += event.box.y - bPreviousY;
	          if (_y3 < 0) _y3 = 0;
	          if (_y3 + _height2 > _screenHeight) _y3 = _screenHeight - _height2;
	          target.style.height = _height2 + 'px';
	          target.setAttribute('data-y', _y3);
	          target.setAttribute('data-bPreviousY', event.box.y);
	          target.setAttribute('data-bHeight', event.box.height);
	        }
	
	        target.style.webkitTransform = target.style.transform = 'translate(' + _x3 + 'px,' + _y3 + 'px)';
	
	        this.updateSplitData(target.getAttribute('data-index'), _x3, _y3, _width2, _height2);
	      }
	    },
	    updateSplitData: function updateSplitData(index, x, y) {
	      var width = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	      var height = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	
	      var splits = _lodash2.default.cloneDeep(this.splits);
	      splits[index][0] = Math.round(x * this.outRatio[2] / this.outRatio[3]);
	      splits[index][1] = Math.round(y * this.outRatio[2] / this.outRatio[3]);
	
	      var limitX = this.outRatio[0] * this.outRatio[2];
	      var limitY = this.outRatio[1] * this.outRatio[2];
	
	      if (Math.abs(Math.round((x + width) * this.outRatio[2] / this.outRatio[3]) - limitX) < 5) {
	        splits[index][2] = limitX;
	      } else {
	        splits[index][2] = Math.round((x + width) * this.outRatio[2] / this.outRatio[3]);
	      }
	
	      if (Math.abs(Math.round((y + height) * this.outRatio[2] / this.outRatio[3]) - limitY) < 5) {
	        splits[index][3] = limitY;
	      } else {
	        splits[index][3] = Math.round((y + height) * this.outRatio[2] / this.outRatio[3]);
	      }
	
	      this.splits = _lodash2.default.cloneDeep(splits);
	    }
	  }, ready: function ready() {},
	
	  watch: {
	    outRatio: function outRatio(nV) {}
	  },
	  events: {
	    render: function render(key) {
	      console.log('got render in screen', this.id);
	      if (key === this.id || key === 'all') {
	        this.renderScreen();
	      }
	    },
	    chgResolution: function chgResolution() {
	      this.outLayout = 'quick';
	      this.quickSelectSplit = '2*2';
	      this.renderScreen();
	    },
	    chgZindex: function chgZindex(newLayer, key) {
	      var query = '';
	      if (key && key === this.id || key === 'all') {
	        console.log('got chgZindex in Screen.vue' + this.id);
	        query = '#screen' + this.id + ' .resizable[data-index=';
	
	        this.layer = newLayer;
	        var counter = this.layer.length;
	        for (var i = 0; i < this.layer.length; i++) {
	          (0, _jquery2.default)(query + this.layer[i] + ']').css({
	            'z-index': (counter - i).toString()
	          });
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 633 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    showOption: {
	      type: Boolean,
	      default: true
	    },
	    options: {
	      type: Array,
	      default: []
	    },
	    output: {
	      type: String,
	      twoWay: true
	    },
	    nameProp: {
	      type: String,
	      default: 'tagTypeCheckbox'
	    }
	  },
	  components: {},
	  data: function data() {
	    return {};
	  },
	
	  computed: {},
	  asyncData: function asyncData() {},
	
	  methods: {},
	  ready: function ready() {},
	
	  events: {}
	};

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(28);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function coerceBoolean(val) {
	  return typeof val !== 'string' ? val : val === 'true' ? true : val === 'false' ? false : val === 'null' ? false : val === 'undefined' ? false : val;
	}
	
	exports.default = {
	  props: {
	    options: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    value: {
	      twoWay: true
	    },
	    placeholder: {
	      type: String,
	      default: 'Nothing Selected'
	    },
	    search: {
	      type: Boolean,
	      coerce: coerceBoolean,
	      default: false
	    },
	    closeOnSelect: {
	      type: Boolean,
	      coerce: coerceBoolean,
	      default: true
	    },
	    disabled: {
	      type: Boolean,
	      coerce: coerceBoolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      searchText: null,
	      show: false
	    };
	  },
	
	  computed: {
	    selectedItems: function selectedItems() {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.options), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = _step.value,
	              value = _step$value.value,
	              label = _step$value.label;
	
	          if (value === this.value) {
	            return label;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    },
	    showPlaceholder: function showPlaceholder() {
	      return this.value.length === 0;
	    }
	  },
	  methods: {
	    select: function select(v) {
	      this.value = v;
	      if (this.closeOnSelect) {
	        this.toggleDropdown();
	      }
	    },
	    isSelected: function isSelected(v) {
	      return this.value === v;
	    },
	    toggleDropdown: function toggleDropdown() {
	      this.show = !this.show;
	    }
	  }
	};

/***/ }),
/* 635 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var VERTICAL = 'vertical';
	var HORIZONTAL = 'horizontal';
	
	exports.default = {
	  props: {
	    direction: {
	      type: String,
	      default: VERTICAL,
	      validator: function validator(value) {
	        return [VERTICAL, HORIZONTAL].indexOf(value) > -1;
	      }
	    },
	    mousewheelControl: {
	      type: Boolean,
	      default: true
	    },
	    performanceMode: {
	      type: Boolean,
	      default: false
	    },
	    paginationVisible: {
	      type: Boolean,
	      default: false
	    },
	    paginationClickable: {
	      type: Boolean,
	      default: false
	    },
	    initialPage: {
	      type: Number,
	      default: 0
	    },
	    slideToPage: {
	      type: Number,
	      default: 0
	    },
	    modalShown: {
	      type: Boolean,
	      default: false
	    },
	    clicks: 0,
	    transitioning: {
	      type: Boolean,
	      default: false,
	      twoway: true
	    }
	  },
	  data: function data() {
	    return {
	      currentPage: 1,
	      lastPage: 1,
	      translateX: 0,
	      translateY: 0,
	      startTranslateX: 0,
	      startTranslateY: 0,
	      delta: 0,
	      dragging: false,
	      startPos: null,
	      slideEls: [],
	      disabling: false,
	      arrowClicked: false
	    };
	  },
	  ready: function ready() {
	    var _this = this;
	
	    this._onTouchMove = this._onTouchMove.bind(this);
	    this._onTouchEnd = this._onTouchEnd.bind(this);
	    this.slideEls = this.$els.swiperWrap.children;
	    var initUnWatcher = this.$watch('initialPage', function (newPage) {
	      if (_this.slideEls.length) {
	        _this._addTwoFake();
	        _this.setPage(newPage);
	      } else {
	        _this.firstSetPage(newPage);
	      }
	      initUnWatcher();
	    });
	  },
	
	  watch: {
	    modalShown: function modalShown(nV) {
	      if (nV) this.setPage(this.slideToPage);
	    },
	    currentPage: function currentPage(nV, v) {
	      if (nV > this.slideEls.length - 2) {
	        this.setPage(this.slideEls.length - 2);
	      } else if (nV < -1) {
	        this.setPage(-1);
	      }
	    }
	  },
	  methods: {
	    handledblClick: function handledblClick() {
	      var _this2 = this;
	
	      this.$dispatch('alert', {
	        type: 'danger',
	        title: '',
	        content: 'Please slow down your click.'
	      });
	      this.arrowClicked = true;
	      setTimeout(function () {
	        _this2.arrowClicked = false;
	      }, 5000);
	    },
	    firstSetPage: function firstSetPage(toPage) {
	      var _this3 = this;
	
	      if (this.transitioning) return;
	      setTimeout(function () {
	        if (_this3.slideEls.length) {
	          _this3._addTwoFake();
	          _this3.setPage(toPage);
	        } else {
	          _this3.firstSetPage(toPage);
	        }
	      }, 1000);
	    },
	    next: function next() {
	      var page = this.currentPage;
	      this.setPage(++page);
	    },
	    prev: function prev() {
	      var page = this.currentPage;
	      this.setPage(--page);
	    },
	    setPage: function setPage(page) {
	      this.transitioning = true;
	      var propName = void 0,
	          translateName = void 0;
	      this.lastPage = this.currentPage;
	      this.currentPage = page;
	
	      if (this.isHorizontal()) {
	        propName = 'clientWidth';
	        translateName = 'translateX';
	      } else {
	        propName = 'clientHeight';
	        translateName = 'translateY';
	      }
	      this[translateName] = -[].reduce.call(this.slideEls, function (total, el, i) {
	        return i > page ? total : total + el[propName];
	      }, 0);
	      this.transitioning = false;
	      this._onTransitionStart();
	    },
	    isHorizontal: function isHorizontal() {
	      return this.direction === HORIZONTAL;
	    },
	    isVertical: function isVertical() {
	      return this.direction === VERTICAL;
	    },
	    _addTwoFake: function _addTwoFake() {
	      var head = this.slideEls[this.slideEls.length - 1].cloneNode(true);
	      var tail = this.slideEls[0].cloneNode(true);
	      this.$els.swiperWrap.insertBefore(head, this.slideEls[0]);
	      this.$els.swiperWrap.appendChild(tail);
	    },
	    _onTouchStart: function _onTouchStart(e) {
	      if (this.transitioning) return;
	      if (this.currentPage > this.slideEls.length - 3 || this.currentPage < 0) return;
	      this.startPos = this._getTouchPos(e);
	      this.delta = 0;
	      this.startTranslateX = this.translateX;
	      this.startTranslateY = this.translateY;
	      this.startTime = new Date().getTime();
	      this.dragging = true;
	
	      document.addEventListener('touchmove', this._onTouchMove, false);
	      document.addEventListener('touchend', this._onTouchEnd, false);
	      document.addEventListener('mousemove', this._onTouchMove, false);
	      document.addEventListener('mouseup', this._onTouchEnd, false);
	    },
	    _onTouchMove: function _onTouchMove(e) {
	      if (this.transitioning) return;
	      this.delta = this._getTouchPos(e) - this.startPos;
	
	      if (!this.performanceMode) {
	        if (this.isHorizontal()) {
	          this.translateX = this.startTranslateX + this.delta;
	          this.$emit('slider-move', this.translateX);
	        } else {
	          this.translateY = this.startTranslateY + this.delta;
	          this.$emit('slider-move', this.translateY);
	        }
	      }
	    },
	    _onTouchEnd: function _onTouchEnd(e) {
	      this.dragging = false;
	      var isQuickAction = new Date().getTime() - this.startTime < 1000;
	      if (this.delta < -100 || isQuickAction && this.delta < -15) {
	        this.next();
	      } else if (this.delta > 100 || isQuickAction && this.delta > 15) {
	        this.prev();
	      } else {
	        this._revert();
	      }
	
	      document.removeEventListener('touchmove', this._onTouchMove);
	      document.removeEventListener('touchend', this._onTouchEnd);
	      document.removeEventListener('mousemove', this._onTouchMove);
	      document.removeEventListener('mouseup', this._onTouchEnd);
	    },
	    _onWheel: function _onWheel(e) {
	      if (this.mousewheelControl) {
	        if (!this.transitioning) {
	          if (e.deltaY > 0) {
	            this.next();
	          } else {
	            this.prev();
	          }
	        }
	        if (this._isPageChanged()) e.preventDefault();
	      }
	    },
	    _revert: function _revert() {
	      this.setPage(this.currentPage);
	    },
	    _getTouchPos: function _getTouchPos(e) {
	      var key = this.isHorizontal() ? 'pageX' : 'pageY';
	      return e.changedTouches ? e.changedTouches[0][key] : e[key];
	    },
	    _onTransitionStart: function _onTransitionStart() {
	      this.arrowClicked = true;
	      this.transitioning = true;
	      if (this._isPageChanged()) {
	        this.$emit('slide-change-start', this.currentPage);
	      } else {
	        this.$emit('slide-revert-start', this.currentPage);
	      }
	      this.transitioning = false;
	    },
	    _onTransitionEnd: function _onTransitionEnd(e) {
	      this.transitioning = true;
	      if (e.propertyName !== 'transform') {
	        this.transitioning = false;
	        return;
	      }
	      if (this._isPageChanged()) {
	        if (this.currentPage === this.slideEls.length - 2) {
	          this.$els.swiperWrap.classList.add('__notransition');
	          this.disabling = true;
	          this.setPage(0);
	          this.transitioning = false;
	          return;
	        }
	        if (this.currentPage === -1) {
	          this.$els.swiperWrap.classList.add('__notransition');
	          this.disabling = true;
	          this.setPage(this.slideEls.length - 3);
	          this.transitioning = false;
	          return;
	        }
	
	        if (this.disabling) {
	          this.disabling = false;
	          this.$els.swiperWrap.classList.remove('__notransition');
	        }
	        this.$emit('slide-change-end', this.currentPage);
	      } else {
	        this.$emit('slide-revert-end', this.currentPage);
	      }
	      this.transitioning = false;
	      this.arrowClicked = false;
	    },
	    _isPageChanged: function _isPageChanged() {
	      return this.lastPage !== this.currentPage;
	    }
	  }
	};

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(616);
	
	exports.default = {
	  components: {},
	  props: {
	    navStyle: {
	      type: String,
	      default: 'tabs'
	    },
	    effect: {
	      type: String,
	      default: 'fadein'
	    },
	    active: {
	      type: Number,
	      coerce: _utils.coerce.number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      show: null,
	      headers: [],
	      tabs: []
	    };
	  },
	  created: function created() {
	    this._tabset = true;
	  },
	
	  watch: {
	    active: function active(val) {
	      this.show = this.tabs[val];
	    }
	  },
	  ready: function ready() {
	    this.show = this.tabs[this.active];
	  },
	
	  methods: {
	    select: function select(tab) {
	      if (!tab.disabled) {
	        this.active = tab.index;
	      }
	    }
	  }
	};

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(119);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _interact2 = __webpack_require__(361);
	
	var _interact3 = _interopRequireDefault(_interact2);
	
	var _jquery = __webpack_require__(21);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Service = __webpack_require__(8);
	
	var _vuex = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FROM_RESIZE = 'fromResize';
	var FROM_GESTURE = 'fromGesture';
	var FROM_DRAG = 'fromDrag';
	
	exports.default = {
	  components: {},
	  props: {
	    showLink: {
	      type: Boolean,
	      default: false
	    },
	    inWhichPage: {
	      type: String,
	      default: 'status' },
	    id: {
	      type: String,
	      default: '1'
	    },
	    showPsOut: {
	      type: Boolean,
	      default: false
	    },
	    showPsIn: {
	      type: Boolean,
	      default: false
	    },
	    imgs: {
	      type: Array,
	      default: function _default() {
	        return ['', __webpack_require__(174), __webpack_require__(175), __webpack_require__(254), __webpack_require__(255)];
	      }
	    },
	    editable: {
	      type: Boolean,
	      default: true
	    },
	    apply: {
	      type: Function,
	      default: function _default() {}
	    },
	    resizeEvent: {
	      type: Object,
	      default: function _default() {
	        return {};
	      },
	
	      twoway: true
	    }
	  },
	  data: function data() {
	    return {
	      posArray: [],
	      bigWidth: 0,
	      bigHeight: 0,
	      smallWidth: 0,
	      smallHeight: 0,
	      event: {},
	      box: {},
	      outLayout: 'init'
	    };
	  },
	  asyncData: function asyncData() {},
	
	  computed: (0, _extends3.default)({
	    inProfile: function inProfile() {
	      return this.inWhichPage === 'preset';
	    },
	    inLayout: function inLayout() {
	      return this.inWhichPage === 'layout';
	    },
	    inStatus: function inStatus() {
	      return this.inWhichPage === 'status';
	    }
	  }, (0, _vuex.mapGetters)({
	    splits: 'getSplitArea',
	    profiles: 'getProfiles',
	    computedSplit: 'getComputedSplit',
	    outResolutionOptions: 'getOutResolutionOptions',
	    outResolution: 'getOutResolutions',
	    inResolution: 'getInResolution',
	    isFetching: 'getIsFetching',
	    inRatio: 'getInRatio',
	    windowFocus: 'getWindowFocus',
	    focus1: 'isFocus1',
	    focus2: 'isFocus2',
	    focus3: 'isFocus3',
	    focus4: 'isFocus4',
	    is4K: 'getIsInput4k',
	    presetRatios: 'getPresetRatios'
	  })),
	  methods: {
	    toFocus: function toFocus(windowFocus) {
	      this.$store.commit('UPDATE', { type: 'winFocus', windowFocus: windowFocus });
	    },
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    handleShowWindow: function handleShowWindow() {
	      this.showWindowConfig = true;
	    },
	    interact: function interact() {
	      var vue = this;
	      var screen = this.$els.screen;
	
	      (0, _interact3.default)('.focus').resizable({
	        inertia: false,
	        preserveAspectRatio: false,
	
	        edges: {
	          left: true,
	          right: true,
	          bottom: true,
	          top: true
	        },
	        restrict: {
	          restriction: screen,
	          endOnly: false
	        },
	        snap: {
	          targets: [_interact3.default.createSnapGrid({ x: 5, y: 5 })],
	          range: Infinity,
	          relativePoints: [{ x: 0, y: 0 }]
	        },
	        enabled: true,
	        invert: 'none',
	        onmove: function onmove(event) {
	          if (event.type === 'resizemove') {
	            vue.updateScreenCords(event, 'resize');
	          }
	        },
	        onend: function onend(event) {
	          if (event.type === 'resizeend') {
	            vue.updateScreenCords(event, 'update', FROM_RESIZE);
	          }
	        }
	      }).draggable({
	        inertia: false,
	
	        restrict: {
	          restriction: screen,
	          endOnly: true,
	          elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
	        },
	        snap: {
	          targets: [_interact3.default.createSnapGrid({ x: 5, y: 5 })],
	          range: Infinity,
	          relativePoints: [{ x: 0, y: 0 }]
	        },
	        autoScroll: false,
	        onstart: function onstart(event) {},
	        onmove: function onmove(event) {
	          if (event.type === 'dragmove') {
	            vue.updateScreenCords(event, 'drag');
	          }
	        },
	        onend: function onend(event) {
	          console.log('drag end');
	          if (event.type === 'dragend') {
	            vue.updateScreenCords(event, 'update', FROM_DRAG);
	          }
	        }
	      }).gesturable({
	        restrict: {
	          restriction: screen,
	          endOnly: true
	        },
	        maxPerElement: 1,
	        onstart: function onstart(event) {
	          if (event.type === 'gesturestart') {
	            vue.event = event.type;
	            var target = event.target;
	
	            target.setAttribute('data-bWidth', event.box.width);
	            target.setAttribute('data-bHeight', event.box.height);
	            target.setAttribute('data-bPreviousX', event.box.x);
	            target.setAttribute('data-bPreviousY', event.box.y);
	          }
	        },
	        onmove: function onmove(event) {
	          if (event.type === 'gesturemove') {
	            vue.event = event.type;
	            vue.updateScreenCords(event, 'gesture');
	          }
	        },
	        onend: function onend(event) {
	          if (event.type === 'gestureend') {
	            vue.updateScreenCords(event, 'update', FROM_GESTURE);
	          }
	        }
	      });
	    },
	    _getSplitSize: function _getSplitSize(screen, screenWidth, screenHeight) {
	      (0, _jquery2.default)(screen).css('width', screenWidth + 'px');
	      (0, _jquery2.default)(screen).css('height', screenHeight + 'px');
	
	      if (this.outLayout === 'quick') {} else if (this.outLayout === 'full') {} else if (this.outLayout === 'custom') {} else if (this.outLayout === 'init') {}
	    },
	    _operateCSS: function _operateCSS(screenWidth, screenHeight) {
	      if (this.outLayout === 'quick') {} else if (this.outLayout === 'full') {} else if (this.outLayout === 'init' || this.outLayout === 'custom') {
	        var targetSplits = {};
	
	        if (this.inProfile) {
	          targetSplits = this.profiles[this.id].split;
	        } else {
	          targetSplits = this.splits;
	        }
	        var sizeAry = [];
	        var toSmall = this.inProfile ? this.presetRatios[this.id][3] / this.presetRatios[this.id][2] : this.inRatio[3] / this.inRatio[2];
	        for (var windowID in targetSplits) {
	          var size = {
	            width: Math.round((targetSplits[windowID][2] - targetSplits[windowID][0]) * toSmall),
	            height: Math.round((targetSplits[windowID][3] - targetSplits[windowID][1]) * toSmall)
	          };
	          sizeAry.push(size);
	        }
	        var query = '#screen' + this.id + ' .resizable';
	
	        _jquery2.default.each((0, _jquery2.default)(query), function (i, val) {
	          if (sizeAry.length !== 0) {
	            (0, _jquery2.default)(val).width(sizeAry[i].width);
	            (0, _jquery2.default)(val).height(sizeAry[i].height);
	            val.style.webkitTransform = val.style.transform = 'translate(' + Math.round(targetSplits[i + 1][0] * toSmall) + 'px,' + Math.round(targetSplits[i + 1][1] * toSmall) + 'px)';
	            (0, _jquery2.default)(val).attr('data-x', Math.round(targetSplits[i + 1][0] * toSmall));
	            (0, _jquery2.default)(val).attr('data-y', Math.round(targetSplits[i + 1][1] * toSmall));
	          }
	        });
	      }
	    },
	    renderScreen: function renderScreen() {
	      console.log('haha renderScreen', this.id);
	      this.$store.commit('UPDATE', {
	        type: 'inRatio'
	      });
	      var query = '#screen' + this.id + ' .screen';
	      var query2 = '#screen' + this.id + ' .resizable';
	      (0, _jquery2.default)(query).css({ transition: 'all .3s' });
	      _jquery2.default.each((0, _jquery2.default)(query2), function (i, val) {
	        (0, _jquery2.default)(val).css({
	          transition: 'all .7s ease'
	        });
	      });
	      var screen = this.$els.screen;
	      var screenWidth = this.inRatio[0] * this.inRatio[3];
	      var screenHeight = this.inRatio[1] * this.inRatio[3];
	
	      this._getSplitSize(screen, screenWidth, screenHeight);
	      this._operateCSS(screenWidth, screenHeight);
	      setTimeout(function () {
	        (0, _jquery2.default)(query).css({ transition: '' });
	        _jquery2.default.each((0, _jquery2.default)(query2), function (i, val) {
	          (0, _jquery2.default)(val).css({
	            transition: ''
	          });
	        });
	      }, 1000);
	      this.interact();
	    },
	    updateScreenCords: function updateScreenCords(event, type, from) {
	      if (!type) return console.log('need to give it a type');
	      var target = event.target;
	
	      if (type === 'drag') {
	        var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
	        var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
	
	        target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
	
	        target.setAttribute('data-x', x);
	        target.setAttribute('data-y', y);
	
	        var width = parseInt(target.style.width.replace('px', ''));
	        var height = parseInt(target.style.height.replace('px', ''));
	
	        this.updateSplitData(target.getAttribute('data-index'), x, y, width, height);
	      } else if (type === 'resize') {
	        var limit = 10;
	
	        var screenWidth = this.inRatio[0] * this.inRatio[3];
	        var screenHeight = this.inRatio[1] * this.inRatio[3];
	
	
	        var _x = parseFloat(target.getAttribute('data-x')) || 0;
	        var _y = parseFloat(target.getAttribute('data-y')) || 0;
	
	        var _width = parseInt(target.style.width.replace('px', ''));
	        var _height = parseInt(target.style.height.replace('px', ''));
	
	        if (event.rect.width > screenWidth / limit) {
	          target.style.width = event.rect.width + 'px';
	          _width += event.deltaRect.width;
	          _x += event.deltaRect.left;
	
	          if (_x + _width > screenWidth) _width = screenWidth - _x;
	
	          target.setAttribute('data-x', _x);
	        }
	        if (event.rect.height > screenHeight / limit) {
	          target.style.height = event.rect.height + 'px';
	          _height += event.deltaRect.height;
	          _y += event.deltaRect.top;
	
	          if (_y + _height > screenHeight) _height = screenHeight - _y;
	
	          target.setAttribute('data-y', _y);
	        }
	
	        target.style.webkitTransform = target.style.transform = 'translate(' + _x + 'px,' + _y + 'px)';
	
	        this.updateSplitData(target.getAttribute('data-index'), _x, _y, _width, _height);
	      } else if (type === 'gesture') {
	        var _limit = 10;
	
	        var _screenWidth = this.inRatio[0] * this.inRatio[3];
	        var _screenHeight = this.inRatio[1] * this.inRatio[3];
	
	        var _x2 = parseFloat(target.getAttribute('data-x')) || 0;
	        var _y2 = parseFloat(target.getAttribute('data-y')) || 0;
	
	        var _width2 = parseInt(target.style.width.replace('px', ''));
	        var _height2 = parseInt(target.style.height.replace('px', ''));
	
	        var bPreviousX = parseInt(target.getAttribute('data-bPreviousX'));
	        var bPreviousY = parseInt(target.getAttribute('data-bPreviousY'));
	        var bWidth = parseInt(target.getAttribute('data-bWidth'));
	        var bHeight = parseInt(target.getAttribute('data-bHeight'));
	
	        if (_width2 > _screenWidth / _limit) {
	          _width2 += event.box.width - bWidth;
	          if (_width2 > _screenWidth) _width2 = _screenWidth;
	          _x2 += event.box.x - bPreviousX;
	          if (_x2 < 0) _x2 = 0;
	          if (_x2 + _width2 > _screenWidth) _x2 = _screenWidth - _width2;
	          target.style.width = _width2 + 'px';
	          target.setAttribute('data-x', _x2);
	          target.setAttribute('data-bPreviousX', event.box.x);
	          target.setAttribute('data-bWidth', event.box.width);
	        }
	        if (_height2 > _screenHeight / _limit) {
	          _height2 += event.box.height - bHeight;
	          if (_height2 > _screenHeight) _height2 = _screenHeight;
	          _y2 += event.box.y - bPreviousY;
	          if (_y2 < 0) _y2 = 0;
	          if (_y2 + _height2 > _screenHeight) _y2 = _screenHeight - _height2;
	          target.style.height = _height2 + 'px';
	          target.setAttribute('data-y', _y2);
	          target.setAttribute('data-bPreviousY', event.box.y);
	          target.setAttribute('data-bHeight', event.box.height);
	        }
	
	        target.style.webkitTransform = target.style.transform = 'translate(' + _x2 + 'px,' + _y2 + 'px)';
	
	        this.updateSplitData(target.getAttribute('data-index'), _x2, _y2, _width2, _height2);
	      } else if (type === 'update') {
	        if (this.is4K) {
	          this.$store.commit('check4KLimit', {
	            index: this.windowFocus,
	            type: from
	          });
	        }
	        this.applySplitData();
	      }
	    },
	    applySplitData: function applySplitData() {
	      var _this = this;
	
	      (0, _Service.call)(this.$route.params.mac, 'dxSetSplitArea', {
	        split: (0, _defineProperty3.default)({}, this.windowFocus, this.splits[this.windowFocus])
	      }).then(function (res) {
	        console.log('res in drag end', res);
	        _this.setLayoutChanged(true);
	      }).catch(function (err) {
	        console.error('err in drag end', err);
	      });
	    },
	    updateSplitData: function updateSplitData(index, x, y) {
	      var width = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	      var height = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	
	      var splits = _lodash2.default.cloneDeep(this.splits);
	
	      splits[index][0] = Math.round(x * this.inRatio[2] / this.inRatio[3]);
	      splits[index][1] = Math.round(y * this.inRatio[2] / this.inRatio[3]);
	
	      var limitX = this.inRatio[0] * this.inRatio[2];
	      var limitY = this.inRatio[1] * this.inRatio[2];
	
	      if (Math.abs(Math.round((x + width) * this.inRatio[2] / this.inRatio[3]) - limitX) < 5) {
	        splits[index][2] = limitX;
	      } else {
	        splits[index][2] = Math.round((x + width) * this.inRatio[2] / this.inRatio[3]);
	      }
	
	      if (Math.abs(Math.round((y + height) * this.inRatio[2] / this.inRatio[3]) - limitY) < 5) {
	        splits[index][3] = limitY;
	      } else {
	        splits[index][3] = Math.round((y + height) * this.inRatio[2] / this.inRatio[3]);
	      }
	
	      if (splits[index][0] < 0) splits[index][0] = 0;
	      if (splits[index][1] < 0) splits[index][1] = 0;
	
	      this.$store.commit('UPDATE', {
	        type: 'split',
	        splitArea: {
	          split: splits
	        }
	      });
	    },
	    setLayoutChanged: function setLayoutChanged(changed) {
	      this.$store.commit('UPDATE', {
	        type: 'layoutChanged',
	        isLayoutChanged: changed
	      });
	    }
	  }, ready: function ready() {},
	
	  watch: {
	    inRatio: function inRatio(nV) {}
	  },
	  events: {
	    render: function render(key) {
	      if (key === this.id || key === 'all') {
	        this.renderScreen();
	      }
	    },
	    chgResolution: function chgResolution() {
	      this.outLayout = 'quick';
	      this.quickSelectSplit = '2*2';
	      this.renderScreen();
	    }
	  }
	};

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _multiselectMixin = __webpack_require__(612);
	
	var _multiselectMixin2 = _interopRequireDefault(_multiselectMixin);
	
	var _pointerMixin = __webpack_require__(613);
	
	var _pointerMixin2 = _interopRequireDefault(_pointerMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_multiselectMixin2.default, _pointerMixin2.default],
	  props: {
	    optionPartial: {
	      type: String,
	      default: ''
	    },
	
	    selectLabel: {
	      type: String,
	      default: 'Press enter to select'
	    },
	
	    selectedLabel: {
	      type: String,
	      default: 'Selected'
	    },
	
	    deselectLabel: {
	      type: String,
	      default: 'Press enter to remove'
	    },
	
	    showLabels: {
	      type: Boolean,
	      default: true
	    },
	
	    limit: {
	      type: Number,
	      default: 99999
	    },
	
	    limitText: {
	      type: Function,
	      default: function _default(count) {
	        return 'and ' + count + ' more';
	      }
	    },
	
	    loading: {
	      type: Boolean,
	      default: false
	    },
	
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    visibleValue: function visibleValue() {
	      return this.multiple ? this.value.slice(0, this.limit) : [];
	    }
	  },
	  ready: function ready() {
	    if (!this.showLabels) {
	      this.deselectLabel = this.selectedLabel = this.selectLabel = '';
	    }
	  }
	};

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(54);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(53);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _Service = __webpack_require__(8);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _vueStrap = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal
	  },
	  data: function data() {
	    return {
	      account: '',
	      password: '',
	      newUser: {
	        email: '',
	        pwd: '',
	        confirmPwd: ''
	      },
	      forgottenMail: '',
	      showNewAccount: false,
	      showForgetPw: false,
	      showMailHint: false,
	      showMailResend: false,
	      emailResendTarget: null
	    };
	  },
	  methods: {
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    login: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var loginRes;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return _Service2.default.login(this.account, this.password);
	
	              case 3:
	                loginRes = _context.sent;
	
	                if (loginRes.emailVerified || loginRes.email === 'joe@gmail.com' || loginRes.email === 'installer@gmail.com' || loginRes.email === 'eagleyestest2017@gmail.com' || loginRes.email === 'scptest@gomax-electronics.com.tw') {
	                  this.$router.go('/');
	                  this.alert('success', '', 'Login Success');
	                } else {
	                  this.showMailResend = true;
	                  this.emailResendTarget = loginRes;
	                }
	                _context.next = 10;
	                break;
	
	              case 7:
	                _context.prev = 7;
	                _context.t0 = _context['catch'](0);
	
	                this.alert('danger', 'Login Fail', _context.t0);
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[0, 7]]);
	      }));
	
	      function login() {
	        return _ref.apply(this, arguments);
	      }
	
	      return login;
	    }(),
	    resendMail: function resendMail() {
	      this.emailResendTarget.sendEmailVerification();
	      this.showMailResend = false;
	    },
	    closeDialogs: function closeDialogs() {
	      this.showMailHint = false;
	      this.showMailResend = false;
	    },
	    handleNewAccount: function handleNewAccount() {
	      var _this = this;
	
	      if (this.$newAccValidator.newemail.valid) {
	        if (this.newUser.pwd !== this.newUser.confirmPwd) {
	          this.alert('danger', 'Error', 'Two passwords must be same.');
	        } else {
	          _Service2.default.createUser(this.newUser.email, this.newUser.pwd).then(function (userCredential) {
	            console.log(userCredential);
	            userCredential.sendEmailVerification();
	            _this.account = _this.newUser.email;
	            _this.password = '';
	            _this.showNewAccount = false;
	            _this.showMailHint = true;
	          }).catch(function (err) {
	            _this.alert('danger', 'Error', err.message);
	          });
	        }
	      } else {
	        this.alert('danger', 'Error', 'Please enter a valid email address');
	      }
	    },
	    handleForget: function handleForget() {
	      var _this2 = this;
	
	      if (this.forgottenMail === 'joe@gmail.com' || this.forgottenMail === 'installer@gmail.com') {
	        return this.alert('danger', 'Error', 'Cannot reset joe and installer.');
	      } else if (this.$forgetPw.email.valid) {
	        _Service2.default.resetPassword(this.forgottenMail).then(function (res) {
	          _this2.showForgetPw = false;
	          _this2.alert('success', '', 'Your password has been reset successfully. Please check your email for more detail.');
	        }).catch(function (err) {
	          _this2.alert('danger', 'Error', err);
	        });
	      } else {
	        return this.alert('danger', 'Error', 'Please enter a valid email address');
	      }
	    }
	  },
	  watch: {
	    showNewAccount: function showNewAccount(show) {
	      if (show) {
	        this.newUser.email = '';
	        this.newUser.pwd = '';
	        this.newUser.confirmPwd = '';
	      }
	    },
	    showForgetPw: function showForgetPw(show) {
	      if (show) {
	        this.forgottenMail = '';
	      }
	    }
	  }
	};

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueStrap = __webpack_require__(12);
	
	var _Tabset = __webpack_require__(258);
	
	var _Tabset2 = _interopRequireDefault(_Tabset);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal,
	    tab: _vueStrap.tab,
	    'tabs': _Tabset2.default
	  },
	  data: function data() {
	    return {
	      showM2M: false,
	      showEvents: false,
	      showActions: false,
	      showEmail: false,
	      showSMS: false,
	      editing: {
	        title: '',
	        m2m: {},
	        events: {},
	        actions: {},
	        email: {},
	        SMS: {}
	      },
	      m2m_details: [{
	        id: '1',
	        name: 'Matrix failover',
	        detail: 'Reset matrix\'s power if disconnected',
	        event: 'Matrix disconnected',
	        actions: ['Power reset']
	      }, {
	        id: '2',
	        name: 'DVD protect',
	        detail: 'When DVD over-current, POW-1109 will power off bank1, then power on bank3. Finally 5588-H will remap from DVD to PS4.',
	        event: 'DVD over-current',
	        actions: ['Matrix remapping', 'DVD power off', 'PS4 power on']
	      }],
	      events_details: [{
	        id: '1',
	        name: 'Matrix failover',
	        detail: 'A11-8F Control Room',
	        device: '5588-H',
	        event: 'Connection === OFF'
	      }, {
	        id: '2',
	        name: 'DVD over-current',
	        detail: 'A11-B1F Power Center',
	        device: 'POW-109',
	        event: 'Current >= 3A of Bank1'
	      }],
	      actions_details: [{
	        id: '1',
	        name: 'Matrix remapping',
	        detail: 'A11-8F Control Room',
	        device: '5588-H',
	        action: 'Remapping (output1, output2)'
	      }, {
	        id: '2',
	        name: 'Power reset',
	        detail: 'A11-B1F Power Center',
	        device: 'POW-109',
	        action: 'Power RESET at Bank1'
	      }, {
	        id: '3',
	        name: 'DVD power off',
	        detail: 'A11-B1F Power Center',
	        device: 'POW-109',
	        action: 'Power OFF at Bank2'
	      }, {
	        id: '4',
	        name: 'PS4 power on',
	        detail: 'A11-B1F Power Center',
	        device: 'POW-109',
	        action: 'Power ON at Bank3'
	      }],
	      email_details: [{
	        id: '1',
	        group: 'Admin',
	        emails: ['admin@gmail.com', 'intrising@gmail.com']
	      }, {
	        id: '2',
	        group: 'Mis',
	        emails: ['mis@gmail.com', 'joe@gmail.com']
	      }],
	      SMS_details: [{
	        id: '1',
	        group: 'Admin',
	        phones: ['+886-972123456']
	      }, {
	        id: '2',
	        group: 'Manager',
	        phones: ['+886-932123456', '+886-012123456']
	      }]
	    };
	  },
	  asyncData: function asyncData() {},
	
	  computed: {},
	  methods: {
	    handleShowM2M: function handleShowM2M(key) {
	      this.editing.m2m = _lodash2.default.cloneDeep(this.m2m_details[key]);
	      this.editing.title = 'M2M ' + this.editing.m2m.id + ' Config';
	      this.showM2M = true;
	    },
	    handleShowEvents: function handleShowEvents(key) {
	      this.editing.events = _lodash2.default.cloneDeep(this.events_details[key]);
	      this.editing.title = 'Event ' + this.editing.events.id + ' Config';
	      this.showEvents = true;
	    },
	    handleShowActions: function handleShowActions(key) {
	      this.editing.actions = _lodash2.default.cloneDeep(this.actions_details[key]);
	      this.editing.title = 'Actions ' + this.editing.actions.id + ' Config';
	      this.showActions = true;
	    },
	    handleShowEmail: function handleShowEmail(key) {
	      this.editing.email = _lodash2.default.cloneDeep(this.email_details[key]);
	      this.editing.title = 'Email ' + this.editing.email.id + ' Config';
	      this.showEmail = true;
	    },
	    handleShowSMS: function handleShowSMS(key) {
	      this.editing.SMS = _lodash2.default.cloneDeep(this.SMS_details[key]);
	      this.editing.title = 'SMS ' + this.editing.SMS.id + ' Config';
	      this.showSMS = true;
	    }
	  }, ready: function ready() {},
	
	  watch: {}
	};

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Service = __webpack_require__(8);
	
	exports.default = {
	  data: function data() {
	    return {
	      user: {}
	    };
	  },
	  ready: function ready() {},
	
	  computed: {},
	  asyncData: function asyncData() {
	    this.user = (0, _Service.getUser)();
	  },
	
	  methods: {
	    handleAddDevice: function handleAddDevice() {
	      this.$root.$broadcast('add_device', this.user);
	    }
	  },
	  events: {
	    user: function user(uid, _user) {
	      this.user = _user;
	      this.user.uid = uid;
	    }
	  }
	};

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getIterator2 = __webpack_require__(28);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(22);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vueStrap = __webpack_require__(12);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Multiselect = __webpack_require__(531);
	
	var _Multiselect2 = _interopRequireDefault(_Multiselect);
	
	var _SingleSelect = __webpack_require__(26);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _Service = __webpack_require__(8);
	
	var _SingleBanks = __webpack_require__(529);
	
	var _SingleBanks2 = _interopRequireDefault(_SingleBanks);
	
	var _MultiBanks = __webpack_require__(178);
	
	var _MultiBanks2 = _interopRequireDefault(_MultiBanks);
	
	var _emailValidator = __webpack_require__(359);
	
	var _jquery = __webpack_require__(21);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal,
	    tab: _vueStrap.tab,
	    'tabs': _vueStrap.tabset,
	    'v-select': _Multiselect2.default,
	    'v-single-select': _SingleSelect2.default,
	    'v-bank': _SingleBanks2.default,
	    'v-multi-banks': _MultiBanks2.default
	  },
	  data: function data() {
	    return {
	      DIs: {},
	      DOs: {},
	      showGroupConfig: false,
	      showGroupConfigTable: false,
	      editingGroup: {
	        _id: '',
	        format: '',
	        title: '',
	        data: {},
	        cb: function cb() {}
	      },
	      editing: {
	        title: 'Event Config',
	        index: '',
	        newEvent: {
	          name: '',
	          enabled: '',
	          key: '',
	          condition: '=',
	          value: '',
	          newSource: ''
	        },
	        actionKeys: [],
	        newActions: []
	      },
	
	      conditions: [{ label: '=', value: '=' }],
	      eventOptions: [{ label: 'DI', value: 'DI' }],
	      eventValueOptions: [{ label: 'From Off to On', value: 'Low2High' }, { label: 'From On to Off', value: 'High2Low' }],
	      events: {},
	      showModal: false,
	      newActions: [],
	      actions: {
	        high: {
	          action: 'DO High',
	          targets: []
	        },
	        low: {
	          action: 'DO Low',
	          targets: []
	        }
	      },
	
	      emailGroups: {
	        selected: [],
	        options: []
	      },
	
	      SMSGroups: {
	        selected: [],
	        options: []
	      },
	
	      emailData: {},
	
	      SMSData: {},
	      singleNumberValid: false
	    };
	  },
	
	  computed: {
	    sourceOptions: function sourceOptions() {
	      var options = [];
	      for (var key in this.DIs) {
	        options.push({
	          label: '[DI' + key + '] ' + this.DIs[key].name,
	          value: '' + key
	        });
	      }
	      return options;
	    },
	    targetOptions: function targetOptions() {
	      var options = [];
	      for (var key in this.DOs) {
	        options.push({
	          label: '[DO' + key + ']' + this.DOs[key].name,
	          value: '' + key
	        });
	      }
	      return options;
	    }
	  },
	  asyncData: function asyncData() {
	    var _this = this;
	
	    var mac = this.$route.params.mac;
	
	    return (0, _Service.call)(mac, 'dxGetDIOStatus').then(function (_ref) {
	      var channels = _ref.channels;
	
	      _this.DIs = channels.DIs;
	      _this.DOs = channels.DOs;
	      return (0, _Service.call)(mac, 'dxGetEvents');
	    }).then(function (_ref2) {
	      var entries = _ref2.entries;
	
	      _this.events = _lodash2.default.cloneDeep(entries);
	      return (0, _Service.call)(mac, 'dxGetEmailGroups');
	    }).then(function (_ref3) {
	      var entries = _ref3.entries;
	
	      for (var key in entries) {
	        if (entries[key].accounts.length !== 0) {
	          _this.emailGroups.options.push(entries[key].name);
	        }
	      }
	      _this.emailData = _lodash2.default.cloneDeep(entries);
	      return (0, _Service.call)(mac, 'dxGetSMSGroups');
	    }).then(function (_ref4) {
	      var entries = _ref4.entries;
	
	      for (var key in entries) {
	        if (entries[key].accounts.length !== 0) {
	          _this.SMSGroups.options.push(entries[key].name);
	        }
	      }
	      _this.SMSData = _lodash2.default.cloneDeep(entries);
	    }).catch(function (err) {
	      _this.alert('danger', 'Error', err.message);
	    });
	  },
	
	  methods: {
	    clickGroups: function clickGroups(which) {
	      var group = which === 'Email' ? this.emailGroups : this.SMSGroups;
	
	      if (this.newActions.indexOf(which) === -1) {
	        this.newActions.push(which);
	        group.selected = [group.options[0]];
	      } else {
	        this.newActions.splice(this.newActions.indexOf(which), 1);
	        group.selected = [];
	      }
	    },
	    updateEmailGroupSelected: function updateEmailGroupSelected(value) {
	      this.emailGroups.selected = value;
	    },
	    updateSMSGroupSelected: function updateSMSGroupSelected(value) {
	      this.SMSGroups.selected = value;
	    },
	    actionTranslator: function actionTranslator(action) {
	      if (action === 'DO High') {
	        return 'Turn On';
	      } else if (action === 'DO Low') {
	        return 'Turn Off';
	      } else {
	        return action;
	      }
	    },
	    isString: function isString(param) {
	      return typeof param === 'string';
	    },
	    eventTranslator: function eventTranslator(event) {
	      if (event === 'Low2High') {
	        return 'Turn On';
	      } else if (event === 'High2Low') {
	        return 'Turn Off';
	      } else return event;
	    },
	    returnEventName: function returnEventName(event) {
	      var str = '';
	      if (event.key === 'DI') {
	        str += event.key + ' ' + (event.source + ' ') + ('' + this.eventTranslator(event.value));
	      }
	      return str;
	    },
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    toShowModal: function toShowModal(key) {
	      this.editing.title = 'Event Config ' + key;
	      this.editing.index = key;
	      this.editing.event = _lodash2.default.cloneDeep(this.events[key]);
	      var newE = this.editing.newEvent;
	      var oldE = this.editing.event;
	      newE.key = oldE.event.key;
	      newE.name = oldE.name;
	      newE.enabled = oldE.enabled;
	      newE.newSource = oldE.event.source;
	      switch (newE.key) {
	        case 'DI':
	          newE.value = oldE.event.value;
	          break;
	      }
	      this.editing.actionKeys = this.editing.event.actions.map(function (obj) {
	        return obj.action;
	      });
	      this.newActions = this.editing.actionKeys;
	      for (var obj in this.editing.event.actions) {
	        switch (this.editing.event.actions[obj].action) {
	          case 'DO High':
	            this.actions.high.targets = this.editing.event.actions[obj].targets;
	            break;
	          case 'DO Low':
	            this.actions.low.targets = this.editing.event.actions[obj].targets;
	            break;
	          case 'SMS':
	            this.SMSGroups.selected = _lodash2.default.cloneDeep(this.editing.event.actions[obj].targets);
	            break;
	          case 'Email':
	            this.emailGroups.selected = _lodash2.default.cloneDeep(this.editing.event.actions[obj].targets);
	            break;
	        }
	      }
	      this.showModal = true;
	    },
	    hasSource: function hasSource() {
	      return this.editing.newEvent.newSource && this.editing.newEvent.newSource.length !== 0;
	    },
	    hasEventValue: function hasEventValue() {
	      var newE = this.editing.newEvent;
	      var value = false;
	      switch (newE.key) {
	        case 'DI':
	          value = newE.value && typeof newE.value === 'string';
	          break;
	      }
	      return value;
	    },
	    hasAction: function hasAction() {
	      if (this.newActions && this.newActions.length !== 0) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    hasValidPowerTypeAction: function hasValidPowerTypeAction() {
	      var counter = 0;
	      for (var i = 0; i < this.newActions.length; i++) {
	        if (this.newActions[i] !== 'Email' && this.newActions[i] !== 'SMS') counter = counter + 1;
	      }
	      return counter <= 1;
	    },
	    hasTarget: function hasTarget() {
	      var newAc = this.newActions;
	      var ac = this.actions;
	      if (newAc.indexOf('DO High') !== -1 && ac.high.targets.length === 0) return false;
	      if (newAc.indexOf('DO Low') !== -1 && ac.low.targets.length === 0) return false;
	      if (newAc.indexOf('Email') !== -1 && this.emailGroups.selected.length === 0) return false;
	      if (newAc.indexOf('SMS') !== -1 && this.SMSGroups.selected.length === 0) return false;
	      return true;
	    },
	    hasConflictActionOnSameTarget: function hasConflictActionOnSameTarget(param) {
	      var actionMap = {};
	      param.entries[this.editing.index].actions.map(function (cur) {
	        actionMap[cur.action] = cur.targets;
	      });
	      var keys = (0, _keys2.default)(actionMap);
	
	      if (!(keys.indexOf('DO High') !== -1 && keys.indexOf('DO Low') !== -1)) return false;
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(actionMap['DO High']), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var highTar = _step.value;
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = (0, _getIterator3.default)(actionMap['DO Low']), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var lowTar = _step2.value;
	
	              if (highTar === lowTar) return true;
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    },
	    handleEventConfig: function handleEventConfig() {
	      var _this2 = this;
	
	      if (!this.$eventName.valid || this.editing.newEvent.name.trim().length === 0) {
	        return this.alert('danger', '', 'Please enter a valid event name');
	      }
	
	      if (!this.hasSource()) {
	        return this.alert('danger', '', 'Please give this event a source');
	      }
	
	      if (!this.hasEventValue()) return this.alert('danger', '', 'Please give your event a value');
	
	      if (!this.hasAction()) return this.alert('danger', '', 'Please give your config an action');
	
	      if (!this.hasTarget()) return this.alert('danger', '', 'Please give your action a target');
	
	      var newEvent = this.editing.newEvent;
	      var ac = [];
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = (0, _getIterator3.default)(this.newActions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var action = _step3.value;
	
	          switch (action) {
	            case 'DO High':
	              ac.push({
	                action: action,
	                targets: this.actions.high.targets
	              });
	              break;
	            case 'DO Low':
	              ac.push({
	                action: action,
	                targets: this.actions.low.targets
	              });
	              break;
	            case 'SMS':
	              ac.push({
	                action: action,
	                targets: this.SMSGroups.selected
	              });
	              break;
	            case 'Email':
	              ac.push({
	                action: action,
	                targets: this.emailGroups.selected
	              });
	              break;
	          }
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      var param = {
	        entries: (0, _defineProperty3.default)({}, this.editing.index, {
	          enabled: newEvent.enabled,
	          name: newEvent.name.trim(),
	          event: {
	            key: newEvent.key,
	            condition: newEvent.condition,
	            value: '',
	            source: newEvent.newSource
	          },
	          actions: ac
	        })
	      };
	
	      if (this.hasConflictActionOnSameTarget(param)) return this.alert('danger', '', 'You can not set conflict action to same target');
	
	      switch (newEvent.key) {
	        case 'DI':
	          param.entries[this.editing.index].event.value = newEvent.value;
	          break;
	      }
	
	      function isEventEqual(a, b) {
	        return a.condition === b.condition && a.key === b.key && a.source === b.source && a.value === b.value;
	      }
	
	      function isActionConflict(a, b) {
	        var hasConflictAction = false;
	        var hasSameTarget = false;
	
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	          for (var _iterator4 = (0, _getIterator3.default)((0, _keys2.default)(a.actions)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var aKey = _step4.value;
	            var _iteratorNormalCompletion5 = true;
	            var _didIteratorError5 = false;
	            var _iteratorError5 = undefined;
	
	            try {
	              for (var _iterator5 = (0, _getIterator3.default)((0, _keys2.default)(b.actions)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                var bKey = _step5.value;
	
	                var aAc = a.actions[aKey];
	                var bAc = b.actions[bKey];
	                if (aAc.action === 'DO High' && bAc.action === 'DO Low' || aAc.action === 'DO Low' && bAc.action === 'DO High') {
	                  hasConflictAction = true;
	
	                  var _iteratorNormalCompletion6 = true;
	                  var _didIteratorError6 = false;
	                  var _iteratorError6 = undefined;
	
	                  try {
	                    for (var _iterator6 = (0, _getIterator3.default)(aAc.targets), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	                      var tar = _step6.value;
	
	                      if (bAc.targets.indexOf(tar) !== -1) {
	                        hasSameTarget = true;
	                        break;
	                      }
	                    }
	                  } catch (err) {
	                    _didIteratorError6 = true;
	                    _iteratorError6 = err;
	                  } finally {
	                    try {
	                      if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                        _iterator6.return();
	                      }
	                    } finally {
	                      if (_didIteratorError6) {
	                        throw _iteratorError6;
	                      }
	                    }
	                  }
	
	                  break;
	                }
	              }
	            } catch (err) {
	              _didIteratorError5 = true;
	              _iteratorError5 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                  _iterator5.return();
	                }
	              } finally {
	                if (_didIteratorError5) {
	                  throw _iteratorError5;
	                }
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError4 = true;
	          _iteratorError4 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	              _iterator4.return();
	            }
	          } finally {
	            if (_didIteratorError4) {
	              throw _iteratorError4;
	            }
	          }
	        }
	
	        return hasConflictAction && hasSameTarget;
	      }
	
	      var conflict = [];
	      var keys = (0, _keys2.default)(this.events);
	      var _iteratorNormalCompletion7 = true;
	      var _didIteratorError7 = false;
	      var _iteratorError7 = undefined;
	
	      try {
	        for (var _iterator7 = (0, _getIterator3.default)(keys), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	          var k = _step7.value;
	
	          var evt = this.events[k];
	          if (isEventEqual(evt.event, param.entries[this.editing.index].event) && isActionConflict(evt, param.entries[this.editing.index]) && parseInt(this.editing.index) !== parseInt(k)) conflict.push(k);
	        }
	      } catch (err) {
	        _didIteratorError7 = true;
	        _iteratorError7 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion7 && _iterator7.return) {
	            _iterator7.return();
	          }
	        } finally {
	          if (_didIteratorError7) {
	            throw _iteratorError7;
	          }
	        }
	      }
	
	      if (conflict.length > 0) return this.alert('danger', '', 'You have set conflict action with Event ' + conflict.join(','));
	
	      console.log('hi everything is fine');
	
	      (0, _Service.call)(this.$route.params.mac, 'dxSetEvents', param).then(function (res) {
	        console.log(res);
	        _this2.showModal = false;
	      }, function (err) {
	        console.log(err);
	      });
	    },
	    setEvent: function setEvent(enabled, eventKey) {
	      var _this3 = this;
	
	      var param = {
	        entries: (0, _defineProperty3.default)({}, eventKey, this.events[eventKey])
	      };
	      param.entries[eventKey].enabled = enabled;
	      (0, _Service.call)(this.$route.params.mac, 'dxSetEvents', param).then(function (res) {
	        console.log(res);
	      }, function (err) {
	        _this3.alert('danger', 'Unexpected Error', err);
	        console.log(err);
	      });
	    },
	    handleGroupConfig: function handleGroupConfig(type, key) {
	      console.log(key);
	
	      if (type === 'email') {
	        this.editingGroup._id = key;
	        this.editingGroup.title = 'Edit email group ' + key;
	        this.editingGroup.format = 'ex1@gmail.com;ex2@gmail.com';
	        this.editingGroup.data = _lodash2.default.cloneDeep(this.emailData[key]);
	        this.editingGroup.cb = this.emailGpApply;
	      } else if (type === 'SMS') {
	        this.editingGroup._id = key;
	        this.editingGroup.title = 'Edit SMS group ' + key;
	        this.editingGroup.format = '+886932123123;+886972456456';
	        this.editingGroup.data = _lodash2.default.cloneDeep(this.SMSData[key]);
	        this.editingGroup.cb = this.SMSGpApply;
	      }
	      this.showGroupConfigTable = true;
	    },
	    checkGroupNameUsed: function checkGroupNameUsed(type) {
	      var data = type === 'email' ? this.emailData : this.SMSData;
	      for (var key in data) {
	        if (key !== this.editingGroup._id && data[key].name === this.editingGroup.data.name) return true;
	      }
	      return false;
	    },
	    checkGroupAccountAvailable: function checkGroupAccountAvailable(type) {
	      if (this.editingGroup.data.accounts.length === 0) {
	        return true;
	      } else {
	        var accounts = this.editingGroup.data.accounts.split(';');
	
	
	        if (type === 'email') {
	          var _iteratorNormalCompletion8 = true;
	          var _didIteratorError8 = false;
	          var _iteratorError8 = undefined;
	
	          try {
	            for (var _iterator8 = (0, _getIterator3.default)(accounts), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	              var email = _step8.value;
	
	              if (!(0, _emailValidator.validate)(email)) return 'one of the emails invalid';
	            }
	          } catch (err) {
	            _didIteratorError8 = true;
	            _iteratorError8 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion8 && _iterator8.return) {
	                _iterator8.return();
	              }
	            } finally {
	              if (_didIteratorError8) {
	                throw _iteratorError8;
	              }
	            }
	          }
	        } else if (type === 'SMS') {
	          var regex = /^\+{1}[0]{0,1}\d{10,12}/;
	          var _iteratorNormalCompletion9 = true;
	          var _didIteratorError9 = false;
	          var _iteratorError9 = undefined;
	
	          try {
	            for (var _iterator9 = (0, _getIterator3.default)(accounts), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	              var number = _step9.value;
	
	              if (!regex.test(number)) return 'one of the number invalid';
	            }
	          } catch (err) {
	            _didIteratorError9 = true;
	            _iteratorError9 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion9 && _iterator9.return) {
	                _iterator9.return();
	              }
	            } finally {
	              if (_didIteratorError9) {
	                throw _iteratorError9;
	              }
	            }
	          }
	        }
	
	        return true;
	      }
	    },
	    checkGroupAccountOverLimit: function checkGroupAccountOverLimit() {
	      return this.editingGroup.data.accounts.split(';').length > 10;
	    },
	    checkGroupCanBeEmpty: function checkGroupCanBeEmpty(type) {
	      var oldName = type === 'Email' ? this.emailData[this.editingGroup._id].name : this.SMSData[this.editingGroup._id].name;
	      var newName = this.editingGroup.data.name;
	
	      if (oldName === newName) return true;
	
	      var _iteratorNormalCompletion10 = true;
	      var _didIteratorError10 = false;
	      var _iteratorError10 = undefined;
	
	      try {
	        for (var _iterator10 = (0, _getIterator3.default)((0, _keys2.default)(this.events)), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	          var key = _step10.value;
	          var _iteratorNormalCompletion11 = true;
	          var _didIteratorError11 = false;
	          var _iteratorError11 = undefined;
	
	          try {
	            for (var _iterator11 = (0, _getIterator3.default)(this.events[key].actions), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
	              var obj = _step11.value;
	
	              if (obj.action === type && obj.targets.indexOf(oldName) !== -1) return false;
	            }
	          } catch (err) {
	            _didIteratorError11 = true;
	            _iteratorError11 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion11 && _iterator11.return) {
	                _iterator11.return();
	              }
	            } finally {
	              if (_didIteratorError11) {
	                throw _iteratorError11;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError10 = true;
	        _iteratorError10 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion10 && _iterator10.return) {
	            _iterator10.return();
	          }
	        } finally {
	          if (_didIteratorError10) {
	            throw _iteratorError10;
	          }
	        }
	      }
	
	      return true;
	    },
	    emailGpApply: function emailGpApply() {
	      var _this4 = this;
	
	      if (this.$groupName.invalid) return this.alert('danger', '', 'Invalid group name');
	
	      if (this.checkGroupNameUsed('email')) return this.alert('danger', '', 'Group name used');
	
	      if (this.editingGroup.data.accounts.length === 0 && !this.checkGroupCanBeEmpty('Email')) {
	        return this.alert('danger', '', 'You need to remove this group out of the targets of all events before leaving it empty');
	      }
	
	      if (!this.checkGroupCanBeEmpty('Email')) {
	        return this.alert('danger', '', 'You need to remove this group out of the targets of all events before modifying the name');
	      }
	
	      if (typeof this.checkGroupAccountAvailable('email') === 'string') {
	        return this.alert('danger', '', this.checkGroupAccountAvailable('email'));
	      }
	
	      if (this.checkGroupAccountOverLimit()) return this.alert('danger', '', 'Only 10 accounts allowed');
	
	      console.log('hahaha all email good');
	
	      var preName = this.emailData[this.editingGroup._id].name;
	      var newName = this.editingGroup.data.name;
	      var newEvents = _lodash2.default.cloneDeep(this.events);
	      console.log('preName = ', preName);
	      console.log('newName = ', newName);
	
	      var _iteratorNormalCompletion12 = true;
	      var _didIteratorError12 = false;
	      var _iteratorError12 = undefined;
	
	      try {
	        for (var _iterator12 = (0, _getIterator3.default)((0, _keys2.default)(newEvents)), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
	          var key = _step12.value;
	          var _iteratorNormalCompletion13 = true;
	          var _didIteratorError13 = false;
	          var _iteratorError13 = undefined;
	
	          try {
	            for (var _iterator13 = (0, _getIterator3.default)(newEvents[key].actions), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
	              var obj = _step13.value;
	
	              if (obj.action === 'Email' && preName !== newName && obj.targets.indexOf(preName) !== -1) {
	                obj.targets[obj.targets.indexOf(preName)] = newName;
	              }
	            }
	          } catch (err) {
	            _didIteratorError13 = true;
	            _iteratorError13 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion13 && _iterator13.return) {
	                _iterator13.return();
	              }
	            } finally {
	              if (_didIteratorError13) {
	                throw _iteratorError13;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError12 = true;
	        _iteratorError12 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion12 && _iterator12.return) {
	            _iterator12.return();
	          }
	        } finally {
	          if (_didIteratorError12) {
	            throw _iteratorError12;
	          }
	        }
	      }
	
	      this.editingGroup.data.name = this.editingGroup.data.name.trim();
	
	      this.events = newEvents;
	
	      var param = {
	        entries: (0, _defineProperty3.default)({}, this.editingGroup._id, this.editingGroup.data)
	      };
	      console.log(param);
	
	      (0, _Service.call)(this.$route.params.mac, 'dxSetEmailGroups', param).then(function (res) {
	        _this4.showGroupConfigTable = false;
	      }, function (err) {
	        _this4.alert('danger', '', err);
	      });
	    },
	    SMSGpApply: function SMSGpApply() {
	      var _this5 = this;
	
	      if (this.$groupName.invalid) return this.alert('danger', '', 'Invalid group name');
	
	      if (this.checkGroupNameUsed('SMS')) return this.alert('danger', '', 'Invalid group name');
	
	      if (this.editingGroup.data.accounts.length === 0 && !this.checkGroupCanBeEmpty('SMS')) {
	        return this.alert('danger', '', 'You need to remove this group out of the targets of all events before leaving it empty');
	      }
	
	      if (!this.checkGroupCanBeEmpty('SMS')) {
	        return this.alert('danger', '', 'You need to remove this group out of the targets of all events before modifying the name');
	      }
	
	      if (typeof this.checkGroupAccountAvailable('SMS') === 'string') {
	        return this.alert('danger', '', this.checkGroupAccountAvailable('SMS'));
	      }
	
	      if (this.checkGroupAccountOverLimit()) return this.alert('danger', '', 'Only 10 accounts allowed');
	
	      console.log('hahah all number good');
	
	      var preName = this.SMSData[this.editingGroup._id].name;
	      var newName = this.editingGroup.data.name;
	      var newEvents = _lodash2.default.cloneDeep(this.events);
	
	      var _iteratorNormalCompletion14 = true;
	      var _didIteratorError14 = false;
	      var _iteratorError14 = undefined;
	
	      try {
	        for (var _iterator14 = (0, _getIterator3.default)((0, _keys2.default)(newEvents)), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
	          var key = _step14.value;
	          var _iteratorNormalCompletion15 = true;
	          var _didIteratorError15 = false;
	          var _iteratorError15 = undefined;
	
	          try {
	            for (var _iterator15 = (0, _getIterator3.default)(newEvents[key].actions), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
	              var obj = _step15.value;
	
	              if (obj.action === 'SMS' && preName !== newName && obj.targets.indexOf(preName) !== -1) {
	                obj.targets[obj.targets.indexOf(preName)] = newName;
	              }
	            }
	          } catch (err) {
	            _didIteratorError15 = true;
	            _iteratorError15 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion15 && _iterator15.return) {
	                _iterator15.return();
	              }
	            } finally {
	              if (_didIteratorError15) {
	                throw _iteratorError15;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError14 = true;
	        _iteratorError14 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion14 && _iterator14.return) {
	            _iterator14.return();
	          }
	        } finally {
	          if (_didIteratorError14) {
	            throw _iteratorError14;
	          }
	        }
	      }
	
	      this.editingGroup.data.name = this.editingGroup.data.name.trim();
	
	      this.events = newEvents;
	
	      var param = {
	        entries: (0, _defineProperty3.default)({}, this.editingGroup._id, this.editingGroup.data)
	      };
	      console.log(param);
	      (0, _Service.call)(this.$route.params.mac, 'dxSetSMSGroups', param).then(function (res) {
	        _this5.showGroupConfigTable = false;
	      }, function (err) {
	        _this5.alert('danger', '', err);
	      });
	    },
	    handleDeleteGroup: function handleDeleteGroup(group, tag) {
	      var key = this[group].selected.indexOf(tag);
	      this[group].selected.splice(key, 1);
	    }
	  },
	  ready: function ready() {},
	
	  watch: {
	    params: 'reloadAsyncData',
	    showModal: function showModal(nv) {
	      if (!nv) {
	        (0, _jquery2.default)('.event_config').scrollTop(0);
	      }
	    },
	    showGroupConfigTable: function showGroupConfigTable(nv) {
	      if (!nv) {
	        (0, _jquery2.default)('.group_config').scrollTop(0);
	      }
	    },
	
	    emailGroups: {
	      deep: true,
	      handler: function handler(nv) {
	        if (nv.selected.length === 0 && this.newActions.indexOf('Email') !== -1) {
	          this.newActions.splice(this.newActions.indexOf('Email'), 1);
	        }
	      }
	    },
	    SMSGroups: {
	      deep: true,
	      handler: function handler(nv) {
	        if (nv.selected.length === 0 && this.newActions.indexOf('SMS') !== -1) {
	          this.newActions.splice(this.newActions.indexOf('SMS'), 1);
	        }
	      }
	    }
	  },
	  events: {
	    update: function update(mac, _ref5) {
	      var type = _ref5.type,
	          event = _ref5.event,
	          msg = _ref5.msg;
	
	      if (type === 'event') {
	        this.events = _lodash2.default.assignIn(this.events, event);
	      } else if (type === 'Email') {
	        this.emailData = _lodash2.default.assignIn(this.emailData, event);
	
	        this.emailGroups = {
	          options: [],
	          selected: []
	        };
	        for (var key in this.emailData) {
	          if (this.emailData[key].accounts.length !== 0) {
	            this.emailGroups.options.push(this.emailData[key].name);
	          }
	        }
	      } else if (type === 'SMS') {
	        this.SMSData = _lodash2.default.assignIn(this.SMSData, event);
	
	        this.SMSGroups = {
	          options: [],
	          selected: []
	        };
	        for (var _key in this.SMSData) {
	          if (this.SMSData[_key].accounts.length !== 0) {
	            this.SMSGroups.options.push(this.SMSData[_key].name);
	          }
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(28);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(22);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _vueStrap = __webpack_require__(12);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _SingleSelect = __webpack_require__(26);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _Service = __webpack_require__(8);
	
	var _MultiBanks = __webpack_require__(178);
	
	var _MultiBanks2 = _interopRequireDefault(_MultiBanks);
	
	var _jquery = __webpack_require__(21);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal,
	    'v-select': _SingleSelect2.default,
	    'v-multi-banks': _MultiBanks2.default
	  },
	  data: function data() {
	    return {
	      DIs: {},
	      DOs: {},
	      editing: {
	        title: 'Schedule Config',
	        index: '',
	        schedule: null,
	        newTargets: [1],
	        newDays: []
	      },
	      schedules: {},
	      showModal: false,
	      new_schedule_name: '',
	      weekDay: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
	      actionOptions: [{ label: 'Turn on', value: 'DO High' }, { label: 'Turn off', value: 'DO Low' }]
	    };
	  },
	
	  computed: {
	    targetOptions: function targetOptions() {
	      var options = [];
	      for (var key in this.DOs) {
	        options.push({
	          label: '[DO' + key + '] ' + this.DOs[key].name,
	          value: '' + key
	        });
	      }
	      return options;
	    }
	  },
	  asyncData: function asyncData() {
	    var _this = this;
	
	    var mac = this.$route.params.mac;
	
	    (0, _Service.call)(mac, 'dxGetSchedules').then(function (_ref) {
	      var entries = _ref.entries;
	
	      _this.schedules = _lodash2.default.cloneDeep(entries);
	      return (0, _Service.call)(mac, 'dxGetDIOStatus');
	    }).then(function (_ref2) {
	      var channels = _ref2.channels;
	
	      _this.DIs = _lodash2.default.cloneDeep(channels.DIs);
	      _this.DOs = _lodash2.default.cloneDeep(channels.DOs);
	    }).catch(function (err) {
	      _this.alert('danger', '', err);
	    });
	  },
	
	  methods: {
	    actionTranslator: function actionTranslator(action) {
	      console.log(action);
	      if (action === 'DO High') {
	        return 'Turn On';
	      } else if (action === 'DO Low') {
	        return 'Turn Off';
	      } else {
	        return '';
	      }
	    },
	    setSchedule: function setSchedule(enabled, scheduleKey) {
	      var _this2 = this;
	
	      var param = {
	        entries: (0, _defineProperty3.default)({}, scheduleKey, this.schedules[scheduleKey])
	      };
	      param.entries[scheduleKey].enabled = enabled;
	      (0, _Service.call)(this.$route.params.mac, 'dxSetSchedules', param).then(function (res) {
	        console.log(res);
	      }, function (err) {
	        _this2.alert('danger', 'Unexpected Error', err);
	        console.log(err);
	      });
	    },
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    toShowModal: function toShowModal(key) {
	      this.editing.index = key;
	      this.editing.title = 'Schedule Config ' + key;
	      this.editing.schedule = _lodash2.default.cloneDeep(this.schedules[key]);
	      this.editing.newTargets = this.editing.schedule.targets;
	      this.editing.newDays = this.editing.schedule.time.days;
	      this.showModal = true;
	    },
	    handleScheduleConfig: function handleScheduleConfig() {
	      var _this3 = this;
	
	      if (this.$scheName.invalid) return this.alert('danger', '', 'Please enter a valid schedule name');
	
	      if (!this.editing.schedule.action) return this.alert('danger', '', 'Please give this schedule an action');
	
	      var regexNum = /^[0-9]{1,2}/;
	      if (!regexNum.test(this.editing.schedule.time.hours) || !regexNum.test(this.editing.schedule.time.minutes) || this.editing.schedule.time.hours.length > 2 || this.editing.schedule.time.minutes.length > 2) return this.alert('danger', '', 'Please enter valid times');
	
	      if (this.editing.schedule.time.hours < 0 || this.editing.schedule.time.minutes < 0 || this.editing.schedule.time.hours > 23 || this.editing.schedule.time.minutes > 59) {
	        return this.alert('danger', '', 'Please enter right format of time (ex: 14:59)');
	      }
	
	      if (this.editing.newDays.length === 0) {
	        return this.alert('danger', '', 'Please choose a day for your schedule to active');
	      }
	
	      if (this.editing.newTargets.length === 0) {
	        return this.alert('danger', '', 'Please give your schedule an output');
	      }
	
	      var sche = _lodash2.default.cloneDeep(this.editing.schedule);
	      sche.name = this.new_schedule_name.trim();
	      sche.targets = _lodash2.default.cloneDeep(this.editing.newTargets);
	      sche.time.days = _lodash2.default.cloneDeep(this.editing.newDays);
	
	      var conflict = [];
	      var toCheckSche = [];
	      var keys = (0, _keys2.default)(this.schedules);
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var k = _step.value;
	
	          var s = this.schedules[k];
	          if (s.action !== sche.action && s.time.hours === parseInt(sche.time.hours) && s.time.minutes === parseInt(sche.time.minutes) && parseInt(k) !== parseInt(this.editing.index)) toCheckSche.push(s);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      conflict = toCheckSche.map(function (s) {
	        var hasSameTarget = false;
	        var hasSameDay = false;
	
	        for (var tar in s.targets) {
	          if (sche.targets.indexOf(tar) !== -1) {
	            hasSameTarget = true;
	            break;
	          }
	        }
	
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(s.time.days), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var day = _step2.value;
	
	            if (sche.time.days.indexOf(day) !== -1) {
	              hasSameDay = true;
	              break;
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	
	        if (hasSameDay && hasSameTarget) return s;
	      });
	
	      conflict = conflict.filter(function (c) {
	        return c;
	      });
	      console.log('length of conflict', conflict.length);
	      if (conflict.length !== 0) return this.alert('danger', '', 'The schedule you set has conflict with others');
	
	      var param = {
	        entries: (0, _defineProperty3.default)({}, this.editing.index, sche)
	      };
	      (0, _Service.call)(this.$route.params.mac, 'dxSetSchedules', param).then(function (res) {
	        console.log(res);
	        _this3.showModal = false;
	      }, function (err) {
	        console.log(err);
	      });
	    }
	  },
	  ready: function ready() {},
	
	  events: {
	    update: function update(mac, _ref3) {
	      var type = _ref3.type,
	          event = _ref3.event,
	          msg = _ref3.msg;
	
	      console.log(type);
	      console.log(event);
	      console.log(msg);
	      if (type === 'schedule') {
	        this.schedules = _lodash2.default.assignIn(this.schedules, event);
	      }
	    }
	  },
	  watch: {
	    showModal: function showModal(nv) {
	      if (!nv) {
	        (0, _jquery2.default)('.schedule_config').scrollTop(0);
	      }
	    }
	  }
	};

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(22);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _Service = __webpack_require__(8);
	
	var _vueStrap = __webpack_require__(12);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal
	  },
	  data: function data() {
	    return {
	      DIs: {},
	      DOs: {},
	      editing: {
	        DIs: {},
	        DOs: {}
	      },
	      isOut: false,
	      currentIndex: -1,
	      showModal: false
	    };
	  },
	  asyncData: function asyncData() {
	    var _this = this;
	
	    var mac = this.$route.params.mac;
	
	    (0, _Service.call)(mac, 'dxGetDIOStatus').then(function (_ref) {
	      var channels = _ref.channels;
	
	      _this.DIs = channels.DIs;
	      _this.DOs = channels.DOs;
	    }).catch(function (err) {
	      _this.alert('danger', '', err);
	    });
	  },
	
	  computed: {},
	  methods: {
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    setDOStatus: function setDOStatus(key) {
	      var _this2 = this;
	
	      var mac = this.$route.params.mac;
	
	      var params = {
	        'DOs': (0, _defineProperty3.default)({}, key, {
	          value: this.DOs[key].value === 'high' ? 'low' : 'high'
	        })
	      };
	      (0, _Service.call)(mac, 'dxSetDOState', params).then(function (res) {
	        console.log(res);
	      }).catch(function (err) {
	        _this2.alert('danger', '', err);
	      });
	    },
	    handleShowModal: function handleShowModal(isOut, index) {
	      this.isOut = isOut;
	      this.currentIndex = index;
	      if (this.isOut) {
	        this.editing.DOs = _lodash2.default.cloneDeep(this.DOs);
	      } else {
	        this.editing.DIs = _lodash2.default.cloneDeep(this.DIs);
	      }
	      this.showModal = true;
	    },
	    allNameValid: function allNameValid() {
	      var regex = /^[0-9A-Za-z\s_]{1,}$/;
	      if (this.isOut) {
	        return regex.test(this.editing.DOs[this.currentIndex].name);
	      } else {
	        return regex.test(this.editing.DIs[this.currentIndex].name);
	      }
	    },
	    applyConfig: function applyConfig() {
	      var _this3 = this;
	
	      if (!this.allNameValid()) return this.alert('danger', '', 'One of the names is invalid.');
	      var DOs = {};
	      var DIs = {};
	      var mac = this.$route.params.mac;
	
	
	      for (var key in this.editing.DIs) {
	        if (this.editing.DIs[key].name !== this.DIs[key].name) {
	          Object.defineProperty(DIs, '' + key, {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: {
	              name: this.editing.DIs[key].name
	            }
	          });
	        }
	      }
	
	      for (var _key in this.editing.DOs) {
	        if (this.editing.DOs[_key].name !== this.DOs[_key].name) {
	          Object.defineProperty(DOs, '' + _key, {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: {
	              name: this.editing.DOs[_key].name
	            }
	          });
	        }
	      }
	
	      var DOAry = (0, _keys2.default)(DOs);
	      var DIAry = (0, _keys2.default)(DIs);
	      var params = void 0;
	
	      if (DOAry.length !== 0 && DIAry.length !== 0) {
	        params = {
	          DOs: DOs,
	          DIs: DIs
	        };
	      } else if (DOAry.length !== 0) {
	        params = {
	          DOs: DOs
	        };
	      } else if (DIAry.length !== 0) {
	        params = {
	          DIs: DIs
	        };
	      }
	      console.log(params);
	      if (params) {
	        (0, _Service.call)(mac, 'dxSetDIOConfig', params).then(function (res) {
	          console.log(res);
	        }).catch(function (err) {
	          _this3.alert('danger', '', err);
	        });
	      } else {
	        this.alert('success', '', 'Nothing changed');
	      }
	
	      this.showModal = false;
	    }
	  }, ready: function ready() {},
	
	  watch: {
	    showModal: function showModal(nV) {
	      if (!nV) {
	        this.editing = {
	          DIs: {},
	          DOs: {}
	        };
	      }
	    }
	  },
	  events: {
	    update: function update(mac, _ref2) {
	      var type = _ref2.type,
	          event = _ref2.event,
	          msg = _ref2.msg;
	
	      if (type === 'state' || type === 'info') {
	        var newDIOs = _lodash2.default.cloneDeep(this[event.type]);
	        var key = type === 'state' ? 'value' : 'name';
	        newDIOs[event.id][key] = event[key];
	        this[event.type] = _lodash2.default.cloneDeep(newDIOs);
	      }
	    }
	  },
	  route: {
	    canReuse: false, activate: function activate(_ref3) {
	      var next = _ref3.next;
	
	      next();
	    }
	  }
	};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobileDetect = __webpack_require__(56);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	var _jquery = __webpack_require__(21);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      iframeSrc: '',
	      ww: 0,
	      wh: 0
	    };
	  },
	  computed: {
	    isMobile: function isMobile() {
	      var md = new _mobileDetect2.default(window.navigator.userAgent);
	      return md.mobile() !== null && this.wh > this.ww;
	    }
	  },
	  methods: {
	    addListener: function addListener() {
	      var _this = this;
	
	      var md = new _mobileDetect2.default(window.navigator.userAgent);
	      setTimeout(function () {
	        _this.ww = window.innerWidth;
	        _this.wh = window.innerHeight;
	
	        if (window.matchMedia('(orientation: landscape)').matches && md.mobile() !== null) {
	          console.log('landscape');
	          var body = document.getElementById('iframe').contentWindow.document.getElementsByTagName('body');
	
	          var innerWindow = document.getElementById('iframe').contentWindow;
	
	          (0, _jquery2.default)('#iframe').height(window.innerHeight - 40);
	          (0, _jquery2.default)('#iframe').width(_this.ww);
	          (0, _jquery2.default)('#iframe').css({
	            'height': window.innerHeight - 40 + 'px',
	            'width': _this.ww + 'px',
	            'outline': '5px solid #000',
	            'outline-offset': '-5px'
	          });
	
	          (0, _jquery2.default)(innerWindow).css({
	            ouline: '5px solid #f00',
	            'outline-offset': '-5px'
	          });
	
	          var scale = 1;
	          if (_this.ww < 1337) {
	            scale = _this.ww / 1337;
	          }
	          console.log(_this.ww);
	          console.log('scale in iframe.vue', scale);
	
	          (0, _jquery2.default)(body).css({
	            'outline': '5px solid #0f0',
	            'transform': 'scale(' + scale + ')',
	            'transform-origin': 'top left',
	            'width': _this.ww / (_this.ww / 1337),
	            'height': '1337px',
	
	            'overflow-x': 'hidden'
	          });
	        }
	      }, 500);
	    }
	  },
	  ready: function ready() {
	    this.iframeSrc = '/ite/?mac=' + this.$route.params.mac;
	    this.ww = window.innerWidth;
	    this.wh = window.innerHeight;
	  },
	
	  route: {
	    canReuse: false, activate: function activate(_ref) {
	      var next = _ref.next;
	
	      next();
	    },
	    deactivate: function deactivate(transition) {
	      transition.next();
	    }
	  }
	};

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(22);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _jquery = __webpack_require__(21);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Service = __webpack_require__(8);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Indicator = __webpack_require__(177);
	
	var _Indicator2 = _interopRequireDefault(_Indicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Indicator: _Indicator2.default
	  },
	  props: {
	    isInstaller: {
	      type: Boolean
	    },
	    cardType: {
	      type: null
	    },
	    outputData: {
	      type: null
	    },
	    inputData: {
	      type: null
	    },
	    isFavorite: {
	      type: Boolean
	    },
	    outputFocus: null,
	    inputFocus: null,
	    inputId: {
	      type: String
	    },
	    highlightInputId: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    isOut: function isOut() {
	      return this.cardType === 'output';
	    },
	    isDesktopFocused: function isDesktopFocused() {
	      return this.isOut && this.outputFocus === Number(this.outputData._id) || !this.isOut && this.inputFocus === Number(this.inputData._id);
	    },
	    isMobileFocused: function isMobileFocused() {
	      return !this.isOut && Number(this.inputFocus) === Number(this.inputData._id);
	    }
	  },
	  data: function data() {
	    return {
	      inputImgs: _Service.photos.inputs,
	      outputImgs: _Service.photos.outputs,
	      vgaImgs: _Service.photos.vga
	    };
	  },
	
	  methods: {
	    cardClick: function cardClick() {
	      this.$emit('focus', this.isOut ? this.outputData._id : this.inputData._id);
	    }
	  },
	  ready: function ready() {
	    var ele = this.$els.content;
	    ele.move = function (left, top, cb) {
	      (0, _jquery2.default)(ele).css({
	        transform: 'translate(' + left + 'px, ' + top + 'px) scale(0)'
	      }).addClass('moving');
	      setTimeout(function () {
	        (0, _jquery2.default)(ele).css({
	          transform: 'none'
	        }).addClass('moved');
	        setTimeout(function () {
	          (0, _jquery2.default)(ele).css({}).removeClass('moving moved');
	        }, 200);
	        cb();
	      }, 600);
	    };
	  },
	
	  events: {
	    update: function update(mac, _ref) {
	      var type = _ref.type,
	          event = _ref.event,
	          msg = _ref.msg;
	
	      var key = (0, _keys2.default)(event.inputs)[0];
	
	      if (key === this.inputId) {
	        console.log(event);
	        console.log(this.inputData);
	        var newInputData = _lodash2.default.cloneDeep(this.inputData);
	        newInputData.link = event.inputs[key];
	        this.inputData = _lodash2.default.cloneDeep(newInputData);
	        console.log(this.inputData);
	      }
	    }
	  }
	};

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _vueStrap = __webpack_require__(12);
	
	var _Service = __webpack_require__(8);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Swiper = __webpack_require__(530);
	
	var _Swiper2 = _interopRequireDefault(_Swiper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = {};
	exports.default = {
	  components: {
	    modal: _vueStrap.modal,
	    swiper: _Swiper2.default
	  },
	  props: {
	    isInstaller: {
	      type: Boolean
	    },
	    show: {
	      type: Boolean,
	      require: true,
	      twoWay: true
	    },
	    inputData: {
	      type: null
	    },
	    outputData: {
	      type: null
	    },
	    hdcpCapability: {
	      type: null
	    },
	    favoritePort: {
	      type: null
	    },
	    isOut: {
	      type: null
	    }
	  },
	  data: function data() {
	    return {
	      vgaIcon: _Service.photos.vga[0],
	      isFavorite: false,
	      inputImgs: _Service.photos.inputs,
	      outputImgs: _Service.photos.outputs,
	      inputImgFocus: null,
	      outputImgFocus: null,
	      transitioning: false
	    };
	  },
	
	  computed: {
	    outImgsliders: function outImgsliders() {
	      var sliders = {};
	      for (var i = 1; i < this.outputImgs.length; i++) {
	        sliders[i] = {
	          _id: i,
	          url: this.outputImgs[i]
	        };
	      }
	
	      return sliders;
	    },
	    inImgsliders: function inImgsliders() {
	      var sliders = {};
	      for (var i = 1; i < this.inputImgs.length; i++) {
	        sliders[i] = {
	          _id: i,
	          url: this.inputImgs[i]
	        };
	      }
	      this.inputImgFocus = this.inputData.photo;
	      return sliders;
	    }
	  },
	  watch: {
	    show: function show(newV) {
	      this.transitioning = false;
	      if (newV) {
	        if (this.outputData) this.isFavorite = this.favoritePort === this.outputData._id;
	        if (!this.isOut) {
	          store.inputData = _lodash2.default.cloneDeep(this.inputData);
	          this.inputData = _lodash2.default.cloneDeep(this.inputData);
	          this.inputImgFocus = store.inputData.photo;
	          console.log('inputImgFoucs', this.inputImgFocus);
	        } else {
	          store.inputData = _lodash2.default.cloneDeep(this.inputData);
	          store.outputData = _lodash2.default.cloneDeep(this.outputData);
	          this.inputData = _lodash2.default.cloneDeep(this.inputData);
	          this.outputData = _lodash2.default.cloneDeep(this.outputData);
	          this.inputImgFocus = store.inputData.photo;
	          this.outputImgFocus = store.outputData.photo;
	        }
	      }
	    }
	  },
	  methods: {
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    onOutSwiperEnd: function onOutSwiperEnd(currentPage) {
	      this.outputImgFocus = currentPage + 1;
	      this.outputData.photo = currentPage + 1;
	    },
	    onInSwiperEnd: function onInSwiperEnd(currentPage) {
	      this.inputImgFocus = currentPage + 1;
	      this.inputData.photo = currentPage + 1;
	    },
	    applyChange: function applyChange() {
	      var _this = this;
	
	      if (this.transitioning) return;
	
	      if (!this.isOut && this.inputData.name.trim().length === 0 || this.isOut && this.outputData.name.trim().length === 0) {
	        this.alert('danger', '', 'Port Name can not be empty');
	        return;
	      }
	      if (!this.isOut && this.inputData.name !== store.inputData.name || this.isOut && this.outputData.name !== store.outputData.name || !this.isOut && this.inputData.photo !== store.inputData.photo || this.isOut && this.outputData.photo !== store.outputData.photo) {
	        var params = (0, _defineProperty3.default)({}, this.isOut ? 'outputs' : 'inputs', (0, _defineProperty3.default)({}, this.isOut ? this.outputData._id : this.inputData._id, {
	          name: this.isOut ? this.outputData.name.trim() : this.inputData.name.trim(),
	          photo: this.isOut ? String(this.outputImgFocus) : String(this.inputImgFocus)
	        }));
	        (0, _Service.call)(this.$route.params.mac, 'dxSetPortInfo', params).then(function () {
	          _this.$dispatch('update', _this.$route.params.mac, {
	            type: 'info',
	            event: params
	          });
	          _this.alert('success', '', 'Port detail modified');
	        }).then(function () {
	          _this.show = false;
	        });
	      } else {
	        console.log('not changed');
	        this.show = false;
	      }
	      if (this.isOut && this.isFavorite !== (this.favoritePort === this.outputData._id)) {
	        console.log('favorite changes', this.isFavorite);
	        (0, _Service.setUserDeviceFavoritePort)((0, _defineProperty3.default)({}, this.$route.params.mac, this.isFavorite ? this.outputData._id : '0'));
	      }
	    }
	  }
	};

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(22);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vueStrap = __webpack_require__(12);
	
	var _EdidPanel = __webpack_require__(1173);
	
	var _EdidPanel2 = _interopRequireDefault(_EdidPanel);
	
	var _SingleSelect = __webpack_require__(26);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _Service = __webpack_require__(8);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _jquery = __webpack_require__(21);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _EdidDisplayer = __webpack_require__(1183);
	
	var _EdidDisplayer2 = _interopRequireDefault(_EdidDisplayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal,
	    accordion: _vueStrap.accordion,
	    panel: _EdidPanel2.default,
	    'v-select': _SingleSelect2.default,
	    'edid-displayer': _EdidDisplayer2.default
	  },
	  data: function data() {
	    return {
	      showOutConfig: false,
	      outModal: {
	        title: '',
	        _id: '',
	        options: [],
	        option: '1'
	      },
	      showLoadingAni: false,
	      oneAtATime: true,
	      access: '',
	      supportAutoEDID: false,
	      inEDIDReadonly: false,
	      inputs: {},
	      outputs: {},
	      inEDID: {},
	      outEDID: {},
	      defaultEDIDoptions: [],
	      outOptions: [],
	      outTypes: [],
	      editing: {
	        title: '',
	        _id: '',
	        type: '',
	        edidMethod: '',
	        buildInValue: '',
	        fileIsAvilable: false,
	        hexValue: '',
	        outValue: '',
	        outType: ''
	      },
	      showConfig: false,
	      uploadFileBtnText: 'Click to upload file',
	      hexString: ''
	    };
	  },
	  asyncData: function asyncData() {
	    var _this = this;
	
	    var mac = this.$route.params.mac;
	
	    (0, _Service.call)(mac, 'dxGetAbout').then(function (_ref) {
	      var capability = _ref.capability;
	
	      console.log('capability', capability);
	      _this.access = capability.edid.access;
	      _this.supportAutoEDID = capability.edid.supportAutoEDID || false;
	      _this.inEDIDReadonly = capability.edid.inputs === 'ro';
	      return (0, _Service.call)(mac, 'dxGetEDIDOptions');
	    }).then(function (res) {
	      _this.defaultEDIDoptions = res.default.map(function (obj) {
	        return {
	          label: obj.name,
	          value: obj.value
	        };
	      });
	
	      return (0, _Service.call)(mac, 'dxGetPortInfo');
	    }).then(function (_ref2) {
	      var inputs = _ref2.inputs,
	          outputs = _ref2.outputs;
	
	      _this.inputs = inputs;
	      _this.outputs = outputs;
	      _this.outModal.options = [];
	      for (var key in outputs) {
	        _this.outEDID[key] = {
	          isOpen: false,
	          HDBT: '',
	          HDMI: ''
	        };
	      }
	      for (var _key in inputs) {
	        _this.inEDID[_key] = {
	          edid: '',
	          isOpen: false
	        };
	        _this.outModal.options.push({
	          label: 'Input' + _key,
	          value: _key
	        });
	      }
	
	      if (_this.$route.name === 'matrix') {
	        return (0, _Service.call)(mac, 'dxGetMatrixStatus');
	      } else if (_this.$route.name === 'mixer') {
	        return (0, _Service.call)(mac, 'dxGetMixerStatus');
	      }
	    }).then(function (_ref3) {
	      var links = _ref3.links;
	
	      var outputs = _lodash2.default.cloneDeep(_this.outputs);
	      for (var key in outputs) {
	        outputs[key] = _lodash2.default.assignIn(outputs[key], { link: links.outputs[key] });
	      }
	      _this.outputs = _lodash2.default.cloneDeep(outputs);
	      if (_this.access === 'multiple') {
	        return (0, _Service.call)(mac, 'dxGetEDID');
	      } else {
	        return _this.alert('danger', '', 'not support single EDID yet');
	      }
	    }).then(function (_ref4) {
	      var outputs = _ref4.outputs;
	
	      console.log('getEDID outputs', outputs);
	      _this.outOptions = [];
	      _this.outTypes = [];
	      (0, _keys2.default)(outputs).map(function (key) {
	        if (_this.outputs[key].link) {
	          _this.outOptions.push({
	            label: key,
	            value: key
	          });
	
	          _this.outTypes[key] = [];
	          if (outputs[key].HDMI) {
	            _this.outTypes[key].push({
	              label: 'HDMI',
	              value: 'HDMI'
	            });
	          }
	          if (outputs[key].HDBT) {
	            _this.outTypes[key].push({
	              label: 'HDBT',
	              value: 'HDBT'
	            });
	          }
	        }
	      });
	    }).catch(function (err) {
	      _this.alert('danger', '', err);
	      _this.reloadAsyncData();
	    });
	  },
	
	  methods: {
	    toggleOpen: function toggleOpen(e) {
	      var target = e.target;
	      if (!(0, _jquery2.default)(target).is('a')) {
	        target = target.parentNode;
	      }
	      if ((0, _jquery2.default)(target).hasClass('open')) {
	        (0, _jquery2.default)(target).removeClass('open');
	      } else {
	        (0, _jquery2.default)(target).addClass('open');
	      }
	    },
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    showOutModal: function showOutModal(key) {
	      this.outModal.title = 'Output ' + key;
	      this.outModal._id = key;
	      this.showOutConfig = true;
	    },
	    handleOutConfig: function handleOutConfig() {
	      var _this2 = this;
	
	      console.log('handle outConfig');
	      this.showLoadingAni = true;
	      var outKey = this.outModal._id;
	      var mac = this.$route.params.mac;
	
	      var params = {
	        inputs: {}
	      };
	      if (this.outModal.option && this.outModal.option === 'all') {
	        for (var inKey in this.inputs) {
	          params.inputs[inKey] = {
	            type: this.outputs[outKey].type,
	            value: outKey
	          };
	        }
	      } else if (this.outModal.option) {
	        params.inputs = (0, _defineProperty3.default)({}, this.outModal.option, {
	          type: this.outputs[outKey].type,
	          value: outKey
	        });
	      } else {
	        return this.alert('danger', '', 'Please select a valid option');
	      }
	      console.log(params);
	      (0, _Service.call)(mac, 'dxSetEDID', params).then(function (res) {
	        setTimeout(function () {
	          console.log(res);
	          _this2.showLoadingAni = false;
	          _this2.showOutConfig = false;
	        }, 2000);
	      }, function (err) {
	        _this2.alert('danger', '', err);
	        _this2.showLoadingAni = false;
	      });
	    },
	    showModal: function showModal(key) {
	      this.editing.edidMethod = '';
	      this.editing._id = key;
	      this.editing.type = this.inputs[key].type;
	      this.editing.title = 'Input ' + key + ' EDID config';
	      this.editing.outValue = '';
	      this.editing.outType = this.outputs[key] ? this.outputs[key].type : this.outputs['1'].type;
	      this.editing.buildInValue = '';
	      this.showConfig = true;
	    },
	    asyncLoadInData: function asyncLoadInData(key, e) {
	      var _this3 = this;
	
	      console.log('hahaha load inEDID');
	      if (this.inEDID[key].edid !== '') {
	        (0, _jquery2.default)(e.target).parents('.panel').find('.edid_trigger').addClass('open');
	        this.$refs.inPanels[key].isOpen = !this.$refs.inPanels[key].isOpen;
	        this.inEDID[key].isOpen = !this.inEDID[key].isOpen;
	        return;
	      }
	      this.showLoadingAni = true;
	      var mac = this.$route.params.mac;
	
	      (0, _Service.call)(mac, 'dxGetEDID', {
	        inputs: key,
	        type: this.inputs[key].type
	      }).then(function (_ref5) {
	        var inputs = _ref5.inputs;
	
	        console.log(inputs[key]);
	        setTimeout(function () {
	          var newEDID = _lodash2.default.cloneDeep(_this3.inEDID);
	          newEDID = _lodash2.default.assignIn(newEDID, (0, _defineProperty3.default)({}, key, {
	            isOpen: false,
	            edid: inputs[key]
	          }));
	
	          _this3.inEDID = newEDID;
	
	          (0, _jquery2.default)(e.target).parents('.panel').find('.edid_trigger').addClass('open');
	          _this3.$refs.inPanels[key].isOpen = true;
	          _this3.inEDID[key].isOpen = true;
	          _this3.showLoadingAni = false;
	        }, 2000);
	      }).catch(function (err) {
	        _this3.alert('danger', '', err);
	        _this3.showLoadingAni = false;
	      });
	    },
	    asyncLoadOutData: function asyncLoadOutData(key, type, e) {
	      var _this4 = this;
	
	      console.log('asyncLoadOutData', key, type);
	      var mac = this.$route.params.mac;
	
	      console.log('start to load the outEDID');
	      if (type === '') {
	        this.$refs.outPanels[key].isOpen = !this.$refs.outPanels[key].isOpen;
	        this.outEDID[key].isOpen = !this.outEDID[key].isOpen;
	        return;
	      }
	      this.showLoadingAni = true;
	
	      if (type !== 'combo') {
	        (0, _Service.call)(mac, 'dxGetEDID', {
	          outputs: key,
	          type: type
	        }).then(function (_ref6) {
	          var outputs = _ref6.outputs;
	
	          setTimeout(function () {
	            var newEDID = _lodash2.default.cloneDeep(_this4.outEDID);
	            if (outputs[key]) {
	              _lodash2.default.setWith(newEDID, '[' + key + ']', outputs[key]);
	            } else {
	              _lodash2.default.setWith(newEDID, '[' + key + '][\'HDMI\']', 'None');
	              _lodash2.default.setWith(newEDID, '[' + key + '][\'HDBT\']', 'None');
	            }
	            _this4.outEDID = _lodash2.default.cloneDeep(newEDID);
	
	            (0, _jquery2.default)(e.target).parents('.panel').find('.edid_trigger').addClass('open');
	            _this4.$refs.outPanels[key].isOpen = true;
	            _this4.outEDID[key].isOpen = true;
	            _this4.showLoadingAni = false;
	          }, 2000);
	        }).catch(function (err) {
	          _this4.alert('danger', '', err);
	          _this4.showLoadingAni = false;
	        });
	      } else {
	        (0, _Service.call)(mac, 'dxGetEDID', {
	          outputs: key,
	          type: 'HDMI'
	        }).then(function (_ref7) {
	          var outputs = _ref7.outputs;
	
	          var newEDID = _lodash2.default.cloneDeep(_this4.outEDID);
	          if (outputs[key]) {
	            _lodash2.default.setWith(newEDID, '[' + key + '][HDMI]', outputs[key].HDMI);
	          } else {
	            _lodash2.default.setWith(newEDID, '[' + key + '][HDMI]', 'None');
	          }
	          console.log('new EDID', newEDID);
	          _this4.outEDID = _lodash2.default.cloneDeep(newEDID);
	
	          return (0, _Service.call)(mac, 'dxGetEDID', {
	            outputs: key,
	            type: 'HDBT'
	          });
	        }).then(function (_ref8) {
	          var outputs = _ref8.outputs;
	
	          console.log(outputs);
	          setTimeout(function () {
	            var newEDID = _lodash2.default.cloneDeep(_this4.outEDID);
	            if (outputs[key]) {
	              _lodash2.default.setWith(newEDID, '[' + key + '][HDBT]', outputs[key].HDBT);
	            } else {
	              _lodash2.default.setWith(newEDID, '[' + key + '][HDBT]', 'None');
	            }
	            console.log('new EDID', newEDID);
	            _this4.outEDID = _lodash2.default.cloneDeep(newEDID);
	            _this4.showLoadingAni = false;
	
	            (0, _jquery2.default)(e.target).parents('.panel').find('.edid_trigger').addClass('open');
	            _this4.$refs.outPanels[key].isOpen = true;
	            _this4.outEDID[key].isOpen = true;
	          }, 2000);
	        }).catch(function (err) {
	          _this4.alert('danger', '', err);
	          _this4.showLoadingAni = false;
	        });
	      }
	    },
	    hasValidExtension: function hasValidExtension(e) {
	      var fileName = e.target.files[0].name;
	      var extension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase();
	      if (extension === 'bin') {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    detectIE: function detectIE() {
	      var ua = window.navigator.userAgent;
	
	
	      var msie = ua.indexOf('MSIE ');
	      if (msie > 0) {
	        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	      }
	
	      var trident = ua.indexOf('Trident/');
	      if (trident > 0) {
	        var rv = ua.indexOf('rv:');
	        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	      }
	
	      var edge = ua.indexOf('Edge/');
	      if (edge > 0) {
	        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	      }
	
	      return false;
	    },
	    checkFile: function checkFile(e) {
	      var _this5 = this;
	
	      this.editing.fileIsAvilable = false;
	      var files = this.$els.edidbin.files;
	
	
	      if (files.length === 0) return this.alert('danger', '', 'file.length === 0');
	      if (!this.hasValidExtension(e)) {
	        this.alert('danger', '', 'Please upload a valid file(.bin)');
	        this.uploadFileBtnText = 'Click to upload file';
	        return;
	      }
	
	      if (this.detectIE()) {
	        console.log('revise readAsBinaryString of IE');
	
	        var vue = this;
	        window.FileReader.prototype.readAsBinaryString = function (fileData) {
	          var binary = '';
	          var pt = this;
	          var reader = new window.FileReader();
	          reader.onload = function (e) {
	            var bytes = new Uint8Array(reader.result);
	            var length = bytes.byteLength;
	            for (var i = 0; i < length; i++) {
	              binary += String.fromCharCode(bytes[i]);
	            }
	
	            pt.content = binary;
	            for (var _i = 0; _i < pt.content.length; _i++) {
	              var uint = pt.content.charCodeAt(_i);
	              vue.hexString += uint < 16 ? '0' + uint.toString(16) : uint.toString(16);
	            }
	            vue.uploadFileBtnText = files[0].name;
	            (0, _jquery2.default)(pt).trigger('onload');
	          };
	          reader.readAsArrayBuffer(fileData);
	        };
	        var freader = new window.FileReader();
	        freader.readAsBinaryString(files[0]);
	        console.log(this.hexString);
	        console.log(this.hexString.length);
	        if (this.hexString.length !== 512) return this.alert('danger', '', 'Invalid EDID');
	
	        this.editing.hexValue = this.hexString;
	        this.hexString = '';
	        this.editing.fileIsAvilable = true;
	      } else {
	        var _freader = new window.FileReader();
	        var hexString = '';
	        _freader.readAsBinaryString(files[0]);
	        _freader.onload = function () {
	          for (var i = 0; i < _freader.result.length; i++) {
	            var uint = _freader.result.charCodeAt(i);
	            hexString += uint < 16 ? '0' + uint.toString(16) : uint.toString(16);
	          }
	          console.log('result hex string = ', hexString);
	          _this5.uploadFileBtnText = files[0].name;
	        };
	        if (hexString.length !== 512) return this.alert('danger', '', 'Invalid EDID');
	
	        console.log(hexString.length);
	        this.editing.hexValue = hexString;
	        this.editing.fileIsAvilable = true;
	      }
	    },
	    handleApply: function handleApply() {
	      var _this6 = this;
	
	      if (!this.editing.edidMethod) {
	        this.alert('danger', '', 'Please pick where you want to set EDID from');
	        return;
	      }
	      this.showLoadingAni = true;
	      var mac = this.$route.params.mac;
	
	      var params = {};
	      switch (this.editing.edidMethod) {
	        case 'default':
	          if (!this.editing.buildInValue) {
	            this.showLoadingAni = false;
	            this.alert('danger', '', 'Please select a default edid.');
	            return;
	          }
	          params = {
	            inputs: (0, _defineProperty3.default)({}, this.editing._id, {
	              type: 'default',
	              value: this.editing.buildInValue
	            })
	          };
	          break;
	        case 'output':
	          if (!this.editing.outValue) {
	            this.showLoadingAni = false;
	            this.alert('danger', '', 'Please select an output EDID.');
	            return;
	          }
	          if (this.editing.outValue && this.outTypes[this.editing.outValue].length === 0) {
	            this.showLoadingAni = false;
	            this.alert('danger', '', 'The port you pick is not available.');
	            return;
	          }
	          if (!this.editing.outType) {
	            this.showLoadingAni = false;
	            this.alert('danger', '', 'Please select an output EDID type.');
	            return;
	          }
	          params = {
	            inputs: (0, _defineProperty3.default)({}, this.editing._id, {
	              type: this.editing.outType,
	
	              value: this.editing.outValue
	            })
	          };
	          break;
	        case 'custom':
	          if (!this.editing.fileIsAvilable) {
	            this.showLoadingAni = false;
	            this.alert('danger', '', 'Please make sure your file has valid EDID.');
	            return;
	          }
	          params = {
	            inputs: (0, _defineProperty3.default)({}, this.editing._id, {
	              type: 'custom',
	              value: this.editing.hexValue
	            })
	          };
	          console.log(params);
	          break;
	        case 'auto':
	          params = {
	            inputs: (0, _defineProperty3.default)({}, this.editing._id, {
	              type: 'auto'
	            })
	          };
	          break;
	      }
	
	      (0, _Service.call)(mac, 'dxSetEDID', params).then(function (res) {
	        setTimeout(function () {
	          console.log('hahah response');
	          console.log(res);
	          _this6.showLoadingAni = false;
	          _this6.showConfig = false;
	        }, 2000);
	      }).catch(function (err) {
	        _this6.alert('danger', 'Error', err);
	        _this6.showLoadingAni = false;
	      });
	    }
	  },
	  watch: {
	    'editing.edidMethod': function editingEdidMethod(nV) {
	      this.editing.outType = '';
	    },
	    'outModal.option': function outModalOption(nV) {
	      console.log(nV);
	    },
	    'showConfig': function showConfig(nV) {
	      if (!nV) {
	        this.uploadFileBtnText = 'Click to upload file';
	        this.editing.fileIsAvilable = false;
	      }
	    }
	  },
	  events: {
	    update: function update(mac, _ref9) {
	      var type = _ref9.type,
	          event = _ref9.event,
	          msg = _ref9.msg;
	
	      if (type === 'edid') {
	        console.log(type);
	        console.log(event);
	        var obj = _lodash2.default.cloneDeep(this.inEDID);
	        obj = _lodash2.default.assignIn(obj, event.inputs);
	        this.inEDID = obj;
	        this.reloadAsyncData();
	      } else if (type === 'links') {}
	    }
	  },
	  ready: function ready() {
	    if (window.FileReader.prototype.readAsBinaryString === undefined) {
	      window.FileReader.prototype.readAsBinaryString = function (fileData) {
	        var binary = '';
	        var pt = this;
	        var reader = new window.FileReader();
	        var data = void 0;
	        reader.onload = function (e) {
	          if (!e) {
	            data = reader.content;
	          } else {
	            data = e.target.result;
	          }
	          var bytes = new Uint8Array(data);
	          var length = bytes.byteLength;
	          for (var i = 0; i < length; i++) {
	            binary += String.fromCharCode(bytes[i]);
	          }
	
	          pt.content = binary;
	          pt.onload();
	        };
	        reader.readAsBinaryString(fileData);
	      };
	    }
	  }
	};

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _edidParser = __webpack_require__(620);
	
	var _edidParser2 = _interopRequireDefault(_edidParser);
	
	var _mobileDetect = __webpack_require__(56);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    edidString: String
	  },
	  data: function data() {
	    return {
	      headers: {
	        validHeader: 'Valid',
	        productCode: 'Product Code',
	        serialNumber: 'Serial Number',
	        manufactureDate: 'Manufacture Date',
	        edidVersion: 'Edid Version',
	        numberOfExtensions: 'No Of Extensions',
	        checksum: 'Checksum',
	        isMobile: false
	      }
	    };
	  },
	  computed: {
	    isMobile: function isMobile() {
	      var md = new _mobileDetect2.default(window.navigator.userAgent);
	      return md.mobile() !== null;
	    },
	    validChecksums: function validChecksums() {
	      var numberBlocks = this.result.edidData.length / this.result.EDID_BLOCK_LENGTH;
	      var cks = [];
	      for (var i = 0; i < numberBlocks; i++) {
	        cks.push(this.result.validChecksum(i).toString().toUpperCase());
	      }
	      return cks;
	    },
	    result: function result() {
	      return (0, _edidParser2.default)(this.edidString);
	    }
	  },
	  methods: {
	    isTimingBitmapSet: function isTimingBitmapSet(index) {
	      var msb = 0x800000;
	      return (this.result.timingBitmap & msb >> index) !== 0;
	    },
	    isAudioBitSet: function isAudioBitSet(testByte, index) {
	      return (testByte & 1 << index) !== 0;
	    },
	    pad: function pad(num, size) {
	      var s = num + '';
	      while (s.length < size) {
	        s = '0' + s;
	      }return s;
	    },
	    audioType: function audioType(format) {
	      if (format <= this.result.audioFormatArray[0]) return 'lpcm';else if (format <= this.result.audioFormatArray[1]) return 'twoEight';else if (format <= this.result.audioFormatArray[2]) return 'nineThirteen';else if (format <= this.result.audioFormatArray[3]) return 'wmaPro';else return 'extension';
	    },
	    download: function download() {
	      var textFileAsBlob = new window.Blob([this.$els.content.innerText], { type: 'text/plain' });
	      var atag = this.$els.downloadTag;
	      atag.download = 'edid.txt';
	      atag.href = window.URL.createObjectURL(textFileAsBlob);
	      try {
	        atag.click();
	      } catch (e) {
	        window.navigator.msSaveBlob(textFileAsBlob, atag.download);
	      }
	    }
	  }
	};

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(22);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _jquery = __webpack_require__(21);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Service = __webpack_require__(8);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Indicator = __webpack_require__(177);
	
	var _Indicator2 = _interopRequireDefault(_Indicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Indicator: _Indicator2.default
	  },
	  props: {
	    isInstaller: {
	      type: Boolean
	    },
	    cardType: {
	      type: null
	    },
	    outputData: {
	      type: null
	    },
	    inputData: {
	      type: null
	    },
	    isFavorite: {
	      type: Boolean
	    },
	    outputFocus: null,
	    inputFocus: null,
	    inputId: {
	      type: String
	    },
	    highlightInputId: {
	      type: Boolean,
	      default: false
	    },
	    isSwitcher: {
	      type: Boolean,
	      default: false
	    },
	    switcherLayout: {
	      type: Number,
	      default: 0
	    },
	    layoutImgSrc: {
	      type: String,
	      default: ''
	    }
	  },
	  computed: {
	    isOut: function isOut() {
	      return this.cardType === 'output';
	    },
	    isDesktopFocused: function isDesktopFocused() {
	      return this.isOut && this.outputFocus === Number(this.outputData._id) || !this.isOut && this.inputFocus === Number(this.inputData._id);
	    },
	    isMobileFocused: function isMobileFocused() {
	      return !this.isOut && Number(this.inputFocus) === Number(this.inputData._id);
	    }
	  },
	  data: function data() {
	    return {
	      inputImgs: _Service.photos.inputs,
	      outputImgs: _Service.photos.outputs
	    };
	  },
	
	  methods: {
	    cardClick: function cardClick() {
	      this.$emit('focus', this.isOut ? this.outputData._id : this.inputData._id);
	    }
	  },
	  ready: function ready() {
	    var ele = this.$els.content;
	    ele.move = function (left, top, cb) {
	      (0, _jquery2.default)(ele).css({
	        transform: 'translate(' + left + 'px, ' + top + 'px) scale(0)'
	      }).addClass('moving');
	      setTimeout(function () {
	        (0, _jquery2.default)(ele).css({
	          transform: 'none'
	        }).addClass('moved');
	        setTimeout(function () {
	          (0, _jquery2.default)(ele).css({}).removeClass('moving moved');
	        }, 200);
	        cb();
	      }, 600);
	    };
	  },
	
	  events: {
	    update: function update(mac, _ref) {
	      var type = _ref.type,
	          event = _ref.event,
	          msg = _ref.msg;
	
	      var key = (0, _keys2.default)(event.inputs)[0];
	
	      if (key === this.inputId) {
	        console.log(event);
	        console.log(this.inputData);
	        var newInputData = _lodash2.default.cloneDeep(this.inputData);
	        newInputData.link = event.inputs[key];
	        this.inputData = _lodash2.default.cloneDeep(newInputData);
	        console.log(this.inputData);
	      }
	    }
	  }
	};

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getIterator2 = __webpack_require__(28);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(22);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(220);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _jquery = __webpack_require__(21);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Card = __webpack_require__(1181);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardModal = __webpack_require__(1182);
	
	var _CardModal2 = _interopRequireDefault(_CardModal);
	
	var _LayoutCard = __webpack_require__(1184);
	
	var _LayoutCard2 = _interopRequireDefault(_LayoutCard);
	
	var _vueStrap = __webpack_require__(12);
	
	var _Swiper = __webpack_require__(530);
	
	var _Swiper2 = _interopRequireDefault(_Swiper);
	
	var _Service = __webpack_require__(8);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LAYOUT_SWITCHER = ['SW-5004DE', 'SW-5005DE', 'SW-5004DA'];
	var NO_LAYOUT_SWITCHER = 'SW-5004RZ';
	exports.default = {
	  components: {
	    Card: _Card2.default,
	    LayoutCard: _LayoutCard2.default,
	    modal: _vueStrap.modal,
	    radioGroup: _vueStrap.radioGroup,
	    CardModal: _CardModal2.default,
	    Swiper: _Swiper2.default,
	    dropdown: _vueStrap.dropdown,
	    radio: _vueStrap.radioBtn,
	    vSelect: _vueStrap.select
	  },
	  data: function data() {
	    return {
	      inputTrans: false,
	      user: {},
	      showCardDetail: false,
	      showConfirm: false,
	      confirmMsg: '',
	      confirmCb: function confirmCb() {},
	      loggedEvent: '',
	      capability: null,
	      mapping: {},
	      editing: {},
	      icons: {
	        quick: [__webpack_require__(253), __webpack_require__(525), __webpack_require__(526)]
	      },
	      iconsSW5005DE: {
	        quick: [__webpack_require__(253), __webpack_require__(1078), __webpack_require__(1079)]
	      },
	      outputCards: [],
	      outputImgs: _Service.photos.outputs,
	      inputCards: [],
	      inputImgs: _Service.photos.inputs,
	      profiles: [],
	      favoritePort: null,
	      mobile: {
	        outputFocus: null,
	        inputFocus: null },
	      desktop: {
	        outputFocus: null,
	        inputFocus: null
	      },
	      isSingleMapping: false,
	      deviceModel: '',
	      switcherLayout: '-1'
	    };
	  },
	  asyncData: function asyncData() {
	    var _this = this;
	
	    console.log('async datat start');
	    var mac = this.$route.params.mac;
	
	    var inputCards = {};
	    var outputCards = {};
	    var profiles = [];
	    return (0, _Service.call)(mac, 'dxGetPortInfo').then(function (_ref) {
	      var inputs = _ref.inputs,
	          outputs = _ref.outputs;
	
	      console.log('getPortInfo');
	      inputCards = inputs;
	      outputCards = outputs;
	      for (var key in inputCards) {
	        if (!(inputCards[key].photo && _lodash2.default.isString(inputCards[key].photo))) {
	          if (inputCards[key].photo) {
	            console.log(inputCards[key].photo);
	            inputCards[key].photo = inputCards[key].photo.toString;
	          } else {
	            inputCards[key].photo = '1';
	          }
	        }
	        if (!inputCards[key].name) {
	          inputCards[key].name = 'No Name';
	        }
	      }
	      return (0, _Service.call)(mac, 'dxGetAbout');
	    }).then(function (_ref2) {
	      var capability = _ref2.capability,
	          model = _ref2.model;
	
	      _this.capability = capability;
	      if (capability.vendor) _this.$dispatch('vendor', capability.vendor);
	      _this.deviceModel = model;
	      console.log('device model is', model);
	
	      if (_this.deviceModel.toUpperCase().includes('SW')) {
	        (0, _Service.call)(_this.$route.params.mac, 'dxGetSwitcherLayout').then(function (_ref3) {
	          var layout = _ref3.layout,
	              error = _ref3.error;
	
	          if (error) {
	            console.log(error);
	            _this.switcherLayout = '0';
	          } else {
	            console.log('get switcherLayout ', layout);
	            _this.switcherLayout = layout;
	          }
	        }).catch(function (err) {
	          console.log(err);
	        });
	      }
	      return (0, _Service.call)(mac, 'dxGetMatrixStatus');
	    }).then(function (_ref4) {
	      var mapping = _ref4.mapping,
	          channels = _ref4.channels,
	          links = _ref4.links,
	          quality = _ref4.quality;
	
	      console.log('getMarixStatus');
	      console.log('mapping', mapping);
	      console.log('channels', channels);
	      console.log('links', links);
	      console.log('quality', quality);
	      _this.mapping = mapping;
	      for (var port in inputCards) {
	        _lodash2.default.assignIn(inputCards[port], {
	          _id: port,
	          cardType: 'input',
	          img: _this.inputImgs[port],
	          quality: quality.inputs[port],
	          link: links.inputs[port]
	        });
	      }
	      for (var _port in outputCards) {
	        _lodash2.default.assignIn(outputCards[_port], {
	          _id: _port,
	          cardType: 'output',
	          img: _this.outputImgs[_port],
	          quality: quality.inputs[_port],
	          link: links.outputs[_port]
	        });
	      }
	      return (0, _Service.call)(mac, 'dxGetHDCP');
	    }).then(function (_ref5) {
	      var inputs = _ref5.inputs,
	          outputs = _ref5.outputs;
	
	      console.log('getHDCP');
	      console.log('inputs', inputs);
	      console.log('outputs', outputs);
	      for (var port in inputCards) {
	        _lodash2.default.assignIn(inputCards[port], {
	          HDCP: inputs[port]
	        });
	      }
	      for (var _port2 in outputCards) {
	        _lodash2.default.assignIn(outputCards[_port2], {
	          HDCP: outputs[_port2]
	        });
	      }
	
	      if (_this.isSwitcher && _this.isLayoutSwitcher) {
	        outputCards[-1] = {
	          _id: -1,
	          name: 'quad'
	        };
	        outputCards[-2] = {
	          _id: -2,
	          name: 'left'
	        };
	        outputCards[-3] = {
	          _id: -3,
	          name: 'right'
	        };
	      } else if (!_this.isSwitcher) {
	        outputCards[0] = {
	          _id: 0,
	          name: 'all'
	        };
	        inputCards[0] = {
	          _id: 0,
	          name: 'mute'
	        };
	      }
	      return (0, _Service.call)(mac, 'dxGetMaps');
	    }).then(function (_ref6) {
	      var maps = _ref6.maps;
	
	      console.log('get maps');
	      console.log('maps', maps);
	      for (var key in maps) {
	        profiles[key] = {
	          label: '',
	          value: '',
	          mapping: {}
	        };
	        profiles[key].label = maps[key].name;
	        profiles[key].value = key;
	        profiles[key].mapping = maps[key].mapping;
	      }
	
	      _this.outputCards = outputCards;
	      _this.inputCards = inputCards;
	      _this.profiles = profiles;
	      console.log('async done');
	    }).catch(function (err) {
	      _this.alert('danger', 'Error', err.message);
	    });
	  },
	
	  computed: {
	    isSW5005DE: function isSW5005DE() {
	      return this.deviceModel === 'SW-5005DE';
	    },
	    isSwitcher: function isSwitcher() {
	      console.log('isSwitcher', this.deviceModel.toUpperCase().includes('SW'));
	      this.$dispatch('updateIsSwitcher', this.deviceModel.toUpperCase().includes('SW'));
	      return this.deviceModel.toUpperCase().includes('SW');
	    },
	    isLayoutSwitcher: function isLayoutSwitcher() {
	      console.log('isLayoutSwitcher', LAYOUT_SWITCHER.includes(this.deviceModel.toUpperCase()));
	      return LAYOUT_SWITCHER.includes(this.deviceModel.toUpperCase());
	    },
	    isNoLayoutSwitcher: function isNoLayoutSwitcher() {
	      console.log('isNoLayoutSwitcher', this.deviceModel.toUpperCase() === NO_LAYOUT_SWITCHER);
	      console.error('model in computed is', this.deviceModel);
	      return this.deviceModel.toUpperCase() === NO_LAYOUT_SWITCHER;
	    },
	    hdcp: function hdcp() {
	      return {
	        inputs: {
	          enabled: {
	            readable: this.capability.hdcp.inputs.enable.indexOf('r') >= 0,
	            settable: this.capability.hdcp.inputs.enable.indexOf('w') >= 0
	          },
	          engine: {
	            readable: this.capability.hdcp.inputs.type.indexOf('r') >= 0,
	            settable: this.capability.hdcp.inputs.type.indexOf('w') >= 0
	          }
	        },
	        outputs: {
	          enabled: {
	            readable: this.capability.hdcp.outputs.enable.indexOf('r') >= 0,
	            settable: this.capability.hdcp.outputs.enable.indexOf('w') >= 0
	          },
	          engine: {
	            readable: this.capability.hdcp.outputs.type.indexOf('r') >= 0,
	            settable: this.capability.hdcp.outputs.type.indexOf('w') >= 0
	          }
	        }
	      };
	    }
	  },
	  events: {
	    update: function update(mac, _ref7) {
	      var type = _ref7.type,
	          event = _ref7.event,
	          msg = _ref7.msg;
	
	      switch (type) {
	        case 'mapping':
	          _lodash2.default.assignIn(this.mapping, event);
	          break;
	
	        case 'info':
	          for (var inputNum in event.inputs) {
	            var newInputCards = _lodash2.default.cloneDeep(this.inputCards);
	            _lodash2.default.assignIn(newInputCards[inputNum], event.inputs[inputNum]);
	            this.inputCards = newInputCards;
	          }
	
	          for (var outputNum in event.outputs) {
	            var newOutputCards = _lodash2.default.cloneDeep(this.outputCards);
	            _lodash2.default.assignIn(newOutputCards[outputNum], event.outputs[outputNum]);
	            this.outputCards = newOutputCards;
	          }
	          break;
	
	        case 'links':
	          if (event.inputs && (0, _typeof3.default)(event.inputs) === 'object') {
	            var _newInputCards = _lodash2.default.cloneDeep(this.inputCards);
	            var inputKeys = (0, _keys2.default)(event.inputs);
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	              for (var _iterator = (0, _getIterator3.default)(inputKeys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var key = _step.value;
	
	                _newInputCards[key].link = event.inputs[key];
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }
	
	            this.inputCards = _lodash2.default.cloneDeep(_newInputCards);
	          }
	          if (event.outputs && (0, _typeof3.default)(event.outputs) === 'object') {
	            var outputKeys = (0, _keys2.default)(event.outputs);
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	              for (var _iterator2 = (0, _getIterator3.default)(outputKeys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var _key = _step2.value;
	
	                console.log(_key);
	                this.outputCards[_key].link = event.outputs[_key];
	              }
	            } catch (err) {
	              _didIteratorError2 = true;
	              _iteratorError2 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                  _iterator2.return();
	                }
	              } finally {
	                if (_didIteratorError2) {
	                  throw _iteratorError2;
	                }
	              }
	            }
	          }
	          this.$broadcast('update', mac, { type: type, event: event, msg: msg });
	          break;
	
	        case 'quality':
	          if (event.inputs && (0, _typeof3.default)(event.inputs) === 'object') {
	            var _inputKeys = (0, _keys2.default)(event.inputs);
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	              for (var _iterator3 = (0, _getIterator3.default)(_inputKeys), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var _key2 = _step3.value;
	
	                this.inputCards[_key2].quality = event.inputs[_key2];
	              }
	            } catch (err) {
	              _didIteratorError3 = true;
	              _iteratorError3 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                  _iterator3.return();
	                }
	              } finally {
	                if (_didIteratorError3) {
	                  throw _iteratorError3;
	                }
	              }
	            }
	          }
	
	          if (event.outputs && (0, _typeof3.default)(event.outputs) === 'object') {
	            var _outputKeys = (0, _keys2.default)(event.outputs);
	            var _iteratorNormalCompletion4 = true;
	            var _didIteratorError4 = false;
	            var _iteratorError4 = undefined;
	
	            try {
	              for (var _iterator4 = (0, _getIterator3.default)(_outputKeys), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                var _key3 = _step4.value;
	
	                this.outputCards[_key3].quality = event.outputs[_key3];
	              }
	            } catch (err) {
	              _didIteratorError4 = true;
	              _iteratorError4 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                  _iterator4.return();
	                }
	              } finally {
	                if (_didIteratorError4) {
	                  throw _iteratorError4;
	                }
	              }
	            }
	          }
	
	          break;
	        case 'switcherLayout':
	          if (typeof event.layout === 'string') {
	            this.switcherLayout = event.layout;
	          }
	          break;
	      }
	    },
	    user: function user(uid, _user) {
	      this.user = _user;
	    },
	    favoritePort: function favoritePort(favoriteData) {
	      for (var mac in favoriteData) {
	        if (mac === this.$route.params.mac) {
	          this.favoritePort = favoriteData[mac];
	        }
	      }
	    }
	  },
	  methods: {
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    setSwitcherLayout: function setSwitcherLayout(layout) {
	      var _this2 = this;
	
	      console.log('layout in setSwitcherLayout', layout);
	      console.log('mapping in setSwitcherLayout', this.desktop.inputFocus);
	      if (this.desktop.inputFocus) {
	        (0, _Service.call)(this.$route.params.mac, 'dxSetMappingAndLayout', {
	          layout: layout,
	          mapping: { '1': String(this.desktop.inputFocus) }
	        }).then(function (res) {
	          console.log(res);
	        });
	      } else {
	        (0, _Service.call)(this.$route.params.mac, 'dxSetSwitcherLayout', {
	          layout: layout
	        }).then(function (res) {
	          if (res.error) {
	            _this2.alert('danger', '', res.error.msg);
	          } else {}
	        });
	      }
	    },
	    setSwitcherLayoutAndMapping: function setSwitcherLayoutAndMapping(layout, mapping) {
	      console.log('set layout and mapping');
	      (0, _Service.call)(this.$route.params.mac, 'dxSetMappingAndLayout', {
	        layout: layout,
	        mapping: mapping
	      }).then(function (res) {
	        console.log(res);
	      });
	    },
	    handleCardDetail: function handleCardDetail(outData, inData, isOut) {
	      this.editing = {
	        outData: outData,
	        inData: inData,
	        isOut: isOut
	      };
	      if (outData) {
	        if (outData.cardType) {
	          this.showCardDetail = true;
	        }
	      } else {
	        if (inData.cardType) {
	          this.showCardDetail = true;
	        }
	      }
	    },
	    handleDragStart: function handleDragStart(evt, inIndex, isInput) {
	      if (isInput) {
	        if (this.desktop.inputFocus !== null && this.desktop.outputFocus === null) {
	          this.desktop.inputFocus = Number(inIndex);
	        }
	        evt.dataTransfer.setData('inIndex', inIndex);
	      } else {
	        return;
	      }
	    },
	    handleDrop: function handleDrop(evt, outIndex, isForLayout, layout) {
	      var inIndex = evt.dataTransfer.getData('inIndex');
	      console.log('!inIndex', !inIndex);
	      if (!inIndex) return;
	      var mapping = (0, _defineProperty3.default)({}, outIndex, inIndex);
	      if (this.isLayoutSwitcher) {
	        if (isForLayout) {
	          console.log('drop to layout card');
	
	          this.setSwitcherLayoutAndMapping(layout, mapping);
	        } else {
	          if (layout === '-1') {
	            this.setSwitcherLayoutAndMapping('0', mapping);
	          }
	        }
	      } else {
	        if (outIndex === '0') {
	          this.handleDropAll(evt);
	        } else {
	          if (inIndex) {
	            this.mapping[outIndex] = inIndex;
	            this.updateMapping('Mapping Changed', mapping);
	          }
	        }
	      }
	
	      if (!this.desktop.inputFocus && (this.desktop.outputFocus || this.desktop.outputFocus === 0)) {
	        this.desktop.outputFocus = Number(outIndex);
	      }
	    },
	    handleOver: function handleOver() {},
	    handleDropAll: function handleDropAll(evt) {
	      var inIndex = evt.dataTransfer.getData('inIndex');
	      if (inIndex) {
	        for (var key in this.mapping) {
	          if (key !== '0') {
	            this.mapping[key] = inIndex;
	          }
	        }
	        this.updateMapping('Mapping Changed', this.mapping);
	      }
	    },
	    handleConfirmModal: function handleConfirmModal(msg, callback) {
	      var _this3 = this;
	
	      var confirmCb = function confirmCb() {
	        callback();
	        _this3.showConfirm = false;
	      };
	      this.confirmMsg = msg;
	      this.confirmCb = confirmCb;
	      this.showConfirm = true;
	    },
	    updateMapping: function updateMapping(msg, mappingDiff) {
	      var _this4 = this;
	
	      (0, _Service.call)(this.$route.params.mac, 'dxSetMapping', { mapping: mappingDiff }).then(function () {}, function (err) {
	        _this4.alert('danger', '', err);
	      });
	    },
	    updateList: function updateList(output, input) {
	      this.updateMapping('Mapping list updated', (0, _defineProperty3.default)({}, output, input));
	    },
	    loadProfileFrom: function loadProfileFrom(index) {
	      var _this5 = this;
	
	      (0, _Service.call)(this.$route.params.mac, 'dxGetMaps').then(function (_ref8) {
	        var maps = _ref8.maps;
	
	        _this5.handleConfirmModal('Load Profile ' + index + ' and set it to current mapping ?', function () {
	          _this5.mapping = maps[index].mapping;
	          _this5.updateMapping('New Profile loaded', _this5.mapping);
	        });
	      });
	    },
	    saveCurProfileTo: function saveCurProfileTo(index) {
	      var _this6 = this;
	
	      this.handleConfirmModal('Save Current mapping into profiles ' + index + ' ?', function () {
	        (0, _Service.call)(_this6.$route.params.mac, 'dxSetMaps', {
	          maps: (0, _defineProperty3.default)({}, index, {
	            name: _this6.profiles[index].label,
	            mapping: _this6.mapping
	          })
	        }).then(function (_ref9) {
	          var maps = _ref9.maps;
	
	          _this6.alert('success', '', 'Current profile saved!');
	          console.log('done');
	        });
	      });
	    },
	    mobileUpdateMapping: function mobileUpdateMapping() {
	      if (this.isLayoutSwitcher) {
	        this.mapping[1] = String(this.mobile.inputFocus + 1);
	        this.setSwitcherLayoutAndMapping(String(Math.abs(this.mobile.outputFocus)), this.mapping);
	      } else {
	        if (this.mobile.outputFocus === 0) {
	          this.mobileUpdateMappingAll();
	        } else {
	          this.mapping[this.mobile.outputFocus] = String(this.mobile.inputFocus);
	          this.updateMapping('Mapping Changed', (0, _defineProperty3.default)({}, this.mobile.outputFocus, String(this.mobile.inputFocus)));
	        }
	        this.$log('mapping');
	      }
	      console.log('final outputFocus', this.mobile.outputFocus);
	      console.log('final inputFocus', this.mobile.inputFocus);
	      console.log('final mapping', this.mapping);
	      console.log('final layout', this.switcherLayout);
	    },
	    mobileUpdateMappingAll: function mobileUpdateMappingAll() {
	      for (var key in this.mapping) {
	        if (key !== '0') {
	          this.mapping[key] = String(this.mobile.inputFocus);
	        }
	      }
	      this.updateMapping('Mapping Changed all', this.mapping);
	    },
	    onOutSwiperEnd: function onOutSwiperEnd(currentPage) {
	      this.mobile.outputFocus = currentPage;
	    },
	    onInSwiperEnd: function onInSwiperEnd(currentPage) {
	      this.mobile.inputFocus = currentPage;
	    },
	    desktopOutputFocus: function desktopOutputFocus(clickedOutput) {
	      if (this.isNoLayoutSwitcher) return;
	      if (this.desktop.inputFocus !== null) {
	        this.applyMapping(this.desktop.inputFocus, Number(clickedOutput));
	      } else {
	        this.desktop.outputFocus = this.desktop.outputFocus === Number(clickedOutput) ? null : Number(clickedOutput);
	      }
	      console.log('final outpuFocus', this.desktop.outputFocus);
	    },
	    desktopInputFocus: function desktopInputFocus(clickedInput) {
	      if (this.isNoLayoutSwitcher) return;
	      if (this.desktop.outputFocus !== null) {
	        this.applyMapping(Number(clickedInput), this.desktop.outputFocus);
	      } else {
	        this.desktop.inputFocus = this.desktop.inputFocus === Number(clickedInput) ? null : Number(clickedInput);
	      }
	      console.log('final inputFocus', this.desktop.inputFocus);
	    },
	    applyMapping: function applyMapping(input, output) {
	      var _this7 = this;
	
	      var ie = this.$refs.desktopInputCard[input].$els.content;
	      var oe = this.$refs.desktopOutputCard[output].$els.content;
	      var dx = (0, _jquery2.default)(oe).offset().left - (0, _jquery2.default)(ie).offset().left;
	      var dy = (0, _jquery2.default)(oe).offset().top - (0, _jquery2.default)(ie).offset().top;
	      var outputValueToSet = output;
	      var inputValueToSet = String(input);
	
	      console.log('set', outputValueToSet, inputValueToSet);
	      ie.move(dx, dy, function () {
	        if (outputValueToSet === 0) {
	          for (var key in _this7.mapping) {
	            if (key !== 0) {
	              _this7.mapping[key] = inputValueToSet;
	            }
	          }
	        } else {
	          _this7.mapping[outputValueToSet] = inputValueToSet;
	        }
	        if (outputValueToSet === 0) {
	          _this7.updateMapping('Mapping Changed', _this7.mapping);
	        } else {
	          _this7.updateMapping('Mapping Changed', (0, _defineProperty3.default)({}, outputValueToSet, inputValueToSet));
	        }
	      });
	    }
	  }, ready: function ready() {
	    var _this8 = this;
	
	    this.user = (0, _Service.getUser)();
	    (0, _Service.getDeviceFavorite)(this.$route.params.mac).then(function (favoritePort) {
	      _this8.favoritePort = favoritePort;
	      _this8.mobile.outputFocus = Number(favoritePort);
	      _this8.mobile.inputFocus = 1;
	    });
	  },
	
	  route: {
	    canReuse: false, activate: function activate(_ref10) {
	      var next = _ref10.next;
	
	      next();
	    }
	  }
	};

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _Service = __webpack_require__(8);
	
	var _vueStrap = __webpack_require__(12);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _jquery = __webpack_require__(21);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { modal: _vueStrap.modal },
	  data: function data() {
	    return {
	      showModal: false,
	      editing: {
	        index: null,
	        profile: {}
	      },
	      profiles: {},
	      outputCards: [],
	      inputCards: []
	    };
	  },
	  asyncData: function asyncData() {
	    var mac = this.$route.params.mac;
	
	    var inputCards = {};
	    var outputCards = {};
	
	    return (0, _Service.call)(mac, 'dxGetPortInfo').then(function (_ref) {
	      var inputs = _ref.inputs,
	          outputs = _ref.outputs;
	
	      inputCards = inputs;
	      outputCards = outputs;
	      return (0, _Service.call)(mac, 'dxGetMaps');
	    }).then(function (_ref2) {
	      var maps = _ref2.maps;
	
	      return {
	        profiles: maps,
	        inputCards: inputCards,
	        outputCards: outputCards
	      };
	    });
	  },
	
	  events: {
	    update: function update(mac, _ref3) {
	      var type = _ref3.type,
	          event = _ref3.event;
	
	      if (type === 'maps') {
	        _lodash2.default.assignIn(this.profiles, event);
	      }
	    }
	  },
	  methods: {
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    toSwitchModal: function toSwitchModal(key) {
	      this.showModal = true;
	      this.editing.index = key;
	      this.editing.profile = _lodash2.default.cloneDeep(this.profiles[key]);
	    },
	    cancel: function cancel(profile) {
	      this.showModal = false;
	      this.editing.index = null;
	    },
	    applyChange: function applyChange() {
	      var _this = this;
	
	      console.log('applyChange');
	      if (this.$newProfileName.newname.valid && this.editing.profile.name) {
	        (0, _Service.call)(this.$route.params.mac, 'dxSetMaps', {
	          maps: (0, _defineProperty3.default)({}, this.editing.index, this.editing.profile)
	        }).then(function () {
	          _this.profiles[_this.editing.index] = _this.editing.profile;
	          _this.alert('success', 'Modified', 'Profiles ' + _this.editing.index + ' modified.');
	          _this.showModal = false;
	        }, function (rejected) {
	          _this.alert('danger', 'Error', rejected);
	        });
	      } else {
	        this.alert('danger', '', 'Please enter at least 1 English character and number only.');
	      }
	    }
	  },
	  watch: {
	    showModal: function showModal(nv) {
	      if (!nv) {
	        (0, _jquery2.default)('.popout').scrollTop(0);
	      }
	    }
	  }
	};

/***/ }),
/* 653 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  components: {},
	  data: function data() {
	    return {};
	  },
	  asyncData: function asyncData() {},
	
	  computed: {},
	  methods: {}, ready: function ready() {},
	
	  watch: {}
	};

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Service = __webpack_require__(8);
	
	exports.default = {
	  components: {},
	  data: function data() {
	    return {
	      ports: {}
	    };
	  },
	  asyncData: function asyncData() {
	    var _this = this;
	
	    var mac = this.$route.params.mac;
	
	    (0, _Service.call)(mac, 'dxGetPortStatus').then(function (_ref) {
	      var ports = _ref.ports;
	
	      _this.ports = ports;
	    });
	  },
	
	  computed: {},
	  methods: {}, ready: function ready() {},
	
	  watch: {}
	};

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Service = __webpack_require__(8);
	
	var _vueStrap = __webpack_require__(12);
	
	var _SingleSelect = __webpack_require__(26);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal,
	    'v-select': _SingleSelect2.default
	  },
	  data: function data() {
	    return {
	      loadingData: true,
	      device: {},
	      keyToDisable: ['type', 'id', 'owner_id', 'installer_id', 'created_at', 'installer_email', 'mfg', 'updated_at', 'platform', 'online', 'service_tag', 'name'],
	      editting: {},
	      newNickname: '',
	      types: ['', 'DPS', 'Matrix', 'Mixer', 'Video wall', 'MES', 'DIO'],
	      namesToShow: {
	        mac_address: 'Mac Address',
	        type_id: 'Type',
	        serial_no: 'Serial No.',
	        ip_address: 'Device IP',
	        id: 'Device Id',
	        model_name: 'Model',
	        firmware_version: 'Firmware',
	        nickname: 'Device Name',
	        mfg: 'MFG',
	        updated_at: 'Update at',
	        platform: 'Platform',
	        online: 'Online'
	      },
	      showConfirm: false,
	      confirmMsg: '',
	      confirmCb: function confirmCb() {},
	      capability: {},
	      timezoneOptions: [],
	      timezone: {},
	      timezoneIndex: '',
	      timezoneKeyAry: []
	    };
	  },
	  asyncData: function asyncData() {
	    var _this = this;
	
	    var mac = this.$route.params.mac;
	
	    var deviceRet = {};
	
	    return (0, _Service.getSpecificDevice)(mac).then(function (device) {
	      _this.newNickname = device.nickname;
	      for (var key in device) {
	        if (_this.keyToDisable.indexOf(key) === -1) {
	          deviceRet[key] = device[key];
	        }
	      }
	
	      return (0, _Service.call)(mac, 'dxGetAbout');
	    }).then(function (_ref) {
	      var firmware = _ref.firmware,
	          capability = _ref.capability,
	          lanAddress = _ref.lanAddress;
	
	      deviceRet.firmware_version = firmware;
	      deviceRet.ip_address = lanAddress;
	      _this.loadingData = false;
	      return {
	        device: deviceRet,
	        capability: capability
	      };
	    }).catch(function (err) {
	      console.error(err);
	      setTimeout(_this.reloadAsyncData, 1000);
	    });
	  },
	
	  computed: {},
	  events: {},
	  methods: {
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    chgName: function chgName() {
	      var _this2 = this;
	
	      var newDevice = _lodash2.default.clone(this.device);
	      console.log('apply');
	      if (this.$deviceNameValidator.devicename.valid && this.newNickname) {
	        (0, _Service.changeDeviceNickname)(this.$route.params.mac, this.newNickname.trim()).then(function () {
	          newDevice.nickname = _this2.newNickname;
	          _this2.device = newDevice;
	
	          _this2.alert('success', '', 'Device Name has been set to \'' + _this2.newNickname + '\'.');
	        });
	      } else {
	        this.alert('danger', '', 'Please enter at least one English character or number only.');
	      }
	    },
	    handleConfirmModal: function handleConfirmModal(msg, callback) {
	      var _this3 = this;
	
	      var confirmCb = function confirmCb() {
	        callback();
	        _this3.showConfirm = false;
	      };
	      this.confirmMsg = msg;
	      this.confirmCb = confirmCb;
	      this.showConfirm = true;
	    },
	    handleMaintenance: function handleMaintenance() {
	      var _this4 = this;
	
	      (0, _Service.hasNewFirmware)({
	        mac: this.$route.params.mac,
	        version: this.device.firmware_version
	      }).then(function (newV) {
	        if (newV) {
	          _this4.handleConfirmModal('Your device is on firmware ' + _this4.device.firmware_version + ' Do you want to update to ' + newV + '?', function () {
	            (0, _Service.call)(_this4.$route.params.mac, 'dxUpdateFirmware', { url: newV });
	          });
	        } else {
	          _this4.handleConfirmModal('Your device firmware is the lastest .');
	        }
	      });
	    },
	    rollbackFirmware: function rollbackFirmware() {
	      var _this5 = this;
	
	      this.handleConfirmModal('Are you sure you want to rollback?', function () {
	        (0, _Service.call)(_this5.$route.params.mac, 'dxRollbackDevice', {});
	      });
	    },
	    resetToFactoryDefault: function resetToFactoryDefault() {
	      var _this6 = this;
	
	      this.handleConfirmModal('Do you want to reset the device to factory default?', function () {
	        (0, _Service.call)(_this6.$route.params.mac, 'dxDefaultDevice', {}).then(function (resolved) {
	          console.log('resolved: ', resolved);
	        }, function (rejected) {
	          console.log('in rejected');
	          _this6.alert('danger', 'Error resetting to factory default', rejected);
	        });
	      });
	    },
	    reboot: function reboot() {
	      var _this7 = this;
	
	      this.handleConfirmModal('Do you want to reboot the device?', function () {
	        (0, _Service.call)(_this7.$route.params.mac, 'dxResetDevice', {}).then(function (resolved) {
	          console.log(resolved);
	        }, function (rejected) {
	          _this7.alert('danger', 'Error in reboot', rejected);
	        });
	      });
	    },
	    setNetwork: function setNetwork() {
	      var _this8 = this;
	
	      console.log('set network');
	      var obj = {};
	      if ((obj.dhcpEnabled = this.editting.dhcpEnabled) === false) {
	        if (this.$dhcpValidation.ip.valid && this.$dhcpValidation.netmask.valid && this.$dhcpValidation.gateway.valid) {
	          obj.dhcpEnabled = false;
	          obj.deviceIpAddress = this.editting.deviceIpAddress;
	          obj.deviceSubnetMask = this.editting.deviceSubnetMask;
	          obj.deviceDefaultGateway = this.editting.deviceDefaultGateway;
	        } else {
	          this.alert('danger', '', 'Please enter valid ip or valid netmask or valid gateway.');
	          return;
	        }
	      }
	
	      (0, _Service.call)(this.$route.params.mac, 'dxSetNetworkSettings', obj).then(function (resolved) {
	        if (resolved.error && resolved.error.msg) {
	          _this8.alert('danger', '', resolved.error.msg);
	        } else {
	          console.log(resolved);
	        }
	      }, function (rejected) {
	        if (rejected.error || rejected.error.msg) {
	          _this8.alert('danger', '', rejected.error || rejected.error.msg);
	        }
	      });
	    }
	  } };

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(156);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getIterator2 = __webpack_require__(28);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(22);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _regenerator = __webpack_require__(54);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(53);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _vueStrap = __webpack_require__(12);
	
	var _Service = __webpack_require__(8);
	
	var _SingleSelect = __webpack_require__(26);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _Screen = __webpack_require__(257);
	
	var _Screen2 = _interopRequireDefault(_Screen);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _mobileDetect = __webpack_require__(56);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	var _jquery = __webpack_require__(21);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal,
	    dropdown: _vueStrap.dropdown,
	    tabs: _vueStrap.tabset,
	    tab: _vueStrap.tab,
	    'v-select': _SingleSelect2.default,
	    'v-screen': _Screen2.default
	  },
	  data: function data() {
	    return {
	      model: '',
	      InteractEvent: {},
	      focus: '1',
	      layerNameAry: ['', 'A', 'B', 'C', 'D'],
	      editing: {
	        _id: '',
	        outRatio: [],
	        outResolution: '',
	        outLayout: '',
	        outSplit: '',
	        splitLayer: []
	      },
	      showWindowConfig: false,
	      label: {},
	      editingWindow: {
	        _id: '',
	        _name: '',
	        title: '',
	        showLabel: false,
	        window: {},
	        input: {},
	        custom: {},
	        osd: {},
	        enableBorder: false,
	        enableTally: false,
	        mapping: {}
	      },
	      sourceOptions: [{ label: 'Source 1', value: '1' }, { label: 'Source 2', value: '2' }, { label: 'Source 3', value: '3' }, { label: 'Source 4', value: '4' }],
	      splits: {
	        setting: {
	          '1': [],
	          '2': [],
	          '3': [],
	          '4': []
	        }
	      },
	      splitLayer: [],
	      links: {},
	      crop: {},
	      radio: {
	        enlarge: 0,
	        narrow: 0
	      },
	      outResolutionOptions: {},
	      outResolution: '',
	      outLayout: 'init',
	      customSplit: '',
	      fullScreenSplit: '',
	      quickSelectSplit: '2*2',
	      customLabelEnabled: false,
	      ww: 0,
	      wh: 0,
	      profiles: {},
	      mapping: {},
	      showChgConfirm: false,
	      saveToPreset: '1',
	      layoutChanged: false,
	      leavePage: function leavePage() {},
	      applyCurrentChange: function applyCurrentChange() {},
	      stop: function stop() {}
	    };
	  },
	  asyncData: function () {
	    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var _this = this;
	
	      var mac, newProfile, i, _ref2, profiles;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              mac = this.$route.params.mac;
	              newProfile = {};
	
	              if (!this.$root.mixerProfile) {
	                this.$root.mixerProfile = {};
	              }
	
	              if (this.$root.mixerProfile[mac]) {
	                _context.next = 25;
	                break;
	              }
	
	              _context.prev = 4;
	              i = 1;
	
	            case 6:
	              if (!(i < 9)) {
	                _context.next = 16;
	                break;
	              }
	
	              console.log(i);
	              _context.next = 10;
	              return (0, _Service.call)(mac, 'dxGetProfiles', {
	                profile: i.toString()
	              });
	
	            case 10:
	              _ref2 = _context.sent;
	              profiles = _ref2.profiles;
	
	              newProfile[i] = profiles;
	
	            case 13:
	              i++;
	              _context.next = 6;
	              break;
	
	            case 16:
	
	              this.profiles = _lodash2.default.cloneDeep(newProfile);
	              this.$root.mixerProfile[mac] = newProfile;
	              _context.next = 23;
	              break;
	
	            case 20:
	              _context.prev = 20;
	              _context.t0 = _context['catch'](4);
	
	              console.error(_context.t0);
	
	            case 23:
	              _context.next = 26;
	              break;
	
	            case 25:
	              this.profiles = _lodash2.default.cloneDeep(this.$root.mixerProfile[mac]);
	
	            case 26:
	
	              (0, _Service.call)(mac, 'dxGetSplitArea').then(function (res) {
	                _this.splits = _lodash2.default.cloneDeep(res);
	                return (0, _Service.call)(mac, 'dxGetOutputResolution');
	              }).then(function (_ref3) {
	                var resolution = _ref3.resolution;
	
	                _this.outResolution = resolution['1'];
	                return (0, _Service.call)(mac, 'dxGetOutputResolutionOptions');
	              }).then(function (_ref4) {
	                var options = _ref4.options;
	
	                _this.outResolutionOptions = options;
	                return (0, _Service.call)(mac, 'dxGetMixerStatus');
	              }).then(function (_ref5) {
	                var mapping = _ref5.mapping;
	
	                _this.mapping = mapping;
	                return (0, _Service.call)(mac, 'dxGetLabel');
	              }).then(function (label) {
	                _this.label = label;
	                return (0, _Service.call)(mac, 'dxGetAbout');
	              }).then(function (_ref6) {
	                var model = _ref6.model;
	
	                console.log('model', model);
	                _this.model = model;
	                return (0, _Service.call)(mac, 'dxGetSplitLayer');
	              }).then(function (_ref7) {
	                var layer = _ref7.layer;
	
	                _this.editing.splitLayer = layer;
	                _this.$broadcast('render', '1');
	                _this.$broadcast('chgZindex', layer, '1');
	              }).catch(function (err) {
	                console.log(err);
	                _this.alert('danger', '', err);
	              });
	
	            case 27:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this, [[4, 20]]);
	    }));
	
	    function asyncData() {
	      return _ref.apply(this, arguments);
	    }
	
	    return asyncData;
	  }(),
	
	  computed: {
	    in4K: function in4K() {
	      if (this.model === 'MX-5004MZ2') return false;
	      return this.outResolutionOptions[this.outResolution] === '3840x2160@60' || this.outResolutionOptions[this.outResolution] === '1080 to 4K2K@60';
	    },
	    outRatio: function outRatio() {
	      console.log('in layout , change outRatio');
	      var ratio = [];
	      switch (this.outResolutionOptions[this.outResolution]) {
	        case '800x600':
	        case '800x600@60':
	        default:
	          ratio = [4, 3, 200];
	          break;
	        case '4096x2160@23.98':
	        case '4096x2160@29.97':
	        case '4096x2160@59.94':
	          ratio = [16, 135, 256];
	          break;
	        case '3840x2160@23.98':
	        case '3840x2160@29.97':
	        case '3840x2160@59.94':
	        case '3840x2160@24':
	        case '3840x2160@25':
	        case '3840x2160@30':
	        case '3840x2160@50':
	        case '3840x2160@60':
	          ratio = [16, 9, 240];
	          break;
	        case '1920x1200':
	        case '1920x1200@60':
	          ratio = [16, 10, 120];
	          break;
	        case '1080 to 4K2K@60':
	        case '1920x1080':
	        case '1920x1080@50':
	        case '1920x1080@60':
	        case '1920x1080@23.98':
	        case '1920x1080@29.97':
	        case '1920x1080@59.94':
	          ratio = [16, 9, 120];
	          break;
	        case '1600x1200@60':
	          ratio = [16, 12, 100];
	          break;
	        case '1440x900@60':
	          ratio = [8, 5, 180];
	          break;
	        case '1400x900@60':
	          ratio = [14, 9, 100];
	          break;
	        case '1366x768@60':
	          ratio = [16, 9, 85];
	          break;
	        case '1280x1024@60':
	          ratio = [5, 4, 256];
	          break;
	        case '1280x960@60':
	          ratio = [4, 3, 320];
	          break;
	        case '1280x768@60':
	          ratio = [5, 3, 256];
	          break;
	        case '1280x720@50':
	        case '1280x720@60':
	        case '1280x720@23.98':
	        case '1280x720@29.97':
	        case '1280x720@59.94':
	          ratio = [16, 9, 80];
	          break;
	        case '1024x768@60':
	          ratio = [4, 3, 256];
	          break;
	        case '720x480@60':
	          ratio = [3, 2, 240];
	          break;
	        case '1680x1050@60':
	          ratio = [8, 5, 210];
	          break;
	
	        case '640x480':
	        case '640x480@60':
	          ratio = [4, 3, 160];
	          break;
	      }
	
	      var md = new _mobileDetect2.default(window.navigator.userAgent);
	      if (md.mobile() !== null && window.innerWidth < 768) {
	        this.ww = window.innerWidth;
	        if (this.ww === 568) {
	          ratio.push(Math.round(360 / ratio[0]));
	        } else if (this.ww === 684) {
	          ratio.push(Math.round(500 / ratio[0]));
	        } else if (this.ww > 568 && this.ww <= 667) {
	          ratio.push(Math.round(460 / ratio[0]));
	        } else if (this.ww > 667 && this.ww <= 736) {
	          ratio.push(Math.round(520 / ratio[0]));
	        } else {
	          ratio.push(Math.round(300 / ratio[0]));
	        }
	      } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
	        ratio.push(Math.round(480 / ratio[0]));
	      } else if (window.innerWidth >= 992 && window.innerWidth < 1200) {
	        ratio.push(Math.round(600 / ratio[0]));
	      } else if (window.innerWidth >= 1200) {
	        ratio.push(Math.round(800 / ratio[0]));
	      }
	
	      return ratio;
	    },
	    isMobile: function isMobile() {
	      var md = new _mobileDetect2.default(window.navigator.userAgent);
	      return md.mobile() !== null && this.wh > this.ww;
	    },
	    computedOutResolutionOptions: function computedOutResolutionOptions() {
	      var options = [];
	      var keys = (0, _keys2.default)(this.outResolutionOptions);
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var key = _step.value;
	
	          options.push({
	            label: this.outResolutionOptions[key],
	            value: key
	          });
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return options;
	    },
	    whichSplit: function whichSplit() {
	      if (this.outLayout === 'quick') {
	        return this.quickSelectSplit;
	      } else if (this.outLayout === 'full') {
	        return this.fullScreenSplit;
	      } else if (this.outLayout === 'custom') {
	        return this.customsplit;
	      }
	    },
	    profileOptions: function profileOptions() {
	      var opts = [];
	      for (var profile in this.profiles) {
	        opts.push({
	          label: this.profiles[profile].name,
	          value: profile
	        });
	      }
	      return opts;
	    }
	  },
	  methods: {
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    onSortEnd: function onSortEnd(event) {
	      if (this.in4K) return;
	      this.layoutChanged = true;
	      var newLayer = [];
	      var newEditing = _lodash2.default.cloneDeep(this.editing);
	      var mac = this.$route.params.mac;
	
	
	      _jquery2.default.each((0, _jquery2.default)('.dragItem'), function (i, val) {
	        newLayer.push(parseInt((0, _jquery2.default)(val).attr('data-index')));
	      });
	      newEditing.splitLayer = _lodash2.default.cloneDeep(newLayer);
	      this.editing = _lodash2.default.cloneDeep(newEditing);
	
	      var params = {
	        layer: this.editing.splitLayer
	      };
	
	      (0, _Service.call)(mac, 'dxSetSplitLayer', params).then(function (res) {});
	    },
	    _editingWindowBorderToBoolean: function _editingWindowBorderToBoolean() {
	      if (this.label.osd[this.focus].border === 0) {
	        this.editingWindow.enableBorder = false;
	        this.editingWindow.enableTally = false;
	      } else if (this.label.osd[this.focus].border === 1) {
	        this.editingWindow.enableBorder = true;
	        this.editingWindow.enableTally = false;
	      } else if (this.label.osd[this.focus].border === 2) {
	        this.editingWindow.enableBorder = true;
	        this.editingWindow.enableTally = true;
	      }
	    },
	    _editingBooleanToWindowBorder: function _editingBooleanToWindowBorder() {
	      var border = this.editingWindow.enableBorder;
	      var tally = this.editingWindow.enableTally;
	
	      if (border & tally) {
	        this.editingWindow.osd.border = 2;
	      } else if (border & !tally) {
	        this.editingWindow.osd.border = 1;
	      } else if (!border) {
	        this.editingWindow.osd.border = 0;
	      }
	    },
	    handleWindowConfig: function handleWindowConfig() {
	      if (!this.focus) return this.alert('danger', '', 'Please select a window');
	
	      this.editingWindow.window = _lodash2.default.cloneDeep(this.label.windows[this.focus]);
	      this.editingWindow.input = _lodash2.default.cloneDeep(this.label.inputs[this.focus]);
	      this.editingWindow.custom = _lodash2.default.cloneDeep(this.label.custom[this.focus]);
	      this.editingWindow.osd = _lodash2.default.cloneDeep(this.label.osd[this.focus]);
	      this.editingWindow.mapping = _lodash2.default.cloneDeep(this.mapping);
	      var windowName = ['', 'A', 'B', 'C', 'D'];
	
	      this._editingWindowBorderToBoolean();
	
	      this.editingWindow._id = this.focus;
	      this.editingWindow._name = windowName[this.focus];
	      this.editingWindow.title = 'Window ' + windowName[this.focus];
	
	      this.showWindowConfig = true;
	    },
	    applyChgSource: function applyChgSource() {
	      var _this2 = this;
	
	      var mac = this.$route.params.mac;
	
	      var params2 = {
	        mapping: (0, _defineProperty3.default)({}, this.focus, this.editingWindow.mapping[this.focus])
	      };
	
	      (0, _Service.call)(mac, 'dxSetMapping', params2).then(function (res) {
	        console.log('done setMapping', res);
	      }).catch(function (err) {
	        _this2.alert('danger', '', err);
	      });
	    },
	    applyChgLabel: function applyChgLabel() {
	      var _this3 = this;
	
	      var mac = this.$route.params.mac;
	
	      this._editingBooleanToWindowBorder();
	      var params = {
	        osd: (0, _defineProperty3.default)({}, this.editingWindow._id, this.editingWindow.osd),
	        windows: (0, _defineProperty3.default)({}, this.editingWindow._id, this.editingWindow.window),
	        inputs: (0, _defineProperty3.default)({}, this.editingWindow._id, this.editingWindow.input),
	        custom: (0, _defineProperty3.default)({}, this.editingWindow._id, this.editingWindow.custom)
	      };
	
	      (0, _Service.call)(mac, 'dxSetLabel', params).then(function (res) {}).catch(function (err) {
	        _this3.alert('danger', '', err);
	      });
	    },
	    applySplit: function applySplit(target) {
	      var _this4 = this;
	
	      var mac = this.$route.params.mac;
	
	      var params2 = {
	        setting: (0, _defineProperty3.default)({}, this.focus, this.splits.setting[this.focus])
	      };
	      console.log(params2);
	      (0, _Service.call)(mac, 'dxSetSplitArea', params2).then(function (res) {}).catch(function (err) {
	        _this4.alert('danger', '', err);
	      });
	    },
	    saveProfile: function saveProfile(key) {
	      var _this5 = this;
	
	      console.log(key);
	      var mac = this.$route.params.mac;
	
	      (0, _Service.call)(mac, 'dxSetProfileByKey', { profiles: key }).then(function (res) {
	        console.log(res);
	        _this5.layoutChanged = false;
	      }).catch(function (err) {
	        _this5.alert('danger', '', err);
	      });
	    },
	    updateRootMixerProfile: function updateRootMixerProfile(key, profile) {
	      var mac = this.$route.params.mac;
	
	      console.log(key);
	      this.profiles[key] = _lodash2.default.cloneDeep(profile);
	      this.$root.mixerProfile[mac][key] = _lodash2.default.cloneDeep(profile);
	    },
	    onInputChange: function onInputChange(index) {
	      if (this.in4K) return;
	      switch (index) {
	        case 0:
	          if (parseInt(this.splits.setting[this.focus][index]) < 0) return this.alert('danger', '', 'The split entered needs to be larger than 0');
	          break;
	        case 2:
	          if (this.splits.setting[this.focus][0] >= parseInt(this.splits.setting[this.focus][2]) || parseInt(this.splits.setting[this.focus][index]) > this.outRatio[0] * this.outRatio[2]) return this.alert('danger', '', 'The split entered needs to be larger than the start or smaller than screen width');
	          break;
	        case 1:
	          if (parseInt(this.splits.setting[this.focus][index]) < 0) return this.alert('danger', '', 'The split entered needs to be larger than 0');
	          break;
	        case 3:
	          if (this.splits.setting[this.focus][1] >= parseInt(this.splits.setting[this.focus][3]) || parseInt(this.splits.setting[this.focus][index]) > this.outRatio[1] * this.outRatio[2]) return this.alert('danger', '', 'The split entered needs to be larger than the start or smaller than screen height');
	          break;
	      }
	      this.layoutChanged = true;
	      this.splits.setting[this.focus][index] = parseInt(this.splits.setting[this.focus][index]);
	      this.applySplit(this.focus);
	      this.$broadcast('render', '1');
	    },
	    addListener: function addListener() {
	      var _this6 = this;
	
	      this.ww = window.innerWidth;
	      this.wh = window.innerHeight;
	      setTimeout(function () {
	        console.log('ww');
	        console.log(_this6.ww);
	        _this6.$broadcast('render', '1');
	      }, 1000);
	    },
	    applyCurrentChange: function applyCurrentChange() {
	      console.log('meht');
	    },
	    leavePage: function leavePage() {
	      console.log('asdfadfsas');
	    }
	  }, ready: function ready() {
	    this.ww = window.innerWidth;
	    this.wh = window.innerHeight;
	    window.addEventListener('orientationchange', this.addListener, false);
	    window.addEventListener('resize', this.addListener, false);
	  },
	
	  route: {
	    deactivate: function deactivate(transition) {
	      var vue = this;
	      window.removeEventListener('orientationchange', this.addListener, false);
	      window.removeEventListener('resize', this.addListener, false);
	      if (!this.layoutChanged) {
	        transition.next();
	      } else {
	        return new _promise2.default(function (resolve, reject) {
	          var _this7 = this;
	
	          vue.showChgConfirm = true;
	          vue.leavePage = function () {
	            resolve();
	          };
	          vue.applyCurrentChange = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	              while (1) {
	                switch (_context2.prev = _context2.next) {
	                  case 0:
	                    vue.saveProfile(vue.saveToPreset);
	                    resolve();
	
	                  case 2:
	                  case 'end':
	                    return _context2.stop();
	                }
	              }
	            }, _callee2, _this7);
	          }));
	          vue.stop = function () {
	            reject();
	            vue.showChgConfirm = false;
	          };
	        });
	      }
	    }
	  },
	  events: {
	    resizeend: function resizeend(_ref9) {
	      var target = _ref9.target;
	
	      console.log('target', target);
	      this.applySplit(target);
	    },
	    dragend: function dragend(_ref10) {
	      var target = _ref10.target;
	
	      console.log('target', target);
	      this.applySplit(target);
	    },
	    gestureend: function gestureend(_ref11) {
	      var target = _ref11.target;
	
	      console.log('gesture', target);
	      this.applySplit(target);
	    },
	    resizemove: function resizemove(event) {
	      this.InteractEvent = _lodash2.default.cloneDeep(event);
	    },
	    update: function update(mac, _ref12) {
	      var _this8 = this;
	
	      var type = _ref12.type,
	          event = _ref12.event,
	          msg = _ref12.msg;
	
	      console.log('got event:', type);
	      switch (type) {
	        case 'layer':
	          this.splitLayer = event.layer;
	          setTimeout(function () {
	            _this8.$broadcast('chgZindex', _this8.splitLayer, '1');
	          }, 700);
	          break;
	        case 'mapping':
	          var newMapping = _lodash2.default.cloneDeep(this.mapping);
	          _lodash2.default.assignIn(newMapping, event);
	          this.mapping = _lodash2.default.cloneDeep(newMapping);
	          break;
	        case 'split':
	          console.log(event);
	          var newSplit = _lodash2.default.cloneDeep(this.splits);
	          _lodash2.default.assignIn(newSplit.setting, event.setting);
	          this.splits = _lodash2.default.cloneDeep(newSplit);
	          this.outLayout = 'init';
	          setTimeout(function () {
	            _this8.$broadcast('render', '1');
	          }, 700);
	          break;
	        case 'label':
	          console.log(event);
	          var newLabel = _lodash2.default.cloneDeep(this.label);
	          var _event$inputs = event.inputs,
	              inputs = _event$inputs === undefined ? {} : _event$inputs,
	              _event$windows = event.windows,
	              windows = _event$windows === undefined ? {} : _event$windows,
	              _event$custom = event.custom,
	              custom = _event$custom === undefined ? {} : _event$custom,
	              _event$osd = event.osd,
	              osd = _event$osd === undefined ? {} : _event$osd;
	
	
	          if (inputs) _lodash2.default.assignIn(newLabel.inputs, event.inputs);
	          if (windows) _lodash2.default.assignIn(newLabel.windows, event.windows);
	          if (custom) _lodash2.default.assignIn(newLabel.custom, event.custom);
	          if (osd) _lodash2.default.assignIn(newLabel.osd, event.osd);
	
	          this.label = _lodash2.default.cloneDeep(newLabel);
	          this._editingWindowBorderToBoolean();
	          break;
	        case 'resolution':
	          this.outResolution = event['1'];
	
	          setTimeout(function () {
	            _this8.$broadcast('render', '1');
	          }, 700);
	          break;
	        case 'preset':
	          var key = (0, _keys2.default)(event)[0];
	          this.updateRootMixerProfile(key, event[key]);
	          break;
	      }
	    }
	  },
	  watch: {
	    outLayout: function outLayout(nv) {
	      if (nv === 'full') {
	        this.fullScreenSplit = '1';
	      }
	    },
	    'editingWindow.osd.enabled': function editingWindowOsdEnabled(nv) {
	      if (!nv) {
	        this.editingWindow.window.enabled = false;
	        this.editingWindow.enableBorder = false;
	        this.editingWindow.input.enabled = false;
	        this.editingWindow.enableTally = false;
	      }
	    },
	    showWindowConfig: function showWindowConfig(nv) {
	      if (!nv) {
	        (0, _jquery2.default)('.single_window_config').scrollTop(0);
	      }
	    }
	  }
	};

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(22);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _regenerator = __webpack_require__(54);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(53);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _Service = __webpack_require__(8);
	
	var _vueStrap = __webpack_require__(12);
	
	var _SingleSelect = __webpack_require__(26);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _Screen = __webpack_require__(257);
	
	var _Screen2 = _interopRequireDefault(_Screen);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _jquery = __webpack_require__(21);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _mobileDetect = __webpack_require__(56);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var md = new _mobileDetect2.default(window.navigator.userAgent);
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal,
	    'v-select': _SingleSelect2.default,
	    'v-screen': _Screen2.default
	  },
	  data: function data() {
	    return {
	      showTestAPI: false,
	      showEditModal: false,
	      showPreviewModal: false,
	      profiles: {},
	      editingProfile: {
	        _id: '',
	        title: '',
	        name: '',
	        mapping: {
	          '1': '',
	          '2': '',
	          '3': '',
	          '4': ''
	        },
	        layer: [],
	        split: {
	          '1': [],
	          '2': [],
	          '3': [],
	          '4': []
	        }
	      },
	      mappingOptions: [{ label: 'Source 1', value: '1' }, { label: 'Source 2', value: '2' }, { label: 'Source 3', value: '3' }, { label: 'Source 4', value: '4' }],
	      winNameAry: ['', 'A', 'B', 'C', 'D'],
	      outResolution: '',
	      outResolutionOptions: {},
	      outLayout: 'custom',
	      label: {},
	      splitsAry: {
	        '1': {},
	        '2': {},
	        '3': {},
	        '4': {},
	        '5': {},
	        '6': {},
	        '7': {},
	        '8': {}
	      },
	      previewProfile: {
	        title: '',
	        _id: '1'
	      }
	    };
	  },
	  asyncData: function () {
	    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var _this = this;
	
	      var mac, newProfile, newSplitsAry, i, _ref2, profiles, _i;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              mac = this.$route.params.mac;
	              newProfile = {};
	              newSplitsAry = {};
	
	              if (!this.$root.mixerProfile) {
	                this.$root.mixerProfile = {};
	              }
	
	              if (this.$root.mixerProfile[mac]) {
	                _context.next = 28;
	                break;
	              }
	
	              _context.prev = 5;
	              i = 1;
	
	            case 7:
	              if (!(i < 9)) {
	                _context.next = 18;
	                break;
	              }
	
	              console.log(i);
	              _context.next = 11;
	              return (0, _Service.call)(mac, 'dxGetProfiles', {
	                profile: i.toString()
	              });
	
	            case 11:
	              _ref2 = _context.sent;
	              profiles = _ref2.profiles;
	
	              newProfile[i] = profiles;
	              newSplitsAry[i] = {
	                setting: profiles.split
	              };
	
	            case 15:
	              i++;
	              _context.next = 7;
	              break;
	
	            case 18:
	
	              this.profiles = _lodash2.default.cloneDeep(newProfile);
	              this.splitsAry = _lodash2.default.cloneDeep(newSplitsAry);
	              this.$root.mixerProfile[mac] = newProfile;
	              _context.next = 26;
	              break;
	
	            case 23:
	              _context.prev = 23;
	              _context.t0 = _context['catch'](5);
	
	              console.error(_context.t0);
	
	            case 26:
	              _context.next = 31;
	              break;
	
	            case 28:
	              this.profiles = _lodash2.default.cloneDeep(this.$root.mixerProfile[mac]);
	              for (_i = 1; _i < 9; _i++) {
	                newSplitsAry[_i] = {
	                  setting: this.profiles[_i].split
	                };
	              }
	              this.splitsAry = _lodash2.default.cloneDeep(newSplitsAry);
	
	            case 31:
	
	              (0, _Service.call)(mac, 'dxGetOutputResolution').then(function (_ref3) {
	                var resolution = _ref3.resolution;
	
	                _this.outResolution = resolution['1'];
	                return (0, _Service.call)(mac, 'dxGetOutputResolutionOptions');
	              }).then(function (_ref4) {
	                var options = _ref4.options;
	
	                _this.outResolutionOptions = options;
	                return (0, _Service.call)(mac, 'dxGetLabel');
	              }).then(function (label) {
	                _this.label = label;
	                console.log('Profile data ready');
	                setTimeout(function () {
	                  _this.$broadcast('render', 'all');
	                }, 1000);
	              }).catch(function (err) {
	                console.error(err);
	              });
	
	            case 32:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this, [[5, 23]]);
	    }));
	
	    function asyncData() {
	      return _ref.apply(this, arguments);
	    }
	
	    return asyncData;
	  }(),
	
	  computed: {
	    outRatio: function outRatio() {
	      var ratio = [];
	      switch (this.outResolutionOptions[this.outResolution]) {
	        case '800x600':
	        case '800x600@60':
	        default:
	          ratio = [4, 3, 200];
	          break;
	        case '4096x2160@23.98':
	        case '4096x2160@29.97':
	        case '4096x2160@59.94':
	          ratio = [16, 135, 256];
	          break;
	        case '3840x2160@23.98':
	        case '3840x2160@29.97':
	        case '3840x2160@59.94':
	        case '3840x2160@24':
	        case '3840x2160@25':
	        case '3840x2160@30':
	        case '3840x2160@50':
	        case '3840x2160@60':
	          ratio = [16, 9, 240];
	          break;
	        case '1920x1200':
	        case '1920x1200@60':
	          ratio = [16, 10, 120];
	          break;
	        case '1080 to 4K2K@60':
	        case '1920x1080':
	        case '1920x1080@50':
	        case '1920x1080@60':
	        case '1920x1080@23.98':
	        case '1920x1080@29.97':
	        case '1920x1080@59.94':
	          ratio = [16, 9, 120];
	          break;
	        case '1600x1200@60':
	          ratio = [16, 12, 100];
	          break;
	        case '1440x900@60':
	          ratio = [8, 5, 180];
	          break;
	        case '1400x900@60':
	          ratio = [14, 9, 100];
	          break;
	        case '1366x768@60':
	          ratio = [16, 9, 85];
	          break;
	        case '1280x1024@60':
	          ratio = [5, 4, 256];
	          break;
	        case '1280x960@60':
	          ratio = [4, 3, 320];
	          break;
	        case '1280x768@60':
	          ratio = [5, 3, 256];
	          break;
	        case '1280x720@50':
	        case '1280x720@60':
	        case '1280x720@23.98':
	        case '1280x720@29.97':
	        case '1280x720@59.94':
	          ratio = [16, 9, 80];
	          break;
	        case '1024x768@60':
	          ratio = [4, 3, 256];
	          break;
	        case '720x480@60':
	          ratio = [3, 2, 240];
	          break;
	        case '1680x1050@60':
	          ratio = [8, 5, 210];
	          break;
	
	        case '640x480':
	        case '640x480@60':
	          ratio = [4, 3, 160];
	          break;
	      }
	      ratio.push(Math.round(280 / ratio[0]));
	      return ratio;
	    },
	    isMobile: function isMobile() {
	      console.log(window.innerWidth);
	      return md.mobile() !== null && window.innerWidth < 768;
	    }
	  },
	  methods: {
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    handleShowGraphPreview: function handleShowGraphPreview(key) {
	      var _this2 = this;
	
	      console.log('handle show graph preview' + key);
	      this.previewProfile._id = key;
	      this.previewProfile.title = 'Preset ' + key + ' graph preview';
	      this.showPreviewModal = true;
	      setTimeout(function () {
	        _this2.$broadcast('render', key);
	      }, 30);
	    },
	    handleShowModal: function handleShowModal(key) {
	      this.editingProfile._id = key;
	      this.editingProfile.title = 'Preset ' + key + ' detail';
	      this.editingProfile.mapping = this.profiles[key].mapping;
	      this.editingProfile.split = this.profiles[key].split;
	      this.editingProfile.layer = this.profiles[key].layer;
	      this.editingProfile.name = this.profiles[key].name;
	      this.showEditModal = true;
	    },
	    updateRootMixerProfile: function updateRootMixerProfile(key, profile) {
	      var _this3 = this;
	
	      var mac = this.$route.params.mac;
	
	      console.log(key);
	      console.log(profile);
	      this.profiles[key] = _lodash2.default.cloneDeep(profile);
	      this.splitsAry[key] = _lodash2.default.cloneDeep({
	        setting: profile.split
	      });
	      this.$root.mixerProfile[mac][key] = _lodash2.default.cloneDeep(profile);
	      setTimeout(function () {
	        _this3.$broadcast('render', key);
	      }, 700);
	    },
	    handleApply: function handleApply() {
	      var _this4 = this;
	
	      var rex = /^-{0,1}[0-9]+/;
	      for (var i in this.editingProfile.split) {
	        for (var j in this.editingProfile.split[i]) {
	          if (!rex.test(parseInt(this.editingProfile.split[i][j]))) {
	            return this.alert('danger', '', 'Please enter valid numbers');
	          }
	
	          if (j > 1 && j < 4 && parseInt(this.editingProfile.split[i][j]) < parseInt(this.editingProfile.split[i][j - 2])) {
	            return this.alert('danger', '', 'First split of each row can not be larger than the second.');
	          }
	        }
	      }
	
	      var mac = this.$route.params.mac;
	
	      var params = {
	        profiles: (0, _defineProperty3.default)({}, this.editingProfile._id, {
	          name: this.editingProfile.name,
	          mapping: this.editingProfile.mapping,
	          split: this.editingProfile.split,
	          layer: this.editingProfile.layer
	        })
	      };
	      (0, _Service.call)(mac, 'dxSetProfiles', params).then(function (res) {
	        _this4.updateRootMixerProfile(_this4.editingProfile._id);
	        var newSplitsAry = _lodash2.default.cloneDeep(_this4.splitsAry);
	
	        newSplitsAry[_this4.editingProfile._id].setting = params.profiles[_this4.editingProfile._id].split;
	
	        _this4.splitsAry = _lodash2.default.cloneDeep(newSplitsAry);
	        _this4.showEditModal = false;
	
	        setTimeout(function () {
	          _this4.$broadcast('render', _this4.editingProfile._id);
	          _this4.$broadcast('chgZindex', _this4.profiles[_this4.editingProfile._id].layer, _this4.editingProfile._id);
	        }, 300);
	      }).catch(function (err) {
	        _this4.alert('danger', '', err);
	      });
	    },
	    onSortEnd: function onSortEnd(event) {
	      var newLayer = [];
	      var newEditing = _lodash2.default.cloneDeep(this.editingProfile);
	      _jquery2.default.each((0, _jquery2.default)('.dragItem'), function (i, val) {
	        newLayer.push(parseInt((0, _jquery2.default)(val).attr('data-index')));
	      });
	      newEditing.layer = _lodash2.default.cloneDeep(newLayer);
	      this.editingProfile = _lodash2.default.cloneDeep(newEditing);
	    }
	  }, ready: function ready() {},
	
	  watch: {
	    showEditModal: function showEditModal(nv) {
	      if (!nv) {
	        (0, _jquery2.default)('.single_profile_edit_modal').scrollTop(0);
	      }
	    }
	  },
	  events: {
	    update: function update(mac, _ref5) {
	      var type = _ref5.type,
	          event = _ref5.event,
	          msg = _ref5.msg;
	
	      console.log('got event:', type);
	      switch (type) {
	        case 'preset':
	          var key = (0, _keys2.default)(event)[0];
	          console.log('key in event', key);
	          console.log(event);
	          this.updateRootMixerProfile(key, event[key]);
	          break;
	      }
	    }
	  }
	};

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getIterator2 = __webpack_require__(28);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(22);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _regenerator = __webpack_require__(54);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(53);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _vueStrap = __webpack_require__(12);
	
	var _Tabset = __webpack_require__(258);
	
	var _Tabset2 = _interopRequireDefault(_Tabset);
	
	var _Loader = __webpack_require__(256);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Service = __webpack_require__(8);
	
	var _SingleSelect = __webpack_require__(26);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _Screen = __webpack_require__(257);
	
	var _Screen2 = _interopRequireDefault(_Screen);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _mobileDetect = __webpack_require__(56);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	var _jquery = __webpack_require__(21);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resolution4KList = ['3840x2160@24', '3840x2160@25', '3840x2160@30', '3840x2160@50', '3840x2160@60', '1080 to 4K2K@60'];
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal,
	    tabs: _Tabset2.default,
	    tab: _vueStrap.tab,
	    'v-select': _SingleSelect2.default,
	    'v-screen': _Screen2.default,
	    'v-loader': _Loader2.default
	  },
	  data: function data() {
	    return {
	      model: '',
	      isUpdatingProfile: false,
	      showLoadingProfile: false,
	      showOutSetting: false,
	      icons: {
	        full: [__webpack_require__(1072), __webpack_require__(1073), __webpack_require__(1074), __webpack_require__(1075)],
	        quick: [__webpack_require__(253), __webpack_require__(1076), __webpack_require__(1077), __webpack_require__(525), __webpack_require__(526)]
	      },
	      splits: {
	        setting: {
	          '1': [],
	          '2': [],
	          '3': [],
	          '4': []
	        }
	      },
	      splitLayer: [],
	      links: {},
	      outResolutionOptions: {},
	      outResolution: '',
	      outResolutionChanged: false,
	      outLayout: 'init',
	      customSplit: '',
	      fullScreenSplit: '',
	      quickSelectSplit: '2*2',
	      customOptions: [{ label: '1', value: '1' }, { label: '2', value: '2' }, { label: '3', value: '3' }, { label: '4', value: '4' }, { label: '5', value: '5' }, { label: '6', value: '6' }, { label: '7', value: '7' }, { label: '8', value: '8' }],
	      fullScreenOptions: [{ label: 'A', value: '1', splitOptionKey: 'Full-A' }, { label: 'B', value: '2', splitOptionKey: 'Full-B' }, { label: 'C', value: '3', splitOptionKey: 'Full-C' }, { label: 'D', value: '4', splitOptionKey: 'Full-D' }],
	      quickSelectionOptions: [{ label: '2*2', value: '2*2', splitOptionKey: 'PAP1' }, { label: '1*3_top', value: 't', splitOptionKey: 'PAP2' }, { label: '1*3_bottom', value: 'b', splitOptionKey: 'PAP3' }, { label: '1*3_left', value: 'l', splitOptionKey: 'PAP4' }, { label: '1*3_right', value: 'r', splitOptionKey: 'PAP5' }],
	      soundFromOptions: [{ label: 'Source 1', value: '1' }, { label: 'Source 2', value: '2' }, { label: 'Source 3', value: '3' }, { label: 'Source 4', value: '4' }],
	      channelOptions: [{ label: 'Channel 1&2', value: '1' }, { label: 'Channel 3&4', value: '2' }, { label: 'Channel 5&6', value: '3' }, { label: 'Channel 7&8', value: '4' }],
	      outSound: {
	        soundFrom: '1',
	        soundRLChannel: '1',
	        fullScreenAudio: false,
	        mute: false
	      },
	      outSoundChanged: false,
	      outVideo: {
	        verticalFlip: true,
	        mirror: false
	      },
	      outVideoChanged: false,
	      outColor: {
	        brightness: 50,
	        contrast: 50,
	        saturation: 50
	      },
	      outColorChanged: false,
	      ww: 0,
	      profiles: {},
	      editing: {
	        outSound: {},
	        outColor: {},
	        outVideo: {},
	        outResolution: '',
	        sourceLabel: {}
	      },
	      label: {},
	      mapping: {},
	      buttonDisabled: false
	    };
	  },
	  asyncData: function () {
	    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var _this = this;
	
	      var mac, newProfile, i, _ref2, profiles;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              mac = this.$route.params.mac;
	              newProfile = {};
	
	              this.showLoadingProfile = true;
	
	              if (!this.$root.mixerProfile) {
	                this.$root.mixerProfile = {};
	              }
	
	              if (this.$root.mixerProfile[mac]) {
	                _context.next = 26;
	                break;
	              }
	
	              _context.prev = 5;
	              i = 1;
	
	            case 7:
	              if (!(i < 9)) {
	                _context.next = 17;
	                break;
	              }
	
	              console.log(i);
	              _context.next = 11;
	              return (0, _Service.call)(mac, 'dxGetProfiles', {
	                profile: i.toString()
	              });
	
	            case 11:
	              _ref2 = _context.sent;
	              profiles = _ref2.profiles;
	
	              newProfile[i] = profiles;
	
	            case 14:
	              i++;
	              _context.next = 7;
	              break;
	
	            case 17:
	
	              this.profiles = _lodash2.default.cloneDeep(newProfile);
	              this.$root.mixerProfile[mac] = newProfile;
	              _context.next = 24;
	              break;
	
	            case 21:
	              _context.prev = 21;
	              _context.t0 = _context['catch'](5);
	
	              console.error(_context.t0);
	
	            case 24:
	              _context.next = 27;
	              break;
	
	            case 26:
	              this.profiles = _lodash2.default.cloneDeep(this.$root.mixerProfile[mac]);
	
	            case 27:
	
	              (0, _Service.call)(mac, 'dxGetSplitArea').then(function (res) {
	                _this.splits = _lodash2.default.cloneDeep(res);
	                return (0, _Service.call)(mac, 'dxGetOutputResolution');
	              }).then(function (_ref3) {
	                var resolution = _ref3.resolution;
	
	                _this.outResolution = resolution['1'];
	                return (0, _Service.call)(mac, 'dxGetOutputResolutionOptions');
	              }).then(function (_ref4) {
	                var options = _ref4.options;
	
	                _this.outResolutionOptions = options;
	                return (0, _Service.call)(mac, 'dxGetMixerStatus');
	              }).then(function (_ref5) {
	                var mapping = _ref5.mapping;
	
	                _this.mapping = mapping;
	                return (0, _Service.call)(mac, 'dxGetOutputVideo');
	              }).then(function (_ref6) {
	                var video = _ref6.video;
	
	                _this.outVideo = video;
	                return (0, _Service.call)(mac, 'dxGetOutputSound');
	              }).then(function (_ref7) {
	                var sound = _ref7.sound;
	
	                _this.outSound = sound;
	                return (0, _Service.call)(mac, 'dxGetOutputColor');
	              }).then(function (_ref8) {
	                var color = _ref8.color;
	
	                _this.outColor = _lodash2.default.cloneDeep(color);
	                return (0, _Service.call)(mac, 'dxGetLabel');
	              }).then(function (label) {
	                _this.label = label;
	                return (0, _Service.call)(mac, 'dxGetAbout');
	              }).then(function (_ref9) {
	                var model = _ref9.model;
	
	                console.log('model', model);
	                _this.model = model;
	                return (0, _Service.call)(mac, 'dxGetSplitLayer');
	              }).then(function (_ref10) {
	                var layer = _ref10.layer;
	
	                _this.splitLayer = layer;
	                _this.showLoadingProfile = false;
	                _this.$broadcast('chgZindex', _this.splitLayer, '1');
	                _this.$broadcast('render', '1');
	              }).catch(function (err) {
	                console.error(err);
	                _this.showLoadingProfile = false;
	                _this.alert('danger', '', err);
	              });
	
	            case 28:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this, [[5, 21]]);
	    }));
	
	    function asyncData() {
	      return _ref.apply(this, arguments);
	    }
	
	    return asyncData;
	  }(),
	
	  computed: {
	    in4K: function in4K() {
	      if (this.model === 'MX-5004MZ2') return false;
	      return Resolution4KList.includes(this.outResolutionOptions[this.outResolution]);
	    },
	    outRatio: function outRatio() {
	      this.ww = window.innerWidth;
	      console.log('change www');
	      var ratio = [];
	      switch (this.outResolutionOptions[this.outResolution]) {
	        case '800x600':
	        case '800x600@60':
	        default:
	          ratio = [4, 3, 200];
	          break;
	        case '4096x2160@23.98':
	        case '4096x2160@29.97':
	        case '4096x2160@59.94':
	          ratio = [16, 135, 256];
	          break;
	        case '3840x2160@23.98':
	        case '3840x2160@29.97':
	        case '3840x2160@59.94':
	        case '3840x2160@24':
	        case '3840x2160@25':
	        case '3840x2160@30':
	        case '3840x2160@50':
	        case '3840x2160@60':
	          ratio = [16, 9, 240];
	          break;
	        case '1920x1200':
	        case '1920x1200@60':
	          ratio = [16, 10, 120];
	          break;
	        case '1080 to 4K2K@60':
	        case '1920x1080':
	        case '1920x1080@50':
	        case '1920x1080@60':
	        case '1920x1080@23.98':
	        case '1920x1080@29.97':
	        case '1920x1080@59.94':
	          ratio = [16, 9, 120];
	          break;
	        case '1600x1200@60':
	          ratio = [16, 12, 100];
	          break;
	        case '1440x900@60':
	          ratio = [8, 5, 180];
	          break;
	        case '1400x900@60':
	          ratio = [14, 9, 100];
	          break;
	        case '1366x768@60':
	          ratio = [16, 9, 85];
	          break;
	        case '1280x1024@60':
	          ratio = [5, 4, 256];
	          break;
	        case '1280x960@60':
	          ratio = [4, 3, 320];
	          break;
	        case '1280x768@60':
	          ratio = [5, 3, 256];
	          break;
	        case '1280x720@50':
	        case '1280x720@60':
	        case '1280x720@23.98':
	        case '1280x720@29.97':
	        case '1280x720@59.94':
	          ratio = [16, 9, 80];
	          break;
	        case '1024x768@60':
	          ratio = [4, 3, 256];
	          break;
	        case '720x480@60':
	          ratio = [3, 2, 240];
	          break;
	        case '1680x1050@60':
	          ratio = [8, 5, 210];
	          break;
	
	        case '640x480':
	        case '640x480@60':
	          ratio = [4, 3, 160];
	          break;
	      }
	      var md = new _mobileDetect2.default(window.navigator.userAgent);
	      if (md.mobile() !== null && window.innerWidth <= 768) {
	        if (this.ww === 320) {
	          ratio.push(Math.round(280 / ratio[0]));
	        } else if (this.ww === 375 || this.ww === 360) {
	          ratio.push(Math.round(320 / ratio[0]));
	        } else if (this.ww === 414 || this.ww === 412 || this.ww === 411) {
	          ratio.push(Math.round(360 / ratio[0]));
	        } else if (this.ww === 568) {
	          ratio.push(Math.round(340 / ratio[0]));
	        } else if (this.ww === 684) {
	          ratio.push(Math.round(400 / ratio[0]));
	        } else if (this.ww > 568 && this.ww <= 667) {
	          ratio.push(Math.round(400 / ratio[0]));
	        } else if (this.ww > 667 && this.ww <= 736) {
	          ratio.push(Math.round(450 / ratio[0]));
	        } else if (this.ww === 768) {
	          ratio.push(Math.round(400 / ratio[0]));
	        } else {
	          ratio.push(Math.round(300 / ratio[0]));
	        }
	      } else if (window.innerWidth > 768 && window.innerWidth < 992) {
	        ratio.push(Math.round(450 / ratio[0]));
	      } else if (window.innerWidth >= 992 && window.innerWidth < 1200) {
	        ratio.push(Math.round(550 / ratio[0]));
	      } else if (window.innerWidth >= 1200) {
	        ratio.push(Math.round(800 / ratio[0]));
	      }
	      return ratio;
	    },
	    computedOutResolutionOptions: function computedOutResolutionOptions() {
	      var options = [];
	      var keys = (0, _keys2.default)(this.outResolutionOptions);
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var key = _step.value;
	
	          options.push({
	            label: this.outResolutionOptions[key],
	            value: key
	          });
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return options;
	    },
	    whichSplit: function whichSplit() {
	      if (this.outLayout === 'quick') {
	        return this.quickSelectSplit;
	      } else if (this.outLayout === 'full') {
	        return this.fullScreenSplit;
	      } else if (this.outLayout === 'custom') {
	        return this.customSplit;
	      }
	    },
	    customProfileOptions: function customProfileOptions() {
	      var options = [];
	      for (var profile in this.profiles) {
	        options.push({
	          label: profile,
	          value: profile,
	          name: this.profiles[profile].name
	        });
	      }
	      return options;
	    }
	  },
	  methods: {
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    _checkChanged: function _checkChanged(a, b) {
	      var keys = (0, _keys2.default)(a);
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(keys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var key = _step2.value;
	
	          if (b[key] !== a[key]) return true;
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return false;
	    },
	    applySingleAPI: function applySingleAPI(apiName, dataKey, paramKey) {
	      var _this2 = this;
	
	      if (this._checkChanged(this[dataKey], this.editing[dataKey])) {
	        var mac = this.$route.params.mac;
	
	        var param = (0, _defineProperty3.default)({}, paramKey, this.editing[dataKey]);
	        (0, _Service.call)(mac, apiName, param).then(function (res) {
	          _this2[dataKey] = _lodash2.default.cloneDeep(_this2.editing[dataKey]);
	        }, function (err) {
	          _this2.alert('danger', '', err);
	        });
	      } else {
	        this.alert('success', '', 'Nothing changed');
	      }
	    },
	    updateRootMixerProfile: function updateRootMixerProfile(key, profile) {
	      var mac = this.$route.params.mac;
	
	      console.log(key);
	      this.profiles[key] = _lodash2.default.cloneDeep(profile);
	      this.$root.mixerProfile[mac][key] = _lodash2.default.cloneDeep(profile);
	    },
	    updateProfile: function () {
	      var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var mac, newProfile, newSplitsAry, i, _ref12, profiles;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                mac = this.$route.params.mac;
	                newProfile = {};
	                newSplitsAry = {};
	
	                this.isUpdatingProfile = true;
	                _context2.prev = 4;
	                i = 1;
	
	              case 6:
	                if (!(i < 9)) {
	                  _context2.next = 17;
	                  break;
	                }
	
	                console.log(i);
	                _context2.next = 10;
	                return (0, _Service.call)(mac, 'dxGetProfiles', {
	                  profile: i.toString()
	                });
	
	              case 10:
	                _ref12 = _context2.sent;
	                profiles = _ref12.profiles;
	
	                newProfile[i] = profiles;
	                newSplitsAry[i] = {
	                  setting: profiles.split
	                };
	
	              case 14:
	                i++;
	                _context2.next = 6;
	                break;
	
	              case 17:
	
	                this.profiles = _lodash2.default.cloneDeep(newProfile);
	                this.splitsAry = _lodash2.default.cloneDeep(newSplitsAry);
	                this.$root.mixerProfile[mac] = newProfile;
	                this.isUpdatingProfile = false;
	                _context2.next = 28;
	                break;
	
	              case 23:
	                _context2.prev = 23;
	                _context2.t0 = _context2['catch'](4);
	
	                this.isUpdatingProfile = false;
	                this.alert('danger', '', _context2.t0);
	                console.error(_context2.t0);
	
	              case 28:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[4, 23]]);
	      }));
	
	      function updateProfile() {
	        return _ref11.apply(this, arguments);
	      }
	
	      return updateProfile;
	    }(),
	    applyOutputResolution: function applyOutputResolution() {
	      var _this3 = this;
	
	      if (this.editing.outResolution !== this.outResolution) {
	        var mac = this.$route.params.mac;
	
	        var param = {
	          resolution: {
	            '1': this.editing.outResolution
	          }
	        };
	        (0, _Service.call)(mac, 'dxSetOutputResolution', param).then(function (res) {
	          _this3.outResolution = _lodash2.default.cloneDeep(_this3.editing.outResolution);
	          _this3.updateProfile();
	        }).catch(function (err) {
	          _this3.alert('danger', '', err);
	        });
	      } else {
	        this.alert('success', '', 'Nothing changed');
	      }
	    },
	    sendKeyToDevice: function sendKeyToDevice(optionKey) {
	      this.buttonDisabled = true;
	      var mac = this.$route.params.mac;
	
	      (0, _Service.call)(mac, 'dxSetSplitByOption', {
	        options: {
	          '1': optionKey
	        }
	      }).then(function (res) {
	        console.log('call splitArea done', res);
	      }).catch(function (err) {
	        console.error(err);
	      });
	    },
	    sendProfileKeyToDevice: function sendProfileKeyToDevice(optionKey) {
	      var _this4 = this;
	
	      this.buttonDisabled = true;
	      var mac = this.$route.params.mac;
	
	      (0, _Service.call)(mac, 'dxSetDeviceByProfileKey', { profile: optionKey }).then(function (res) {
	        console.log(res);
	      }).catch(function (err) {
	        _this4.alert('danger', '', err);
	      });
	    },
	    applySourceLabel: function () {
	      var _ref13 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        var keys, targets, mac, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, k, key;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                keys = (0, _keys2.default)(this.editing.sourceLabel);
	                targets = {};
	                mac = this.$route.params.mac;
	                _iteratorNormalCompletion3 = true;
	                _didIteratorError3 = false;
	                _iteratorError3 = undefined;
	                _context3.prev = 6;
	
	                for (_iterator3 = (0, _getIterator3.default)(keys); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                  k = _step3.value;
	
	                  if (this.editing.sourceLabel[k].text !== this.label.inputs[k].text) {
	                    targets[k] = {
	                      text: this.editing.sourceLabel[k].text,
	                      enabled: this.editing.sourceLabel[k].enabled
	                    };
	                  }
	                }
	                _context3.next = 14;
	                break;
	
	              case 10:
	                _context3.prev = 10;
	                _context3.t0 = _context3['catch'](6);
	                _didIteratorError3 = true;
	                _iteratorError3 = _context3.t0;
	
	              case 14:
	                _context3.prev = 14;
	                _context3.prev = 15;
	
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                  _iterator3.return();
	                }
	
	              case 17:
	                _context3.prev = 17;
	
	                if (!_didIteratorError3) {
	                  _context3.next = 20;
	                  break;
	                }
	
	                throw _iteratorError3;
	
	              case 20:
	                return _context3.finish(17);
	
	              case 21:
	                return _context3.finish(14);
	
	              case 22:
	                _context3.prev = 22;
	                _context3.t1 = _regenerator2.default.keys(targets);
	
	              case 24:
	                if ((_context3.t2 = _context3.t1()).done) {
	                  _context3.next = 31;
	                  break;
	                }
	
	                key = _context3.t2.value;
	
	                console.log(key);
	                _context3.next = 29;
	                return (0, _Service.call)(mac, 'dxSetLabel', {
	                  inputs: (0, _defineProperty3.default)({}, key, targets[key])
	                });
	
	              case 29:
	                _context3.next = 24;
	                break;
	
	              case 31:
	                console.log('dxSetLabel done');
	                _context3.next = 38;
	                break;
	
	              case 34:
	                _context3.prev = 34;
	                _context3.t3 = _context3['catch'](22);
	
	                console.error(_context3.t3);
	                this.alert('danger', '', _context3.t3);
	
	              case 38:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this, [[6, 10, 14, 22], [15,, 17, 21], [22, 34]]);
	      }));
	
	      function applySourceLabel() {
	        return _ref13.apply(this, arguments);
	      }
	
	      return applySourceLabel;
	    }(),
	    addListener: function addListener() {
	      var _this5 = this;
	
	      console.log('resize');
	      this.ww = 0;
	      this.ww = window.innerWidth;
	      setTimeout(function () {
	        _this5.$broadcast('render', '1');
	      }, 200);
	    },
	    changeProps: function changeProps(outLayout, split, optionKey) {
	      var _this6 = this;
	
	      this.outLayout = outLayout;
	      if (outLayout === 'quick') {
	        this.quickSelectSplit = split;
	      } else if (outLayout === 'full') {
	        this.fullScreenSplit = split;
	      } else if (outLayout === 'custom') {
	        this.buttonDisabled = true;
	      }
	      setTimeout(function () {
	        _this6._applyScreenChg(optionKey);
	      }, 100);
	    },
	    _applyScreenChg: function _applyScreenChg(optionKey) {
	      this.$broadcast('render', '1');
	      this.$broadcast('chgZindex', this.splitLayer, '1');
	      if (this.outLayout === 'custom') {
	        this.sendProfileKeyToDevice(optionKey);
	      } else {
	        this.sendKeyToDevice(optionKey);
	      }
	    }
	  }, ready: function ready() {
	    window.addEventListener('orientationchange', this.addListener, false);
	    window.addEventListener('resize', this.addListener, false);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('orientationchange', this.addListener, false);
	    window.removeEventListener('resize', this.addListener, false);
	  },
	
	  events: {
	    update: function update(mac, _ref14) {
	      var _this7 = this;
	
	      var type = _ref14.type,
	          event = _ref14.event,
	          msg = _ref14.msg;
	
	      console.log('got event:', type);
	      switch (type) {
	        case 'layer':
	          this.splitLayer = event.layer;
	          setTimeout(function () {
	            _this7.$broadcast('chgZindex', _this7.splitLayer, '1');
	            _this7.buttonDisabled = false;
	          }, 700);
	          break;
	        case 'mapping':
	          var newMapping = _lodash2.default.cloneDeep(this.mapping);
	          _lodash2.default.assignIn(newMapping, event);
	          this.mapping = _lodash2.default.cloneDeep(newMapping);
	          this.buttonDisabled = false;
	          break;
	        case 'split':
	          var newSplit = _lodash2.default.cloneDeep(this.splits);
	          _lodash2.default.assignIn(newSplit.setting, event.setting);
	          this.splits = _lodash2.default.cloneDeep(newSplit);
	          this.outLayout = 'init';
	          setTimeout(function () {
	            _this7.$broadcast('render', '1');
	            _this7.buttonDisabled = false;
	          }, 700);
	          break;
	        case 'label':
	          console.log(event);
	          var newLabel = _lodash2.default.cloneDeep(this.label);
	          var _event$inputs = event.inputs,
	              inputs = _event$inputs === undefined ? {} : _event$inputs,
	              _event$windows = event.windows,
	              windows = _event$windows === undefined ? {} : _event$windows,
	              _event$custom = event.custom,
	              custom = _event$custom === undefined ? {} : _event$custom,
	              _event$osd = event.osd,
	              osd = _event$osd === undefined ? {} : _event$osd;
	
	
	          if (inputs) _lodash2.default.assignIn(newLabel.inputs, event.inputs);
	          if (windows) _lodash2.default.assignIn(newLabel.windows, event.windows);
	          if (custom) _lodash2.default.assignIn(newLabel.custom, event.custom);
	          if (osd) _lodash2.default.assignIn(newLabel.osd, event.osd);
	
	          this.label = _lodash2.default.cloneDeep(newLabel);
	          break;
	        case 'resolution':
	          this.outResolution = event['1'];
	          setTimeout(function () {
	            _this7.$broadcast('render', '1');
	            _this7.$broadcast('chgZindex', _this7.splitLayer, '1');
	            _this7.buttonDisabled = false;
	          }, 700);
	          break;
	        case 'sound':
	          var _event$soundFrom = event.soundFrom,
	              soundFrom = _event$soundFrom === undefined ? '' : _event$soundFrom,
	              _event$soundRLChannel = event.soundRLChannel,
	              soundRLChannel = _event$soundRLChannel === undefined ? '' : _event$soundRLChannel,
	              _event$fullScreenAudi = event.fullScreenAudio,
	              fullScreenAudio = _event$fullScreenAudi === undefined ? null : _event$fullScreenAudi,
	              _event$mute = event.mute,
	              mute = _event$mute === undefined ? null : _event$mute;
	
	          var newSound = _lodash2.default.cloneDeep(this.outSound);
	
	          if (soundFrom) newSound.soundFrom = soundFrom;
	          if (soundRLChannel) newSound.soundRLChannel = soundRLChannel;
	          if (fullScreenAudio !== null) newSound.fullScreenAudio = fullScreenAudio;
	          if (mute !== null) newSound.mute = mute;
	
	          this.outSound = _lodash2.default.cloneDeep(newSound);
	          break;
	        case 'preset':
	          var key = (0, _keys2.default)(event)[0];
	          this.updateRootMixerProfile(key, event[key]);
	          break;
	      }
	    }
	  },
	  watch: {
	    showOutSetting: function showOutSetting(nV) {
	      if (nV) {
	        this.editing.outSound = _lodash2.default.cloneDeep(this.outSound);
	        this.editing.outColor = _lodash2.default.cloneDeep(this.outColor);
	        this.editing.outVideo = _lodash2.default.cloneDeep(this.outVideo);
	        this.editing.outResolution = _lodash2.default.cloneDeep(this.outResolution);
	        this.editing.sourceLabel = _lodash2.default.cloneDeep(this.label.inputs);
	      } else {
	        this.outColorChanged = false;
	        this.outVideoChanged = false;
	        this.outSoundChanged = false;
	        this.outResolutionChanged = false;
	        (0, _jquery2.default)('.window_setting_modal').scrollTop(0);
	      }
	    }
	  },
	  route: {
	    canReuse: false, activate: function activate(_ref15) {
	      var next = _ref15.next;
	
	      next();
	    }
	  }
	};

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(219);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(22);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _slicedToArray2 = __webpack_require__(338);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getIterator2 = __webpack_require__(28);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _zingchart = __webpack_require__(1220);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Service = __webpack_require__(8);
	
	var _mobileDetect = __webpack_require__(56);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEVICE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss';
	
	var BEHAVIOR_CONFIG = [{ id: 'About', enabled: 'none' }, { id: 'ViewSource', enabled: 'none' }, { id: 'Reload', enabled: 'none' }];
	var MOBILE_BEHAVIOR_CONFIG = [{ id: 'About', enabled: 'none' }, { id: 'ViewSource', enabled: 'none' }, { id: 'Print', enabled: 'none' }, { id: 'DownloadPDF', enabled: 'none' }, { id: 'DownloadSVG', enabled: 'none' }, { id: 'SaveAsImage', enabled: 'none' }, { id: 'Reload', enabled: 'none' }];
	
	exports.default = {
	  components: {},
	  asyncData: function asyncData() {
	    var _this = this;
	
	    var md = new _mobileDetect2.default(window.navigator.userAgent);
	    (0, _Service.call)(this.$route.params.mac, 'dxGetTimeZone').then(function (_ref) {
	      var timezone = _ref.timezone;
	
	      _this.timezone = timezone;
	      return (0, _Service.call)(_this.$route.params.mac, 'dxGetPowerStatus');
	    }).then(function (data) {
	      console.log('async');
	      _this.input = _lodash2.default.cloneDeep(data.input);
	      _this.banks = _lodash2.default.cloneDeep(data.banks);
	
	      var colors = ['#1f77b4', '#ff7f0e', '#357935'];
	      _this.curSeries = [];
	      _this.powerSeries = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(_this.filter.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
	              idx = _step$value[0],
	              key = _step$value[1];
	
	          var obj = {
	            text: 'Bank' + key,
	            values: [],
	            marker: {
	              visible: false
	            },
	            scales: 'scale-x,scale-y',
	            'line-color': colors[idx]
	          };
	          _this.curSeries.push(obj);
	          _this.powerSeries.push(obj);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var vue = _this;
	
	      console.log('render chart');
	      (0, _zingchart.render)({
	        id: 'inputVoltage',
	        data: {
	          gui: {
	            contextMenu: {
	              button: {
	                visible: true
	              },
	              'custom-items': [{
	                id: 'reloadInput',
	                function: 'reloadInput()',
	                text: 'Reload'
	              }],
	              position: 'right'
	            },
	            behaviors: md.mobile() !== null ? MOBILE_BEHAVIOR_CONFIG : BEHAVIOR_CONFIG
	          },
	          graphset: [{
	            title: {
	              text: 'Voltage (Input/Outputs)',
	              bold: false,
	              fontSize: md.mobile() !== null ? '14px' : '18px'
	            },
	            type: 'line',
	            x: 0,
	            y: 0,
	            height: 250,
	            width: '100%',
	            plotarea: {
	              margin: '50 25 20 50'
	            },
	            'scale-y': {
	              values: _this.isEurope ? '260:200:10' : '135:85:10',
	              format: '%v V'
	            },
	            'scale-x': {
	              step: 1000,
	              transform: {
	                type: 'date',
	                text: '%H:%i:%s',
	                item: {
	                  visible: false
	                }
	              }
	            },
	            refresh: {
	              type: 'feed',
	              resetTimeout: 1000,
	              transport: 'js',
	              url: 'inputVoltageCallback()',
	              maxTicks: 30,
	              interval: 1000
	            },
	            series: [{
	              values: [],
	              marker: {
	                visible: false
	              },
	              'line-color': '#e0564c'
	            }]
	          }] } });
	
	      (0, _zingchart.render)({
	        id: 'bankCurrent',
	        data: {
	          gui: {
	            contextMenu: {
	              button: {
	                visible: true
	              },
	              'custom-items': [{
	                id: 'reloadCurrent',
	                function: 'reloadCurrent()',
	                text: 'Reload'
	              }],
	              position: 'right'
	            },
	            behaviors: md.mobile() !== null ? MOBILE_BEHAVIOR_CONFIG : BEHAVIOR_CONFIG
	          },
	          graphset: [{
	            title: {
	              text: 'Current (Outputs)',
	              bold: false,
	              fontSize: md.mobile() !== null ? '14px' : '18px'
	            },
	            type: 'line',
	            x: 0,
	            y: 0,
	            width: '100%',
	            height: 250,
	            plotarea: {
	              margin: '50 25 20 50'
	            },
	            'scale-x': {
	              step: 1000,
	              transform: {
	                type: 'date',
	                text: '%H:%i:%s',
	                item: {
	                  visible: false
	                }
	              }
	            },
	            'scale-y': {
	              values: _this.isEurope ? '16:0:4' : '15:0:3',
	              format: '%v A',
	              tick: {
	                'line-color': '#29A2CC'
	              },
	              item: {
	                'font-color': '#29A2CC'
	              }
	            },
	            refresh: {
	              type: 'feed',
	              resetTimeout: 1000,
	              transport: 'js',
	              url: 'bankCurrentCallback()',
	              maxTicks: 30,
	              interval: 1000
	            },
	            series: vue.curSeries
	          }]
	        }
	      });
	      (0, _zingchart.render)({
	        id: 'bankPower',
	        data: {
	          gui: {
	            contextMenu: {
	              button: {
	                visible: true
	              },
	              'custom-items': [{
	                id: 'reloadPower',
	                function: 'reloadPower()',
	                text: 'Reload'
	              }],
	              position: 'right'
	            },
	            behaviors: md.mobile() !== null ? MOBILE_BEHAVIOR_CONFIG : BEHAVIOR_CONFIG
	          },
	          graphset: [{
	            title: {
	              text: 'Power (Outputs)',
	              bold: false,
	              fontSize: md.mobile() !== null ? '14px' : '18px'
	            },
	            type: 'line',
	            x: 0,
	            y: 0,
	            width: '100%',
	            height: 250,
	            plotarea: {
	              margin: '50 25 20 50'
	            },
	            'scale-x': {
	              step: 1000,
	              transform: {
	                type: 'date',
	                text: '%H:%i:%s',
	                item: {
	                  visible: false
	                }
	              }
	            },
	            'scale-y': {
	              values: _this.isEurope ? '0:3600:600' : '0:2100:300',
	              format: '%v W',
	              tick: {
	                'line-color': '#29A2CC'
	              },
	              item: {
	                'font-color': '#29A2CC'
	              }
	            },
	            refresh: {
	              type: 'feed',
	              resetTimeout: 1000,
	              transport: 'js',
	              url: 'bankPowerCallback()',
	              maxTicks: 30,
	              interval: 1000
	            },
	            series: vue.powerSeries
	          }]
	        }
	      });
	    }).catch(function (err) {
	      _this.alert('danger', 'No response', err);
	    });
	  },
	  data: function data() {
	    return {
	      testData: {},
	      filter: ['1', '2', '3'],
	      typeOption: '',
	      isEurope: false,
	      banks: {},
	      input: {},
	      curSeries: [],
	      powerSeries: [],
	      timezone: {},
	      currentTime: '',
	      colors: ['#1f77b4', '#ff7f0e', '#357935']
	    };
	  },
	
	  methods: {
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    chkAmount: function chkAmount() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        if (_this2.filter.length > 3) {
	          _this2.filter.shift();
	        }
	      }, 100);
	    },
	    updateTime: function updateTime() {
	      this.currentTime = Date.now();
	      var vue = this;
	      setTimeout(function () {
	        vue.updateTime();
	      }, 1000);
	    }
	  },
	  computed: {
	    deviceTime: function deviceTime() {
	      if (this.timezone.useDaylight && (0, _moment2.default)().isDST()) {
	        return (0, _moment2.default)(this.currentTime).utc().add(this.timezone.offset, 'seconds').add(this.timezone.dstSavings, 'seconds').format(DEVICE_TIME_FORMAT);
	      } else {
	        return (0, _moment2.default)(this.currentTime).utc().add(this.timezone.offset, 'seconds').format(DEVICE_TIME_FORMAT);
	      }
	    },
	    filteredCurrent: function filteredCurrent() {
	      var obj = {};
	      var offset = _moment2.default.parseZone((0, _moment2.default)(this.currentTime).utcOffset());
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(this.filter), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var key = _step2.value;
	
	          if (this.testData.banks[key].current >= 0) {
	            var toAdd = {};
	            toAdd['plot' + this.filter.indexOf(key)] = this.testData.banks[key].current;
	            if (this.timezone.useDaylight) {
	              toAdd['scale-x'] = (0, _moment2.default)(this.currentTime - offset * 60000 + this.timezone.dstSavings * 1000).add(this.timezone.offset, 'seconds').valueOf();
	            } else {
	              toAdd['scale-x'] = (0, _moment2.default)(this.currentTime - offset * 60000).add(this.timezone.offset, 'seconds').valueOf();
	            }
	            _lodash2.default.merge(obj, toAdd);
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return obj;
	    },
	    filteredPower: function filteredPower() {
	      var obj = {};
	      var offset = _moment2.default.parseZone((0, _moment2.default)(this.currentTime).utcOffset());
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = (0, _getIterator3.default)((0, _keys2.default)(this.testData.banks)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var i = _step3.value;
	
	          if (this.filter.indexOf(i) !== -1 && this.testData.banks[i].power >= 0) {
	            var toAdd = {};
	            toAdd['plot' + this.filter.indexOf(i)] = this.testData.banks[i].power;
	            if (this.timezone.useDaylight) {
	              toAdd['scale-x'] = (0, _moment2.default)(this.currentTime - offset * 60000 + this.timezone.dstSavings * 1000).add(this.timezone.offset, 'seconds').valueOf();
	            } else {
	              toAdd['scale-x'] = (0, _moment2.default)(this.currentTime - offset * 60000).add(this.timezone.offset, 'seconds').valueOf();
	            }
	            _lodash2.default.merge(obj, toAdd);
	          }
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      return obj;
	    }
	  },
	  watch: {
	    filter: function filter(nV) {
	      this.curSeries = [];
	      this.powerSeries = [];
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = (0, _getIterator3.default)(nV.entries()), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var _step4$value = (0, _slicedToArray3.default)(_step4.value, 2),
	              idx = _step4$value[0],
	              key = _step4$value[1];
	
	          var obj = {
	            text: 'Bank' + key,
	            values: [],
	            marker: {
	              visible: false
	            },
	            scales: 'scale-x,scale-y',
	            'line-color': this.colors[idx]
	          };
	          this.curSeries.push(obj);
	          this.powerSeries.push(obj);
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      (0, _zingchart.exec)('bankCurrent', 'clearfeed');
	      (0, _zingchart.exec)('bankPower', 'clearfeed');
	      (0, _zingchart.exec)('inputVoltage', 'clearfeed');
	    }
	  },
	  ready: function ready() {
	    var _this3 = this;
	
	    console.log('ready');
	    this.updateTime();
	    var offset = _moment2.default.parseZone((0, _moment2.default)(this.currentTime).utcOffset());
	    window.inputVoltageCallback = function (cb) {
	      cb((0, _stringify2.default)({
	        plot0: _this3.testData.input.voltage,
	        'scale-x': _this3.timezone.useDaylight ? (0, _moment2.default)(_this3.currentTime - offset * 60000 + _this3.timezone.dstSavings * 1000).add(_this3.timezone.offset, 'seconds').valueOf() : (0, _moment2.default)(_this3.currentTime - offset * 60000).add(_this3.timezone.offset, 'seconds').valueOf()
	      }));
	    };
	    window.bankCurrentCallback = function (cb) {
	      cb((0, _stringify2.default)(_this3.filteredCurrent));
	    };
	    window.bankPowerCallback = function (cb) {
	      cb((0, _stringify2.default)(_this3.filteredPower));
	    };
	    window.reloadInput = function () {
	      (0, _zingchart.exec)('inputVoltage', 'clearfeed');
	    };
	    window.reloadCurrent = function () {
	      (0, _zingchart.exec)('bankCurrent', 'clearfeed');
	    };
	    window.reloadPower = function () {
	      (0, _zingchart.exec)('bankPower', 'clearfeed');
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    console.log('b4 destroy');
	    (0, _zingchart.exec)('inputVoltage', 'destroy');
	    (0, _zingchart.exec)('bankCurrent', 'destroy');
	    (0, _zingchart.exec)('bankPower', 'destroy');
	  },
	
	  events: {
	    status: function status(mac, _ref2) {
	      var banks = _ref2.banks,
	          input = _ref2.input;
	
	      this.isEurope = input.voltage > 200;
	      this.testData = { banks: banks, input: input };
	    },
	    update: function update(mac, _ref3) {
	      var type = _ref3.type,
	          event = _ref3.event,
	          msg = _ref3.msg;
	
	      if (type === 'timezone') {
	        this.timezone = event.timezone;
	        (0, _zingchart.exec)('inputVoltage', 'clearfeed');
	        (0, _zingchart.exec)('bankCurrent', 'clearfeed');
	        (0, _zingchart.exec)('bankPower', 'clearfeed');
	      }
	    }
	  }
	};

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(338);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getIterator2 = __webpack_require__(28);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(22);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vueStrap = __webpack_require__(12);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Multiselect = __webpack_require__(531);
	
	var _Multiselect2 = _interopRequireDefault(_Multiselect);
	
	var _SingleSelect = __webpack_require__(26);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _Service = __webpack_require__(8);
	
	var _SingleBanks = __webpack_require__(529);
	
	var _SingleBanks2 = _interopRequireDefault(_SingleBanks);
	
	var _MultiBanks = __webpack_require__(178);
	
	var _MultiBanks2 = _interopRequireDefault(_MultiBanks);
	
	var _emailValidator = __webpack_require__(359);
	
	var _jquery = __webpack_require__(21);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEVICE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss';
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal,
	    'tabs': _vueStrap.tabset,
	    tab: _vueStrap.tab,
	    'v-select': _Multiselect2.default,
	    'v-single-select': _SingleSelect2.default,
	    'v-bank': _SingleBanks2.default,
	    'v-multi-banks': _MultiBanks2.default
	  },
	  data: function data() {
	    return {
	      showAni: true,
	      showGroupConfig: false,
	      showGroupConfigTable: false,
	      editingGroup: {
	        _id: '',
	        format: '',
	        title: '',
	        data: {},
	        cb: function cb() {}
	      },
	      banks: {},
	      input: {},
	      allBanks: [],
	      editing: {
	        title: 'Event Config',
	        index: '',
	        newEvent: {
	          name: '',
	          enabled: '',
	          key: '',
	          condition: '',
	          newSource: '',
	          connect: '',
	          power: '',
	          float: '',
	          pingCondition: 'fail',
	          pingAddr: ''
	        },
	        actionKeys: []
	      },
	
	      conditions: [{ label: '>', value: '>' }, { label: '>=', value: '>=' }, { label: '=', value: '=' }, { label: '<=', value: '<=' }, { label: '<', value: '<' }],
	      eventOptions: [{ label: 'Current(A)', value: 'Current' }, { label: 'Voltage(V)', value: 'Voltage' }, { label: 'Power(W)', value: 'Power' }, { label: 'Connection', value: 'Connection' }, { label: 'Ping', value: 'Ping' }],
	      connectOptions: [{ label: 'Get Connection', value: 'ON' }, { label: 'Lost Connection', value: 'OFF' }],
	      powerOptions: [{ label: 'ON', value: 'ON' }, { label: 'OFF', value: 'OFF' }, { label: 'RESET', value: 'RESET' }],
	      pingOptions: [{ label: 'Ping fail', value: 'fail' }],
	
	      events: {},
	      showModal: false,
	      newActions: [],
	      actions: {
	        sqOFF: {
	          action: 'Sequence OFF',
	          targets: ['0', '1', '2', '3'],
	          value: '0'
	        },
	        sqON: {
	          action: 'Sequence ON',
	          targets: ['0', '1', '2', '3'],
	          value: '0'
	        },
	        reset: {
	          action: 'Power Reset',
	          targets: []
	        },
	        on: {
	          action: 'Power ON',
	          targets: []
	        },
	        off: {
	          action: 'Power OFF',
	          targets: []
	        }
	      },
	
	      emailGroups: {
	        selected: [],
	        options: []
	      },
	
	      SMSGroups: {
	        selected: [],
	        options: []
	      },
	
	      emailData: {},
	
	      SMSData: {},
	      singleNumberValid: false,
	      currentTime: '',
	      timezone: {},
	      emailGroupMap: {},
	      SMSGroupMap: {},
	      pageFocus: 1
	    };
	  },
	
	  computed: {
	    deviceTime: function deviceTime() {
	      if (this.timezone.useDaylight && (0, _moment2.default)().isDST()) {
	        return (0, _moment2.default)(this.currentTime).utc().add(this.timezone.offset, 'seconds').add(this.timezone.dstSavings, 'seconds').format(DEVICE_TIME_FORMAT);
	      } else {
	        return (0, _moment2.default)(this.currentTime).utc().add(this.timezone.offset, 'seconds').format(DEVICE_TIME_FORMAT);
	      }
	    },
	    sourceOptions: function sourceOptions() {
	      return (0, _keys2.default)(this.allBanks).map(function (idx) {
	        return {
	          label: idx === '0' ? 'Input' : 'Outlet' + idx,
	          value: idx
	        };
	      });
	    }
	  },
	  asyncData: function asyncData() {
	    var _this = this;
	
	    var mac = this.$route.params.mac;
	
	    this.showAni = true;
	    return (0, _Service.call)(mac, 'dxGetPowerStatus').then(function (_ref) {
	      var banks = _ref.banks,
	          input = _ref.input;
	
	      _this.banks = _lodash2.default.cloneDeep(banks);
	      _this.input = _lodash2.default.cloneDeep(input);
	      _this.allBanks = [];
	      _this.allBanks.push(_this.input);
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(_this.banks)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var key = _step.value;
	
	          _this.allBanks.push(_this.banks[key]);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return (0, _Service.call)(mac, 'dxGetEvents', { key: 1 });
	    }).then(function (_ref2) {
	      var entries = _ref2.entries;
	
	      _this.events = _lodash2.default.cloneDeep(entries);
	      return (0, _Service.call)(mac, 'dxGetEmailGroups');
	    }).then(function (_ref3) {
	      var entries = _ref3.entries;
	
	      _this.emailGroups = {
	        options: [],
	        selected: []
	      };
	      _this.emailGroupMap = {};
	      for (var key in entries) {
	        _this.emailGroupMap[key] = entries[key].name;
	        if (entries[key].accounts.length !== 0) {
	          _this.emailGroups.options.push({
	            label: entries[key].name,
	            value: key
	          });
	        }
	      }
	      _this.emailData = _lodash2.default.cloneDeep(entries);
	      return (0, _Service.call)(mac, 'dxGetSMSGroups');
	    }).then(function (_ref4) {
	      var entries = _ref4.entries;
	
	      _this.SMSGroups = {
	        options: [],
	        selected: []
	      };
	      _this.SMSGroupMap = {};
	      for (var key in entries) {
	        _this.SMSGroupMap[key] = entries[key].name;
	        if (entries[key].accounts.length !== 0) {
	          _this.SMSGroups.options.push({
	            label: entries[key].name,
	            value: key
	          });
	        }
	      }
	      _this.SMSData = _lodash2.default.cloneDeep(entries);
	      return (0, _Service.call)(mac, 'dxGetTimeZone');
	    }).then(function (_ref5) {
	      var timezone = _ref5.timezone;
	
	      _this.timezone = timezone;
	      _this.showAni = false;
	    }).catch(function (err) {
	      _this.alert('danger', 'Error', err.message);
	    });
	  },
	
	  methods: {
	    clickGroups: function clickGroups(which) {
	      var group = which === 'Email' ? this.emailGroups : this.SMSGroups;
	
	      if (this.newActions.indexOf(which) === -1) {
	        this.newActions.push(which);
	        group.selected = [group.options[0]];
	      } else {
	        this.newActions.splice(this.newActions.indexOf(which), 1);
	        group.selected = [];
	      }
	    },
	    updateEmailGroupSelected: function updateEmailGroupSelected(value) {
	      this.emailGroups.selected = value;
	    },
	    updateSMSGroupSelected: function updateSMSGroupSelected(value) {
	      this.SMSGroups.selected = value;
	    },
	    selectPowerTypeAction: function selectPowerTypeAction(action) {
	      var filter = ['Power ON', 'Power OFF', 'Power RESET', 'Sequence ON', 'Sequence OFF'];
	      this.newActions = this.newActions.filter(function (a) {
	        return a;
	      });
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(this.newActions.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
	              idx = _step2$value[0],
	              ac = _step2$value[1];
	
	          console.log(idx);
	          console.log(ac);
	          if (filter.indexOf(ac) !== -1) {
	            this.newActions[idx] = '';
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      this.newActions = this.newActions.filter(function (a) {
	        return a;
	      });
	      this.newActions.push(action);
	      console.log(this.newActions);
	    },
	    getEvent: function getEvent(page) {
	      var _this2 = this;
	
	      var mac = this.$route.params.mac;
	
	      this.showAni = true;
	      (0, _Service.call)(mac, 'dxGetEvents', { key: page }).then(function (_ref6) {
	        var entries = _ref6.entries;
	
	        _this2.events = _lodash2.default.cloneDeep(entries);
	        _this2.pageFocus = page;
	        _this2.showAni = false;
	      }).catch(function (err) {
	        _this2.alert('danger', 'Error', 'Unexpect error when initializing the page');
	        _this2.events = [];
	        _this2.showAni = false;
	        console.log(err);
	      });
	    },
	    updateTime: function updateTime() {
	      this.currentTime = Date.now();
	      var vue = this;
	      setTimeout(function () {
	        vue.updateTime();
	      }, 1000);
	    },
	    isString: function isString(param) {
	      return typeof param === 'string';
	    },
	    returnEventName: function returnEventName(event) {
	      var str = '';
	      if (event.key === 'Current' || event.key === 'Voltage') {
	        str += event.key + ' ';
	        str += event.condition + ' ';
	        str += event.value;
	      } else if (event.key === 'Power') {
	        str += event.key + ' ';
	        str += event.value;
	      } else if (event.key === 'Connection') {
	        str += event.value === 'ON' ? 'Get Connection' : 'Lost Connection';
	      } else if (event.key === 'Ping') {
	        str += event.key + ' fail';
	      }
	      return str;
	    },
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    toShowModal: function toShowModal(key) {
	      this.editing.title = 'Event Config ' + key;
	      this.editing.index = key;
	      this.editing.event = _lodash2.default.cloneDeep(this.events[key]);
	      var newE = this.editing.newEvent;
	      var oldE = this.editing.event;
	      newE.key = oldE.event.key;
	      newE.name = oldE.name;
	      newE.enabled = oldE.enabled;
	      newE.condition = oldE.event.condition;
	      newE.newSource = oldE.event.source;
	      switch (newE.key) {
	        case 'Connection':
	          newE.connect = oldE.event.value;
	          break;
	        case 'Power':
	          newE.power = oldE.event.value;
	          break;
	        case 'Current':
	          newE.float = oldE.event.value;
	          break;
	        case 'Voltage':
	          newE.float = oldE.event.value;
	          break;
	        case 'Ping':
	          newE.pingAddr = oldE.event.value;
	      }
	      this.editing.actionKeys = this.editing.event.actions.map(function (obj) {
	        return obj.action;
	      });
	      this.newActions = _lodash2.default.cloneDeep(this.editing.actionKeys);
	      for (var obj in this.editing.event.actions) {
	        switch (this.editing.event.actions[obj].action) {
	          case 'Power ON':
	            this.actions.on.targets = this.editing.event.actions[obj].targets;
	            break;
	          case 'Power OFF':
	            this.actions.off.targets = this.editing.event.actions[obj].targets;
	            break;
	          case 'Power RESET':
	            this.actions.reset.targets = this.editing.event.actions[obj].targets;
	            break;
	          case 'SMS':
	            var selectedSMS = [];
	            var selectedSMSMap = {};
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	              for (var _iterator3 = (0, _getIterator3.default)(this.SMSGroups.options), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var opt = _step3.value;
	
	                selectedSMSMap[opt.value] = opt;
	              }
	            } catch (err) {
	              _didIteratorError3 = true;
	              _iteratorError3 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                  _iterator3.return();
	                }
	              } finally {
	                if (_didIteratorError3) {
	                  throw _iteratorError3;
	                }
	              }
	            }
	
	            var _iteratorNormalCompletion4 = true;
	            var _didIteratorError4 = false;
	            var _iteratorError4 = undefined;
	
	            try {
	              for (var _iterator4 = (0, _getIterator3.default)(this.editing.event.actions[obj].targets), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                var tar = _step4.value;
	
	                selectedSMS.push(selectedSMSMap[tar]);
	              }
	            } catch (err) {
	              _didIteratorError4 = true;
	              _iteratorError4 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                  _iterator4.return();
	                }
	              } finally {
	                if (_didIteratorError4) {
	                  throw _iteratorError4;
	                }
	              }
	            }
	
	            this.SMSGroups.selected = _lodash2.default.cloneDeep(selectedSMS);
	            break;
	          case 'Email':
	            var selectedEmail = [];
	            var selectedEmailMap = {};
	            var _iteratorNormalCompletion5 = true;
	            var _didIteratorError5 = false;
	            var _iteratorError5 = undefined;
	
	            try {
	              for (var _iterator5 = (0, _getIterator3.default)(this.emailGroups.options), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                var _opt = _step5.value;
	
	                selectedEmailMap[_opt.value] = _opt;
	              }
	            } catch (err) {
	              _didIteratorError5 = true;
	              _iteratorError5 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                  _iterator5.return();
	                }
	              } finally {
	                if (_didIteratorError5) {
	                  throw _iteratorError5;
	                }
	              }
	            }
	
	            var _iteratorNormalCompletion6 = true;
	            var _didIteratorError6 = false;
	            var _iteratorError6 = undefined;
	
	            try {
	              for (var _iterator6 = (0, _getIterator3.default)(this.editing.event.actions[obj].targets), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	                var _tar = _step6.value;
	
	                selectedEmail.push(selectedEmailMap[_tar]);
	              }
	            } catch (err) {
	              _didIteratorError6 = true;
	              _iteratorError6 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                  _iterator6.return();
	                }
	              } finally {
	                if (_didIteratorError6) {
	                  throw _iteratorError6;
	                }
	              }
	            }
	
	            this.emailGroups.selected = _lodash2.default.cloneDeep(selectedEmail);
	            break;
	          case 'Sequence OFF':
	            this.actions.sqOFF.value = this.editing.event.actions[obj].value;
	            break;
	          case 'Sequence ON':
	            this.actions.sqON.value = this.editing.event.actions[obj].value;
	            break;
	        }
	      }
	      this.showModal = true;
	    },
	    hasSource: function hasSource() {
	      return this.editing.newEvent.newSource && this.editing.newEvent.newSource.length !== 0;
	    },
	    hasEventValue: function hasEventValue() {
	      var newE = this.editing.newEvent;
	      var value = false;
	      switch (newE.key) {
	        case 'Connection':
	          value = newE.connect && typeof newE.connect === 'string';
	          break;
	        case 'Power':
	          value = newE.power && typeof newE.power === 'string';
	          break;
	        case 'Current':
	          value = newE.float && typeof newE.float === 'string' && newE.condition && typeof newE.condition === 'string' && this.$newEventFloatValue.float.valid;
	          break;
	        case 'Voltage':
	          value = newE.float && typeof newE.float === 'string' && newE.condition && typeof newE.condition === 'string' && this.$newEventFloatValue.float.valid;
	          break;
	        case 'Ping':
	          value = this.$els.urlInput.className.indexOf('valid') !== -1;
	          break;
	      }
	      return value;
	    },
	    hasAction: function hasAction() {
	      if (this.newActions && this.newActions.length !== 0) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    hasValidPowerTypeAction: function hasValidPowerTypeAction() {
	      var counter = 0;
	      console.log('in valid Power Type action', this.newActions);
	      for (var i = 0; i < this.newActions.length; i++) {
	        if (this.newActions[i] !== 'Email' && this.newActions[i] !== 'SMS' && this.newActions[i] !== '') counter = counter + 1;
	      }
	      return counter <= 1;
	    },
	    hasTarget: function hasTarget() {
	      var newAc = this.newActions;
	      var ac = this.actions;
	      if (newAc.indexOf('Power ON') !== -1 && ac.on.targets.length === 0) return false;
	      if (newAc.indexOf('Power OFF') !== -1 && ac.off.targets.length === 0) return false;
	      if (newAc.indexOf('Power RESET') !== -1 && ac.reset.targets.length === 0) return false;
	      if (newAc.indexOf('Sequence ON') !== -1 && !this.hasSeqValue('on') && ac.sqON.targets.indexOf('') === -1 && ac.sqON.targets.indexOf('0') === -1 && ac.sqON.targets.length !== 3) return false;
	      if (newAc.indexOf('Sequence OFF') !== -1 && !this.hasSeqValue('off') && ac.sqOFF.targets.indexOf('') === -1 && ac.sqOFF.targets.indexOf('0') === -1 && ac.sqOFF.targets.length !== 3) return false;
	      if (newAc.indexOf('Email') !== -1 && this.emailGroups.selected.length === 0) return false;
	      if (newAc.indexOf('SMS') !== -1 && this.SMSGroups.selected.length === 0) return false;
	      return true;
	    },
	    hasSeqValue: function hasSeqValue(which) {
	      if (which === 'on') {
	        if (this.actions.sqON.value && this.actions.sqON.value !== '0' && this.actions.sqON.value !== '') return true;
	      } else if (which === 'off') {
	        if (this.actions.sqOFF.value && this.actions.sqOFF.value !== '0' && this.actions.sqOFF.value !== '') return true;
	      }
	      return false;
	    },
	    handleEventConfig: function handleEventConfig() {
	      var _this3 = this;
	
	      if (!this.$eventName.valid || this.editing.newEvent.name.trim().length === 0) {
	        return this.alert('danger', '', 'Please enter a valid event name');
	      }
	
	      if (this.editing.newEvent.key !== 'Connection' && this.editing.newEvent.key !== 'Ping' && !this.hasSource()) {
	        console.log(this.editing.newEvent.key);
	        return this.alert('danger', '', 'Please give this event a source');
	      }
	
	      if (!this.hasEventValue()) return this.alert('danger', '', 'Please complete the event config');
	
	      if (!this.hasAction()) return this.alert('danger', '', 'Please give your config an action');
	
	      if (!this.hasValidPowerTypeAction()) return this.alert('danger', 'You can only select one power related action at a time');
	
	      if (!this.hasTarget()) return this.alert('danger', '', 'Please give your action a target');
	
	      if (this.newActions.indexOf('Sequence ON') !== -1 && this.$seqON.delay.invalid || this.newActions.indexOf('Sequence OFF') !== -1 && this.$seqOFF.delay.invalid) return this.alert('danger', '', 'Please enter a valid delay time with integer');
	
	      console.log('hi everything is fine');
	      var newEvent = this.editing.newEvent;
	      var ac = [];
	
	      var _iteratorNormalCompletion7 = true;
	      var _didIteratorError7 = false;
	      var _iteratorError7 = undefined;
	
	      try {
	        for (var _iterator7 = (0, _getIterator3.default)(this.newActions), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	          var action = _step7.value;
	
	          switch (action) {
	            case 'Power ON':
	              ac.push({
	                action: action,
	                targets: this.actions.on.targets
	              });
	              break;
	            case 'Power OFF':
	              ac.push({
	                action: action,
	                targets: this.actions.off.targets
	              });
	              break;
	            case 'Power RESET':
	              ac.push({
	                action: action,
	                targets: this.actions.reset.targets
	              });
	              break;
	            case 'SMS':
	              ac.push({
	                action: action,
	                targets: this.SMSGroups.selected.map(function (tar) {
	                  return tar.value;
	                })
	              });
	              break;
	            case 'Email':
	              ac.push({
	                action: action,
	                targets: this.emailGroups.selected.map(function (tar) {
	                  return tar.value;
	                })
	              });
	              break;
	            case 'Sequence OFF':
	              ac.push({
	                action: action,
	                targets: ['0', '1', '2', '3'],
	                value: parseInt(this.actions.sqOFF.value).toString() });
	              break;
	            case 'Sequence ON':
	              ac.push({
	                action: action,
	                targets: ['0', '1', '2', '3'],
	                value: parseInt(this.actions.sqON.value).toString() });
	              break;
	          }
	        }
	      } catch (err) {
	        _didIteratorError7 = true;
	        _iteratorError7 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion7 && _iterator7.return) {
	            _iterator7.return();
	          }
	        } finally {
	          if (_didIteratorError7) {
	            throw _iteratorError7;
	          }
	        }
	      }
	
	      var param = {
	        entries: (0, _defineProperty3.default)({}, this.editing.index, {
	          enabled: newEvent.enabled,
	          name: newEvent.name.trim(),
	          event: {
	            key: newEvent.key,
	            condition: newEvent.condition,
	            value: '',
	            source: newEvent.key !== 'Connection' || newEvent.key !== 'Ping' ? newEvent.newSource : null
	          },
	          actions: ac
	        })
	      };
	      switch (newEvent.key) {
	        case 'Connection':
	          param.entries[this.editing.index].event.value = newEvent.connect;
	          break;
	        case 'Current':
	          param.entries[this.editing.index].event.value = parseFloat(newEvent.float).toString();
	          break;
	        case 'Voltage':
	          param.entries[this.editing.index].event.value = parseFloat(newEvent.float).toString();
	          break;
	        case 'Power':
	          param.entries[this.editing.index].event.value = newEvent.power;
	          break;
	        case 'Ping':
	          param.entries[this.editing.index].event.value = newEvent.pingAddr;
	      }
	
	      console.log(param);
	      (0, _Service.call)(this.$route.params.mac, 'dxSetEvents', param).then(function (res) {
	        console.log(res);
	        _this3.showModal = false;
	      }, function (err) {
	        _this3.alert('danger', 'Unexpected Error', err);
	        console.log(err);
	      });
	    },
	    setEvent: function setEvent(enabled, eventKey) {
	      var _this4 = this;
	
	      var param = {
	        entries: (0, _defineProperty3.default)({}, eventKey, this.events[eventKey])
	      };
	      param.entries[eventKey].enabled = enabled;
	      (0, _Service.call)(this.$route.params.mac, 'dxSetEvents', param).then(function (res) {
	        console.log(res);
	      }, function (err) {
	        _this4.alert('danger', 'Unexpected Error', err);
	        console.log(err);
	      });
	    },
	    handleGroupConfig: function handleGroupConfig(type, key) {
	      console.log(key);
	
	      if (type === 'email') {
	        this.editingGroup._id = key;
	        this.editingGroup.title = 'Edit email group ' + key;
	        this.editingGroup.format = 'ex1@gmail.com;ex2@gmail.com';
	        this.editingGroup.data = _lodash2.default.cloneDeep(this.emailData[key]);
	        this.editingGroup.cb = this.emailGpApply;
	      } else if (type === 'SMS') {
	        this.editingGroup._id = key;
	        this.editingGroup.title = 'Edit SMS group ' + key;
	        this.editingGroup.format = '+886932123123;+886972456456';
	        this.editingGroup.data = _lodash2.default.cloneDeep(this.SMSData[key]);
	        this.editingGroup.cb = this.SMSGpApply;
	      }
	
	      this.showGroupConfigTable = true;
	    },
	    checkGroupNameUsed: function checkGroupNameUsed(type) {
	      var data = type === 'email' ? this.emailData : this.SMSData;
	      for (var key in data) {
	        if (key !== this.editingGroup._id && data[key].name === this.editingGroup.data.name) return true;
	      }
	      return false;
	    },
	    checkGroupAccountAvailable: function checkGroupAccountAvailable(type) {
	      if (this.editingGroup.data.accounts.length === 0) {
	        return true;
	      } else {
	        var accounts = this.editingGroup.data.accounts.split(';');
	
	
	        if (type === 'email') {
	          var _iteratorNormalCompletion8 = true;
	          var _didIteratorError8 = false;
	          var _iteratorError8 = undefined;
	
	          try {
	            for (var _iterator8 = (0, _getIterator3.default)(accounts), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	              var email = _step8.value;
	
	              if (!(0, _emailValidator.validate)(email)) return 'one of the emails invalid';
	            }
	          } catch (err) {
	            _didIteratorError8 = true;
	            _iteratorError8 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion8 && _iterator8.return) {
	                _iterator8.return();
	              }
	            } finally {
	              if (_didIteratorError8) {
	                throw _iteratorError8;
	              }
	            }
	          }
	        } else if (type === 'SMS') {
	          var regex = /^\+{1}[0]{0,1}\d{10,12}/;
	          var _iteratorNormalCompletion9 = true;
	          var _didIteratorError9 = false;
	          var _iteratorError9 = undefined;
	
	          try {
	            for (var _iterator9 = (0, _getIterator3.default)(accounts), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	              var number = _step9.value;
	
	              if (!regex.test(number)) return 'one of the number invalid';
	            }
	          } catch (err) {
	            _didIteratorError9 = true;
	            _iteratorError9 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion9 && _iterator9.return) {
	                _iterator9.return();
	              }
	            } finally {
	              if (_didIteratorError9) {
	                throw _iteratorError9;
	              }
	            }
	          }
	        }
	
	        return true;
	      }
	    },
	    checkGroupAccountOverLimit: function checkGroupAccountOverLimit() {
	      return this.editingGroup.data.accounts.split(';').length > 10;
	    },
	    checkGroupCanBeEmpty: function checkGroupCanBeEmpty(type) {
	      var oldName = type === 'Email' ? this.emailData[this.editingGroup._id].name : this.SMSData[this.editingGroup._id].name;
	      var newName = this.editingGroup.data.name;
	
	      if (oldName === newName) return true;
	
	      var _iteratorNormalCompletion10 = true;
	      var _didIteratorError10 = false;
	      var _iteratorError10 = undefined;
	
	      try {
	        for (var _iterator10 = (0, _getIterator3.default)((0, _keys2.default)(this.events)), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	          var key = _step10.value;
	          var _iteratorNormalCompletion11 = true;
	          var _didIteratorError11 = false;
	          var _iteratorError11 = undefined;
	
	          try {
	            for (var _iterator11 = (0, _getIterator3.default)(this.events[key].actions), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
	              var obj = _step11.value;
	
	              if (obj.action === type && obj.targets.indexOf(oldName) !== -1) return false;
	            }
	          } catch (err) {
	            _didIteratorError11 = true;
	            _iteratorError11 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion11 && _iterator11.return) {
	                _iterator11.return();
	              }
	            } finally {
	              if (_didIteratorError11) {
	                throw _iteratorError11;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError10 = true;
	        _iteratorError10 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion10 && _iterator10.return) {
	            _iterator10.return();
	          }
	        } finally {
	          if (_didIteratorError10) {
	            throw _iteratorError10;
	          }
	        }
	      }
	
	      return true;
	    },
	    emailGpApply: function emailGpApply() {
	      var _this5 = this;
	
	      if (this.$groupName.invalid) return this.alert('danger', '', 'Invalid group name');
	
	      if (this.checkGroupNameUsed('email')) return this.alert('danger', '', 'Group name used');
	
	      if (this.editingGroup.data.accounts.length === 0 && !this.checkGroupCanBeEmpty('Email')) {
	        return this.alert('danger', '', 'You need to remove this group out of the targets of all events before leaving it empty');
	      }
	
	      if (!this.checkGroupCanBeEmpty('Email')) {
	        return this.alert('danger', '', 'You need to remove this group out of the targets of all events before modifying the name');
	      }
	
	      if (typeof this.checkGroupAccountAvailable('email') === 'string') {
	        return this.alert('danger', '', this.checkGroupAccountAvailable('email'));
	      }
	
	      if (this.checkGroupAccountOverLimit()) return this.alert('danger', '', 'Only 10 accounts allowed');
	
	      console.log('hahaha all email good');
	
	      var preName = this.emailData[this.editingGroup._id].name;
	      var newName = this.editingGroup.data.name;
	      var newEvents = _lodash2.default.cloneDeep(this.events);
	      console.log('preName = ', preName);
	      console.log('newName = ', newName);
	
	      var _iteratorNormalCompletion12 = true;
	      var _didIteratorError12 = false;
	      var _iteratorError12 = undefined;
	
	      try {
	        for (var _iterator12 = (0, _getIterator3.default)((0, _keys2.default)(newEvents)), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
	          var key = _step12.value;
	          var _iteratorNormalCompletion13 = true;
	          var _didIteratorError13 = false;
	          var _iteratorError13 = undefined;
	
	          try {
	            for (var _iterator13 = (0, _getIterator3.default)(newEvents[key].actions), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
	              var obj = _step13.value;
	
	              if (obj.action === 'Email' && preName !== newName && obj.targets.indexOf(preName) !== -1) {
	                obj.targets[obj.targets.indexOf(preName)] = newName;
	              }
	            }
	          } catch (err) {
	            _didIteratorError13 = true;
	            _iteratorError13 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion13 && _iterator13.return) {
	                _iterator13.return();
	              }
	            } finally {
	              if (_didIteratorError13) {
	                throw _iteratorError13;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError12 = true;
	        _iteratorError12 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion12 && _iterator12.return) {
	            _iterator12.return();
	          }
	        } finally {
	          if (_didIteratorError12) {
	            throw _iteratorError12;
	          }
	        }
	      }
	
	      this.editingGroup.data.name = this.editingGroup.data.name.trim();
	
	      this.events = newEvents;
	
	      var param = {
	        entries: (0, _defineProperty3.default)({}, this.editingGroup._id, this.editingGroup.data)
	      };
	      console.log(param);
	
	      (0, _Service.call)(this.$route.params.mac, 'dxSetEmailGroups', param).then(function (res) {
	        _this5.showGroupConfigTable = false;
	      }, function (err) {
	        _this5.alert('danger', '', err);
	      });
	    },
	    SMSGpApply: function SMSGpApply() {
	      var _this6 = this;
	
	      if (this.$groupName.invalid) return this.alert('danger', '', 'Invalid group name');
	
	      if (this.checkGroupNameUsed('SMS')) return this.alert('danger', '', 'Invalid group name');
	
	      if (this.editingGroup.data.accounts.length === 0 && !this.checkGroupCanBeEmpty('SMS')) {
	        return this.alert('danger', '', 'You need to remove this group out of the targets of all events before leaving it empty');
	      }
	
	      if (this.editingGroup.data.accounts.length === 0 && !this.checkGroupCanBeEmpty('SMS')) {
	        return this.alert('danger', '', 'You need to remove this group out of the targets of all events before modifying the name');
	      }
	
	      if (typeof this.checkGroupAccountAvailable('SMS') === 'string') {
	        return this.alert('danger', '', this.checkGroupAccountAvailable('SMS'));
	      }
	
	      if (this.checkGroupAccountOverLimit()) return this.alert('danger', '', 'Only 10 accounts allowed');
	
	      console.log('hahah all number good');
	
	      var preName = this.SMSData[this.editingGroup._id].name;
	      var newName = this.editingGroup.data.name;
	      var newEvents = _lodash2.default.cloneDeep(this.events);
	      console.log('preName = ', preName);
	      console.log('newName = ', newName);
	
	      var _iteratorNormalCompletion14 = true;
	      var _didIteratorError14 = false;
	      var _iteratorError14 = undefined;
	
	      try {
	        for (var _iterator14 = (0, _getIterator3.default)((0, _keys2.default)(newEvents)), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
	          var key = _step14.value;
	          var _iteratorNormalCompletion15 = true;
	          var _didIteratorError15 = false;
	          var _iteratorError15 = undefined;
	
	          try {
	            for (var _iterator15 = (0, _getIterator3.default)(newEvents[key].actions), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
	              var obj = _step15.value;
	
	              if (obj.action === 'SMS' && preName !== newName && obj.targets.indexOf(preName) !== -1) {
	                obj.targets[obj.targets.indexOf(preName)] = newName;
	              }
	            }
	          } catch (err) {
	            _didIteratorError15 = true;
	            _iteratorError15 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion15 && _iterator15.return) {
	                _iterator15.return();
	              }
	            } finally {
	              if (_didIteratorError15) {
	                throw _iteratorError15;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError14 = true;
	        _iteratorError14 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion14 && _iterator14.return) {
	            _iterator14.return();
	          }
	        } finally {
	          if (_didIteratorError14) {
	            throw _iteratorError14;
	          }
	        }
	      }
	
	      this.editingGroup.data.name = this.editingGroup.data.name.trim();
	
	      this.events = newEvents;
	
	      var param = {
	        entries: (0, _defineProperty3.default)({}, this.editingGroup._id, this.editingGroup.data)
	      };
	      console.log(param);
	      (0, _Service.call)(this.$route.params.mac, 'dxSetSMSGroups', param).then(function (res) {
	        _this6.showGroupConfigTable = false;
	      }, function (err) {
	        _this6.alert('danger', '', err);
	      });
	    },
	    handleDeleteGroup: function handleDeleteGroup(group, tag) {
	      var key = this[group].selected.indexOf(tag);
	      this[group].selected.splice(key, 1);
	    }
	  },
	  ready: function ready() {
	    this.updateTime();
	  },
	
	  watch: {
	    params: 'reloadAsyncData',
	    showModal: function showModal(nv) {
	      if (!nv) {
	        (0, _jquery2.default)('.event_config').scrollTop(0);
	        this.editing = {
	          title: 'Event Config',
	          index: '',
	          newEvent: {
	            name: '',
	            enabled: '',
	            key: '',
	            condition: '',
	            newSource: '',
	            connect: '',
	            power: '',
	            float: '',
	            pingCondition: 'fail',
	            pingAddr: ''
	          },
	          actionKeys: [],
	          newActions: []
	        };
	      }
	    },
	    showGroupConfigTable: function showGroupConfigTable(nv) {
	      if (!nv) {
	        (0, _jquery2.default)('.group_config').scrollTop(0);
	      }
	    },
	    showGroupConfig: function showGroupConfig(nv) {
	      if (!nv) {
	        this.reloadAsyncData();
	      }
	    },
	
	    emailGroups: {
	      deep: true,
	      handler: function handler(nv) {
	        if (nv.selected.length === 0 && this.newActions.indexOf('Email') !== -1) {
	          this.newActions.splice(this.newActions.indexOf('Email'), 1);
	        }
	      }
	    },
	    SMSGroups: {
	      deep: true,
	      handler: function handler(nv) {
	        if (nv.selected.length === 0 && this.newActions.indexOf('SMS') !== -1) {
	          this.newActions.splice(this.newActions.indexOf('SMS'), 1);
	        }
	      }
	    }
	  },
	  events: {
	    update: function update(mac, _ref7) {
	      var type = _ref7.type,
	          event = _ref7.event,
	          msg = _ref7.msg;
	
	      console.log(type);
	      console.log(event);
	      console.log(msg);
	      if (type === 'event') {
	        this.events = _lodash2.default.assignIn(this.events, event);
	      } else if (type === 'Email') {
	        this.emailData = _lodash2.default.assignIn(this.emailData, event);
	
	        this.emailGroups = {
	          options: [],
	          selected: []
	        };
	        for (var key in this.emailData) {
	          if (this.emailData[key].accounts.length !== 0) {
	            this.emailGroups.options.push({
	              label: this.emailData[key].name,
	              value: this.emailData[key].name
	            });
	          }
	        }
	      } else if (type === 'SMS') {
	        this.SMSData = _lodash2.default.assignIn(this.SMSData, event);
	
	        this.SMSGroups = {
	          options: [],
	          selected: []
	        };
	        for (var _key in this.SMSData) {
	          if (this.SMSData[_key].accounts.length !== 0) {
	            this.SMSGroups.options.push({
	              label: this.SMSData[_key].name,
	              value: this.SMSData[_key].name
	            });
	          }
	        }
	      } else if (type === 'timezone') {
	        this.timezone = event.timezone;
	      }
	    }
	  }
	};

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getIterator2 = __webpack_require__(28);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(22);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vueStrap = __webpack_require__(12);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _SingleSelect = __webpack_require__(26);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _Service = __webpack_require__(8);
	
	var _MultiBanks = __webpack_require__(178);
	
	var _MultiBanks2 = _interopRequireDefault(_MultiBanks);
	
	var _jquery = __webpack_require__(21);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEVICE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss';
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal,
	    'v-select': _SingleSelect2.default,
	    'v-multi-banks': _MultiBanks2.default
	  },
	  data: function data() {
	    return {
	      editing: {
	        title: 'Schedule Config',
	        index: '',
	        schedule: null,
	        newBanks: [],
	        newDays: []
	      },
	      schedules: {},
	      banks: {},
	      input: {},
	      allBanks: [],
	      showModal: false,
	      new_schedule_name: '',
	      weekDay: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
	      actionOptions: [{ label: 'Power ON', value: 'Power ON' }, { label: 'Power OFF', value: 'Power OFF' }, { label: 'Power RESET', value: 'Power RESET' }, { label: 'Sequence ON (From Outlet 1 to 9)', value: 'Sequence ON' }, { label: 'Sequence OFF (From Outlet 1 to 9)', value: 'Sequence OFF' }],
	      currentTime: '',
	      timezone: {},
	      pageFocus: 1,
	      showAni: true
	    };
	  },
	
	  computed: {
	    scheduleLength: function scheduleLength() {
	      return (0, _keys2.default)(this.schedules).length;
	    },
	    deviceTime: function deviceTime() {
	      if (this.timezone.useDaylight && (0, _moment2.default)().isDST()) {
	        return (0, _moment2.default)(this.currentTime).utc().add(this.timezone.offset, 'seconds').add(this.timezone.dstSavings, 'seconds').format(DEVICE_TIME_FORMAT);
	      } else {
	        return (0, _moment2.default)(this.currentTime).utc().add(this.timezone.offset, 'seconds').format(DEVICE_TIME_FORMAT);
	      }
	    },
	    targetOption: function targetOption() {
	      return (0, _keys2.default)(this.allBanks).map(function (idx) {
	        return {
	          label: idx === '0' ? 'Input' : 'Outlet' + idx,
	          value: idx
	        };
	      });
	    },
	    weekOption: function weekOption() {
	      return this.weekDay.map(function (day) {
	        return {
	          label: day,
	          value: day
	        };
	      });
	    }
	  },
	  asyncData: function asyncData() {
	    var _this = this;
	
	    var mac = this.$route.params.mac;
	
	    this.showAni = true;
	    (0, _Service.call)(mac, 'dxGetSchedules', { key: 1 }).then(function (_ref) {
	      var entries = _ref.entries;
	
	      _this.schedules = _lodash2.default.cloneDeep(entries);
	      return (0, _Service.call)(mac, 'dxGetPowerStatus');
	    }).then(function (_ref2) {
	      var banks = _ref2.banks,
	          input = _ref2.input;
	
	      _this.banks = _lodash2.default.cloneDeep(banks);
	      _this.input = _lodash2.default.cloneDeep(input);
	      _this.allBanks = [];
	      _this.allBanks.push(_this.input);
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(_this.banks)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var key = _step.value;
	
	          _this.allBanks.push(_this.banks[key]);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return (0, _Service.call)(mac, 'dxGetTimeZone');
	    }).then(function (_ref3) {
	      var timezone = _ref3.timezone;
	
	      _this.timezone = timezone;
	      _this.showAni = false;
	    }).catch(function (err) {
	      _this.alert('danger', 'Error', 'Unexpect error when initializing the page');
	      console.log(err);
	    });
	  },
	
	  methods: {
	    getSchedule: function getSchedule(page) {
	      var _this2 = this;
	
	      var mac = this.$route.params.mac;
	
	      this.showAni = true;
	      (0, _Service.call)(mac, 'dxGetSchedules', { key: page }).then(function (_ref4) {
	        var entries = _ref4.entries;
	
	        _this2.schedules = _lodash2.default.cloneDeep(entries);
	        _this2.pageFocus = page;
	        _this2.showAni = false;
	      }).catch(function (err) {
	        _this2.alert('danger', 'Error', 'Unexpect error when initializing the page');
	        _this2.schedule = [];
	        _this2.showAni = false;
	        console.log(err);
	      });
	    },
	    updateTime: function updateTime() {
	      this.currentTime = Date.now();
	      var vue = this;
	      setTimeout(function () {
	        vue.updateTime();
	      }, 1000);
	    },
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    setSchedule: function setSchedule(enabled, scheduleKey) {
	      var _this3 = this;
	
	      var param = {
	        entries: (0, _defineProperty3.default)({}, scheduleKey, this.schedules[scheduleKey])
	      };
	      param.entries[scheduleKey].enabled = enabled;
	      (0, _Service.call)(this.$route.params.mac, 'dxSetSchedules', param).then(function (res) {
	        console.log(res);
	      }, function (err) {
	        _this3.alert('danger', 'Unexpected Error', err);
	        console.log(err);
	      });
	    },
	    toShowModal: function toShowModal(key) {
	      this.editing.index = key;
	      this.editing.title = 'Schedule Config ' + key;
	      this.editing.schedule = _lodash2.default.cloneDeep(this.schedules[key]);
	      this.editing.newBanks = this.editing.schedule.banks;
	      this.editing.newDays = this.editing.schedule.time.days;
	      this.showModal = true;
	    },
	    handleScheduleConfig: function handleScheduleConfig() {
	      var _this4 = this;
	
	      if (this.$scheName.invalid) return this.alert('danger', '', 'Please enter a valid schedule name');
	
	      var regexNum = /^[0-9]{1,2}/;
	      if (!regexNum.test(this.editing.schedule.time.hours) || !regexNum.test(this.editing.schedule.time.minutes) || this.editing.schedule.time.hours.length > 2 || this.editing.schedule.time.minutes.length > 2) return this.alert('danger', '', 'Please enter valid times');
	
	      if (this.editing.schedule.time.hours < 0 || this.editing.schedule.time.minutes < 0 || this.editing.schedule.time.hours > 23 || this.editing.schedule.time.minutes > 59) {
	        return this.alert('danger', '', 'Please enter right format of time (ex: 14:59)');
	      }
	
	      if (this.editing.newDays.length === 0) {
	        return this.alert('danger', '', 'Please choose a day for your schedule to active');
	      }
	
	      if (this.editing.newBanks.length === 0) {
	        return this.alert('danger', '', 'Please give your schedule a target');
	      }
	
	      if (this.editing.newBanks.length !== this.allBanks.length && (this.editing.schedule.action === 'Sequence ON' || this.editing.schedule.action === 'Sequence OFF')) {
	        return this.alert('danger', '', 'You need to select all targets to enable Sequence ON/Sequence OFF');
	      }
	
	      var sche = _lodash2.default.cloneDeep(this.editing.schedule);
	      sche.name = this.new_schedule_name.trim();
	      sche.banks = _lodash2.default.cloneDeep(this.editing.newBanks);
	      sche.time.days = _lodash2.default.cloneDeep(this.editing.newDays);
	
	      var param = {
	        entries: (0, _defineProperty3.default)({}, this.editing.index, sche)
	      };
	
	      (0, _Service.call)(this.$route.params.mac, 'dxSetSchedules', param).then(function (res) {
	        console.log(res);
	        _this4.showModal = false;
	      }, function (err) {
	        _this4.alert('danger', 'Unexpected Error', err);
	        console.log(err);
	      });
	    }
	  },
	  ready: function ready() {
	    this.updateTime();
	  },
	
	  events: {
	    update: function update(mac, _ref5) {
	      var type = _ref5.type,
	          event = _ref5.event,
	          msg = _ref5.msg;
	
	      console.log(type);
	      console.log(event);
	      console.log(msg);
	      if (type === 'schedule') {
	        this.schedules = _lodash2.default.assignIn(this.schedules, event);
	      } else if (type === 'timezone') {
	        this.timezone = event.timezone;
	      }
	    }
	  },
	  watch: {
	    'editing.schedule.action': function editingScheduleAction(nV) {
	      console.log(nV);
	      if (nV === 'Sequence ON' || nV === 'Sequence OFF') {
	        this.editing.newBanks = [];
	        for (var i = 0; i < this.allBanks.length; i++) {
	          this.editing.newBanks.push(i.toString());
	        }
	      }
	    },
	    showModal: function showModal(nv) {
	      if (!nv) {
	        (0, _jquery2.default)('.schedule_config').scrollTop(0);
	      }
	    }
	  }
	};

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(28);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _regenerator = __webpack_require__(54);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _keys = __webpack_require__(22);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _asyncToGenerator2 = __webpack_require__(53);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _Service = __webpack_require__(8);
	
	var _vueStrap = __webpack_require__(12);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEVICE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss';
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal
	  },
	  data: function data() {
	    return {
	      input: {
	        enabled: false
	      },
	      banks: {},
	      outletNameValid: {},
	      showConfig: false,
	      showConfirm: false,
	      editing: {
	        _id: null,
	        title: '',
	        locked: null,
	        outlets: []
	      },
	      confirm: {
	        msg: '',
	        cb: function cb() {}
	      },
	      currentTime: '',
	      timezone: {}
	    };
	  },
	  asyncData: function asyncData() {
	    var _this = this;
	
	    (0, _Service.call)(this.$route.params.mac, 'dxGetPowerStatus').then(function (data) {
	      _this.input = _lodash2.default.cloneDeep(data.input);
	      _this.banks = _lodash2.default.cloneDeep(data.banks);
	      return (0, _Service.call)(_this.$route.params.mac, 'dxGetTimeZone');
	    }).then(function (_ref) {
	      var timezone = _ref.timezone;
	
	      console.log(timezone);
	      _this.timezone = timezone;
	    }).catch(function (err) {
	      _this.alert('danger', 'No response', err);
	    });
	  },
	
	  computed: {
	    deviceTime: function deviceTime() {
	      if (this.timezone.useDaylight && (0, _moment2.default)().isDST()) {
	        return (0, _moment2.default)(this.currentTime).utc().add(this.timezone.offset, 'seconds').add(this.timezone.dstSavings, 'seconds').format(DEVICE_TIME_FORMAT);
	      } else {
	        return (0, _moment2.default)(this.currentTime).utc().add(this.timezone.offset, 'seconds').format(DEVICE_TIME_FORMAT);
	      }
	    },
	    inputPowerString: function inputPowerString() {
	      var str = '';
	      if (this.input.power > 1000) {
	        str = (this.input.power / 1000).toFixed(2) + 'KW';
	      } else {
	        str = this.input.power + 'W';
	      }
	      return str || 0;
	    }
	  },
	  methods: {
	    updateTime: function updateTime() {
	      this.currentTime = Date.now();
	      var vue = this;
	      setTimeout(function () {
	        vue.updateTime();
	      }, 1000);
	    },
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    handleOutletConfig: function handleOutletConfig(key, bank) {
	      this.editing._id = key;
	      this.editing.title = 'Outlet' + key;
	      this.editing.outlets = _lodash2.default.cloneDeep(bank.outlets);
	      this.editing.locked = bank.locked;
	      this.showConfig = true;
	    },
	    nameValid: function nameValid(val) {
	      return (/^[0-9A-Za-z\s_]{1,}$/.test(val)
	      );
	    },
	    handleOutletApply: function handleOutletApply() {
	      for (var key in this.editing.outlets) {
	        this.editing.outlets[key].name = this.editing.outlets[key].name.trim();
	        if (!this.nameValid(this.editing.outlets[key].name)) return this.alert('danger', '', 'Please enter valid outlet name, number and english characters only');
	      }
	
	      this.setBankInfo();
	      this.showConfig = false;
	    },
	    lockChged: function lockChged() {
	      if (this.banks[this.editing._id].locked === this.editing.locked) {
	        return false;
	      } else {
	        return true;
	      }
	    },
	    portChged: function portChged() {
	      for (var port in this.banks[this.editing._id].outlets) {
	        if (this.editing.outlets[port].name !== this.banks[this.editing._id].outlets[port].name) {
	          return true;
	        }
	      }
	      return false;
	    },
	    switchEnable: function switchEnable(key) {
	      var newParam = {
	        banks: [key],
	        enabled: key === '0' ? !this.input.enabled : !this.banks[key].enabled
	      };
	
	      this.sendAPI('dxEnableBank', newParam);
	    },
	    switchLock: function switchLock(key) {
	      var newParam = {
	        banks: [key],
	        locked: key === 0 ? !this.input.locked : this.editing.locked
	      };
	
	      this.sendAPI('dxLockBank', newParam);
	    },
	    toReset: function toReset(key) {
	      this.sendAPI('dxResetBank', {
	        banks: [key]
	      });
	    },
	    toResetAll: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var mac, i;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('reset all');
	                mac = this.$route.params.mac;
	                _context.prev = 2;
	                i = 1;
	
	              case 4:
	                if (!(i <= (0, _keys2.default)(this.banks).length)) {
	                  _context.next = 10;
	                  break;
	                }
	
	                _context.next = 7;
	                return (0, _Service.call)(mac, 'dxResetBank', {
	                  banks: [i.toString()]
	                });
	
	              case 7:
	                i++;
	                _context.next = 4;
	                break;
	
	              case 10:
	                _context.next = 15;
	                break;
	
	              case 12:
	                _context.prev = 12;
	                _context.t0 = _context['catch'](2);
	
	                console.error(_context.t0);
	
	              case 15:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[2, 12]]);
	      }));
	
	      function toResetAll() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return toResetAll;
	    }(),
	    setBankInfo: function setBankInfo() {
	      this.sendAPI('dxSetBankInfo', {
	        banks: (0, _defineProperty3.default)({}, this.editing._id, {
	          outlets: this.editing.outlets
	        })
	      });
	    },
	    sendAPI: function sendAPI(cmd, params) {
	      var _this2 = this;
	
	      (0, _Service.call)(this.$route.params.mac, cmd, params).then(function (res) {
	        console.log(res);
	      }, function (err) {
	        _this2.alert('danger', '', err);
	      });
	    }
	  },
	  ready: function ready() {
	    this.updateTime();
	  },
	
	  events: {
	    update: function update(mac, _ref3) {
	      var type = _ref3.type,
	          event = _ref3.event,
	          msg = _ref3.msg;
	
	      console.log('type: ', type);
	      console.log('event: ', event);
	      console.log('msg: ', msg);
	      if (type === 'info') {
	        var key = event.banks[0];
	        if (this.banks[key].outlets) {
	          this.banks[key].outlets = _lodash2.default.cloneDeep(event.outlets);
	        }
	      } else if (type === 'lock') {
	        if (event.banks[0] > 0) {
	          this.banks[event.banks[0]].locked = event.locked;
	        } else {
	          this.input.locked = event.locked;
	        }
	      } else if (type === 'enable') {
	        if (event.banks.length > 0) {
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(event.banks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var _key = _step.value;
	
	              if (_key === '0') {
	                this.input.enabled = event.enabled;
	              } else {
	                this.banks[_key].enabled = event.enabled;
	              }
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        }
	      } else if (type === 'reset') {} else if (type === 'timezone') {
	        this.timezone = event.timezone;
	      }
	    },
	    status: function status(mac, _ref4) {
	      var banks = _ref4.banks,
	          input = _ref4.input;
	
	      this.input.voltage = input.voltage;
	      this.input.current = input.current;
	      this.input.power = input.power;
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)((0, _keys2.default)(banks)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var key = _step2.value;
	
	          _lodash2.default.assignIn(this.banks[key], {
	            current: banks[key].current,
	            power: banks[key].power
	          });
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  },
	  route: {
	    canReuse: false, activate: function activate(_ref5) {
	      var next = _ref5.next;
	
	      next();
	    }
	  }
	};

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      DIs: {
	        1: {
	          name: 'fan sensor'
	        },
	        2: {
	          name: 'light sensor'
	        },
	        3: {
	          name: 'fan sensor'
	        },
	        4: {
	          name: 'light sensor'
	        }
	      },
	      DOs: {
	        1: {
	          name: 'alarm LED',
	          value: 'low'
	        },
	        2: {
	          name: 'alarm Call',
	          value: 'high'
	        },
	        3: {
	          name: 'alarm Call',
	          value: 'high'
	        },
	        4: {
	          name: 'alarm Call',
	          value: 'high'
	        }
	      },
	      weekDays: ['mon', 'tue', 'wed', 'thr', 'fri', 'sat', 'sun'],
	      dxSetSchedules: {
	        no: '1',
	        params: {
	          enabled: true,
	          name: 'hahaha',
	          action: 'DO High',
	          targets: ['1'],
	          time: {
	            hours: 8,
	            minutes: 0,
	            days: ['mon', 'tue']
	          }
	        }
	      },
	      dxSetEvents: {
	        no: '1',
	        keys: ['DI'],
	        conditions: ['=='],
	        actionTypes: ['DO High', 'DO Low', 'Email', 'SMS'].map(function (action, index) {
	          return {
	            selected: false,
	            show_checkbox_dio: index <= 1,
	            show_targets_string: index > 1 && index < 4,
	            show_value: index >= 7,
	            action: action,
	            value: '',
	            targets_string: 'admin;user1',
	            targets: []
	          };
	        }),
	        content: {
	          enabled: false,
	          name: 'test',
	          event: {
	            key: 'DI',
	            condition: '==',
	            value: 'High2Low',
	            source: '2'
	          },
	          actions: []
	        }
	      }
	    };
	  },
	  methods: {
	    sendAPI: function sendAPI(cmd, params) {
	      this.$dispatch('sendAPI', cmd, params);
	    },
	    dxSetDIOConfig: function dxSetDIOConfig() {
	      var DIs = {};
	      var DOs = {};
	      for (var i in this.DIs) {
	        DIs[i] = {
	          name: this.DIs[i].name
	        };
	      }
	      for (var _i in this.DOs) {
	        DOs[_i] = {
	          name: this.DOs[_i].name
	        };
	      }
	      this.sendAPI('dxSetDIOConfig', { DIs: DIs, DOs: DOs });
	    },
	    dxSetDOState: function dxSetDOState() {
	      var DOs = {};
	      for (var i in this.DOs) {
	        DOs[i] = {
	          value: this.DOs[i].value
	        };
	      }
	      this.sendAPI('dxSetDOState', { DOs: DOs });
	    },
	    dxSetSchedulesHandler: function dxSetSchedulesHandler() {
	      if (this.dxSetSchedules.no > 10 || this.dxSetSchedules.no < 1) return window.alert('only 1-10 schedules number allowed');
	      this.sendAPI('dxSetSchedules', {
	        entries: (0, _defineProperty3.default)({}, this.dxSetSchedules.no, this.dxSetSchedules.params)
	      });
	    },
	    dxSetEventsHandler: function dxSetEventsHandler() {
	      var _dxSetEvents = this.dxSetEvents,
	          content = _dxSetEvents.content,
	          no = _dxSetEvents.no;
	
	      content.actions = this.dxSetEvents.actionTypes.map(function (T, index) {
	        return {
	          action: T.selected && T.action,
	          value: T.value,
	          targets: T.show_targets_string ? T.targets_string.split(';') : T.targets
	        };
	      }).filter(function (T) {
	        return T.action;
	      });
	      if (content.actions.length === 0) {
	        window.alert('at least one action, please!');
	      } else {
	        this.sendAPI('dxSetEvents', {
	          entries: (0, _defineProperty3.default)({}, no, content)
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _vueStrap = __webpack_require__(12);
	
	var _timezoneOption = __webpack_require__(617);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    radio: _vueStrap.radio
	  },
	  data: function data() {
	    return {
	      timezoneOpts: (0, _timezoneOption.getTimezoneOptions)(),
	      timezone: {
	        'id': 'GMT-6:00(Chicago, Dallas, Huston, Mexico City, New Orleans)',
	        'offset': -21600,
	        'dstSavings': 3600,
	        'useDaylight': true
	      },
	      networkSettings: {
	        deviceName: '',
	        deviceIpAddress: '',
	        deviceSubnetMask: '',
	        deviceDefaultGateway: '',
	        dnsServer1: '',
	        dnsServer2: '',
	        webPagePort: ''
	      },
	      dhcpEnabled: false,
	      firmwareUrl: '',
	      emailGroup: {
	        gid: '1',
	        content: {
	          name: 'admins',
	          accounts: 'joe@gmail.com;lisa@gmail.com'
	        }
	      },
	      smsGroup: {
	        gid: '1',
	        content: {
	          name: 'admins',
	          accounts: '+886972345678;+886912345678;'
	        }
	      },
	      weekDays: ['mon', 'tue', 'wed', 'thr', 'fri', 'sat', 'sun'],
	      dxSetSchedules: {
	        no: '1',
	        params: {
	          enabled: true,
	          name: 'hahaha',
	          action: 'Power RESET',
	          banks: ['1'],
	          time: {
	            hours: 8,
	            minutes: 0,
	            days: ['mon', 'tue']
	          }
	        }
	      },
	      dxSetEvents: {
	        no: '1',
	        keys: ['Voltage', 'Current', 'Connection', 'Power', 'DI'],
	        conditions: ['>', '>=', '==', '<=', '<'],
	        actionTypes: ['Power RESET', 'Power ON', 'Power OFF', 'DO High', 'DO Low', 'Email', 'SMS', 'Sequence ON', 'Sequence OFF'].map(function (action, index) {
	          return {
	            selected: false,
	            show_checkbox_power: index < 3,
	            show_checkbox_dio: index >= 3 && index < 5,
	            show_targets_string: index >= 5,
	            show_value: index >= 7,
	            action: action,
	            value: '',
	            targets_string: 'admin;user1',
	            targets: []
	          };
	        }),
	        content: {
	          enabled: false,
	          name: 'test',
	          event: {
	            key: 'Voltage',
	            condition: '>=',
	            value: '110',
	            source: '2'
	          },
	          actions: []
	        }
	      }
	    };
	  },
	  methods: {
	    sendAPI: function sendAPI(cmd, params) {
	      this.$dispatch('sendAPI', cmd, params);
	    },
	    dxSetTimeZone: function dxSetTimeZone() {
	      this.sendAPI('dxSetTimeZone', {
	        timezone: this.timezone
	      });
	    },
	    dxSetNetworkSettings: function dxSetNetworkSettings() {
	      var params = this.networkSettings;
	      params.dhcpEnabled = this.dhcpEnabled;
	      console.log(params);
	      this.sendAPI('dxSetNetworkSettings', params);
	    },
	    dxSetPower: function dxSetPower(str) {
	      this.sendAPI('dxSetNetworkSettings', { power: str });
	    },
	    dxUpdateFirmware: function dxUpdateFirmware() {
	      this.sendAPI('dxUpdateFirmware', { url: this.firmwareUrl });
	    },
	    dxSetEmailGroups: function dxSetEmailGroups() {
	      this.sendAPI('dxSetEmailGroups', {
	        entries: (0, _defineProperty3.default)({}, this.emailGroup.gid, this.emailGroup.content)
	      });
	    },
	    dxSetSMSGroups: function dxSetSMSGroups() {
	      this.sendAPI('dxSetSMSGroups', {
	        entries: (0, _defineProperty3.default)({}, this.smsGroup.gid, this.smsGroup.content)
	      });
	    },
	    dxSetSchedulesHandler: function dxSetSchedulesHandler() {
	      if (this.dxSetSchedules.no > 10 || this.dxSetSchedules.no < 1) return window.alert('only 1-10 schedules number allowed');
	      this.sendAPI('dxSetSchedules', {
	        entries: (0, _defineProperty3.default)({}, this.dxSetSchedules.no, this.dxSetSchedules.params)
	      });
	    },
	    dxSetEventsHandler: function dxSetEventsHandler() {
	      var _dxSetEvents = this.dxSetEvents,
	          content = _dxSetEvents.content,
	          no = _dxSetEvents.no;
	
	      content.actions = this.dxSetEvents.actionTypes.map(function (T, index) {
	        return {
	          action: T.selected && T.action,
	          value: T.value,
	          targets: T.show_targets_string ? T.targets_string.split(';') : T.targets
	        };
	      }).filter(function (T) {
	        return T.action;
	      });
	      if (content.length === 0) {
	        window.alert('at least one action, please!');
	      } else {
	        this.sendAPI('dxSetEvents', {
	          entries: (0, _defineProperty3.default)({}, no, content)
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 665 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      command: '',
	      hexValue: ''
	    };
	  },
	  methods: {
	    up: function up() {
	      this.dxSendIRSignal('77e150fb');
	    },
	    down: function down() {
	      this.dxSendIRSignal('77e130fb');
	    },
	    left: function left() {
	      this.dxSendIRSignal('77e190fb');
	    },
	    right: function right() {
	      this.dxSendIRSignal('77e160fb');
	    },
	    menu: function menu() {
	      this.dxSendIRSignal('77e1c0fb');
	    },
	    select: function select() {
	      this.dxSendIRSignal('77e13afb');
	    },
	    play: function play() {
	      this.dxSendIRSignal('77e1fafb');
	    },
	    sendAPI: function sendAPI(cmd, params) {
	      this.$dispatch('sendAPI', cmd, params);
	    },
	    dxSendIRCommand: function dxSendIRCommand() {
	      this.sendAPI('dxSendIRCommand', {
	        command: this.command
	      });
	    },
	    dxSendIRSignal: function dxSendIRSignal(cmd) {
	      console.log(this.hexValue);
	      this.sendAPI('dxSendIRSignal', {
	        signal: cmd || this.hexValue
	      });
	    }
	  }
	};

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getIterator2 = __webpack_require__(28);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      mapping: [{
	        port: '2',
	        value: '3'
	      }, {
	        port: '3',
	        value: '3'
	      }],
	      info: {
	        inputs: [{
	          port: '2',
	          name: 'DVD',
	          photo: '1'
	        }, {
	          port: '3',
	          name: 'PS4',
	          photo: '3'
	        }],
	        outputs: [{
	          port: '4',
	          name: 'Room',
	          photo: '2'
	        }, {
	          port: '5',
	          name: 'Lobby',
	          photo: '2'
	        }]
	      },
	      engineOpts: ['0', '1.4', '2.2'],
	      hdcp: {
	        inputs: [{
	          port: '2',
	          enabled: true,
	          engine: '0'
	        }, {
	          port: '3',
	          enabled: true,
	          engine: '0'
	        }],
	        outputs: [{
	          port: '3',
	          enabled: true,
	          engine: '0'
	        }, {
	          port: '4',
	          enabled: true,
	          engine: '0'
	        }]
	      },
	      maps: {
	        no: '2',
	        name: 'profile1',
	        count: 4,
	        mapping: {}
	      },
	      edidOpts: ['default', 'HDMI', 'HDBT', 'custom', 'auto'],
	      edid: {
	        no: '2',
	        type: 'default',
	        value: '1'
	      },
	      toResetLinks: {
	        inputs: [],
	        outputs: []
	      },
	      switcherLayout: '0',
	      switcherMapping: '1'
	    };
	  },
	  methods: {
	    sendAPI: function sendAPI(cmd, params) {
	      this.$dispatch('sendAPI', cmd, params);
	    },
	    dxSetMappingAndLayout: function dxSetMappingAndLayout() {
	      this.sendAPI('dxSetMappingAndLayout', {
	        layout: this.switcherLayout,
	        mapping: {
	          '1': this.switcherMapping
	        }
	      });
	    },
	    dxSetSwitcherLayout: function dxSetSwitcherLayout() {
	      this.sendAPI('dxSetSwitcherLayout', {
	        layout: this.switcherLayout
	      });
	    },
	    dxSetMapping: function dxSetMapping() {
	      var mapping = {};
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.mapping), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var setting = _step.value;
	
	          mapping[setting.port] = setting.value;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      this.sendAPI('dxSetMapping', { mapping: mapping });
	    },
	    dxSetPortInfo: function dxSetPortInfo() {
	      var params = {
	        inputs: {},
	        outputs: {}
	      };
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(this.info.inputs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var setting = _step2.value;
	
	          params.inputs[setting.port] = {
	            photo: setting.photo,
	            name: setting.name
	          };
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = (0, _getIterator3.default)(this.info.outputs), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var _setting = _step3.value;
	
	          params.outputs[_setting.port] = {
	            photo: _setting.photo,
	            name: _setting.name
	          };
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      this.sendAPI('dxSetPortInfo', params);
	    },
	    dxSetHDCP: function dxSetHDCP() {
	      var params = {
	        outputs: {}
	      };
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = (0, _getIterator3.default)(this.hdcp.outputs), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var setting = _step4.value;
	
	          params.outputs[setting.port] = {
	            enabled: setting.enabled,
	            engine: setting.engine
	          };
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      this.sendAPI('dxSetHDCP', params);
	    },
	    dxSetMaps: function dxSetMaps() {
	      var mapping = {};
	      for (var i = 1; i <= this.maps.count; i++) {
	        mapping[i] = this.maps.mapping[i];
	      }
	      var maps = (0, _defineProperty3.default)({}, this.maps.no, {
	        name: this.maps.name,
	        mapping: mapping
	      });
	      this.sendAPI('dxSetMaps', { maps: maps });
	    },
	    dxSetEDID: function dxSetEDID() {
	      this.sendAPI('dxSetEDID', {
	        inputs: (0, _defineProperty3.default)({}, this.edid.no, {
	          type: this.edid.type,
	          value: this.edid.value
	        })
	      });
	    },
	    dxResetLink: function dxResetLink() {
	      this.sendAPI('dxResetLink', this.toResetLinks);
	    }
	  }
	};

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	  methods: {
	    sendAPI: function sendAPI(cmd, params) {
	      this.$dispatch('sendAPI', cmd, params);
	    },
	    dxSetOutputResolution: function dxSetOutputResolution() {
	      this.sendAPI('dxSetOutputResolution', {
	        resolution: (0, _defineProperty3.default)({}, this.outputRes.port, this.outputRes.option)
	      });
	    },
	    dxSetSplitArea: function dxSetSplitArea() {
	      this.sendAPI('dxSetSplitArea', {
	        setting: this.splitArea
	      });
	    }
	  }
	};

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _SingleSelect = __webpack_require__(26);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    'v-select': _SingleSelect2.default
	  },
	  data: function data() {
	    return {
	      profileKey: '1',
	      setProfileKey: '1',
	      profile: {
	        pid: '1',
	        content: {
	          name: 'custom 1',
	          mapping: {
	            1: '4',
	            2: '4',
	            3: '4',
	            4: '4'
	          },
	          layer: [1, 3, 2, 4],
	          split: {
	            1: [0, 0, 960, 540, 0],
	            2: [960, 0, 1920, 540, 0],
	            3: [0, 540, 960, 1080, 0],
	            4: [960, 540, 1920, 1080, 0]
	          }
	        }
	      },
	      sound: {
	        SoundFrom: '1',
	        RLChannel: '1',
	        FullScreenAudio: true,
	        Mute: false
	      },
	      video: {
	        VerticalFlip: false,
	        Mirror: false
	      },
	      color: {
	        Brightness: 50,
	        Saturation: 50,
	        Contrast: 50
	      },
	      outputRes: {
	        port: '1',
	        option: '3'
	      },
	      splitLayer: [1, 2, 3, 4],
	      splitAreaPort: 1,
	      splitArea: {
	        1: [0, 0, 960, 540, 0],
	        2: [960, 0, 1920, 540, 0],
	        3: [0, 540, 960, 1080, 0],
	        4: [960, 540, 1920, 1080, 0]
	      },
	      mappingPort: 1,
	      mapping: {
	        1: '3',
	        2: '3',
	        3: '3',
	        4: '3'
	      },
	      labelPort: {
	        'osd': 1,
	        'windows': 1,
	        'inputs': 1,
	        'custom': 1
	      },
	      label: {
	        'osd': {
	          '1': { 'enabled': true, 'border': 0 },
	          '2': { 'enabled': true, 'border': 1 },
	          '3': { 'enabled': true, 'border': 2 },
	          '4': { 'enabled': false, 'border': 0 }
	        },
	        'windows': {
	          '1': { 'text': 'A', 'enabled': true },
	          '2': { 'text': 'B', 'enabled': true },
	          '3': { 'text': 'C', 'enabled': true },
	          '4': { 'text': 'D', 'enabled': true }
	        },
	        'inputs': {
	          '1': { 'text': '1', 'enabled': true },
	          '2': { 'text': '2', 'enabled': true },
	          '3': { 'text': '3', 'enabled': true },
	          '4': { 'text': '4', 'enabled': true }
	        },
	        'custom': {
	          '1': { 'text': 'Custom 1', 'enabled': false },
	          '2': { 'text': 'Custom 2', 'enabled': false },
	          '3': { 'text': 'Custom 3', 'enabled': false },
	          '4': { 'text': 'Custom 4', 'enabled': false }
	        }
	      },
	      cropPort: 1,
	      crop: {
	        1: { enabled: true, H: [1, 3, 4], V: [1, 1, 1] },
	        2: { enabled: true, H: [1, 3, 4], V: [1, 1, 1] },
	        3: { enabled: false, H: [1, 1, 1], V: [1, 1, 1] },
	        4: { enabled: false, H: [1, 1, 1], V: [1, 1, 1] } },
	      splitOptions: [{ label: 'PAP1', value: 'PAP1' }, { label: 'PAP2', value: 'PAP2' }, { label: 'PAP3', value: 'PAP3' }, { label: 'PAP4', value: 'PAP4' }, { label: 'PAP5', value: 'PAP5' }, { label: 'Full-A', value: 'Full-A' }, { label: 'Full-B', value: 'Full-B' }, { label: 'Full-C', value: 'Full-C' }, { label: 'Full-D', value: 'Full-D' }],
	      currentSplit: 'PAP1'
	    };
	  },
	  methods: {
	    sendAPI: function sendAPI(cmd, params) {
	      this.$dispatch('sendAPI', cmd, params);
	    },
	    dxGetProfiles: function dxGetProfiles() {
	      this.sendAPI('dxGetProfiles', { profile: this.profileKey });
	    },
	    dxGetMixerStatus: function dxGetMixerStatus() {
	      this.sendAPI('dxGetMixerStatus');
	    },
	    dxSetProfiles: function dxSetProfiles() {
	      var profiles = (0, _defineProperty3.default)({}, this.profile.pid, this.profile.content);
	      this.sendAPI('dxSetProfiles', { profiles: profiles });
	    },
	    dxSetOutputSound: function dxSetOutputSound() {
	      this.sendAPI('dxSetOutputSound', { sound: this.sound });
	    },
	    dxSetOutputVideo: function dxSetOutputVideo() {
	      this.sendAPI('dxSetOutputVideo', { video: this.video });
	    },
	    dxSetOutputColor: function dxSetOutputColor() {
	      this.sendAPI('dxSetOutputColor', { color: this.color });
	    },
	    dxSetOutputResolution: function dxSetOutputResolution() {
	      this.sendAPI('dxSetOutputResolution', {
	        resolution: (0, _defineProperty3.default)({}, this.outputRes.port, this.outputRes.option)
	      });
	    },
	    dxSetSplitLayer: function dxSetSplitLayer() {
	      this.sendAPI('dxSetSplitLayer', {
	        layer: this.splitLayer
	      });
	    },
	    dxSetSplitArea: function dxSetSplitArea() {
	      this.sendAPI('dxSetSplitArea', {
	        setting: (0, _defineProperty3.default)({}, this.splitAreaPort, this.splitArea[this.splitAreaPort])
	      });
	    },
	    dxSetMapping: function dxSetMapping() {
	      this.sendAPI('dxSetMapping', {
	        mapping: (0, _defineProperty3.default)({}, this.mappingPort, this.mapping[this.mappingPort])
	      });
	    },
	    dxSetLabel: function dxSetLabel() {
	      this.sendAPI('dxSetLabel', {
	        osd: (0, _defineProperty3.default)({}, this.labelPort['osd'], this.label.osd[this.labelPort['osd']]),
	        windows: (0, _defineProperty3.default)({}, this.labelPort['windows'], this.label.windows[this.labelPort['windows']]),
	        inputs: (0, _defineProperty3.default)({}, this.labelPort['inputs'], this.label.inputs[this.labelPort['inputs']]),
	        custom: (0, _defineProperty3.default)({}, this.labelPort['custom'], this.label.custom[this.labelPort['custom']])
	      });
	    },
	    dxSetInputCrop: function dxSetInputCrop() {
	      this.sendAPI('dxSetInputCrop', {
	        crop: (0, _defineProperty3.default)({}, this.cropPort, this.crop[this.cropPort])
	      });
	    },
	    dxSetSplitByOption: function dxSetSplitByOption() {
	      this.sendAPI('dxSetSplitByOption', {
	        options: {
	          '1': this.currentSplit
	        }
	      });
	    },
	    dxSetDeviceByProfileKey: function dxSetDeviceByProfileKey() {
	      this.sendAPI('dxSetDeviceByProfileKey', {
	        profile: this.setProfileKey
	      });
	    }
	  }
	};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      apis: {
	        'dxEnableBank': {
	          params: {
	            banks: [false, false, true, false],
	            enabled: false
	          }
	        },
	        'dxLockBank': {
	          params: {
	            banks: [false, true, false, false],
	            locked: false
	          }
	        },
	        'dxResetBank': {
	          params: {
	            banks: [true, false, false, true]
	          }
	        },
	        'dxSetBankInfo': {
	          no: '1',
	          outlets: [{ name: 'amp', supplying: true }, { name: 'TV', supplying: true }, { name: 'PS4', supplying: true }]
	        }
	      }
	    };
	  },
	
	  methods: {
	    sendAPI: function sendAPI(cmd, params) {
	      this.$dispatch('sendAPI', cmd, params);
	    },
	    dxEnableBank: function dxEnableBank() {
	      this.sendAPI('dxEnableBank', {
	        banks: this.apis.dxEnableBank.params.banks.map(function (enable, index) {
	          return enable ? index.toString() : null;
	        }).filter(function (v) {
	          return v !== null;
	        }),
	        enabled: this.apis.dxEnableBank.params.enabled
	      });
	    },
	    dxLockBank: function dxLockBank() {
	      this.sendAPI('dxLockBank', {
	        banks: this.apis.dxLockBank.params.banks.map(function (enable, index) {
	          return enable ? index.toString() : null;
	        }).filter(function (v) {
	          return v !== null;
	        }),
	        locked: this.apis.dxLockBank.params.locked
	      });
	    },
	    dxResetBank: function dxResetBank() {
	      this.sendAPI('dxResetBank', {
	        banks: this.apis.dxResetBank.params.banks.map(function (enable, index) {
	          return enable ? index.toString() : null;
	        }).filter(function (v) {
	          return v !== null;
	        })
	      });
	    },
	    dxSetBankInfo: function dxSetBankInfo() {
	      var newParams = {
	        banks: (0, _defineProperty3.default)({}, this.apis.dxSetBankInfo.no, {
	          outlets: this.apis.dxSetBankInfo.outlets
	        })
	      };
	      this.sendAPI('dxSetBankInfo', newParams);
	    }
	  }
	};

/***/ }),
/* 670 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      baudrate: '9600',
	      command: ''
	    };
	  },
	  methods: {
	    sendAPI: function sendAPI(cmd, params) {
	      this.$dispatch('sendAPI', cmd, params);
	    },
	    dxSetBaudrate: function dxSetBaudrate() {
	      this.sendAPI('dxSetBaudrate', {
	        baudrate: this.baudrate
	      });
	    },
	    dxSendSerialCommand: function dxSendSerialCommand(convert) {
	      this.sendAPI('dxSendSerialCommand', {
	        command: convert ? window.btoa(this.command) : this.command
	      });
	    }
	  }
	};

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      splitOption: '1',
	      resolution4K: '4096x2160@60Hz',
	      resolutionNormal: '1920x1080@60Hz',
	      chose4k: true,
	      profileIndex: '1',
	      profileName: 'testProfile',
	      profileIndexUWantToSet: '1',
	      profile: {
	        pid: '1',
	        content: {
	          name: 'custom 1',
	          split: {
	            1: [0, 0, 960, 540, 0],
	            2: [960, 0, 1920, 540, 0],
	            3: [0, 540, 960, 1080, 0],
	            4: [960, 540, 1920, 1080, 0]
	          }
	        }
	      },
	      outputRes: {
	        port: '1',
	        option: '3'
	      },
	      splitAreaPort: 1,
	      splitArea: {
	        1: [0, 0, 960, 540, 0],
	        2: [960, 0, 1920, 540, 0],
	        3: [0, 540, 960, 1080, 0],
	        4: [960, 540, 1920, 1080, 0]
	      },
	      inResolution: '',
	      isSourceFromHDMI: true
	    };
	  },
	  methods: {
	    sendAPI: function sendAPI(cmd, params) {
	      this.$dispatch('sendAPI', cmd, params);
	    },
	    dxSetInputSource: function dxSetInputSource() {
	      this.sendAPI('dxSetInputSource', {
	        isSourceFromHDMI: this.isSourceFromHDMI
	      });
	    },
	    dxSetOutputResolution: function dxSetOutputResolution() {
	      this.sendAPI('dxSetOutputResolution', {
	        resolution: (0, _defineProperty3.default)({}, this.outputRes.port, parseInt(this.outputRes.option))
	      });
	    },
	    dxSetSplitArea: function dxSetSplitArea() {
	      this.sendAPI('dxSetSplitArea', {
	        split: (0, _defineProperty3.default)({}, this.splitAreaPort, this.splitArea[this.splitAreaPort])
	      });
	    },
	    dxSetProfileByKey: function dxSetProfileByKey() {
	      this.sendAPI('dxSetProfileByKey', {
	        profiles: this.profileIndex
	      });
	    },
	    dxSetDeviceByProfileKey: function dxSetDeviceByProfileKey() {
	      this.sendAPI('dxSetDeviceByProfileKey', {
	        profile: this.profileIndexUWantToSet
	      });
	    },
	    dxSetInputResolution: function dxSetInputResolution() {
	      var resolution = this.chose4k ? this.resolution4K : this.resolutionNormal;
	      this.sendAPI('dxSetInputResolution', { resolution: resolution });
	    },
	    dxSetSplitByOption: function dxSetSplitByOption() {
	      this.sendAPI('dxSetSplitByOption', {
	        option: this.splitOption
	      });
	    }
	  }
	};

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(219);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _regenerator = __webpack_require__(54);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(53);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _Service = __webpack_require__(8);
	
	var _vue = __webpack_require__(132);
	
	var _general = __webpack_require__(1197);
	
	var _general2 = _interopRequireDefault(_general);
	
	var _matrix = __webpack_require__(1199);
	
	var _matrix2 = _interopRequireDefault(_matrix);
	
	var _power = __webpack_require__(1202);
	
	var _power2 = _interopRequireDefault(_power);
	
	var _dio = __webpack_require__(1196);
	
	var _dio2 = _interopRequireDefault(_dio);
	
	var _mixer = __webpack_require__(1201);
	
	var _mixer2 = _interopRequireDefault(_mixer);
	
	var _splitter = __webpack_require__(1204);
	
	var _splitter2 = _interopRequireDefault(_splitter);
	
	var _mes = __webpack_require__(1200);
	
	var _mes2 = _interopRequireDefault(_mes);
	
	var _ir = __webpack_require__(1198);
	
	var _ir2 = _interopRequireDefault(_ir);
	
	var _rs = __webpack_require__(1203);
	
	var _rs2 = _interopRequireDefault(_rs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    generalApi: _general2.default,
	    matrixApi: _matrix2.default,
	    powerApi: _power2.default,
	    dioApi: _dio2.default,
	    mixerApi: _mixer2.default,
	    splitterApi: _splitter2.default,
	    mesApi: _mes2.default,
	    irApi: _ir2.default,
	    rs232Api: _rs2.default
	  },
	  data: function data() {
	    return {
	      devices: [],
	      selected: '',
	      type: 0,
	      req: '',
	      res: '',
	      msg: ''
	    };
	  },
	
	  computed: {
	    apiType: function apiType() {
	      return _Service.deviceTypes[this.type] || 'general';
	    }
	  },
	  ready: function ready() {
	    var _this = this;
	
	    console.log(this.$route.query.type);
	    var type = _Service.deviceTypes.indexOf(this.$route.query.type);
	    if (type > -1) {
	      this.type = type;
	    }
	    setInterval((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var _ref2, data;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _vue.http.get('/ajax/devlist');
	
	            case 2:
	              _ref2 = _context.sent;
	              data = _ref2.data;
	
	              if (_this.devices.length < data.length && _this.selected === '') {
	                _this.selected = data[data.length - 1].mac;
	              }
	              _this.devices = data;
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    })), 500);
	  },
	
	  methods: {
	    changeType: function changeType(tid) {
	      this.$router.replace({
	        name: 'test',
	        query: {
	          type: _Service.deviceTypes[tid]
	        }
	      });
	      this.type = tid;
	    },
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    hiLight: function hiLight(json) {
	      json = (0, _stringify2.default)(json, undefined, 4);
	      json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	
	      return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
	        var cls = 'number';
	        if (/^"/.test(match)) {
	          cls = /:$/.test(match) ? 'key' : 'string';
	        } else if (/true|false/.test(match)) {
	          cls = 'boolean';
	        } else if (/null/.test(match)) {
	          cls = 'null';
	        }
	        return '<span class="' + cls + '">' + match + '</span>';
	      });
	    }
	  },
	  events: {
	    sendAPI: function sendAPI(cmd) {
	      var _this2 = this;
	
	      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      console.log(cmd, params);
	      if (!this.selected) return console.log('no mac');
	      this.req = this.hiLight({
	        method: cmd,
	        params: params
	      });
	      this.res = 'waiting response...';
	      (0, _Service.call)(this.selected, cmd, params).then(function (res) {
	        _this2.res = _this2.hiLight(res);
	      }, function (err) {
	        _this2.alert('danger', '', err);
	      });
	    }
	  }
	};

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(54);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(53);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _promise = __webpack_require__(156);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(16);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(119);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _VWScreen = __webpack_require__(259);
	
	var _VWScreen2 = _interopRequireDefault(_VWScreen);
	
	var _vuex = __webpack_require__(109);
	
	var _Loader = __webpack_require__(256);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _vueStrap = __webpack_require__(12);
	
	var _Service = __webpack_require__(8);
	
	var _SingleSelect = __webpack_require__(26);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function numberify(split) {
	  for (var windowIndex in split) {
	    for (var cordsIndex in split[windowIndex]) {
	      split[windowIndex][cordsIndex] = parseInt(split[windowIndex][cordsIndex]);
	    }
	  }
	  return split;
	}
	
	exports.default = {
	  components: {
	    dropdown: _vueStrap.dropdown,
	    modal: _vueStrap.modal,
	    'v-screen': _VWScreen2.default,
	    'v-loader': _Loader2.default,
	    'v-select': _SingleSelect2.default
	  },
	  data: function data() {
	    return {
	      showChgConfirm: false,
	      leavePage: function leavePage() {},
	      applyCurrentChange: function applyCurrentChange() {},
	      stop: function stop() {},
	      saveToPreset: '1'
	    };
	  },
	  asyncData: function asyncData() {
	    var mac = this.$route.params.mac;
	
	    this.$store.dispatch('fetchData', mac);
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    isFetching: 'getIsFetching',
	    is4K: 'getIsInput4k',
	    outputPorts: 'getOutputPorts',
	    windowFocus: 'getWindowFocus',
	    splits: 'getSplitArea',
	    profiles: 'getProfiles',
	    isLayoutChanged: 'getLayoutChanged',
	    isMobile: 'getIsMobile',
	    inRatio: 'getInRatio'
	  }), {
	    profileOptions: function profileOptions() {
	      var opts = [];
	      for (var profile in this.profiles) {
	        opts.push({
	          label: this.profiles[profile].name,
	          value: profile
	        });
	      }
	      return opts;
	    },
	    showMask: function showMask() {
	      return this.isMobile && window.innerWidth < window.innerHeight;
	    }
	  }),
	  methods: {
	    toFocus: function toFocus(windowFocus) {
	      this.$store.commit('UPDATE', { type: 'winFocus', windowFocus: windowFocus });
	    },
	    addListener: function addListener() {
	      this.$store.dispatch('updateMainScreenSize');
	      this.$broadcast('render', '1');
	    },
	    saveProfile: function saveProfile(key) {
	      var _this = this;
	
	      console.log(key);
	      var mac = this.$route.params.mac;
	
	      (0, _Service.call)(mac, 'dxSetProfileByKey', { profiles: key }).then(function (res) {
	        console.log(res);
	        _this.$store.commit('UPDATE', {
	          type: 'layoutChanged',
	          isLayoutChanged: false
	        });
	      }).catch(function (err) {
	        _this.alert('danger', '', err);
	      });
	    },
	    onInputChange: function onInputChange(index) {
	      var split = _lodash2.default.cloneDeep(this.splits);
	      switch (index) {
	        case 0:
	          if (parseInt(split[this.windowFocus][index]) < 0) return this.alert('danger', '', 'The split entered needs to be larger than 0');
	          break;
	        case 2:
	          if (split[this.windowFocus][0] >= parseInt(split[this.windowFocus][2]) || parseInt(split[this.windowFocus][index]) > this.inRatio[0] * this.inRatio[2]) return this.alert('danger', '', 'The split entered needs to be larger than the start or smaller than screen width');
	          break;
	        case 1:
	          if (parseInt(split[this.windowFocus][index]) < 0) return this.alert('danger', '', 'The split entered needs to be larger than 0');
	          break;
	        case 3:
	          if (split[this.windowFocus][1] >= parseInt(split[this.windowFocus][3]) || parseInt(split[this.windowFocus][index]) > this.inRatio[1] * this.inRatio[2]) return this.alert('danger', '', 'The split entered needs to be larger than the start or smaller than screen height');
	          break;
	      }
	      split[this.windowFocus][index] = Number(split[this.windowFocus][index]);
	
	      if (this.is4K) {
	        this.$store.commit('check4KLimit', {
	          index: this.windowFocus
	        });
	      }
	
	      this.$store.commit('UPDATE', {
	        type: 'layoutChanged',
	        isLayoutChanged: true
	      });
	
	      split = numberify(split);
	      (0, _Service.call)(this.$route.params.mac, 'dxSetSplitArea', {
	        split: (0, _defineProperty3.default)({}, this.windowFocus, split[this.windowFocus])
	      }).then(function (res) {
	        console.log(res);
	      }).catch(function (err) {
	        console.error(err);
	      });
	    }
	  }, ready: function ready() {
	    window.addEventListener('orientationchange', this.addListener, false);
	    window.addEventListener('resize', this.addListener, false);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('orientationchange', this.addListener, false);
	    window.removeEventListener('resize', this.addListener, false);
	  },
	
	  watch: {
	    isFetching: function isFetching(nv) {
	      if (!nv) this.addListener();
	    },
	    is4K: function is4K(nv) {
	      console.log('is4k to ', nv);
	    }
	  },
	  events: {
	    update: function update(mac, _ref) {
	      var _this2 = this;
	
	      var type = _ref.type,
	          event = _ref.event,
	          msg = _ref.msg;
	
	      switch (type) {
	        case 'split':
	          console.log('event', event);
	          this.outLayout = 'init';
	          this.$store.commit('UPDATE', {
	            type: 'split',
	            splitArea: {
	              split: event
	            }
	          });
	
	          setTimeout(function () {
	            _this2.addListener();
	            _this2.buttonDisabled = false;
	          }, 700);
	          break;
	        case 'resolution':
	          this.buttonDisabled = true;
	
	          if (event.input) {
	            this.$store.commit('UPDATE', { type: 'inResolution', resolution: event.input });
	            this.$store.commit('UPDATE', { type: 'inRatio' });
	            this.addListener();
	          }
	
	          if (event.output) {
	            this.$store.commit('UPDATE', {
	              type: 'outResolutions',
	              resolution: event.output
	            });
	          }
	
	          setTimeout(function () {
	            _this2.buttonDisabled = false;
	          }, 700);
	          break;
	        case 'preset':
	          this.$store.commit('UPDATE', {
	            type: 'preset',
	            preset: event
	          });
	          break;
	      }
	    }
	  },
	  route: {
	    deactivate: function deactivate(transition) {
	      console.log(transition);
	      var vue = this;
	      window.removeEventListener('orientationchange', this.addListener, false);
	      window.removeEventListener('resize', this.addListener, false);
	      if (!this.isLayoutChanged) {
	        transition.next();
	      } else {
	        return new _promise2.default(function (resolve, reject) {
	          var _this3 = this;
	
	          vue.showChgConfirm = true;
	          vue.leavePage = function () {
	            vue.$store.commit('UPDATE', {
	              type: 'layoutChanged',
	              isLayoutChanged: false
	            });
	            resolve();
	          };
	          vue.applyCurrentChange = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	            return _regenerator2.default.wrap(function _callee$(_context) {
	              while (1) {
	                switch (_context.prev = _context.next) {
	                  case 0:
	                    vue.saveProfile(vue.saveToPreset);
	                    resolve();
	
	                  case 2:
	                  case 'end':
	                    return _context.stop();
	                }
	              }
	            }, _callee, _this3);
	          }));
	          vue.stop = function () {
	            reject();
	            vue.showChgConfirm = false;
	          };
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(22);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(119);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(54);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(53);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _vueStrap = __webpack_require__(12);
	
	var _SingleSelect = __webpack_require__(26);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _VWScreen = __webpack_require__(259);
	
	var _VWScreen2 = _interopRequireDefault(_VWScreen);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _jquery = __webpack_require__(21);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _vuex = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal,
	    'v-select': _SingleSelect2.default,
	    'v-screen': _VWScreen2.default
	  },
	  data: function data() {
	    return {
	      showTestAPI: false,
	      showEditModal: false,
	      showPreviewModal: false,
	      editingProfile: {
	        _id: '',
	        title: '',
	        name: '',
	        resolution: '',
	        split: {
	          '1': [],
	          '2': [],
	          '3': [],
	          '4': []
	        }
	      },
	      winNameAry: ['', 'A', 'B', 'C', 'D'],
	      outLayout: 'custom',
	      label: {},
	
	      previewProfile: {
	        title: '',
	        _id: ''
	      }
	    };
	  },
	  asyncData: function () {
	    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var mac;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              mac = this.$route.params.mac;
	
	              this.$store.dispatch('fetchData', mac);
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function asyncData() {
	      return _ref.apply(this, arguments);
	    }
	
	    return asyncData;
	  }(),
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    isFetching: 'getIsFetching',
	    profiles: 'getProfiles',
	    isMobile: 'getIsMobile'
	  })),
	  methods: {
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    handleShowGraphPreview: function handleShowGraphPreview(key) {
	      var _this = this;
	
	      console.log('handle show graph preview' + key);
	      this.previewProfile._id = key;
	      this.previewProfile.title = 'Preset ' + key + ' graph preview';
	      this.showPreviewModal = true;
	      setTimeout(function () {
	        _this.$broadcast('render', key);
	      }, 50);
	    },
	    handleShowModal: function handleShowModal(key) {
	      this.editingProfile._id = key;
	      this.editingProfile.title = 'Preset ' + key + ' detail';
	      this.editingProfile.resolution = this.profiles[key].resolution;
	      this.editingProfile.name = this.profiles[key].name;
	      this.editingProfile.split = this.profiles[key].split;
	      this.showEditModal = true;
	    },
	    handleApply: function handleApply() {},
	    onSortEnd: function onSortEnd(event) {
	      var newLayer = [];
	      var newEditing = _lodash2.default.cloneDeep(this.editingProfile);
	      _jquery2.default.each((0, _jquery2.default)('.dragItem'), function (i, val) {
	        newLayer.push(parseInt((0, _jquery2.default)(val).attr('data-index')));
	      });
	      newEditing.layer = _lodash2.default.cloneDeep(newLayer);
	      this.editingProfile = _lodash2.default.cloneDeep(newEditing);
	    }
	  }, ready: function ready() {},
	
	  watch: {
	    showEditModal: function showEditModal(nv) {
	      if (!nv) {
	        (0, _jquery2.default)('.single_profile_edit_modal').scrollTop(0);
	      }
	    },
	    isFetching: function isFetching(nv) {
	      if (!nv) this.$broadcast('render', 'all');
	    }
	  },
	  events: {
	    update: function update(mac, _ref2) {
	      var _this2 = this;
	
	      var type = _ref2.type,
	          event = _ref2.event,
	          msg = _ref2.msg;
	
	      console.log('got event:', type);
	      switch (type) {
	        case 'preset':
	          var key = (0, _keys2.default)(event)[0];
	
	          this.$store.dispatch('updatePreset', event);
	          setTimeout(function () {
	            _this2.$broadcast('render', key);
	          }, 700);
	          break;
	      }
	    }
	  }
	};

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(22);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(119);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(54);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(53);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _VWScreen = __webpack_require__(259);
	
	var _VWScreen2 = _interopRequireDefault(_VWScreen);
	
	var _Loader = __webpack_require__(256);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _vueStrap = __webpack_require__(12);
	
	var _Tabset = __webpack_require__(258);
	
	var _Tabset2 = _interopRequireDefault(_Tabset);
	
	var _Service = __webpack_require__(8);
	
	var _SingleSelect = __webpack_require__(26);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _lodash = __webpack_require__(11);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _vuex = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    modal: _vueStrap.modal,
	    tabs: _Tabset2.default,
	    tab: _vueStrap.tab,
	    'v-screen': _VWScreen2.default,
	    'v-select': _SingleSelect2.default,
	    'v-loader': _Loader2.default
	  },
	  data: function data() {
	    return {
	      showOutSetting: false,
	      ww: 0,
	      quickIcons: [__webpack_require__(1084), __webpack_require__(1085), __webpack_require__(1087), __webpack_require__(1086), __webpack_require__(1080), __webpack_require__(1081), __webpack_require__(1082), __webpack_require__(1083)],
	      editing: {
	        outResolutions: []
	      },
	      buttonDisabled: false,
	      editingSourceFrom: false
	    };
	  },
	  asyncData: function () {
	    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var mac;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              mac = this.$route.params.mac;
	              _context.next = 3;
	              return this.$store.dispatch('fetchData', mac);
	
	            case 3:
	              console.log('done async');
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function asyncData() {
	      return _ref.apply(this, arguments);
	    }
	
	    return asyncData;
	  }(),
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    isFetching: 'getIsFetching',
	    is4K: 'getIsInput4k',
	    inRatio: 'getInRatio',
	    splits: 'getSplitArea',
	    outputPorts: 'getOutputPorts',
	    windowFocus: 'getWindowFocus',
	    focus1: 'isFocus1',
	    focus2: 'isFocus2',
	    focus3: 'isFocus3',
	    focus4: 'isFocus4',
	    outSplitOptions: 'getOutputSplitOptions',
	    customProfileOptions: 'getProfiles',
	    outResolutionOpts: 'getOutResolutionOptions',
	    outResolutions: 'getOutResolutions',
	    canSetRotatedSplit: 'getCanSetRotatedSplit',
	    inResolution: 'getInResolution',
	    model: 'getDeviceModel',
	    isSourceFromHDMI: 'getIsSourceFromHDMI'
	  }), {
	    profileOptions: function profileOptions() {
	      return (0, _keys2.default)(this.customProfileOptions);
	    },
	    isVDev: function isVDev() {
	      return this.$route.params.mac.startsWith('00:00:00:00');
	    },
	    computedOutResolutionOptions: function computedOutResolutionOptions() {
	      var _this = this;
	
	      return (0, _keys2.default)(this.outResolutionOpts).map(function (k) {
	        return {
	          label: _this.outResolutionOpts[k],
	          value: parseInt(k)
	        };
	      });
	    }
	  }),
	  methods: {
	    alert: function alert(type, title, content) {
	      this.$dispatch('alert', {
	        type: type,
	        title: title,
	        content: content
	      });
	    },
	    applySourcInput: function applySourcInput() {
	      var _this2 = this;
	
	      var mac = this.$route.params.mac;
	
	      (0, _Service.call)(mac, 'dxSetInputSource', {
	        isSourceFromHDMI: this.editingSourceFrom
	      }).then(function (res) {
	        _this2.showOutSetting = false;
	        _this2.$store.dispatch('fetchSource', { mac: mac, model: _this2.model });
	      }).catch(function (e) {
	        console.error(e);
	      });
	    },
	    sendKeyToDevice: function sendKeyToDevice(option) {
	      if (!this.canSetRotatedSplit && parseInt(option) < 5) {
	        this.$dispatch('alert', {
	          type: 'warning',
	          title: '',
	          content: 'Outputs and input needs to be all 1920x1080 to rotate the output.'
	        });
	        return;
	      }
	      this.buttonDisabled = true;
	      var mac = this.$route.params.mac;
	
	      (0, _Service.call)(mac, 'dxSetSplitByOption', {
	        option: option
	      }).then(function (res) {
	        console.log('call splitArea done', res);
	      }).catch(function (err) {
	        console.error(err);
	      });
	    },
	    handleshowOutSetting: function handleshowOutSetting() {
	      this.showOutSetting = true;
	      this.editing.outResolutions = _lodash2.default.cloneDeep(this.outResolutions);
	      this.editingSourceFrom = _lodash2.default.cloneDeep(this.isSourceFromHDMI);
	    },
	    applyOutputResolution: function applyOutputResolution(key) {
	      var resolution = {};
	
	      resolution[key] = this.editing.outResolutions[key];
	      (0, _Service.call)(this.$route.params.mac, 'dxSetOutputResolution', { resolution: resolution }).then(function (res) {
	        console.log(res);
	      }).catch(function (err) {
	        console.error(err);
	      });
	    },
	    isStraight: function isStraight(key) {
	      return parseInt(key) < 5;
	    },
	    addListener: function addListener() {
	      this.$store.dispatch('updateMainScreenSize');
	      this.$broadcast('render', '1');
	    },
	    toFocus: function toFocus(windowFocus) {
	      this.$store.commit('UPDATE', { type: 'winFocus', windowFocus: windowFocus });
	    },
	    setLayoutByProfileKey: function setLayoutByProfileKey(profile) {
	      if (this.inResolution['1'] !== this.customProfileOptions[profile].resolution) {
	        this.alert('warning', '', 'Profile resolution does not match the input resolution');
	        return;
	      }
	      var mac = this.$route.params.mac;
	      (0, _Service.call)(mac, 'dxSetDeviceByProfileKey', {
	        profile: profile
	      }).then(function (res) {
	        console.log(res);
	      });
	    },
	    setSplitByOption: function setSplitByOption(option) {}
	  }, ready: function ready() {
	    window.addEventListener('orientationchange', this.addListener, false);
	    window.addEventListener('resize', this.addListener, false);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('orientationchange', this.addListener, false);
	    window.removeEventListener('resize', this.addListener, false);
	  },
	
	  watch: {
	    isFetching: function isFetching(nv) {
	      if (!nv) this.addListener();
	    },
	    is4K: function is4K(nv) {}
	  },
	  route: {
	    canReuse: false, activate: function activate(_ref2) {
	      var next = _ref2.next;
	
	      next();
	    }
	  },
	  events: {
	    update: function update(mac, _ref3) {
	      var _this3 = this;
	
	      var type = _ref3.type,
	          event = _ref3.event,
	          msg = _ref3.msg;
	
	      switch (type) {
	        case 'split':
	          this.outLayout = 'init';
	          this.$store.commit('UPDATE', {
	            type: 'split',
	            splitArea: {
	              split: event
	            }
	          });
	
	          setTimeout(function () {
	            _this3.addListener();
	            _this3.buttonDisabled = false;
	          }, 700);
	          break;
	        case 'resolution':
	          this.buttonDisabled = true;
	
	          if (event.input) {
	            this.$store.commit('UPDATE', { type: 'inResolution', resolution: event.input });
	            this.$store.commit('UPDATE', { type: 'inRatio' });
	            this.addListener();
	          }
	
	          if (event.output) {
	            this.$store.commit('UPDATE', {
	              type: 'outResolutions',
	              resolution: event.output
	            });
	          }
	
	          setTimeout(function () {
	            _this3.buttonDisabled = false;
	          }, 700);
	          break;
	        case 'preset':
	          this.$store.commit('UPDATE', {
	            type: 'preset',
	            preset: event
	          });
	          break;
	      }
	    }
	  }
	};

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	
	'use strict';
	
	var _stringify = __webpack_require__(219);
	
	var _stringify2 = _interopRequireDefault2(_stringify);
	
	var _getIterator2 = __webpack_require__(28);
	
	var _getIterator3 = _interopRequireDefault2(_getIterator2);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	exports.default = {
	  props: {
	    required: false,
	    time: {
	      type: String,
	      required: true
	    },
	    option: {
	      type: Object,
	      default: function _default() {
	        return {
	          type: 'day',
	          SundayFirst: false,
	          week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
	          month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	          format: 'YYYY-MM-DD',
	          color: {
	            checked: '#F50057',
	            header: '#3f51b5',
	            headerText: '#fff'
	          },
	          inputStyle: {
	            'display': 'inline-block',
	            'padding': '6px',
	            'line-height': '22px',
	            'font-size': '16px',
	            'border': '2px solid #fff',
	            'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
	            'border-radius': '2px',
	            'color': '#5F5F5F'
	          },
	          inputClass: 'cov-datepicker',
	          placeholder: 'when?',
	          buttons: {
	            ok: 'OK',
	            cancel: 'Cancel'
	          },
	          overlayOpacity: 0.5,
	          dismissible: true
	        };
	      }
	    },
	    limit: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    function hours() {
	      var list = [];
	      var hour = 24;
	      while (hour > 0) {
	        hour--;
	        list.push({
	          checked: false,
	          value: hour < 10 ? '0' + hour : hour
	        });
	      }
	      return list;
	    }
	
	    function mins() {
	      var list = [];
	      var min = 60;
	      while (min > 0) {
	        min--;
	        list.push({
	          checked: false,
	          value: min < 10 ? '0' + min : min
	        });
	      }
	      return list;
	    }
	    return {
	      hours: hours(),
	      mins: mins(),
	      showInfo: {
	        hour: false,
	        day: false,
	        month: false,
	        year: false,
	        check: false
	      },
	      displayInfo: {
	        month: ''
	      },
	      library: {
	        week: this.option.week,
	        month: this.option.month,
	        year: []
	      },
	      checked: {
	        oldtime: '',
	        currentMoment: null,
	        year: '',
	        month: '',
	        day: '',
	        hour: '00',
	        min: '00'
	      },
	      dayList: [],
	      selectedDays: []
	    };
	  },
	
	  methods: {
	    pad: function pad(n) {
	      n = Math.floor(n);
	      return n < 10 ? '0' + n : n;
	    },
	    nextMonth: function nextMonth(type) {
	      var next = null;
	      type === 'next' ? next = (0, _moment2.default)(this.checked.currentMoment).add(1, 'M') : next = (0, _moment2.default)(this.checked.currentMoment).add(-1, 'M');
	      this.showDay(next);
	    },
	    showDay: function showDay(time) {
	      if (time === undefined || !Date.parse(time)) {
	        this.checked.currentMoment = (0, _moment2.default)();
	      } else {
	        this.checked.currentMoment = (0, _moment2.default)(time, this.option.format);
	      }
	      this.showOne('day');
	      this.checked.year = (0, _moment2.default)(this.checked.currentMoment).format('YYYY');
	      this.checked.month = (0, _moment2.default)(this.checked.currentMoment).format('MM');
	      this.checked.day = (0, _moment2.default)(this.checked.currentMoment).format('DD');
	      this.displayInfo.month = this.library.month[(0, _moment2.default)(this.checked.currentMoment).month()];
	      var days = [];
	      var currentMoment = this.checked.currentMoment;
	      var firstDay = (0, _moment2.default)(currentMoment).date(1).day();
	
	      var previousMonth = (0, _moment2.default)(currentMoment);
	      var nextMonth = (0, _moment2.default)(currentMoment);
	      nextMonth.add(1, 'months');
	      previousMonth.subtract(1, 'months');
	      var monthDays = (0, _moment2.default)(currentMoment).daysInMonth();
	      var oldtime = this.checked.oldtime;
	      for (var i = 1; i <= monthDays; ++i) {
	        days.push({
	          value: i,
	          inMonth: true,
	          unavailable: false,
	          checked: false,
	          moment: (0, _moment2.default)(currentMoment).date(i)
	        });
	        if (i === Math.ceil((0, _moment2.default)(currentMoment).format('D')) && (0, _moment2.default)(oldtime, this.option.format).year() === (0, _moment2.default)(currentMoment).year() && (0, _moment2.default)(oldtime, this.option.format).month() === (0, _moment2.default)(currentMoment).month()) {
	          days[i - 1].checked = true;
	        }
	        this.checkBySelectDays(i, days);
	      }
	      if (firstDay === 0) firstDay = 7;
	      for (var _i = 0; _i < firstDay - (this.option.SundayFirst ? 0 : 1); _i++) {
	        var passiveDay = {
	          value: previousMonth.daysInMonth() - _i,
	          inMonth: false,
	          action: 'previous',
	          unavailable: false,
	          checked: false,
	          moment: (0, _moment2.default)(currentMoment).date(1).subtract(_i + 1, 'days')
	        };
	        days.unshift(passiveDay);
	      }
	      if (this.limit.length > 0) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(this.limit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var li = _step.value;
	
	            switch (li.type) {
	              case 'fromto':
	                days = this.limitFromTo(li, days);
	                break;
	              case 'weekday':
	                days = this.limitWeekDay(li, days);
	                break;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	      var passiveDaysAtFinal = 42 - days.length;
	      for (var _i2 = 1; _i2 <= passiveDaysAtFinal; _i2++) {
	        var _passiveDay = {
	          value: _i2,
	          inMonth: false,
	          action: 'next',
	          unavailable: false,
	          checked: false,
	          moment: (0, _moment2.default)(currentMoment).add(1, 'months').date(_i2)
	        };
	        days.push(_passiveDay);
	      }
	      this.dayList = days;
	    },
	    checkBySelectDays: function checkBySelectDays(d, days) {
	      var _this = this;
	
	      this.selectedDays.forEach(function (day) {
	        if (_this.checked.year === (0, _moment2.default)(day).format('YYYY') && _this.checked.month === (0, _moment2.default)(day).format('MM') && d === Math.ceil((0, _moment2.default)(day).format('D'))) {
	          days[d - 1].checked = true;
	        }
	      });
	    },
	    limitWeekDay: function limitWeekDay(limit, days) {
	      days.map(function (day) {
	        if (limit.available.indexOf(Math.floor(day.moment.format('d'))) === -1) {
	          day.unavailable = true;
	        }
	      });
	      return days;
	    },
	    limitFromTo: function limitFromTo(limit, days) {
	      var _this2 = this;
	
	      if (limit.from || limit.to) {
	        days.map(function (day) {
	          if (_this2.getLimitCondition(limit, day)) {
	            day.unavailable = true;
	          }
	        });
	      }
	      return days;
	    },
	    getLimitCondition: function getLimitCondition(limit, day) {
	      var tmpMoment = (0, _moment2.default)(this.checked.year + '-' + this.pad(this.checked.month) + '-' + this.pad(day.value));
	      if (limit.from && !limit.to) {
	        return !tmpMoment.isAfter(limit.from);
	      } else if (!limit.from && limit.to) {
	        return !tmpMoment.isBefore(limit.to);
	      } else {
	        return !tmpMoment.isBetween(limit.from, limit.to);
	      }
	    },
	    checkDay: function checkDay(obj) {
	      if (obj.unavailable || obj.value === '') {
	        return false;
	      }
	      if (!obj.inMonth) {
	        this.nextMonth(obj.action);
	      }
	      if (this.option.type === 'day' || this.option.type === 'min') {
	        this.dayList.forEach(function (x) {
	          x.checked = false;
	        });
	        this.checked.day = this.pad(obj.value);
	        obj.checked = true;
	      } else {
	        var day = this.pad(obj.value);
	        var ctime = this.checked.year + '-' + this.checked.month + '-' + day;
	        if (obj.checked === true) {
	          obj.checked = false;
	          this.selectedDays.$remove(ctime);
	        } else {
	          this.selectedDays.push(ctime);
	          obj.checked = true;
	        }
	      }
	      switch (this.option.type) {
	        case 'day':
	          this.picked();
	          break;
	        case 'min':
	          this.showOne('hour');
	
	          this.shiftActTime();
	          break;
	      }
	    },
	    showYear: function showYear() {
	      var _this3 = this;
	
	      var year = (0, _moment2.default)(this.checked.currentMoment).year();
	      this.library.year = [];
	      var yearTmp = [];
	      for (var i = year - 100; i < year + 5; ++i) {
	        yearTmp.push(i);
	      }
	      this.library.year = yearTmp;
	      this.showOne('year');
	      this.$nextTick(function () {
	        var listDom = document.getElementById('yearList');
	        listDom.scrollTop = listDom.scrollHeight - 100;
	        _this3.addYear();
	      });
	    },
	    showOne: function showOne(type) {
	      switch (type) {
	        case 'year':
	          this.showInfo.hour = false;
	          this.showInfo.day = false;
	          this.showInfo.year = true;
	          this.showInfo.month = false;
	          break;
	        case 'month':
	          this.showInfo.hour = false;
	          this.showInfo.day = false;
	          this.showInfo.year = false;
	          this.showInfo.month = true;
	          break;
	        case 'day':
	          this.showInfo.hour = false;
	          this.showInfo.day = true;
	          this.showInfo.year = false;
	          this.showInfo.month = false;
	          break;
	        case 'hour':
	          this.showInfo.hour = true;
	          this.showInfo.day = false;
	          this.showInfo.year = false;
	          this.showInfo.month = false;
	          break;
	        default:
	          this.showInfo.day = true;
	          this.showInfo.year = false;
	          this.showInfo.month = false;
	          this.showInfo.hour = false;
	      }
	    },
	    showMonth: function showMonth() {
	      this.showOne('month');
	    },
	    addYear: function addYear() {
	      var _this4 = this;
	
	      var listDom = document.getElementById('yearList');
	      listDom.addEventListener('scroll', function (e) {
	        if (listDom.scrollTop < listDom.scrollHeight - 100) {
	          var len = _this4.library.year.length;
	          var lastYear = _this4.library.year[len - 1];
	          _this4.library.year.push(lastYear + 1);
	        }
	      }, false);
	    },
	    setYear: function setYear(year) {
	      this.checked.currentMoment = (0, _moment2.default)(year + '-' + this.checked.month + '-' + this.checked.day);
	      this.showDay(this.checked.currentMoment);
	    },
	    setMonth: function setMonth(month) {
	      var mo = this.library.month.indexOf(month) + 1;
	      if (mo < 10) {
	        mo = '0' + '' + mo;
	      }
	      this.checked.currentMoment = (0, _moment2.default)(this.checked.year + '-' + mo + '-' + this.checked.day);
	      this.showDay(this.checked.currentMoment);
	    },
	    showCheck: function showCheck() {
	      if (this.time === '') {
	        this.showDay();
	      } else {
	        if (this.option.type === 'day' || this.option.type === 'min') {
	          this.checked.oldtime = this.time;
	          this.showDay(this.time);
	        } else {
	          this.selectedDays = JSON.parse(this.time);
	          if (this.selectedDays.length) {
	            this.checked.oldtime = this.selectedDays[0];
	            this.showDay(this.selectedDays[0]);
	          } else {
	            this.showDay();
	          }
	        }
	      }
	      this.showInfo.check = true;
	    },
	    setTime: function setTime(type, obj, list) {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var item = _step2.value;
	
	          item.checked = false;
	          if (item.value === obj.value) {
	            item.checked = true;
	            this.checked[type] = item.value;
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    },
	    picked: function picked() {
	      if (this.option.type === 'day' || this.option.type === 'min') {
	        var ctime = this.checked.year + '-' + this.checked.month + '-' + this.checked.day + ' ' + this.checked.hour + ':' + this.checked.min;
	        this.checked.currentMoment = (0, _moment2.default)(ctime, 'YYYY-MM-DD HH:mm');
	        this.time = (0, _moment2.default)(this.checked.currentMoment).format(this.option.format);
	      } else {
	        this.time = (0, _stringify2.default)(this.selectedDays);
	      }
	      this.showInfo.check = false;
	      this.$emit('change', this.time);
	    },
	    dismiss: function dismiss(evt) {
	      if (evt.target.className === 'datepicker-overlay') {
	        if (this.option.dismissible === undefined || this.option.dismissible) {
	          this.showInfo.check = false;
	          this.$emit('cancel');
	        }
	      }
	    },
	    shiftActTime: function shiftActTime() {
	      this.$nextTick(function () {
	        if (!document.querySelector('.hour-item.active')) {
	          return false;
	        }
	        document.querySelector('.hour-box').scrollTop = (document.querySelector('.hour-item.active').offsetTop || 0) - 250;
	        document.querySelector('.min-box').scrollTop = (document.querySelector('.min-item.active').offsetTop || 0) - 250;
	      });
	    }
	  }
	};

/***/ }),
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 947 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 948 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 949 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 950 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 951 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 952 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 953 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 954 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 955 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 956 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 957 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 958 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 959 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 960 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 961 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 962 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 963 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 964 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 965 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 966 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 967 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 968 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 969 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 970 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 971 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 972 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 973 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 974 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 975 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 976 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 977 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 978 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 979 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 980 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 981 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 982 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 983 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 984 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 985 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 986 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 987 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 988 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 989 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 990 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 991 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 992 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 993 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 994 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 995 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 996 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 997 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 999 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 391,
		"./af.js": 391,
		"./ar": 398,
		"./ar-dz": 392,
		"./ar-dz.js": 392,
		"./ar-kw": 393,
		"./ar-kw.js": 393,
		"./ar-ly": 394,
		"./ar-ly.js": 394,
		"./ar-ma": 395,
		"./ar-ma.js": 395,
		"./ar-sa": 396,
		"./ar-sa.js": 396,
		"./ar-tn": 397,
		"./ar-tn.js": 397,
		"./ar.js": 398,
		"./az": 399,
		"./az.js": 399,
		"./be": 400,
		"./be.js": 400,
		"./bg": 401,
		"./bg.js": 401,
		"./bm": 402,
		"./bm.js": 402,
		"./bn": 403,
		"./bn.js": 403,
		"./bo": 404,
		"./bo.js": 404,
		"./br": 405,
		"./br.js": 405,
		"./bs": 406,
		"./bs.js": 406,
		"./ca": 407,
		"./ca.js": 407,
		"./cs": 408,
		"./cs.js": 408,
		"./cv": 409,
		"./cv.js": 409,
		"./cy": 410,
		"./cy.js": 410,
		"./da": 411,
		"./da.js": 411,
		"./de": 414,
		"./de-at": 412,
		"./de-at.js": 412,
		"./de-ch": 413,
		"./de-ch.js": 413,
		"./de.js": 414,
		"./dv": 415,
		"./dv.js": 415,
		"./el": 416,
		"./el.js": 416,
		"./en-au": 417,
		"./en-au.js": 417,
		"./en-ca": 418,
		"./en-ca.js": 418,
		"./en-gb": 419,
		"./en-gb.js": 419,
		"./en-ie": 420,
		"./en-ie.js": 420,
		"./en-il": 421,
		"./en-il.js": 421,
		"./en-nz": 422,
		"./en-nz.js": 422,
		"./eo": 423,
		"./eo.js": 423,
		"./es": 426,
		"./es-do": 424,
		"./es-do.js": 424,
		"./es-us": 425,
		"./es-us.js": 425,
		"./es.js": 426,
		"./et": 427,
		"./et.js": 427,
		"./eu": 428,
		"./eu.js": 428,
		"./fa": 429,
		"./fa.js": 429,
		"./fi": 430,
		"./fi.js": 430,
		"./fo": 431,
		"./fo.js": 431,
		"./fr": 434,
		"./fr-ca": 432,
		"./fr-ca.js": 432,
		"./fr-ch": 433,
		"./fr-ch.js": 433,
		"./fr.js": 434,
		"./fy": 435,
		"./fy.js": 435,
		"./gd": 436,
		"./gd.js": 436,
		"./gl": 437,
		"./gl.js": 437,
		"./gom-latn": 438,
		"./gom-latn.js": 438,
		"./gu": 439,
		"./gu.js": 439,
		"./he": 440,
		"./he.js": 440,
		"./hi": 441,
		"./hi.js": 441,
		"./hr": 442,
		"./hr.js": 442,
		"./hu": 443,
		"./hu.js": 443,
		"./hy-am": 444,
		"./hy-am.js": 444,
		"./id": 445,
		"./id.js": 445,
		"./is": 446,
		"./is.js": 446,
		"./it": 447,
		"./it.js": 447,
		"./ja": 448,
		"./ja.js": 448,
		"./jv": 449,
		"./jv.js": 449,
		"./ka": 450,
		"./ka.js": 450,
		"./kk": 451,
		"./kk.js": 451,
		"./km": 452,
		"./km.js": 452,
		"./kn": 453,
		"./kn.js": 453,
		"./ko": 454,
		"./ko.js": 454,
		"./ky": 455,
		"./ky.js": 455,
		"./lb": 456,
		"./lb.js": 456,
		"./lo": 457,
		"./lo.js": 457,
		"./lt": 458,
		"./lt.js": 458,
		"./lv": 459,
		"./lv.js": 459,
		"./me": 460,
		"./me.js": 460,
		"./mi": 461,
		"./mi.js": 461,
		"./mk": 462,
		"./mk.js": 462,
		"./ml": 463,
		"./ml.js": 463,
		"./mr": 464,
		"./mr.js": 464,
		"./ms": 466,
		"./ms-my": 465,
		"./ms-my.js": 465,
		"./ms.js": 466,
		"./mt": 467,
		"./mt.js": 467,
		"./my": 468,
		"./my.js": 468,
		"./nb": 469,
		"./nb.js": 469,
		"./ne": 470,
		"./ne.js": 470,
		"./nl": 472,
		"./nl-be": 471,
		"./nl-be.js": 471,
		"./nl.js": 472,
		"./nn": 473,
		"./nn.js": 473,
		"./pa-in": 474,
		"./pa-in.js": 474,
		"./pl": 475,
		"./pl.js": 475,
		"./pt": 477,
		"./pt-br": 476,
		"./pt-br.js": 476,
		"./pt.js": 477,
		"./ro": 478,
		"./ro.js": 478,
		"./ru": 479,
		"./ru.js": 479,
		"./sd": 480,
		"./sd.js": 480,
		"./se": 481,
		"./se.js": 481,
		"./si": 482,
		"./si.js": 482,
		"./sk": 483,
		"./sk.js": 483,
		"./sl": 484,
		"./sl.js": 484,
		"./sq": 485,
		"./sq.js": 485,
		"./sr": 487,
		"./sr-cyrl": 486,
		"./sr-cyrl.js": 486,
		"./sr.js": 487,
		"./ss": 488,
		"./ss.js": 488,
		"./sv": 489,
		"./sv.js": 489,
		"./sw": 490,
		"./sw.js": 490,
		"./ta": 491,
		"./ta.js": 491,
		"./te": 492,
		"./te.js": 492,
		"./tet": 493,
		"./tet.js": 493,
		"./tg": 494,
		"./tg.js": 494,
		"./th": 495,
		"./th.js": 495,
		"./tl-ph": 496,
		"./tl-ph.js": 496,
		"./tlh": 497,
		"./tlh.js": 497,
		"./tr": 498,
		"./tr.js": 498,
		"./tzl": 499,
		"./tzl.js": 499,
		"./tzm": 501,
		"./tzm-latn": 500,
		"./tzm-latn.js": 500,
		"./tzm.js": 501,
		"./ug-cn": 502,
		"./ug-cn.js": 502,
		"./uk": 503,
		"./uk.js": 503,
		"./ur": 504,
		"./ur.js": 504,
		"./uz": 506,
		"./uz-latn": 505,
		"./uz-latn.js": 505,
		"./uz.js": 506,
		"./vi": 507,
		"./vi.js": 507,
		"./x-pseudo": 508,
		"./x-pseudo.js": 508,
		"./yo": 509,
		"./yo.js": 509,
		"./zh-cn": 510,
		"./zh-cn.js": 510,
		"./zh-hk": 511,
		"./zh-hk.js": 511,
		"./zh-tw": 512,
		"./zh-tw.js": 512
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1049;


/***/ }),
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjU0cHgiIGhlaWdodD0iNDVweCIgdmlld0JveD0iMCAwIDU0IDQ1IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCAzOS4xICgzMTcyMCkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+RElPX0I8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0icGF0aC0xIiB4PSIwIiB5PSIwIiB3aWR0aD0iNTQiIGhlaWdodD0iNDUiIHJ4PSI1Ij48L3JlY3Q+CiAgICAgICAgPG1hc2sgaWQ9Im1hc2stMiIgbWFza0NvbnRlbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIG1hc2tVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giIHg9IjAiIHk9IjAiIHdpZHRoPSI1NCIgaGVpZ2h0PSI0NSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNwYXRoLTEiPjwvdXNlPgogICAgICAgIDwvbWFzaz4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJFYWdsZXllLURldmljZS1PdmVydmlldyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkFydGJvYXJkLTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02MDIuMDAwMDAwLCAtMTAzLjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjAyLjAwMDAwMCwgMTAzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHVzZSBpZD0iUmVjdGFuZ2xlLTEyLUNvcHktNSIgc3Ryb2tlPSIjMDAwMDAwIiBtYXNrPSJ1cmwoI21hc2stMikiIHN0cm9rZS13aWR0aD0iMiIgeGxpbms6aHJlZj0iI3BhdGgtMSI+PC91c2U+CiAgICAgICAgICAgICAgICA8dGV4dCBpZD0iRElPIiBmb250LWZhbWlseT0iU1RIZWl0aVRDLU1lZGl1bSwgSGVpdGkgVEMiIGZvbnQtc2l6ZT0iMjIiIGZvbnQtd2VpZ2h0PSJib2xkIiBmaWxsPSIjMDAwMDAwIj4KICAgICAgICAgICAgICAgICAgICA8dHNwYW4geD0iNy4yNzEiIHk9IjMxIj5ESU88L3RzcGFuPgogICAgICAgICAgICAgICAgPC90ZXh0PgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjU0cHgiIGhlaWdodD0iNDVweCIgdmlld0JveD0iMCAwIDU0IDQ1IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCAzOS4xICgzMTcyMCkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+bTJtX0I8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0icGF0aC0xIiB4PSIwIiB5PSIwIiB3aWR0aD0iNTQiIGhlaWdodD0iNDUiIHJ4PSI1Ij48L3JlY3Q+CiAgICAgICAgPG1hc2sgaWQ9Im1hc2stMiIgbWFza0NvbnRlbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIG1hc2tVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giIHg9IjAiIHk9IjAiIHdpZHRoPSI1NCIgaGVpZ2h0PSI0NSIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNwYXRoLTEiPjwvdXNlPgogICAgICAgIDwvbWFzaz4KICAgICAgICA8cGF0aCBkPSJNOS41MTc2MDExNSwyLjU3NTIxNTg2IEM5LjUxNzYwMTE1LDEuNDY2OTQxNzggMTAuNDE3MzA1OCwwLjU2ODUwODEyNCAxMS41MDg5MjMxLDAuNTY4NTA4MTI0IEwyOS4xMDQyMDIxLDAuNTY4NTA4MTI0IEMzMC4yMDM5Nzg4LDAuNTY4NTA4MTI0IDMxLjA5NTUyNCwxLjQ2MDEyMDk2IDMxLjA5NTUyNCwyLjU3NTIxNTg2IEwzMS4wOTU1MjQsMTMuOTExNTE5NyBDMzEuMDk1NTI0LDE1LjAxOTc5MzggMzAuMTk1ODE5NCwxNS45MTgyMjc1IDI5LjEwNDIwMjEsMTUuOTE4MjI3NSBMMTEuNTA4OTIzMSwxNS45MTgyMjc1IEMxMC40MDkxNDY0LDE1LjkxODIyNzUgOS41MTc2MDExNSwxNS4wMjY2MTQ2IDkuNTE3NjAxMTUsMTMuOTExNTE5NyBMOS41MTc2MDExNSwyLjU3NTIxNTg2IFoiIGlkPSJwYXRoLTMiPjwvcGF0aD4KICAgICAgICA8bWFzayBpZD0ibWFzay00IiBtYXNrQ29udGVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgbWFza1VuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgeD0iMCIgeT0iMCIgd2lkdGg9IjIxLjU3NzkyMjkiIGhlaWdodD0iMTUuMzQ5NzE5MyIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNwYXRoLTMiPjwvdXNlPgogICAgICAgIDwvbWFzaz4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJFYWdsZXllLURldmljZS1PdmVydmlldyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkFydGJvYXJkLTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zNzUuMDAwMDAwLCAtMTAzLjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMjYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM3NS4wMDAwMDAsIDEwMy4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC0yMCI+CiAgICAgICAgICAgICAgICAgICAgPHVzZSBpZD0iUmVjdGFuZ2xlLTEyLUNvcHktNCIgc3Ryb2tlPSIjMDAwMDAwIiBtYXNrPSJ1cmwoI21hc2stMikiIHN0cm9rZS13aWR0aD0iMiIgeGxpbms6aHJlZj0iI3BhdGgtMSI+PC91c2U+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTE5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3LjAwMDAwMCwgOC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTI3Ljk3MjQwMzYsMjMgTDM4Ljc2MTM2NTEsMjMiIGlkPSJMaW5lIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49ImJldmVsIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yLjQxOTYwMDE5LDIzIEwxMy4yMDg1NjE2LDIzIiBpZD0iTGluZS1Db3B5IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49ImJldmVsIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMTQiIGZpbGw9IiMwMDAwMDAiIHg9IjE4LjAzNTIwMjMiIHk9IjE1LjkxODIyNzUiIHdpZHRoPSI0LjU0MjcyMDYxIiBoZWlnaHQ9IjQuNTQ4MDY0OTkiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0xNC1Db3B5IiBmaWxsPSIjMDAwMDAwIiB4PSIxNS43NjM4NDIiIHk9IjIwLjQ2NjI5MjQiIHdpZHRoPSI5LjA4NTQ0MTIyIiBoZWlnaHQ9IjcuOTU5MTEzNzMiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICAgICAgPHVzZSBpZD0iUmVjdGFuZ2xlLTEzIiBzdHJva2U9IiMwMDAwMDAiIG1hc2s9InVybCgjbWFzay00KSIgc3Ryb2tlLXdpZHRoPSI0IiB4bGluazpocmVmPSIjcGF0aC0zIj48L3VzZT4KICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTM1LjA3MDQwNDYsMi44NDI1NDA2MiBDMzUuMDcwNDA0NiwyLjg0MjU0MDYyIDM4LjQ3MzU2MzMsOC4zNjc3Mjg5NCAzNS4yMDczNzM4LDE0LjI4NjU0MjUiIGlkPSJQYXRoLTciIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0iYmV2ZWwiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTMuNDA3MDQwNDYsMi44NDI1NDA2MiBDMy40MDcwNDA0NiwyLjg0MjU0MDYyIDYuODEwMTk5Miw4LjM2NzcyODk0IDMuNTQ0MDA5NywxNC4yODY1NDI1IiBpZD0iUGF0aC03LUNvcHkiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0iYmV2ZWwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQuMTg0MDA1LCA4LjU2NDU0Mikgc2NhbGUoLTEsIDEpIHRyYW5zbGF0ZSgtNC4xODQwMDUsIC04LjU2NDU0MikgIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0zOC4wMTk5NTY3LC0yLjg0MjE3MDk0ZS0xNCBDMzguMDE5OTU2NywtMi44NDIxNzA5NGUtMTQgNDIuNzA2ODU1NSw4Ljc2OTEyNjc3IDM3LjkwOTYwNSwxNi42NzM4MzI1IiBpZD0iUGF0aC04IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49ImJldmVsIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wLjExMDM1MTczNCwtMi44NDIxNzA5NGUtMTQgQzAuMTEwMzUxNzM0LC0yLjg0MjE3MDk0ZS0xNCA0Ljc5NzI1MDQ5LDguNzY5MTI2NzcgLTcuMjA3NTY3ODhlLTEzLDE2LjY3MzgzMjUiIGlkPSJQYXRoLTgtQ29weSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJiZXZlbCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4wODA1NTEsIDguMzM2OTE2KSBzY2FsZSgtMSwgMSkgdHJhbnNsYXRlKC0xLjA4MDU1MSwgLTguMzM2OTE2KSAiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/Matrix_B.fd6c79a.svg";

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAhCAYAAACvBDmYAAAAAXNSR0IArs4c6QAAAlRJREFUWAntWFtPE0EYPTOzBQIlEGi4RBATLqFS9IHoA/HBKAGNiKEYnv0d/hYeSHgEAy8EXkyUN0zQIHiLgNGCV0BIQAzb3XGm7dK00NCdHQLE/ZJNdtq5nDnfme9MlvQM7XGcg6DnAGMCog9Ud6Z8Rs88o90tDB0X9CfK0LnzgMD3qMPAjx2OubV9nVND69ZvNTFUFBOEq6h4yNkFOtDODsANtGtNlj5Gr9dTXCyn+GtycM7R2UBRU6qPVW2pf5hicPK9hdmYDUoI+tvSDB9QrfiiBWhziOBKLYVlc4y/iePJQjwBp0dUgGCBIrKsYVqAOmw+X7GxvgssfOf4uG6jKEBwt1UPq56BVgcJblxKTjOWYlKS4bD64LIBpkGqnoH2RxgYJXi1ZmFlM31jnPlk46eop6ESgpuNnpeBpxoi9XdH6FDGxh/gXlaaV7dtVAUZohEDT5e8GYAnoL1hltChBNrVzBKPfM+OxkqKq+KwzX+zs//Ku60MVNpln9CfjPmvFnZyECY13BSikGZwKkAdu/wldPh42oSVlmcGS6ESYHiwENfqKOrLCGLbOTpmjDrcUFa5Y5eybuYCKZeT5erZsg0iDCAqDp5qKAF17HJ3n2Pqg3Xs2qOpsnVbXFrKio7tfmQHJaBOgZ98Z2HPPHLejB8//+Z4EbNQYBDcD6sdC9dAHbs0Rb4n3iatMgNVjsbo62RfWSkCCgpwvT1ZwMcX44htcWyK2plvSFsdeWkK7yeoFbeqL2K8myD+Bwg3dOXR17VG85jzRLr4QHXT6jP63zL6D2UMmsmwHx2gAAAAAElFTkSuQmCC"

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAhCAYAAACvBDmYAAAAAXNSR0IArs4c6QAAAjlJREFUWAntls9LFGEYx7/vuzO7mr8izVYJgjItyTCQwDpEJ0kvguCpg4G3CK916p/wIkodonNoRIcOeRDBDplQ0iFLDQQFXU121XXfnZ53RpfRnYPu885BmPeyM++87/N+3u/za0XX2I6DMzDkGWB0ESNQ056KFDWtqMU1KHwGwiwfLFA7BrwfKCug5h0HqQywlnYws6wwMa+Q2S98Zj0YjVEpBGorBG7WSwx02Hjdn0Cyyq956awsRf3Hdr/aBQmKygTQVCvxpMNC80WJFw9tDE1k/UtLejamqIbUMbq9B8yu5PHyU5bAHbQQbEW8JLYjm4yBHrFKL6kdIH0gZN05vvtDA71cIygMBDJZB3+3+PXAWIweKqq1a2+UeHrPMz35WyHP54Qx0OHeuBuL58sFyizP1VOLCsPTucM7sH6Nuf4aZXqyShYgNVUrlalHLVRsDQxjij7/mIUkIRPEVV8p8OBqDK2XJJ7dt9FYLTD6haesMdA5Kkn+UBynrtRzI+aC9rVZ+Lyg8Gvdv+J0MhtzfdCxH34qfFtR7qfOK7wQCBVUEy4cqHihPOgqJ58LHfR2g3fE0mbpbtfXCRX08R0L1+skFBVSHcOcYSyZ+tpibjLFKRSrqSPdSkoXUsO9nc3hT4qnqDHQwbt2kWBpap9vvuYw/sNLqKIFp5hggSry5rvvxfVxI+P19/nVPP7RvykTgwWqe/jITDGoCbDjNkJNpuOHcd4jUI56QXsjRYNU4cxFinLUC9r7H4eliprGMWXZAAAAAElFTkSuQmCC"

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAhCAYAAACvBDmYAAAAAXNSR0IArs4c6QAAArlJREFUWAntVk1oE0EU/mZ/omlrtWlD/Cva1BoxXhRBi6UqglpQL94ErwpeAnrVm3gQRC966kW8FX/OHkSKShR/wKqUgra1VWpNm7bUasPuzjiza8r6Q7IzmwqFPNhkYd/M++Z78977yKHuHwxLwLQlgNGFWAVa6UxVGa00o0alNtQI0BIjSNQRNEQJZgsMk98Z3k8wFJzwUUIDjUWBY2kDB9t0xGo42j9s3mLIjlD09NkYyqt3QhKmj+5q1nCu00T9cg9gwWYYnmIYnWZYW0+wqYkgonvfbMrQ89rBrVc2VOAqM9qV0pHpMF3+pvnMuJ618GSYguNZMIOXamsjwckdBnau13Fiu4G6ZcCNrL3gE/RFqepTcYIz7d4Zn404OHWngEdDv4MUAGwKDOQYLty3cJunXtj+Vh2rV/x9RdyPJX6UGM3sMWHylH6eobj00EKhDEGC5O7nNvpz1C2u8W8+2kuA83+SBppOECQbNTg8x5d7y4P0BxNXQ9WkU783qbux3nyhblpVA8uukwYqqlnYh0n59MmC8/tLA43XFoGqp9EPIOi7NNCJOY/JqClfuUFB/ctPGmhxuoj++D9NGuhg3kv5lrj00lDnko4mql2MStGiDm/2OkAoBAEXSwPNzQE3X3od/vRuI/CUifAzZToM7EtKh3SPorTq3lsH78YpREFdPRpBZ0vpbeK1wJUjEXSlDJzlImbdrxYXkEzXTVk9Cd15/oCJtiYP5ItPDnoHKT5OUYzOMNRwvZJOaNjKHzHfV3KFJRTUxQcWnnLZJ2vKQEUgIZaPb9NddRQxSneBAT7nrz22lDVpKKBFVtZwNdS+QcPGBsIfDc2rCOb5Nc5zhd//lbrKqm+MKunQYgxpUVJc6P8fm2W4y+/tYlrpKljMyJJ7V4FKElbWvcpoWYokHaqMShJW1v0nWr7WGXjNOQkAAAAASUVORK5CYII="

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAhCAYAAACvBDmYAAAAAXNSR0IArs4c6QAAAkNJREFUWAntlr9LHEEUx7+ze7tGUdFIyHEg0WBQMIFrBCGRFBFCSJFa8A+wsUgRsA3+DSkS7AQLCy1tTGEwQoI2Saogp0UKiXomUXPunrfje7sp1tPI7uy4KOwrhtm9nZnPfd+8H+LpVEXiGphxDRh9xAxUt6cyRXUrmkuyoQgtvuzUoQza2gDMjt4IoQJuTcI5Bo6qwNaBRGnXw8dND1+2vFPfqTwog553mG0K2CbQQn/iVrPAg7yBF/3A8kYN7z5X8fPgvFXR3iUG/UX1YmTGgUH3wKbdGLSjSaCzTeBZr4liwcSjbhMDnQYm31ex+kNNXS1Rz/eTvI4Kufz3EVAqSyyVPEwsVDE25+Arub4hJ/ByyEKzHU3B+q+0gNZvGn7e3JOYXHSxTXeWlR4btMI/R55fOiiT/HFAbndR8ySG75kotIbzRTTWVEAZ5fuOxPpukMS6b15hUB92OwikrvarDkqqst1pj+/I+Cv8o9QGTmFsKpGfKujdf3dz5zBQNsCONqYMGhy3QXk2rqUGWiwYuJ8XfopaopIa11IB5Qbm1WMLQggsU5NS/hsXE0hc6y86koPnSY+JkaLpVyXuC96sUJ1VsMSg3IQ876OBLEf+sWjaaAncpu6JXZ1vCZzGAfSaSilXKRVLDNpkC4w//H/9PnQlPtCdnF47RrmighisUQZ1KB7mv1GXXGdUzrHvSOwRFKvInZMbP3bqdk1wR7mTf/vpLOiZEzS9SCXqdbBmoDpUDO+RKRpWQ8c8U1SHiuE9TgDlj5yoxEAm9gAAAABJRU5ErkJggg=="

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAhCAYAAACvBDmYAAAAAXNSR0IArs4c6QAAAMJJREFUWAntmM0JwzAUg/NaU+g+2aCHrpFDx8oaPXSIzlMI/cOX4hSCLBIfBMrJ4QlbfLLh2XEap0+n8CkYzR53CjCzRxmjqYboeXw03ce3yzGQDxmiNoqiZOsmyhJDehNFhNi6ibLEkN5EESG2bqIsMaQ3UUSIrVf1ozX9Irswq5eJfpEo6upT2vfX4XDPZFppS+oyRG20jG2LsYluQbGcY/HUR8SrFP6Pn+/ud9dvpZ2t6benGY71PzKHKRSiz3l8AVUxMWfjuC8kAAAAAElFTkSuQmCC"

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAhCAYAAACvBDmYAAAAAXNSR0IArs4c6QAAAMZJREFUWAntl0sKAjEQRKc1CN7HG7jwGi481lzDhYfwPIL4IxvpEWJN6cyioLLq0JWkePnHtr8+O4WiYLR6XCjArB5ljJYW0V1/+bp2S1lujvvVubafS5u9yRC10TxtU8QmOgXF3Edz10fEPQs/49uje58Kc2kHY/pmGuD4v9Kc+tw1OtCz9pf4dFgHauddjwixeRNliSG9iSJCbN5EWWJIb6KIEJs3UZYY0psoIsTmZYiOeo+OeS+yhFi9DFEZo6HwuavL5AU/OzFn1kvIhgAAAABJRU5ErkJggg=="

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAhCAYAAACvBDmYAAAAAXNSR0IArs4c6QAAAKxJREFUWAntl8ENgCAMRcF4cTIXcSwXcTKPGg6Q2Av8tmqafC6E0NLPa0NDXvfzShFGBKFF41xhooKPbcnVF5m1cSYkyJ+2FOpNn0RJ1JuA93lhajShD7A3qZHzHp1pxEHaoJfUdrMSN0zqKVSWiXVNolaC0p9EJRHrOgzR9hXR3NjygKPxmtCvuow2TpjUUyhagz17Eu0RQvdJFCXWsw9DNMyfKaOdopeit/ZvAB0sMvKe6goAAAAASUVORK5CYII="

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAhCAYAAACvBDmYAAAAAXNSR0IArs4c6QAAAI9JREFUWAntljEKgDAUQ624eDIv4rG8iCdzVP4gZK0+xEC69C8N4f1A05btOAeH42C0PE43TMrwvs6tNGm98Tb69ztG6Q2FaIjSBGi9ZDREaQK0XjIaojQBWs8mo1jBpQmq3quGX02+t8U/fVOmbVYfo5oxYg5RgqJqhKjSIOYQJSiqhg1Rm7+++7/WdXw5X4lBKwcSVMJZAAAAAElFTkSuQmCC"

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAmCAYAAAC76qlaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAYBJREFUeNrsWLttwzAQFQUtoAVSKFVquU8KZwQHmYArJCtoBGuCwBrBKuIBVLuSiwwQj6C8C46AwnzUkM4dQAIHSseD/O75kUfSTNOUGWPuMkUNmF8NA5+UATeF5zsIx3zrHr4wTplIRj3HmWdKWwJ+6VbE+OjNy5tFt+XX4fh4tdLC+Gb2XCORtXjgAFmjI6BnWPNDImIZdyBbWOd8SKiUDtw64ND2QBqHlaFZzwPLZMMge4A+sbuLIZc8kky6ma/lfo3EqmBVNFTJZw2/L4Q9459opJV8Gyjm4oyP6EgKD2C188bIP/Lrt/F/Y5wLTMVrd++P80QdQk7SPLBMaDU5/xIzX9MrMVJJ+/G0H9ewH9d0TaH+euKgTSqfjKfJmYAn4IuleEsrE8z+EVPDRjIRwAHkia4gFmLokLHj3aMMxrEqNbCVB3TP7FoYnYpqxFx7Rzp5GgfIe2aXbrMosV7F5GRpuINFGeM3ikig93wSImns4DuB9TZVTs3r+IcAAwCpxqkO2sYjDQAAAABJRU5ErkJggg=="

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAmCAYAAAC76qlaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAipJREFUeNpi/P//PwMnK6sDA/WBBJR+QW2Dv//+fYAR6vD/DEMIAB3OyIImdpCK5itA6QdUNNMexkAJcZBPqGUD0MwGqJkNVDQT7k4mhiEKRh1Ob8BCC0M1VzxKE/YKr4eyfa5HyJkMlRAPRWIbAx3vMugdDnSkMZBy+f/3z48fLx4exeKRQRviYEf+fP307K9nD6/CxIAeEhzsDk8Dl7V3b579/eL5cyDzLBALUjvUWdAKeIraLMAM6SCgbSv47+v7s/8+vucHCvH/3NJ7lktOyxgolsYZW3uLWg5Hb6tQVOWzScloMXJyi/5+8/LWv48f2CFxyviEXVHNGsT88fDuScY/f35QWuWDak6qVfnQNPwOxv+8vApM80a2ISurABaNnYOtyk+jkhq6Z06Yo8KAocr4dtvKRhAGsYFiylA5JWDMhA4ah0MrGCUgfg/Ee9DlgY6/By1dqFamM1E5tPcAHfkeh5rVSGW6ElVLldH2+Gizdri3x6k8TKFAAzNxVvlDbnji4FBLKuAQH82cow4fdTjeargcVCpB8W4capSA+C5UzTsgprzXD8qc1MAcLCwuQPwfiI0JqNsNxKsotY+aScUY2qy9Bwp5aAinIYcwkBaENn/PDooQRwrtUCSxM1CxcrTQPkMNO6mRxkFtcVDaTgfWaKvRQhYUA4IgPhCfgQ5TuA6KCgiUJKCOhHeIob2ce9DOwyqQp4B4JpKae0BPKo/WnEMJAAQYACXozliPovV5AAAAAElFTkSuQmCC"

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAmCAYAAAC76qlaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAg9JREFUeNrsWD1LA0EQvTsuoGBhsLFSiTZWBpLeFLER20R/QfwJKaOd+QmXX6Cmt0mKpLBMYSEiGDGCJiB6CoLRqOebMBeOQ71VL2YPbuGxw+7L3tvJ7OyHalmWMh6JpBTxsgB0gEcP3jTXHQ/eBHPPRAU89Xo1lYVbSoAKhKu6q60u8LsloAXce/DmuL7w4E0Cs8CRwLeXBxZ5fEzXLQLZXgCvBqQEeFsEAV6KxhT89kCnpgS0hML/u+jDGHRx9zI3tbpeYHvtZGMmGRSPZxx2AuLT0guHyASqtPX22u12WoefTERaj/dFPt9cNV6uW8d2GyYUlV14rr+7NU8bvU67DbMBRP32uuZzmGRYZPX9wTS5uTyMcNGGtCjLjrYS12lMLCZdOuQYtoUbSId2V8E1saJsHs/5xBmZ8Cw2HPX2YG+bQDba5rkvxutADuG8wVD80oKsuvsh/pyzi2+LVPPZ21WINL/glB05PSbF4oTYrACn6NfCDI+1ofDfxrjgMwVdbuPgevHmBMeM05g/fCJRAv88UQ9aqPQ9Hi7OUHgo/PuCrGRQZgJyHrw88/IjF84iEgK8GB/GTCk8jpxaBJIukRWgSf8AcAfQsdfga5wpbYxjIiss0OATIXk7SpOU7s7p8njUcbGw7YRjh96BbWIiJWmEs+gK34To8rAPbNI2zf1NCpm/iA53zlGUDwEGAL6qG+YdW+mgAAAAAElFTkSuQmCC"

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAmCAYAAAC76qlaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAhFJREFUeNpi/P//PwMnK6sDwxAC33//PsAIdfj/IeZwRhY0sYOD3M32MAZKiIN8MphdjexOJoYhCkYdTm/AgpaGDlAlNPgFJFlFxNVA7P+/f37+9ejBOZo6HAgaqGGofHRxDxO3IIzL+/7M9s3v9m89SwWj99OsVNFc8cgYSJ0B4vdAPAuIy0H09Qi59MFeqoRCaZCjV8PEgB4SHOyZMw3mcGAog5IHCAsieYgmmZOiNouwV7iDgLat4L+v78/en1YrxxnLICcZnnWWS07LGCiWxhlbe4taDkdvq1BU5bNJyWgxcnKL/n7z8ta/jx+eQ+KUkYVdUc0axPzx8O5Jxj9/flBa5YPSONUyJzQNvyOgrAKYfDoHW+ZMo5IaumdOmKPCgKHKiIyBYspQOSVgzIQOGocDHeMCchS07N6DLg90/D1o6cJArdKFKpkTlin/f//6+tezJ9ewqWEWFJJlERJVojCTYs+cQOA4yNtW+6leqox2JEZae3zIDFMM+eGJg0MtqYBDfDRzjjp81OEEazRBIL6Lr3QCyhlD1dwdTCFeTshjQGoVtPU4OEIc6CgXaFN1FpLYbmjopgExqFdkDCx7lZF6/YMixGeCumTIoQl0pCuUD5LrBPL30LTKJyO0laAdiFVIYqA0bILUsRAcdJkTGJL3QNUvtDkMG6kCOXo3tCcEEisHJZnRmnOol+MAAQYAAhvu2ksJOwgAAAAASUVORK5CYII="

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAA7CAYAAABhT0pgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAapJREFUeNrsmN9tgzAQxnHEAnSAPvDW5yzQSGQEpE7ACmSEdgSYoEpGSKR2gOa5T+GhA4QR6HfVIV0tHP7ZVdra0slgke93PvvMEdU0TaCUeg0cNGjfKwY0jgAq1MZWlrRf2otvMyCiDXWptwgcNw/wAA/4C4BQO0OsH9v6cW31NKXDbvZpevf8sURXvz/cVl2naTjFPYhG6FJYBiPAGlb1rsFAbzMWj0Yv8kBvZTvCdtyPA1zwtub7J8R9M2kGEC9YXIqSpwe+3nM/OUSxCEFJ4vC2ZnhiM5MpTAmHaX4mi1Zy34qn8PyRx+vJmawnGkRjXousY1sSbNOGzlS2DM5kwDJDuEreUdUsgDarNi/azbAG4GAFoMFShpVOAFdROoZdZGcA2yHyVYUHeIAH/Nvy3dm/LStXIfqawY8vMkIWU9jY3uje8FwCO8PyUZUdZkU1jhJvp6X+gYFxGtv2VXqLC6+9gsVrAHe43rPlNCsCYvzG9GUjvTUal4tnUTqe6CdUcIlnqJTPTRp9iRaJPhL38dxFzjk8J/GNsG0LXlhhWvjr2Ka/CvApwACULQs+xeYR4QAAAABJRU5ErkJggg=="

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAA7CAYAAABhT0pgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAbdJREFUeNrsWDtOxDAQTZBXgjJ7AIp01OEArJQrROIE4QjZI8ARdk+AkiOkgAOQmipbcIBNSbFFeIMmyFgxJMZGfDzSkx0rmef5eDy7Yd/3wclicR84kOfD4SJkgt4RQSiUtZUl3XfD5J0FxGhDu6zvKHAsnsATeIK/QCCUGmK9bKvl2mo1pWLnvJoK3Utnt08phhyoHi9PKysxGJGMALIdxi2T7Wxl0aCUJAaugRZkJZAbBXksBlAWsXJVaccb2KpWzbrR8HHH1pCsgRtWTsQFW1UDmY2D1oBwDSwxv6KY8Ho6YuGkIH8klRSfxDSLxtI34x1n7CY5KYwJBkWlorRjSyjQzSwCzp6cd5ooRI10LjrTg5Zwek7eramLJu92LgEF7XzObo1OstVq6qKNF2o/b9MC31V4Ak/gCf5t++7s35aVKxe9WvDtQYbLYnIb44GeNe+lwB4oZl368B1d+KF0OyVq54b1hBuxzihNoWDDyjsQVpjXjIKsIkKsL3Ut45tQDHQ4FiIC9kDO8xbogVh6pwYKnY7PDlokjZH0HH81yAW7p5U6u5JH+hGy0QX+Z6TpryJ4EWAAhe/zUXnt/IsAAAAASUVORK5CYII="

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAA7CAYAAABhT0pgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAgpJREFUeNrsWD9PwkAUb6HEoCFYkpowwFAmXcsuJHVzcUBdHFwg8QvUxR0/AnwCA7ORBBN0h4XFCQaicTDhJkTFWN/pa3I2oG1tFZJ7yUvLtff73ft394pomqYQjUSuhABkPJnkRCQwAyIQJdtY3ifslnXzxQLK6Ac6ixcSAhZOwAkWgECaViCBEfhdyTzIc5hFrKyfDXS4FEHrN/vpuu8EKAWqQNaHaxXJ+n65yAKlooKWQXtAVgMtOiX48UQDMBnB7aAEF1C1W+XqRIPJBK2hcgx6iuCU2ECrmqAFJ1tFbtpLyb0jdTm9IZD2xeuwdd6AoYayc7i9oqS0cHyNztHfRkSOHpw8fOsikOtpBGE5kZISivp8f9sVHkfkM3qiFIrFFSm+mhQjSzHzaUxe7gZdnLJpuchRVwHmGxiHLXSNjhkmM6/RWJTsMZAcJoMFVLOBUmvqCN5xW2gyZg5dqWYj6jB1QbwWmoZucbxaL5XsarVuCWjuZ92s1lMl8970z9sW3z+l7HuRr184jvcinkWcgBMs2FYR2L8t+aBc9GHBvwUZXFeh7gNVZzzXQYeghmsCOhl7olnPNWzEiFcLythNW4BNVAO0TbsOCGKC6bydty0AUMSJl8zwLmgbiTMATn4TAw3d08PfPWwbZeaLx3uQYXUlPN0yOJRFf1fRbZVZgZ+vNF0IgncBBgCzp+9n2uROhAAAAABJRU5ErkJggg=="

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAA7CAYAAABhT0pgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAf9JREFUeNpi/P//PwMnK+sBBhqA779/OzBCLfhPIwsYWdDEHKlk9n4YA8UHIBupYTqyeUwMNAajFoxaMAQsYMGWQWhmAbVz8mgk08cCzRWPjIFYiahIJsFQQSAVCsRpQGwMxK5AfI9iC0CuhRoKMlyQ5GRKpGuRwVkgXg2lSbMAj2vfQ/md1yPkKsjyAdDwmVDDkQ0FuXQPlL0bSpNcVDiAaMWsZmMmbqAjf3y59enJzc0fju04+Pvl888gOSFHb2NBE0+Gb4+uKXHGTnMgZAF6s+UgiGCTltNj5OAEB8v/719f//n65f2/jx+eg1VwcQuyS8ro/Xn3+t7f9+8e4zDXHmuzBdRQggYRLFJdgFgUCc+CBo0eiA2Mg05CZRHeZgs0A6VBMXqyBFlWAbTkPb5mC9HtIqBlMB+FYrEIlKLuUWQBmq9gQQgrIlyBFuyhigVoloVCLZtFEwtGm45Ds9lC9a4UellE1R7OaDIdtWDUguFaVNBstMWRVkEE9sGARTIw6GaCgg+IlXDIuwDxOyAuJ9kCkGYsbSBkeVDrexWhRjA+H3SAWm5IBu6G4nIgPgPq0QAjUQhXzwZv8x1oQBpU4x4k4TAgPgO1WBlo+HtK4sAYGjx3ofy70LYprH2qRFEkA12XDq3dlKFCJtDwngUNtpm4In5wJdMhYQFAgAEACOMJSx2TKu8AAAAASUVORK5CYII="

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALEAAACxCAYAAACLKVzFAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAN7SURBVHic7dxNa1xlGAbg+zXBBqlfoHZh6MJVrUtXuhFBBBU/cKsLwYUr/Q3qPyguqns3LtxIkaLioqKI7kRQUIqoYFGwKrUf1vRxMSOE0CZp5s05mcl1QRjm4zznyeTOO2fOec9JAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIA9q/UuWFUHkzyX5IEkh5PckeTO6e1ykj+S1LpFzk5v/0xyJclfSdaSnEtyuXd/dHVLkqV195eT3Lzu/tkkF5P8nOT7JKdaa1/2bqJriKvqSJKPktzdsy4L5f0kT7fW/u1V8IZeharqQJJ3I8Bs7vEkL/Qs2C3ESe5PcrRjPRbXMz2L9QwxbNd9PYsJMWNYrapu38eEmDEsJznQq5gQMxYhZu7906vQ0CF+u+0TSb4b6D291LHW51f5PX6YPvfUhsefn3Fdcxvirwde337wRJJXkvw4diPXYa21ttar2NAhvjjw+vaD8621N5IcSfJa5uM97vnpYZt4UbTWLrTWXs1kH+yJkdvZSrdNiWT4EC9t/RJm0Vo73Vp7MsmjST4Zu59r6DoSL/cstg1CPJDW2odV9WuSD5LcNXY/G3QdiYcO8cNVtV82YW4fa8XTo2EvJjmW5Kax+thE1ym2Q4f4sekPu6Sq7k1yPMlDY/eyia652y+j4sKrqsNV9VaSr7K3A5x0PFqXDD8S099qVR1L8lI6h2MX3dizmBDPv3fS7wydlaq6Z8Nj/2fk0IbnZvmy2PWfrdt0uKp6MMmnveqx0NZaa90GUNvEjGGpqrrtbhVixtJtu1iIGYv5xMy9vXfKPlyHSnKhVzEhZgxn5nk+MSTJNz2L9Qzxt5lcPw228l7PYt1C3Fr7PcmzSc70qslC+izJmz0L7sZVMVeSPJLJJJSjSVYzOUR5/hqLrGVyJcxMX9N1wjS7auNVMZPk1kwGx8uZfDL/neSnJKeTnErycWvtypBNwp7XfSS+mqq6LcnKDhc/11qzrT2g6aT6QzOU+K3n3oc9oapO1M69Pnb/+01VHZzh71VVNejVUe1iY+4JMXNPiJl7QszcE2Lm3lDn2B1PcnKHy37RsxG25VKSl2dY/pdejQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMPEfnXMSKvoEwG8AAAAASUVORK5CYII="

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAQAAABecRxxAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAHdElNRQfjBgsMMh2DKXDhAAAj5klEQVR42u3deZxcVZn/8W93QhJI0iQsYYcsnQQCgQZERJZAFFkG2TSAA4ILiuJL0VFAnFGQHzM/RAQUQXYk4CABhLhgAkiQAGENzRbAJGzZAyGQ7iTdSadr/mhj73XPc5c6d/m86w9edE499zlV5z5V99a950gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADInKqY4vTXGI3RCG2ugRqoob67BeTQSq1Woz7S23pDc9UcR8ioBaBWE3WY9tcuqvb96gAFskHv6Bk9ohmaFyVM+AKwn76o47WT79cBKLh3db8m6/lwTw5TALbSmfqixvnuN4B/maPJulnvW59mLQDb6Jv6nmp89xZAN6t1sy7TIstTLAVgK12sr6i/714C6FWTbtaFWuHavI9juyqdrqmaoL6++wegjL76uL6mJj2rkktzt28Ae+gm7e+7ZwCczdKZmhPczOUbwOm6TyN89weAwU76qhr1dFCzoG8Ag3SdTvXdFwCh3K6z1ViuQfkCsL2mabzvPgAI7UUdpSW9/3O5AjBS01XrO38AkbytI/SP3v6x9wt499Usdn8g84Zrpvbp7R97+wYwTo9pS9+ZA4jFCh2s13r6h54LwI56XLv4zhlAbBbpQL3T/c89HQJsqYfY/YFc2UF/0Rbd/9y9AFTpVu3qO1sAMdtdd3T/xt/9QqALdLbvTAEkYLRW68nOf+paET6hx7SJ7zwBJKJFh+qJjn/oXAA20xyO/oEce1N7aG37/3Y+BLhYx/jOD0CChqpVM9r/t+M3gN1Ur34Rw6/QXDVqpe9eAjk0VIM0OvL1Oc3as+crAx9WKfRjqX6tE7S171cIyL1hOlHXaGmEvXVaT2EnhA73d32WiUKAiuqrYzUz9D57UPeAD4YK9LIO9f1KAIU1Ua+E2m//2jXQx0MEadFP+MkQ8GoTXaSWEHvvxzqHudsc4H0++4FUmKgV5v33ro4BtlSz8envajffvQbwT+P0rnEPbuq4gN+3jE9errG+ewygg1Hm3wXOan/yU6YnrtW+vnsLoIv9tNa0Hz++8YkjwlcOAKlxtmk/bt24sudXTU/7a7QcASRmumlf/lLbk35n+vrPPIFAWo1Rk2Fvntz2pEWGp1zju4cAyrjOsDcvkqRawxNaNNx3/wCUMdx0WdDIao0zBH9Qb/vuH4Ay3tbDhta7VWuMofkdvnsHIIBlLx1bbZgAtKQHffcNQIAH5bQwuCRpbLXhrP4ret933wAEWK5XnduOrjbML/KS754BcPCyc8stqjXIufEbvvsFwMHrzi1rqlXj3Pg93/0C4MB9Tx1s+QbQ6LtfABw0OLccXG2YB3id734BcNDs3LJ/tXNTALlDAQAKjAIAFBgFACgwCgBQYBQAoMAoAECBUQCAAqMAAAVGAQAKjAIAFBgFACgwCgBQYBQAoMAoAECBUQCAAqMAAAVGAQAKjAIAFBgFACgwCgBQYBQAoMAoAECBUQCAAqMAAAVGAQAKjAIAFBgFACgwCgBQYBQAoMAoAECB9fWdQCr10XDtpt20q3bWEA3WIA1Wje+kYLJKDWpUgz7Uu3pdr+k1vaVW30mlDwWgo77aX4fr09pXA3yngohqupXsJj2vh/SQnlGL7+TSgwLQZqAm6QQdyud8jg3QgTpQF2mVZug+3aPVvhNKA84BSPvqei3RrTqW3b8QanScfqvFmqxPq8p3Mr4VuwD01Vf0qp7T1zXYdyqosBp9UQ/pFX252N+Ci1sAqjVJc3SzxvlOBB6N0y2aq68XtwgUtQB8Qa9rikb7TgMpMFzX61Wd7DsNP4pYAEZomv6XnR8djNHvNaOIY6JoBaCvztFLOsJ3GkihQ/Wizlcf32lUVrEKQK2e0lUa5DsNpNSmulSzNMp3GpVUpALwb3pG+/pOAim3n2brBN9JVE5RCkCVztcfNdR3GsiAGt2rS4uyZxSjm4P1QHHeUkRWpfP1p2IcKhZhpxii6TrSdxLImKM1Q1v6TiJ5+S8AwzRDB/hOAhn0MT2srX0nkbS8F4Bt9TfV+U4CGVWnx7Sj7ySSle8CsKX+rj18J4EM21UP5/tAIM8FYICmaozvJJBxY3V/nmeHyG8BqNJNOtB3EsiBg3RbfveT3HZMl+lU3ykgJ07SJb5TSEpeC8DJ+oHvFJAjF+hzvlNIRj7vg95Z18USZ7Ve1xzNVYMatMp3p2BSo8EarDHaTbtpsxji3aCntdB3p+KXxwLQR7drSKQIrZqlaZqu55lHNgeq9TEdoSN1QKQJwLbQZH06j+Oh5Pw4yXeqjv7T0Kfuj6W6tFj3gxVGrS7Sgkhj4zzfXXA0ydCn3BWA8VoX+g1eou+ov+8OIEEDdI6WhR4fzRmZQK7QBeCR0G/uhRroO3lUwCD9VM0hR8mDvpN3UuAC8PmQb+wL2tt36qigPfRMyJFynO/UHRS2AAzQW6He1MtzeTIU5fTVVaHGytwMHCQWtgCEOf23Rqf5ThuenKG1IUbM+b7TDlTQAjBYK81vZqMO8502PDpYq8xjZkXqpwoxFIA8XQn4NfOv/6t1jGb4ThsezdTRajA+Zwt92XfaccrLN4BN9I6xkjdrgu+kkQKHmX84fjPl54wK+Q3gZO1sfMa39XffSSMFZugs4zNGaJLvpOOTl28As41V/Oe+E0aKXGkcPc/5TrisAp4E3Mv4Bs5WP98pI0X6qd44gtI801QBDwG+YGrdrDO0znfKSJF1+nc1mZ5xiu+U45GPAlBlXNv1Er3sO2WkzBxdamr/hUj3FqZIHg4BDjR9eVsQy/3hyJtNjb8j7e874V4V7hDA9vn/Q63xnTBSaK1+Ymqfi4OAfBSAww1t/6E7faeLlLpd8wytLaMutfJQAIZprKH1lXmc1QWxaNUvDa3HaZjvhKPLQwGYYDgd84Em+04XKXarVjq3rdJBvtONLt2XNLqxXNB7Z4zH/wM1SjtKWqj5Wh1b1G00UttopZZoXmzfVapVq+00VMv0ppYVsP/uVusufcO59QT9oeIZxi77vwK8ZOjDITFt83j9qcOtpGv1Jx0bOeYgna/nO+S6WNfFsLLRWF2nJR2iPq/zYpj5KDv9tzrMMJrqK56dm0JdCdhPLc49WBzLIc8YPdFj9JmqjRD1lE676cbHOv0ywgQUA3S11vf4OkR5L7PT/zCqtch5PK1P6fWkhSoAuxl6cFMM25uoD3qNvyLk7AJV+p8yWT8RcpHqYXqy15itode6yU7/w/qtYUSlc+3JQhWA4ww9OCPy1vZSQ9ktNGjPEFEvCMj7iRCfggPK7P5tj3Nz3f/wvmoYUcdUMC93hSoAPzD0YGTEbW3qMOfgfPNashO0ITDqVeZcrw6MuUEH57j/4Y0xjKjvVTAvd4UqANc75/9+5G0FfVK1PWyfrFV6yiHmeu1mijqmx2P/ro9njNezZ6f/0Xzg1M+SSvpNBbNyV6gCMN05/6cibqmPljttZ6n6GKJ+yjH7a025XucY1XLMnqX+R+M+ZfhfK5iVu0LdC7C5c8u5Ebd0kOPJqG10gCHq8Y7tjjN8Wlc7/yhnmeU+O/2Pyv2CYPfRl1LZLwDuM7S+FXFL7td9WY6tXaNub1ixsFbbOba0XBeRnf5H9aZzy8EVyykh2S8A7m/BhxG3tEMCLaUdvba0ZJqd/kf1oXPLtE8QHij7BcD9LWiMuCX3UmP5Yugetca5pftrkkymvvsflftIoQB4V7kC4H4V/ZJEoi51brncc6a++x+V+0jhEMC7yp0aejuBlu5nJkqm7Zdi3nq2+h+V66tXydGXkOwXAPdqHfUWmD87t7T8OOTa9jnD5/pSveDY8oFc9j+qyn2r9C77BcD9RtSox2tvO84G/4zpc/VebXBqN8WU611OrVpMt7Nmqf/RUAAyxH1ltyGRt/VfMbbaaJ5+69BqsfGas6u10KHVzYYfvLLV/2iGOLfMfAHI/pWAzzrnH8dcQFMCt2KfcXA7LQ6I2arPmaOepNaAqIu0TY77H8UdzmPq6Yrm5apQlwI/5Jz/rBi2NjBgCbLnQk05vr/WlI16cahcLykbc432y3n/w5vlPKamVzgzN4UqAO43A70Xy/YG60+9bmFa6MOMvfVuLzFbdH7oXM/pdbKURfp4Afof1nvOY4qbgbw719CDbWPZYh99u4fbYpbpW6abYLraVjf2sLvO0oGRcj1YT3eLuV7Xh/jyn83+h7GdYUR9v+LZuShUATjB0IOjYtvqYJ2muzVHDWrQHE3RqbFcEjJS5+kRvaNmLdVsXaVDY/iduUqH6ZearaVq1jt6ROdFnhUhW/23O9owoiw3U1VOoQrAeEMPLvCdLDLgR4YRtbvvZHtUqNuBLZNH1/lOFhmwl3PLVuPPqCmU/QKw1nD3dp3vZJEBezu3nKu1vpONKvsFQIbZ2Wuzf/cWEjbIMO9Ave9ko8tDAXjR0Nswc9aiSPYy7BPuIy+18lAAXG98kTgIQJA6Q1vLyEupPBSAekPbOt/JIuXqDG3rfScbXR4KwBLDpBJ1vpNFytU5t1xewSlKEpOHAmCpxONzsR4yktJXezi3ne072TgUrQAM0FjfySLFdjWsa1TvO9k4+Ps8HKDR2kYDJa3WUs1TU4RY9Ya2dXrVW5+RdnWGtvWRthTn+I+g8gWgv47WETpUozt9+2jVXM3QdD2gdSFi1hva1ul3Fe8zsqLO0LY+1BaSGP+RVPJegJ10pVaU3cYKXRFi/vfqgDVrOz4eqvQLjAx52HkcNYY4fE5q/HeVypuBNtcv1ey0nWZdYZ4D3n0Kh+hLhCK/3GcCeNIYOdnx31kKC8ARgdM+dX4s0uGm+L8xxK7cCjPIlp0Mo8i2WGnS47+zlN0NWKWL9YDzanVtttc0XWi4G7zeENv9Zg8Ui2Vk1Du3rMT4jyDpbwB9dIup9nV83OQ8x8z+hqg/rsTLigz6iWEUuU6pVpnx31mKDgGqdFPo7pdU0mTHKrhpr7PfdX/ck8zoQebd6zyGWhwnP63U+O8sRQXg4kjdL6mknzhuaY5zxPlJjR9k3JvOY8j1WpLKjf+OUlMAJho+l3t7bNBnnLb1O+eIrabVa1EUNYErKbQ/7nCKWMnx31FKTgLW6I5I88S2qdYtThNOut+bXWWY9AnFsbfh67bLaKvs+A8pySsBLzae+ezNDrrIYfrlekPEOj2WYL+76qMDdbC201At03xNi+kQZHMdpd21o6SFekXT9FEsUUfpSI3SNlqpJXpMTzqu25eP/tcZ2tY7tKns+A8tqUOAHR0ve3B5NGmHwO1tbYh3c3IvZxeb6vxuc+g/qyMiRh2hO7q8us26XcMjRj1Kz3XJdJnO06aF6b/lbP2wwGiVHv8dpeIcwFWxdb+kkn7hsMWFztEqdSPnXnqrlwymRFis/OxehlaTzgodc5Du6SXT+RpfgP5L0gvO42eBQ7TKj/92KSgA/fR+rC/ACvUP3OafnaM1q1+koeJmYtk7FGaHXEbr8rI9+1momEPLDv4GHZbz/ktSP8Mn9p8colV+/LdLQQGwrNfj9jg2cJuXGKIlfxpwZOB15Q+GOAPzrcCefcMcs48eCBx+o3Pc/zZ1htHz/wKj+Rj/7VJQANyX7HR9XBO4zc8bop0Rcpi4e9whi28bYw5XU2DMZvPSX99zyHSW+YKU7PS/zZcMoyd4sXIf479dCgrA67G/AHMCt1lriHZlqEHi7jinLJYbf+BxW7d+silmjeMdcJ/Naf83shyzB68c4GP8t/NeADbVhthfgJbAyZqq9JFztBmhBok71/MRpxlibu54lNpkupn0DMdMp+a0/xs96jx2Pgr8NuRn/LfzfiFQbQJzDfYJrLslveQcrS7RO60G6lOOLS1Hdkc6nrrsb/qZzfWT/XDHq9+z1v82VYYlY15UKaCFn/EfSjIFIPhX0jC2DmxR7xxriHZJJMc2o52rtWWlIve2SUTdVLW57H+b4Rrq3LY+sIWv8R9CMgUgmRX4gr/Y1Rui1SWSY5vtnVtaLvBwv67MffuWqO65Zqn/beoMbesDW/ga/yHkY1rwjeoNbesSzCPoK2I796XNLVHdWyaTa5b636bO0LbeHD3FkikAjYlEXRXY4hWtd45Wl0iObRY7t1xkiLrEc1T3XmWp/23qnFu2OJyP9zX+Q0imACxPJOp7gS2a9bpztLpEcmzjPsv7K4aoLzu3TCLqWsNNPFnqf5s655ZzHPrma/yHkEwBmBvLXWSdbXAagPXO8XbRVon0XZJW62HHlvcbov7Vcc74Zk0zRHX9ee9Brcll/yVpS+3s3LbeoY2/8W+WTAFo0rzYY77h9KlSb4hoP1fs7kanVsv1R0PMVZri1O4uNRii3u/4yXJTTvsvxX8GwN/4N0vqJOCjsUd0u3Sn3hCxLqG+S9If9bhDq4uNR4s/VnNgmybjpKcNusSh1WP6c077LyVxCvBRcw5BErt0LYkrAaXjY78Syu2ClaGGaZ1uS+ollSSNCLzEdnqI+WK+HNirr5tj9gm8bm+F4RqA7PVfmmwYh1s4RfQ1/tt4vxQ4idshXW/gfcc5pvt1g+EcVvZ22OdCzkz4s7J9+v+hYg7R7DIxV2lCzvv/svOYedsxor/xL6WiAEhXxvoCXO683fudY643XF0dznjN72XbdxourO3qrF7uiVurM0PHHKgpvWQ6V3vkvP/9tc55zNznHNXX+JdSUgB2dLh10/VhmRLpIkPcfUMNGIsBOldLu2z1qUjLPknSLprc5dVt0m2GM9k9+4ye7pLpUn0/YpHMQv8/ZhgxFzlH9TX+JVMBqJL7VVMnO56F3egKfS/kW9LVz3Wec9sT9AfntmdWZHbAPjpAh2g7DdVSzdc0vRVL1BodqT20o6QFekXTzGe+ezZCR/1zUtDFekyzTFfqZbX/Zzr+ZiFJJxh+uPQz/iVpkmVPTeobgFSjRbHUvwWma6uHGyL/KqY3CFl2tWHEWG4h8zP+pRTcDtxmlU6L4YKIVn3F9GPRO1rp3JZlQmEZBR/qXUNcP+PfKNmbgWY4zJ4W5EI9ZGpfMiwRslfOboaCXZVh1uMXDAfMkp/xb5bcIYAkVenGSF9/bgixzSsN8e2/byNfRhtGyxXm6D7Gf2oOASSppG9EONF2o74Z4ln1hrZ1CfcfaVdnaFtvju5j/Jsk/xV4g76mC0OcTd6gH+vroY6h6g1t6xLvP9KtztC2PkT8yo9/o2QPATb6tGHdnrYznxNDb2sTwy+wtivckT9/cR4rUZaTqeT4T8mFQF0N1uWOO+ZaXRZxUqXZzn1aGGk7yD73n+qej7SdSo7/VBYASdpBvwi4Rvo9XR5iRreu4l3mEflV2SVlKzX+U1sAJKmfjtU1mqOWTrFbNEfX6LMxrdn3HUOvol6Wiiz7jGGkWNcx6lklxr+hANhXZ4tqnf6oP0rqr1HaVoMkNWqp5jvc6e2u3tB276R/Z0WKWS4Fq49li5UY/waVLwAbNWuOabkji3qVnBf+SH6ZUKSX+7sf9+3jSY5/g3xeCbfKcMNJne9k4VGdc8s39ZHvZJOQzwJg+bo2NsKd6ci2zTTGuW2972STQQHoY7gWHPmyp2FSsnrfySaDAsBBQHHVGdrW+042GRQATgMWl+Wdr/edbDLyWgAW6H3ntswKUFTu7/yKvF4zmtcCYKnYliNB5Ifl7M9s38kmhQIgbabRvpOFB2MMv//U+042KfktAO7zAnEasJjqDG0toylT8lsAXjC0tZ8GrNHpukevqVGNek336IuqiSHnWv1Qj2qBmrVUL+hXmuh8PWPvqvQpXa16LVWzFmiGzo9lFqTs9L93lnfdMpoyptI3A1VKH6127pltNdm++m4Py14t13cinUvYXrd0uUGkpJKe1iGRXoUJerZbzBbdpO0ixMxS/8uZ7jw+1ni8ZD6MVN8NWDnPOPdsmSFqTZmV9KZraMhcP6ElvcRsNSxG0dU52tBL1MXaP2TMLPW/vKUqOT6eTiiDpFAAJEk3GPrm+ok4SC+UjTNbA0NkeoDWlo3qsn5vd/8T8KkWpgRkqf/lbW8YHdcnsP0kUQAkSWcb+naUY8x7AyPZVk+SpO17/fRr/xS0v/anBGa6WNuao2an/0GONoyOxKfmjBkFQJL0SUPfLnCK6DZoPmPM02X+omUabIo5KHCnKqlkWBIra/0P9iPD6Dgg5m0njQIgSRrY6xFw98ddThGfc4r1jCnL2h5OffX0ONcU9XynmC0aZYqanf4Hm+K01ZJK2hBxhr7KS9G6AD6t1jzntnUObUY5ria8n0YaspzkeO78ZFPfT3Fq1UefM8TMUv+D1Tm3nJvk0ly+5bkAWK7fqnWo8q7nCaQjDTm6tt3HMH3pts6/cbv3KUv9DzbI8N2nPsbtpg4FoE219gxsM8I5mntL97ZVpu27XkCTRKb++x/MsipkfYzbTR0KwEbBd4ZZPoHduUfdxrnl1p4z9d3/YJWfDDSlKAAbBX9pXuUc60PDdt2jus9J5ztT3/0PxkwA/5TvArDEcI1fXWCLxc6x3FtKixJomUym2el/sDrnlsu1NMbtpk6+C4Cleo/XJgEtHnOO9XdDhjMd2y3WfOeYc513Fkum2el/kL7aw7ltbmcCaJP3AuB+F9cAjQ1o8aSWO0VapqcMGd7v2G6qSs4x3Rc9nWrINDv9D7KbBji3zfF9gFL+C0CcswJs0C+c4lxmWgx6hmY5tFqvK0z9vkLrHVo9Y/qszlL/y7OcAYh3OZAUyu+VgJK0q6F/vw6MtqnmB0aZa/h0aXOwwxWL9uH/S4frAA80xsxS/8u5xjAqgr4XphGXAv9LtRqc+1fvEG+cPioboyHUKgPnBWT2hPqbY26iRwOifj9EptnpfzkvOY+Jxkx+R6YAdPCkc/9aNMQh3mFa0WuE9zUhZJaXqLXXqDO1VaiYW+uJXmO26uKQmWan/73ZwnCPyJOxbrlSKAAdXGvo4WlOEWs1s8dn/914a01nJ2lxDzHX6YoIS0b311Va10PURaZ7ALLb/56dbhgR18a87cqgAHTwRUMP73WOeqymas2/nrdGU3VM5EwH6lw91+GTcKGujWH+vtG6Vos6fPI/qx/EsBpidvrf3dTYPxLSxlAAquT+48rJISZ78G+k4ffjNdrecL3ZZhqlnSQt0HytiS3fYRqpbfWBlmie4b0pr0q12k5baKnm673YMs1O/zsaqkXa1Ln1SMM60+kxybKn5v0bgLTQ0Mfv+E4WCfsPw2jI6mpAzAfQieVEzjcTnYgavlXpLENr16sUM6wIBeBRQ9tddazvdJGgEzXG0NpymVRm5f8QYAfDzz4lvVSIolhM1XrRMBI2RFo9wScOATpZZJrXfbzjdFrInlMdpn1p96SW+E44eUUoADL8vCdJv3C6IAhZs7kuNbW/x3fClVCMAvAH0w9K2+q/fSeMBPxc2xtal3Sf74QrI//nACTpEUM/S2rlVGDuHF3mYuOeHg/6TjgCzgF0c42pdZVu1c6+U0aMdtRtxh94bSMms4pSAKZqgan9FpoSwwWzSIeBus94Q9E7zlOqZFxRCkCLeYHH/TUlY4tCo2d99Dt9zPic32iD77QrpRjnAKStDTMDbHzcFmnFe6RBX91hft9XaUvfaUfCOYAevKerzM85XXcGThWKNNtEd+pU87Ou0ArfiVdOUb4BSJuXmcqi98fDGf80KLKtjL/+tD3eV43vxCPiG0CPPtJlIZ71KT1jmEUe6bGPntVhIZ53mWGxkhwozjcAaTO9E+IToaRm/YgTgpnSV/+l5lDv9Ts5+PWHGYF6dUyoQVFSSc/qIN/Jw9Ehej70+/xvvpOPAQWgjLtCD42S7jXNKA8f9tZ9Ed7hO32nHwsKQBnb6oMIA6Skh3VczJNUIx79dbz+Fum9XRHrCsT+UADKskwT2vNjpW7VyZm9Wzx/ttcp+q1WRn5f/913R2JiKABFPLV1uw7RmZEiDNGX9CVJb+l1zdNCfahGp6W4EJ9NNEhDtYNGa6xGxBLxBv2v705VXhELgPRt7aN9YogzIqahB/9e0nd9p+BDka4DaNekkw3TfyP/GnSS1vpOwodiFgBpnk5Us+8kkBLrNUlv+E7Cj6IWAOkRfcm0jDXyqqQzNd13Er4UtwBIv2cZEEj6vib7TsGfIhcA6Rpd4jsFeHaxrvSdgk/FLgDSj3WOkliBDllQ0nm60HcSfhXzZ8COfqUm/abwhbCIWvUN3eg7Cd8Y+NINOiXG1W2RDWt0Crs/BaDN3TrAsIg4su9dTdDdvpNIAwpAm5e0j6b6TgIV8lfV6TnfSaQDBWCjVTpRF6jJdxpIWJN+qGO00ncaaUEBaNeqSzVej/lOAwl6SvvoZ1wA1o4C0Nk8TdQP1Og7DSSgUd/XQXrNdxrpQgHoaoN+oRH6GXcK5Mp63aDRuqI4y324ogD05H39UHvqXi4RyoVW3a3ddZaW+k4kjSgAvfmHPq8x+hWHA5nWqBs0Xidpru9E0ooCUM48naOddC7HjZn0ms7VTjpLc3wnkmZcChzkQ12uy7W7JmmSxvlOBk7e1J91tx73nUYWUADcvKpXdZFG6yAdrIM02nc66NE/9IRmaqbm+U4kOygAFnM1V7dKGqbdNUq1GqWdVaPNNFiDeSUrrEUNatBqNehdzdc8zdMcLfedVPYwbMNYruWa4TsJIDpOAgIFRgEACowCABQYBQAoMAoAUGAUAKDAKABAgVEAgAKjAAAFRgEACowCABQYBQAoMAoAUGAUAKDAKABAgVEAgAKjAAAFRgEACowCABQYBQAoMAoAUGAUAKDAKABAgVEAgAKjAAAFRgEACowCABQYBQAoMAoAUGAUAKDAKABAgVVrnXPbfr6TBeCgv3PL5mo1Ojce5LtfABwMdm7ZUK1Vzo2H+e4XAAfue2qD5RvAGN/9AuBgrHPLVdVa4dx4T9/9AuBgvHPLD6o117nxHhwEAKk3TLs7t/1Htd5wblylz/juG4AAR6jKua2pAEin+u4bgACnGdq+LtWq5Pxo0XDfvQNQxki1GPbokZK00PCEa333D0AZNxj25kVtT7nD8JQmjfbdQwC9GKtmw958W9u9ADMMG+ivq333EUAvfm26YP+Rtv8MN9SMkkr6pu9eAujBt037cat23PjEWaYnrtV+vnsKoItPqMm0H89sf+rZxu8A7xkuNgSQvFotNe7FX29/8hbG2lHSuxrnu8cA/ml3LTDuwWs1tGOAKcanl7RCE333GoCkw/WBef/9fecQ+5kDlNSin2oT330HCq2fLtEG877bqn26BpoWogSUNEef9v0KAIV1hF4Ptd/+pXuog0MFKqmkx3Uc3wSAitpEx+vJ0PvsJ3sK+WDocCUt13X6vLbx/aoAubetJul6vRdhb32gPVjHGwfH6kXDdII9W6l5+kgfquT7VQJypkpDNESjOp+9D6FJ4zWvPWhH/60f+e4lgET9VBe1/0/nArCZXtEI3/kBSMx8jdfa9v/tvDDIGn1B631nCCAh63V6x91f6tOlwSKt44c9IKfO05TOf+g+e1iV7texvvMEELu/6LNdT8/3NH3gFprJlf5Azryig/Vh1z/2PH/oDnpCu/jOF0BsFuqTWtD9zz2vDrxIh2u574wBxGSFDu9p9+99efC5OooSAOTCMh2u13v+p3JLCIzQg6r1nTuASN7SEb2v/1Vd9omH6EXf2QOIYLYOKLf8X3XZJy/RAbrBdw8AhHS7DtGycg1cVhE7XddqoO+eADBZq3N0Y1Ajt2UEx+nGnu8gBpBKj+trvZ3466g6uImkOTpIZ/CrAJAJH+i7muCy+3e/F6B3L+oWDdSe6uu7dwB6tVa/0Yl61HVGDveVxNsM09n6rjb33UsA3TTqFv1Miy1PsRYASdpSX9Hp2sN3bwH8y8u6XbdohfVpYQpAm711uo5j+hDAszc1VZNVH+7J4QtAmxGaqInaX8MNZxMARLVBb+tp/U2P6O0oYaIWgI36qVa7aoRqNEiDIk9bCKC7lWpUgxr0pt7QPK3znQ4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8+T931+wRFqKWqQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOS0wNi0xMVQxMDo1MDoyOSswMjowMPHsi98AAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTktMDYtMTFUMTA6NTA6MjkrMDI6MDCAsTNjAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg=="

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/siig_logo_white.ad07e87.png";

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/output6.7cd5712.jpg";

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/output7.b2f0ae2.jpg";

/***/ }),
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */
/***/ (function(module, exports) {

	module.exports = " <div class=swiper :class=\"[direction, {'dragging-swiper': dragging}]\" @touchstart=_onTouchStart @mousedown=_onTouchStart> <div class=swiper-wrap v-el:swiper-wrap :style=\"{'transform' : 'translate3d(' + translateX + 'px,' + translateY + 'px, 0)'}\" @transitionend=_onTransitionEnd> <slot></slot> </div> <div class=swiper-pagination v-show=paginationVisible> <span class=swiper-pagination-bullet :class=\"{'active': $index+1===currentPage}\" v-for=\"slide in slideEls\" @click=\"paginationClickable && setPage($index+1)\"></span> </div> <button class=\"btn arrow arrow-left\" @click=prev v-bind:diabled=arrowClicked v-on:dblclick=handledblClick> <i class=\"fa fa-fw fa-angle-left\"></i> </button> <button class=\"btn arrow arrow-right\" @click=next v-bind:diabled=arrowClicked v-on:dblclick=handledblClick> <i class=\"fa fa-fw fa-angle-right\"></i> </button> </div> ";

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

	module.exports = " <div tabindex=0 :class=\"{ 'multiselect--active': isOpen, 'multiselect--disabled': disabled }\" @focus=activate() @blur=\"searchable ? false : deactivate()\" @keydown.self.down.prevent=pointerForward() @keydown.self.up.prevent=pointerBackward() @keydown.enter.stop.prevent.self=addPointerElement() @keydown.tab.stop=addPointerElement() @keyup.esc=deactivate() class=multiselect> <div @mousedown.prevent=toggle() class=multiselect__select></div> <div v-el:tags class=multiselect__tags> <span v-for=\"option in visibleValue\" track-by=$index onmousedown=event.preventDefault() class=multiselect__tag> <span v-text=getOptionLabel(option)></span> <i aria-hidden=true tabindex=1 @keydown.enter.prevent=removeElement(option) @mousedown.prevent=removeElement(option) class=multiselect__tag-icon> </i> </span> <template v-if=\"value && value.length > limit\"> <strong v-text=\"limitText(value.length - limit)\"></strong> </template> <div v-show=loading transition=multiselect__loading class=multiselect__spinner></div> <input name=search type=text autocomplete=off :placeholder=placeholder v-el:search v-if=searchable v-model=search :disabled=disabled @focus.prevent=activate() @blur.prevent=deactivate() @keyup.esc=deactivate() @keyup.down=pointerForward() @keyup.up=pointerBackward() @keydown.enter.stop.prevent.self=addPointerElement() @keydown.tab.stop=addPointerElement() @keydown.delete=removeLastElement() class=multiselect__input /> <span v-if=\"!searchable && !multiple\" class=multiselect__single v-text=\"currentOptionLabel || placeholder\"> </span> </div> <ul transition=multiselect :style=\"{ maxHeight: maxHeight + 'px' }\" v-el:list v-show=isOpen @mousedown.stop.prevent=\"\" class=multiselect__content> <slot name=beforeList></slot> <li v-if=\"multiple && max !== 0 && max === value.length\"> <span class=multiselect__option> <slot name=maxElements>Maximum of {{ max }} options selected. First remove a selected option to select another.</slot> </span> </li> <template v-if=\"!max || value.length < max\"> <li v-for=\"option in filteredOptions\" track-by=$index tabindex=0 :class=\"{ 'multiselect__option--highlight': $index === pointer && this.showPointer, 'multiselect__option--selected': !isNotSelected(option) }\" class=multiselect__option @mousedown.prevent=select(option) @mouseenter=pointerSet($index) :data-select=\"option.isTag ? tagPlaceholder : selectLabel\" :data-selected=selectedLabel :data-deselect=deselectLabel> <partial :name=optionPartial v-if=optionPartial.length></partial> <span v-else v-text=getOptionLabel(option)></span> </li> </template> <li v-show=\"filteredOptions.length === 0 && search\"> <span class=multiselect__option> <slot name=noResult>No elements found. Consider changing the search query.</slot> </span> </li> <slot name=afterList></slot> </ul> </div> ";

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

	module.exports = "<div v-show=showWarning class=\"loaderBackDrop warning\"><div class=loader><div class=text>Screen resolution</div><div class=text>must be larger than 1024x768</div></div></div><div v-if=showLoading class=loaderBackDrop><div class=loader><span class=\"loadStyle load2\"></span><h2 class=loadText>Searching...</h2><span class=loadTextDetail>{{loaderMsg}}</span><br/><span class=loadTextDetail>{{loaderMsg1}}</span></div></div><div class=alert_group><alert v-for=\"(key, a) in alertList\" v-bind:type=a.type v-bind:show.sync=a.show width=280px placement=top-right dismissable=dismissable class=alert__single><span class=\"icon-ok-circled alert-icon-float-left\"></span><strong>{{ a.title }}</strong><p>{{ a.content }}</p></alert></div><app-header v-if=\"$route.path!='/login'\" v-bind:show-left-bar.sync=showLeft></app-header><aside id=side_menu v-bind:show.sync=showLeft placement=left header=Title v-bind:width=200><ul v-if=\"$route.name == 'matrix' &amp;&amp; !showLoading &amp;&amp; !isSwitcher\" class=side_menu_group><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'mapping' \" v-bind:class=\"{'active': stateMatch('mapping')}\">mapping</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'preset' \" v-bind:class=\"{'active': stateMatch('preset')}\">preset</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'setting' \" v-bind:class=\"{'active': stateMatch('setting')}\">setting</a></li></ul><ul v-if=\"$route.name == 'matrix' &amp;&amp; !showLoading &amp;&amp; isSwitcher\" class=side_menu_group><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'mapping' \" v-bind:class=\"{'active': stateMatch('mapping')}\">mapping</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'setting' \" v-bind:class=\"{'active': stateMatch('setting')}\">setting</a></li></ul><ul v-if=\"$route.name == 'power' &amp;&amp; !showLoading\" class=side_menu_group><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'status' \" v-bind:class=\"{'active': stateMatch('status')}\">status</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'analysis' \" v-bind:class=\"{'active': stateMatch('analysis')}\">analysis</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'schedule' \" v-bind:class=\"{'active': stateMatch('schedule')}\">schedule</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'event' \" v-bind:class=\"{'active': stateMatch('event')}\">event</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'setting' \" v-bind:class=\"{'active': stateMatch('setting')}\">setting</a></li></ul><ul v-if=\"$route.name == 'mixer'  &amp;&amp; !showLoading\" class=side_meun_group><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'status' \" v-bind:class=\"{'active': stateMatch('status')}\">status</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'layout' \" v-bind:class=\"{'active': stateMatch('layout')}\">layout</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'preset' \" v-bind:class=\"{'active': stateMatch('preset')}\">preset</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'setting' \" v-bind:class=\"{'active': stateMatch('setting')}\">setting</a></li></ul><ul v-if=\"$route.name == 'dio' &amp;&amp; !showLoading\" class=side_meun_group><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'status' \" v-bind:class=\"{'active': stateMatch('status')}\">status</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'schedule' \" v-bind:class=\"{'active': stateMatch('schedule')}\">schedule</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'event' \" v-bind:class=\"{'active': stateMatch('event')}\">event</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'setting' \" v-bind:class=\"{'active': stateMatch('setting')}\">setting</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'log' \" v-bind:class=\"{'active': stateMatch('log')}\">log</a></li></ul><ul v-if=\"$route.name == 'splitter' &amp;&amp; !showLoading\" class=side_meun_group><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'status' \" v-bind:class=\"{'active': stateMatch('status')}\">status</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'layout' \" v-bind:class=\"{'active': stateMatch('layout')}\">layout</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'preset' \" v-bind:class=\"{'active': stateMatch('preset')}\">preset</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'setting' \" v-bind:class=\"{'active': stateMatch('setting')}\">setting</a></li></ul><ul v-if=\"$route.name == 'mes' &amp;&amp; !showLoading\" class=side_meun_group><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'port-status' \" v-bind:class=\"{'active': stateMatch('port-status')}\">port-status</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'setting' \" v-bind:class=\"{'active': stateMatch('setting')}\">setting</a></li></ul><ul v-if=\"$route.name == 'matrix' &amp;&amp; isInstaller &amp;&amp; !showLoading &amp;&amp; !isSwitcher\" class=\"side_menu_group support_group\"><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'HDCP' \" v-bind:class=\"{'active': stateMatch('HDCP')}\">I/O Status</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'EDID' \" v-bind:class=\"{'active': stateMatch('EDID')}\">EDID</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'system' \" v-bind:class=\"{'active': stateMatch('system')}\">system</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'log' \" v-bind:class=\"{'active': stateMatch('log')}\">log</a></li></ul><ul v-if=\"$route.name == 'matrix' &amp;&amp; isInstaller &amp;&amp; !showLoading &amp;&amp; isSwitcher\" class=\"side_menu_group support_group\"><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'system' \" v-bind:class=\"{'active': stateMatch('system')}\">system</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'log' \" v-bind:class=\"{'active': stateMatch('log')}\">log</a></li></ul><ul v-if=\"$route.name == 'mixer' &amp;&amp; isInstaller &amp;&amp; !showLoading\" class=\"side_menu_group support_group\"><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'HDCP' \" v-bind:class=\"{'active': stateMatch('HDCP')}\">I/O Status</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'EDID' \" v-bind:class=\"{'active': stateMatch('EDID')}\">EDID</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'system' \" v-bind:class=\"{'active': stateMatch('system')}\">system</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'log' \" v-bind:class=\"{'active': stateMatch('log')}\">log</a></li></ul><ul v-if=\"($route.name == 'power' || $route.name == 'splitter') &amp;&amp; isInstaller &amp;&amp; !showLoading\" class=\"side_menu_group support_group\"><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'system' \" v-bind:class=\"{'active': stateMatch('system')}\">system</a></li><li class=\"side__menu__single clearfix\"><a @click=\"showLeft = false\" v-link=\" 'log' \" v-bind:class=\"{'active': stateMatch('log')}\">log</a></li></ul><ul v-if=\"$route.name === 'nodev' &amp;&amp; !showLoading\" class=side_menu_group><li class=\"side__menu__single clearfix\"><a>Please add new Device</a></li></ul><div v-if=showLoading class=outerLoadingBar><div class=loadingBar></div><span class=loadingText>Searching...</span></div></aside><div id=router-view-container><router-view></router-view></div>";

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

	module.exports = "<div class=login-container><div class=container><div class=row><div class=\"login col-lg-5 col-md-6 col-sm-8 col-xs-10 col-centered clearfix\"><section class=input_group><div class=\"input_single clearfix\"><label>Account</label><input type=email name=acc placeholder=\"Enter your account\" v-model=account class=\"input form-control\"/></div><div class=\"input_single clearfix\"><label>Password</label><input type=password name=pwd placeholder=\"Enter your password\" v-model=password v-on:keyup.enter=login class=\"input form-control\"/></div></section><section class=\"func_group clearfix row_space--xxs\"><a @click=login class=\"btn login-btn btn-primary col-md-12 clearfix\">Login</a></section><footer class=\"footer col-md-12\"><a @click=\"showNewAccount = true\" class=\"btn btn-no-bg col-md-6 col-sm-6 col-xs-12 clearfix\">Create new account</a><a @click=\"showForgetPw = true\" class=\"btn btn-no-bg col-md-6 col-sm-6 col-xs-12 clearfix\">Forgot password</a></footer></div><modal title=\"Please check your email box\" v-bind:show.sync=showMailHint effect=fade cancel-text=Cancel ok-text=\"I see\"><div slot=modal-body class=\"modal-body clearfix\"><div class=col-md-12><h2>One more step to go....</h2><p>We will send a confirm email to your email box shortly, please check it to activate your account.</p></div></div><div slot=modal-footer class=\"modal-footer clearfix\"><button v-on:click=closeDialogs class=\"btn btn-primary\">I see</button></div></modal><modal title=\"Oops, seems like your Email has not been verified.\" v-bind:show.sync=showMailResend effect=fade cancel-text=Cancel ok-text=\"I see\"><div slot=modal-body class=\"modal-body clearfix\"><div class=col-md-12><h2>Please check your email box .</h2><p>Or We can send the confirm email again.</p></div></div><div slot=modal-footer class=\"modal-footer clearfix\"><button v-on:click=resendMail class=\"btn btn-primary\">Send Again</button><button v-on:click=closeDialogs class=\"btn btn-primary\">I see</button></div></modal><modal title=\"Creat new account\" v-bind:show.sync=showNewAccount effect=fade cancel-text=Cancel ok-text=Apply v-bind:callback=handleNewAccount class=new_account_modal><div slot=modal-body class=\"modal-body clearfix\"><validator name=newAccValidator><div class=col-md-8><label>Enter an available email as account</label><input type=email v-model=newUser.email placeholder=example@gmail.... v-validate:newemail=\"['email']\" class=form-control /><span v-show=\"$newAccValidator.newemail.invalid &amp;&amp; $newAccValidator.newemail.modified\" class=error>Please enter a valid email address</span></div><div class=col-md-8><label>Please enter your password</label><input type=password v-model=newUser.pwd placeholder=1234XXX maxlength=15 class=form-control /></div><div class=col-md-8><label>Please enter your password again</label><input type=password v-model=newUser.confirmPwd placeholder=\"please enter your password again\" maxlength=15 class=form-control /></div></validator></div></modal><modal title=\"Forgot your password\" v-bind:show.sync=showForgetPw effect=fade cancel-text=Cancel ok-text=Apply v-bind:callback=handleForget class=forget_pwd_modal><div slot=modal-body class=\"modal-body clearfix\"><validator name=forgetPw><div class=col-md-8><label>Enter your accout/email</label><input type=email v-model=forgottenMail placeholder=\"please enter your account/email.\" v-validate:email=\"['email']\" class=form-control /><span v-show=\"$forgetPw.email.invalid &amp;&amp; $forgetPw.email.modified\" class=error>Please enter a valid email address</span></div></validator></div></modal></div></div></div>";

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

	module.exports = "<div v-el:content=v-el:content class=card><div @click=cardClick v-bind:class=\"{ clicked: isDesktopFocused, highlight: highlightInputId }\" v-if=\"cardType === 'output'\" class=\"card__inner clearfix\"><div v-show=\"outputData.name !=='all'\" class=\"card__header clearfix\"><div class=\"output_name card__header__inner col-xs-12 col-md-12 col-sm-12 no_pad\"><span class=title><span class=id>{{outputData._id}}</span><span class=name>{{ outputData.name || 'no name'}}</span><span class=right><i v-show=isFavorite class=\"fa fa-heart favorite\"></i><span v-show=\"outputData.HDCP.enabled &amp;&amp; isInstaller\" class=encrypted><i class=\"fa fa-lock\"></i><label>{{ outputData.HDCP.engine}}</label></span><indicator v-bind:enable=outputData.link na=true class=card_indicator></indicator></span></span></div></div><div v-if=\"outputData.name === 'all'\" class=\"card__block input__card__block card_all clearfix\"><div class=all><span>All</span></div></div><div v-else=v-else class=\"card__block output__card__block clearfix\"><img v-bind:src=inputImgs[inputData.photo] v-show=inputData.photo class=img-height-responsive /><div v-if=inputData.img class=input_id>{{inputData._id}}</div><div v-else=v-else class=input_id><i class=\"fa fa-times\"></i></div></div><div class=\"card__footer clearfix\"><div class=\"input_btns card_footer_inner col-lg-12 col-md-12 col-xs-12 no_pad\"><a @click.stop=\"$emit('detail', outputData, inputData, isOut, $event)\" v-show=isDesktopFocused class=\"btn setting_btn\"><i class=\"fa fa-gear\"></i></a><a @click.stop=\"$emit('detail', outputData, inputData, isOut, $event)\" class=\"btn setting_btn visible-xs\"><i class=\"fa fa-gear\"></i></a><span class=input_name>{{ inputData.name || 'no name' }}</span></div></div></div><div @click=cardClick v-bind:class=\"{ clicked: isDesktopFocused, highlight: highlightInputId }\" v-if=\"cardType === 'input'\" class=\"card__inner clearfix\"><div class=\"card__header input_header\"><span class=title><span class=pull-right><indicator v-bind:enable=inputData.link na=true v-if=\"inputData.name !== 'mute'\" class=card_indicator></indicator></span></span></div><div v-if=\"inputData.name === 'mute' \" class=\"card__block input__card__block card_mute clearfix\"><i class=\"fa fa-times\"></i><span>Mute</span></div><div v-else=v-else class=\"card__block input__card__block clearfix\"><img v-bind:src=vgaImgs[0] v-show=\"inputData.type === 'VGA' \" class=img-height-responsive /><img v-bind:src=inputImgs[inputData.photo] draggable=false v-show=\"inputData.type === 'HDMI'\" class=img-height-responsive /><div v-if=inputData.img class=input_id>{{inputData._id}}</div><div v-else=v-else class=input_id><i class=\"fa fa-times\"></i></div></div><div class=\"card__footer clearfix\"><div class=\"input_btns card_footer_inner col-lg-12 col-md-12 col-xs-12 no_pad\"><a @click.stop=\"$emit('detail', outputData, inputData, isOut, $event)\" v-show=\"isDesktopFocused || isMobileFocused\" class=\"btn setting_btn\"><i class=\"fa fa-gear\"></i></a><span class=input_name>{{ inputData.name || 'no name' }}</span></div></div></div></div>";

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

	module.exports = "<div v-el:content=v-el:content class=layout_card><div v-if=\"isSwitcher &amp;&amp; switcherLayout === 1 &amp;&amp; cardType=== 'function'\" class=\"card__inner clearfix\"><div class=\"card__header clearfix\"><div class=\"function_name card__header__inner col-md-12 no_pad clearfix\"><span class=title>&nbsp;</span></div></div><div class=\"card__block function_card clearfix\"><img v-bind:src=layoutImgSrc /></div><div class=\"card__footer clearfix\"><span>&nbsp;</span></div></div><div v-if=\"isSwitcher &amp;&amp; switcherLayout === 2 &amp;&amp; cardType=== 'function'\" class=\"card__inner clearfix\"><div class=\"card__header clearfix\"><div class=\"function_name card__header__inner col-md-12 no_pad\"><span class=title>&nbsp;</span></div></div><div class=\"card__block function_card clearfix\"><img v-bind:src=layoutImgSrc /></div><div class=\"card__footer clearfix\"><span>&nbsp;</span></div></div><div v-if=\"isSwitcher &amp;&amp; switcherLayout === 3 &amp;&amp; cardType=== 'function'\" class=\"card__inner clearfix\"><div class=\"card__header clearfix\"><div class=\"function_name card__header__inner col-md-12 no_pad\"><span class=title>&nbsp;</span></div></div><div class=\"card__block function_card clearfix\"><img v-bind:src=layoutImgSrc /></div><div class=\"card__footer clearfix\"><span>&nbsp;</span></div></div></div>";

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid><div class=row><div class=\"profile_main col-md-12\"><header class=\"profile_title_bar main_title_bar clearfix\"><h1 class=\"title col-md-10 col-sm-3 col-xs-3 clearfix\">Preset</h1></header><section class=\"profile_content row_space--xs clearfix\"><div v-if=isMobile class=table-responsive><table class=\"profile_table_mobile col-centered table table-bordered table-striped table-hover\"><tr><th>No.</th><th>Name</th><th>Detail/Preview</th></tr><tr v-for=\"(key, profile) in profiles\"><td>{{key}}</td><td>{{profile.name}}</td><td><i v-on:click=handleShowModal(key) class=\"fa fa-info-circle fa-lg\"></i><i v-on:click=handleShowGraphPreview(key) class=\"fa fa-picture-o fa-lg\"></i></td></tr></table></div><div v-if=!isMobile class=\"col-md-8 col-centered\"><table class=\"profile_table conl-centered table table-bordered table-striped table-hover\"><tr><th>No.</th><th>Name</th><th>Preview</th><th>Detail</th></tr><tr v-for=\"(key, profile) in profiles\"><td>{{key}}</td><td>{{profile.name}}</td><td class=screen_preview><v-screen v-if=!isMobile v-bind:out-ratio.sync=outRatio v-bind:splits.sync=splitsAry[key].setting v-bind:out-resolution.sync=outResolution v-bind:out-resolution-options.sync=outResolutionOptions v-bind:out-layout=outLayout v-bind:editable=false v-bind:layer.sync=profile.layer v-bind:show-ps=false v-bind:label.sync=label v-bind:mapping.sync=profile.mapping v-bind:id=key v-bind:in-profile=true></v-screen></td><td><i v-on:click=handleShowModal(key) class=\"fa fa-info-circle fa-lg\"></i></td></tr></table></div></section></div><modal v-bind:callback=handleApply v-bind:show.sync=showEditModal v-bind:title.sync=editingProfile.title effect=zoom ok-text=Apply cancel-text=Cancel class=single_profile_edit_modal><div slot=modal-body class=modal-body><table class=\"profile_config_table col-centered table table-bordered table-hover\"><tr><th>Name</th><td><input v-model=editingProfile.name maxlength=7 disabled=disabled class=form-control /></td></tr><tr><th>Mapping</th><td class=mapping_group><div class=\"col-xs-12 col-md-6 no_pad row_space--xxs\"><label>Window A:&nbsp;</label><v-select v-bind:options=mappingOptions v-bind:value.sync=\"editingProfile.mapping['1']\" disabled=disabled></v-select></div><div class=\"col-xs-12 col-md-6 no_pad row_space--xxs\"><label>Window B:&nbsp;</label><v-select v-bind:options=mappingOptions v-bind:value.sync=\"editingProfile.mapping['2']\" disabled=disabled></v-select></div><div class=\"col-xs-12 col-md-6 no_pad row_space--xxs\"><label>Window C:&nbsp;</label><v-select v-bind:options=mappingOptions v-bind:value.sync=\"editingProfile.mapping['3']\" disabled=disabled></v-select></div><div class=\"col-xs-12 col-md-6 no_pad row_space--xxs\"><label>Window D:&nbsp;</label><v-select v-bind:options=mappingOptions v-bind:value.sync=\"editingProfile.mapping['4']\" disabled=disabled></v-select></div></td></tr><tr><th>Layer</th><td><div class=\"layer_area col-xs-12 clearfix no_pad-xs\"><ul class=\"dropzone clearfix\"><li v-for=\"(key, value) in editingProfile.layer\" v-bind:data-index=value v-bind:data-bgcolor=value class=\"dragItem disabled\"><span class=\"token col-xs-12 clearfix\">{{winNameAry[value]}}</span></li></ul></div></td></tr><tr><th>Split</th><td><section class=\"split_group col-xs-12 clearfix no_pad-xs\"><div v-for=\"(key, value) in editingProfile.split\" v-bind:data-index=key class=\"split__single col-xs-12 no_pad\"><label class=\"col-xs-12 col-md-4\">Window {{winNameAry[key]}}</label><div class=\"col-xs-6 h_start clear-left\"><input v-model=value[0] type=number disabled=disabled class=\"form-control col-xs-6\"/></div><div class=\"col-xs-6 h_end\"><input v-model=value[2] type=number disabled=disabled class=\"form-control col-xs-6\"/></div><div class=\"col-xs-6 v_start\"><input v-model=value[1] type=number disabled=disabled class=\"form-control col-xs-6\"/></div><div class=\"col-xs-6 v_end\"><input v-model=value[3] type=number disabled=disabled class=\"form-control col-xs-6\"/></div></div></section></td></tr></table></div><div slot=modal-footer class=modal-footer><button v-on:click=\"showEditModal = false\" class=\"btn btn-default\">Cancel</button></div></modal><modal v-bind:callback=\"\" v-bind:show.sync=showPreviewModal v-bind:title.sync=previewProfile.title effect=zoom ok-text=Apply cancel-text=Cancel v-if=isMobile class=single_screen_preview_modal><div slot=modal-body class=\"modal-body no_pad\"><div class=screen_group><v-screen v-if=showPreviewModal v-bind:out-ratio.sync=outRatio v-bind:splits.sync=splitsAry[previewProfile._id].setting v-bind:out-resolution.sync=outResolution v-bind:out-resolution-options.sync=outResolutionOptions v-bind:out-layout=outLayout v-bind:editable=false v-bind:layer.sync=profiles[previewProfile._id].layer v-bind:show-ps=false v-bind:mapping.sync=profiles[previewProfile._id].mapping v-bind:id.sync=previewProfile._id v-bind:in-profile=true></v-screen></div></div><div slot=modal-footer class=modal-footer></div></modal></div></div>";

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

	module.exports = "<div class=row><div class=col-xs-12><fieldset><legend>dxGetDIOStatus</legend><button @click=\"sendAPI('dxGetDIOStatus')\">dxGetDIOStatus</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxSetDIOConfig</legend><div v-for=\"(id, DI) in DIs\"><span>DI {{ id }}: name</span><input type=text v-model=DI.name /></div><div v-for=\"(id, DO) in DOs\"><span>DO {{ id }}: name</span><input type=text v-model=DO.name /></div><button @click=dxSetDIOConfig>dxSetDIOConfig</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxSetDOState</legend><div v-for=\"(id, DO) in DOs\"><span>DO {{ id }}: value</span><input type=text v-model=DO.value /></div><button @click=dxSetDOState>dxSetDOState</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxGetSchedules</legend><button @click=\"sendAPI('dxGetSchedules')\">dxGetSchedules</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxSetSchedules</legend><div><h3>schedule<input type=number v-model=dxSetSchedules.no max=10 min=1 /></h3><span>enabled:<input type=checkbox v-model=dxSetSchedules.params.enabled /></span><div><span>name:<input type=text v-model=dxSetSchedules.params.name /></span></div><div><span>Actions</span><span><select v-model=dxSetSchedules.params.action><option value=\"DO High\">Do High</option><option value=\"DO Low\">Do low</option></select></span></div><div><span>Target</span><span v-for=\"i in 4\"><input type=checkbox v-bind:value=(i+1).toString() v-model=dxSetSchedules.params.targets />{{ i+1 }}</span></div><div class=row><div class=col-xs-6>hours<input type=number max=23 v-model=dxSetSchedules.params.time.hours /></div><div class=col-xs-6>minutes<input type=number max=59 v-model=dxSetSchedules.params.time.minutes /></div><div class=col-xs-12>days:<span v-for=\"(key,day) in weekDays\"><input type=checkbox v-bind:value=day v-model=dxSetSchedules.params.time.days /><label>{{day}}</label></span></div></div></div><button @click=dxSetSchedulesHandler>dxSetSchedules</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxGetEvents</legend><button @click=\"sendAPI('dxGetEvents')\">dxGetEvents</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxSetEvents</legend><div><h3>Event no.<input type=number min=1 max=10 v-model=dxSetEvents.no /></h3><div>enabled:<input type=checkbox v-model=dxSetEvents.content.enabled /></div><div>event.name<input type=text v-model=dxSetEvents.content.name /></div><div>event.key: {{ dxSetEvents.content.event.key }}</div><div>event.condition:<label v-for=\"condition in dxSetEvents.conditions\" class=radio-inline><input type=radio v-bind:value=condition v-model=dxSetEvents.content.event.condition />{{ condition }}</label></div><div>event.value<input type=text v-model=dxSetEvents.content.event.value placeholder=\"High2Low or Low2High\" class=light /></div><div><fieldset><legend> Actions</legend><div v-for=\"type in dxSetEvents.actionTypes\"><fieldset><legend>{{ type.action }}<input type=checkbox v-model=type.selected /></legend><div v-if=\"type.selected &amp;&amp; type.show_checkbox_dio\">Targets:<span v-for=\"i in 4\"><input type=checkbox v-bind:value=(i+1).toString() v-model=type.targets /><span>DO {{ i+1 }}</span></span></div><div v-if=\"type.selected &amp;&amp; type.show_targets_string\" class=form-group><label>accounts:</label><textarea v-model=type.targets_string class=form-control></textarea><div v-if=type.show_value>Delay Time:<input v-model=type.value /></div></div></fieldset></div></fieldset></div></div><button @click=dxSetEventsHandler>dxSetEvents</button></fieldset></div></div>";

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

	module.exports = "<div class=row><div class=col-xs-12><fieldset><legend>dxGetAbout</legend><button @click=\"sendAPI('dxGetAbout')\">dxGetAbout</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxGetBaudrate</legend><button @click=\"sendAPI('dxGetBaudrate')\">dxGetBaudrate</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxGetTimeZoneOptions</legend><button @click=\"sendAPI('dxGetTimeZoneOptions')\">dxGetTimeZoneOptions</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxGetTimeZone</legend><button @click=\"sendAPI('dxGetTimeZone')\">dxGetTimeZone</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxSetTimeZone</legend><div><span>id :</span><input v-model=timezone.id readonly=readonly /></div><div><span>offset :</span><input v-model=timezone.offset number=number readonly=readonly /></div><div><span>dstSavings :</span><input v-model=timezone.dstSavings number=number readonly=readonly /></div><div><span>useDaylight :</span><input type=checkbox v-model=timezone.useDaylight onclick=\"return false\"/></div><select v-model=timezone><option v-for=\"opt in timezoneOpts\" v-bind:value=opt>{{opt.id}}</option></select><button @click=dxSetTimeZone>dxSetTimeZone</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxGetNetworkSettings</legend><button @click=\"sendAPI('dxGetNetworkSettings')\">dxGetNetworkSettings</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxSetNetworkSettings</legend><div v-for=\"(key, val) in networkSettings\"><span>{{ key }}:</span><input type=text v-model=val /></div><div><span>dhcpEnabled:</span><input type=checkbox v-model=dhcpEnabled /></div><button @click=dxSetNetworkSettings>dxSetNetworkSettings</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxGetPower</legend><button @click=\"sendAPI('dxGetPower')\">dxGetPower</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxSetPower</legend><div><span>power status:</span></div><button @click=\"dxSetPower('on')\">dxSetPower( on )</button><button @click=\"dxSetPower('off')\">dxSetPower( off )</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxResetDevice</legend><button @click=\"sendAPI('dxResetDevice')\">dxResetDevice</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxDefaultDevice</legend><button @click=\"sendAPI('dxDefaultDevice')\">dxDefaultDevice</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxRollbackDevice</legend><button @click=\"sendAPI('dxRollbackDevice')\">dxRollbackDevice</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxUpdateFirmware</legend><div><span>url:</span><input type=text v-model=firmwareUrl /></div><button @click=dxUpdateFirmware>dxUpdateFirmware</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxGetEmailGroups</legend><button @click=\"sendAPI('dxGetEmailGroups')\">dxGetEmailGroups</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxSetEmailGroups</legend><div><span>gid:</span><input type=text v-model=emailGroup.gid /></div><div><span>name:</span><input type=text v-model=emailGroup.content.name /></div><div class=form-group><label>accounts:</label><textarea v-model=emailGroup.content.accounts class=form-control></textarea></div><button @click=dxSetEmailGroups>dxSetEmailGroups</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxGetSMSGroups</legend><button @click=\"sendAPI('dxGetSMSGroups')\">dxGetSMSGroups</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxSetSMSGroups</legend><div><span>gid:</span><input type=text v-model=smsGroup.gid /></div><div><span>name:</span><input type=text v-model=smsGroup.content.name /></div><div class=form-group><label>accounts:</label><textarea v-model=smsGroup.content.accounts class=form-control></textarea></div><button @click=dxSetSMSGroups>dxSetSMSGroups</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxGetSchedules</legend><button @click=\"sendAPI('dxGetSchedules')\">dxGetSchedules</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxSetSchedules</legend><div><h3>schedule<input type=number v-model=dxSetSchedules.no max=10 min=1 /></h3><span>enabled:<input type=checkbox v-model=dxSetSchedules.params.enabled /></span><div><span>name:<input type=text v-model=dxSetSchedules.params.name /></span></div><div><span>Actions</span><span><select v-model=dxSetSchedules.params.action><option value=\"Power RESET\">Power RESET</option><option value=\"Power ON\">Power ON</option><option value=\"Power OFF\">Power OFF</option><option value=\"Sequence ON\">Sequence ON</option><option value=\"Sequence OFF\">Sequence OFF</option></select></span></div><div><span>Banks</span><span v-for=\"i in 3\"><input type=checkbox v-bind:value=(i+1).toString() v-model=dxSetSchedules.params.banks />{{ i+1 }}</span></div><div class=row><div class=col-xs-6>hours<input type=number max=23 v-model=dxSetSchedules.params.time.hours /></div><div class=col-xs-6>minutes<input type=number max=59 v-model=dxSetSchedules.params.time.minutes /></div><div class=col-xs-12>days:<span v-for=\"(key,day) in weekDays\"><input type=checkbox v-bind:value=day v-model=dxSetSchedules.params.time.days /><label>{{day}}</label></span></div></div></div><button @click=dxSetSchedulesHandler>dxSetSchedules</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxGetEvents</legend><button @click=\"sendAPI('dxGetEvents')\">dxGetEvents</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxSetEvents</legend><div><h3>Event no.<input type=number min=1 max=10 v-model=dxSetEvents.no /></h3><div>enabled:<input type=checkbox v-model=dxSetEvents.content.enabled /></div><div>event.name<input type=text v-model=dxSetSchedules.params.name /></div><div>event.key: {{ dxSetEvents.content.event.key }}<radio type=info v-bind:checked.sync=dxSetEvents.content.event.key v-for=\"key in dxSetEvents.keys\" v-bind:value=key>{{ key }}</radio></div><div>event.condition:<label v-for=\"condition in dxSetEvents.conditions\" class=radio-inline><input type=radio v-bind:value=condition v-model=dxSetEvents.content.event.condition />{{ condition }}</label></div><div>event.value<input type=text v-model=dxSetEvents.event.value /></div><div><fieldset><legend> Actions</legend><div v-for=\"type in dxSetEvents.actionTypes\"><fieldset><legend>{{ type.action }}<input type=checkbox v-model=type.selected /></legend><div v-if=\"type.selected &amp;&amp; type.show_checkbox_power\">Targets:<span v-for=\"i in 4\"><input type=checkbox v-bind:value=i.toString() v-model=type.targets /><span v-if=i>bank {{ i }}</span><span v-else=v-else>input</span></span></div><div v-if=\"type.selected &amp;&amp; type.show_checkbox_dio\">Targets:<span v-for=\"i in 2\"><input type=checkbox v-bind:value=i.toString() v-model=type.targets /><span>DO {{ i+1 }}</span></span></div><div v-if=\"type.selected &amp;&amp; type.show_targets_string\" class=form-group><label>accounts:</label><textarea v-model=type.targets_string class=form-control></textarea><div v-if=type.show_value>Delay Time:<input v-model=type.value /></div></div></fieldset></div></fieldset></div></div><button @click=dxSetEventsHandler>dxSetEvents</button></fieldset></div></div>";

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

	module.exports = "<div class=row><div class=col-xs-12><fieldset><legend>dxGetPowerStatus</legend><button @click=\"sendAPI('dxGetPowerStatus')\">dxGetPowerStatus</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxEnableBank</legend><div v-for=\"(key, val) in apis.dxEnableBank.params.banks\" track-by=$index><span v-if=key>Bank {{ key }} :</span><span v-else=v-else>Input :</span><input type=checkbox v-model=val /></div><div><span>Enabled:</span><input type=checkbox v-model=apis.dxEnableBank.params.enabled /></div><button @click=dxEnableBank>dxEnableBank</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxLockBank</legend><div v-for=\"(key, val) in apis.dxLockBank.params.banks\" track-by=$index><span v-if=key>Bank {{ key }} :</span><span v-else=v-else>Input :</span><input type=checkbox v-model=val /></div><div><span>locked:</span><input type=checkbox v-model=apis.dxLockBank.params.locked /></div><button @click=dxLockBank>dxLockBank</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxResetBank</legend><div v-for=\"(key, val) in apis.dxResetBank.params.banks\" track-by=$index><span v-if=key>Bank {{ key }} :</span><span v-else=v-else>Input :</span><input type=checkbox v-model=val /></div><button @click=dxResetBank>dxResetBank</button></fieldset></div></div><div class=row><div class=col-xs-12><fieldset><legend>dxSetBankInfo</legend><div><span>Bank No</span><input type=number v-model=apis.dxSetBankInfo.no min=0 max=3 /></div><div v-for=\"(key, val) in apis.dxSetBankInfo.outlets\"><span>Outlet {{ key }} name:</span><input v-model=val.name /></div><button @click=dxSetBankInfo>dxSetBankInfo</button></fieldset></div></div>";

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

	module.exports = "<div id=test_page class=container-fluid><div class=row><div class=col-xs-4>Online Device List<div v-if=\"devices.length == 0\" class=list><span>no any devices</span></div><div v-else=v-else v-for=\"d in devices\" track-by=$index class=list><label v-bind:for=\"'mac_'+$index\">{{ d.xtea ? 'XTEA ' : 'HTTPS ' }} {{ d.mac }}</label><input v-bind:id=\"'mac_'+$index\" type=radio style=\"float: right\" value={{d.mac}} v-model=selected /></div><div>chosen device:{{selected}}</div><button @click=changeType(0)>general</button><button @click=changeType(2)>matrix</button><button @click=changeType(1)>power</button><button @click=changeType(3)>mixer</button><button @click=changeType(6)>dio</button><button @click=changeType(4)>splitter</button><button @click=changeType(5)>mes</button><button @click=changeType(8)>ir</button><button @click=changeType(9)>rs232</button><h2 class=title>----- {{ apiType }} Apis ------</h2><general-api v-if=\"type === 0\"></general-api><power-api v-if=\"type === 1\"></power-api><matrix-api v-if=\"type === 2\"></matrix-api><mixer-api v-if=\"type === 3\"></mixer-api><dio-api v-if=\"type === 6\"></dio-api><splitter-api v-if=\"type === 4\"></splitter-api><mes-api v-if=\"type === 5\"></mes-api><ir-api v-if=\"type === 8\"></ir-api><rs232-api v-if=\"type === 9\"></rs232-api></div><div class=\"col-xs-8 result\"><div class=row><div class=\"col-xs-6 scrolling\"><h2>API request</h2><pre v-html=req></pre></div><div class=\"col-xs-6 scrolling\"><h2>API result</h2><pre v-html=res></pre></div></div></div></div></div>";

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid><div class=row><div class=\"profile_main col-md-12\"><header class=\"profile_title_bar main_title_bar clearfix\"><h1 class=\"title col-md-10 col-sm-3 col-xs-3 clearfix\">Preset</h1></header><section class=\"profile_content row_space--xs clearfix\"><div v-if=isMobile class=table-responsive><table class=\"profile_table_mobile col-centered table table-bordered table-striped table-hover\"><tr><th>No.</th><th>Name</th><th>Detail/Preview</th></tr><tr v-for=\"(key, profile) in profiles\"><td>{{key}}</td><td>{{profile.name}}</td><td><i v-on:click=handleShowModal(key) class=\"fa fa-info-circle fa-lg\"></i><i v-on:click=handleShowGraphPreview(key) class=\"fa fa-picture-o fa-lg\"></i></td></tr></table></div><div v-else=v-else class=\"col-md-10 col-centered\"><table class=\"profile_table conl-centered table table-bordered table-striped table-hover\"><tr><th>No.</th><th>Name</th><th>Resolution</th><th>Preview</th><th>Detail</th></tr><tr v-for=\"(key, profile) in profiles\"><td>{{key}}</td><td>{{profile.name}}</td><td>{{profile.resolution}}</td><td class=screen_preview><v-screen v-bind:editable=false v-bind:show-link=false v-bind:in-which-page=\"'preset'\" v-bind:show-ps-in=false v-bind:id=key></v-screen></td><td><i v-on:click=handleShowModal(key) class=\"fa fa-info-circle fa-lg\"></i></td></tr></table></div></section></div><modal v-bind:callback=handleApply v-bind:show.sync=showEditModal v-bind:title.sync=editingProfile.title effect=zoom ok-text=Apply cancel-text=Cancel class=single_profile_edit_modal><div slot=modal-body class=modal-body><table class=\"profile_config_table col-centered table table-bordered table-hover\"><tr><th>Name</th><td><input v-model=editingProfile.name maxlength=7 disabled=disabled class=form-control /></td></tr><tr><th>Resolution</th><td>{{editingProfile.resolution}}</td></tr><tr><th>Split</th><td><section class=\"split_group col-xs-12 clearfix no_pad-xs\"><div v-for=\"(key, value) in editingProfile.split\" v-bind:data-index=key class=\"split__single col-xs-12 no_pad\"><label class=\"col-xs-12 col-md-4\">Window {{winNameAry[key]}}</label><div class=\"col-xs-6 h_start clear-left\"><input v-model=value[0] type=number disabled=disabled class=\"form-control col-xs-6\"/></div><div class=\"col-xs-6 h_end\"><input v-model=value[2] type=number disabled=disabled class=\"form-control col-xs-6\"/></div><div class=\"col-xs-6 v_start\"><input v-model=value[1] type=number disabled=disabled class=\"form-control col-xs-6\"/></div><div class=\"col-xs-6 v_end\"><input v-model=value[3] type=number disabled=disabled class=\"form-control col-xs-6\"/></div></div></section></td></tr></table></div><div slot=modal-footer class=modal-footer><button v-on:click=\"showEditModal = false\" class=\"btn btn-default\">Cancel</button></div></modal><modal v-bind:callback=\"\" v-bind:show.sync=showPreviewModal v-bind:title.sync=previewProfile.title effect=zoom ok-text=Apply cancel-text=Cancel large=large class=single_screen_preview_modal><div slot=modal-body class=\"modal-body no_pad\"><div class=screen_group><v-screen v-if=showPreviewModal v-bind:editable=false v-bind:show-link=false v-bind:in-which-page=\"'preset'\" v-bind:show-ps-in=true v-bind:id.sync=previewProfile._id></v-screen></div></div><div slot=modal-footer class=modal-footer></div></modal></div></div>";

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

	module.exports = "<modal v-bind:show.sync=show effect=fade v-bind:callback=applyChange ok-text=Apply cancel-text=Cancel class=popout _v-03dc5208=\"\"><div slot=modal-header class=modal-header _v-03dc5208=\"\"><span @click=\"show = false\" class=close _v-03dc5208=\"\">×</span><h2 slot=modal-title v-show=isOut _v-03dc5208=\"\">Output {{ outputData._id }}</h2><h2 slot=modal-title v-else=v-else _v-03dc5208=\"\">Input {{ inputData._id }}</h2></div><div slot=modal-body class=\"modal-body clearfix\" _v-03dc5208=\"\"><div v-if=isOut class=\"col-md-6 col-xs-6 outDevice_img device_img\" _v-03dc5208=\"\"><div class=\"col-md-12 no_pad\" _v-03dc5208=\"\"><img v-bind:src=inputImgs[inputImgFocus] class=img-responsive _v-03dc5208=\"\"></div></div><div v-else=v-else class=\"col-md-6 col-xs-6 device_img\" _v-03dc5208=\"\"><div v-if=\"inputData.type === 'HDMI'\" class=\"col-md-12 no_pad\" _v-03dc5208=\"\"><h3 class=title _v-03dc5208=\"\">Photo {{ inputImgFocus }}</h3><swiper direction=horizontal v-bind:initial-page=\"inputImgFocus - 1\" v-bind:slide-to-page=\"inputImgFocus - 1\" @slide-change-end=onInSwiperEnd v-bind:modal-shown.sync=show v-bind:transitioning.sync=transitioning class=input _v-03dc5208=\"\"><div v-for=\"($index, slide) in inImgsliders\" class=inner__slider _v-03dc5208=\"\"><img v-bind:src=slide.url class=img-responsive _v-03dc5208=\"\"></div></swiper></div><div v-if=\"inputData.type === 'VGA'\" class=\"col-md-0 no_pad col-centered\" _v-03dc5208=\"\"><img v-bind:src=vgaIcon class=\"img-responsive vga\" _v-03dc5208=\"\"></div></div><div class=\"col-md-6 col-xs-6 device_config\" _v-03dc5208=\"\"><h3 class=title _v-03dc5208=\"\">Name<input v-show=isOut v-model=outputData.name maxlength=7 class=form-control _v-03dc5208=\"\"><input v-else=v-else v-model=inputData.name maxlength=7 class=form-control _v-03dc5208=\"\"></h3><div v-if=\"!isOut &amp;&amp; hdcpCapability.inputs.enabled.settable &amp;&amp; isInstaller\" _v-03dc5208=\"\"><h3 class=title _v-03dc5208=\"\">HDCP</h3><label class=iosCheck _v-03dc5208=\"\"><input type=checkbox v-model=inputData.HDCP.enabled _v-03dc5208=\"\"><i _v-03dc5208=\"\"></i></label></div><h3 v-if=isOut class=title _v-03dc5208=\"\">favorite</h3><label v-if=isOut class=favoriteCheck _v-03dc5208=\"\"><input type=checkbox v-model=isFavorite _v-03dc5208=\"\"><i class=\"fa fa-heart\" _v-03dc5208=\"\"></i></label></div></div><div slot=modal-footer class=modal-footer _v-03dc5208=\"\"><button v-on:click=\"show = false\" class=\"btn btn-default\" _v-03dc5208=\"\">Cancel</button><button v-on:click=applyChange v-bind:disabled.sync=transitioning class=\"btn btn-primary\" _v-03dc5208=\"\">Apply</button></div></modal>";

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid clearfix\" _v-0433ddcb=\"\"><div v-if=showLoadingAni class=waitingAni _v-0433ddcb=\"\"><div class=boxLoading _v-0433ddcb=\"\"><span _v-0433ddcb=\"\">Loading..</span></div></div><div class=row _v-0433ddcb=\"\"><div class=\"edid_main col-md-12\" _v-0433ddcb=\"\"><header class=\"edid_title_bar main_title_bar clearfix\" _v-0433ddcb=\"\"><h1 class=\"title col-md-10 col-sm-10 col-xs-12 clearfix\" _v-0433ddcb=\"\">edid</h1></header><section _v-0433ddcb=\"\"><header class=\"input col-md-12 clearfix\" _v-0433ddcb=\"\"><h2 _v-0433ddcb=\"\">Input</h2></header><section class=\"col-md-12 col-lg-11 col-centered edid_group clear-left\" _v-0433ddcb=\"\"><accordion type=info _v-0433ddcb=\"\"><panel v-for=\"(key, input) in inputs\" v-ref:in-panels=v-ref:in-panels _v-0433ddcb=\"\"><div slot=header class=\"panel-title clearfix\" _v-0433ddcb=\"\"><div class=\"col-xs-2 no_pad col-md-2\" _v-0433ddcb=\"\"><h4 class=\"no_pad_v no_margin_v\" _v-0433ddcb=\"\">{{key}}.&nbsp;{{inputs[key].name}}</h4></div><div class=\"col-xs-1 reload_edid pull-right\" _v-0433ddcb=\"\"><i v-on:click.stop=\"asyncLoadInData(key, $event)\" v-if=\"inEDID[key].edid === ''\" class=\"fa fa-external-link fa-lg\" _v-0433ddcb=\"\"></i><i v-on:click.stop=\"asyncLoadInData(key, $event)\" v-else=v-else v-bind:class=\"{'fa-angle-up': inEDID[key].isOpen, 'fa-angle-down': !inEDID[key].isOpen}\" class=\"fa fa-lg\" _v-0433ddcb=\"\"></i></div><div v-if=!inEDIDReadonly class=\"col-xs-1 pull-right edit_edid no_pad\" _v-0433ddcb=\"\"><i v-on:click.stop=showModal(key) class=\"fa fa-edit fa-lg\" _v-0433ddcb=\"\"></i></div></div><div class=\"col-md-12 col-xs-12 no_pad\" _v-0433ddcb=\"\"><div class=edid_trigger _v-0433ddcb=\"\"><edid-displayer v-on:click=toggleOpen($event) v-bind:edid-string=inEDID[key].edid _v-0433ddcb=\"\"></edid-displayer></div></div></panel></accordion></section><header class=\"output col-md-12 clearfix\" _v-0433ddcb=\"\"><h2 _v-0433ddcb=\"\">Output</h2></header><section class=\"col-md-12 col-lg-11 col-centered edid_group clear-left\" _v-0433ddcb=\"\"><accordion type=info _v-0433ddcb=\"\"><panel v-for=\"(key ,output) in outputs\" v-ref:out-panels=v-ref:out-panels _v-0433ddcb=\"\"><div slot=header class=\"panel-title clearfix\" _v-0433ddcb=\"\"><div class=\"col-xs-2 no_pad\" _v-0433ddcb=\"\"><h4 class=\"no_pad_v no_margin_v\" _v-0433ddcb=\"\">{{key}}.&nbsp;{{outputs[key].name}}</h4></div><div class=\"col-xs-1 reload_edid pull-right\" _v-0433ddcb=\"\"><i v-if=\"outEDID[key].HDMI === '' &amp;&amp; outEDID[key].HDBT === ''\" v-on:click.stop=\"asyncLoadOutData(key, outputs[key].type, $event)\" class=\"fa fa-external-link fa-lg\" _v-0433ddcb=\"\"></i><i v-on:click.stop=\"asyncLoadOutData(key, '', $event)\" v-else=v-else v-bind:class=\"{'fa-angle-up': outEDID[key].isOpen, 'fa-angle-down': !outEDID[key].isOpen}\" class=\"fa fa-lg\" _v-0433ddcb=\"\"></i></div></div><div class=\"col-md-12 col-xs-11 no_pad trigger_group\" _v-0433ddcb=\"\"><div v-if=\"outEDID[key].HDMI &amp;&amp; outEDID[key].HDMI !== 'None' \" class=edid_trigger _v-0433ddcb=\"\"><edid-displayer v-on:click=toggleOpent($event) v-bind:edid-string=outEDID[key].HDMI _v-0433ddcb=\"\"></edid-displayer></div><div v-if=\"outEDID[key].HDBT &amp;&amp; outEDID[key].HDBT !== 'None'\" class=edid_trigger _v-0433ddcb=\"\"><edid-displayer v-on:click=toggleOpen($event) v-bind:edid-string=outEDID[key].HDBT _v-0433ddcb=\"\"></edid-displayer></div><div v-if=\"outEDID[key].HDBT === 'None' || outEDID[key].HDMI === 'None'\" class=edid_trigger _v-0433ddcb=\"\"><span _v-0433ddcb=\"\">{{outEDID[key].HDBT === 'None' ? outEDID[key].HDBT : outEDID[key].HDMI}}</span></div></div></panel></accordion></section></section></div></div><modal v-bind:title.sync=outModal.title v-bind:show.sync=showOutConfig v-bind:callback=handleOutConfig effect:zoom=effect:zoom backdrop=false ok-text=Apply cancel-text=Cancel class=out_edid_config _v-0433ddcb=\"\"><div slot=modal-body class=\"modal-body clearfix\" _v-0433ddcb=\"\"><div class=col-xs-12 _v-0433ddcb=\"\"><div class=\"col-xs-4 col-md-3 no_pad\" _v-0433ddcb=\"\"><label _v-0433ddcb=\"\">Learn EDID to</label></div><div class=\"col-xs-6 col-md-4\" _v-0433ddcb=\"\"><v-select v-bind:options=outModal.options v-bind:value.sync=outModal.option _v-0433ddcb=\"\"></v-select></div></div></div></modal><modal v-bind:title.sync=editing.title v-bind:show.sync=showConfig v-bind:callback=handleApply effect:zoom=effect:zoom backdrop=false ok-text=Apply cancel-text=Cancel class=edid_config _v-0433ddcb=\"\"><div slot=modal-body class=\"modal-body clearfix\" _v-0433ddcb=\"\"><table class=\"table table-bordered table-striped table-hover\" _v-0433ddcb=\"\"><tbody _v-0433ddcb=\"\"><tr _v-0433ddcb=\"\"><th _v-0433ddcb=\"\">EDID</th><td _v-0433ddcb=\"\"><span class=\"col-xs-12 no_pad clearfix\" _v-0433ddcb=\"\"><div class=fa_checkbox _v-0433ddcb=\"\"><input type=radio id=default value=default name=method v-model=editing.edidMethod _v-0433ddcb=\"\"><label for=default _v-0433ddcb=\"\"><span _v-0433ddcb=\"\">Default</span></label></div><div v-if=\"editing.edidMethod === 'default'\" class=\"col-md-12 clearfix input_single no_pad\" _v-0433ddcb=\"\"><v-select v-bind:options=defaultEDIDoptions v-bind:value.sync=editing.buildInValue placeholder=\"Select a default EDID\" class=outputBtn _v-0433ddcb=\"\"></v-select></div><div class=fa_checkbox _v-0433ddcb=\"\"><input type=radio id=output value=output name=method v-model=editing.edidMethod _v-0433ddcb=\"\"><label for=output _v-0433ddcb=\"\"><span _v-0433ddcb=\"\">Output</span></label></div><div v-if=\"editing.edidMethod === 'output'\" class=\"col-md-12 clearfix input_single\" _v-0433ddcb=\"\"><v-select v-bind:options=outOptions v-bind:value.sync=editing.outValue placeholder=Port v-bind:disabled=\"outOptions.length === 0\" _v-0433ddcb=\"\"></v-select><v-select v-bind:options=outTypes[editing.outValue] v-bind:value.sync=editing.outType v-bind:disabled=\"!outTypes[editing.outValue] || outTypes[editing.outValue].length === 0\" placeholder=type class=col_space--xxs _v-0433ddcb=\"\"></v-select></div><div class=fa_checkbox _v-0433ddcb=\"\"><input type=radio id=custom value=custom name=method v-model=editing.edidMethod _v-0433ddcb=\"\"><label for=custom _v-0433ddcb=\"\"><span _v-0433ddcb=\"\">Customize File</span></label></div><div v-if=supportAutoEDID class=fa_checkbox _v-0433ddcb=\"\"><input type=radio id=auto value=auto name=method v-model=editing.edidMethod _v-0433ddcb=\"\"><label for=auto _v-0433ddcb=\"\"><span _v-0433ddcb=\"\">Auto</span></label></div><div v-if=\"editing.edidMethod === 'custom'\" class=\"col-md-12 clearfix input_single\" _v-0433ddcb=\"\"><label id=fileBtn for=file class=\"btn btn-default\" _v-0433ddcb=\"\">{{uploadFileBtnText}}</label><input id=file type=file v-el:edidbin=v-el:edidbin v-on:change=checkFile($event) class=form-control _v-0433ddcb=\"\"></div></span></td></tr></tbody></table></div></modal></div>";

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-044ba768=\"\"><div class=row _v-044ba768=\"\"><div class=col-md-12 _v-044ba768=\"\"><h2 _v-044ba768=\"\">Schedule</h2></div></div></div>";

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

	module.exports = "<div class=row _v-05e33afa=\"\"><div class=col-xs-12 _v-05e33afa=\"\"><div class=row _v-05e33afa=\"\"><div class=col-xs-12 _v-05e33afa=\"\"><fieldset _v-05e33afa=\"\"><legend _v-05e33afa=\"\">dxGetBaudrate</legend><button @click=\"sendAPI('dxGetBaudrate')\" _v-05e33afa=\"\">dxGetBaudrate</button></fieldset></div></div><fieldset _v-05e33afa=\"\"><legend _v-05e33afa=\"\">dxSendSerialCommand</legend><span _v-05e33afa=\"\">signal</span><input type=text v-model=command _v-05e33afa=\"\"><br _v-05e33afa=\"\"><button @click=dxSendSerialCommand(false) _v-05e33afa=\"\">send string</button><button @click=dxSendSerialCommand(true) _v-05e33afa=\"\">send b64 string</button></fieldset><fieldset _v-05e33afa=\"\"><legend _v-05e33afa=\"\">dxSetBaudrate</legend><span _v-05e33afa=\"\">signal</span><input type=text v-model=baudrate _v-05e33afa=\"\"><button @click=dxSetBaudrate() _v-05e33afa=\"\">dxSendIRSignal</button></fieldset></div></div>";

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-0d4de43f=\"\"><header role=banner class=\"navbar navbar-fixed-top bs-docs-nav\" _v-0d4de43f=\"\"><div v-if=\"$route.name !== 'test' &amp;&amp; $route.name !== 'control'\" class=homeButton _v-0d4de43f=\"\"><i v-on:click=toIndex() class=\"fa fa-home fa-lg\" _v-0d4de43f=\"\"></i></div><div class=\"mobile_menu hidden-sm hidden-md hidden-lg col-sm-12 col-xs-12 no_pad\" _v-0d4de43f=\"\"><ul class=\"nav navbar-nav\" _v-0d4de43f=\"\"><li class=\"logo hidden-xs\" _v-0d4de43f=\"\"><span _v-0d4de43f=\"\">{{* VV.label.appName }}</span></li><li class=\"menu__hamburger pull-left\" _v-0d4de43f=\"\"><a @click=toShowLeft() _v-0d4de43f=\"\"><i class=\"fa fa-bars fa-2\" _v-0d4de43f=\"\"></i></a></li><li class=\"user pull-right\" _v-0d4de43f=\"\"><dropdown _v-0d4de43f=\"\"><button slot=button data-toggle=dropdown class=\"btn btn-default\" _v-0d4de43f=\"\"><i class=\"fa fa-user\" _v-0d4de43f=\"\"></i></button><ul slot=dropdown-menu class=\"dropdown-menu user_dropdown\" _v-0d4de43f=\"\"><li v-if=\"$route.name === 'control'\" _v-0d4de43f=\"\"><a v-on:click.prevent=handleShowChgNickname _v-0d4de43f=\"\"><i class=\"fa fa-edit\" _v-0d4de43f=\"\"></i>change name</a></li><li _v-0d4de43f=\"\"><a v-on:click.prevent=\"showChgProfile = true\" _v-0d4de43f=\"\"><i class=\"fa fa-user\" _v-0d4de43f=\"\"></i>profile</a></li><li _v-0d4de43f=\"\"><a v-on:click.prevent=\"showChgPw = true\" _v-0d4de43f=\"\"><i class=\"fa fa-lock\" _v-0d4de43f=\"\"></i>change password</a></li><li _v-0d4de43f=\"\"><a v-on:click.prevent=\"showAddDevice = true\" _v-0d4de43f=\"\"><i class=\"fa fa-hdd-o\" _v-0d4de43f=\"\"></i>add device</a></li><li v-if=\"$route.name === 'power' || $route.anem === 'control \" _v-0d4de43f=\"\"><a v-link=\"'m2m'\" _v-0d4de43f=\"\"><img v-bind={src:imgs[10]} class=icon _v-0d4de43f=\"\">M2M</a></li><li _v-0d4de43f=\"\"><a @click=logout() _v-0d4de43f=\"\"><i class=\"fa fa-sign-out\" _v-0d4de43f=\"\"></i>Logout</a></li><li _v-0d4de43f=\"\"><a _v-0d4de43f=\"\">{{ version }}</a></li></ul></dropdown></li><li class=machine_name _v-0d4de43f=\"\"><dropdown _v-0d4de43f=\"\"><button slot=button data-toggle=dropdown v-bind:disabled=isEmpty(devices) class=\"btn btn-default\" _v-0d4de43f=\"\"><div class=btn-view _v-0d4de43f=\"\"><div v-bind:class=\"{'rolling': vendorIcons[vendor]}\" class=rolling-group _v-0d4de43f=\"\"><span class=icon-group _v-0d4de43f=\"\"><img v-show=!isEmpty(devices) v-bind={src:imgs[current.typeId]} class=icon _v-0d4de43f=\"\"><span v-if=\"current.nickname !== null\" class=text _v-0d4de43f=\"\">{{current.nickname || 'Anonymous'}}</span></span><span class=logo-group _v-0d4de43f=\"\"><span class=img _v-0d4de43f=\"\"><img v-bind={src:vendorIcons[vendor]} class=icon _v-0d4de43f=\"\"></span></span></div></div></button><ul slot=dropdown-menu v-if=user.installer class=\"dropdown-menu machine_dropdown\" _v-0d4de43f=\"\"><li v-for=\"(mac, device) in devices | orderBy '!online' \" v-bind:class=\"{'online':device.online,'current_device': mac === current.mac_address}\" class=machine__single _v-0d4de43f=\"\"><div v-bind:class=\"{'hidden': device.online}\" class=mask _v-0d4de43f=\"\"></div><a v-link=\"{ name: device.type , params: { mac:mac } }\" _v-0d4de43f=\"\"><indicator v-bind:enable=device.online _v-0d4de43f=\"\"></indicator><img v-show=!isEmpty(devices) v-bind={src:imgs[device.typeId]} class=icon _v-0d4de43f=\"\"><span class=nickName _v-0d4de43f=\"\">{{ device.nickname || 'Anonymous' }}</span></a></li></ul><ul slot=dropdown-menu v-if=!user.installer class=\"dropdown-menu machine_dropdown\" _v-0d4de43f=\"\"><li v-for=\"(mac, device) in devices | orderBy '!online' | filterBy user.uid in 'ownerId'\" v-bind:class=\"{'online':device.online,'current_device':mac === current.mac_address}\" class=machine__single _v-0d4de43f=\"\"><div v-bind:class=\"{'hidden': device.online}\" class=mask _v-0d4de43f=\"\"></div><a v-link=\"{ name: device.type , params: { mac:mac } }\" _v-0d4de43f=\"\"><indicator v-bind:enable=device.online _v-0d4de43f=\"\"></indicator><img v-show=!isEmpty(devices) v-bind={src:imgs[device.typeId]} class=icon _v-0d4de43f=\"\"><span class=nickName _v-0d4de43f=\"\">{{ device.nickname || 'Anonymous' }}</span></a></li></ul></dropdown></li></ul></div><div class=\"pc_menu hidden-xs\" _v-0d4de43f=\"\"><ul class=\"nav navbar-nav menu__single left_menu col-lg-5 col-md-5 col-sm-5\" _v-0d4de43f=\"\"><li class=logo _v-0d4de43f=\"\"><span _v-0d4de43f=\"\">{{* VV.label.appName }}</span></li><li class=\"menu__hamburger hidden-sm\" _v-0d4de43f=\"\"><a @click=toShowLeft() class=btn _v-0d4de43f=\"\"><i class=\"fa fa-bars fa-2\" _v-0d4de43f=\"\"></i>&nbsp;menu</a></li><li class=\"menu__hamburger col-md-2 no_pad hidden-lg hidden-md\" _v-0d4de43f=\"\"><a @click=toShowLeft() _v-0d4de43f=\"\"><i class=\"fa fa-bars fa-2\" _v-0d4de43f=\"\"></i>&nbsp;menu</a></li></ul><div class=\"center_menu col-lg-2 col-md-2 col-sm-2\" _v-0d4de43f=\"\"><span v-if=vendorIcons[vendor] _v-0d4de43f=\"\"><img v-bind={src:vendorIcons[vendor]} _v-0d4de43f=\"\"></span></div><ul class=\"nav navbar-nav col-lg-5 col-md-5 col-sm-5 menu__single right_menu\" _v-0d4de43f=\"\"><li class=user _v-0d4de43f=\"\"><dropdown _v-0d4de43f=\"\"><button slot=button class=\"btn btn-default\" _v-0d4de43f=\"\"><i class=\"fa fa-user\" _v-0d4de43f=\"\"></i>&nbsp; {{ user.name }}</button><ul slot=dropdown-menu class=\"dropdown-menu user_dropdown\" _v-0d4de43f=\"\"><li v-if=\"$route.name === 'control\" _v-0d4de43f=\"\"><a v-on:click.prevent=handleShowChgNickname _v-0d4de43f=\"\"><i class=\"fa fa-edit\" _v-0d4de43f=\"\"></i>change name</a></li><li _v-0d4de43f=\"\"><a v-on:click.prevent=\"showChgProfile = true\" _v-0d4de43f=\"\"><i class=\"fa fa-user\" _v-0d4de43f=\"\"></i>profile</a></li><li _v-0d4de43f=\"\"><a v-on:click.prevent=\"showChgPw = true\" _v-0d4de43f=\"\"><i class=\"fa fa-lock\" _v-0d4de43f=\"\"></i>change password</a></li><li _v-0d4de43f=\"\"><a v-on:click.prevent=\"showAddDevice = true\" _v-0d4de43f=\"\"><i class=\"fa fa-hdd-o\" _v-0d4de43f=\"\"></i>add device</a></li><li v-if=\"$route.name === 'power' || $route.anem === 'control \" _v-0d4de43f=\"\"><a v-link=\"'m2m'\" _v-0d4de43f=\"\"><img v-bind={src:imgs[10]} class=icon _v-0d4de43f=\"\">M2M</a></li><li _v-0d4de43f=\"\"><a @click=logout() _v-0d4de43f=\"\"><i class=\"fa fa-sign-out\" _v-0d4de43f=\"\"></i>logout</a></li><li _v-0d4de43f=\"\"><a _v-0d4de43f=\"\">{{ version }}</a></li></ul></dropdown></li><li class=machine_name _v-0d4de43f=\"\"><dropdown _v-0d4de43f=\"\"><button slot=button data-toggle=dropdown v-bind:disabled=isEmpty(devices) class=\"btn btn-default\" _v-0d4de43f=\"\"><img v-bind={src:imgs[current.typeId]} v-show=!isEmpty(devices) class=icon _v-0d4de43f=\"\"><span _v-0d4de43f=\"\"><i v-show=isEmpty(devices) class=\"fa fa-question icon\" _v-0d4de43f=\"\"></i>{{current.nickname}}</span></button><ul slot=dropdown-menu @wheel=wheelOnMachineList class=\"dropdown-menu machine_dropdown\" _v-0d4de43f=\"\"><li class=machine__single _v-0d4de43f=\"\"><div class=\"arrow_left arrow\" _v-0d4de43f=\"\"><a @click=\"toScrollSlider('left')\" _v-0d4de43f=\"\"><i class=\"fa fa-angle-left\" _v-0d4de43f=\"\"></i></a></div><div v-el:slider=v-el:slider class=\"slider_menu slider_group\" _v-0d4de43f=\"\"><ul _v-0d4de43f=\"\"><li v-for=\"(mac, device) in devices | orderBy '!online'\" v-bind:class=\"{'online':device.online, 'current_device': mac === current.mac_address}\" v-show=\"mac === favorite &amp;&amp; (device.ownerId === user.uid || user.installer)\" class=\"slider__single favorite_device\" _v-0d4de43f=\"\"><div v-bind:class=\"{'hidden':device.online}\" class=mask _v-0d4de43f=\"\"></div><a v-link=\"{ name: device.type , params : { mac: mac } }\" _v-0d4de43f=\"\"><img v-bind={src:imgs[device.typeId]} class=icon _v-0d4de43f=\"\"><span class=nickName _v-0d4de43f=\"\">&nbsp;{{device.nickname || 'Anonymous' }}</span></a></li><li v-for=\"(mac, device) in devices | orderBy '!online' \" v-bind:class=\"{'online': device.online, 'current_device': mac === current.mac_address}\" v-show=\"mac !== favorite &amp;&amp; user.installer\" class=slider__single _v-0d4de43f=\"\"><div v-bind:class=\"{'hidden':device.online}\" class=mask _v-0d4de43f=\"\"></div><a v-link=\"{ name: device.type , params : { mac: mac } }\" _v-0d4de43f=\"\"><img v-bind={src:imgs[device.typeId]} class=icon _v-0d4de43f=\"\"><span class=nickName _v-0d4de43f=\"\">&nbsp;{{device.nickname || 'Anonymous' }}</span></a></li><li v-for=\"(mac, device) in devices | orderBy '!online' | filterBy user.uid in 'ownerId'\" v-bind:class=\"{'online':device.online, 'current_device': mac === current.mac_address}\" v-show=\"mac !== favorite &amp;&amp; !user.installer\" class=slider__single _v-0d4de43f=\"\"><div v-bind:class=\"{'hidden':device.online}\" class=mask _v-0d4de43f=\"\"></div><a v-link=\"{ name: device.type , params : { mac: mac } }\" _v-0d4de43f=\"\"><img v-bind={src:imgs[device.typeId]} class=icon _v-0d4de43f=\"\"><span class=nickName _v-0d4de43f=\"\">&nbsp;{{device.nickname || 'Anonymous' }}</span></a></li></ul></div><div class=\"arrow_right arrow\" _v-0d4de43f=\"\"><a @click=\"toScrollSlider('right')\" _v-0d4de43f=\"\"><i class=\"fa fa-angle-right\" _v-0d4de43f=\"\"></i></a></div></li></ul></dropdown></li></ul></div></header></div><modal title=\"Edit My Profile\" v-bind:show.sync=showChgProfile effect=fade cancel-text=Cancel ok-text=Apply v-bind:callback=handleChgProfile backdrop=false class=user_profile_edit_modal _v-0d4de43f=\"\"><div slot=modal-body class=\"modal-body clearfix\" _v-0d4de43f=\"\"><div class=col-md-12 _v-0d4de43f=\"\"><label _v-0d4de43f=\"\">Account</label><input disabled=disabled v-model=user.email class=form-control _v-0d4de43f=\"\"></div><div class=col-md-4 _v-0d4de43f=\"\"><validator name=displayName _v-0d4de43f=\"\"><label _v-0d4de43f=\"\">Display name</label><input v-model=newName maxlength=12 v-validate:name=\"['engAndNum']\" class=form-control _v-0d4de43f=\"\"><span v-show=\"$displayName.name.invalid &amp;&amp; $displayName.name.modified\" class=error _v-0d4de43f=\"\">At least 1 English character, number or ' allowed</span></validator></div><div class=\"col-md-4 no_pad clearfix\" _v-0d4de43f=\"\"><label class=col-xs-12 _v-0d4de43f=\"\">Auto logout time</label><v-select disabled=disabled v-bind:value.sync=newSessionTime v-bind:options=sessionOptions v-bind:close-on-select=true class=col-xs-12 _v-0d4de43f=\"\"></v-select></div><div class=\"col-md-4 no_pad clearfix\" _v-0d4de43f=\"\"><label class=col-xs-12 _v-0d4de43f=\"\">Favorite Device</label><v-select v-if=\"favoriteOptions.length !== 0\" v-bind:value.sync=favorite v-bind:options=favoriteOptions v-bind:close-on-select=true placeholder=\"No favorite device\" class=col-xs-12 _v-0d4de43f=\"\"></v-select><span v-else=v-else class=reminding _v-0d4de43f=\"\">None of your devices online</span></div></div></modal><modal v-bind:show.sync=showChgPw title=\"Edit my password\" effect=fade ok-text=Apply cancel-text=Cancel v-bind:callback=handleChgPw backdrop=false class=user_change_pwd _v-0d4de43f=\"\"><div slot=modal-body class=\"modal-body clearfix\" _v-0d4de43f=\"\"><validator name=changePwValidator _v-0d4de43f=\"\"><div class=col-md-8 _v-0d4de43f=\"\"><label _v-0d4de43f=\"\">old password</label><input type=password v-model=oldPwd maxlength=20 v-bind:readonly=user.installer class=form-control _v-0d4de43f=\"\"></div><div class=col-md-8 _v-0d4de43f=\"\"><label _v-0d4de43f=\"\">new password</label><input type=password v-model=newPwd maxlength=20 v-validate:newpwd=\"['password']\" v-bind:readonly=user.installer class=form-control _v-0d4de43f=\"\"><span v-show=\"$changePwValidator.newpwd.invalid &amp;&amp; $changePwValidator.newpwd.modified\" class=error _v-0d4de43f=\"\">At least 4 English characters or numbers allowed</span></div><div class=col-md-8 _v-0d4de43f=\"\"><label _v-0d4de43f=\"\">confirm password</label><input type=password v-model=newPwd2 maxlength=20 v-validate:newpwd2=\"['password']\" v-bind:readonly=user.installer class=form-control _v-0d4de43f=\"\"><span v-show=\"$changePwValidator.newpwd2.invalid &amp;&amp; $changePwValidator.newpwd2.modified\" class=error _v-0d4de43f=\"\">At least 4 English characters or numbers allowed</span></div></validator></div></modal><modal v-bind:show.sync=showAddDevice title=\"Add new device\" effect=fade ok-text=Apply cancel-tex=Cancel v-bind:callback=handleAddDevice backdrop=false class=add_device _v-0d4de43f=\"\"><div slot=modal-body class=\"modal-body clearfix\" _v-0d4de43f=\"\"><validator name=addDeviceValidation _v-0d4de43f=\"\"><div class=col-md-8 _v-0d4de43f=\"\"><label _v-0d4de43f=\"\">Installer Email</label><input type=email id=installer v-model=newDevice.email disabled=disabled class=form-control _v-0d4de43f=\"\"><span v-show=\"$addDeviceValidation.installer.invalid &amp;&amp; $addDeviceValidation.installer.modified\" class=error _v-0d4de43f=\"\">Invalid email</span></div><div class=col-md-8 _v-0d4de43f=\"\"><label _v-0d4de43f=\"\">Association Code</label><input type=text id=assCode v-model=newDevice.code v-validate:asscode=\"['assocCode']\" maxlength=6 class=form-control _v-0d4de43f=\"\"><span v-show=\"$addDeviceValidation.asscode.invalid &amp;&amp; $addDeviceValidation.asscode.modified\" class=error _v-0d4de43f=\"\">Six numbers needed</span></div></validator></div></modal><modal v-bind:show.sync=showChangePiNicknameModal title=\"Change name\" effect=fade ok-text=Apply cancel-text=Cancel v-bind:callback=handleChangePiNickName backdrop=false class=pi_chg_name _v-0d4de43f=\"\"><div slot=modal-body class=\"modal-body clearfix\" _v-0d4de43f=\"\"><div class=col-xs-12 _v-0d4de43f=\"\"><label _v-0d4de43f=\"\">Device Name:</label></div><div class=\"col-xs-12 col-md-12\" _v-0d4de43f=\"\"><span _v-0d4de43f=\"\"><validator name=deviceNameValidator _v-0d4de43f=\"\"><input v-model=newNickname maxlength=12 v-validate:devicename=\"['deviceValid']\" class=\"input form-control\" _v-0d4de43f=\"\"></validator><span v-show=\"$deviceNameValidator.devicename.invalid &amp;&amp; $deviceNameValidator.devicename.modified\" class=error _v-0d4de43f=\"\">Only English characters, numbers ,'-' and '_' allowed</span></span></div></div></modal>";

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

	module.exports = " <ul class=\"nav nav-{{navStyle}}\" role=tablist _v-0faa8558=\"\"> <template v-for=\"t in headers\"> <li v-if=!t._tabgroup :class=\"{active:t.active, disabled:t.disabled}\" @click.prevent=select(t) _v-0faa8558=\"\"> <a href=# _v-0faa8558=\"\"><slot name=header _v-0faa8558=\"\">{{{t.header}}}</slot></a> </li> </template> </ul> <div class=tab-content v-el:tab-content=\"\" _v-0faa8558=\"\"> <slot _v-0faa8558=\"\"></slot> </div> ";

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

	module.exports = "<div class=row _v-10fabf62=\"\"><div class=col-xs-12 _v-10fabf62=\"\"><fieldset _v-10fabf62=\"\"><legend _v-10fabf62=\"\">dxSendIRCommand</legend><span _v-10fabf62=\"\">signal</span><input type=text v-model=command _v-10fabf62=\"\"><button @click=dxSendIRCommand _v-10fabf62=\"\">dxSendIRCommand</button></fieldset></div><div class=row _v-10fabf62=\"\"><div class=col-xs-12 _v-10fabf62=\"\"><fieldset _v-10fabf62=\"\"><legend _v-10fabf62=\"\">dxSendIRSignal</legend><span _v-10fabf62=\"\">signal</span><input type=text v-model=hexValue _v-10fabf62=\"\"><button @click=dxSendIRSignal() _v-10fabf62=\"\">dxSendIRSignal</button></fieldset></div></div><div class=row _v-10fabf62=\"\"><div class=\"col-xs-offset-4 col-xs-6\" _v-10fabf62=\"\"><button @click=up class=\"btn btn-info\" _v-10fabf62=\"\">Up</button></div><div class=\"col-xs-offset-2 col-xs-1\" _v-10fabf62=\"\"><button @click=left class=\"btn btn-info\" _v-10fabf62=\"\">Left</button></div><div class=\"col-xs-offset-1 col-xs-2\" _v-10fabf62=\"\"><button @click=select class=\"btn btn-primary\" _v-10fabf62=\"\">Select</button></div><div class=col-xs-4 _v-10fabf62=\"\"><button @click=right class=\"btn btn-primary btn-info\" _v-10fabf62=\"\">Right</button></div><div class=\"col-xs-offset-4 col-xs-6\" _v-10fabf62=\"\"><button @click=down class=\"btn btn-info\" _v-10fabf62=\"\">Down</button></div><div class=\"col-xs-offset-2 col-xs-4\" _v-10fabf62=\"\"><button @click=menu class=btn _v-10fabf62=\"\">Menu</button></div><div class=col-xs-6 _v-10fabf62=\"\"><button @click=play class=\"btn btn-primary\" _v-10fabf62=\"\">Play</button></div></div></div>";

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

	module.exports = " <div class=cov-vue-date _v-18676b36=\"\"> <div class=datepickbox _v-18676b36=\"\"> <input type=text title=\"input date\" :class=option.inputClass readonly=readonly :placeholder=option.placeholder v-model=time :required=required @click=showCheck @foucus=showCheck :style=option.inputStyle _v-18676b36=\"\"> </div> <div class=datepicker-overlay v-if=showInfo.check @click=dismiss($event) v-bind:style=\"{'background' : option.overlayOpacity? 'rgba(0,0,0,'+option.overlayOpacity+')' : 'rgba(0,0,0,0.5)'}\" _v-18676b36=\"\"> <div class=cov-date-body :style=\"{'background-color': option.color ? option.color.header : '#3f51b5'}\" _v-18676b36=\"\"> <div class=cov-date-monthly _v-18676b36=\"\"> <div class=cov-date-previous @click=\"nextMonth('pre')\" _v-18676b36=\"\">«</div> <div class=cov-date-caption :style=\"{'color': option.color ? option.color.headerText : '#fff'}\" _v-18676b36=\"\"> <span @click=showYear _v-18676b36=\"\"><small _v-18676b36=\"\">{{checked.year}}</small></span> <br _v-18676b36=\"\"> <span @click=showMonth _v-18676b36=\"\">{{displayInfo.month}}</span> </div> <div class=cov-date-next @click=\"nextMonth('next')\" _v-18676b36=\"\">»</div> </div> <div class=cov-date-box v-if=showInfo.day _v-18676b36=\"\"> <div class=cov-picker-box _v-18676b36=\"\"> <div class=week _v-18676b36=\"\"> <ul _v-18676b36=\"\"> <li v-for=\"weekie in library.week\" _v-18676b36=\"\">{{weekie}}</li> </ul> </div> <div class=day v-for=\"day in dayList\" track-by=$index @click=checkDay(day) :class=\"{'checked':day.checked,'unavailable':day.unavailable,'passive-day': !(day.inMonth)}\" :style=\"day.checked ? (option.color &amp;&amp; option.color.checkedDay ? { background: option.color.checkedDay } : { background: '#F50057' }) : {}\" _v-18676b36=\"\">{{day.value}}</div> </div> </div> <div class=\"cov-date-box list-box\" v-if=showInfo.year _v-18676b36=\"\"> <div class=\"cov-picker-box date-list\" id=yearList _v-18676b36=\"\"> <div class=date-item v-for=\"yearItem in library.year\" track-by=$index @click=setYear(yearItem) _v-18676b36=\"\">{{yearItem}}</div> </div> </div> <div class=\"cov-date-box list-box\" v-if=showInfo.month _v-18676b36=\"\"> <div class=\"cov-picker-box date-list\" _v-18676b36=\"\"> <div class=date-item v-for=\"monthItem in library.month\" track-by=$index @click=setMonth(monthItem) _v-18676b36=\"\">{{monthItem}}</div> </div> </div> <div class=\"cov-date-box list-box\" v-if=showInfo.hour _v-18676b36=\"\"> <div class=\"cov-picker-box date-list\" _v-18676b36=\"\"> <div class=watch-box _v-18676b36=\"\"> <div class=hour-box _v-18676b36=\"\"> <div class=\"mui-pciker-rule mui-pciker-rule-ft\" _v-18676b36=\"\"></div> <ul _v-18676b36=\"\"> <li class=hour-item v-for=\"hitem in hours\" @click=\"setTime('hour', hitem, hours)\" :class=\"{'active':hitem.checked}\" _v-18676b36=\"\">{{hitem.value}}</li> </ul> </div> <div class=min-box _v-18676b36=\"\"> <div class=\"mui-pciker-rule mui-pciker-rule-ft\" _v-18676b36=\"\"></div> <div class=min-item v-for=\"mitem in mins\" @click=\"setTime('min',mitem, mins)\" :class=\"{'active':mitem.checked}\" _v-18676b36=\"\">{{mitem.value}}</div> </div> </div> </div> </div> <div class=button-box _v-18676b36=\"\"> <span @click=\"showInfo.check=false\" _v-18676b36=\"\">{{option.buttons? option.buttons.cancel : 'Cancel' }}</span> <span @click=picked _v-18676b36=\"\">{{option.buttons? option.buttons.ok : 'Ok'}}</span> </div> </div> </div> </div> ";

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

	module.exports = "<div class=load_wrap _v-1fbb1c8c=\"\"><div v-if=\"aniKey === '6'\" class=load-6 _v-1fbb1c8c=\"\"><div class=letter-holder _v-1fbb1c8c=\"\"><div class=\"l-1 letter\" _v-1fbb1c8c=\"\">L</div><div class=\"l-2 letter\" _v-1fbb1c8c=\"\">o</div><div class=\"l-3 letter\" _v-1fbb1c8c=\"\">a</div><div class=\"l-4 letter\" _v-1fbb1c8c=\"\">d</div><div class=\"l-5 letter\" _v-1fbb1c8c=\"\">i</div><div class=\"l-6 letter\" _v-1fbb1c8c=\"\">n</div><div class=\"l-7 letter\" _v-1fbb1c8c=\"\">g</div><div class=\"l-8 letter\" _v-1fbb1c8c=\"\">.</div><div class=\"l-9 letter\" _v-1fbb1c8c=\"\">.</div><div class=\"l-10 letter\" _v-1fbb1c8c=\"\">.</div></div></div></div>";

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-259bd109=\"\"><div class=row _v-259bd109=\"\"><div class=\"schedule_main col-md-12\" _v-259bd109=\"\"><header class=\"schedule_titile_bar main_title_bar clearfix\" _v-259bd109=\"\"><h1 class=\"title col-md-12 col-sm-10 col-xs-12\" _v-259bd109=\"\">schedule</h1></header><section class=\"schedule_content clearfix\" _v-259bd109=\"\"><table class=\"table table-bordered schedule_table hidden-md hidden-lg\" _v-259bd109=\"\"><tbody _v-259bd109=\"\"><tr _v-259bd109=\"\"><th _v-259bd109=\"\">No.</th><th _v-259bd109=\"\">Name</th><th _v-259bd109=\"\"></th></tr><tr v-for=\"(key ,schedule) in schedules\" _v-259bd109=\"\"><td _v-259bd109=\"\">{{ key }}</td><td _v-259bd109=\"\">{{ schedule.name }}</td><td _v-259bd109=\"\"><span v-on:click=toShowModal(key) _v-259bd109=\"\"><i class=\"fa fa-edit\" _v-259bd109=\"\"></i></span></td></tr></tbody></table><table class=\"table table-bordered table-striped table-hover schedule_table hidden-sm hidden-xs\" _v-259bd109=\"\"><tbody _v-259bd109=\"\"><tr _v-259bd109=\"\"><th _v-259bd109=\"\">Enabled</th><th _v-259bd109=\"\">No.</th><th _v-259bd109=\"\">Name</th><th _v-259bd109=\"\">Action</th><th _v-259bd109=\"\">Digital Output</th><th _v-259bd109=\"\">Time</th><th _v-259bd109=\"\">Days</th><th _v-259bd109=\"\"></th></tr><tr v-for=\"(key, schedule) in schedules\" _v-259bd109=\"\"><td _v-259bd109=\"\"><i v-if=schedule.enabled v-on:click=\"setSchedule(false, key)\" class=\"fa fa-check-square fa-lg\" _v-259bd109=\"\"></i><i v-else=v-else v-on:click=\"setSchedule(true, key)\" class=\"fa fa-square-o fa-lg\" _v-259bd109=\"\"></i></td><td _v-259bd109=\"\">{{ key }}</td><td _v-259bd109=\"\">{{ schedule.name }}</td><td _v-259bd109=\"\">{{ actionTranslator(schedule.action) }}</td><td class=\"targets no_pad\" _v-259bd109=\"\"><div v-for=\"(key, target) in schedule.targets\" _v-259bd109=\"\"><span v-bind:data-target=target class=clearfix _v-259bd109=\"\">[DO{{target}}] {{DOs[target].name}}</span></div></td><td _v-259bd109=\"\">{{ schedule.time.hours.toString().length === 1 ? '0' + schedule.time.hours : schedule.time.hours }}:{{schedule.time.minutes.toString().length === 1 ? '0'+schedule.time.minutes : schedule.time.minutes }}</td><td class=weekDay _v-259bd109=\"\"><span v-for=\"(key,day) in weekDay\" v-bind:class=\"{enabled:schedule.time.days.indexOf(day) !== -1}\" class=day _v-259bd109=\"\">{{ day }}</span></td><td _v-259bd109=\"\"><span v-on:click=toShowModal(key) _v-259bd109=\"\"><i class=\"fa fa-edit fa-lg\" _v-259bd109=\"\"></i></span></td></tr></tbody></table></section></div></div></div><modal v-bind:show.sync=showModal v-bind:title=editing.title effect=zoom v-bind:callback=handleScheduleConfig ok-text=Apply cancel-text=Cancel class=\"popout schedule_config\" _v-259bd109=\"\"><div slot=modal-body class=modal-body _v-259bd109=\"\"><table class=\"table table-bordered schedule_config_table\" _v-259bd109=\"\"><tbody _v-259bd109=\"\"><tr _v-259bd109=\"\"><th _v-259bd109=\"\">Enabled</th><td class=enabled _v-259bd109=\"\"><input type=checkbox v-model=editing.schedule.enabled id=schedule{{editing.schedule.no}} _v-259bd109=\"\"><label for=schedule{{editing.schedule.no}} _v-259bd109=\"\"><i v-show=editing.schedule.enabled class=\"fa fa-check-square fa-lg\" _v-259bd109=\"\"></i><i v-else=v-else class=\"fa fa-square-o fa-lg\" _v-259bd109=\"\"></i>Enabled</label></td></tr><tr _v-259bd109=\"\"><th _v-259bd109=\"\">Name</th><td _v-259bd109=\"\"><validator name=scheName _v-259bd109=\"\"><input type=text v-model=new_schedule_name v-bind:value=editing.schedule.name maxlength=7 v-validate:name=\"['engAndNum']\" class=form-control _v-259bd109=\"\"><span v-show=\"$scheName.name.invalid &amp;&amp; $scheName.name.modified\" class=error _v-259bd109=\"\">English Charactor ,numbers and '_' only</span></validator></td></tr><tr _v-259bd109=\"\"><th _v-259bd109=\"\">Digital Output</th><td class=\"banks col-xs-10\" _v-259bd109=\"\"><v-multi-banks v-bind:name-prop=target v-bind:options.sync=targetOptions v-bind:output-ary.sync=editing.newTargets _v-259bd109=\"\"></v-multi-banks></td></tr><tr _v-259bd109=\"\"><th _v-259bd109=\"\">Action</th><td _v-259bd109=\"\"><v-select v-bind:options.sync=actionOptions v-bind:value.sync=editing.schedule.action _v-259bd109=\"\"></v-select></td></tr><tr _v-259bd109=\"\"><th _v-259bd109=\"\">Days</th><td class=weekDay _v-259bd109=\"\"><span v-for=\"(key,day) in weekDay\" class=clearfix _v-259bd109=\"\"><input type=checkbox value={{day}} v-bind:checked=\"editing.schedule.time.days.indexOf(day) !== -1\" id={{day}}{{key}} v-model=editing.newDays class=weekDay_checkbox _v-259bd109=\"\"><label for={{day}}{{key}} class=weekDay_label _v-259bd109=\"\">{{ day }}</label></span></td></tr><tr _v-259bd109=\"\"><th _v-259bd109=\"\">Time</th><td class=\"time col-xs-10\" _v-259bd109=\"\"><input type=number max=23 min=0 v-model=editing.schedule.time.hours class=form-control-inline _v-259bd109=\"\"><span _v-259bd109=\"\">&nbsp;:&nbsp;</span><input type=number max=59 min=0 v-model=editing.schedule.time.minutes class=form-control-inline _v-259bd109=\"\"></td></tr></tbody></table></div></modal>";

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-2bca76c9=\"\"><div class=row _v-2bca76c9=\"\"><div class=\"status_main col-md-12\" _v-2bca76c9=\"\"><header class=\"status_title_bar main_title_bar clearfix\" _v-2bca76c9=\"\"><h1 class=\"title col-md-12 col-sm-10 col-xs-12\" _v-2bca76c9=\"\">status<span class=\"deviceTime col-md-3 pull-right no_pad\" _v-2bca76c9=\"\">{{deviceTime}}</span></h1></header><section class=\"status_content col-lg-12 col-md-12 col-sm-12 col-xs-12 no_pad\" _v-2bca76c9=\"\"><header class=\"status_header clearfix\" _v-2bca76c9=\"\"><h2 class=\"title_bar col-lg-5 col-md-5 col-sm-7 clearfix\" _v-2bca76c9=\"\">input</h2><div class=\"pc_input_funtions function_group col-lg-4 col-md-4 col-sm-4 visible-sm visible-md visible-lg no_pad\" _v-2bca76c9=\"\"><div class=\"function__single col-xs-6\" _v-2bca76c9=\"\"><button v-bind:class=\"{'btn-success':input.enabled, 'btn-danger': !input.enabled}\" v-on:click=\"switchEnable('0')\" class=\"btn col-xs-12 btn-default\" _v-2bca76c9=\"\"><i class=\"fa fa-power-off\" _v-2bca76c9=\"\"></i>{{ input.enabled ? 'ON' : 'OFF' }}</button></div><div class=\"function__single col-xs-6\" _v-2bca76c9=\"\"><button v-on:click=\"toReset('0')\" v-bind:disabled=!input.enabled class=\"btn btn-default col-xs-12\" _v-2bca76c9=\"\"><i class=\"fa fa-refresh\" _v-2bca76c9=\"\"></i>Reset</button></div></div></header><section class=\"input_group col-lg-9 col-md-11 col-sm-11 col-xs-12 col-centered clearfix\" _v-2bca76c9=\"\"><div class=\"input__inner clearfix col-lg-9 col-md-11 no_pad col-centered\" _v-2bca76c9=\"\"><div class=\"voltage input__single col-lg-4 col-md-4 col-sm-4 col-xs-12\" _v-2bca76c9=\"\"><h3 class=\"input_name col-lg-12 col-sm-12 col-xs-4\" _v-2bca76c9=\"\">Voltage</h3><span class=\"bolder col-lg-12 col-xs-8 no_pad\" _v-2bca76c9=\"\">{{ input.voltage ? input.voltage : 0}}V</span></div><div class=\"current input__single col-lg-4 col-md-4 col-sm-4 col-xs-12\" _v-2bca76c9=\"\"><h3 class=\"input_name col-lg-12 col-md-12 col-sm-12 col-xs-4 no_pad\" _v-2bca76c9=\"\">Current</h3><span class=\"col-lg-12 col-md-12 col-sm-6 col-xs-8 no_pad bolder\" _v-2bca76c9=\"\">{{ input.current ? input.current : 0 }}A</span></div><div class=\"power_consumption input__single col-lg-4 col-md-4 col-sm-4 col-xs-12\" _v-2bca76c9=\"\"><h3 class=\"input_name col-lg-12 col-md-12 col-sm-12 col-xs-4 no_pad\" _v-2bca76c9=\"\">Power</h3><span class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 no_pad bolder\" _v-2bca76c9=\"\">{{inputPowerString}}</span></div><div class=\"input_functions function_group col-xs-12 no_pad visible-xs\" _v-2bca76c9=\"\"><div class=\"function__single col-xs-6\" _v-2bca76c9=\"\"><button v-bind:class=\"{'btn-success':input.enabled, 'btn-danger': !input.enabled}\" v-on:click=\"switchEnable('0')\" class=\"btn col-xs-12 btn-default\" _v-2bca76c9=\"\"><i class=\"fa fa-power-off\" _v-2bca76c9=\"\"></i>{{ input.enabled ? 'ON' : 'OFF' }}</button></div><div class=\"function__single col-xs-6\" _v-2bca76c9=\"\"><button v-on:click=\"toReset('0')\" v-bind:disabled=!input.enabled class=\"btn btn-default col-xs-12\" _v-2bca76c9=\"\"><i class=\"fa fa-refresh\" _v-2bca76c9=\"\"></i>Reset</button></div></div></div></section><header class=\"outlet_header clearfix\" _v-2bca76c9=\"\"><h2 class=\"title_bar col-sm-7 col-lg-7 clearfix\" _v-2bca76c9=\"\">Output</h2><div class=\"col-lg-2 col-sm-3 hidden-xs\" _v-2bca76c9=\"\"><button v-on:click=toResetAll class=\"btn btn-default col-xs-12\" _v-2bca76c9=\"\">Reset All Outlets</button></div></header><section class=\"outlet_group col-lg-9 col-md-11 col-sm-11 col-xs-12 col-centered clearfix\" _v-2bca76c9=\"\"><div class=\"outlet__inner col-lg-9 col-md-11 no_pad col-centered\" _v-2bca76c9=\"\"><div v-for=\"(bankKey,bank) in banks\" class=\"bank outlet__single clearfix\" _v-2bca76c9=\"\"><div class=title _v-2bca76c9=\"\"><span _v-2bca76c9=\"\">Outlet{{ bankKey }}</span></div><div class=\"function_group col-sm-2 col-md-2 col-lg-2 hidden-xs\" _v-2bca76c9=\"\"><div class=col-xs-12 _v-2bca76c9=\"\"><button v-bind:class=\"{'btn-success':bank.enabled,'btn-danger': !bank.enabled}\" v-on:click=switchEnable(bankKey) v-bind:disabled=bank.locked class=\"btn btn-default col-xs-12\" _v-2bca76c9=\"\"><i class=\"fa fa-power-off\" _v-2bca76c9=\"\"></i>{{ bank.enabled ? 'ON' : 'OFF' }}</button></div><div class=col-xs-12 _v-2bca76c9=\"\"><button v-on:click=toReset(bankKey) v-bind:disabled=!bank.enabled class=\"btn btn-default col-xs-12\" _v-2bca76c9=\"\"><i class=\"fa fa-refresh\" _v-2bca76c9=\"\"></i>Reset</button></div></div><div class=\"info col-lg-4 col-md-5 col-sm-5 clearfix\" _v-2bca76c9=\"\"><div class=\"current clearfix\" _v-2bca76c9=\"\"><h3 class=\"col-lg-4 col-sm-4 col-xs-4\" _v-2bca76c9=\"\">Current</h3><h3 class=\"col-lg-offset-1 col-lg-6 col-sm-3 col-xs-6 bolder no_pad\" _v-2bca76c9=\"\">{{ input.enabled &amp;&amp; bank.enabled ? bank.current : '0' }}A</h3></div><div class=\"power_consumption clearfix\" _v-2bca76c9=\"\"><h3 class=\"col-lg-4 col-sm-4 col-xs-4\" _v-2bca76c9=\"\">Power</h3><h3 class=\"col-lg-offset-1 col-lg-6 col-md-2 col-sm-5 col-xs-6 bolder no_pad\" _v-2bca76c9=\"\">{{ input.enabled &amp;&amp; bank.enabled ? bank.power : '0' }}W</h3></div></div><div class=\"function_group col-xs-12 visible-xs\" _v-2bca76c9=\"\"><div class=col-xs-6 _v-2bca76c9=\"\"><button v-bind:class=\"{'btn-success':bank.enabled,'btn-danger': !bank.enabled}\" v-bind:disabled=bank.locked v-on:click=switchEnable(bankKey) class=\"btn btn-default col-xs-12\" _v-2bca76c9=\"\"><i class=\"fa fa-power-off\" _v-2bca76c9=\"\"></i>{{ bank.enabled ? 'ON' : 'OFF' }}</button></div><div class=col-xs-6 _v-2bca76c9=\"\"><button v-on:click=toReset(bankKey) v-bind:disabled=!bank.enabled class=\"btn btn-default col-xs-12\" _v-2bca76c9=\"\"><i class=\"fa fa-refresh\" _v-2bca76c9=\"\"></i>Reset</button></div></div><div class=\"outlet_group col-xs-12 visible-xs\" _v-2bca76c9=\"\"><div v-on:click=\"handleOutletConfig(bankKey, bank)\" class=edit _v-2bca76c9=\"\"><i class=\"fa fa-pencil\" _v-2bca76c9=\"\"></i></div><div v-for=\"(outletKey,outlet) in bank.outlets\" class=\"outlet__single col-xs-12 clearfix\" _v-2bca76c9=\"\"><div class=outlet_num _v-2bca76c9=\"\">{{ bankKey }}</div><div class=outlet_name _v-2bca76c9=\"\">{{ outlet.name }}</div><div v-bind:class={enabled:bank.enabled} class=outlet_btn _v-2bca76c9=\"\"><button v-if=\"bank.locked &amp;&amp; bank.enabled\" class=\"btn locked_outlet\" _v-2bca76c9=\"\"><i class=\"fa fa-lock\" _v-2bca76c9=\"\"></i></button><button v-else=!bank.enabled class=\"btn outlet__btn__inner\" _v-2bca76c9=\"\"></button></div></div></div><div v-on:click=handleOutletConfig(bankKey,bank) class=\"outlet_group hidden-xs\" _v-2bca76c9=\"\"><div v-for=\"(outletKey,outlet) in bank.outlets\" class=\"outlet__single clearfix\" _v-2bca76c9=\"\"><div class=\"outlet_single_header col-sm-12\" _v-2bca76c9=\"\">{{ outlet.name }}<div v-on:click=\"handleOutletConfig(bankKey, bank)\" class=edit _v-2bca76c9=\"\"><i class=\"fa fa-pencil\" _v-2bca76c9=\"\"></i></div></div><div class=\"outlet_body clearfix\" _v-2bca76c9=\"\"><div v-bind:class={enabled:bank.enabled} class=outlet_btn _v-2bca76c9=\"\"><button v-if=\"bank.locked &amp;&amp; bank.enabled\" class=\"btn locked_outlet\" _v-2bca76c9=\"\"><i class=\"fa fa-lock\" _v-2bca76c9=\"\"></i></button><button v-else=!bank.enabled class=\"btn outlet__btn__inner\" _v-2bca76c9=\"\"></button></div></div></div></div></div></div></section><div class=\"col-xs-12 row_space--xs visible-xs\" _v-2bca76c9=\"\"><button v-on:click=toResetAll class=\"btn btn-default col-xs-12\" _v-2bca76c9=\"\">Reset All Outlets</button></div></section></div></div></div><modal v-bind:title.sync=editing.title v-bind:show.sync=showConfig effect=zoom v-bind:callback=handleOutletApply ok-text=Apply cancel-text=Cancel class=bank_config _v-2bca76c9=\"\"><div slot=modal-body class=\"modal-body clearfix\" _v-2bca76c9=\"\"><div v-for=\"(key,o) in editing.outlets\" class=\"outlet input__single col-xs-12\" _v-2bca76c9=\"\"><label _v-2bca76c9=\"\">Name</label><input type=text v-model=o.name maxlength=7 class=form-control _v-2bca76c9=\"\"><span v-show=outletNameValid[editing._id][key].invalid class=error _v-2bca76c9=\"\">English characters , numbers and '_' only</span></div></div></modal>";

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-2dfbd8e6=\"\"><div class=row _v-2dfbd8e6=\"\"><div class=\"mapping_main col-md-12 clearfix\" _v-2dfbd8e6=\"\"><header class=\"mapping_title_bar main_title_bar clearfix\" _v-2dfbd8e6=\"\"><h1 class=\"title col-md-10 col-sm-10 col-xs-12 hidden-xs\" _v-2dfbd8e6=\"\">mapping</h1><h1 v-if=isSwitcher class=\"title col-md-10 col-sm-10 col-xs-12 visible-xs\" _v-2dfbd8e6=\"\">mapping</h1><h1 v-else=v-else v-on:click=\"isSingleMapping = !isSingleMapping\" class=\"title col-md-10 col-sm-10 col-xs-12 visible-xs\" _v-2dfbd8e6=\"\">mapping<span v-bind:class=\"isSingleMapping ? 'fa-list' : 'fa-th-large'\" class=\"pull-right fa\" _v-2dfbd8e6=\"\"></span></h1></header><section v-show=isSingleMapping v-bind:class=\"{'list_mode':isSingleMapping}\" class=\"mapping_content_list clearfix col_space--xs\" _v-2dfbd8e6=\"\"><header class=\"output_header clearfix\" _v-2dfbd8e6=\"\"><h2 class=\"output_title_bar title_bar clearfix col-md-8 col-xs-2\" _v-2dfbd8e6=\"\">Output</h2><div v-if=!isSwitcher class=\"profile_function_group col-md-4 col-md-offset-0 col-xs-8 col-xs-offset-2 clearfix\" _v-2dfbd8e6=\"\"><div class=\"function__single load col-xs-6\" _v-2dfbd8e6=\"\"><dropdown _v-2dfbd8e6=\"\"><button slot=button class=\"btn btn-primary base_white\" _v-2dfbd8e6=\"\">load<i class=\"fa fa-angle-down\" _v-2dfbd8e6=\"\"></i></button><ul slot=dropdown-menu class=dropdown-menu _v-2dfbd8e6=\"\"><li v-for=\"($index,profile) in profiles\" _v-2dfbd8e6=\"\"><a v-on:click=loadProfileFrom($index) _v-2dfbd8e6=\"\">{{profile.label}}</a></li></ul></dropdown></div><div class=\"function__single save col-xs-6\" _v-2dfbd8e6=\"\"><dropdown _v-2dfbd8e6=\"\"><button slot=button class=\"btn btn-primary base_white\" _v-2dfbd8e6=\"\">save as<i class=\"fa fa-angle-up\" _v-2dfbd8e6=\"\"></i></button><ul slot=dropdown-menu class=dropdown-menu _v-2dfbd8e6=\"\"><li v-for=\"($index,profile) in profiles\" _v-2dfbd8e6=\"\"><a v-on:click=saveCurProfileTo($index) _v-2dfbd8e6=\"\">{{profile.label}}</a></li></ul></dropdown></div></div></header><section class=\"list_group row_space--xs clearfix\" _v-2dfbd8e6=\"\"><div v-for=\"(output, input) in mapping\" v-bind:class=\"{'clear-left': output == 0}\" v-show=\"output !== 'all' \" class=\"col-lg-6 col-md-6 col-sm-3 col-xs-6 form-horizontal\" _v-2dfbd8e6=\"\"><div class=form-group _v-2dfbd8e6=\"\"><label class=\"input_name control-label\" _v-2dfbd8e6=\"\">{{ output }}. {{ outputCards[output].name }}</label><select v-model=input v-on:change=\"updateList(output, input)\" class=form-control _v-2dfbd8e6=\"\"><option v-for=\"( v_out , v_in  ) in mapping\" v-bind:value=v_out _v-2dfbd8e6=\"\">{{inputCards[v_out].name}} ({{v_out}})</option><option value=0 _v-2dfbd8e6=\"\">Mute</option></select></div></div></section></section><section class=\"mapping_content clearfix col_space--xs\" _v-2dfbd8e6=\"\"><header class=\"output_header clearfix\" _v-2dfbd8e6=\"\"><h2 v-bind:class=\"{'col-xs-2': isSwitcher &amp;&amp; !isSW5005DE, 'col-xs-12': isSW5005DE}\" class=\"output_title_bar title_bar clearfix col-md-8\" _v-2dfbd8e6=\"\">Output<span v-if=\"isSW5005DE &amp;&amp; switcherLayout !== '0'\" class=smaller _v-2dfbd8e6=\"\">Only full screen mode can switch input</span></h2><div v-if=!isSwitcher class=\"profile_function_group col-md-4 col-md-offset-0 col-xs-8 col-xs-offset-2 clearfix\" _v-2dfbd8e6=\"\"><div class=\"function__single load col-xs-6\" _v-2dfbd8e6=\"\"><dropdown _v-2dfbd8e6=\"\"><button slot=button data-toggle=dropdown class=\"btn btn-primary base_white\" _v-2dfbd8e6=\"\">load<i class=\"fa fa-angle-down\" _v-2dfbd8e6=\"\"></i></button><ul slot=dropdown-menu class=dropdown-menu _v-2dfbd8e6=\"\"><li v-for=\"($index,profile) in profiles\" _v-2dfbd8e6=\"\"><a v-on:click=loadProfileFrom($index) _v-2dfbd8e6=\"\">{{profile.label}}</a></li></ul></dropdown></div><div class=\"function__single save col-xs-6\" _v-2dfbd8e6=\"\"><dropdown _v-2dfbd8e6=\"\"><button slot=button data-toggle=dropdown class=\"btn btn-primary base_white\" _v-2dfbd8e6=\"\">save as<i class=\"fa fa-angle-up\" _v-2dfbd8e6=\"\"></i></button><ul slot=dropdown-menu class=dropdown-menu _v-2dfbd8e6=\"\"><li v-for=\"($index,profile) in profiles\" _v-2dfbd8e6=\"\"><a v-on:click=saveCurProfileTo($index) _v-2dfbd8e6=\"\">{{profile.label}}</a></li></ul></dropdown></div></div></header><section class=\"output_card_group card_group clearfix\" _v-2dfbd8e6=\"\"><div class=\"card__group__inner clearfix hidden-xs\" _v-2dfbd8e6=\"\"><template v-for=\"(outIndex, card) in outputCards\" v-ref:desktop-output-card=v-ref:desktop-output-card><card v-if=\"card._id > -1\" card-type=output @detail=handleCardDetail @focus=desktopOutputFocus v-bind:is-favorite=\"favoritePort == outIndex\" v-bind:output-data.sync=card v-bind:input-data=inputCards[mapping[outIndex]] v-on:drop.prevent=\"handleDrop($event, outIndex, false, '-1')\" v-on:dragover.prevent=handleOver($event) v-bind:class=\"{outAll:outIndex === '0'}\" v-on:dragstart=\"handleDragStart($event, outIndex, false)\" v-bind:is-installer=user.installer v-bind:output-focus=desktop.outputFocus v-bind:highlight-input-id=\"desktop.inputFocus == mapping[outIndex] &amp;&amp; card.name != 'all' || isLayoutSwitcher &amp;&amp; switcherLayout === '0'\" class=\"col-xs-12 output__card__single slide__single clearfix\" _v-2dfbd8e6=\"\"></card><layout-card v-if=\"card._id === -1\" card-type=function v-bind:is-switcher=true v-bind:switcher-layout=1 v-bind:class=\"{highlight: isLayoutSwitcher &amp;&amp; switcherLayout === '1'}\" v-bind:layout-img-src=\"isSW5005DE ? iconsSW5005DE.quick[0] : icons.quick[0]\" v-on:drop.prevent=\"handleDrop($event, '1', true, '1')\" v-on:dragover.prevent=handleOver($event) v-on:click=\"setSwitcherLayout('1')\" class=\"output__card__single slide__single clearfix cursor_pointer\" _v-2dfbd8e6=\"\"></layout-card><layout-card v-if=\"card._id === -2\" card-type=function v-bind:is-switcher=true v-bind:switcher-layout=2 v-bind:class=\"{highlight: isLayoutSwitcher &amp;&amp; switcherLayout === '2'}\" v-bind:layout-img-src=\"isSW5005DE ? iconsSW5005DE.quick[1] : icons.quick[1]\" v-on:drop.prevent=\"handleDrop($event, '1', true, '2')\" v-on:dragover.prevent=handleOver($event) v-on:click=\"setSwitcherLayout('2')\" class=\"output__card__single slide__single clearfix cursor_pointer\" _v-2dfbd8e6=\"\"></layout-card><layout-card v-if=\"card._id === -3\" card-type=function v-bind:is-switcher=true v-bind:switcher-layout=3 v-bind:class=\"{highlight: isLayoutSwitcher &amp;&amp; switcherLayout === '3'}\" v-bind:layout-img-src=\"isSW5005DE ? iconsSW5005DE.quick[2] : icons.quick[2]\" v-on:drop.prevent=\"handleDrop($event, '1', true, '3')\" v-on:dragover.prevent=handleOver($event) v-on:click=\"setSwitcherLayout('3')\" class=\"output__card__single slide__single clearfix cursor_pointer\" _v-2dfbd8e6=\"\"></layout-card></template></div><div class=\"card__group__inner clearfix hidden-sm hidden-md hidden-lg\" _v-2dfbd8e6=\"\"><swiper direction=horizontal v-bind:initial-page=mobile.outputFocus @slide-change-end=onOutSwiperEnd class=no_arrow _v-2dfbd8e6=\"\"><template v-for=\"(outIndex, card) in outputCards\"><card v-if=\"card._id > -1\" card-type=output v-bind:is-favorite=\"favoritePort == outIndex\" @detail=handleCardDetail v-bind:output-data.sync=card v-bind:input-data=inputCards[mapping[outIndex]] v-bind:class=\"{outAll:outIndex === '0'}\" v-bind:is-installer.sync=user.installer v-bind:highlight-input-id=\"isLayoutSwitcher &amp;&amp; switcherLayout === '0'\" class=\"col-xs-12 output__card__single slide__single clearfix\" _v-2dfbd8e6=\"\"></card><layout-card v-if=\"card._id === -1\" v-bind:is-switcher=true v-bind:switcher-layout=1 card-type=function v-bind:class=\"{highlight: isLayoutSwitcher &amp;&amp; switcherLayout === '1'}\" v-bind:layout-img-src=\"isSW5005DE ? iconsSW5005DE.quick[0] : icons.quick[0]\" class=\"output__card__single slide__single clearfix\" _v-2dfbd8e6=\"\"></layout-card><layout-card v-if=\"card._id === -2\" v-bind:is-switcher=true v-bind:switcher-layout=2 card-type=function v-bind:class=\"{highlight: isLayoutSwitcher &amp;&amp; switcherLayout === '2'}\" v-bind:layout-img-src=\"isSW5005DE ? iconsSW5005DE.quick[1] : icons.quick[1]\" class=\"output__card__single slide__single clearfix\" _v-2dfbd8e6=\"\"></layout-card><layout-card v-if=\"card._id === -3\" v-bind:is-switcher=true v-bind:switcher-layout=3 card-type=function v-bind:class=\"{highlight: isLayoutSwitcher &amp;&amp; switcherLayout === '3'}\" v-bind:layout-img-src=\"isSW5005DE ? iconsSW5005DE.quick[2] : icons.quick[2]\" class=\"output__card__single slide__single clearfix\" _v-2dfbd8e6=\"\"></layout-card></template></swiper></div></section><section class=\"map_function clearfix row_space--xs visible-xs\" _v-2dfbd8e6=\"\"><div class=\"mapTo col-sm-7 col-xs-12 col-centered\" _v-2dfbd8e6=\"\"><button v-on:click=mobileUpdateMapping class=\"btn btn-success\" _v-2dfbd8e6=\"\"><i class=\"fa fa-arrow-up\" _v-2dfbd8e6=\"\"></i>&nbsp;To</button></div></section><header class=\"input_header clearfix\" _v-2dfbd8e6=\"\"><h2 class=\"input_title_bar title_bar card_group clearfix\" _v-2dfbd8e6=\"\">Input</h2></header><section class=\"input_card_group card_group clearfix\" _v-2dfbd8e6=\"\"><div class=\"card__group__inner clearfix hidden-lg hidden-md hidden-sm\" _v-2dfbd8e6=\"\"><swiper direction=horizontal v-bind:initial-page=mobile.inputFocus @slide-change-end=onInSwiperEnd v-bind:transitioning.sync=inputTrans class=no_arrow _v-2dfbd8e6=\"\"><card v-for=\"(inIndex,card) in inputCards\" card-type=input @detail=\"handleCardDetail( null, card, false, $event)\" v-bind:class=\"{outMute:card.name === 'mute', 'mobile-highlight': inIndex == mapping[mobile.outputFocus] &amp;&amp; !isLayoutSwitcher}\" v-bind:input-data.sync=card v-bind:input-id=inIndex v-bind:is-installer.sync=user.installer v-bind:input-focus=inIndex class=\"col-xs-12 input__card__single\" _v-2dfbd8e6=\"\"></card></swiper></div><div class=\"card__group__inner clearfix hidden-xs\" _v-2dfbd8e6=\"\"><div class=\"slide_group clearfix\" _v-2dfbd8e6=\"\"><card v-for=\"(inIndex,card) in inputCards\" card-type=input v-ref:desktop-input-card=v-ref:desktop-input-card @focus=desktopInputFocus @detail=\"handleCardDetail(null, card, false)\" v-bind:class=\"{outMute:card.name === 'mute'}\" v-bind:id=card.name v-bind:input-data.sync=card draggable=draggable v-on:dragstart=\"handleDragStart($event, inIndex, true)\" v-bind:is-installer.sync=user.installer v-bind:input-focus=desktop.inputFocus v-bind:highlight-input-id=\"mapping[desktop.outputFocus] == card._id\" class=\"col-xs-12 input__card__single\" _v-2dfbd8e6=\"\"></card></div></div></section></section></div></div><card-modal v-bind:show.sync=showCardDetail v-bind:input-data=editing.inData v-bind:output-data=editing.outData v-bind:hdcp-capability=hdcp v-bind:favorite-port=favoritePort v-bind:is-installer.sync=user.installer v-bind:is-out=editing.isOut _v-2dfbd8e6=\"\"></card-modal><modal title=Confirm v-bind:show.sync=showConfirm effect=zoom v-bind:callback=confirmCb ok-text=Yes cancel-text=Cancel _v-2dfbd8e6=\"\"><div slot=modal-body class=\"modal-body clearfix\" _v-2dfbd8e6=\"\">{{ confirmMsg }}</div></modal></div>";

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

	module.exports = "<button v-on:click=download v-if=!isMobile class=\"btn btn-primary\" _v-2f668e14=\"\">Download</button><a v-el:download-tag=v-el:download-tag v-show=false _v-2f668e14=\"\"></a><div v-el:content=v-el:content _v-2f668e14=\"\"><h2 _v-2f668e14=\"\">EDID HEADER</h2><p v-for=\"(h,k) in headers\" _v-2f668e14=\"\">{{ k }} : {{ result[h] }}</p><h2 _v-2f668e14=\"\">Basic Display Parameters</h2><p _v-2f668e14=\"\">Digital Input: {{ result.bdp.digitalInput }}</p><p _v-2f668e14=\"\">Compatible with VESA DFP: {{ result.bdp.vesaDfpCompatible }}</p><p _v-2f668e14=\"\">Maximum Horizontal Image Size: {{ result.bdp.maxHorImgSize }}</p><p _v-2f668e14=\"\">Maximum Vertical Image Size: {{ result.bdp.maxVertImgSize }}</p><p _v-2f668e14=\"\">Display Gamma: {{ result.bdp.displayGamma.toFixed(2) }}</p><p _v-2f668e14=\"\">DPMS Standby: {{ result.bdp.dpmsStandby }}</p><p _v-2f668e14=\"\">DPMS Suspend: {{ result.bdp.dpmsSuspend }}</p><p _v-2f668e14=\"\">DPMS Active-Off: {{ result.bdp.dpmsActiveOff }}</p><p _v-2f668e14=\"\">Display Type: {{ result.digitalColorSpace[result.bdp.displayType] }}</p><p _v-2f668e14=\"\">Standard sRGB Color Space: {{ result.bdp.standardSRgb }}</p><p _v-2f668e14=\"\">Preferred Timing Mode: {{ result.bdp.preferredTiming }}</p><p _v-2f668e14=\"\">GTF Supported: {{ result.bdp.gtfSupported }}</p><template v-if=result.bdp.digitalInput><h2 _v-2f668e14=\"\">Anolog BDP</h2><p _v-2f668e14=\"\">Digital Input: {{ result.bdp.digitalInput }}</p><p _v-2f668e14=\"\">Video white and sync levels, relative to blank: {{ result.WhiteAndSyncLevels[result.bdp.whiteSyncLevels] }}</p><p _v-2f668e14=\"\">Blank-to-black setup (pedestal) expected: {{ result.bdp.blankToBlack }}</p><p _v-2f668e14=\"\">Separate sync supported: {{ result.bdp.separateSyncSupported }}</p><p _v-2f668e14=\"\">Composite sync (on HSync) supported: {{ result.bdp.compositeSyncSupported }}</p><p _v-2f668e14=\"\">Sync on green supported: {{ result.bdp.synOnGreen }}</p><p _v-2f668e14=\"\">VSync pulse must be serrated: {{ result.bdp.vsyncSerrated }}</p><p _v-2f668e14=\"\">Maximum Horizontal Image Size: {{ result.bdp.maxHorImgSize }}</p><p _v-2f668e14=\"\">Maximum Vertical Image Size: {{ result.bdp.maxVertImgSize }}</p><p _v-2f668e14=\"\">Display Gamma: {{ result.bdp.displayGamma.toFixed(2) }}</p><p _v-2f668e14=\"\">DPMS Standby: {{ result.bdp.dpmsStandby }}</p><p _v-2f668e14=\"\">DPMS Suspend: {{ result.bdp.dpmsSuspend }}</p><p _v-2f668e14=\"\">DPMS Active-Off: {{ result.bdp.dpmsActiveOff }}</p><p _v-2f668e14=\"\">Display Type: {{ result.digitalColorSpace[result.bdp.displayType] }}</p><p _v-2f668e14=\"\">Standard sRGB Color Space: {{ result.bdp.standardSRgb }}</p><p _v-2f668e14=\"\">Preferred Timing Mode: {{ result.bdp.preferredTiming }}</p><p _v-2f668e14=\"\">GTF Supported: {{ result.bdp.gtfSupported }}</p></template><h2 _v-2f668e14=\"\">Chromaticity Coordinates</h2><p _v-2f668e14=\"\">Red X: {{ result.chromaticity.redXCoords.toFixed(3) }}</p><p _v-2f668e14=\"\">Red Y: {{ result.chromaticity.redYCoords.toFixed(3) }}</p><p _v-2f668e14=\"\">Green X: {{ result.chromaticity.greenXCoords.toFixed(3) }}</p><p _v-2f668e14=\"\">Green Y: {{ result.chromaticity.greenYCoords.toFixed(3) }}</p><p _v-2f668e14=\"\">Blue X: {{ result.chromaticity.blueXCoords.toFixed(3) }}</p><p _v-2f668e14=\"\">Blue Y: {{ result.chromaticity.blueYCoords.toFixed(3) }}</p><p _v-2f668e14=\"\">White X: {{ result.chromaticity.whiteXCoords.toFixed(3) }}</p><p _v-2f668e14=\"\">White Y: {{ result.chromaticity.whiteYCoords.toFixed(3) }}</p><h2 _v-2f668e14=\"\">Timing Bitmap</h2><p v-for=\"tb in result.establishedTimingBitmaps\" _v-2f668e14=\"\">{{tb}} : {{ isTimingBitmapSet($index) }}</p><h2 _v-2f668e14=\"\">Standard Display Modes</h2><ul v-for=\"dispMode in result.standardDisplayModes\" _v-2f668e14=\"\"><li _v-2f668e14=\"\">Resolution: {{ dispMode.xResolution }}</li><li _v-2f668e14=\"\">X:Y Pixel Ratio: {{result.xyPixelRatioEnum[dispMode.xyPixelRatio].string}}</li><li _v-2f668e14=\"\">Vertical Frequency: {{dispMode.vertFreq}}</li></ul><h2 _v-2f668e14=\"\">Standard Display Modes</h2><div v-for=\"dtd in result.dtds\" _v-2f668e14=\"\"><ul _v-2f668e14=\"\">Detailed Timing Descriptor {{ $index + 1 }}<li _v-2f668e14=\"\">Pixel Clock: {{dtd.pixelClock}}MHz</li><li _v-2f668e14=\"\">Horizontal Active: {{dtd.horActivePixels}}</li><li _v-2f668e14=\"\">Horizontal Blanking: {{dtd.horBlankPixels}}</li><li _v-2f668e14=\"\">Vertical Active: {{dtd.vertActivePixels}}</li><li _v-2f668e14=\"\">Vertical Blanking: {{dtd.vertBlankPixels}}</li><li _v-2f668e14=\"\">Horizontal Sync Offset: {{dtd.horSyncOff}}</li><li _v-2f668e14=\"\">Horizontal Sync Pulse: {{dtd.horSyncPulse}}</li><li _v-2f668e14=\"\">Vertical Sync Offset: {{dtd.vertSyncOff}}</li><li _v-2f668e14=\"\">Vertical Sync Pulse: {{dtd.vertSyncPulse}}</li><li _v-2f668e14=\"\">Horizontal Display Size: {{dtd.horDisplaySize}}</li><li _v-2f668e14=\"\">Vertical Display Size: {{dtd.vertDisplaySize}}</li><li _v-2f668e14=\"\">Horizontal Border: {{dtd.horBorderPixels}}</li><li _v-2f668e14=\"\">Vertical Border: {{dtd.vertBorderLines}}</li><li _v-2f668e14=\"\">Interlaced: {{dtd.interlaced}}</li><li _v-2f668e14=\"\">Stereo Mode: {{dtd.stereoMode}}</li><li _v-2f668e14=\"\">Sync Type: {{dtd.syncType}}</li><li _v-2f668e14=\"\">Vertical Sync {{ dtd.syncType == result.syncTypeEnum.DIGITAL_SEPARATE ? 'Polarity' : 'Serrated' }}: {{dtd.vSyncPolarity}}</li><li v-show=\"dtd.syncType == result.syncTypeEnum.DIGITAL_SEPARATE\" _v-2f668e14=\"\">Vertical Sync Polarity: {{dtd.vSyncPolarity}}</li><li v-show=\"dtd.syncType == result.syncTypeEnum.DIGITAL_SEPARATE\" _v-2f668e14=\"\">Vertical Sync Polarity: {{dtd.vSyncPolarity}}</li><template v-if=\"(dtd.syncType == result.syncTypeEnum.ANALOG_COMPOSITE) || (dtd.syncType == result.syncTypeEnum.BIPOLAR_ANALOG_COMPOSITE)\"><li _v-2f668e14=\"\">Sync on all 3 RGB lines: {{dtd.syncAllRGBLines}}</li></template><template v-else=v-else><li _v-2f668e14=\"\">HSync polarity: {{dtd.hSyncPolarity}}</li><li _v-2f668e14=\"\">2-Way Line-Interleaved Stereo: {{dtd.twoWayStereo}}</li></template></ul></div><div v-for=\"ext in result.exts\" _v-2f668e14=\"\"><h2 _v-2f668e14=\"\">BLOCK {{ ext.blockNumber }}</h2><h3 _v-2f668e14=\"\">Extension Header Information</h3><p _v-2f668e14=\"\">Valid Checksum: {{validChecksums[ext.blockNumber]}}</p><p _v-2f668e14=\"\">Extension Tag: {{ext.extTag}}</p><p _v-2f668e14=\"\">Revision Number: {{ext.revisionNumber}}</p><p _v-2f668e14=\"\">DTD Start: 0x{{ext.dtdStart.toString(16).toUpperCase()}}</p><p _v-2f668e14=\"\">Number of Native DTDs: {{ext.numDtds}}</p><p _v-2f668e14=\"\">Supports Underscan: {{ ext.underscan }}</p><p _v-2f668e14=\"\">Supports Basic Audio: {{ ext.basicAudio }}</p><p _v-2f668e14=\"\">Supports YcBcR 4:4:4: {{ ext.ycbcr444 }}</p><p _v-2f668e14=\"\">Supports YcBcR 4:2:2: {{ ext.ycbcr422 }}</p><p _v-2f668e14=\"\">Checksum: 0x{{ext.checksum.toString(16).toUpperCase()}}</p><div class=new _v-2f668e14=\"\"><div v-for=\"dbc in ext.dataBlockCollection\" track-by=$index _v-2f668e14=\"\"><p _v-2f668e14=\"\"></p><div v-if=\"dbc.tag.value == 0\" _v-2f668e14=\"\"><h3 _v-2f668e14=\"\">Reserved Data Block</h3><p _v-2f668e14=\"\">Insert Audio Descriptor! <br _v-2f668e14=\"\"></p></div><div v-if=\"dbc.tag.value == 2\" _v-2f668e14=\"\"><h3 _v-2f668e14=\"\">VIDEO</h3><ul v-for=\"svd in dbc.shortVideoDescriptors\" _v-2f668e14=\"\"><li _v-2f668e14=\"\">Native: {{ svd.nativeResolution.toString().toUpperCase() }}</li><li _v-2f668e14=\"\">VIC: {{ result.shortVideoDescriptors[svd.vic].vic }}</li><li _v-2f668e14=\"\">Format: {{ result.shortVideoDescriptors[svd.vic].format }}</li><li _v-2f668e14=\"\">Field Rate: {{ result.shortVideoDescriptors[svd.vic].fieldRate }}</li><li _v-2f668e14=\"\">Picture AR: {{ result.shortVideoDescriptors[svd.vic].pictureAspectRatio }}</li><li _v-2f668e14=\"\">Pixel AR: {{ result.shortVideoDescriptors[svd.vic].pixelAspectRatio }}</li></ul></div><div v-if=\"dbc.tag.value == 1\" _v-2f668e14=\"\"><h3 _v-2f668e14=\"\">AUDIO</h3><ul v-for=\"sad in dbc.shortAudioDescriptors\" _v-2f668e14=\"\"><p _v-2f668e14=\"\">Format Code: {{ result.shortAudioDescriptors[sad.format] }}</p><p _v-2f668e14=\"\">Max Channels: {{ sad.maxChannels }}</p><div _v-2f668e14=\"\"><p _v-2f668e14=\"\">Sample Rates:</p><p v-for=\"sampleRate in result.sadSampleRates\" _v-2f668e14=\"\">{{ sampleRate }} {{ isAudioBitSet(sad.sampleRates ,$index) }}</p></div><div v-if=\"audioType(sad.format) == 'lpcm' \" _v-2f668e14=\"\"><p _v-2f668e14=\"\">Bit Depth:</p><p v-for=\"bitDepth in result.sadBitDepths\" _v-2f668e14=\"\">{{ bitDepth }} {{ isAudioBitSet(sad.bitDepth,$index) }}</p></div><div v-if=\"audioType(sad.format) == 'twoEight' \" _v-2f668e14=\"\"><p _v-2f668e14=\"\">Maximum Bit Rate: {{ sad.bitRate }}</p></div><div v-if=\"audioType(sad.format) == 'nineThirteen' \" _v-2f668e14=\"\"><p _v-2f668e14=\"\">Audio Format Code: {{ sad.audioFormatCode }}</p></div><div v-if=\"audioType(sad.format) == 'wmaPro' \" _v-2f668e14=\"\"><p _v-2f668e14=\"\">Format Code Ext.: {{ sad.formatCodeExt }}</p></div><div v-if=\"audioType(sad.format) == 'extension' \" _v-2f668e14=\"\"><p _v-2f668e14=\"\">Profile: {{ sad.profile }}</p></div></ul></div><div v-if=\"dbc.tag.value == 4\" _v-2f668e14=\"\"><h3 _v-2f668e14=\"\">Speaker Allocation Data Block</h3><p v-for=\"speakerAllocation in result.speakerAllocation\" _v-2f668e14=\"\">{{ speakerAllocation }} {{ isAudioBitSet(dbc.payload,$index) }}</p></div><div v-if=\"dbc.tag.value == 3\" _v-2f668e14=\"\"><h3 _v-2f668e14=\"\">Vendor Specific Data Block</h3><p _v-2f668e14=\"\">IEEE OUI: {{ pad(dbc.ieeeIdentifier.toString(16).toUpperCase(),6) }}</p><div v-if=\"dbc.ieeeIdentifier == result.ieeeOuiType.HDMI14.value\" _v-2f668e14=\"\"><p _v-2f668e14=\"\">Source Physical Address: {{ dbc.physicalAddress.toString(16).toUpperCase() }}</p><p _v-2f668e14=\"\">Supports ACP, ISRC1, ISRC2 {{ dbc.supportsAI }}</p><p _v-2f668e14=\"\">Supports 48 bits/pixel (16 bits/color) {{ dbc.deepColor48 }}</p><p _v-2f668e14=\"\">Supports 36 bits/pixel (12 bits/color) {{ dbc.deepColor36 }}</p><p _v-2f668e14=\"\">Supports 30 bits/pixel (10 bits/color) {{ dbc.deepColor30 }}</p><p _v-2f668e14=\"\">Supports YCbCr 4:4:4 Deep Color {{ dbc.deepColorY444 }}</p><p _v-2f668e14=\"\">Supports Dual DVI {{ dbc.dualDvi }}</p><p _v-2f668e14=\"\">Max TMDS Clock Rate: {{dbc.maxTmdsRate}} MHz</p><p _v-2f668e14=\"\">Video/Audio Latency Fields Present {{ dbc.latencyPresent }}</p><div v-show=dbc.latencyPresent _v-2f668e14=\"\"><p _v-2f668e14=\"\">Video Latency: {{dbc.videoLatency}} ms</p><p _v-2f668e14=\"\">Audio Latency: {{dbc.audioLatency}} ms</p><p _v-2f668e14=\"\">Interlaced Video/Audio Latency Fields Present: {{dbc.latencyPresent.toString().toUpperCase()}}</p><p _v-2f668e14=\"\">Interlaced Video Latency: {{dbc.iVideoLatency}} ms</p><p _v-2f668e14=\"\">Interlaced Audio Latency: {{dbc.iAudioLatency}} ms</p></div></div><div v-if=\"dbc.ieeeIdentifier == result.ieeeOuiType.HDMI20.value\" _v-2f668e14=\"\"><p _v-2f668e14=\"\">Version: {{ dbc.versionHF }}</p><p _v-2f668e14=\"\">Max TMDS Clock Rate: {{ dbc.maxTmdsRateHF }} MHz</p><p _v-2f668e14=\"\">Supports SCDC {{ dbc.supportsSCDC }}</p><p _v-2f668e14=\"\">Supports SCDC Read Request {{ dbc.supportsSCDCRR }}</p><p _v-2f668e14=\"\">Supports Scrambling for less &lt;=340MHz {{ dbc.supportsLTE340scramble }}</p><p _v-2f668e14=\"\">Supports 3D Independent View {{ dbc.supports3DIV }}</p><p _v-2f668e14=\"\">Supports 3D Dual View {{ dbc.supports3DDV }}</p><p _v-2f668e14=\"\">Supports 3D OSD Disparity {{ dbc.supports3DOSD }}</p><p _v-2f668e14=\"\">Supports 30 bits/pixel (10 bits/color) for Deep Color YCbCr 4:2:0 {{ dbc.deepColorY420_30 }}</p><p _v-2f668e14=\"\">Supports 36 bits/pixel (12 bits/color) for Deep Color YCbCr 4:2:0 {{ dbc.deepColorY420_36 }}</p><p _v-2f668e14=\"\">Supports 48 bits/pixel (16 bits/color) for Deep Color YCbCr 4:2:0 {{ dbc.deepColorY420_48 }}</p></div></div><div v-if=\"dbc.tag.value == 7\" _v-2f668e14=\"\"><div v-if=\"dbc.extendedTag.value == 0\" _v-2f668e14=\"\"><h3 _v-2f668e14=\"\">Video Capability Data Block</h3><p _v-2f668e14=\"\">Quantization Range selectable via AVI YQ for YCC formats {{ dbc.quantizationRangeYCC }}</p><p _v-2f668e14=\"\">Quantization Range selectable via AVI Q for RGB formats {{ dbc.quantizationRangeRGB }}</p><p _v-2f668e14=\"\">Overscan underscan behaviour for Preferred Video Format: {{ceaDataBlock.overscanPT}}</p><p _v-2f668e14=\"\">Overscan underscan behaviour for IT Video Formats: {{ceaDataBlock.overscanIT}}</p><p _v-2f668e14=\"\">Overscan underscan behaviour for CE Video Formats: {{ceaDataBlock.overscanCE}}</p></div><div v-if=\"dbc.extendedTag.value == 5\" _v-2f668e14=\"\"><h3 _v-2f668e14=\"\">Colorimetry Data Block</h3><p _v-2f668e14=\"\">Supports BT2020 RGB {{ dbc.supportsBT2020RGB }}</p><p _v-2f668e14=\"\">Supports BT2020 YCC {{ dbc.supportsBT2020YCC }}</p><p _v-2f668e14=\"\">Supports BT2020 cYCC {{ dbc.supportsBT2020cYCC }}</p><p _v-2f668e14=\"\">Supports Adobe RGB {{ dbc.supportsAdobeRGB }}</p><p _v-2f668e14=\"\">Supports Adobe YCC601 {{ dbc.supportsAdobeYCC601 }}</p><p _v-2f668e14=\"\">Supports sYCC601 {{ dbc.supportssYCC601 }}</p><p _v-2f668e14=\"\">Supports xvYCC709 {{ dbc.supportsxvYCC709 }}</p><p _v-2f668e14=\"\">Supports xvYCC601 {{ dbc.supportsxvYCC601 }}</p><p _v-2f668e14=\"\">Gamut MetaData3 (MD3): {{ dbc.gamutMD3}}</p><p _v-2f668e14=\"\">Gamut MetaData2 (MD2): {{ dbc.gamutMD2}}</p><p _v-2f668e14=\"\">Gamut MetaData1 (MD1): {{ dbc.gamutMD1}}</p><p _v-2f668e14=\"\">Gamut MetaData0 (MD0): {{ dbc.gamutMD0}}</p></div><div v-if=\"dbc.extendedTag.value == 14\" _v-2f668e14=\"\"><h3 _v-2f668e14=\"\">YCbCr 4:2:0 Video Data Block</h3><p _v-2f668e14=\"\">The following modes support only YCbCr 4:2:0 color format.</p><div v-for=\"svd in dbc.YCbCr420OnlyShortVideoDescriptors\" _v-2f668e14=\"\"><p _v-2f668e14=\"\">Native: {{svd.nativeResolution.toString().toUpperCase() }}</p><p _v-2f668e14=\"\">VIC: {{ result.shortVideoDescriptors[svd.vic].vic }}</p><p _v-2f668e14=\"\">Format: {{ result.shortVideoDescriptors[svd.vic].format }}</p><p _v-2f668e14=\"\">Field Rate: {{ result.shortVideoDescriptors[svd.vic].fieldRate }}</p><p _v-2f668e14=\"\">Picture AR: {{ result.shortVideoDescriptors[svd.vic].pictureAspectRatio }}</p><p _v-2f668e14=\"\">Pixel AR: {{ result.shortVideoDescriptors[svd.vic].pixelAspectRatio }}</p></div></div><div v-if=\"dbc.extendedTag.value == 15\" _v-2f668e14=\"\"><h3 _v-2f668e14=\"\">YCbCr 4:2:0 Capability Map Data Block</h3><p _v-2f668e14=\"\">The following modes support YCbCr 4:2:0 in addition to other color formats.</p><div v-for=\"svd in dbc.YCbCr420CapableShortVideoDescriptors\" _v-2f668e14=\"\"><p _v-2f668e14=\"\">Native: {{svd.nativeResolution.toString().toUpperCase()}}</p><p _v-2f668e14=\"\">VIC: {{ result.shortVideoDescriptors[svd.vic].vic}}</p><p _v-2f668e14=\"\">Format: {{ result.shortVideoDescriptors[svd.vic].format}}</p><p _v-2f668e14=\"\">Field Rate: {{ result.shortVideoDescriptors[svd.vic].fieldRate}}</p><p _v-2f668e14=\"\">Picture AR: {{ result.shortVideoDescriptors[svd.vic].pictureAspectRatio}}</p><p _v-2f668e14=\"\">Pixel AR: {{ result.shortVideoDescriptors[svd.vic].pixelAspectRatio}}</p></div></div></div><p _v-2f668e14=\"\"></p></div></div></div></div>";

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

	module.exports = "<div class=row _v-2fe0a86d=\"\"><div class=col-xs-12 _v-2fe0a86d=\"\"><fieldset _v-2fe0a86d=\"\"><legend _v-2fe0a86d=\"\">dxGetInputResolution</legend><button @click=\"sendAPI('dxGetInputResolution')\" _v-2fe0a86d=\"\">dxGetInputResolution</button></fieldset></div></div><div class=row _v-2fe0a86d=\"\"><div class=col-xs-12 _v-2fe0a86d=\"\"><fieldset _v-2fe0a86d=\"\"><legend _v-2fe0a86d=\"\">dxSetInputResolution(VIRTUAL DEVICE ONLY, only for test 4K)</legend><span _v-2fe0a86d=\"\">Set 4K</span><input type=checkbox v-model=chose4k _v-2fe0a86d=\"\"><div _v-2fe0a86d=\"\"><span _v-2fe0a86d=\"\">resolution4K :</span><input v-model=resolution4K readonly=readonly _v-2fe0a86d=\"\"></div><div _v-2fe0a86d=\"\"><span _v-2fe0a86d=\"\">resolutionNormal :</span><input v-model=resolutionNormal readonly=readonly _v-2fe0a86d=\"\"></div><button @click=dxSetInputResolution _v-2fe0a86d=\"\">dxSetInputResolution</button></fieldset></div></div><div class=row _v-2fe0a86d=\"\"><div class=col-xs-12 _v-2fe0a86d=\"\"><fieldset _v-2fe0a86d=\"\"><legend _v-2fe0a86d=\"\">dxGetOutputResolutionOptions</legend><button @click=\"sendAPI('dxGetOutputResolutionOptions')\" _v-2fe0a86d=\"\">dxGetOutputResolutionOptions</button></fieldset></div></div><div class=row _v-2fe0a86d=\"\"><div class=col-xs-12 _v-2fe0a86d=\"\"><fieldset _v-2fe0a86d=\"\"><legend _v-2fe0a86d=\"\">dxGetOutputResolution</legend><button @click=\"sendAPI('dxGetOutputResolution')\" _v-2fe0a86d=\"\">dxGetOutputResolution</button></fieldset></div></div><div class=row _v-2fe0a86d=\"\"><div class=col-xs-12 _v-2fe0a86d=\"\"><fieldset _v-2fe0a86d=\"\"><legend _v-2fe0a86d=\"\">dxSetOutputResolution</legend><div _v-2fe0a86d=\"\"><span _v-2fe0a86d=\"\">port :</span><input v-model=outputRes.port _v-2fe0a86d=\"\"></div><div _v-2fe0a86d=\"\"><span _v-2fe0a86d=\"\">option :</span><input v-model=outputRes.option _v-2fe0a86d=\"\"></div><button @click=dxSetOutputResolution _v-2fe0a86d=\"\">dxSetOutputResolution</button></fieldset></div></div><div class=row _v-2fe0a86d=\"\"><div class=col-xs-12 _v-2fe0a86d=\"\"><fieldset _v-2fe0a86d=\"\"><legend _v-2fe0a86d=\"\">dxGetOutputSplitOptions</legend><button @click=\"sendAPI('dxGetOutputSplitOptions')\" _v-2fe0a86d=\"\">dxGetOutputSplitOptions</button></fieldset></div></div><div class=row _v-2fe0a86d=\"\"><div class=col-xs-12 _v-2fe0a86d=\"\"><fieldset _v-2fe0a86d=\"\"><legend _v-2fe0a86d=\"\">dxGetSplitArea</legend><button @click=\"sendAPI('dxGetSplitArea')\" _v-2fe0a86d=\"\">dxGetSplitArea</button></fieldset></div></div><div class=row _v-2fe0a86d=\"\"><div class=col-xs-12 _v-2fe0a86d=\"\"><fieldset _v-2fe0a86d=\"\"><legend _v-2fe0a86d=\"\">dxSetSplitArea</legend><div _v-2fe0a86d=\"\"><label _v-2fe0a86d=\"\">Port</label><input number=number v-model=splitAreaPort class=thin _v-2fe0a86d=\"\"></div><div v-for=\"(id, sval) in splitArea\" track-by=$index _v-2fe0a86d=\"\"><span _v-2fe0a86d=\"\">port : {{ id }}</span><input number=number v-model=v v-for=\"v in sval\" track-by=$index class=thin _v-2fe0a86d=\"\"></div><button @click=dxSetSplitArea _v-2fe0a86d=\"\">dxSetSplitArea</button></fieldset></div></div><div class=row _v-2fe0a86d=\"\"><div class=col-xs-12 _v-2fe0a86d=\"\"><fieldset _v-2fe0a86d=\"\"><legend _v-2fe0a86d=\"\">dxGetProfiles</legend><button @click=\"sendAPI('dxGetProfiles')\" _v-2fe0a86d=\"\">dxGetProfiles</button></fieldset></div></div><div class=row _v-2fe0a86d=\"\"><div class=col-xs-12 _v-2fe0a86d=\"\"><fieldset _v-2fe0a86d=\"\"><legend _v-2fe0a86d=\"\">dxSetProfileByKey</legend><div _v-2fe0a86d=\"\"><span _v-2fe0a86d=\"\">profileIndex :</span><input v-model=profileIndex _v-2fe0a86d=\"\"></div><button @click=dxSetProfileByKey _v-2fe0a86d=\"\">dxSetProfileByKey</button></fieldset></div></div><div class=row _v-2fe0a86d=\"\"><div class=col-xs-12 _v-2fe0a86d=\"\"><fieldset _v-2fe0a86d=\"\"><legend _v-2fe0a86d=\"\">dxSetDeviceByProfileKey</legend><div _v-2fe0a86d=\"\"><span _v-2fe0a86d=\"\">profileIndexUWantToSet :</span><input v-model=profileIndexUWantToSet _v-2fe0a86d=\"\"></div><button @click=dxSetDeviceByProfileKey _v-2fe0a86d=\"\">dxSetDeviceByProfileKey</button></fieldset></div></div><div class=row _v-2fe0a86d=\"\"><div class=col-xs-12 _v-2fe0a86d=\"\"><fieldset _v-2fe0a86d=\"\"><legend _v-2fe0a86d=\"\">dxSetSplitByOption</legend><div _v-2fe0a86d=\"\"><span _v-2fe0a86d=\"\">splitOption :</span><input v-model=splitOption _v-2fe0a86d=\"\"></div><button @click=dxSetSplitByOption _v-2fe0a86d=\"\">dxSetSplitByOption</button></fieldset></div></div><h2 _v-2fe0a86d=\"\">(for VW-1404ZH-G only)</h2><div class=row _v-2fe0a86d=\"\"><div class=col-xs-12 _v-2fe0a86d=\"\"><fieldset _v-2fe0a86d=\"\"><legend _v-2fe0a86d=\"\">dxGetInputSource</legend><button @click=\"sendAPI('dxGetInputSource')\" _v-2fe0a86d=\"\">dxGetInputSource</button></fieldset></div></div><div class=row _v-2fe0a86d=\"\"><div class=col-xs-12 _v-2fe0a86d=\"\"><fieldset _v-2fe0a86d=\"\"><legend _v-2fe0a86d=\"\">dxSetInputSource </legend><span _v-2fe0a86d=\"\">isSourceFromHDMI &nbsp;</span><input type=checkbox v-model=isSourceFromHDMI _v-2fe0a86d=\"\"><br _v-2fe0a86d=\"\"><button @click=dxSetInputSource _v-2fe0a86d=\"\">dxSetInputSource</button></fieldset></div></div>";

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-32789f0a=\"\"><div class=row _v-32789f0a=\"\"><div class=\"hdcp_main col-md-12\" _v-32789f0a=\"\"><header class=\"hdcp_title_bar main_title_bar clearfix\" _v-32789f0a=\"\"><h1 class=\"title col-md-10 col-sm-10 col-xs-12 clearfix\" _v-32789f0a=\"\">I/O Status</h1></header><section class=\"hdcp_content col-lg-10 col-md-10 col-sm-11 col-xs-12 row_space--xs col-centered no_pad-xxs\" _v-32789f0a=\"\"><header class=\"output col-md-12 clearfix\" _v-32789f0a=\"\"><h2 _v-32789f0a=\"\">Output</h2></header><section class=\"output_section col-md-12 col-lg-11 col-centered\" _v-32789f0a=\"\"><table class=\"table table-bordered table-hover table-striped hdcp_table\" _v-32789f0a=\"\"><tbody _v-32789f0a=\"\"><tr class=title _v-32789f0a=\"\"><td class=port _v-32789f0a=\"\">Port</td><td class=link _v-32789f0a=\"\">Link</td><td class=reconnect _v-32789f0a=\"\">Reconnection</td><td _v-32789f0a=\"\">Debug Mode</td></tr><tr v-for=\"(key, obj) in outputHDCP\" _v-32789f0a=\"\"><td class=port_key _v-32789f0a=\"\">{{key}}</td><td _v-32789f0a=\"\"><indicator v-bind:enable=outputLink[key] na=true _v-32789f0a=\"\"></indicator></td><td _v-32789f0a=\"\"><button v-on:click=\"resetLink(key, 'o')\" class=\"btn btn-info\" _v-32789f0a=\"\">Reconnect</button></td><td _v-32789f0a=\"\"><div class=iosCheck _v-32789f0a=\"\"><div v-on:click.stop=enterPassword(key) class=mask _v-32789f0a=\"\"></div><input type=checkbox v-bind:checked.sync=\"outputLink[key] &amp;&amp; !outputHDCP[key].enabled \" v-model=!outputHDCP[key].enabled _v-32789f0a=\"\"><i _v-32789f0a=\"\"></i></div></td></tr></tbody></table></section><header class=\"input_header col-md-12 clearfix\" _v-32789f0a=\"\"><h2 _v-32789f0a=\"\">Input</h2></header><section class=\"input_section col-md-12 col-lg-11 col-centered\" _v-32789f0a=\"\"><table class=\"table table-bordered table-hover table-striped input_table\" _v-32789f0a=\"\"><tbody _v-32789f0a=\"\"><tr class=title _v-32789f0a=\"\"><td class=port _v-32789f0a=\"\">Port</td><td class=link _v-32789f0a=\"\">Link</td><td class=reconnect _v-32789f0a=\"\">Reconnection</td><td _v-32789f0a=\"\">HDCP&nbsp;&nbsp;</td></tr><tr v-for=\"(key, obj) in inputLink\" _v-32789f0a=\"\"><td _v-32789f0a=\"\">{{key}}</td><td _v-32789f0a=\"\"><indicator v-bind:enable=obj na=true _v-32789f0a=\"\"></indicator></td><td _v-32789f0a=\"\"><button v-on:click=\"resetLink(key, 'i')\" class=\"btn btn-info\" _v-32789f0a=\"\">Reconnect</button></td><td _v-32789f0a=\"\"><indicator v-bind:enable=inputHDCP[key].enabled na=true _v-32789f0a=\"\"></indicator></td></tr></tbody></table></section></section><modal v-bind:show.sync=showModal v-bind:close=cancel v-bind:callback=applyChange v-bind:backdrop=false effect=fade ok-text=Apply cancel-text=Cancel title=\"Enter Password\" _v-32789f0a=\"\"><div slot=modal-body class=\"modal-body clearfix\" _v-32789f0a=\"\"><div class=row _v-32789f0a=\"\"><div class=col-md-12 _v-32789f0a=\"\"><div class=col-md-12 _v-32789f0a=\"\"><label _v-32789f0a=\"\">Please enter the password to enable Debug mode:</label><input v-model=password type=password class=form-control _v-32789f0a=\"\"></div><div class=col-md-12 _v-32789f0a=\"\"><span class=msg _v-32789f0a=\"\">In order to get the device work properly, please turn off debug mode after finishing tests. Debug mode is&nbsp;<span class=warning _v-32789f0a=\"\">NOT&nbsp;</span>recommended for normal usage.</span></div></div></div></div></modal></div></div></div>";

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-3817f454=\"\"><div class=row _v-3817f454=\"\"><div class=\"port_status_main col-md-12\" _v-3817f454=\"\"><header class=\"port_status_title_bar main_title_bar clearfix\" _v-3817f454=\"\"><h1 class=\"title col-md-10 col-sm-10 col-xs-12 hidden-xs\" _v-3817f454=\"\">Port Status</h1><h1 class=\"title col-md-10 col-sm-10 col-xs-12 visible-xs\" _v-3817f454=\"\">Port Status</h1></header><section class=\"port_status_content clear-left clearfix row_space--xs\" _v-3817f454=\"\"><table class=\"table table-bordered table-striped table-hover port_status_table\" _v-3817f454=\"\"><tbody _v-3817f454=\"\"><tr _v-3817f454=\"\"><th _v-3817f454=\"\">Port No.</th><th _v-3817f454=\"\">Type</th><th _v-3817f454=\"\">Link</th><th _v-3817f454=\"\">State</th><th _v-3817f454=\"\">Speed / Duplex</th><th _v-3817f454=\"\">Flow Control</th></tr><tr v-for=\"(key, port) in ports\" _v-3817f454=\"\"><td _v-3817f454=\"\">{{port.portNo}}</td><td _v-3817f454=\"\">{{port.type}}</td><td _v-3817f454=\"\">{{port.link}}</td><td _v-3817f454=\"\">{{port.state}}</td><td _v-3817f454=\"\">{{port.speed || \"N\"}}/{{port.duplex || \"A\"}}</td><td _v-3817f454=\"\">{{port.flowControl || \"N/A\"}}</td></tr></tbody></table></section></div></div></div>";

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

	module.exports = "<div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxGetMixerStatus</legend><button @click=dxGetMixerStatus _v-3ce49b5a=\"\">dxGetMixerStatus</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxGetProfiles</legend><input v-model=profileKey class=thin _v-3ce49b5a=\"\"><br _v-3ce49b5a=\"\"><button @click=dxGetProfiles _v-3ce49b5a=\"\">dxGetProfiles</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxSetProfiles</legend><div _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">no:</span><input type=text v-model=profile.pid _v-3ce49b5a=\"\"></div><div _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">name:</span><input type=text v-model=profile.content.name _v-3ce49b5a=\"\"></div><div v-for=\"(id, val) in profile.content.mapping\" track-by=$index _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">mapping: {{ id }}</span><input v-model=val _v-3ce49b5a=\"\"></div><div v-for=\"(id, slv) in profile.content.layer\" track-by=$index _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">layer index : {{ id + 1 }}</span><input number=number v-model=slv track-by=$index class=thin _v-3ce49b5a=\"\"></div><div v-for=\"(id, sval) in profile.content.split\" track-by=$index _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">split: {{ id }}</span><input number=number v-model=v v-for=\"v in sval\" track-by=$index class=thin _v-3ce49b5a=\"\"></div><button @click=dxSetProfiles _v-3ce49b5a=\"\">dxSetProfiles</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxSetDeviceByProfileKey</legend><div _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">Profile:</span><input type=text v-model=setProfileKey _v-3ce49b5a=\"\"></div><button @click=dxSetDeviceByProfileKey _v-3ce49b5a=\"\">dxSetDeviceByProfileKey</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxGetOutputSound</legend><button @click=\"sendAPI('dxGetOutputSound')\" _v-3ce49b5a=\"\">dxGetOutputSound</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxSetOutputSound</legend><div _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">SoundFrom :</span><input v-model=sound.SoundFrom _v-3ce49b5a=\"\"></div><div _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">RLChannel :</span><input v-model=sound.RLChannel _v-3ce49b5a=\"\"></div><div _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">FullScreenAudio :</span><input type=checkbox v-model=sound.FullScreenAudio _v-3ce49b5a=\"\"></div><div _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">Mute :</span><input type=checkbox v-model=sound.Mute _v-3ce49b5a=\"\"></div><button @click=dxSetOutputSound _v-3ce49b5a=\"\">dxSetOutputSound</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxGetOutputVideo</legend><button @click=\"sendAPI('dxGetOutputVideo')\" _v-3ce49b5a=\"\">dxGetOutputVideo</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"> <legend _v-3ce49b5a=\"\">dxSetOutputVideo</legend><div _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">VerticalFlip :</span><input type=checkbox v-model=video.VerticalFlip _v-3ce49b5a=\"\"></div><div _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">Mirror :</span><input type=checkbox v-model=video.Mirror _v-3ce49b5a=\"\"></div><button @click=dxSetOutputVideo _v-3ce49b5a=\"\">dxSetOutputVideo</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxGetOutputColor</legend><button @click=\"sendAPI('dxGetOutputColor')\" _v-3ce49b5a=\"\">dxGetOutputColor</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"> <legend _v-3ce49b5a=\"\">dxSetOutputColor</legend><div _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">Brightness :</span><input v-model=color.Brightness number=number _v-3ce49b5a=\"\"></div><div _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">Saturation :</span><input v-model=color.Saturation number=number _v-3ce49b5a=\"\"></div><div _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">Contrast :</span><input v-model=color.Contrast number=number _v-3ce49b5a=\"\"></div><button @click=dxSetOutputColor _v-3ce49b5a=\"\">dxSetOutputColor</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxGetInputResolution</legend><button @click=\"sendAPI('dxGetInputResolution')\" _v-3ce49b5a=\"\">dxGetInputResolution</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxGetOutputResolutionOptions</legend><button @click=\"sendAPI('dxGetOutputResolutionOptions')\" _v-3ce49b5a=\"\">dxGetOutputResolutionOptions</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxGetOutputResolution</legend><button @click=\"sendAPI('dxGetOutputResolution')\" _v-3ce49b5a=\"\">dxGetOutputResolution</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxSetOutputResolution</legend><div _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">port :</span><input v-model=outputRes.port _v-3ce49b5a=\"\"></div><div _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">option :</span><input v-model=outputRes.option _v-3ce49b5a=\"\"></div><button @click=dxSetOutputResolution _v-3ce49b5a=\"\">dxSetOutputResolution</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxGetSplitOptions</legend><button @click=\"sendAPI('dxGetSplitOptions')\" _v-3ce49b5a=\"\">dxGetSplitOptions</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxGetSplitLayer</legend><button @click=\"sendAPI('dxGetSplitLayer')\" _v-3ce49b5a=\"\">dxGetSplitLayer</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxSetSplitLayer</legend><div v-for=\"(id, slv) in splitLayer\" track-by=$index _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">layer index : {{ id + 1 }}</span><input number=number v-model=slv track-by=$index class=thin _v-3ce49b5a=\"\"></div><button @click=dxSetSplitLayer _v-3ce49b5a=\"\">dxSetSplitLayer</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxGetSplitArea</legend><button @click=\"sendAPI('dxGetSplitArea')\" _v-3ce49b5a=\"\">dxGetSplitArea</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxSetSplitArea</legend><div _v-3ce49b5a=\"\"><label _v-3ce49b5a=\"\">Port</label><input number=number v-model=splitAreaPort class=thin _v-3ce49b5a=\"\"></div><div v-for=\"(id, sval) in splitArea\" track-by=$index _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">port : {{ id }}</span><input number=number v-model=v v-for=\"v in sval\" track-by=$index class=thin _v-3ce49b5a=\"\"></div><button @click=dxSetSplitArea _v-3ce49b5a=\"\">dxSetSplitArea</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxGetMixerStatus</legend><button @click=\"sendAPI('dxGetMixerStatus')\" _v-3ce49b5a=\"\">dxGetMixerStatus</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxSetMapping</legend><div _v-3ce49b5a=\"\"><label _v-3ce49b5a=\"\">Port</label><input number=number v-model=mappingPort class=thin _v-3ce49b5a=\"\"></div><div v-for=\"(id, sval) in mapping\" track-by=$index _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">port : {{ id }}</span><input v-model=sval track-by=$index class=thin _v-3ce49b5a=\"\"></div><button @click=dxSetMapping _v-3ce49b5a=\"\">dxSetMapping</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxGetLabel</legend><button @click=\"sendAPI('dxGetLabel')\" _v-3ce49b5a=\"\">dxGetLabel</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxSetLabel</legend><div v-for=\"(key, content) in label\" track-by=$index _v-3ce49b5a=\"\"><div v-if=\"key !== 'osd'\" _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">{{ key }} :</span><div _v-3ce49b5a=\"\"><label _v-3ce49b5a=\"\">Port</label><input number=number v-model=labelPort[key] _v-3ce49b5a=\"\"></div><div v-for=\"(id, vals) in content\" track-by=$index _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">{{ id }} :</span><span _v-3ce49b5a=\"\">text<input v-model=vals.text class=thin _v-3ce49b5a=\"\"></span><span _v-3ce49b5a=\"\">enabled<input type=checkbox v-model=vals.enabled class=thin _v-3ce49b5a=\"\"></span></div></div><div v-else=v-else _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">{{key}}:</span><div _v-3ce49b5a=\"\"><label _v-3ce49b5a=\"\">Port</label><input number=number v-model=labelPort[key] _v-3ce49b5a=\"\"></div><div v-for=\"(id, vals) in content\" track-by=$index _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">{{ id }}:</span><span _v-3ce49b5a=\"\">enabled<input type=checkbox v-model=vals.enabled class=thin _v-3ce49b5a=\"\"></span><span _v-3ce49b5a=\"\">border<input number=number v-model=vals.border class=thin _v-3ce49b5a=\"\"></span></div></div></div><button @click=dxSetLabel _v-3ce49b5a=\"\">dxSetLabel</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxGetInputCrop</legend><button @click=\"sendAPI('dxGetInputCrop')\" _v-3ce49b5a=\"\">dxGetInputCrop</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxSetInputCrop</legend><div _v-3ce49b5a=\"\"><label _v-3ce49b5a=\"\">Port</label><input number=number v-model=cropPort _v-3ce49b5a=\"\"></div><div v-for=\"(key, content) in crop\" track-by=$index _v-3ce49b5a=\"\"><div _v-3ce49b5a=\"\">crop:{{ key }}</div><span _v-3ce49b5a=\"\">enabled<input type=checkbox v-model=content.enabled class=thin _v-3ce49b5a=\"\"></span><div _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">H</span><span v-for=\"h in content.H\" track-by=$index _v-3ce49b5a=\"\"><input number=number v-model=h class=thin _v-3ce49b5a=\"\"></span></div><div _v-3ce49b5a=\"\"><span _v-3ce49b5a=\"\">V</span><span v-for=\"v in content.V\" track-by=$index _v-3ce49b5a=\"\"><input number=number v-model=v class=thin _v-3ce49b5a=\"\"></span></div></div><button @click=dxSetInputCrop _v-3ce49b5a=\"\">dxSetInputCrop</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxGetSplitOptions</legend><button @click=\"sendAPI('dxGetSplitOptions')\" _v-3ce49b5a=\"\">dxGetSplitOptions</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxSetSplitByOption</legend><div class=row_space--xxs _v-3ce49b5a=\"\"><v-select v-bind:options=splitOptions v-bind:value.sync=currentSplit _v-3ce49b5a=\"\"></v-select></div><button @click=dxSetSplitByOption _v-3ce49b5a=\"\">dxSetSplitByOption</button></fieldset></div></div><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">For test only</legend><div class=row _v-3ce49b5a=\"\"><div class=col-xs-12 _v-3ce49b5a=\"\"><fieldset _v-3ce49b5a=\"\"><legend _v-3ce49b5a=\"\">dxGetCurrentSplit</legend><button @click=\"sendAPI('dxGetCurrentSplit')\" _v-3ce49b5a=\"\">dxGetCurrentSplit</button></fieldset></div></div></fieldset></div></div>";

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

	module.exports = "<div v-if=showOption class=outer _v-414676b9=\"\"><span v-for=\"(key, option) in options\" v-bind:data-bgcolor=key _v-414676b9=\"\"><input type=radio v-bind:value=option.value id=\"{{ nameProp + key }}\" name=\"{{ nameProp }}\" v-model=output _v-414676b9=\"\"><label for=\"{{ nameProp + key }}\" _v-414676b9=\"\">{{option.label}}</label></span></div>";

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-445f948b=\"\"><div class=row _v-445f948b=\"\"><div class=\"m2m_main col-md-12\" _v-445f948b=\"\"><header class=\"m2m_title_bar main_title_bar clearfix\" _v-445f948b=\"\"><h1 class=\"title col-md-12\" _v-445f948b=\"\">Machine To Machine</h1></header><section class=\"m2m_content clearfix row_space--xs\" _v-445f948b=\"\"><section class=\"m2m_tabs col-md-10 col-centered\" _v-445f948b=\"\"><tabs _v-445f948b=\"\"><tab header=M2M _v-445f948b=\"\"><table id=m2m_table class=\"table table-striped table-hover table-bordered hidden-xs\" _v-445f948b=\"\"><tbody _v-445f948b=\"\"><tr _v-445f948b=\"\"><th _v-445f948b=\"\">No.</th><th _v-445f948b=\"\">Name</th><th _v-445f948b=\"\">Detail</th><th _v-445f948b=\"\">Event</th><th _v-445f948b=\"\">Actions</th><th _v-445f948b=\"\"><i class=\"fa fa-plus-square\" _v-445f948b=\"\"></i></th></tr><tr v-for=\"detail in m2m_details\" _v-445f948b=\"\"><td _v-445f948b=\"\">{{detail.id}}</td><td _v-445f948b=\"\">{{detail.name}}</td><td _v-445f948b=\"\"><p _v-445f948b=\"\">{{detail.detail}}</p></td><td _v-445f948b=\"\">{{detail.event}}</td><td class=actions _v-445f948b=\"\"><div v-for=\"action in detail.actions\" class=action _v-445f948b=\"\"><span _v-445f948b=\"\"><i class=\"fa fa-edit\" _v-445f948b=\"\"></i></span><span _v-445f948b=\"\">{{action}}</span></div></td><td class=function_group _v-445f948b=\"\"><div class=function__single _v-445f948b=\"\"><i class=\"fa fa-edit\" _v-445f948b=\"\"></i></div><div class=function__single _v-445f948b=\"\"><i class=\"fa fa-trash\" _v-445f948b=\"\"></i></div></td></tr></tbody></table><table id=m2m_table_mobile class=\"table table-striped table-bordered visible-xs\" _v-445f948b=\"\"><tbody _v-445f948b=\"\"><tr _v-445f948b=\"\"><th _v-445f948b=\"\">No.</th><th _v-445f948b=\"\">Name</th><th _v-445f948b=\"\"></th></tr><tr v-for=\"(key, detail) in m2m_details\" _v-445f948b=\"\"><td _v-445f948b=\"\">{{detail.id}}</td><td _v-445f948b=\"\">{{detail.name}}</td><td v-on:click=handleShowM2M(key) class=function_group _v-445f948b=\"\"><div class=function__single _v-445f948b=\"\"><i class=\"fa fa-edit\" _v-445f948b=\"\"></i></div><div class=\"function__single hidden\" _v-445f948b=\"\"><i class=\"fa fa-trash\" _v-445f948b=\"\"></i></div></td></tr></tbody></table></tab><tab header=Events _v-445f948b=\"\"><table id=events_table class=\"table table-striped table-hover table-bordered hidden-xs\" _v-445f948b=\"\"><tbody _v-445f948b=\"\"><tr _v-445f948b=\"\"><th _v-445f948b=\"\">No.</th><th _v-445f948b=\"\">Name</th><th _v-445f948b=\"\">Detail</th><th _v-445f948b=\"\">From Device</th><th _v-445f948b=\"\">Event</th><th _v-445f948b=\"\"><i class=\"fa fa-plus-square\" _v-445f948b=\"\"></i></th></tr><tr v-for=\"detail in events_details\" _v-445f948b=\"\"><td _v-445f948b=\"\">{{detail.id}}</td><td _v-445f948b=\"\">{{detail.name}}</td><td _v-445f948b=\"\"><span _v-445f948b=\"\">{{detail.detail}}</span></td><td _v-445f948b=\"\">{{detail.device}}</td><td _v-445f948b=\"\">{{detail.event}}</td><td class=function_group _v-445f948b=\"\"><div class=function__single _v-445f948b=\"\"><i class=\"fa fa-edit\" _v-445f948b=\"\"></i></div><div class=function__single _v-445f948b=\"\"><i class=\"fa fa-trash\" _v-445f948b=\"\"></i></div></td></tr></tbody></table><table id=events_table_mobile class=\"table table-striped table-bordered visible-xs\" _v-445f948b=\"\"><tbody _v-445f948b=\"\"><tr _v-445f948b=\"\"><th _v-445f948b=\"\">No.</th><th _v-445f948b=\"\">Name</th><th _v-445f948b=\"\"></th></tr><tr v-for=\"(key, detail) in events_details\" _v-445f948b=\"\"><td _v-445f948b=\"\">{{detail.id}}</td><td _v-445f948b=\"\">{{detail.name}}</td><td v-on:click=handleShowEvents(key) class=function_group _v-445f948b=\"\"><div class=function__single _v-445f948b=\"\"><i class=\"fa fa-edit\" _v-445f948b=\"\"></i></div><div class=\"function__single hidden\" _v-445f948b=\"\"><i class=\"fa fa-trash\" _v-445f948b=\"\"></i></div></td></tr></tbody></table></tab><tab header=Actions _v-445f948b=\"\"><table id=actions_table class=\"table table-striped table-hover table-bordered hidden-xs\" _v-445f948b=\"\"><tbody _v-445f948b=\"\"><tr _v-445f948b=\"\"><th _v-445f948b=\"\">No.</th><th _v-445f948b=\"\">Name</th><th _v-445f948b=\"\">Detail</th><th _v-445f948b=\"\">From Device</th><th _v-445f948b=\"\">Action</th><th _v-445f948b=\"\"><i class=\"fa fa-plus-square\" _v-445f948b=\"\"></i></th></tr><tr v-for=\"detail in actions_details\" _v-445f948b=\"\"><td _v-445f948b=\"\">{{detail.id}}</td><td _v-445f948b=\"\">{{detail.name}}</td><td _v-445f948b=\"\"><span _v-445f948b=\"\">{{detail.detail}}</span></td><td _v-445f948b=\"\">{{detail.device}}</td><td _v-445f948b=\"\">{{detail.action}}</td><td class=function_group _v-445f948b=\"\"><div class=function__single _v-445f948b=\"\"><i class=\"fa fa-edit\" _v-445f948b=\"\"></i></div><div class=function__single _v-445f948b=\"\"><i class=\"fa fa-trash\" _v-445f948b=\"\"></i></div></td></tr></tbody></table><table id=actions_table_mobile class=\"table table-striped table-bordered visible-xs\" _v-445f948b=\"\"><tbody _v-445f948b=\"\"><tr _v-445f948b=\"\"><th _v-445f948b=\"\">No.</th><th _v-445f948b=\"\">Name</th><th _v-445f948b=\"\"></th></tr><tr v-for=\"(key,detail) in actions_details\" _v-445f948b=\"\"><td _v-445f948b=\"\">{{detail.id}}</td><td _v-445f948b=\"\">{{detail.name}}</td><td v-on:click=handleShowActions(key) class=function_group _v-445f948b=\"\"><div class=function__single _v-445f948b=\"\"><i class=\"fa fa-edit\" _v-445f948b=\"\"></i></div><div class=\"function__single hidden\" _v-445f948b=\"\"><i class=\"fa fa-trash\" _v-445f948b=\"\"></i></div></td></tr></tbody></table></tab><tab header=E-mail _v-445f948b=\"\"><table id=email_table class=\"table table-striped table-hover table-bordered hidden-xs\" _v-445f948b=\"\"><tbody _v-445f948b=\"\"><tr _v-445f948b=\"\"><th _v-445f948b=\"\">No.</th><th _v-445f948b=\"\">Manage Group</th><th _v-445f948b=\"\">Email</th><th _v-445f948b=\"\"><i class=\"fa fa-plus-square\" _v-445f948b=\"\"></i></th></tr><tr v-for=\"detail in email_details\" _v-445f948b=\"\"><td _v-445f948b=\"\">{{detail.id}}</td><td _v-445f948b=\"\">{{detail.group}}</td><td _v-445f948b=\"\"><p v-for=\"email in detail.emails\" _v-445f948b=\"\">{{email}}</p></td><td class=function_group _v-445f948b=\"\"><div class=function__single _v-445f948b=\"\"><i class=\"fa fa-edit\" _v-445f948b=\"\"></i></div><div class=function__single _v-445f948b=\"\"><i class=\"fa fa-trash\" _v-445f948b=\"\"></i></div></td></tr></tbody></table><table id=email_table_mobile class=\"table table-striped table-bordered visible-xs\" _v-445f948b=\"\"><tbody _v-445f948b=\"\"><tr _v-445f948b=\"\"><th _v-445f948b=\"\">No.</th><th _v-445f948b=\"\">Manage Group</th><th _v-445f948b=\"\"></th></tr><tr v-for=\"(key,detail) in email_details\" _v-445f948b=\"\"><td _v-445f948b=\"\">{{detail.id}}</td><td _v-445f948b=\"\">{{detail.group}}</td><td v-on:click=handleShowEmail(key) class=function_group _v-445f948b=\"\"><div class=function__single _v-445f948b=\"\"><i class=\"fa fa-edit\" _v-445f948b=\"\"></i></div><div class=\"function__single hidden\" _v-445f948b=\"\"><i class=\"fa fa-trash\" _v-445f948b=\"\"></i></div></td></tr></tbody></table></tab><tab header=SMS _v-445f948b=\"\"><table id=SMS_table class=\"table table-striped table-hover table-bordered hidden-xs\" _v-445f948b=\"\"><tbody _v-445f948b=\"\"><tr _v-445f948b=\"\"><th _v-445f948b=\"\">No.</th><th _v-445f948b=\"\">Manage Group</th><th _v-445f948b=\"\">Phone Number</th><th _v-445f948b=\"\"><i class=\"fa fa-plus-square\" _v-445f948b=\"\"></i></th></tr><tr v-for=\"detail in SMS_details\" _v-445f948b=\"\"><td _v-445f948b=\"\">{{detail.id}}</td><td _v-445f948b=\"\">{{detail.group}}</td><td _v-445f948b=\"\"><p v-for=\"phone in detail.phones\" _v-445f948b=\"\">{{phone}}</p></td><td class=function_group _v-445f948b=\"\"><div class=function__single _v-445f948b=\"\"><i class=\"fa fa-edit\" _v-445f948b=\"\"></i></div><div class=function__single _v-445f948b=\"\"><i class=\"fa fa-trash\" _v-445f948b=\"\"></i></div></td></tr></tbody></table><table id=SMS_table_mobile class=\"table table-striped table-bordered visible-xs\" _v-445f948b=\"\"><tbody _v-445f948b=\"\"><tr _v-445f948b=\"\"><th _v-445f948b=\"\">No.</th><th _v-445f948b=\"\">Manage Group</th><th _v-445f948b=\"\"></th></tr><tr v-for=\"(key,detail) in SMS_details\" _v-445f948b=\"\"><td _v-445f948b=\"\">{{detail.id}}</td><td _v-445f948b=\"\">{{detail.group}}</td><td v-on:click=handleShowSMS(key) class=function_group _v-445f948b=\"\"><div class=function__single _v-445f948b=\"\"><i class=\"fa fa-edit\" _v-445f948b=\"\"></i></div><div class=\"function__single hidden\" _v-445f948b=\"\"><i class=\"fa fa-trash\" _v-445f948b=\"\"></i></div></td></tr></tbody></table></tab></tabs></section></section></div><modal v-bind:show.sync=showM2M v-bind:title=editing.title effect=zoom v-bind:callback=\"\" ok-text=Apply cancel-text=Cancel class=\"popout_m2m_config config_table\" _v-445f948b=\"\"><div slot=modal-body class=modal-body _v-445f948b=\"\"><div class=table-responsive _v-445f948b=\"\"><table id=m2m_table_config class=\"table table-bordered\" _v-445f948b=\"\"><tbody _v-445f948b=\"\"><tr v-for=\"(key, value) in editing.m2m\" _v-445f948b=\"\"><th _v-445f948b=\"\">{{key}}</th><td _v-445f948b=\"\"><p _v-445f948b=\"\">{{value}}</p></td></tr></tbody></table></div></div></modal><modal v-bind:show.sync=showEvents v-bind:title=editing.title effect=zoom v-bind:callback=\"\" ok-text=Apply cancel-text=Cancel class=\"popout_events_config config_table\" _v-445f948b=\"\"><div slot=modal-body class=modal-body _v-445f948b=\"\"><div class=table-responsive _v-445f948b=\"\"><table id=events_table_config class=\"table table-bordered\" _v-445f948b=\"\"><tbody _v-445f948b=\"\"><tr v-for=\"(key, value) in editing.events\" _v-445f948b=\"\"><th _v-445f948b=\"\">{{key}}</th><td _v-445f948b=\"\"><p _v-445f948b=\"\">{{value}}</p></td></tr></tbody></table></div></div></modal><modal v-bind:show.sync=showActions v-bind:title=editing.title effect=zoom v-bind:callback=\"\" ok-text=Apply cancel-text=Cancel class=\"popout_actions_config config_table\" _v-445f948b=\"\"><div slot=modal-body class=modal-body _v-445f948b=\"\"><div class=table-responsive _v-445f948b=\"\"><table id=actions_table_config class=\"table table-bordered\" _v-445f948b=\"\"><tbody _v-445f948b=\"\"><tr v-for=\"(key, value) in editing.actions\" _v-445f948b=\"\"><th _v-445f948b=\"\">{{key}}</th><td _v-445f948b=\"\"><p _v-445f948b=\"\">{{value}}</p></td></tr></tbody></table></div></div></modal><modal v-bind:show.sync=showEmail v-bind:title=editing.title effect=zoom v-bind:callback=\"\" ok-text=Apply cancel-text=Cancel class=\"popout_email_config config_table\" _v-445f948b=\"\"><div slot=modal-body class=modal-body _v-445f948b=\"\"><div class=table-responsive _v-445f948b=\"\"><table id=email_table_config class=\"table table-bordered\" _v-445f948b=\"\"><tbody _v-445f948b=\"\"><tr v-for=\"(key, value) in editing.email\" _v-445f948b=\"\"><th _v-445f948b=\"\">{{key}}</th><td class=value _v-445f948b=\"\"><p _v-445f948b=\"\">{{value}}</p></td></tr></tbody></table></div></div></modal><modal v-bind:show.sync=showSMS v-bind:title=editing.title effect=zoom v-bind:callback=\"\" ok-text=Apply cancel-text=Cancel class=\"popout_SMS_config config_table\" _v-445f948b=\"\"><div slot=modal-body class=modal-body _v-445f948b=\"\"><div class=table-responsive _v-445f948b=\"\"><table id=SMS_table_config class=\"table table-bordered\" _v-445f948b=\"\"><tbody _v-445f948b=\"\"><tr v-for=\"(key, value) in editing.SMS\" _v-445f948b=\"\"><th _v-445f948b=\"\">{{key}}</th><td _v-445f948b=\"\"><p _v-445f948b=\"\">{{value}}</p></td></tr></tbody></table></div></div></modal></div></div>";

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-44cee713=\"\"><div class=row _v-44cee713=\"\"><div class=\"event_main col-md-12\" _v-44cee713=\"\"><header class=\"event_titile_bar main_title_bar clearfix\" _v-44cee713=\"\"><h1 class=\"title col-md-12 col-sm-10 col-xs-12\" _v-44cee713=\"\">{{!showGroupConfig ? 'event' : ' Email / SMS'}}<span class=\"deviceTime col-md-3 pull-right no_pad\" _v-44cee713=\"\">{{deviceTime}}</span></h1></header><section v-if=showAni class=\"animation clearfix\" _v-44cee713=\"\"><div class=spinner-wrap _v-44cee713=\"\"><div class=spinner _v-44cee713=\"\"><i _v-44cee713=\"\"></i><i _v-44cee713=\"\"></i><i _v-44cee713=\"\"></i><i _v-44cee713=\"\"></i><i _v-44cee713=\"\"></i><i _v-44cee713=\"\"></i><i _v-44cee713=\"\"></i><i _v-44cee713=\"\"></i><i _v-44cee713=\"\"></i><i _v-44cee713=\"\"></i><i _v-44cee713=\"\"></i><i _v-44cee713=\"\"></i></div></div></section><div v-if=!showAni class=\"function_group col-xs-12 col-lg-12 clearfix no_pad\" _v-44cee713=\"\"><div v-if=!showGroupConfig class=\"col-xs-5 no_pad-xs col-md-5 col-sm-5 event_pagination\" _v-44cee713=\"\"><div class=\"btn-group col-centered\" _v-44cee713=\"\"><button v-on:click=getEvent(1) v-bind:class=\"{'focus': pageFocus === 1}\" class=\"btn btn-default\" _v-44cee713=\"\"><span _v-44cee713=\"\">1</span></button><button v-on:click=getEvent(2) v-bind:class=\"{'focus': pageFocus === 2}\" class=\"btn btn-default\" _v-44cee713=\"\"><span _v-44cee713=\"\">2</span></button></div></div><button v-on:click=\"showGroupConfig = !showGroupConfig\" class=\"config_switch btn btn-info clearfix\" _v-44cee713=\"\">{{!showGroupConfig ? 'Edit Email/SMS group' : 'Back To Event'}}</button></div><section v-if=\"!showGroupConfig &amp;&amp; !showAni\" class=\"event_content clear-left clearfix\" _v-44cee713=\"\"><table class=\"table table-bordered table-striped event_mobile_table hidden-md hidden-lg\" _v-44cee713=\"\"><tbody _v-44cee713=\"\"><tr _v-44cee713=\"\"><th _v-44cee713=\"\">No.</th><th _v-44cee713=\"\">Enable</th><th _v-44cee713=\"\">Name</th><th _v-44cee713=\"\"></th></tr><tr v-for=\"(key ,event) in events\" _v-44cee713=\"\"><td _v-44cee713=\"\">{{ key }}</td><td class=enabled _v-44cee713=\"\"><i v-if=event.enabled v-on:click=\"setEvent(false, key)\" class=\"fa fa-check-square fa-lg\" _v-44cee713=\"\"></i><i v-else=v-else v-on:click=\"setEvent(true, key)\" class=\"fa fa-square-o fa-lg\" _v-44cee713=\"\"></i></td><td _v-44cee713=\"\">{{ event.name }}</td><td _v-44cee713=\"\"><span v-on:click=toShowModal(key) _v-44cee713=\"\"><i class=\"fa fa-edit\" _v-44cee713=\"\"></i></span></td></tr></tbody></table><table class=\"table table-bordered table-striped table-hover event_table hidden-sm hidden-xs col-md-11 col-lg-10 col-centered hidden-sm hidden-xs\" _v-44cee713=\"\"><tbody _v-44cee713=\"\"><tr _v-44cee713=\"\"><th _v-44cee713=\"\">No.</th><th _v-44cee713=\"\">Enable</th><th class=name _v-44cee713=\"\">Name</th><th _v-44cee713=\"\">I/O</th><th _v-44cee713=\"\">Event</th><th class=actions _v-44cee713=\"\">Actions</th><th _v-44cee713=\"\"></th></tr><tr v-for=\"(key, event) in events\" _v-44cee713=\"\"><td _v-44cee713=\"\">{{ key }}</td><td class=enabled _v-44cee713=\"\"><i v-if=event.enabled v-on:click=\"setEvent(false, key)\" class=\"fa fa-check-square fa-lg\" _v-44cee713=\"\"></i><i v-else=v-else v-on:click=\"setEvent(true, key)\" class=\"fa fa-square-o fa-lg\" _v-44cee713=\"\"></i></td><td class=name _v-44cee713=\"\">{{event.name}}</td><td v-if=\"returnEventName(event.event) !== 'Ping fail'\" class=source _v-44cee713=\"\"><div v-for=\"(key, bank) in allBanks\" v-if=\"event.event.source.indexOf(key.toString()) !== -1\" class=\"col-xs-12 no_pad\" _v-44cee713=\"\"><span data-bgcolor={{key}} class=clearfix _v-44cee713=\"\">{{key === 0 ? 'Input' : 'Outlet' + key}}</span></div></td><td v-else=v-else class=source _v-44cee713=\"\"><div v-else=v-else class=\"col-xs-12 no_pad\" _v-44cee713=\"\"><span class=clearfix _v-44cee713=\"\">-</span></div></td><td class=event _v-44cee713=\"\">{{ returnEventName(event.event) }}</td><td class=action _v-44cee713=\"\"><span v-for=\"ac in event.actions\" class=col_space--xxs _v-44cee713=\"\">{{ac.action}}</span></td><td _v-44cee713=\"\"><span v-on:click=toShowModal(key) _v-44cee713=\"\"><i class=\"fa fa-edit fa-lg\" _v-44cee713=\"\"></i></span></td></tr></tbody></table></section><section v-if=\"showGroupConfig &amp;&amp; !showAni\" class=\"group_editing_section clear-left clearfix\" _v-44cee713=\"\"><div class=\"col-xs-12 col-lg-10 col-centered row_space--xxs\" _v-44cee713=\"\"><tabs _v-44cee713=\"\"><tab header=Email _v-44cee713=\"\"><div class=col-md-12 _v-44cee713=\"\"><table class=\"table table-striped table-hover table-bordered email_group_table\" _v-44cee713=\"\"><tbody _v-44cee713=\"\"><tr _v-44cee713=\"\"><th _v-44cee713=\"\">No</th><th _v-44cee713=\"\">Group Name</th><th class=\"hidden-xs hidden-sm\" _v-44cee713=\"\">Emails</th><th _v-44cee713=\"\"></th></tr><tr v-for=\"(key, group) in emailData\" _v-44cee713=\"\"><td _v-44cee713=\"\">{{key}}</td><td _v-44cee713=\"\">{{group.name}}</td><td class=\"hidden-xs hidden-sm\" _v-44cee713=\"\">{{group.accounts}}</td><td _v-44cee713=\"\"><i v-on:click=\"handleGroupConfig('email', key)\" class=\"fa fa-edit fa-lg\" _v-44cee713=\"\"></i></td></tr></tbody></table></div></tab><tab header=SMS _v-44cee713=\"\"><div class=col-md-12 _v-44cee713=\"\"><table class=\"table table-striped table-hover table-bordered SMS_group_table\" _v-44cee713=\"\"><tbody _v-44cee713=\"\"><tr _v-44cee713=\"\"><th _v-44cee713=\"\">No</th><th _v-44cee713=\"\">Group Name</th><th class=\"hidden-xs hidden-sm\" _v-44cee713=\"\">Numbers</th><th _v-44cee713=\"\"></th></tr><tr v-for=\"(key, group) in SMSData\" _v-44cee713=\"\"><td _v-44cee713=\"\">{{key}}</td><td _v-44cee713=\"\">{{group.name}}</td><td class=\"hidden-xs hidden-sm\" _v-44cee713=\"\">{{group.accounts}}</td><td _v-44cee713=\"\"><i v-on:click=\"handleGroupConfig('SMS', key)\" class=\"fa fa-edit fa-lg\" _v-44cee713=\"\"></i></td></tr></tbody></table></div></tab></tabs></div></section></div></div></div><modal v-bind:show.sync=showModal v-bind:title=editing.title effect=zoom v-bind:callback=handleEventConfig ok-text=Apply cancel-text=Cancel class=\"popout event_config\" _v-44cee713=\"\"><div slot=modal-body class=modal-body _v-44cee713=\"\"><table class=\"table table-bordered event_config_table\" _v-44cee713=\"\"><tbody _v-44cee713=\"\"><tr _v-44cee713=\"\"><th _v-44cee713=\"\">Enable</th><td _v-44cee713=\"\"><div class=fa_checkbox _v-44cee713=\"\"><input type=checkbox v-model=editing.newEvent.enabled v-bind:id=\"'event' + editing.index\" _v-44cee713=\"\"><label v-bind:for=\"'event' + editing.index\" _v-44cee713=\"\"></label></div></td></tr><tr _v-44cee713=\"\"><th _v-44cee713=\"\">Name</th><td _v-44cee713=\"\"><div class=\"col-sm-8 col-md-7 col-lg-6 no_pad\" _v-44cee713=\"\"><validator name=eventName _v-44cee713=\"\"><input type=text v-model=editing.newEvent.name maxlength=7 v-validate:name=\"['engAndNum']\" class=form-control _v-44cee713=\"\"><span v-if=\"$eventName.name.invalid &amp;&amp; $eventName.name.modified\" class=error _v-44cee713=\"\">English characters , numbers and '_' only</span></validator></div></td></tr><tr v-if=\"editing.newEvent.key !== 'Ping'\" _v-44cee713=\"\"><th _v-44cee713=\"\">I/O</th><td class=\"source col-xs-10\" _v-44cee713=\"\"><v-bank v-bind:options=sourceOptions name-prop=source_target v-bind:output.sync=editing.newEvent.newSource _v-44cee713=\"\"></v-bank></td></tr><tr _v-44cee713=\"\"><th _v-44cee713=\"\">Event</th><td _v-44cee713=\"\"><span class=\"col-xs-12 no_pad event_content key\" _v-44cee713=\"\"><div class=\"col-xs-12 no_pad\" _v-44cee713=\"\"><v-single-select v-bind:options=eventOptions v-bind:value.sync=editing.newEvent.key placeholder=\"Please select a key\" _v-44cee713=\"\"></v-single-select></div></span><span v-if=\"editing.newEvent.key === 'Current' || editing.newEvent.key === 'Voltage' || editing.newEvent.key === 'Connection' || editing.newEvent.key === 'Ping'\" class=\"col-xs-12 no_pad event_content condition\" _v-44cee713=\"\"><label _v-44cee713=\"\">Condition</label><div class=\"col-xs-12 no_pad\" _v-44cee713=\"\"><v-single-select v-if=\"editing.newEvent.key === 'Voltage' || editing.newEvent.key === 'Current'\" v-bind:options=conditions v-bind:value.sync=editing.newEvent.condition placeholder=\"Please select a condition\" _v-44cee713=\"\"></v-single-select><v-single-select v-if=\"editing.newEvent.key === 'Connection'\" v-bind:options=connectOptions v-bind:value.sync=editing.newEvent.connect placeholder=\"Please select a condition\" _v-44cee713=\"\"></v-single-select><v-single-select v-if=\"editing.newEvent.key === 'Ping'\" v-bind:options=pingOptions v-bind:value.sync=editing.newEvent.pingCondition placeholder=\"Please select a condition\" _v-44cee713=\"\"></v-single-select></div></span><span v-if=\"editing.newEvent.key === 'Current' || editing.newEvent.key === 'Voltage' || editing.newEvent.key === 'Ping'\" class=\"col-xs-12 no_pad event_content float_value\" _v-44cee713=\"\"><validator name=newEventFloatValue _v-44cee713=\"\"><div v-if=\"editing.newEvent.key !== 'Ping'\" class=\"col-xs-12 no_pad\" _v-44cee713=\"\"><label _v-44cee713=\"\">Value</label></div><div v-if=\"editing.newEvent.key !== 'Ping'\" class=\"col-xs-4 no_pad\" _v-44cee713=\"\"><input type=number v-model=editing.newEvent.float placeholder=\"Please enter a value\" v-validate:float=\"['float']\" v-el:float-input=v-el:float-input class=form-control _v-44cee713=\"\"></div><div v-if=\"editing.newEvent.key === 'Ping'\" class=\"col-xs-12 no_pad\" _v-44cee713=\"\"><label _v-44cee713=\"\">Url/IP</label></div><div v-if=\"editing.newEvent.key === 'Ping'\" class=\"col-xs-6 no_pad\" _v-44cee713=\"\"><input type=text v-model=editing.newEvent.pingAddr placeholder=\"google.com / 192.168.15.2\" v-validate:url=\"['ipOrURL']\" v-el:url-input=v-el:url-input class=form-control _v-44cee713=\"\"></div></validator></span><span v-if=\"editing.newEvent.key === 'Power'\" class=\"col-xs-12 no_pad event_content power_value\" _v-44cee713=\"\"><label _v-44cee713=\"\">Value</label><div class=\"col-xs-12 no_pad\" _v-44cee713=\"\"><v-single-select v-bind:options=powerOptions v-bind:value.sync=editing.newEvent.power placeholder=\"Please select a value\" _v-44cee713=\"\"></v-single-select></div></span></td></tr><tr _v-44cee713=\"\"><th _v-44cee713=\"\">Actions</th><td class=actions _v-44cee713=\"\"><span class=\"col-xs-12 no_pad row_space--xxs clearfix power_on\" _v-44cee713=\"\"><div class=\"fa_checkbox fa_radio\" _v-44cee713=\"\"><input type=checkbox value=\"Power ON\" id=power_on v-model=newActions _v-44cee713=\"\"><label for=power_on v-on:click.prevent=\"selectPowerTypeAction('Power ON')\" _v-44cee713=\"\">Power on</label></div><div class=bank_group _v-44cee713=\"\"><v-multi-banks v-bind:options=sourceOptions v-bind:output-ary.sync=actions.on.targets name-prop=power_on_target v-bind:show-option=\"newActions.indexOf('Power ON') !== -1\" _v-44cee713=\"\"></v-multi-banks></div></span><span class=\"col-xs-12 no_pad row_space--xxs clearfix power_off\" _v-44cee713=\"\"><div class=\"fa_checkbox fa_radio\" _v-44cee713=\"\"><input type=checkbox value=\"Power OFF\" id=power_off v-model=newActions _v-44cee713=\"\"><label for=power_off v-on:click.prevent=\"selectPowerTypeAction('Power OFF')\" _v-44cee713=\"\">Power off</label></div><div class=bank_group _v-44cee713=\"\"><v-multi-banks v-bind:options=sourceOptions v-bind:output-ary.sync=actions.off.targets name-prop=power_off_target v-bind:show-option=\"newActions.indexOf('Power OFF') !== -1\" _v-44cee713=\"\"></v-multi-banks></div></span><span class=\"col-xs-12 no_pad row_space--xxs clearfix power_reset\" _v-44cee713=\"\"><div class=\"fa_checkbox fa_radio\" _v-44cee713=\"\"><input type=checkbox value=\"Power RESET\" id=power_reset v-model=newActions _v-44cee713=\"\"><label for=power_reset v-on:click.prevent=\"selectPowerTypeAction('Power RESET')\" _v-44cee713=\"\">Power reset</label></div><div class=bank_group _v-44cee713=\"\"><v-multi-banks v-bind:options=sourceOptions v-bind:output-ary.sync=actions.reset.targets name-prop=power_reset v-bind:show-option=\"newActions.indexOf('Power RESET') !== -1\" _v-44cee713=\"\"></v-multi-banks></div></span><span class=\"col-xs-12 no_pad row_space--xxs clearfix sequence_on\" _v-44cee713=\"\"><div class=\"fa_checkbox fa_radio\" _v-44cee713=\"\"><input type=checkbox value=\"Sequence ON\" id=sequence_on v-model=newActions _v-44cee713=\"\"><label for=sequence_on v-on:click.prevent=\"selectPowerTypeAction('Sequence ON')\" _v-44cee713=\"\">Sequence on<span _v-44cee713=\"\">(From outlet1 to outlet9)</span></label></div><span v-if=\"newActions.indexOf('Sequence ON') !== -1\" _v-44cee713=\"\"><span class=\"row_space--xxs delay\" _v-44cee713=\"\"><validator name=seqON _v-44cee713=\"\"><label _v-44cee713=\"\">Delay time(sec)</label><input type=number v-model=actions.sqON.value v-validate:delay=\"['int']\" class=form-control _v-44cee713=\"\"></validator></span></span></span><span class=\"col-xs-12 no_pad row_space--xxs clearfix sequence_off\" _v-44cee713=\"\"><div class=\"fa_checkbox fa_radio\" _v-44cee713=\"\"><input type=checkbox value=\"Sequence OFF\" id=sequence_off v-model=newActions _v-44cee713=\"\"><label for=sequence_off v-on:click.prevent=\"selectPowerTypeAction('Sequence OFF')\" _v-44cee713=\"\">Sequence off<span _v-44cee713=\"\">(From outlet1 to outlet9)</span></label></div><span v-if=\"newActions.indexOf('Sequence OFF') !== -1\" _v-44cee713=\"\"><span class=\"row_space--xxs delay\" _v-44cee713=\"\"><validator name=seqOFF _v-44cee713=\"\"><label _v-44cee713=\"\">Delay time(sec)</label><input type=number v-model=actions.sqOFF.value v-validate:delay=\"['int']\" class=form-control _v-44cee713=\"\"></validator></span></span></span><span v-if=\"emailGroups.options.length !== 0\" class=\"col-xs-12 no_pad row_space--xxs clearfix email\" _v-44cee713=\"\"><div class=fa_checkbox _v-44cee713=\"\"><input type=checkbox value=Email id=email v-model=newActions v-bind:checked=\"editing.actionKeys.indexOf('Email') !== -1\" _v-44cee713=\"\"><label for=email v-on:click.prevent=\"clickGroups('Email')\" _v-44cee713=\"\">email</label></div><span v-if=\"newActions.indexOf('Email') !== -1\" class=\"no_pad col-xs-12 row_space--xxs\" _v-44cee713=\"\"><v-select v-bind:selected=emailGroups.selected v-bind:show-labels=true v-bind:options=emailGroups.options v-bind:taggable=true v-bind:multiple=true v-bind:limit=2 label=label key=value @update=updateEmailGroupSelected _v-44cee713=\"\"></v-select></span></span><span v-else=v-else class=\"col-xs-12 no_pad row_space--xxs clearfix actionReminding\" _v-44cee713=\"\">You need to have at least 1 valid Email group to set Email action</span><span v-if=\"SMSGroups.options.length !== 0\" class=\"col-xs-12 no_pad row_space--xxs clearfix SMS\" _v-44cee713=\"\"><div class=fa_checkbox _v-44cee713=\"\"><input type=checkbox value=SMS id=SMS v-model=newActions v-bind:checked=\"editing.actionKeys.indexOf('SMS') !== -1\" _v-44cee713=\"\"><label for=SMS v-on:click.prevent=\"clickGroups('SMS')\" _v-44cee713=\"\">SMS</label></div><span v-if=\"newActions.indexOf('SMS') !== -1\" class=\"no_pad col-xs-12 row_space--xxs\" _v-44cee713=\"\"><v-select v-bind:selected=SMSGroups.selected v-bind:show-labels=true v-bind:options=SMSGroups.options v-bind:taggable=true v-bind:multiple=true v-bind:limit=2 @update=updateSMSGroupSelected label=label key=value _v-44cee713=\"\"></v-select></span></span><span v-else=v-else class=\"no_pad col-xs-12 row_space--xxs actionReminding\" _v-44cee713=\"\">You need to have at least 1 valid SMS group to set SMS action</span></td></tr></tbody></table></div></modal><modal v-bind:title=editingGroup.title v-bind:show.sync=showGroupConfigTable effect=zoom v-bind:callback=editingGroup.cb ok-text=Apply cancel-text=Cancel class=\"popout group_config\" _v-44cee713=\"\"><div slot=modal-body class=\"modal-body clearfix\" _v-44cee713=\"\"><div class=\"col-md-6 row_space--xxs\" _v-44cee713=\"\"><label _v-44cee713=\"\">Group Name</label><br _v-44cee713=\"\"><span class=hint _v-44cee713=\"\">(Use a name different from other group)</span><validator name=groupName _v-44cee713=\"\"><input v-model=editingGroup.data.name maxlength=7 v-validate:name=\"['engAndNum']\" class=form-control _v-44cee713=\"\"><span v-if=\"$groupName.name.invalid &amp;&amp; $groupName.name.modified\" class=error _v-44cee713=\"\">English characters , numbers and '_' only</span></validator></div><div class=\"col-md-6 row_space--xxs\" _v-44cee713=\"\"><label _v-44cee713=\"\">Group Accouts</label><br _v-44cee713=\"\"><span class=hint _v-44cee713=\"\">({{editingGroup.format}})</span><textarea v-model=editingGroup.data.accounts placeholder=\"Please use ';' to separate multiple accounts. Empty to disable this group.\" rows=8 class=form-control _v-44cee713=\"\"></textarea></div></div></modal>";

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

	module.exports = " <div class=btn-group v-bind:class=\"{open: show}\" _v-4cbf10ea=\"\"> <button v-el:btn=\"\" type=button class=\"btn btn-default dropdown-toggle\" @click=toggleDropdown @blur=\"show = (search ? show : false)\" v-bind=\"{disabled: disabled}\" _v-4cbf10ea=\"\"> <span class=btn-placeholder v-show=showPlaceholder _v-4cbf10ea=\"\">{{placeholder}}</span> <span class=btn-content _v-4cbf10ea=\"\">{{ selectedItems }}</span> <span class=caret _v-4cbf10ea=\"\"></span> </button> <ul class=dropdown-menu _v-4cbf10ea=\"\"> <template v-if=options.length> <li v-if=search class=bs-searchbox _v-4cbf10ea=\"\"> <input type=text placeholder=Search v-model=searchText class=form-control autocomplete=off _v-4cbf10ea=\"\"> </li> <li v-for=\"option in options | filterBy searchText \" v-bind:id=option.value style=position:relative v-bind:class=\"{'hidden': option.isFake}\" _v-4cbf10ea=\"\"> <a @mousedown.prevent=select(option.value) style=cursor:pointer _v-4cbf10ea=\"\"> {{ option.label }} <span class=\"glyphicon glyphicon-ok check-mark\" v-show=isSelected(option.value) _v-4cbf10ea=\"\"></span> </a> </li> </template> <slot v-else=\"\" _v-4cbf10ea=\"\"></slot> <div class=notify v-show=showNotify transition=fadein _v-4cbf10ea=\"\">Limit reached ({{limit}} items max). </div> </ul> </div> ";

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-4dce2945=\"\"><div class=row _v-4dce2945=\"\"><div class=\"status_main col-md-12\" _v-4dce2945=\"\"><header class=\"config_title_bar main_title_bar clearfix\" _v-4dce2945=\"\"><h1 class=\"title col-md-2 col-lg-2 col-sm-2 col-xs-3 clearfix\" _v-4dce2945=\"\">Status</h1><v-loader v-bind:ani-key=\"'6'\" v-if=showLoadingProfile class=\"col-lg-2 col-lg-offset-3 col-md-2 col-md-offset-3 col-sm-1 col-sm-offset-3 col-xs-2 col-xs-offset-0\" _v-4dce2945=\"\"></v-loader><div class=\"window_setting col-lg-2 col-md-2 col-xs-2 row_space--xxs pull-right\" _v-4dce2945=\"\"><i v-on:click=\"showOutSetting=true\" class=\"fa fa-cog fa-2x\" _v-4dce2945=\"\"></i></div></header><section class=status_content _v-4dce2945=\"\"><section class=\"screen_block clearfix col-md-12 col-lg-12 no_pad\" _v-4dce2945=\"\"><section class=\"screen_section col-xs-12 col-sm-7 col-md-7 col-lg-8 row_space--xxs no_pad clearfix\" _v-4dce2945=\"\"><v-screen v-bind:out-ratio.sync=outRatio v-bind:splits.sync=splits.setting v-bind:out-resolution.sync=outResolution v-bind:out-resolution-options.sync=outResolutionOptions v-bind:out-layout.sync=outLayout v-bind:which-split.sync=whichSplit v-bind:editable=false v-bind:layer.sync=splitLayer v-bind:show-ps=true v-bind:label.sync=label v-bind:mapping.sync=mapping v-bind:show-link=true _v-4dce2945=\"\"></v-screen></section><section class=\"function_section col-xs-12 col-sm-5 col-md-5 col-lg-4 clearfix no_pad-xxs\" _v-4dce2945=\"\"><div class=\"col-xs-12 col-md-12 full_screen_btn_group col-centered clearfix no_pad-xxs\" _v-4dce2945=\"\"><header class=\"row_space--xxs hidden-xs\" _v-4dce2945=\"\"><label _v-4dce2945=\"\">Full Screen</label></header><div v-for=\"(key,opt) in fullScreenOptions\" class=\"col-xs-3 col-sm-3 col-md-3 full__btn__single clearfix\" _v-4dce2945=\"\"><button v-on:click=sendKeyToDevice(opt.splitOptionKey) v-bind:disabled=buttonDisabled class=\"btn btn-default clearfix btn-square-xs\" _v-4dce2945=\"\">{{opt.label}}</button></div></div><div class=\"col-xs-12 col-md-12 quick_selection_btn_group col-centered clearfix no_pad-xxs\" _v-4dce2945=\"\"><header class=\"row_space--xxs hidden-xs\" _v-4dce2945=\"\"><label _v-4dce2945=\"\">Quick Selection</label></header><div v-for=\"(key, opt) in quickSelectionOptions\" class=\"quick__btn__single pull-left\" _v-4dce2945=\"\"><button v-on:click=sendKeyToDevice(opt.splitOptionKey) v-bind:disabled=\"in4K &amp;&amp; opt.splitOptionKey !== 'PAP1' || buttonDisabled\" class=\"btn btn-default clearfix btn-square-xs\" _v-4dce2945=\"\"><img v-bind:src=icons.quick[key] class=icon _v-4dce2945=\"\"></button></div></div><div class=\"col-xs-12 col-md-12 custom_btn_group col-centered clearfix\" _v-4dce2945=\"\"><header class=\"row_space--xxs hidden-xs\" _v-4dce2945=\"\"><label _v-4dce2945=\"\">Custom Preset</label></header><div v-for=\"opt in customProfileOptions\" class=\"custom__btn__single col-xs-3 col-sm-3 col-md-3 clearfix\" _v-4dce2945=\"\"><button v-on:click=\"changeProps('custom', opt.value, opt.value)\" v-bind:disabled=\"in4K || buttonDisabled\" class=\"btn btn-default btn-square-xs no_pad\" _v-4dce2945=\"\"><span _v-4dce2945=\"\"><i class=\"fa fa-user\" _v-4dce2945=\"\">&nbsp;{{opt.label}}</i></span><br _v-4dce2945=\"\"><span class=profile_name _v-4dce2945=\"\">{{opt.name}}</span></button></div></div></section></section></section></div><modal title=Settings v-bind:show.sync=showOutSetting effect=fade ok-text=Apply cancel-text=Cancel backdrop=false class=window_setting_modal _v-4dce2945=\"\"><div slot=modal-header class=modal-header _v-4dce2945=\"\"><button v-on:click=\"showOutSetting = false\" v-bind:disabled.sync=isUpdatingProfile class=close _v-4dce2945=\"\"><span _v-4dce2945=\"\">×</span></button><h4 class=modal-title _v-4dce2945=\"\">Settings</h4></div><div slot=modal-body class=\"modal-body clearfix\" _v-4dce2945=\"\"><tabs _v-4dce2945=\"\"><tab header=Source _v-4dce2945=\"\"><section class=\"source_sec clearfix col-md-12 outer_group\" _v-4dce2945=\"\"><div class=col-md-12 _v-4dce2945=\"\"><h3 class=title _v-4dce2945=\"\">Source Setting</h3></div><label class=\"col-xs-12 clearfix\" _v-4dce2945=\"\">Name</label><div class=\"col-xs-12 col-sm-6 clearfix source__single\" _v-4dce2945=\"\"><label _v-4dce2945=\"\">Source1:</label><input type=text v-model=editing.sourceLabel[1].text class=form-control _v-4dce2945=\"\"></div><div class=\"col-xs-12 col-sm-6 clearfix source__single\" _v-4dce2945=\"\"><label _v-4dce2945=\"\">Source2:</label><input type=text v-model=editing.sourceLabel[2].text class=form-control _v-4dce2945=\"\"></div><div class=\"col-xs-12 col-sm-6 clearfix source__single\" _v-4dce2945=\"\"><label _v-4dce2945=\"\">Source3:</label><input type=text v-model=editing.sourceLabel[3].text class=form-control _v-4dce2945=\"\"></div><div class=\"col-xs-12 col-sm-6 clearfix source__single\" _v-4dce2945=\"\"><label _v-4dce2945=\"\">Source4:</label><input type=text v-model=editing.sourceLabel[4].text class=form-control _v-4dce2945=\"\"></div><div class=\"col-xs-3 col-xs-offset-9 col-sm-3 col-sm-offset-9 row_space--xs\" _v-4dce2945=\"\"><button v-on:click=applySourceLabel v-bind:disabled.sync=isUpdatingProfile class=\"btn btn-primary pull-right\" _v-4dce2945=\"\">Apply</button></div></section></tab><tab header=Output _v-4dce2945=\"\"><section class=\"resolution_sec clearfix col-md-12 outer_group\" _v-4dce2945=\"\"><div class=col-md-12 _v-4dce2945=\"\"><h3 class=title _v-4dce2945=\"\">Output Setting</h3></div><div class=\"col-xs-12 col-sm-12 clearfix\" _v-4dce2945=\"\"><label class=\"col-xs-4 no_pad\" _v-4dce2945=\"\">Output Resolution:&nbsp;</label><v-select v-bind:options=computedOutResolutionOptions v-bind:value.sync=editing.outResolution _v-4dce2945=\"\"></v-select></div><div class=\"col-xs-12 col-sm-12 row_space--xs\" _v-4dce2945=\"\"><span v-if=isUpdatingProfile class=\"pull-left reminding\" _v-4dce2945=\"\">Updating all preset..., this might take about 30secs</span><button v-on:click=applyOutputResolution v-bind:disabled.sync=isUpdatingProfile class=\"btn btn-primary pull-right\" _v-4dce2945=\"\">Apply</button></div></section></tab><tab header=Sound _v-4dce2945=\"\"><section class=\"sound_sec clear-fix outer_group col-md-12\" _v-4dce2945=\"\"><div class=col-md-12 _v-4dce2945=\"\"><h3 class=title _v-4dce2945=\"\">Sound</h3></div><div class=\"col-xs-12 sound__single\" _v-4dce2945=\"\"><label class=\"col-xs-5 col-md-4 no_pad clear-right\" _v-4dce2945=\"\">Sound from:</label><v-select v-bind:options=soundFromOptions v-bind:value.sync=editing.outSound.soundFrom class=col-xs-7 _v-4dce2945=\"\"></v-select></div><div class=\"col-xs-12 sound__single\" _v-4dce2945=\"\"><label class=\"col-xs-5 col-md-4 no_pad clear-right\" _v-4dce2945=\"\">R/L Channel:</label><v-select v-bind:options=channelOptions v-bind:value.sync=editing.outSound.soundRLChannel class=col-xs-7 _v-4dce2945=\"\"></v-select></div><div class=\"fa_checkbox col-xs-12\" _v-4dce2945=\"\"><input id=audio type=checkbox v-model=editing.outSound.fullScreenAudio _v-4dce2945=\"\"><label for=audio _v-4dce2945=\"\"><span _v-4dce2945=\"\">Audio follows Windows when full screen</span></label></div><div class=\"fa_checkbox col-xs-12\" _v-4dce2945=\"\"><input id=mute type=checkbox v-model=editing.outSound.mute _v-4dce2945=\"\"><label for=mute _v-4dce2945=\"\"><span _v-4dce2945=\"\">Mute</span></label></div><div class=col-xs-12 _v-4dce2945=\"\"><button v-on:click=\"applySingleAPI('dxSetOutputSound', 'outSound', 'sound')\" v-bind:disabled.sync=isUpdatingProfile class=\"btn btn-primary pull-right\" _v-4dce2945=\"\">Apply</button></div></section></tab></tabs></div><div slot=modal-footer class=\"modal-footer clearfix\" _v-4dce2945=\"\"><button v-on:click=\"showOutSetting = false\" v-bind:disabled.sync=isUpdatingProfile class=\"btn btn-default\" _v-4dce2945=\"\">Cancel</button></div></modal></div></div>";

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"p_section col-md-12 col-sm-12 row_space--xs no_pad-xxs clearfix\" _v-50f07e41=\"\"><div class=btn-group _v-50f07e41=\"\"><button @click.prevent=setPage(currPage-1) v-bind:class=\"{'disabled': (currPage === 1)}\" class=\"btn btn-default arrow\" _v-50f07e41=\"\"><span class=\"glyphicon glyphicon-chevron-left\" _v-50f07e41=\"\"></span></button><button @click=setPaginationSec(currPaginationSec-1) v-if=\"currPaginationSec !== 1\" class=\"btn btn-default more\" _v-50f07e41=\"\"> ...</button><button @click.prevent=setPage(n+1) v-for=\"n in totalPageAry | limitBy countOfPagination paginationStart\" v-bind:class=\"{'active': (currPage === (n+1))}\" class=\"btn btn-default page\" _v-50f07e41=\"\"> {{n+1}}</button><button @click=setPaginationSec(currPaginationSec+1) v-if=\"currPaginationSec !== totalSection\" class=\"btn btn-default more\" _v-50f07e41=\"\"> ...</button><button @click.prevent=setPage(currPage+1) v-bind:class=\"{'disabled': (currPage === totalPage)}\" class=\"btn btn-default arrow\" _v-50f07e41=\"\"><span class=\"glyphicon glyphicon-chevron-right\" _v-50f07e41=\"\"></span></button></div></div>";

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-51316e8e=\"\"><div class=row _v-51316e8e=\"\"><div v-if=!loadingData class=\"setting_main col-md-12\" _v-51316e8e=\"\"><header class=\"setting_title_bar main_title_bar clearfix\" _v-51316e8e=\"\"><h1 class=\"title col-md-10 col-sm-10 col-xs-12\" _v-51316e8e=\"\">settings<span v-if=\"$route.name === 'power'\" class=\"deviceTime col-md-3 pull-right no_pad\" _v-51316e8e=\"\">{{deviceTime}}</span></h1></header><section class=\"information_section col-md-12 col-sm-12 col-xs-12 row_space--xs no_pad-xs\" _v-51316e8e=\"\"><h2 class=title_bar _v-51316e8e=\"\">information</h2><div class=\"id_group col-lg-8 col-md-10 col-sm-12 col-xs-12 col-centered clearfix\" _v-51316e8e=\"\"><template v-for=\"(key,data) in device\"><div v-if=\"key !== 'description'\" class=\"id__single col-lg-6 col-md-6 col-sm-12 col-xs-12 clearfix\" _v-51316e8e=\"\"><div class=\"id_key col-lg-6 col-md-6 col-sm-4 col-xs-6 clearfix\" _v-51316e8e=\"\"><span class=key _v-51316e8e=\"\">{{ namesToShow[key] }}</span></div><div v-if=\"key === 'typeId'\" class=\"id_value col-lg-6 col-md-6 col-sm-8 col-xs-6 clearfix\" _v-51316e8e=\"\"><span class=value _v-51316e8e=\"\">{{ isSwitcher ? 'Switch' : types[data] }}</span></div><div v-else=v-else class=\"id_value col-lg-6 col-md-6 col-sm-8 col-xs-6 clearfix\" _v-51316e8e=\"\"><span class=value _v-51316e8e=\"\">{{ data }}</span></div></div><div v-else=v-else class=\"id__single col-md-12 col-sm-12\" _v-51316e8e=\"\"><a href=javascript:void(0); _v-51316e8e=\"\"><div class=\"id_key col-md-3 col-sm-4 col-xs-6 description\" _v-51316e8e=\"\"><span class=key _v-51316e8e=\"\">{{ namesToShow[key] }}</span></div><div class=\"id_value col-lg-6 col-md-6 col-sm-8 col-xs-6 description_value\" _v-51316e8e=\"\"><span class=value _v-51316e8e=\"\">{{ data }}</span></div></a></div></template></div></section><section class=\"identification_section col-md-12 col-sm-12 col-xs-12 row_space--xs no_pad-xs\" _v-51316e8e=\"\"><h2 class=title_bar _v-51316e8e=\"\">identification</h2><div class=\"device_name col-lg-10 col-md-10 col-sm-12 col-xs-12 clearfix no_pad-xs\" _v-51316e8e=\"\"><div class=col-xs-12 _v-51316e8e=\"\"><label _v-51316e8e=\"\">Device Name:</label></div><div class=\"col-xs-8 col-sm-4 col-lg-3\" _v-51316e8e=\"\"><span _v-51316e8e=\"\"><validator name=deviceNameValidator _v-51316e8e=\"\"><input v-model=newNickname maxlength=12 v-validate:devicename=\"['deviceValid']\" class=\"input form-control\" _v-51316e8e=\"\"></validator><span v-show=\"$deviceNameValidator.devicename.invalid &amp;&amp; $deviceNameValidator.devicename.modified\" class=error _v-51316e8e=\"\">Only English characters, numbers ,'-' and '_' allowed</span></span></div><div class=\"apply col-xs-4 col-sm-4 col-lg-3\" _v-51316e8e=\"\"><button v-on:click=chgName class=\"btn btn-success\" _v-51316e8e=\"\">apply</button></div></div></section><section v-if=\"$route.name === 'power' || $route.name === 'dio'\" class=\"time_zone_section col-md-12 col-sm-12 col-xs-12 row_space--xs no_pad-xs\" _v-51316e8e=\"\"><h2 class=title_bar _v-51316e8e=\"\">Time</h2><div class=col-xs-12 _v-51316e8e=\"\"><label _v-51316e8e=\"\">Device Time:</label></div><div class=\"col-sm-12 col-md-12 clearfix no_pad-xs\" _v-51316e8e=\"\"><div class=\"col-xs-12 col-md-12clearfix title\" _v-51316e8e=\"\"><span _v-51316e8e=\"\">UTC</span></div><div class=\"col-xs-12 col-md-12 clearfix time\" _v-51316e8e=\"\"><span _v-51316e8e=\"\">{{utcTime}}</span></div><div class=\"col-xs-12 col-md-12 clearfix title\" _v-51316e8e=\"\"><span _v-51316e8e=\"\">{{timezone.id}}</span></div><div class=\"col-xs-12 col-md-12 clearfix time\" _v-51316e8e=\"\"><span _v-51316e8e=\"\">{{deviceTime}}</span></div></div><div class=col-xs-12 _v-51316e8e=\"\"><label _v-51316e8e=\"\">Device Time Zone:</label></div><div class=\"col-sm-12 col-md-10 clearfix no_pad-xs\" _v-51316e8e=\"\"><div class=\"selector col-xs-12\" _v-51316e8e=\"\"><select v-model=timezoneIndex class=form-control _v-51316e8e=\"\"><option v-for=\"opt in timezoneUIOptions\" v-bind:value=opt.value v-bind:selected.once=\"opt.value === timezoneIndex\" _v-51316e8e=\"\">{{opt.label}}</option></select></div><div class=\"apply col-xs-12\" _v-51316e8e=\"\"><button v-on:click=applyTimeZone class=\"btn btn-success\" _v-51316e8e=\"\">Apply</button></div></div></section><section class=\"network_section col-md-12 col-sm-12 col-xs-12 row_space--xs no_pad-xs\" _v-51316e8e=\"\"><h2 class=title_bar _v-51316e8e=\"\">network</h2><div class=\"dhcp_config col-lg-7 col-md-7 col-sm-12 col-xs-12 row_space--xxs no_pad-xs\" _v-51316e8e=\"\"><validator name=dhcpValidation _v-51316e8e=\"\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\" _v-51316e8e=\"\"><span _v-51316e8e=\"\">IP Address</span><input v-model=editting.deviceIpAddress maxlength=15 v-validate:ip=\"['ipAddress']\" disabled=true class=form-control _v-51316e8e=\"\"><span v-show=\"$dhcpValidation.ip.invalid &amp;&amp; $dhcpValidation.ip.modified\" class=error _v-51316e8e=\"\">Please enter valid ip address</span></div><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\" _v-51316e8e=\"\"><span _v-51316e8e=\"\">Netmask</span><input v-model=editting.deviceSubnetMask maxlength=15 v-validate:netmask=\"['ipAddress']\" disabled=true class=form-control _v-51316e8e=\"\"><span v-show=\"$dhcpValidation.netmask.invalid &amp;&amp; $dhcpValidation.netmask.modified\" class=error _v-51316e8e=\"\">Please enter valid netmask</span></div><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\" _v-51316e8e=\"\"><span _v-51316e8e=\"\">Gateway</span><input v-model=editting.deviceDefaultGateway maxlength=15 v-validate:gateway=\"['ipAddress']\" disabled=true class=form-control _v-51316e8e=\"\"><span v-show=\"$dhcpValidation.gateway.invalid &amp;&amp; $dhcpValidation.gateway.modified\" class=error _v-51316e8e=\"\">Please enter valid gateway</span></div></validator></div></section><section class=\"maintenance_section col-md-12 col-sm-12 col-xs-12 row_space--xs no_pad-xs\" _v-51316e8e=\"\"><h2 class=title_bar _v-51316e8e=\"\">maintenance</h2><div class=\"btn_group col-lg-12 col-md-12 col-sm-8 col-xs-12 col-centered\" _v-51316e8e=\"\"><button v-on:click=reboot v-show=capability.system.reboot class=\"btn btn-danger clearfix col-lg-2 col-lg-offset-0 col-md-3 col-md-offset-0 col-sm-8 col-sm-offset-2 col-xs-12\" _v-51316e8e=\"\"><i class=\"fa fa-rotate-left\" _v-51316e8e=\"\"></i>reboot</button></div><modal title=Confirm v-bind:show.sync=showConfirm effect=zoom v-bind:callback=confirmCb ok-text=Yes cancel-text=Cancel class=confirm_modal _v-51316e8e=\"\"><div slot=modal-body class=\"modal-body clearfix\" _v-51316e8e=\"\">{{ confirmMsg }}</div></modal></section></div></div></div>";

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid clearfix\" _v-5362f87d=\"\"><div v-if=isMobile class=mask _v-5362f87d=\"\"><h2 _v-5362f87d=\"\">Please rotate your mobile to show config</h2></div><div class=row _v-5362f87d=\"\"><div class=\"layout_main col-md-12\" _v-5362f87d=\"\"><header class=\"layout_title_bar main_title_bar clearfix\" _v-5362f87d=\"\"><h1 class=\"title col-md-4 col-sm-3 col-xs-3 clearfix no_margin_v-xs\" _v-5362f87d=\"\">Layout</h1><div class=\"function_group col-xs-4 col-md-4 pull-right\" _v-5362f87d=\"\"><div class=\"col-xs-4 no_pad-xs clearfix function__single save_profile_btn pull-right\" _v-5362f87d=\"\"><dropdown class=\"col-md-12 no_pad\" _v-5362f87d=\"\"><button slot=button type=button class=\"col-sm-12 col-md-12 col-lg-12 btn btn-primary dropdown-toggle\" _v-5362f87d=\"\"><i class=\"fa fa-save fa-lg\" _v-5362f87d=\"\"></i><span class=caret _v-5362f87d=\"\"></span></button><ul slot=dropdown-menu class=dropdown-menu _v-5362f87d=\"\"><li v-for=\"(key, opt) in profileOptions\" _v-5362f87d=\"\"><a v-on:click=saveProfile(opt.value) _v-5362f87d=\"\">{{opt.label}}</a></li></ul></dropdown></div><div class=\"col-xs-4 no_pad-xs clearfix function__single edit_window pull-right\" _v-5362f87d=\"\"><button v-on:click=handleWindowConfig class=\"btn btn-primary col-sm-12 col-md-12 col-lg-12\" _v-5362f87d=\"\"><i class=\"fa fa-cog fa-lg\" _v-5362f87d=\"\"></i></button></div></div><div class=\"ps_group col-xs-5 col-sm-5 col-md-4 no_pad clearfix row_space--xxs pull-right\" _v-5362f87d=\"\"><span class=ps _v-5362f87d=\"\">Output Resolution: {{outResolutionOptions[outResolution]}}</span></div></header><section class=\"layout_content clearfix\" _v-5362f87d=\"\"><section class=\"screen_block clearfix col-xs-12 col-md-12 col-lg-11 col-centered no_pad\" _v-5362f87d=\"\"><section v-on:click=\"layoutChanged = true\" class=\"screen_container clearfix col-xs-9 col-sm-9 col-md-9 no_pad\" _v-5362f87d=\"\"><v-screen v-bind:out-ratio.sync=outRatio v-bind:splits.sync=splits.setting v-bind:out-resolution.sync=outResolution v-bind:out-resolution-options.sync=outResolutionOptions v-bind:out-layout.sync=outLayout v-bind:which-split.sync=whichSplit v-bind:window-focus.sync=focus v-bind:layer.sync=editing.splitLayer v-bind:show-window-config.sync=showWindowConfig v-bind:label.sync=label v-bind:resize-event.sync=InteractEvent v-bind:mapping.sync=mapping v-bind:editable=!in4K class=clearfix _v-5362f87d=\"\"></v-screen></section><section class=\"layer_functions_sec col-xs-3 col-sm-3 col-md-3 clearfix\" _v-5362f87d=\"\"><div class=\"layer_title col-md-12 no_pad-xs\" _v-5362f87d=\"\"><h3 _v-5362f87d=\"\">Layer</h3></div><div v-if=!in4K class=\"layer_area col-xs-12 clearfix no_pad-xs\" _v-5362f87d=\"\"><ul v-sortable={onEnd:onSortEnd} class=\"dropzone clearfix\" _v-5362f87d=\"\"><li v-for=\"(key, layer) in editing.splitLayer\" v-bind:data-index=layer v-bind:data-bgcolor=layer v-bind:class=\"{'focusMenu': focus === editing.splitLayer[key].toString()}\" v-on:click=\"focus = editing.splitLayer[key].toString()\" class=dragItem _v-5362f87d=\"\"><span class=\"token col-xs-12 clearfix\" _v-5362f87d=\"\">{{layerNameAry[layer]}}</span></li></ul></div><div v-else=v-else class=\"layer_area col-xs-12 clearfix no_pad-xs\" _v-5362f87d=\"\"><ul class=\"dropzone clearfix\" _v-5362f87d=\"\"><li v-for=\"(key, layer) in editing.splitLayer\" v-bind:data-index=layer v-bind:data-bgcolor=layer v-bind:class=\"{'focusMenu': focus === editing.splitLayer[key].toString()}\" v-on:click=\"focus = editing.splitLayer[key].toString()\" class=dragItem _v-5362f87d=\"\"><span class=\"token col-xs-12 clearfix\" _v-5362f87d=\"\">{{layerNameAry[layer]}}</span></li></ul></div><div class=\"input_detail col-xs-12 clearfix no_pad-xs\" _v-5362f87d=\"\"><div class=\"col-xs-6 col-md-6 h_start\" _v-5362f87d=\"\"><input type=number min=0 v-model=splits.setting[focus][0] v-on:change=onInputChange(0) class=\"col-xs-6 form-control\" _v-5362f87d=\"\"></div><div class=\"col-xs-6 col-md-6 h_end\" _v-5362f87d=\"\"><input type=number min=0 v-model=splits.setting[focus][2] v-on:change=onInputChange(2) class=\"col-xs-6 form-control\" _v-5362f87d=\"\"></div><div class=\"col-xs-6 col-md-6 v_start\" _v-5362f87d=\"\"><input type=number min=0 v-model=splits.setting[focus][1] v-on:change=onInputChange(1) class=\"col-xs-6 form-control\" _v-5362f87d=\"\"></div><div class=\"col-xs-6 col-md-6 v_end\" _v-5362f87d=\"\"><input type=number min=0 v-model=splits.setting[focus][3] v-on:change=onInputChange(3) class=\"col-xs-6 form-control\" _v-5362f87d=\"\"></div></div></section></section></section></div><modal ok-text=Apply cancel-text=Cancel effect=zoom v-bind:callback=applyWindowConfig v-bind:show.sync=showWindowConfig v-bind:title=editingWindow.title backdrop=false class=single_window_config _v-5362f87d=\"\"><div slot=modal-body class=\"modal-body clearfix row_space--xxs\" _v-5362f87d=\"\"><tabs _v-5362f87d=\"\"><tab header=Source _v-5362f87d=\"\"><section class=\"window_setting_section col-xs-12 clearfix\" _v-5362f87d=\"\"><span _v-5362f87d=\"\">Selected Source:&nbsp;</span><v-select v-bind:options=sourceOptions v-bind:value.sync=editingWindow.mapping[focus] _v-5362f87d=\"\"></v-select><br _v-5362f87d=\"\"><span _v-5362f87d=\"\">Original Resolution: {{outResolutionOptions[outResolution]}}</span><button v-on:click=applyChgSource() class=\"btn btn-primary applySourceBtn\" _v-5362f87d=\"\">Apply</button></section></tab><tab header=Label _v-5362f87d=\"\"><section class=\"source_selection_section col-xs-12\" _v-5362f87d=\"\"><section class=\"col-xs-12 clearfix no_pad\" _v-5362f87d=\"\"><div class=\"fa_checkbox col-xs-12\" _v-5362f87d=\"\"><input id=osdLabel type=checkbox v-model=editingWindow.osd.enabled _v-5362f87d=\"\"><label for=osdLabel _v-5362f87d=\"\"><span _v-5362f87d=\"\">Enable OSD</span></label></div><div v-bind:class=\"{'disabled': !editingWindow.osd.enabled}\" v-bind:disabled=!editingWindow.osd.enabled class=\"fa_checkbox col-xs-4\" _v-5362f87d=\"\"><input id=winLabel type=checkbox v-model=editingWindow.window.enabled v-bind:disabled=!editingWindow.osd.enabled _v-5362f87d=\"\"><label for=winLabel _v-5362f87d=\"\"><span _v-5362f87d=\"\">Window Label</span></label></div><div v-bind:class=\"{'disabled': !editingWindow.osd.enabled}\" class=\"fa_checkbox col-xs-8\" _v-5362f87d=\"\"><input id=border type=checkbox v-model=editingWindow.enableBorder v-bind:disabled=!editingWindow.osd.enabled _v-5362f87d=\"\"><label for=border _v-5362f87d=\"\"><span _v-5362f87d=\"\">Border</span></label></div><div v-bind:class=\"{'disabled': !editingWindow.osd.enabled}\" class=\"fa_checkbox col-xs-4\" _v-5362f87d=\"\"><input id=sourceLabel type=checkbox v-model=editingWindow.input.enabled v-bind:disabled=!editingWindow.osd.enabled _v-5362f87d=\"\"><label for=sourceLabel _v-5362f87d=\"\"><span _v-5362f87d=\"\">Source Label</span></label></div><div v-bind:class=\"{'disabled': !editingWindow.osd.enabled || !editingWindow.enableBorder}\" v-bind:disabled=!editingWindow.osd.enabled class=\"fa_checkbox col-xs-8\" _v-5362f87d=\"\"><input id=borderTally type=checkbox v-model=editingWindow.enableTally v-bind:disabled=!editingWindow.enableBorder _v-5362f87d=\"\"><label for=borderTally _v-5362f87d=\"\"><span _v-5362f87d=\"\">Border Tally</span></label></div></section></section><section class=\"custom_footer col-xs-12 row_space--xxs\" _v-5362f87d=\"\"><button v-on:click=applyChgLabel() class=\"btn btn-primary applyLabelBtn\" _v-5362f87d=\"\">Apply</button></section></tab></tabs></div><div slot=modal-footer class=\"modal-footer clearfix\" _v-5362f87d=\"\"><button v-on:click=\"showWindowConfig = false\" class=\"btn btn-default\" _v-5362f87d=\"\">Cancel</button></div></modal><modal backdrop=false title=\"Changes detected\" v-bind:show.sync=showChgConfirm class=change_confirm _v-5362f87d=\"\"><div slot=modal-header class=modal-header _v-5362f87d=\"\"><button v-on:click=stop class=close _v-5362f87d=\"\"><span _v-5362f87d=\"\">x</span></button><h4 class=modal-title _v-5362f87d=\"\">Changes detected</h4></div><div slot=modal-body class=\"modal-body clearfix\" _v-5362f87d=\"\"><div class=col-md-12 _v-5362f87d=\"\"><span _v-5362f87d=\"\">Save the change as Custome Preset?</span></div><hr _v-5362f87d=\"\"><div class=\"col-md-12 saveTo\" _v-5362f87d=\"\"><label class=pull-left _v-5362f87d=\"\">Save to</label><v-select v-bind:options=profileOptions v-bind:value.sync=saveToPreset class=pull-left _v-5362f87d=\"\"></v-select></div></div><div slot=modal-footer class=\"modal-footer clearfix\" _v-5362f87d=\"\"><button v-on:click=leavePage class=\"btn btn-default\" _v-5362f87d=\"\">No</button><button v-on:click=applyCurrentChange class=\"btn btn-primary\" _v-5362f87d=\"\">Save</button></div></modal></div></div>";

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-56c0a712=\"\"><div class=row _v-56c0a712=\"\"><div class=\"profile_main col-md-12\" _v-56c0a712=\"\"><header class=\"profile_title_bar main_title_bar clearfix\" _v-56c0a712=\"\"><h1 class=\"title col-md-10 col-sm-10 col-xs-12 clearfix\" _v-56c0a712=\"\">preset</h1></header><section class=\"profile_content col-lg-12 col-md-12 col-sm-12 col-xs-12 row_space--xs\" _v-56c0a712=\"\"><div class=\"profile_header clearfix\" _v-56c0a712=\"\"><h2 class=\"title_bar clearfix\" _v-56c0a712=\"\"> preset profile</h2></div><div class=\"col-xs-12 col-sm-11 col-md-10 col-lg-9 col-centered\" _v-56c0a712=\"\"><div class=table-responsive _v-56c0a712=\"\"><table class=\"profile_table col-centered table table-bordered table-hover table-striped\" _v-56c0a712=\"\"><tbody _v-56c0a712=\"\"><tr _v-56c0a712=\"\"><th _v-56c0a712=\"\">No.</th><th _v-56c0a712=\"\">Name</th><th v-for=\"(key,card) in outputCards\" class=\"hidden-xs output_name_header\" _v-56c0a712=\"\">{{key}}<br _v-56c0a712=\"\">{{card.name}}</th><th class=function _v-56c0a712=\"\"></th></tr><tr v-for=\"(key,profile) in profiles\" class=profile__row _v-56c0a712=\"\"><td _v-56c0a712=\"\">{{key}}</td><td _v-56c0a712=\"\">{{profile.name}}</td><td v-for=\"(output, input) in profile.mapping\" v-show=\"inputCards[output].name !== 'all' \" class=hidden-xs _v-56c0a712=\"\"><span v-if=\"input !== '0'\" class=name _v-56c0a712=\"\">{{inputCards[input].name}}</span><span v-else=v-else class=name _v-56c0a712=\"\"><i class=\"fa fa-times fa-2x\" _v-56c0a712=\"\"></i></span><span v-show=\"input !== '0' &amp;&amp; inputCards[input]\" class=port _v-56c0a712=\"\">({{input}})</span></td><td data-index={{$index}} class=edit _v-56c0a712=\"\"><span v-on:click.stop=toSwitchModal(key) _v-56c0a712=\"\"><i class=\"fa fa-edit\" _v-56c0a712=\"\"></i></span></td></tr></tbody></table></div></div></section></div></div></div><modal v-bind:show.sync=showModal effect=fade v-bind:callback=applyChange v-bind:close=cancel ok-text=Apply cancel-text=Cancel v-bind:backdrop=false title=Configuration class=\"popout col-md-12\" _v-56c0a712=\"\"><div slot=modal-body class=\"modal-body clearfix\" _v-56c0a712=\"\"><div class=\"col-lg-6 col-xs-12 form-horizontal clear_right clearfix\" _v-56c0a712=\"\"><div class=form-group _v-56c0a712=\"\"><label class=\"col-md-5 control-label\" _v-56c0a712=\"\">Name</label><div class=\"col-md-7 col-xs-12\" _v-56c0a712=\"\"><validator name=newProfileName _v-56c0a712=\"\"><input v-model=editing.profile.name maxlength=12 v-validate:newname=\"['deviceValid']\" class=form-control _v-56c0a712=\"\"><span v-show=\"$newProfileName.newname.invalid &amp;&amp; $newProfileName.newname.modified\" class=error _v-56c0a712=\"\">Please enter at least 1 English character or numbers, _ or - allowed</span></validator></div></div></div><div v-for=\"(output, input) in editing.profile.mapping\" v-bind:class=\"{'clear-left': output == 0}\" v-show=\"output !== 'all' \" class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 form-horizontal\" _v-56c0a712=\"\"><div class=form-group _v-56c0a712=\"\"><label class=\"input_name col-md-5 control-label\" _v-56c0a712=\"\">{{ output }} {{ outputCards[output].name }}</label><div class=col-md-7 _v-56c0a712=\"\"><select v-model=input class=form-control _v-56c0a712=\"\"><option v-for=\"( key , card  ) in inputCards\" v-bind:value=key _v-56c0a712=\"\">{{inputCards[key].name}} (Input {{key}})</option><option value=0 _v-56c0a712=\"\">Mute</option></select></div></div></div></div><div slot=modal-footer class=modal-footer _v-56c0a712=\"\"><button v-on:click=\"showModal = false\" class=\"btn btn-default\" _v-56c0a712=\"\">Cancel</button><button v-on:click=applyChange class=\"btn btn-success\" _v-56c0a712=\"\">Apply</button></div></modal>";

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

	module.exports = "<div v-bind:id=\"'screen'+id\" class=\"screen_group unselectable\" _v-66e7c958=\"\"><div v-bind:class=\"{'editable': editable, 'inProfile': inProfile}\" v-el:screen=v-el:screen class=\"screen clearfix no_pad\" _v-66e7c958=\"\"><img v-bind:src=imgs[1] class=bg _v-66e7c958=\"\"><div v-if=showLink v-link=\" 'layout' \" class=link_mask _v-66e7c958=\"\"></div><div v-if=!editable class=mask _v-66e7c958=\"\"></div><div id=output1 data-index=1 data-bdcolor=1 v-bind:class=\"{'focus': focus1, 'hidden': !focus1 &amp;&amp; !inProfile}\" class=\"left-top resizable no_pad border\" _v-66e7c958=\"\"><span class=label_group _v-66e7c958=\"\"><span class=window_name _v-66e7c958=\"\">Output 1</span></span></div><div id=output2 data-index=2 data-bdcolor=2 v-bind:class=\"{'focus': focus2, 'hidden': !focus2 &amp;&amp; !inProfile}\" class=\"right-top resizable no_pad border\" _v-66e7c958=\"\"><span class=label_group _v-66e7c958=\"\"><span class=window_name _v-66e7c958=\"\">Output 2</span></span></div><div id=output3 data-index=3 data-bdcolor=3 v-bind:class=\"{'focus': focus3, 'hidden': !focus3 &amp;&amp; !inProfile}\" class=\"left-bottom resizable no_pad border\" _v-66e7c958=\"\"><span class=label_group _v-66e7c958=\"\"><span class=window_name _v-66e7c958=\"\">Output 3</span></span></div><div id=output4 data-index=4 data-bdcolor=4 v-bind:class=\"{'focus': focus4, 'hidden': !focus4 &amp;&amp; !inProfile}\" class=\"right-bottom resizable no_pad border\" _v-66e7c958=\"\"><span class=label_group _v-66e7c958=\"\"><span class=window_name _v-66e7c958=\"\">Output 4</span></span></div></div><div class=\"ps_section col-md-12 no_pad\" _v-66e7c958=\"\"><span v-if=showPsOut class=ps _v-66e7c958=\"\">Output Resolution: {{outResolutionOptions[outResolution[windowFocus]]}}</span><span v-if=showPsIn class=ps _v-66e7c958=\"\">Input Resolution: {{inResolution['1']}}</span></div></div>";

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-68fda6fc=\"\"><div class=row _v-68fda6fc=\"\"><div class=\"log_main col-md-12\" _v-68fda6fc=\"\"><header class=\"profile_title_bar main_title_bar clearfix\" _v-68fda6fc=\"\"><h1 class=\"title col-md-10 col-sm-10 col-xs-12\" _v-68fda6fc=\"\">log<span v-if=\"$route.name === 'power'\" class=\"deviceTime col-md-3 pull-right no_pad\" _v-68fda6fc=\"\">{{deviceTime}}</span></h1></header><section class=\"function_section col-md-12 col-sm-12 col-xs-12 row_space--xs no_pad-xxs\" _v-68fda6fc=\"\"><div class=\"filter input_group col-lg-8 col-md-8 col-sm-6 col-xs-12\" _v-68fda6fc=\"\"><div v-for=\"chk in checkedConditions\" class=\"input_single no_select\" _v-68fda6fc=\"\"><input type=checkbox checked=checked v-model=selectedOptions v-bind:id=chk v-bind:value=chk class=\"input_radio form-control\" _v-68fda6fc=\"\"><label v-bind:for=chk _v-68fda6fc=\"\">{{chk}}</label></div><div class=input_single _v-68fda6fc=\"\"><input type=checkbox v-model=selectAll id=all class=\"input_radio form-control\" _v-68fda6fc=\"\"><label for=all _v-68fda6fc=\"\">all</label></div></div><div class=\"button_group col-lg-4 col-md-4 col-sm-6 hidden-xs clearfix\" _v-68fda6fc=\"\"><button v-on:click=clear() class=\"btn btn-danger col-lg-5 col-md-5 col-offset-md-1 col-sm-12 col-xs-12 col-offset-xs-0\" _v-68fda6fc=\"\"><i class=\"fa fa-trash-o\" _v-68fda6fc=\"\"></i>Clear</button><a v-el:download=v-el:download v-show=0 _v-68fda6fc=\"\"></a><button v-on:click=download() v-if=!isMobile class=\"btn btn-info col-lg-5 col-lg-offset-1 col-md-5 col-md-offset-1 col-sm-5 col-sm-offset-1\" _v-68fda6fc=\"\"><i class=\"fa fa-download\" _v-68fda6fc=\"\"></i>Download</button></div><div class=\"search_bar col-lg-9 col-md-10 col-sm-12 col-xs-12 col-centered clearfix clear-left\" _v-68fda6fc=\"\"><div class=\"title col-lg-12 col-md-12 col-sm-12 col-xs-12 clearfix clear-left\" _v-68fda6fc=\"\"><div class=\"col-md-10 col-sm-10 col-xs-7 no_pad\" _v-68fda6fc=\"\"><h2 _v-68fda6fc=\"\">Date range:</h2></div><div class=\"col-md-2 col-sm-2 col-xs-2 reset_filter_time\" _v-68fda6fc=\"\"><button @click=cleanFilterTime() class=\"btn btn-default\" _v-68fda6fc=\"\">Clean Date</button></div></div><div class=\"start_date col-lg-6 clear-left col-md-6 col-sm-6 col-sm-offset-0 col-xs-12\" _v-68fda6fc=\"\"><label class=\"col-md-3 col-xs-3\" _v-68fda6fc=\"\">From:</label><date-picker v-bind:time.sync=startDate v-bind:option=startOption v-on:click=blur v-bind:limit.sync=limitStart class=\"col-md-9 col-xs-9\" _v-68fda6fc=\"\"></date-picker></div><div class=\"end_date col-lg-6 col-md-6 col-sm-6 col-sm-offset-0 col-xs-12\" _v-68fda6fc=\"\"><label class=\"col-md-3 col-xs-3\" _v-68fda6fc=\"\">To:</label><date-picker v-bind:time.sync=endDate v-bind:option=endOption v-on:click=blur v-bind:limit.sync=limitEnd class=\"col-md-9 col-xs-9\" _v-68fda6fc=\"\"></date-picker></div></div><div class=\"pagination_section col-md-12 col-sm-12 row_space--xs no_pad-xxs clearfix\" _v-68fda6fc=\"\"><div class=\"col-md-9 col-sm-12 col-xs-12 col-centered clearfix no_pad-xxs\" _v-68fda6fc=\"\"><div class=btn-group _v-68fda6fc=\"\"><button @click.prevent=setPage(currPage-1) v-bind:disabled=\"currPage === 1\" class=\"btn btn-default arrow\" _v-68fda6fc=\"\"><span class=\"glyphicon glyphicon-chevron-left\" _v-68fda6fc=\"\"></span></button><button @click=setPaginationSec(currPaginationSec-1) v-if=\"currPaginationSec !== 1\" class=\"btn btn-default more\" _v-68fda6fc=\"\"> ...</button><button @click.prevent=setPage(n+1) v-for=\"n in totalPageAry | limitBy countOfPagination paginationStart\" v-bind:class=\"{'active': (currPage === (n+1))}\" class=\"btn btn-default page\" _v-68fda6fc=\"\"> {{n+1}}</button><button @click=setPaginationSec(currPaginationSec+1) v-if=\"currPaginationSec !== totalSection\" class=\"btn btn-default more\" _v-68fda6fc=\"\"> ...</button><button @click.prevent=setPage(currPage+1) v-bind:disabled=\"currPage === totalPage\" class=\"btn btn-default arrow\" _v-68fda6fc=\"\"><span class=\"glyphicon glyphicon-chevron-right\" _v-68fda6fc=\"\"></span></button></div></div></div><div class=\"log_section col-lg-12 col-md-12 col-sm-12 col-xs-12 row_space--xs no_pad-xxs\" _v-68fda6fc=\"\"><div class=\"col-lg-9 col-md-10 col-sm-10 col-xs-12 col-centered no_pad-xxs\" _v-68fda6fc=\"\"><table class=\"table table-bordered log_table\" _v-68fda6fc=\"\"><tbody _v-68fda6fc=\"\"><tr _v-68fda6fc=\"\"><th _v-68fda6fc=\"\">Time</th><th _v-68fda6fc=\"\">Type</th><th _v-68fda6fc=\"\">Message</th></tr><tr v-for=\"log in computedLog | orderBy 'dateTime' -1 | limitBy countOfPage pageStart \" _v-68fda6fc=\"\"><td class=hidden-xs _v-68fda6fc=\"\">{{ log.dateTime | moment 'DD-MM-YYYY HH:mm:ss' }}</td><td class=visible-xs _v-68fda6fc=\"\">{{ log.dateTime | moment 'DD-MM-YYYY' }}</td><td _v-68fda6fc=\"\">{{ log.type }}</td><td class=logMsg _v-68fda6fc=\"\"><span v-on:click.stop=toggleMsg($event) class=trigger _v-68fda6fc=\"\">{{ log.message }}</span></td></tr></tbody></table></div><div class=\"button_group mobile_button_group col-lg-6 col-md-6 col-sm-6 visible-xs col-xs-12\" _v-68fda6fc=\"\"><button v-on:click=clear class=\"btn btn-danger col-xs-12\" _v-68fda6fc=\"\"><i class=\"fa fa-trash-o\" _v-68fda6fc=\"\"></i>Clear</button></div></div></section></div><modal title=Confirm v-bind:show.sync=showConfirm effect=zoom v-bind:callback=confirmCb ok-text=Yes cancel-text=Cancel class=confrim_modal _v-68fda6fc=\"\"><div slot=modal-body class=\"modal-body clearfix\" _v-68fda6fc=\"\">{{ confirmMsg }}</div></modal></div></div>";

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-6a6d0b2e=\"\"><div class=row _v-6a6d0b2e=\"\"><div class=\"schedule_main col-md-12\" _v-6a6d0b2e=\"\"><header class=\"schedule_titile_bar main_title_bar clearfix\" _v-6a6d0b2e=\"\"><h1 class=\"title col-md-12 col-sm-10 col-xs-12\" _v-6a6d0b2e=\"\">schedule<span class=\"deviceTime col-md-3 pull-right no_pad\" _v-6a6d0b2e=\"\">{{deviceTime}}</span></h1></header><section v-if=showAni class=\"animation clearfix\" _v-6a6d0b2e=\"\"><div class=spinner-wrap _v-6a6d0b2e=\"\"><div class=spinner _v-6a6d0b2e=\"\"><i _v-6a6d0b2e=\"\"></i><i _v-6a6d0b2e=\"\"></i><i _v-6a6d0b2e=\"\"></i><i _v-6a6d0b2e=\"\"></i><i _v-6a6d0b2e=\"\"></i><i _v-6a6d0b2e=\"\"></i><i _v-6a6d0b2e=\"\"></i><i _v-6a6d0b2e=\"\"></i><i _v-6a6d0b2e=\"\"></i><i _v-6a6d0b2e=\"\"></i><i _v-6a6d0b2e=\"\"></i><i _v-6a6d0b2e=\"\"></i></div></div></section><section v-if=!showAni class=\"schedule_pagination clearfix\" _v-6a6d0b2e=\"\"><div class=\"col-md-8 col-sm-8 col-centered\" _v-6a6d0b2e=\"\"><div class=\"btn-group col-centered\" _v-6a6d0b2e=\"\"><button v-on:click=getSchedule(1) v-bind:class=\"{'focus': pageFocus === 1}\" class=\"btn btn-default\" _v-6a6d0b2e=\"\"><span _v-6a6d0b2e=\"\">1</span></button><button v-on:click=getSchedule(2) v-bind:class=\"{'focus': pageFocus === 2}\" class=\"btn btn-default\" _v-6a6d0b2e=\"\"><span _v-6a6d0b2e=\"\">2</span></button></div></div></section><section v-if=!showAni class=\"schedule_content clearfix\" _v-6a6d0b2e=\"\"><table class=\"table table-bordered schedule_table hidden-md hidden-lg\" _v-6a6d0b2e=\"\"><tbody _v-6a6d0b2e=\"\"><tr _v-6a6d0b2e=\"\"><th _v-6a6d0b2e=\"\">No.</th><th _v-6a6d0b2e=\"\">Enable</th><th _v-6a6d0b2e=\"\">Name</th><th _v-6a6d0b2e=\"\"></th></tr><tr v-for=\"(key ,schedule) in schedules\" _v-6a6d0b2e=\"\"><td _v-6a6d0b2e=\"\">{{ key }}</td><td _v-6a6d0b2e=\"\"><i v-if=schedule.enabled v-on:click=\"setSchedule(false, key)\" class=\"fa fa-check-square fa-lg\" _v-6a6d0b2e=\"\"></i><i v-else=v-else v-on:click=\"setSchedule(true, key)\" class=\"fa fa-square-o fa-lg\" _v-6a6d0b2e=\"\"></i></td><td _v-6a6d0b2e=\"\">{{ schedule.name }}</td><td _v-6a6d0b2e=\"\"><span v-on:click=toShowModal(key) _v-6a6d0b2e=\"\"><i class=\"fa fa-edit\" _v-6a6d0b2e=\"\"></i></span></td></tr></tbody></table><table class=\"table table-bordered table-striped table-hover schedule_table hidden-sm hidden-xs\" _v-6a6d0b2e=\"\"><tbody _v-6a6d0b2e=\"\"><tr _v-6a6d0b2e=\"\"><th _v-6a6d0b2e=\"\">No.</th><th _v-6a6d0b2e=\"\">Enable</th><th _v-6a6d0b2e=\"\">Name</th><th _v-6a6d0b2e=\"\">I/O</th><th _v-6a6d0b2e=\"\">Actions</th><th _v-6a6d0b2e=\"\">Time</th><th _v-6a6d0b2e=\"\">Days</th><th _v-6a6d0b2e=\"\"></th></tr><tr v-for=\"(key, schedule) in schedules\" _v-6a6d0b2e=\"\"><td _v-6a6d0b2e=\"\">{{ key }}</td><td _v-6a6d0b2e=\"\"><i v-if=schedule.enabled v-on:click=\"setSchedule(false, key)\" class=\"fa fa-check-square fa-lg\" _v-6a6d0b2e=\"\"></i><i v-else=v-else v-on:click=\"setSchedule(true, key)\" class=\"fa fa-square-o fa-lg\" _v-6a6d0b2e=\"\"></i></td><td _v-6a6d0b2e=\"\">{{ schedule.name }}</td><td class=banks _v-6a6d0b2e=\"\"><div v-for=\"(key, bank) in allBanks\" v-if=\"schedule.banks.indexOf(key.toString()) !== -1\" class=no_pad _v-6a6d0b2e=\"\"><span _v-6a6d0b2e=\"\">{{key === 0 ? 'Input' : 'Outlet' + key}}</span></div></td><td _v-6a6d0b2e=\"\">{{ schedule.action }}</td><td _v-6a6d0b2e=\"\">{{ schedule.time.hours.toString().length === 1 ? '0' + schedule.time.hours : schedule.time.hours }}:{{schedule.time.minutes.toString().length === 1 ? '0'+schedule.time.minutes : schedule.time.minutes }}</td><td class=weekDay _v-6a6d0b2e=\"\"><span v-for=\"(key,day) in weekDay\" v-bind:class=\"{enabled:schedule.time.days.indexOf(day) !== -1}\" class=day _v-6a6d0b2e=\"\">{{ day }}</span></td><td _v-6a6d0b2e=\"\"><span v-on:click=toShowModal(key) _v-6a6d0b2e=\"\"><i class=\"fa fa-edit fa-lg\" _v-6a6d0b2e=\"\"></i></span></td></tr></tbody></table></section></div></div></div><modal v-bind:show.sync=showModal v-bind:title=editing.title effect=zoom v-bind:callback=handleScheduleConfig ok-text=Apply cancel-text=Cancel class=\"popout schedule_config\" _v-6a6d0b2e=\"\"><div slot=modal-body class=modal-body _v-6a6d0b2e=\"\"><table class=\"table table-bordered schedule_config_table\" _v-6a6d0b2e=\"\"><tbody _v-6a6d0b2e=\"\"><tr _v-6a6d0b2e=\"\"><th _v-6a6d0b2e=\"\">Enable</th><td class=enabled _v-6a6d0b2e=\"\"><input type=checkbox v-model=editing.schedule.enabled id=schedule{{editing.schedule.no}} _v-6a6d0b2e=\"\"><label for=schedule{{editing.schedule.no}} _v-6a6d0b2e=\"\"><i v-show=editing.schedule.enabled class=\"fa fa-check-square fa-lg\" _v-6a6d0b2e=\"\"></i><i v-else=v-else class=\"fa fa-square-o fa-lg\" _v-6a6d0b2e=\"\"></i></label></td></tr><tr _v-6a6d0b2e=\"\"><th _v-6a6d0b2e=\"\">Name</th><td _v-6a6d0b2e=\"\"><validator name=scheName _v-6a6d0b2e=\"\"><input type=text v-model=new_schedule_name v-bind:value=editing.schedule.name maxlength=7 v-validate:name=\"['engAndNum']\" class=form-control _v-6a6d0b2e=\"\"><span v-show=\"$scheName.name.invalid &amp;&amp; $scheName.name.modified\" class=error _v-6a6d0b2e=\"\">English Charactor ,numbers and '_' only</span></validator></td></tr><tr _v-6a6d0b2e=\"\"><th _v-6a6d0b2e=\"\">I/O</th><td class=\"banks col-xs-10\" _v-6a6d0b2e=\"\"><v-multi-banks v-bind:name-prop=\"'bank'\" v-bind:options=targetOption v-bind:output-ary.sync=editing.newBanks v-bind:show-all-outlet-btn=true _v-6a6d0b2e=\"\"></v-multi-banks></td></tr><tr _v-6a6d0b2e=\"\"><th _v-6a6d0b2e=\"\">Actions</th><td _v-6a6d0b2e=\"\"><v-select v-bind:options.sync=actionOptions v-bind:value.sync=editing.schedule.action _v-6a6d0b2e=\"\"></v-select></td></tr><tr _v-6a6d0b2e=\"\"><th _v-6a6d0b2e=\"\">Time</th><td class=\"time col-xs-10\" _v-6a6d0b2e=\"\"><input type=number max=23 min=0 v-model=editing.schedule.time.hours class=form-control-inline _v-6a6d0b2e=\"\"><span _v-6a6d0b2e=\"\">&nbsp;:&nbsp;</span><input type=number max=59 min=0 v-model=editing.schedule.time.minutes class=form-control-inline _v-6a6d0b2e=\"\"></td></tr><tr _v-6a6d0b2e=\"\"><th _v-6a6d0b2e=\"\">Days</th><td class=weekDay _v-6a6d0b2e=\"\"><v-multi-banks v-bind:name-prop=\"'weekDay'\" v-bind:options=weekOption v-bind:output-ary.sync=editing.newDays _v-6a6d0b2e=\"\"></v-multi-banks></td></tr></tbody></table></div></modal>";

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-6fd21138=\"\"><div class=row _v-6fd21138=\"\"><div class=\"status_main col-md-12\" _v-6fd21138=\"\"><header class=\"status_title_bar main_title_bar clearfix\" _v-6fd21138=\"\"><h1 class=\"title col-lg-10 col-md-10 col-sm-10 col-xs-10\" _v-6fd21138=\"\">status</h1></header><section class=\"status_content col-lg-12 col-md-12 col-sm-12 col-xs-12 no_pad\" _v-6fd21138=\"\"><header class=\"output_header clearfix\" _v-6fd21138=\"\"><h2 class=\"title_bar col-lg-5 col-md-5 col-sm-7\" _v-6fd21138=\"\">Digital Outputs</h2></header><section class=\"output_content col-md-12 col-lg-9 clearfix\" _v-6fd21138=\"\"><div v-for=\"(key, card) in DOs\" class=\"col-md-3 output__single clearfix row_space--xxs\" _v-6fd21138=\"\"><div class=\"card col-md-12 no_pad\" _v-6fd21138=\"\"><div class=\"card_header col-md-12 clearfix\" _v-6fd21138=\"\"><span class=key _v-6fd21138=\"\">{{key}}</span><span class=name _v-6fd21138=\"\">{{card.name}}</span><span class=setting _v-6fd21138=\"\"><i v-on:click=\"handleShowModal(true, key)\" class=\"fa fa-cog\" _v-6fd21138=\"\"></i></span></div><div class=\"card_body col-md-12 clearfix\" _v-6fd21138=\"\"><div class=\"btn_group col-md-5 col-centered\" _v-6fd21138=\"\"><span _v-6fd21138=\"\"><div v-on:click.self=setDOStatus(key) class=mask _v-6fd21138=\"\"></div><label class=\"iosCheck longer\" _v-6fd21138=\"\"><input type=checkbox v-bind:checked.sync=\"card.value === 'high'\" _v-6fd21138=\"\"><i _v-6fd21138=\"\"><span v-bind:class=\"{addOpacity: card.value !== 'high'}\" class=on _v-6fd21138=\"\">On</span><span v-bind:class=\"{addOpacity: card.value === 'high'}\" class=off _v-6fd21138=\"\">Off</span></i></label></span></div></div></div></div></section><header class=\"input_header clearfix\" _v-6fd21138=\"\"><h2 class=\"title_bar col-lg-5 col-md-5 col-sm-7\" _v-6fd21138=\"\">Digital Inputs</h2></header><section class=\"input_content col-md-12 col-lg-9 clearfix no_pad-xs\" _v-6fd21138=\"\"><div v-for=\"(key, card) in DIs\" class=\"col-md-3 col-xs-6 input__single row_space--xxs clearfix\" _v-6fd21138=\"\"><div class=\"card col-md-12 no_pad\" _v-6fd21138=\"\"><div class=\"card_header col-md-12 clearfix\" _v-6fd21138=\"\"><span class=key _v-6fd21138=\"\">{{key}}</span><span class=name _v-6fd21138=\"\">{{card.name}}</span><span class=setting _v-6fd21138=\"\"><i v-on:click=\"handleShowModal(false, key)\" class=\"fa fa-cog\" _v-6fd21138=\"\"></i></span></div><div class=\"card_body col-md-12 clearfix\" _v-6fd21138=\"\"><button v-bind:class=\"{'enabled': card.value === 'high'}\" disabled=disabled class=btn _v-6fd21138=\"\"></button></div></div></div></section></section></div></div><modal title=\"DIO Config\" v-bind:show.sync=showModal v-bind:callback=applyConfig effect=zoom ok-text=Apply cancel-text=Cancel class=config_modal _v-6fd21138=\"\"><div slot=modal-body class=\"modal-body clearfix\" _v-6fd21138=\"\"><section v-if=!isOut class=\"di_name_group clearfix\" _v-6fd21138=\"\"><div class=\"di__name__single col-md-12 clearfix\" _v-6fd21138=\"\"><label _v-6fd21138=\"\">DI {{currentIndex}}</label><input v-model=editing.DIs[currentIndex].name maxlength=7 class=form-control _v-6fd21138=\"\"></div></section><section v-else=v-else class=\"do_name_group clearfix\" _v-6fd21138=\"\"><div class=\"do__name__single col-md-12 clearfix\" _v-6fd21138=\"\"><label _v-6fd21138=\"\">DO {{currentIndex}}</label><input v-model=editing.DOs[currentIndex].name maxlength=7 class=form-control _v-6fd21138=\"\"></div></section></div></modal></div>";

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

	module.exports = "<div class=group _v-6fef55ec=\"\"><div v-if=showOption class=\"outer clearfix\" _v-6fef55ec=\"\"><span v-for=\"(key, option) in options\" v-bind:data-bgcolor=key _v-6fef55ec=\"\"><input type=checkbox v-bind:value=option.value id=\"{{ nameProp + key }}\" name=\"{{ nameProp }}\" v-model=outputAry _v-6fef55ec=\"\"><label for=\"{{ nameProp + key }}\" _v-6fef55ec=\"\">{{option.label}}</label></span><span v-if=showAllOutletBtn v-on:click.once=selectAll _v-6fef55ec=\"\"><input type=checkbox id={{nameProp}}All v-model=allSelected _v-6fef55ec=\"\"><label _v-6fef55ec=\"\">All Outlets</label></span></div></div>";

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-72ec73c2=\"\"><div class=row _v-72ec73c2=\"\"><div v-if=!loadingData class=\"setting_main col-md-12\" _v-72ec73c2=\"\"><header class=\"setting_title_bar main_title_bar clearfix\" _v-72ec73c2=\"\"><h1 class=\"title col-md-10 col-sm-10 col-xs-12\" _v-72ec73c2=\"\">settings</h1></header><section class=\"identification_section col-md-12 col-sm-12 col-xs-12 row_space--xs\" _v-72ec73c2=\"\"><h2 class=title_bar _v-72ec73c2=\"\">information</h2><div class=\"id_group col-lg-8 col-md-10 col-sm-12 col-xs-12 col-centered clearfix\" _v-72ec73c2=\"\"><div v-for=\"(key,data) in device\" class=\"id__single col-lg-6 col-md-6 col-sm-12 col-xs-12 clearfix\" _v-72ec73c2=\"\"><div class=\"id_key col-lg-6 col-md-6 col-sm-4 col-xs-5 clearfix\" _v-72ec73c2=\"\"><span class=key _v-72ec73c2=\"\">{{ namesToShow[key] }}</span></div><div v-if=\"key === 'type_id'\" class=\"id_value col-lg-6 col-md-6 col-sm-8 col-xs-7 clearfix\" _v-72ec73c2=\"\"><span class=value _v-72ec73c2=\"\">{{ types[data] }}</span></div><div v-else=v-else v-bind:class=\"{'smaller': key === 'nickname' || key === 'model_name'}\" class=\"id_value col-lg-6 col-md-6 col-sm-8 col-xs-7 clearfix\" _v-72ec73c2=\"\"><span class=value _v-72ec73c2=\"\">{{ data}}</span></div></div></div></section></div></div></div>";

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

	module.exports = "<div v-bind:id=\"'screen'+id\" class=\"screen_group unselectable\" _v-74dda4da=\"\"><div v-bind:class=\"{'editable':editable, 'inProfile': inProfile}\" v-el:screen=v-el:screen class=\"screen clearfix no_pad\" _v-74dda4da=\"\"><div v-if=showLink v-link=\" 'layout' \" class=link_mask _v-74dda4da=\"\"></div><div v-if=!editable class=mask _v-74dda4da=\"\"></div><div id=input1 data-index=1 data-bgcolor=1 v-bind:data-source=\"mapping['1']\" v-bind:class=\"{'focus': windowFocus === '1', 'border': (label.osd['1'].border === 1 || label.osd['1'].border === 2) &amp;&amp; !inProfile, 'border_ani': label.osd['1'].border === 2 &amp;&amp; !inProfile}\" v-on:click=\"toFocus('1')\" class=\"left-top resizable no_pad\" _v-74dda4da=\"\"><span v-if=\"label.osd['1'].enabled\" class=label_group _v-74dda4da=\"\"><span v-if=\"label.windows['1'].enabled\" class=window_name _v-74dda4da=\"\">{{label.windows['1'].text}}</span><span v-if=\"label.inputs['1'].enabled\" class=input_name _v-74dda4da=\"\">({{label.inputs[mapping['1']].text}})</span><span v-if=\"label.custom['1'].enabled\" class=custom_name _v-74dda4da=\"\">&nbsp;{{label.custom['1'].text}}</span></span></div><div id=input2 data-index=2 data-bgcolor=2 v-bind:data-source=\"mapping['2']\" v-bind:class=\"{'focus': windowFocus === '2', 'border': (label.osd['2'].border === 1 || label.osd['2'].border === 2) &amp;&amp; !inProfile, 'border_ani': label.osd['2'].border === 2 &amp;&amp; !inProfile}\" v-on:click=\"toFocus('2')\" class=\"right-top resizable no_pad\" _v-74dda4da=\"\"><span v-if=\"label.osd['2'].enabled\" class=label_group _v-74dda4da=\"\"><span v-if=\"label.windows['2'].enabled\" class=window_name _v-74dda4da=\"\">{{label.windows['2'].text}}</span><span v-if=\"label.inputs['2'].enabled\" class=input_name _v-74dda4da=\"\">({{label.inputs[mapping['2']].text}})</span><span v-if=\"label.custom['2'].enabled\" class=custom_name _v-74dda4da=\"\">&nbsp;{{label.custom['2'].text}}</span></span></div><div id=input3 data-index=3 data-bgcolor=3 v-bind:data-source=\"mapping['3']\" v-bind:class=\"{'focus': windowFocus === '3', 'border': (label.osd['3'].border === 1 || label.osd['3'].border === 2) &amp;&amp; !inProfile, 'border_ani': label.osd['3'].border === 2 &amp;&amp; !inProfile}\" v-on:click=\"toFocus('3')\" class=\"left-bottom resizable no_pad\" _v-74dda4da=\"\"><span v-if=\"label.osd['3'].enabled\" class=label_group _v-74dda4da=\"\"><span v-if=\"label.windows['3'].enabled\" class=window_name _v-74dda4da=\"\">{{label.windows['3'].text}}</span><span v-if=\"label.inputs['3'].enabled\" class=input_name _v-74dda4da=\"\">({{label.inputs[mapping['3']].text}})</span><span v-if=\"label.custom['3'].enabled\" class=custom_name _v-74dda4da=\"\">&nbsp;{{label.custom['3'].text}}</span></span></div><div id=input4 data-index=4 data-bgcolor=4 v-bind:data-source=\"mapping['4']\" v-bind:class=\"{'focus': windowFocus === '4', 'border': (label.osd['4'].border === 1 || label.osd['4'].border === 2) &amp;&amp; !inProfile, 'border_ani': label.osd['4'].border === 2 &amp;&amp; !inProfile}\" v-on:click=\"toFocus('4')\" class=\"right-bottom resizable no_pad\" _v-74dda4da=\"\"><span v-if=\"label.osd['4'].enabled\" class=label_group _v-74dda4da=\"\"><span v-if=\"label.windows['4'].enabled\" class=window_name _v-74dda4da=\"\">{{label.windows['4'].text}}</span><span v-if=\"label.inputs['4'].enabled\" class=input_name _v-74dda4da=\"\">({{label.inputs[mapping['4']].text}})</span><span v-if=\"label.custom['4'].enabled\" class=custom_name _v-74dda4da=\"\">&nbsp;{{label.custom['4'].text}}</span></span></div></div><span v-if=showPs class=ps _v-74dda4da=\"\">Output Resolution: {{outResolutionOptions[outResolution]}}</span></div>";

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

	module.exports = " <span class=indicator-container _v-7511fb90=\"\"> <span class=indicator v-bind:class=indicatorClass _v-7511fb90=\"\"></span> <span v-if=showText class=\"indicator text\" _v-7511fb90=\"\">{{ indicatorText }}</span> </span> ";

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"panel panel-default\" _v-79d6ab98=\"\"> <div class=panel-heading _v-79d6ab98=\"\"> <span class=accordion-toggle _v-79d6ab98=\"\"> <h4 class=panel-title _v-79d6ab98=\"\"> <slot name=header _v-79d6ab98=\"\"> {{ header }} </slot> </h4> </span> </div> <div class=panel-collapse v-el:panel=\"\" v-show=isOpen _v-79d6ab98=\"\"> <div class=panel-body _v-79d6ab98=\"\"> <slot _v-79d6ab98=\"\"></slot> </div> </div> </div> ";

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-847e5a3e=\"\"><div class=row _v-847e5a3e=\"\"><div class=\"system_main col-md-12\" _v-847e5a3e=\"\"><header class=\"system_title_bar main_title_bar clearfix\" _v-847e5a3e=\"\"><h1 class=\"title col-md-10 col-sm-10 col-xs-12\" _v-847e5a3e=\"\">system</h1><span v-if=\"$route.name === 'power'\" class=\"deviceTime col-md-3 pull-right no_pad\" _v-847e5a3e=\"\">{{deviceTime}}</span></header><section class=\"maintenance_section col-md-12 col-sm-12 col-xs-12 row_space--xs no_pad-xs\" _v-847e5a3e=\"\"><h2 class=title_bar _v-847e5a3e=\"\">maintenance</h2><div class=\"btn_group col-md-12 col-sm-12 col-centered\" _v-847e5a3e=\"\"><h3 v-if=\"!capability.system.default &amp;&amp; !capability.system.upgrade &amp;&amp; !capability.system.reboot &amp;&amp; !capability.system.rollback\" _v-847e5a3e=\"\">This device does't support any of the maintenance options</h3><div v-show=capability.system.upgrade class=\"clearfix col-lg-3 col-md-3 col-sm-6 col-xs-12\" _v-847e5a3e=\"\"><button v-on:click=handleMaintenance class=\"btn upload col-md-12 col-xs-12\" _v-847e5a3e=\"\"><i class=\"fa fa-cloud-upload\" _v-847e5a3e=\"\"></i>update firmware</button></div><div v-show=capability.system.default class=\"clearfix col-lg-3 col-md-3 col-sm-6 col-xs-12\" _v-847e5a3e=\"\"><button v-on:click=resetToFactoryDefault class=\"btn factory_default col-md-12 col-xs-12\" _v-847e5a3e=\"\"><i class=\"fa fa-gear\" _v-847e5a3e=\"\"></i>factory default</button></div><div v-show=capability.system.reboot class=\"clearfix col-lg-3 col-md-3 col-sm-6 col-xs-12\" _v-847e5a3e=\"\"><button v-on:click=reboot class=\"btn reboot col-md-12 col-xs-12\" _v-847e5a3e=\"\"><i class=\"fa fa-rotate-left\" _v-847e5a3e=\"\"></i>reboot</button></div><div v-show=capability.system.rollback class=\"clearfix col-lg-3 col-md-3 col-sm-6 col-xs-12\" _v-847e5a3e=\"\"><button v-on:click=rollbackFirmware class=\"btn rollback col-md-12 col-xs-12\" _v-847e5a3e=\"\"><i class=\"fa fa-level-down\" _v-847e5a3e=\"\"></i>RollBack</button></div></div></section><modal title=Confirm v-bind:show.sync=showConfirm effect=zoom v-bind:callback=confirmCb ok-text=Yes cancel-text=Cancel class=confirm_modal _v-847e5a3e=\"\"><div slot=modal-body class=\"modal-body clearfix\" _v-847e5a3e=\"\"><span _v-847e5a3e=\"\">{{ confirmMsg }}</span></div></modal></div></div></div>";

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-8619fe1a=\"\"><div class=row _v-8619fe1a=\"\"><div class=\"status_main col-md-12\" _v-8619fe1a=\"\"><header class=\"status_title_bar main_title_bar clearfix\" _v-8619fe1a=\"\"><h1 class=\"title col-md-10 col-sm-10 col-xs-12\" _v-8619fe1a=\"\">Analysis<span class=\"deviceTime col-md-3 pull-right no_pad\" _v-8619fe1a=\"\">{{deviceTime}}</span></h1></header><section class=analysis_content _v-8619fe1a=\"\"><section class=\"input_voltage clearfix row_space--xxs\" _v-8619fe1a=\"\"><div class=\"col-lg-6 col-md-6 col-xs-12 clear-left clearfix no_pad-xs\" _v-8619fe1a=\"\"><div id=inputVoltage class=char _v-8619fe1a=\"\"></div></div></section><section class=\"banks clearfix row_space--xxs\" _v-8619fe1a=\"\"><div class=\"reminding col-sm-12 no_pad-xs\" _v-8619fe1a=\"\"><span _v-8619fe1a=\"\">You can select 3 outlets at most</span></div><div class=\"col-xs-12 col-sm-12 col-lg-12 filter_group no_pad-xs\" _v-8619fe1a=\"\"><div v-for=\"(key,bank) in testData.banks\" v-bind:class=\"{'blue': filter.indexOf(key) === 0, 'orange':filter.indexOf(key) === 1, 'green': filter.indexOf(key) === 2}\" class=\"filter__single fa_checkbox clearfix\" _v-8619fe1a=\"\"><input type=checkbox name=filter v-bind:value=key v-model=filter v-bind:id=\"'bank'+key+'_filter'\" _v-8619fe1a=\"\"><label v-bind:for=\"'bank'+key+'_filter'\" v-on:click=chkAmount() _v-8619fe1a=\"\"><span _v-8619fe1a=\"\">Outlet{{key}}</span></label></div></div><div class=row _v-8619fe1a=\"\"><div class=\"bank__single col-lg-6 col-md-6 col-xs-12 row_space--xxs\" _v-8619fe1a=\"\"><div id=bankCurrent class=char _v-8619fe1a=\"\"></div></div></div><div class=row _v-8619fe1a=\"\"><div class=\"bank__single col-lg-6 col-md-6 col-xs-12 row_space--xxs\" _v-8619fe1a=\"\"><div id=bankPower class=char _v-8619fe1a=\"\"></div></div></div></section></section></div></div></div>";

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

	module.exports = "<div class=row _v-8c3210b6=\"\"><div class=col-xs-12 _v-8c3210b6=\"\"><fieldset _v-8c3210b6=\"\"><legend _v-8c3210b6=\"\">dxGetAVQosSettings</legend><button @click=\"sendAPI('dxGetAVQosSettings')\" _v-8c3210b6=\"\">dxGetAVQosSettings</button></fieldset></div></div><div class=row _v-8c3210b6=\"\"><div class=col-xs-12 _v-8c3210b6=\"\"><fieldset _v-8c3210b6=\"\"><legend _v-8c3210b6=\"\">dxGetSysInfo</legend><button @click=\"sendAPI('dxGetSysInfo')\" _v-8c3210b6=\"\">dxGetSysInfo</button></fieldset></div></div><div class=row _v-8c3210b6=\"\"><div class=col-xs-12 _v-8c3210b6=\"\"><fieldset _v-8c3210b6=\"\"><legend _v-8c3210b6=\"\">dxGetPortStatus</legend><button @click=\"sendAPI('dxGetPortStatus')\" _v-8c3210b6=\"\">dxGetPortStatus</button></fieldset></div></div>";

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid clearfix\" _v-957368be=\"\"><div v-if=showMask class=mask _v-957368be=\"\"><h2 _v-957368be=\"\">Please rotate your mobile to show config</h2></div><div class=row _v-957368be=\"\"><div class=\"layout_main col-md-12\" _v-957368be=\"\"><header class=\"layout_title_bar main_title_bar clearfix\" _v-957368be=\"\"><h1 class=\"title col-lg-10 col-md-10 col-sm-10 col-xs-10\" _v-957368be=\"\">Layout</h1><v-loader v-bind:ani-key=\"'6'\" v-if=isFetching class=\"col-lg-2 col-lg-offset-3 col-md-2 col-md-offset-3 col-sm-1 col-sm-offset-3 col-xs-2 col-xs-offset-0\" _v-957368be=\"\"></v-loader><div class=\"function_group col-xs-4 col-md-4 pull-right\" _v-957368be=\"\"><div class=\"col-xs-4 no_pad-xs clearfix function__single save_profile_btn pull-right\" _v-957368be=\"\"><dropdown class=\"col-md-12 no_pad\" _v-957368be=\"\"><button slot=button type=button class=\"col-sm-12 col-md-12 col-lg-12 btn btn-primary dropdown-toggle\" _v-957368be=\"\"><i class=\"fa fa-save fa-lg\" _v-957368be=\"\"></i>&nbsp;<span class=caret _v-957368be=\"\"></span></button><ul slot=dropdown-menu class=dropdown-menu _v-957368be=\"\"><li v-for=\"(key, opt) in profileOptions\" _v-957368be=\"\"><a v-on:click=saveProfile(opt.value) _v-957368be=\"\">{{opt.label}}</a></li></ul></dropdown></div></div></header><section class=\"layout_content clearfix\" _v-957368be=\"\"><section class=\"screen_section col-xs-8 col-sm-7 col-md-7 col-lg-8 no_pad clearfix\" _v-957368be=\"\"><div class=\"col-lg-12 col-md-12 no_pad-xs clearfix\" _v-957368be=\"\"><v-screen v-bind:editable=true v-bind:show-link=false v-bind:in-which-page=\"'layout'\" v-bind:show-ps-out=true v-bind:show-ps-in=true _v-957368be=\"\"></v-screen></div></section><section class=\"function_section col-xs-4 col-sm-5 col-md-5 col-lg-4 clearfix no_pad-xxs\" _v-957368be=\"\"><div class=\"col-xs-12 col-md-12 full_screen_btn_group col-centered clearfix no_pad-xxs no_pad-xs\" _v-957368be=\"\"><header class=\"row_space--xxs hidden-xs\" _v-957368be=\"\"><label _v-957368be=\"\">Output</label></header><div v-for=\"key in outputPorts\" class=\"col-xs-3 col-sm-3 col-md-3 full__btn__single clearfix\" _v-957368be=\"\"><button v-on:click=toFocus(key) v-bind:class=\"{active: windowFocus === key}\" class=\"btn btn-default clearfix btn-square-xs no_pad-xs no_pad-xxs\" _v-957368be=\"\">{{key}}</button></div><div class=\"input_detail col-xs-12 clearfix no_pad-xs\" _v-957368be=\"\"><div class=\"col-xs-6 col-md-6 h_start\" _v-957368be=\"\"><input type=number min=0 v-model=splits[windowFocus][0] v-on:change=onInputChange(0) class=\"col-xs-6 form-control\" _v-957368be=\"\"></div><div class=\"col-xs-6 col-md-6 h_end\" _v-957368be=\"\"><input type=number min=0 v-model=splits[windowFocus][2] v-on:change=onInputChange(2) class=\"col-xs-6 form-control\" _v-957368be=\"\"></div><div class=\"col-xs-6 col-md-6 v_start\" _v-957368be=\"\"><input type=number min=0 v-model=splits[windowFocus][1] v-on:change=onInputChange(1) class=\"col-xs-6 form-control\" _v-957368be=\"\"></div><div class=\"col-xs-6 col-md-6 v_end\" _v-957368be=\"\"><input type=number min=0 v-model=splits[windowFocus][3] v-on:change=onInputChange(3) class=\"col-xs-6 form-control\" _v-957368be=\"\"></div></div></div></section></section></div><modal backdrop=false title=\"Changes detected\" v-bind:show.sync=showChgConfirm class=change_confirm _v-957368be=\"\"><div slot=modal-header class=modal-header _v-957368be=\"\"><button v-on:click=stop class=close _v-957368be=\"\"><span _v-957368be=\"\">x</span></button><h4 class=modal-title _v-957368be=\"\">Changes detected</h4></div><div slot=modal-body class=\"modal-body clearfix\" _v-957368be=\"\"><div class=col-md-12 _v-957368be=\"\"><span _v-957368be=\"\">Save the change as Custome Preset?</span></div><hr _v-957368be=\"\"><div class=\"col-md-12 saveTo\" _v-957368be=\"\"><label class=pull-left _v-957368be=\"\">Save to</label><v-select v-bind:options=profileOptions v-bind:value.sync=saveToPreset class=pull-left _v-957368be=\"\"></v-select></div></div><div slot=modal-footer class=\"modal-footer clearfix\" _v-957368be=\"\"><button v-on:click=leavePage class=\"btn btn-default\" _v-957368be=\"\">No</button><button v-on:click=applyCurrentChange class=\"btn btn-primary\" _v-957368be=\"\">Save</button></div></modal></div></div>";

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

	module.exports = "<div class=row _v-9a703032=\"\"><div class=col-xs-12 _v-9a703032=\"\"><fieldset _v-9a703032=\"\"><legend _v-9a703032=\"\">dxGetMatrixStatus</legend><button @click=\"sendAPI('dxGetMatrixStatus')\" _v-9a703032=\"\">dxGetMatrixStatus</button></fieldset></div></div><div class=row _v-9a703032=\"\"><div class=col-xs-12 _v-9a703032=\"\"><fieldset _v-9a703032=\"\"><legend _v-9a703032=\"\">dxSetMapping</legend><div v-for=\"setting in mapping\" track-by=$index _v-9a703032=\"\"><span _v-9a703032=\"\">set output</span><input v-model=setting.port class=thin _v-9a703032=\"\"><span _v-9a703032=\"\">value</span><input v-model=setting.value class=thin _v-9a703032=\"\"></div><button @click=dxSetMapping _v-9a703032=\"\">dxSetMapping</button></fieldset></div></div><div class=row _v-9a703032=\"\"><div class=col-xs-12 _v-9a703032=\"\"><fieldset _v-9a703032=\"\"><legend _v-9a703032=\"\">dxGetPortInfo</legend><button @click=\"sendAPI('dxGetPortInfo')\" _v-9a703032=\"\">dxGetPortInfo</button></fieldset></div></div><div class=row _v-9a703032=\"\"><div class=col-xs-12 _v-9a703032=\"\"><fieldset _v-9a703032=\"\"><legend _v-9a703032=\"\">dxSetPortInfo</legend><div v-for=\"inp in info.inputs\" track-by=$index _v-9a703032=\"\"><div _v-9a703032=\"\"><span _v-9a703032=\"\">input port :</span><input v-model=inp.port _v-9a703032=\"\"></div><div _v-9a703032=\"\"><span _v-9a703032=\"\">input port {{ inp.port }}.name :</span><input v-model=inp.name _v-9a703032=\"\"></div><div _v-9a703032=\"\"><span _v-9a703032=\"\">input port {{ inp.port }}.photo :</span><input v-model=inp.photo _v-9a703032=\"\"></div></div><div v-for=\"inp in info.outputs\" track-by=$index _v-9a703032=\"\"><div _v-9a703032=\"\"><span _v-9a703032=\"\">output port :</span><input v-model=inp.port _v-9a703032=\"\"></div><div _v-9a703032=\"\"><span _v-9a703032=\"\">output port {{ inp.port }}.name :</span><input v-model=inp.name _v-9a703032=\"\"></div><div _v-9a703032=\"\"><span _v-9a703032=\"\">output port {{ inp.port }}.photo :</span><input v-model=inp.photo _v-9a703032=\"\"></div></div><button @click=dxSetPortInfo _v-9a703032=\"\">dxSetPortInfo</button></fieldset></div></div><div class=row _v-9a703032=\"\"><div class=col-xs-12 _v-9a703032=\"\"><fieldset _v-9a703032=\"\"><legend _v-9a703032=\"\">dxGetHDCPStatus</legend><button @click=\"sendAPI('dxGetHDCPStatus')\" _v-9a703032=\"\">dxGetHDCPStatus</button></fieldset></div></div><div class=row _v-9a703032=\"\"><div class=col-xs-12 _v-9a703032=\"\"><fieldset _v-9a703032=\"\"><legend _v-9a703032=\"\">dxGetHDCP</legend><button @click=\"sendAPI('dxGetHDCP')\" _v-9a703032=\"\">dxGetHDCP</button></fieldset></div></div><div class=row _v-9a703032=\"\"><div class=col-xs-12 _v-9a703032=\"\"><fieldset _v-9a703032=\"\"><legend _v-9a703032=\"\">dxSetHDCP</legend><div v-for=\"oup in hdcp.outputs\" track-by=$index _v-9a703032=\"\"><div _v-9a703032=\"\"><span _v-9a703032=\"\">output port :</span><input v-model=oup.port _v-9a703032=\"\"></div><div _v-9a703032=\"\"><span _v-9a703032=\"\">output port {{ oup.port }}.enabled :</span><input type=checkbox v-model=oup.enabled _v-9a703032=\"\"></div><div _v-9a703032=\"\"><span _v-9a703032=\"\">output port {{ oup.port }}.engine :</span><span v-for=\"op in engineOpts\" _v-9a703032=\"\"><input type=radio value={{op}} v-bind:id=\" 'r_' + op + $index\" v-model=oup.engine _v-9a703032=\"\"><label v-bind:for=\" 'o_' + op + $index\" _v-9a703032=\"\">{{ op }}</label></span></div></div><button @click=dxSetHDCP _v-9a703032=\"\">dxSetHDCP</button></fieldset></div></div><div class=row _v-9a703032=\"\"><div class=col-xs-12 _v-9a703032=\"\"><fieldset _v-9a703032=\"\"><legend _v-9a703032=\"\">dxGetMaps</legend><button @click=\"sendAPI('dxGetMaps')\" _v-9a703032=\"\">dxGetMaps</button></fieldset></div></div><div class=row _v-9a703032=\"\"><div class=col-xs-12 _v-9a703032=\"\"><fieldset _v-9a703032=\"\"><legend _v-9a703032=\"\">dxSetMaps</legend><div _v-9a703032=\"\"><span _v-9a703032=\"\">config map id :</span><input v-model=maps.no _v-9a703032=\"\"></div><div _v-9a703032=\"\"><span _v-9a703032=\"\">amout of port wanna send:</span><input type=number v-model=maps.count number=number _v-9a703032=\"\"></div><div _v-9a703032=\"\"><span _v-9a703032=\"\">name :</span><input v-model=maps.name _v-9a703032=\"\"></div><div v-for=\"count in maps.count\" track-by=$index _v-9a703032=\"\"><span _v-9a703032=\"\">output : {{ count + 1 }}</span><input v-model=maps.mapping[count+1] _v-9a703032=\"\"></div><button @click=dxSetMaps _v-9a703032=\"\">dxSetMaps</button></fieldset></div></div><div class=row _v-9a703032=\"\"><div class=col-xs-12 _v-9a703032=\"\"><fieldset _v-9a703032=\"\"><legend _v-9a703032=\"\">dxGetEDID</legend><button @click=\"sendAPI('dxGetEDID')\" _v-9a703032=\"\">dxGetEDID</button></fieldset></div></div><div class=row _v-9a703032=\"\"><div class=col-xs-12 _v-9a703032=\"\"><fieldset _v-9a703032=\"\"><legend _v-9a703032=\"\">dxGetEDIDOptions</legend><button @click=\"sendAPI('dxGetEDIDOptions')\" _v-9a703032=\"\">dxGetEDIDOptions</button></fieldset></div></div><div class=row _v-9a703032=\"\"><div class=col-xs-12 _v-9a703032=\"\"><fieldset _v-9a703032=\"\"><legend _v-9a703032=\"\">dxSetEDID</legend><div _v-9a703032=\"\"><span _v-9a703032=\"\">port:</span><input v-model=edid.no _v-9a703032=\"\"></div><div _v-9a703032=\"\"><span _v-9a703032=\"\">type</span><span v-for=\"op in edidOpts\" _v-9a703032=\"\"><input type=radio value={{op}} id=edidCbx v-model=edid.type _v-9a703032=\"\"><label v-bind:for=edidCbx _v-9a703032=\"\">{{ op }}</label></span></div><div _v-9a703032=\"\"><span _v-9a703032=\"\">value :</span><textarea v-model=edid.value _v-9a703032=\"\"></textarea></div><button @click=dxSetEDID _v-9a703032=\"\">dxSetEDID</button></fieldset></div></div><div class=row _v-9a703032=\"\"><div class=col-xs-12 _v-9a703032=\"\"><fieldset _v-9a703032=\"\"><legend _v-9a703032=\"\">dxResetLink</legend><div _v-9a703032=\"\"><span _v-9a703032=\"\">inputs ports:</span><input type=checkbox value=1 v-model=toResetLinks.inputs _v-9a703032=\"\"><label _v-9a703032=\"\">1</label><input type=checkbox value=2 v-model=toResetLinks.inputs _v-9a703032=\"\"><label _v-9a703032=\"\">2</label><input type=checkbox value=3 v-model=toResetLinks.inputs _v-9a703032=\"\"><label _v-9a703032=\"\">3</label><input type=checkbox value=4 v-model=toResetLinks.inputs _v-9a703032=\"\"><label _v-9a703032=\"\">4</label><input type=checkbox value=5 v-model=toResetLinks.inputs _v-9a703032=\"\"><label _v-9a703032=\"\">5</label><input type=checkbox value=6 v-model=toResetLinks.inputs _v-9a703032=\"\"><label _v-9a703032=\"\">6</label><input type=checkbox value=7 v-model=toResetLinks.inputs _v-9a703032=\"\"><label _v-9a703032=\"\">7</label><input type=checkbox value=8 v-model=toResetLinks.inputs _v-9a703032=\"\"><label _v-9a703032=\"\">8</label></div><div _v-9a703032=\"\"><span _v-9a703032=\"\">outputs ports:</span><input type=checkbox value=1 v-model=toResetLinks.outputs _v-9a703032=\"\"><label _v-9a703032=\"\">1</label><input type=checkbox value=2 v-model=toResetLinks.outputs _v-9a703032=\"\"><label _v-9a703032=\"\">2</label><input type=checkbox value=3 v-model=toResetLinks.outputs _v-9a703032=\"\"><label _v-9a703032=\"\">3</label><input type=checkbox value=4 v-model=toResetLinks.outputs _v-9a703032=\"\"><label _v-9a703032=\"\">4</label><input type=checkbox value=5 v-model=toResetLinks.outputs _v-9a703032=\"\"><label _v-9a703032=\"\">5</label><input type=checkbox value=6 v-model=toResetLinks.outputs _v-9a703032=\"\"><label _v-9a703032=\"\">6</label><input type=checkbox value=7 v-model=toResetLinks.outputs _v-9a703032=\"\"><label _v-9a703032=\"\">7</label><input type=checkbox value=8 v-model=toResetLinks.outputs _v-9a703032=\"\"><label _v-9a703032=\"\">8</label></div><button @click=dxResetLink _v-9a703032=\"\">dxResetLink</button></fieldset></div></div><div class=row _v-9a703032=\"\"><div class=col-xs-12 _v-9a703032=\"\"><fieldset _v-9a703032=\"\"><legend _v-9a703032=\"\">dxGetSwitcherLayout</legend><button @click=\"sendAPI('dxGetSwitcherLayout')\" _v-9a703032=\"\">dxGetSwitcherLayout</button></fieldset></div></div><div class=row _v-9a703032=\"\"><div class=col-xs-12 _v-9a703032=\"\"><fieldset _v-9a703032=\"\"><legend _v-9a703032=\"\">dxSetSwitcherLayout</legend><div _v-9a703032=\"\"><span _v-9a703032=\"\">Layout:<input type=text v-model=switcherLayout _v-9a703032=\"\"></span></div><button @click=dxSetSwitcherLayout _v-9a703032=\"\">dxSetSwitcherLayout</button></fieldset></div></div><div class=row _v-9a703032=\"\"><div class=col-xs-12 _v-9a703032=\"\"><fieldset _v-9a703032=\"\"><legend _v-9a703032=\"\">dxSetMappingAndLayout</legend><div _v-9a703032=\"\"><span _v-9a703032=\"\">Layout:<input type=text v-model=switcherLayout _v-9a703032=\"\"></span></div><div _v-9a703032=\"\"><span _v-9a703032=\"\">Mapping:<input type=text v-model=switcherMapping _v-9a703032=\"\"></span></div><button @click=dxSetMappingAndLayout _v-9a703032=\"\">dxSetMappingAndLayout</button></fieldset></div></div>";

/***/ }),
/* 1167 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-a09d072e=\"\"><div class=row _v-a09d072e=\"\"><div class=\"status_main col-md-12\" _v-a09d072e=\"\"><header class=\"config_title_bar main_title_bar clearfix\" _v-a09d072e=\"\"><h1 class=\"title col-md-2 col-lg-2 col-sm-2 col-xs-3 clearfix\" _v-a09d072e=\"\">Status</h1><v-loader v-bind:ani-key=\"'6'\" v-if=isFetching class=\"col-lg-2 col-lg-offset-3 col-md-2 col-md-offset-3 col-sm-1 col-sm-offset-3 col-xs-2 col-xs-offset-0\" _v-a09d072e=\"\"></v-loader><div class=\"window_setting col-lg-2 col-md-2 col-xs-2 row_space--xxs pull-right\" _v-a09d072e=\"\"><i v-on:click=handleshowOutSetting() class=\"fa fa-cog fa-2x\" _v-a09d072e=\"\"></i></div></header><section class=status_content _v-a09d072e=\"\"><section class=\"screen_block clearfix col-md-12 col-lg-12 no_pad\" _v-a09d072e=\"\"><section class=\"screen_section col-xs-12 col-sm-7 col-md-7 col-lg-8 row_space--sm no_pad clearfix\" _v-a09d072e=\"\"><v-screen v-bind:editable=true v-bind:show-link=true v-bind:in-which-page=\"'status'\" v-bind:show-ps-out=true v-bind:show-ps-in=true _v-a09d072e=\"\"></v-screen></section><section class=\"function_section col-xs-12 col-sm-5 col-md-5 col-lg-4 clearfix no_pad-xxs\" _v-a09d072e=\"\"><div class=\"col-xs-12 col-md-12 full_screen_btn_group col-centered clearfix no_pad-xxs\" _v-a09d072e=\"\"><header class=\"row_space--xxs hidden-xs\" _v-a09d072e=\"\"><label _v-a09d072e=\"\">Output</label></header><div v-for=\"key in outputPorts\" class=\"col-xs-3 col-sm-3 col-md-3 full__btn__single clearfix\" _v-a09d072e=\"\"><button v-on:click=toFocus(key) v-bind:disabled=buttonDisabled v-bind:class=\"{active: windowFocus === key}\" class=\"btn btn-default clearfix btn-square-xs\" _v-a09d072e=\"\">{{key}}</button></div></div><div class=\"col-xs-12 col-md-12 quick_selection_btn_group col-centered clearfix no_pad-xxs\" _v-a09d072e=\"\"><header class=\"row_space--xxs hidden-xs\" _v-a09d072e=\"\"><label _v-a09d072e=\"\">Quick Selection</label></header><div v-for=\"(key, val) in outSplitOptions\" v-if=!isFetching class=\"quick__btn__single pull-left\" _v-a09d072e=\"\"><button v-on:click=sendKeyToDevice(key) v-bind:disabled=\"is4K || buttonDisabled\" v-bind:class=\"{straight: isStraight(key)}\" class=\"btn btn-default clearfix btn-square-xs\" _v-a09d072e=\"\"><img v-bind:src=quickIcons[key-1] class=icon _v-a09d072e=\"\"></button></div></div><div class=\"col-xs-12 col-md-12 custom_btn_group col-centered clearfix\" _v-a09d072e=\"\"><header class=\"row_space--xxs hidden-xs\" _v-a09d072e=\"\"><label _v-a09d072e=\"\">Custom Preset</label></header><div v-for=\"key in profileOptions\" class=\"custom__btn__single col-xs-3 col-sm-3 col-md-3 clearfix\" _v-a09d072e=\"\"><button v-on:click=setLayoutByProfileKey(key) v-bind:disabled=buttonDisabled class=\"btn btn-default btn-square-xs no_pad\" _v-a09d072e=\"\"><span _v-a09d072e=\"\"><i class=\"fa fa-user\" _v-a09d072e=\"\">&nbsp;{{key}}</i></span><br _v-a09d072e=\"\"><span class=profile_name _v-a09d072e=\"\">{{customProfileOptions[key].name}}</span></button></div></div></section></section></section></div><modal title=Settings v-bind:show.sync=showOutSetting effect=fade ok-text=Apply cancel-text=Cancel backdrop=false class=window_setting_modal _v-a09d072e=\"\"><div slot=modal-header class=modal-header _v-a09d072e=\"\"><button v-on:click=\"showOutSetting = false\" v-bind:disabled.sync=isUpdatingProfile class=close _v-a09d072e=\"\"><span _v-a09d072e=\"\">×</span></button><h4 class=modal-title _v-a09d072e=\"\">Settings</h4></div><div slot=modal-body class=\"modal-body clearfix\" _v-a09d072e=\"\"><tabs _v-a09d072e=\"\"><tab header=Output _v-a09d072e=\"\"><section class=\"resolution_sec clearfix col-md-12 outer_group\" _v-a09d072e=\"\"><div class=col-md-12 _v-a09d072e=\"\"><h3 class=title _v-a09d072e=\"\">Output Setting</h3></div><div v-for=\"(key, val) in editing.outResolutions\" class=\"col-xs-12 col-sm-12 clearfix row_space--xs\" _v-a09d072e=\"\"><label class=\"col-xs-4 no_pad\" _v-a09d072e=\"\">Output {{key}} Resolution:</label><v-select v-bind:options=computedOutResolutionOptions v-bind:value.sync=val _v-a09d072e=\"\"></v-select><button v-on:click=applyOutputResolution(key) class=\"btn btn-primary pull-right\" _v-a09d072e=\"\">Apply</button></div></section></tab><tab header=Input v-if=\"model === 'VW-1404ZH-G' || isVDev\" _v-a09d072e=\"\"><section class=\"clearfix col-md-12 outer_group\" _v-a09d072e=\"\"><div class=col-md-12 _v-a09d072e=\"\"><h3 class=title _v-a09d072e=\"\">Input Source</h3></div><div class=\"col-xs-12 col-sm-12 clearfix row_space--xs\" _v-a09d072e=\"\"><label class=\"col-xs-4 no_pad\" _v-a09d072e=\"\">From HDMI</label><label class=iosCheck _v-a09d072e=\"\"><input type=checkbox v-model=editingSourceFrom _v-a09d072e=\"\"><i _v-a09d072e=\"\"></i></label></div><div class=\"col-xs-12 col-ms-12\" _v-a09d072e=\"\"><button v-on:click=applySourcInput() class=\"pull-right btn btn-primary\" _v-a09d072e=\"\">Apply</button></div></section></tab></tabs></div><div slot=modal-footer class=\"modal-footer clearfix\" _v-a09d072e=\"\"><button v-on:click=\"showOutSetting = false\" v-bind:disabled.sync=isUpdatingProfile class=\"btn btn-default\" _v-a09d072e=\"\">Cancel</button></div></modal></div></div>";

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

	module.exports = "<div class=container-fluid _v-a61b31d0=\"\"><div class=row _v-a61b31d0=\"\"><div class=\"event_main col-md-12\" _v-a61b31d0=\"\"><header class=\"event_titile_bar main_title_bar clearfix\" _v-a61b31d0=\"\"><h1 class=\"title col-md-12 col-sm-10 col-xs-12\" _v-a61b31d0=\"\">{{!showGroupConfig ? 'event' : ' Email / SMS'}}</h1></header><div class=\"function_group col-lg-12 clearfix no_pad\" _v-a61b31d0=\"\"><button v-on:click=\"showGroupConfig = !showGroupConfig\" class=\"config_switch col-lg-2 btn btn-info pull-right clearfix\" _v-a61b31d0=\"\">{{!showGroupConfig ? 'Edit Email/SMS group' : 'Back To Event'}}</button></div><section v-show=!showGroupConfig class=\"event_content clear-left clearfix\" _v-a61b31d0=\"\"><table class=\"table table-bordered table-striped event_mobile_table hidden-md hidden-lg\" _v-a61b31d0=\"\"><tbody _v-a61b31d0=\"\"><tr _v-a61b31d0=\"\"><th _v-a61b31d0=\"\">No.</th><th _v-a61b31d0=\"\">Name</th><th _v-a61b31d0=\"\"></th></tr><tr v-for=\"(key ,event) in events\" _v-a61b31d0=\"\"><td _v-a61b31d0=\"\">{{ key }}</td><td _v-a61b31d0=\"\">{{ event.name }}</td><td _v-a61b31d0=\"\"><span v-on:click=toShowModal(key) _v-a61b31d0=\"\"><i class=\"fa fa-edit\" _v-a61b31d0=\"\"></i></span></td></tr></tbody></table><table class=\"table table-bordered table-striped table-hover event_table hidden-sm hidden-xs\" _v-a61b31d0=\"\"><tbody _v-a61b31d0=\"\"><tr _v-a61b31d0=\"\"><th _v-a61b31d0=\"\">Enabled</th><th _v-a61b31d0=\"\">No.</th><th _v-a61b31d0=\"\">Name</th><th _v-a61b31d0=\"\">Event</th><th _v-a61b31d0=\"\">Source</th><th _v-a61b31d0=\"\">Actions</th><th _v-a61b31d0=\"\"></th></tr><tr v-for=\"(key, event) in events\" _v-a61b31d0=\"\"><td class=enabled _v-a61b31d0=\"\"><i v-if=event.enabled v-on:click=\"setEvent(false, key)\" class=\"fa fa-check-square fa-lg\" _v-a61b31d0=\"\"></i><i v-else=v-else v-on:click=\"setEvent(true, key)\" class=\"fa fa-square-o fa-lg\" _v-a61b31d0=\"\"></i></td><td _v-a61b31d0=\"\">{{ key }}</td><td _v-a61b31d0=\"\">{{event.name}}</td><td _v-a61b31d0=\"\">{{ returnEventName(event.event) }}</td><td class=source _v-a61b31d0=\"\"><div v-for=\"(key, source) in event.event.source\" class=\"col-xs-12 col-centered\" _v-a61b31d0=\"\"><span v-bind:data-bgcolor=source class=clearfix _v-a61b31d0=\"\">[DI{{source}}] {{DIs[source].name}}</span></div></td><td class=action _v-a61b31d0=\"\"><span v-for=\"ac in event.actions\" class=\"action__single clearfix\" _v-a61b31d0=\"\"><label class=\"action_title pull-left\" _v-a61b31d0=\"\">{{actionTranslator(ac.action)}}:</label><span v-for=\"target in ac.targets\" class=\"action_content pull-left col_space--xxs clearfix\" _v-a61b31d0=\"\"><span v-if=\"ac.action === 'Email' || ac.action === 'SMS'\" class=action_tags _v-a61b31d0=\"\">{{target}}</span><span v-else=v-else v-bind:data-bgcolor=target class=action_target _v-a61b31d0=\"\">[DO{{target}}]{{DOs[target].name}}</span></span></span></td><td _v-a61b31d0=\"\"><span v-on:click=toShowModal(key) _v-a61b31d0=\"\"><i class=\"fa fa-edit fa-lg\" _v-a61b31d0=\"\"></i></span></td></tr></tbody></table></section><section v-show=showGroupConfig class=\"group_editing_section clear-left clearfix\" _v-a61b31d0=\"\"><div class=\"col-xs-12 col-lg-10 col-centered row_space--xxs\" _v-a61b31d0=\"\"><tabs _v-a61b31d0=\"\"><tab header=Email _v-a61b31d0=\"\"><div class=col-md-12 _v-a61b31d0=\"\"><table class=\"table table-striped table-hover table-bordered email_group_table\" _v-a61b31d0=\"\"><tbody _v-a61b31d0=\"\"><tr _v-a61b31d0=\"\"><th _v-a61b31d0=\"\">No</th><th _v-a61b31d0=\"\">Group Name</th><th class=\"hidden-xs hidden-sm\" _v-a61b31d0=\"\">Emails</th><th _v-a61b31d0=\"\"></th></tr><tr v-for=\"(key, group) in emailData\" _v-a61b31d0=\"\"><td _v-a61b31d0=\"\">{{key}}</td><td _v-a61b31d0=\"\">{{group.name}}</td><td class=\"hidden-xs hidden-sm\" _v-a61b31d0=\"\">{{group.accounts}}</td><td _v-a61b31d0=\"\"><i v-on:click=\"handleGroupConfig('email', key)\" class=\"fa fa-edit fa-lg\" _v-a61b31d0=\"\"></i></td></tr></tbody></table></div></tab><tab header=SMS _v-a61b31d0=\"\"><div class=col-md-12 _v-a61b31d0=\"\"><table class=\"table table-striped table-hover table-bordered SMS_group_table\" _v-a61b31d0=\"\"><tbody _v-a61b31d0=\"\"><tr _v-a61b31d0=\"\"><th _v-a61b31d0=\"\">No</th><th _v-a61b31d0=\"\">Group Name</th><th class=\"hidden-xs hidden-sm\" _v-a61b31d0=\"\">Numbers</th><th _v-a61b31d0=\"\"></th></tr><tr v-for=\"(key, group) in SMSData\" _v-a61b31d0=\"\"><td _v-a61b31d0=\"\">{{key}}</td><td _v-a61b31d0=\"\">{{group.name}}</td><td class=\"hidden-xs hidden-sm\" _v-a61b31d0=\"\">{{group.accounts}}</td><td _v-a61b31d0=\"\"><i v-on:click=\"handleGroupConfig('SMS', key)\" class=\"fa fa-edit fa-lg\" _v-a61b31d0=\"\"></i></td></tr></tbody></table></div></tab></tabs></div></section></div></div></div><modal v-bind:show.sync=showModal v-bind:title=editing.title effect=zoom v-bind:callback=handleEventConfig ok-text=Apply cancel-text=Cancel class=\"popout event_config\" _v-a61b31d0=\"\"><div slot=modal-body class=modal-body _v-a61b31d0=\"\"><table class=\"table table-bordered event_config_table\" _v-a61b31d0=\"\"><tbody _v-a61b31d0=\"\"><tr _v-a61b31d0=\"\"><th _v-a61b31d0=\"\">Enabled</th><td _v-a61b31d0=\"\"><div class=fa_checkbox _v-a61b31d0=\"\"><input type=checkbox v-model=editing.newEvent.enabled v-bind:id=\"'event' + editing.index\" _v-a61b31d0=\"\"><label v-bind:for=\"'event' + editing.index\" _v-a61b31d0=\"\">Enabled</label></div></td></tr><tr _v-a61b31d0=\"\"><th _v-a61b31d0=\"\">Name</th><td _v-a61b31d0=\"\"><validator name=eventName _v-a61b31d0=\"\"><input type=text v-model=editing.newEvent.name maxlength=7 v-validate:name=\"['engAndNum']\" class=form-control _v-a61b31d0=\"\"><span v-show=\"$eventName.name.invalid &amp;&amp; $eventName.name.modified\" class=error _v-a61b31d0=\"\">English characters , numbers and '_' only</span></validator></td></tr><tr _v-a61b31d0=\"\"><th _v-a61b31d0=\"\">Source</th><td class=\"source col-xs-10\" _v-a61b31d0=\"\"><v-bank v-bind:options=sourceOptions name-prop=source_target v-bind:output.sync=editing.newEvent.newSource _v-a61b31d0=\"\"></v-bank></td></tr><tr _v-a61b31d0=\"\"><th _v-a61b31d0=\"\">Event</th><td _v-a61b31d0=\"\"><span class=\"col-xs-12 no_pad event_content key\" _v-a61b31d0=\"\"><label _v-a61b31d0=\"\">Trigger type</label><div class=\"col-xs-12 no_pad\" _v-a61b31d0=\"\"><v-single-select v-bind:options=eventOptions v-bind:value.sync=editing.newEvent.key placeholder=\"Please select a key\" _v-a61b31d0=\"\"></v-single-select></div></span><span v-if=\"editing.newEvent.key === 'DI'\" class=\"col-xs-12 no_pad event_content condition\" _v-a61b31d0=\"\"><label _v-a61b31d0=\"\">Condition</label></span><span v-if=\"editing.newEvent.key === 'DI'\" class=\"col-xs-12 no_pad event_content power_value\" _v-a61b31d0=\"\"><div class=\"col-xs-12 no_pad\" _v-a61b31d0=\"\"><v-single-select v-bind:options=eventValueOptions v-bind:value.sync=editing.newEvent.value placeholder=\"Please select a value\" _v-a61b31d0=\"\"></v-single-select></div></span></td></tr><tr _v-a61b31d0=\"\"><th _v-a61b31d0=\"\">Actions</th><td class=actions _v-a61b31d0=\"\"><span class=\"col-xs-12 no_pad row_space--xxs clearfix do_high\" _v-a61b31d0=\"\"><div class=fa_checkbox _v-a61b31d0=\"\"><input type=checkbox value=\"DO High\" id=do_high v-model=newActions v-bind:checked.once=\"editing.actionKeys.indexOf('DO High') !== -1\" _v-a61b31d0=\"\"><label for=do_high _v-a61b31d0=\"\">DO High</label></div><div class=bank_group _v-a61b31d0=\"\"><v-multi-banks v-bind:options=targetOptions v-bind:output-ary.sync=actions.high.targets name-prop=do_high_target v-bind:show-option=\"newActions.indexOf('DO High') !== -1\" _v-a61b31d0=\"\"></v-multi-banks></div></span><span class=\"col-xs-12 no_pad row_space--xxs clearfix do_low\" _v-a61b31d0=\"\"><div class=fa_checkbox _v-a61b31d0=\"\"><input type=checkbox value=\"DO Low\" id=do_low v-model=newActions v-bind:checked.once=\"editing.actionKeys.indexOf('DO Low') !== -1\" _v-a61b31d0=\"\"><label for=do_low _v-a61b31d0=\"\">DO Low</label></div><div class=bank_group _v-a61b31d0=\"\"><v-multi-banks v-bind:options=targetOptions v-bind:output-ary.sync=actions.low.targets name-prop=do_low_target v-bind:show-option=\"newActions.indexOf('DO Low') !== -1\" _v-a61b31d0=\"\"></v-multi-banks></div></span><span v-if=\"emailGroups.options.length !== 0\" class=\"col-xs-12 no_pad row_space--xxs clearfix email\" _v-a61b31d0=\"\"><div class=fa_checkbox _v-a61b31d0=\"\"><input type=checkbox value=Email id=email v-model=newActions v-bind:checked.once=\"editing.actionKeys.indexOf('Email') !== -1\" _v-a61b31d0=\"\"><label for=email v-on:click.prevent=\"clickGroups('Email')\" _v-a61b31d0=\"\">email</label></div><span v-if=\"newActions.indexOf('Email') !== -1\" class=\"no_pad col-xs-12 row_space--xxs\" _v-a61b31d0=\"\"><v-select v-bind:selected=emailGroups.selected v-bind:show-labels=true v-bind:options=emailGroups.options v-bind:taggable=true v-bind:multiple=true v-bind:limit=2 @update=updateEmailGroupSelected _v-a61b31d0=\"\"></v-select></span></span><span v-else=v-else class=\"col-xs-12 no_pad row_space--xxs clearfix actionReminding\" _v-a61b31d0=\"\">You need to have at least 1 valid email group to set email action</span><span v-if=\"emailGroups.options.length !== 0\" class=\"col-xs-12 no_pad row_space--xxs clearfix SMS\" _v-a61b31d0=\"\"><div class=fa_checkbox _v-a61b31d0=\"\"><input type=checkbox value=SMS id=SMS v-model=newActions v-bind:checked.once=\"editing.actionKeys.indexOf('SMS') !== -1\" _v-a61b31d0=\"\"><label for=SMS v-on:click.prevent=\"clickGroups('SMS')\" _v-a61b31d0=\"\">SMS</label></div><span v-if=\"newActions.indexOf('SMS') !== -1\" class=\"no_pad col-xs-12 row_space--xxs\" _v-a61b31d0=\"\"><v-select v-bind:selected=SMSGroups.selected v-bind:show-labels=true v-bind:options=SMSGroups.options v-bind:taggable=true v-bind:multiple=true v-bind:limit=2 @update=updateSMSGroupSelected _v-a61b31d0=\"\"></v-select></span></span><span v-else=v-else class=\"col-xs-12 no_pad row_space--xxs clearfix actionReminding\" _v-a61b31d0=\"\">You need to have at least 1 valid SMS group to set SMS action</span></td></tr></tbody></table></div></modal><modal v-bind:title=editingGroup.title v-bind:show.sync=showGroupConfigTable effect=zoom v-bind:callback=editingGroup.cb ok-text=Apply cancel-text=Cancel class=\"popout group_config\" _v-a61b31d0=\"\"><div slot=modal-body class=\"modal-body clearfix\" _v-a61b31d0=\"\"><div class=\"col-md-6 row_space--xxs\" _v-a61b31d0=\"\"><label _v-a61b31d0=\"\">Group Name</label><br _v-a61b31d0=\"\"><span class=hint _v-a61b31d0=\"\">(Use a name different from other group)</span><validator name=groupName _v-a61b31d0=\"\"><input v-model=editingGroup.data.name maxlength=7 v-validate:name=\"['engAndNum']\" class=form-control _v-a61b31d0=\"\"><span v-show=\"$groupName.name.invalid &amp;&amp; $groupName.name.modified\" class=error _v-a61b31d0=\"\">English characters , numbers and '_' only</span></validator></div><div class=\"col-md-6 row_space--xxs\" _v-a61b31d0=\"\"><label _v-a61b31d0=\"\">Group Accouts</label><br _v-a61b31d0=\"\"><span class=hint _v-a61b31d0=\"\">({{editingGroup.format}})</span><textarea v-model=editingGroup.data.accounts placeholder=\"Please use ';' to separate multiple accounts. Empty to disable this group.\" rows=8 class=form-control _v-a61b31d0=\"\"></textarea></div></div></modal>";

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

	module.exports = "<div class=container _v-c88e3436=\"\"><div class=row _v-c88e3436=\"\"><div class=\"welcome_main col-md-12\" _v-c88e3436=\"\"><header class=\"welcome_title_bar main_title_bar\" _v-c88e3436=\"\"><h1 _v-c88e3436=\"\">Welcome , {{user.name}}</h1></header><section class=\"steps_content col-md-12\" _v-c88e3436=\"\"><h2 class=warning _v-c88e3436=\"\">You have no devices online yet</h2><h2 _v-c88e3436=\"\">To add some device, you can follow the steps below:</h2><ul class=\"steps clearfix\" _v-c88e3436=\"\"><li _v-c88e3436=\"\">1.<span class=bold _v-c88e3436=\"\">Click</span><span v-on:click=handleAddDevice class=link _v-c88e3436=\"\">Add Device</span>&nbsp;or<span class=bold _v-c88e3436=\"\">Click</span>&nbsp;your name on the right top corner and click 'Add device'</li><li _v-c88e3436=\"\">2. Enter the installer mail ,the Association Code ,then click apply</li><li _v-c88e3436=\"\">3. Enjoy operating your device!!!</li></ul></section></div></div></div>";

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid frame\" _v-d1ece4c4=\"\"><div class=row _v-d1ece4c4=\"\"><div class=\"col-md-12 no_pad frame_group\" _v-d1ece4c4=\"\"><iframe id=iframe v-bind:src=iframeSrc _v-d1ece4c4=\"\"></iframe></div></div></div>";

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(947)
	__vue_script__ = __webpack_require__(621)
	__vue_template__ = __webpack_require__(1117)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(961)
	__vue_script__ = __webpack_require__(623)
	__vue_template__ = __webpack_require__(1131)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(991)
	__vue_script__ = __webpack_require__(627)
	__vue_template__ = __webpack_require__(1161)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(979)
	__vue_script__ = __webpack_require__(631)
	__vue_template__ = __webpack_require__(1149)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(950)
	__vue_script__ = __webpack_require__(639)
	__vue_template__ = __webpack_require__(1118)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(999)
	__vue_script__ = __webpack_require__(641)
	__vue_template__ = __webpack_require__(1169)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(998)
	__vue_script__ = __webpack_require__(642)
	__vue_template__ = __webpack_require__(1168)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(966)
	__vue_script__ = __webpack_require__(643)
	__vue_template__ = __webpack_require__(1136)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(986)
	__vue_script__ = __webpack_require__(644)
	__vue_template__ = __webpack_require__(1156)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(1000)
	__vue_script__ = __webpack_require__(645)
	__vue_template__ = __webpack_require__(1170)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(951)
	__vue_script__ = __webpack_require__(646)
	__vue_template__ = __webpack_require__(1119)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(957)
	__vue_script__ = __webpack_require__(647)
	__vue_template__ = __webpack_require__(1127)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(969)
	__vue_script__ = __webpack_require__(649)
	__vue_template__ = __webpack_require__(1139)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(952)
	__vue_script__ = __webpack_require__(650)
	__vue_template__ = __webpack_require__(1120)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(968)
	__vue_script__ = __webpack_require__(651)
	__vue_template__ = __webpack_require__(1138)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(982)
	__vue_script__ = __webpack_require__(652)
	__vue_template__ = __webpack_require__(1152)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(972)
	__vue_script__ = __webpack_require__(654)
	__vue_template__ = __webpack_require__(1142)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(988)
	__vue_script__ = __webpack_require__(655)
	__vue_template__ = __webpack_require__(1158)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(981)
	__vue_script__ = __webpack_require__(656)
	__vue_template__ = __webpack_require__(1151)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(953)
	__vue_script__ = __webpack_require__(657)
	__vue_template__ = __webpack_require__(1121)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(978)
	__vue_script__ = __webpack_require__(658)
	__vue_template__ = __webpack_require__(1148)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(993)
	__vue_script__ = __webpack_require__(659)
	__vue_template__ = __webpack_require__(1163)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(976)
	__vue_script__ = __webpack_require__(660)
	__vue_template__ = __webpack_require__(1146)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(985)
	__vue_script__ = __webpack_require__(661)
	__vue_template__ = __webpack_require__(1155)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(967)
	__vue_script__ = __webpack_require__(662)
	__vue_template__ = __webpack_require__(1137)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(956)
	__vue_script__ = __webpack_require__(663)
	__vue_template__ = __webpack_require__(1122)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(664)
	__vue_template__ = __webpack_require__(1123)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(963)
	__vue_script__ = __webpack_require__(665)
	__vue_template__ = __webpack_require__(1133)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(996)
	__vue_script__ = __webpack_require__(666)
	__vue_template__ = __webpack_require__(1166)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(994)
	__vue_script__ = __webpack_require__(667)
	__vue_template__ = __webpack_require__(1164)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(973)
	__vue_script__ = __webpack_require__(668)
	__vue_template__ = __webpack_require__(1143)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(669)
	__vue_template__ = __webpack_require__(1124)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(960)
	__vue_script__ = __webpack_require__(670)
	__vue_template__ = __webpack_require__(1130)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(970)
	__vue_script__ = __webpack_require__(671)
	__vue_template__ = __webpack_require__(1140)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(954)
	__vue_script__ = __webpack_require__(672)
	__vue_template__ = __webpack_require__(1125)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(995)
	__vue_script__ = __webpack_require__(673)
	__vue_template__ = __webpack_require__(1165)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(955)
	__vue_script__ = __webpack_require__(674)
	__vue_template__ = __webpack_require__(1126)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(997)
	__vue_script__ = __webpack_require__(675)
	__vue_template__ = __webpack_require__(1167)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(964)
	__vue_script__ = __webpack_require__(676)
	__vue_template__ = __webpack_require__(1134)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.fcec1372d5aeac753dcc.js